// App.js
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { calcDeliveryDate, formatJPDate, formatAUDate, isHoliday, toJSTDateString, jstDateStringToDate, addCalendarDays } from "./dateUtils";
import { getHolidaysByYear, HOLIDAY_DATA_RANGE } from "./japaneseHolidays";
import { createPortal } from "react-dom";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "./App.css";
import orderlinkLogo from "./orderlink_logo.png";

import { db, auth, functions, MARKET } from "./firebase";
import { httpsCallable } from "firebase/functions";
// 注：PDFのStorage直接アップロードは廃止し、finalizeDeliveryPdf / finalizeBillingPdf
// Callable経由（write-once・GCS世代プリコンディション付き）に一本化した
import jsPDF from "jspdf";
import html2canvas from "html2canvas";




import {
  collection,
  addDoc,
  serverTimestamp,
  onSnapshot,
  doc,
  updateDoc,
  getDoc,
  setDoc,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  startAt,
  endAt,
  Timestamp,
  increment,
  deleteDoc,
  getDocs,
  writeBatch,
  runTransaction,
  arrayUnion,
  arrayRemove,
  documentId,
} from "firebase/firestore";




import {
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup,
  getAdditionalUserInfo,
} from "firebase/auth";

import JanScanner from "./JanScanner";
import JanManual from "./JanManual";
import { QRCodeSVG } from "qrcode.react";




// Scanner / WholesaleOrdersPanel が無くてもビルドできるように安全読み込み
let Scanner = null;
let WholesaleOrdersPanel = null;
try {
  // eslint-disable-next-line global-require
  Scanner = require("./Scanner").default;
} catch { }
try {
  // eslint-disable-next-line global-require
  WholesaleOrdersPanel = require("./WholesaleOrdersPanel").default;
} catch { }
// ====== demo suppliers ======
const SUPPLIERS = [
  { id: "s1", name: "山田青果" },
  { id: "s2", name: "佐藤精肉" },
  { id: "s3", name: "鈴木鮮魚" },
];

const CenterWrap = ({ children }) => (
  <div
    style={{
      width: "100%",
      maxWidth: 860,
      margin: "0 auto",

      /* ✅ これが超重要 */
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",

      /* 念のため */
      overflow: "visible",
    }}
  >
    {children}
  </div>
);


// ====== テナント設定の書き込み許可フィールド ======
// firestore.rules の tenants update ブロック（hasOnlyアローリスト）と1対1で対応させること。
// 会社情報系とスケジュール系はRules上で別のupdateブロックに分かれているため、配列も分ける。
const TENANT_SETTINGS_ALLOWED_FIELDS = [
  'id', 'name', 'tel', 'fax', 'address', 'invoiceNo', 'bank', 'noteTemplate', 'shopName',
  'retailCompany', 'retailName', 'retailAddress', 'retailTel', 'retailFax', 'retailEmail',
  'email', 'allowRetailProductEdit',
  'wholesaleTenantId', 'wholesaleName',
  // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：ABN専用フィールド。
  // 以前はinvoiceNo（日本の適格請求書発行事業者番号と兼用）を先頭"T"除去して
  // ABNとして流用していたが、日本の登録番号とABNは全く異なる制度・書式の識別子で
  // あり、同じフィールドで兼用するのは設計として不適切（Codex指摘）。
  // AU版Tax InvoiceのABN表示はこのabnフィールドのみを参照し、invoiceNoには
  // 一切依存しない
  'abn',
  // 2026-08 AU版基盤（Phase 3）：AU向けBusiness Setup画面用の住所分解フィールド。
  // 日本版のaddress（単一自由入力）は維持したまま、AU版のみこれらを使用する
  'suburb', 'state', 'postcode', 'country',
];
// 2026-08 AU版基盤（Phase 3）：Business Setup画面のtimezone選択肢。豪州はUTCオフセットが
// 州ごとに異なり、かつ夏時間（DST）の有無も州によって違う（例：QLD/WAはDSTなし）ため、
// 固定オフセット文字列ではなくIANA timezone名を使う（Phase 1のzonedTimeToUtc/
// dateUtils.jsが前提とする形式と一致させる）
const AU_TIMEZONE_OPTIONS = [
  { value: "Australia/Sydney", label: "Sydney (NSW/ACT)" },
  { value: "Australia/Melbourne", label: "Melbourne (VIC)" },
  { value: "Australia/Brisbane", label: "Brisbane (QLD)" },
  { value: "Australia/Adelaide", label: "Adelaide (SA)" },
  { value: "Australia/Perth", label: "Perth (WA)" },
  { value: "Australia/Hobart", label: "Hobart (TAS)" },
  { value: "Australia/Darwin", label: "Darwin (NT)" },
];
const AU_STATE_OPTIONS = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];
const TENANT_SCHEDULE_ALLOWED_FIELDS = ['leadDays', 'cutoffTime', 'closedWeekdays', 'holidayDates'];
// 2026-08 AU版基盤（Phase 2）：firestore.rulesのtenants updateブロック
// （timezone/activation専用のhasOnly）と1対1で対応させる
const TENANT_AU_BASIS_ALLOWED_FIELDS = ['timezone'];

// 2026-08 AU版基盤（Phase 2）：GA4イベント送信の共通ヘルパー。
// window.gtagが未定義（gtag.jsの非同期読み込みが完了していない、
// またはGA4測定IDが未設定でindex.js側のスクリプト注入自体が
// スキップされた場合）でも例外を投げず、単に送信をスキップする
function trackEvent(eventName, params) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params || {});
  }
}

// 2026-08 AU Ads launch blocker対応：広告クリック（gclid）・UTMパラメータを
// first-party storage（localStorage）へ保存し、signup完了までの間にURLから
// 消えても（アプリ内遷移・replaceState等）参照できるようにする。
// - LP到達時にgclid/utm_*のいずれかがURLにあれば新規に保存する（新しい広告流入で
//   上書きする——同一ブラウザで別キャンペーンの広告を後から踏んだ場合、直近の
//   クリックを正とする「last-touch」方式。first-touchで固定したい場合は
//   このoverwrite判定を変更すること）
// - Secret・個人情報は一切含めない（gclid/utm系パラメータと流入日時のみ）
// - signup_complete時にtenant側へ1回だけスナップショットとして書き込む
//   （updateTenantSettings経由。以降はtenant docが真実源になり、localStorageは
//   参照しない）
const AD_ATTRIBUTION_STORAGE_KEY = "ol_ad_attribution";
const AD_ATTRIBUTION_PARAMS = ["gclid", "gbraid", "wbraid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
function captureAdAttributionFromUrl() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    let hasAny = false;
    for (const key of AD_ATTRIBUTION_PARAMS) {
      const v = params.get(key);
      if (v) { found[key] = v; hasAny = true; }
    }
    if (!hasAny) return;
    // capturedAtはローカルでのデバッグ・目視確認用のみ（サーバー側
    // sanitizeAdAttributionのホワイトリストには含まれておらず、送信時に
    // 自動的に無視される。tenant保存時のcapturedAtはサーバー側で
    // FieldValue.serverTimestamp()により確定される）
    found.capturedAt = new Date().toISOString();
    window.localStorage.setItem(AD_ATTRIBUTION_STORAGE_KEY, JSON.stringify(found));
  } catch (e) {
    // localStorage不可（プライベートブラウジング等）でも計測以外の機能に影響させない
    console.error("[captureAdAttributionFromUrl]", e);
  }
}
function readStoredAdAttribution() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(AD_ATTRIBUTION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
// 2026-08（Codexレビュー指摘、MUST-FIX対応）：role確定（confirmInitialRole成功、
// tenantへのadAttributionSnapshot書き込み確定後）まで進んだら、このlocalStorageの
// 値を消す。消さないと、同一ブラウザで以下のような操作をした場合に古い広告帰属が
// 別アカウントへ誤って持ち越されてしまう：
//   1. 広告Aから訪問してsignupを開始（またはLP訪問のみ）
//   2. 登録を完了せず離脱、またはログアウト
//   3. 別のタイミングで、広告パラメータの無いURLから別アカウントを新規登録
//   （この場合、captureAdAttributionFromUrlは新規URLに広告パラメータが無いため
//   上書きされず、ステップ1の古い値がそのまま2件目のtenantへ書き込まれてしまう）
function clearStoredAdAttribution() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(AD_ATTRIBUTION_STORAGE_KEY);
  } catch {
    // no-op
  }
}

// デモ/テストデータを実発注から除外する述語。
// isDemoはサーバー側（placeOrder/createManualOrderはisDemo:false、seedDemoDataはisDemo:true）
// でのみリテラル設定されるため、クライアントはこのフラグを信頼してよい。
function isRealOrder(order) {
  return !order?.isDemo;
}

// ====== initial catalog (demo) ======
const INITIAL_CATALOG = [
  { id: "p1", supplierId: "s1", barcode: "4900000000011", name: "キャベツ", unit: "玉", price: 180, taxRate: 0.1 },
  { id: "p2", supplierId: "s1", barcode: "4900000000028", name: "トマト", unit: "kg", price: 480, taxRate: 0.1 },
  { id: "p3", supplierId: "s2", barcode: "4900000000035", name: "豚バラ", unit: "kg", price: 1280, taxRate: 0.1 },
  { id: "p4", supplierId: "s3", barcode: "4900000000042", name: "サーモン", unit: "切", price: 380, taxRate: 0.1 },
];

// ✅ 共通：数値変換（"1,234" や "" に強い）
const toNum = (v, fallback = 0) => {
  if (v === null || v === undefined) return fallback;
  const s = String(v).trim();
  if (s === "") return fallback;
  const n = Number(s.replace(/,/g, ""));
  return Number.isFinite(n) ? n : fallback;
};

// ====== helpers ======
// 2026-08 通貨丸め統一：市場（通貨）ごとに小数桁数が異なる（JPY=0桁、将来のAUD=2桁）ため、
// 「常に整数化する」ようなグローバル実装は行わない。roundToCurrencyDecimals(value, decimals)
// を通貨非依存の汎用関数とし、日本版はroundJPY(value)（decimals固定0）を必ず経由する。
// 四捨五入はNumber.EPSILONを加算してから丸めることで、0.5のちょうど境界での
// 浮動小数点誤差（例：1.005が1.00499999...として保存され切り捨てられる）を防ぐ
function roundToCurrencyDecimals(value, decimals) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  const factor = Math.pow(10, decimals);
  return Math.round((n + Number.EPSILON) * factor) / factor;
}
// 日本円（JPY）専用：小数点以下を四捨五入して整数円にする。
// 商品マスタの単価保存・注文明細金額・集計・請求書等、JPY金額を確定保存する
// 全ての箇所はこの関数を経由すること（Math.roundを直接呼ばない）
export function roundJPY(value) {
  return roundToCurrencyDecimals(value, 0);
}
// 2026-08 修正：yen()はJPY金額の最終表示フォーマッタであり、必ずroundJPYを通してから
// 表示する。保存経路（商品マスタ・注文明細・集計）は既にroundJPYで整数化しているが、
// 過去に小数のまま保存された既存データ（本番監査で商品マスタ2,490件・一部注文明細で
// 確認済み）が残っているため、表示側でも最終防御として丸める。これは「小数点以下を
// 隠す」のではなく「JPYの確定金額は常に整数円である」という表示規約を強制するもの
const yen = (n) => `¥${roundJPY(n).toLocaleString("ja-JP")}`;
// 2026-08 修正（本番回帰・第2弾〜第3弾、Codex検証済み）：明細行の「単価」表示専用。
// yen()と異なりroundJPYで丸めない——旧データには小数単価（例:443.6円）が
// 残っており、単価そのものを丸めて表示すると、行金額（単価×数量、円単位に
// 丸めて表示）を検算しようとした際に「単価×数量」が行金額と食い違って見える。
// 単価は計算の根拠として小数のまま見せる。
//
// 行金額・小計自体は円単位に丸めて表示する（yen()を使う）。行ごとにroundJPY
// した値を積み上げた合計と、SSOTのroundJPY(生合計)は一般に一致しないため
// （例：0.4円の行が2つあると表示は0円+0円=0円だがSSOT小計はroundJPY(0.8)=1円
// になる、Codexレビュー指摘・MUST-FIX）、明細行の表示値をそのまま生値にしても
// この問題は解消しない（小計自体を丸める必要がある以上、構造的に避けられない）。
// 差が生じる場合は帳票側で「端数調整」として明示する
// （getDisplayOrderAmounts の roundingAdjustmentTotal を参照）。
// 新規データ（保存時点で既に整数）ではこの差は常に0になる
const yenRaw = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return "¥0";
  const isInt = Number.isInteger(v);
  return `¥${v.toLocaleString("ja-JP", { minimumFractionDigits: isInt ? 0 : 1, maximumFractionDigits: 2 })}`;
};

// 2026-08 AU版基盤（Phase 1）：AUD（豪ドル、小数点以下2桁）専用の丸め関数。
// roundJPYと同じroundToCurrencyDecimalsを経由するが、decimals=2を渡す。
// 既存のroundJPY・yen()・yenRaw()は一切変更しない（日本版の呼び出し元は
// このコミット以前と完全に同じ関数・同じ挙動のまま）
export function roundAUD(value) {
  return roundToCurrencyDecimals(value, 2);
}

// 通貨非依存の表示フォーマッタ。marketId未指定時は"JP"扱いとし、
// 既存のyen()と完全に同じ文字列を返す（¥記号・整数丸め・ja-JPロケール）。
// marketId==="AU"の場合のみAUD表示（$記号・2桁小数・en-AUロケール）になる。
// 既存コードのyen()呼び出し箇所はこの関数の追加によって一切影響を受けない
// ——formatMoneyは新規呼び出し元（Phase 2以降のAU版UI）のためだけに存在する
export function formatMoney(n, marketId) {
  if (marketId === "AU") {
    const v = roundAUD(n);
    return `$${v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return yen(n);
}

// 2026-08 AU版基盤（Phase 2）：yenRaw（丸めない生値表示）のmarket対応版。
// marketId==="AU"の場合、AUDは元々小数点2桁通貨のため丸め表示は不要——
// roundAUDで2桁に整えた値をそのまま$表記で返す（yenRawのような
// 「整数なら0桁、非整数なら1〜2桁」という可変桁数表示は行わない。
// JPYのように「本来整数通貨なのに小数が残っている」という異常値を
// 目立たせる目的の表示だったため、元々2桁小数が正常なAUDには不要）。
// marketId未指定・"JP"時は既存のyenRaw()と完全に同じ文字列を返す
export function formatMoneyRaw(n, marketId) {
  if (marketId === "AU") {
    const v = Number(n);
    if (!Number.isFinite(v)) return "$0.00";
    return `$${roundAUD(v).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return yenRaw(n);
}

const jdate = (v, locale = "ja-JP") => {
  if (!v) return "";
  try {
    if (typeof v?.toMillis === "function") return new Date(v.toMillis()).toLocaleString(locale);
  } catch {}
  const ms = Number(v);
  if (!Number.isNaN(ms) && ms > 0) return new Date(ms).toLocaleString(locale);
  const d = new Date(v);
  if (!Number.isNaN(d.getTime())) return d.toLocaleString(locale);
  return "";
};

// ✅ 旧データ互換：lines が違うキーでも拾う（明細が空になるのを防ぐ）
export const getOrderLines = (o) => {
  if (!o) return [];
  if (Array.isArray(o.lines)) return o.lines;
  if (Array.isArray(o.linesSnapshot)) return o.linesSnapshot;
  if (Array.isArray(o.orderLines)) return o.orderLines;
  if (Array.isArray(o.items)) return o.items;
  return [];
};

// ═══════════════════════════════════════════════════════════════════════
//  集計基準「納品書発行ベース」一本化：共通ヘルパー
// ═══════════════════════════════════════════════════════════════════════

// isTest/isDemoの除外判定。サーバー側（functions/index.js）のisExcludedTestOrDemoと
// 完全に同一のロジックにする——truthy判定だとレガシーな文字列値（"false"等）を
// 誤って除外してしまい、クライアント・サーバーで集計対象が食い違う可能性がある
function isExcludedTestOrDemo(order) {
  if (!order) return true;
  return order.isTest === true || order.isDemo === true || order.isTest === "true" || order.isDemo === "true";
}

// 唯一の集計対象判定。発注ベース・受注確定ベースは廃止し、納品書発行ベースのみ。
function isDeliveredAndCounted(o) {
  if (!o) return false;
  const s = String(o.status || "").trim();
  if (s !== "納品書発行") return false;
  if (isExcludedTestOrDemo(o)) return false;
  return true;
}

// 型付きの取引先識別子。kind:"tenant" は接続済みテナント、kind:"shop" は手動登録shop
// （retailTenantIdを持たない）由来。viewpointで「卸から見た小売」「小売から見た卸」を
// 明示的に切り替える。
function resolveCounterpartyKey(order, viewpoint) {
  if (!order) return null;
  if (viewpoint === "fromWholesale") {
    const tenantId = order.retailTenantIdFromShop || order.retailTenantId || null;
    if (tenantId) return { kind: "tenant", id: tenantId };
    if (order.shopId) return { kind: "shop", id: order.shopId };
    return null;
  }
  if (viewpoint === "fromRetail") {
    if (order.wholesaleTenantId) return { kind: "tenant", id: order.wholesaleTenantId };
    return null;
  }
  throw new Error("viewpoint must be specified");
}
function partnerKeyEquals(a, b) {
  return !!a && !!b && a.kind === b.kind && a.id === b.id;
}

function isUnbilled(order) {
  const v = order?.billedInvoiceId;
  return v == null || String(v).trim() === "" || String(v).trim().toLowerCase() === "null";
}

// HTML文字列補間用エスケープ（印刷用ポップアップに動的な取引先名・住所等を
// 埋め込む際、HTML/script注入を防ぐ）。null/undefinedは空文字にする
function escapeHtml(v) {
  if (v == null) return "";
  return String(v)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// "YYYY-MM-DD" を指定タイムゾーン（省略時はAsia/Tokyo）のその日0:00に対応する
// UTC Dateへ変換。
// 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：以前はUTC+9固定の
// 独自実装だったが、dateUtils.jsのjstDateStringToDate（Phase 1でCodexレビューを
// 通した、DST・非存在時刻対応済みの実装）へ委譲する形に統一した。日付妥当性検証
// （存在しない日付の拒否）は元の実装をそのまま維持する
function parseJstMidnight(dateStr, timezone = "Asia/Tokyo") {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateStr || ""));
  if (!m) throw new Error("invalid date: " + dateStr);
  const y = Number(m[1]), month = Number(m[2]), day = Number(m[3]);
  const check = new Date(Date.UTC(y, month - 1, day));
  if (check.getUTCFullYear() !== y || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) {
    throw new Error("invalid date: " + dateStr);
  }
  return jstDateStringToDate(dateStr, timezone);
}
// startDateStrの指定タイムゾーン0:00（含む）からendDateStrの翌日0:00（含まない）
// までの半開区間。timezone省略時は既存どおりAsia/Tokyo
// 2026-08 Codexレビュー指摘対応（2ラウンド目MUST-FIX）：以前はendMidnight.getTime()に
// UTCミリ秒で24時間を単純加算していたため、SydneyのDST切替日（1日が23時間または
// 25時間になる日）をendDateStrに指定すると「翌日の現地0時」からずれた時刻が
// 境界になっていた（functions/index.jsの同名関数と同じバグ・同じ修正）。
// endDateStr自体を暦上で1日進めてから、その新しい日付文字列を改めて
// parseJstMidnightで現地時刻へ変換する
function toJstDayRange(startDateStr, endDateStr, timezone = "Asia/Tokyo") {
  const start = parseJstMidnight(startDateStr, timezone);
  const nextDayStr = addCalendarDays(endDateStr, 1);
  const endExclusive = parseJstMidnight(nextDayStr, timezone);
  if (endExclusive <= start) throw new Error("endDateStr must not precede startDateStr");
  return { start, endExclusive };
}
// 2026-08 修正（本番回帰・第2弾、Codex検証済み）：注文単位の金額計算・表示の
// 唯一の参照元。帳票（納品書・受領書・請求書）・画面内プレビュー・集計（月別・
// 取引先別・商品別・取引先指定）の全てがこの関数を経由する。
//
// これ以前は、集計系はgetOrderAmounts（保存済みsnap値をそのまま返す）、
// 帳票系はgetDisplayOrderAmounts（明細から独自に再計算する別関数）という
// 2つの異なるSSOTが並存しており、両者が数円〜数十円ズレる回帰が発生した
// （集計画面と請求書PDFで税抜小計・8%/10%税額が食い違う）。原因は2つ：
//
// 1. 単価フィールドの優先順位誤り：明細のcostPrice（原価スナップショット、
//    補助的な参考値）を優先していたが、サーバー側recomputeOrderTotals
//    （唯一の正しい金額計算）はl.priceのみを使う。過去の一部注文でprice/
//    costPriceが食い違ったまま保存されており、costPrice優先だと数百円
//    ズレていた。→ priceのみを使うよう修正（欠損時は0＝金額データ不正として
//    扱う。costPriceへの推測フォールバックはしない）
//
// 2. 丸めタイミングの相違：以前は「単価を先にroundJPYで丸めてから数量倍」
//    していたが、recomputeOrderTotalsは「単価は丸めず生の小数のままlineTotal
//    =qty*priceを計算し、税率区分ごとに積算してから最後にMath.roundで丸める」
//    方式（税額は各行ごとにMath.roundしてから積算）。443.6円×5個のような
//    小数単価×複数数量の組み合わせで、丸めタイミングが違うと結果が変わる
//    （443.6*5=2218 vs roundJPY(443.6)*5=444*5=2220）。
//    → recomputeOrderTotalsと完全に同じ集計アルゴリズムに統一
//
// 新規注文（price=roundJPY済みの整数、qty=整数、taxRateが0/0.08/0.10）では、
// 上記2つの問題は原理的に発生しない（生のlineTotalが既に整数なので
// 丸めタイミングの違いが結果に影響しない）。影響は過去の小数単価データの
// 表示・集計・新規請求発行時の再計算に限定される。
//
// 表示上の注意（Codexレビュー指摘・MUST-FIX、2ラウンド目で確定）：明細行を
// 生値のまま表示しても、JPYは整数円である以上「小計」自体を最終的に丸める
// 必要があるため、「明細の表示値を積み上げた金額」と「丸めたSSOT小計」は
// 小数単価の旧データでは数学的に一致し得ない（例：0.4円の行が2つあると
// 明細の表示合計は0.8円だが、SSOT小計はroundJPY(0.8)=1円になる）。
// 単価×数量から一意に決まらない「1円の行き先」を特定の行へ黙って配賦する
//ことは、金額の根拠を不透明にするため行わない。
// 代わりに、明細行は円単位の丸めた値で表示し（lineAmount=roundJPY(rawLineAmount)）、
// 「明細行の丸め済み金額を単純合計した値」と「SSOT小計（全区分の生合計を
// 先に足してからroundJPYで丸めた値）」の差を roundingAdjustmentTotal として返す。
// 呼び出し側（帳票・画面プレビュー）は、差が0でなければ「端数調整」として
// 明示的に1行表示すること（黙って無視しない）。新規注文（保存時点で既に
// 整数単価）ではこの差は常に0になる。
// 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：marketId引数を
// 追加。省略時（日本版の全既存呼び出し元）はroundJPYのまま——挙動を一切変えない。
// marketId==="AU"の場合のみroundAUD（小数点2桁）を使う。0.08区分（sub8/tax8）は
// AU側では常に発生しない前提だが、既存のsafeDisplayTaxRateがJAPAN_TAX_POLICYの
// allowedRatesを参照する構造のため、AU_TAX_POLICYの範囲外（0.08）が来た場合は
// 従来どおり不正税率として扱われるよう、safeDisplayTaxRateにもpolicyを渡す
export function getDisplayOrderAmounts(order, marketId) {
  const round = marketId === "AU" ? roundAUD : roundJPY;
  const policy = resolveTaxPolicy(marketId);
  const snap = order?.orderSnapshot || order || {};
  const rawLines = snap.lines || [];
  let sub0 = 0, sub8 = 0, sub10 = 0, tax8 = 0, tax10 = 0, subInvalid = 0;
  let lineAmountSum0 = 0, lineAmountSum8 = 0, lineAmountSum10 = 0, lineAmountSumInvalid = 0;
  let hasInvalidRates = false;
  const lines = rawLines.map(l => {
    const rawUnitPrice = Number(l.price ?? 0);
    const qty = Number(l.qty || 0);
    const rawLineAmount = rawUnitPrice * qty; // 丸めない、SSOT計算用
    const lineAmount = round(rawLineAmount); // 表示用（明細行の金額欄はこれを丸めて見せる）
    const taxRate = safeDisplayTaxRate(l.taxRate, policy);
    if (taxRate === null) {
      // 2026-08 丸め統一（Codexレビュー指摘対応・v3）：不正税率（0/0.08/0.10以外）の
      // 行を税額計算から除外するのは正しいが、以前はlineAmount自体をどの小計にも
      // 加算していなかったため、表示明細には金額が出るのに小計・合計から
      // その分がまるごと消失する重大な過少計上バグがあった（Codexレビューで指摘）。
      // 表示系（帳票・画面プレビュー）では、金額を見失わないことを最優先し、
      // 不正税率行の金額もsubtotalに算入する（税額は確定できないため0のまま）。
      // hasInvalidRatesフラグで「税率不明の行が含まれる」ことを呼び出し側へ伝え、
      // 請求書発行（issueBilling）側ではこのフラグを見て発行自体を拒否する
      hasInvalidRates = true;
      subInvalid += rawLineAmount;
      lineAmountSumInvalid += lineAmount;
    } else if (taxRate === 0) {
      sub0 += rawLineAmount;
      lineAmountSum0 += lineAmount;
    } else {
      // 税額は各行ごとに丸めてから積算する（recomputeOrderTotalsと同一の丸め関数
      // を使う——2026-08 AU版基盤：Math.round固定からmarket別roundへ変更）。
      // 区分合計を先に出してから税額をまとめて丸めると異なる結果になるため注意
      const lineTax = round(rawLineAmount * taxRate);
      if (taxRate === 0.08) { sub8 += rawLineAmount; tax8 += lineTax; lineAmountSum8 += lineAmount; }
      else { sub10 += rawLineAmount; tax10 += lineTax; lineAmountSum10 += lineAmount; }
    }
    // unitPriceは後方互換のため残す（displayUnitPriceと同義、小数を保持したまま返す）
    return { ...l, unitPrice: rawUnitPrice, displayUnitPrice: rawUnitPrice, rawLineAmount, lineAmount, displayTaxRate: taxRate };
  });
  // recomputeOrderTotalsと同じ順序で丸める：区分ごとの生合計をそれぞれ丸め、
  // subtotalは「丸めた区分の和」ではなく「生合計の和を丸めた値」にする
  // （round(A)+round(B)+round(C) と round(A+B+C) は一般に一致しないため、
  // recomputeOrderTotals・buildOrderSnapshotが保存した値との一致を最優先する）
  const rawSubtotal = sub0 + sub8 + sub10 + subInvalid;
  const subtotal = round(rawSubtotal);
  const subtotal0 = round(sub0);
  const subtotal8 = round(sub8);
  const subtotal10 = round(sub10);
  const subtotalInvalid = round(subInvalid);
  const tax = tax8 + tax10;
  const total = subtotal + tax;
  // 2026-08修正（Codexレビュー指摘対応・MUST-FIX1、3ラウンド目で確定）：
  // 帳票に表示する「注文全体の端数調整額」は、必ず注文全体のSSOT小計
  // （subtotal = roundJPY(全区分の生合計)）から、全区分の明細合計（丸め済み、
  // lineAmountSumTotal）を直接引いて求める。区分ごとの差分を先に求めてから
  // 合計する方式（roundingAdjustment0+8+10+Invalidの単純合計）は、
  // round(A)+round(B)+round(C)+round(D) ≠ round(A+B+C+D) という丸め処理の
  // 性質により、注文全体のSSOT小計と一致しない反例が存在する（Codex指摘：
  // 0%区分0.4円→表示0円、8%区分0.4円→表示0円のケースで、区分別に見ると
  // 差はどちらも0だが、SSOT小計はroundJPY(0.8)=1円になる）。
  // 常に lineAmountSumTotal + roundingAdjustmentTotal = subtotal が成立する
  const lineAmountSumTotal = lineAmountSum0 + lineAmountSum8 + lineAmountSum10 + lineAmountSumInvalid;
  const roundingAdjustmentTotal = subtotal - lineAmountSumTotal;
  return {
    lines, subtotal, tax, tax8, tax10, subtotal0, subtotal8, subtotal10, subtotalInvalid, total, hasInvalidRates,
    roundingAdjustmentTotal, lineAmountSumTotal,
  };
}

// 2026-08 修正（本番回帰対応）：旧getOrderAmounts（保存済みsnap値をそのまま
// 返すだけの別SSOT）を廃止し、getDisplayOrderAmountsへの薄い委譲にする。
// 呼び出しシグネチャ（{subtotal,tax,total,tax8,tax10}を返す）は既存呼び出し
// 箇所との互換のため維持するが、計算ロジック自体はgetDisplayOrderAmountsに
// 一本化した（2つの並存するSSOTが数円〜数十円ズレる回帰を防ぐため）。
//
// 2026-08 修正（Codexレビュー指摘対応・v4）：以前はtax8/tax10がnullかどうかで
// 「税率内訳が信頼できない旧データ」を呼び出し側が判定していたが、
// getDisplayOrderAmountsは常に数値のtax8/tax10を返すため、この判定が
// 常にfalseになり死んでいた。不正税率（0/0.08/0.10以外）の明細を含む注文では、
// 有効行だけのtax8/tax10合計は実際の税額より過少になり得るのに、この判定が
// 機能しないと「税額不明」であることが呼び出し側に伝わらず、無言の過少表示に
// なる（Codex指摘）。hasInvalidRatesをそのまま返すことで、呼び出し側が
// 「税率内訳が信頼できるか」を正しく判定できるようにする
// 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：marketId引数を
// 追加。省略時は従来どおり日本版のroundJPY/JAPAN_TAX_POLICY相当のまま
function getOrderAmounts(o, marketId) {
  const d = getDisplayOrderAmounts(o, marketId);
  return { subtotal: d.subtotal, tax: d.tax, total: d.total, tax8: d.tax8, tax10: d.tax10, hasInvalidRates: d.hasInvalidRates };
}

// ✅ 明細の「欠け」対策：表示用 key と、更新に使う lineId を安全に付与
// 2026-08修正（Codexレビュー指摘対応・MINOR、単価表示不整合の是正・2ラウンド目）：
// 「lines配列を取得してnull除去する」部分を独立関数normalizeOrderLinesに切り出す。
// 以前はgetOrderLinesSafe内で(getOrderLines(order)||[]).filter(Boolean)を独自に
// 再実行しており、呼び出し側で別途計算した正規化済み配列と「たまたま同じ結果に
// なる」ことに依存していた（将来どちらかの実装だけが変更されるとindex対応が
// 壊れるリスクがあった）。normalizeOrderLinesを唯一の正規化関数とし、
// getOrderLinesSafeもgetDisplayOrderAmounts用の配列も、必ずこの関数の結果を
// 経由するように構造を固定する
export function normalizeOrderLines(order) {
  return (getOrderLines(order) || []).filter(Boolean);
}
// 正規化済み配列（normalizeOrderLinesの結果、またはそれと同じ内容の配列）を受け取り、
// 表示用の_lineId/_key・costPrice優先のprice上書きを付与する。呼び出し側が既に
// normalizeOrderLinesの結果を持っている場合は、getOrderLinesSafeで再度
// normalizeOrderLinesを呼ぶ（重複実行だが結果は同じ）代わりに、この関数へ直接
// 渡すことで「同じ配列から両方を導出する」という構造をコード上でも保証できる
export function decorateLinesSafe(arr) {
  return (arr || []).map((l, idx) => {
    const baseId = String(l?.id || l?.barcode || `row${idx}`);
    const bc = String(l?.barcode || "");
    const nm = String(l?.name || "");
    // ✅ costPriceがあればpriceに上書き（過去データの売価混入を防ぐ）
    const costP = Number(l?.costPrice ?? 0);
    const price = costP > 0 ? costP : Number(l?.price ?? 0);
    return {
      ...l,
      price,
      _lineId: baseId,
      _key: `${baseId}-${bc}-${nm}-${idx}`,
    };
  });
}
function getOrderLinesSafe(order) {
  return decorateLinesSafe(normalizeOrderLines(order));
}


// ✅ 金額計算の唯一の正（single source of truth）
// 注：招待コード生成はサーバー側（registerNewTenant / rotateInviteCode Callable）に移管済み。
// クライアント側でのコード生成（Math.randomベース）は廃止した（CSPRNG化・衝突検査・
// inviteCodesコレクションとの整合性をサーバーで一括担保するため）。

// lines: [{qty, price, taxRate}] を受け取り、税区分別合計を返す
// 端数処理: 行ごとに Math.round（四捨五入）。
// サーバー側 recomputeOrderTotals と同じ「厳密等価判定・0%区分あり」のロジックに統一。
// 不正な税率（0/0.08/0.1以外）の行は推測補完せず、hasInvalidRatesで呼び出し側へ通知する
// （サーバー側は別途 assertValidTaxRate で必ず再検証されるため、ここはプレビュー用途）
function calcOrderTotals(lines) {
  let subtotal = 0, tax0 = 0, tax8 = 0, tax10 = 0;
  let hasInvalidRates = false;
  (lines || []).forEach((l) => {
    const qty = Number(l.qty || 0);
    const price = Number(l.price || 0);
    const lineTotal = qty * price;
    const taxRate = safeDisplayTaxRate(l.taxRate);
    if (taxRate === null) {
      hasInvalidRates = true;
      subtotal += lineTotal;
      return;
    }
    const taxAmount = Math.round(lineTotal * taxRate);
    subtotal += lineTotal;
    if (taxRate === 0.08) {
      tax8 += taxAmount;
    } else if (taxRate === 0.10) {
      tax10 += taxAmount;
    } else {
      tax0 += taxAmount;
    }
  });
  const taxTotal = tax0 + tax8 + tax10;
  return { subtotal, tax8, tax10, taxTotal, grandTotal: subtotal + taxTotal, hasInvalidRates };
}

// ✅ 共通：仕入れ先選択コンポーネント（App.js のトップレベル）
function SupplierSelector({ suppliers = [], supplierId, onSelect, supplierNameById, isAU = false }) {
  const currentName =
    (typeof supplierNameById === "function" ? supplierNameById(supplierId) : "") ||
    (suppliers.find((s) => s.id === supplierId)?.name ?? "");

  const isSelected = !!supplierId;

  return (
    <div
      style={{
        border: isSelected ? "2px solid #16a34a" : "2px solid #f97316",
        borderRadius: 16,
        padding: 14,
        background: isSelected ? "#f0fdf4" : "#fff7ed",
        display: "grid",
        gap: 12,
      }}
    >
      {/* ヘッダー */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 18 }}>{isSelected ? "✅" : "⚠️"}</span>
        <div>
          <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Supplier" : "仕入れ先"}</div>
          {isSelected ? (
            <div style={{ fontSize: 13, color: "#16a34a", fontWeight: 700 }}>
              {isAU ? `Selected: ${currentName || supplierId}` : `選択中：${currentName || supplierId}`}
            </div>
          ) : (
            <div style={{ fontSize: 13, color: "#ea580c", fontWeight: 700 }}>
              {isAU ? "▼ Please select a supplier before ordering" : "▼ 仕入れ先を選んでから発注してください"}
            </div>
          )}
        </div>
      </div>

      {/* セレクト */}
      <select
        value={supplierId || ""}
        onChange={(e) => onSelect?.(e.target.value)}
        style={{
          width: "100%",
          padding: "14px 12px",
          borderRadius: 12,
          border: isSelected ? "2px solid #16a34a" : "2px solid #f97316",
          fontWeight: 800,
          fontSize: 15,
          background: "white",
          color: isSelected ? "#111" : "#ea580c",
          boxSizing: "border-box",
        }}
      >
        <option value="">{isAU ? "── Select a supplier ──" : "── 仕入れ先を選択 ──"}</option>
        {suppliers.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>

      {/* クイック選択ボタン */}
      {suppliers.length > 0 && (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {suppliers.slice(0, 6).map((s) => (
            <button
              key={s.id}
              onClick={() => onSelect?.(s.id)}
              style={{
                padding: "10px 16px",
                borderRadius: 12,
                border: s.id === supplierId ? "2px solid #16a34a" : "1.5px solid #d1d5db",
                fontWeight: 900,
                fontSize: 14,
                background: s.id === supplierId ? "#16a34a" : "white",
                color: s.id === supplierId ? "white" : "#374151",
                cursor: "pointer",
              }}
            >
              {s.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function nextSeq(key) {
  const n = Number(localStorage.getItem(key) || "0") + 1;
  localStorage.setItem(key, String(n));
  return n;
}


// ═══════════════════════════════════════════════════════════════════════
// 税率共通契約（2026-08 税率誤登録問題の修正）
// ═══════════════════════════════════════════════════════════════════════
// 日本版の内部保存税率は 0 / 0.08 / 0.10 の3値のみに限定する。
// 「不明な税率を推測して8%/10%を補完する」処理は全経路から排除し、
// fail-closed（不正・曖昧な入力は必ず明示的エラーとして拒否）に統一する。
//
// この実装は functions/index.js 側に意図的に複製されている（Cloud Functionsと
// ブラウザは別ランタイム・別ビルドパイプラインのため、モノレポ化を伴う共有
// npmパッケージ化は今回のtaxRate修正のスコープを超える）。両実装の一致は、
// 共有テストケース配列（taxRateTestCases.js）を両方に対して実行するパリティ
// テストで保証する。片方だけを変更した場合は、必ずもう一方にも同じ変更を
// 適用し、パリティテストを再実行すること。

const JAPAN_TAX_POLICY = {
  marketId: "JP",
  allowedRates: [0, 0.08, 0.10],
  // 生入力（trim・全角半角正規化済み文字列）→ 正規化後の税率、の決定的な
  // 対応表。ここに存在しない入力は「曖昧な値」として必ず拒否する
  // （n>1?n/100:n のような閾値変換ロジックは意図的に持たない）
  inputAliases: {
    "0": 0, "0%": 0, "0.0": 0, "0.0%": 0, "00": 0,
    "8": 0.08, "8%": 0.08, "8.0": 0.08, "8.0%": 0.08, "0.08": 0.08, "0.080": 0.08,
    "10": 0.10, "10%": 0.10, "10.0": 0.10, "10.0%": 0.10, "0.1": 0.10, "0.10": 0.10, "0.100": 0.10,
  },
  requireValue: true,
};

// 2026-08 AU版基盤（Phase 1）：functions/index.jsのAU_TAX_POLICYと対になる、
// 豪州GST（0% / 10%）用のtax policy。normalizeTaxRate/assertValidTaxRate/
// safeDisplayTaxRateは全てpolicy引数を明示的に渡さない限りJAPAN_TAX_POLICYを
// デフォルトで使い続けるため、この定数を追加しただけでは日本版の挙動に
// 一切影響しない。実際にAU版UIがこのpolicyを使うのはPhase 2以降のスコープ
export const AU_TAX_POLICY = {
  marketId: "AU",
  allowedRates: [0, 0.10],
  inputAliases: {
    "0": 0, "0%": 0, "0.0": 0, "0.0%": 0, "00": 0, "gst free": 0, "gstfree": 0,
    "10": 0.10, "10%": 0.10, "10.0": 0.10, "10.0%": 0.10, "0.1": 0.10, "0.10": 0.10, "0.100": 0.10, "gst": 0.10,
  },
  requireValue: true,
};

// marketId（"JP" | "AU"）からtax policyを解決する。functions/index.jsの
// resolveTaxPolicyと対になる。未知のmarketIdはfail-closedでJAPAN_TAX_POLICYへ
// フォールバックせず例外を投げる
export function resolveTaxPolicy(marketId) {
  if (marketId === "AU") return AU_TAX_POLICY;
  if (marketId === "JP" || marketId == null) return JAPAN_TAX_POLICY;
  throw new Error(`TAX_POLICY_UNKNOWN_MARKET: 不明なmarketIdです: ${JSON.stringify(marketId)}`);
}

// 全角数字・全角パーセント・全角小数点を半角に正規化する（値の意味は変えない、
// 表記ゆれの吸収のみ）
function normalizeTaxRateInputString(s) {
  return String(s)
    .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))
    .replace(/％/g, "%")
    .replace(/．/g, ".")
    .trim()
    .replace(/\s+/g, ""); // 内部の空白（"10 %"等）も除去する
}

// normalizeTaxRate(raw, policy) — 税率生入力を正規化する。
// 戻り値: { ok: true, value: 0|0.08|0.10 } | { ok: false, error: { code, message, rawInput } }
function normalizeTaxRate(raw, policy = JAPAN_TAX_POLICY) {
  // boolean/Array/プレーンオブジェクトは即座に型エラー（false→0のような
  // 暗黙変換は絶対にしない）
  if (typeof raw === "boolean" || Array.isArray(raw) || (raw !== null && typeof raw === "object")) {
    return { ok: false, error: { code: "TAX_RATE_INVALID_TYPE", message: "税率は数値または文字列である必要があります", rawInput: raw } };
  }
  if (typeof raw === "number" && !Number.isFinite(raw)) {
    return { ok: false, error: { code: "TAX_RATE_INVALID_TYPE", message: "税率が不正な数値です（NaN/Infinity）", rawInput: raw } };
  }
  if (raw === null || raw === undefined || String(raw).trim() === "") {
    if (policy.requireValue) {
      return { ok: false, error: { code: "TAX_RATE_REQUIRED", message: "税率が未入力です", rawInput: raw } };
    }
  }

  const normalized = normalizeTaxRateInputString(raw);
  if (Object.prototype.hasOwnProperty.call(policy.inputAliases, normalized)) {
    return { ok: true, value: policy.inputAliases[normalized] };
  }
  return {
    ok: false,
    error: {
      code: "TAX_RATE_UNRECOGNIZED",
      message: `不正な税率です: ${JSON.stringify(raw)}（入力可能値: 0% / 8% / 10% 相当の表記のみ）`,
      rawInput: raw,
    },
  };
}

// assertValidTaxRate(value, policy) — 保存直前の最終防御。
// 呼び出し側は Number(...) 等の事前型強制を行わず、元の値をそのまま渡すこと。
// 不正な場合は例外を投げる（fail-closed）
function assertValidTaxRate(value, policy = JAPAN_TAX_POLICY) {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    throw new Error(`TAX_RATE_INVALID_TYPE: 税率は数値である必要があります: ${JSON.stringify(value)}`);
  }
  if (!policy.allowedRates.includes(value)) {
    throw new Error(`TAX_RATE_OUT_OF_RANGE: 不正な税率です: ${value}`);
  }
  return value;
}

// 表示専用の安全参照。不正な税率（0/0.08/0.1以外）を推測補完せず、
// 呼び出し側が「不明」であることを明示的に扱えるようnullを返す
// （例外を投げるとレンダリング中に画面全体がクラッシュするため、表示系は非throw）
function safeDisplayTaxRate(rawTaxRate, policy = JAPAN_TAX_POLICY) {
  const n = Number(rawTaxRate);
  if (Number.isFinite(n) && policy.allowedRates.includes(n)) return n;
  return null;
}

// 2026-08 重複発注防止：1回の発注操作を識別するrequestId（idempotencyKey）を生成する。
// crypto.randomUUID()はHTTPS/localhost限定のWeb Crypto APIのため、非対応環境向けの
// フォールバックも用意する（衝突確率は実用上無視できるレベル）
function generateRequestId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `req-${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

// 2026-08 Codexレビュー指摘対応（MUST-FIX）：ABNの11桁形式チェックのみでは
// "00000000000"のような無効な番号でも通ってしまっていた。ATO公式のABN checksum
// アルゴリズム（weighted modulus 89）で検証する。サーバー側（functions/index.js
// のisValidAbnChecksum）と同一ロジック——クライアント側はUX向上のための早期
// フィードバック用であり、権威的な検証は引き続きサーバー側issueBillingが行う。
// 参照：https://abr.business.gov.au/Help/AbnFormat
const ABN_WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
function isValidAbnChecksum(abnDigits) {
  if (!/^\d{11}$/.test(abnDigits)) return false;
  const digits = abnDigits.split("").map(Number);
  digits[0] -= 1;
  const sum = digits.reduce((acc, d, i) => acc + d * ABN_WEIGHTS[i], 0);
  return sum % 89 === 0;
}

// 税率の "N%" 表示専用ヘルパー（テーブルセル等）。不正値は10%として黙って
// 表示せず、赤字で「税率エラー」と出して利用者が気づけるようにする
function TaxRateBadge({ rawTaxRate, isAU = false }) {
  const rate = safeDisplayTaxRate(rawTaxRate);
  if (rate === null) {
    return <span style={{ color: "#dc2626", fontWeight: 700 }}>{isAU ? "GST rate error" : "税率エラー"}</span>;
  }
  return <>{Math.round(rate * 100)}%</>;
}

// 検索正規化：半角カナ→全角カナ→ひらがな に統一して比較
export function normalizeKana(str) {
  // Step1: 半角カナ→全角カナ（濁音・半濁音合成対応）
  const h2z = {
    'ｦ':'ヲ','ｧ':'ァ','ｨ':'ィ','ｩ':'ゥ','ｪ':'ェ','ｫ':'ォ','ｬ':'ャ','ｭ':'ュ','ｮ':'ョ',
    'ｯ':'ッ','ｰ':'ー','ｱ':'ア','ｲ':'イ','ｳ':'ウ','ｴ':'エ','ｵ':'オ','ｶ':'カ','ｷ':'キ',
    'ｸ':'ク','ｹ':'ケ','ｺ':'コ','ｻ':'サ','ｼ':'シ','ｽ':'ス','ｾ':'セ','ｿ':'ソ','ﾀ':'タ',
    'ﾁ':'チ','ﾂ':'ツ','ﾃ':'テ','ﾄ':'ト','ﾅ':'ナ','ﾆ':'ニ','ﾇ':'ヌ','ﾈ':'ネ','ﾉ':'ノ',
    'ﾊ':'ハ','ﾋ':'ヒ','ﾌ':'フ','ﾍ':'ヘ','ﾎ':'ホ','ﾏ':'マ','ﾐ':'ミ','ﾑ':'ム','ﾒ':'メ',
    'ﾓ':'モ','ﾔ':'ヤ','ﾕ':'ユ','ﾖ':'ヨ','ﾗ':'ラ','ﾘ':'リ','ﾙ':'ル','ﾚ':'レ','ﾛ':'ロ',
    'ﾜ':'ワ','ﾝ':'ン','ﾞ':'゛','ﾟ':'゜',
  };
  const voiced = {'カ':'ガ','キ':'ギ','ク':'グ','ケ':'ゲ','コ':'ゴ','サ':'ザ','シ':'ジ','ス':'ズ',
    'セ':'ゼ','ソ':'ゾ','タ':'ダ','チ':'ヂ','ツ':'ヅ','テ':'デ','ト':'ド','ハ':'バ','ヒ':'ビ',
    'フ':'ブ','ヘ':'ベ','ホ':'ボ','ウ':'ヴ'};
  const semiVoiced = {'ハ':'パ','ヒ':'ピ','フ':'プ','ヘ':'ペ','ホ':'ポ'};
  let s = '';
  const chars = [...String(str || '')];
  for (let i = 0; i < chars.length; i++) {
    const c = chars[i], next = chars[i+1], z = h2z[c];
    if (z && next === 'ﾞ' && voiced[z])       { s += voiced[z]; i++; }
    else if (z && next === 'ﾟ' && semiVoiced[z]) { s += semiVoiced[z]; i++; }
    else if (z) { s += z; }
    else { s += c; }
  }
  // Step2: 全角カナ→ひらがな（U+30A1-30F6 → U+3041-3096）
  s = s.replace(/[ァ-ヶ]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x60));
  // Step3: 全角英数・記号→半角（U+FF01-FF5E → U+0021-007E）
  s = s.replace(/[！-～]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xFEE0));
  // Step4: 全角スペース→半角
  s = s.replace(/\u3000/g, ' ');
  return s.toLowerCase();
}

const PRODUCT_SEARCH_TOKEN_MAX_LEN = 20; // 1\u30c8\u30fc\u30af\u30f3\u3042\u305f\u308a\u6700\u5927\u6587\u5b57\u6570\uff08\u3053\u308c\u3092\u8d85\u3048\u308b\u90e8\u5206\u306f\u5207\u308a\u8a70\u3081\uff09
const PRODUCT_SEARCH_TOKENS_MAX_COUNT = 40; // 1\u5546\u54c1\u3042\u305f\u308a\u4fdd\u5b58\u3059\u308b\u30d7\u30ec\u30d5\u30a3\u30c3\u30af\u30b9\u306e\u6700\u5927\u6570
// 2026-08 \u5546\u54c1\u691c\u7d22\u4e0d\u5177\u5408\u4fee\u6b63\uff1a\u5546\u54c1\u540d\u306e\u300c\u5148\u982d\u4e00\u81f4\u300d\u3060\u3051\u3067\u306a\u304f\u300c\u5358\u8a9e\u5358\u4f4d\u306e\u4e2d\u9593\u4e00\u81f4\u300d
// \uff08\u4f8b\uff1a\u5168\u89d2\u30b9\u30da\u30fc\u30b9\u533a\u5207\u308a\u306e\u5546\u54c1\u540d\u3092\u30012\u8a9e\u76ee\u4ee5\u964d\u306e\u4e00\u90e8\u5206\u3060\u3051\u3067\u691c\u7d22\u3057\u3066\u3082\u30d2\u30c3\u30c8\u3059\u308b\uff09\u306b
// \u5bfe\u5fdc\u3059\u308b\u305f\u3081\u3001normalizeKana\u6e08\u307f\u306e\u5546\u54c1\u540d\u3092\u30b9\u30da\u30fc\u30b9\u533a\u5207\u308a\u3067\u30c8\u30fc\u30af\u30f3\u5206\u5272\u3057\u3001\u5404\u30c8\u30fc\u30af\u30f3\u306e
// \u5168\u30d7\u30ec\u30d5\u30a3\u30c3\u30af\u30b9\uff081\u6587\u5b57\u76ee\u30011\u301c2\u6587\u5b57\u76ee\u30011\u301c3\u6587\u5b57\u76ee\u2026\uff09\u3092\u751f\u6210\u3057\u3066Firestore\u306e
// array-contains\u3067\u691c\u7d22\u3067\u304d\u308b\u3088\u3046\u306b\u3059\u308b\u30021\u30c8\u30fc\u30af\u30f3\u3042\u305f\u308a\u306e\u751f\u6210\u30d7\u30ec\u30d5\u30a3\u30c3\u30af\u30b9\u6570\u30fb
// \u4fdd\u5b58\u3059\u308b\u914d\u5217\u306e\u7dcf\u30b5\u30a4\u30ba\u306b\u306f\u5b9f\u7528\u4e0a\u306e\u4e0a\u9650\u3092\u8a2d\u3051\u3001\u6975\u7aef\u306b\u9577\u3044\u5546\u54c1\u540d\u3067\u30c9\u30ad\u30e5\u30e1\u30f3\u30c8\u30b5\u30a4\u30ba\u304c
// \u80a5\u5927\u5316\u3057\u306a\u3044\u3088\u3046\u306b\u3059\u308b
export function buildProductSearchTokens(name) {
  const normalized = normalizeKana(String(name || "")).trim();
  if (!normalized) return [];
  const words = normalized.split(/\s+/).filter(Boolean);
  const prefixes = new Set();
  words.forEach((w) => {
    const truncated = w.slice(0, PRODUCT_SEARCH_TOKEN_MAX_LEN);
    for (let i = 1; i <= truncated.length; i++) {
      prefixes.add(truncated.slice(0, i));
    }
  });
  return Array.from(prefixes).slice(0, PRODUCT_SEARCH_TOKENS_MAX_COUNT);
}

// 2026-08 商品検索不具合修正（Codexレビュー指摘対応・2ラウンド目、テストで実装の
// 回帰を検知できるようにする）：前方一致結果とトークン一致結果を「重複排除しながら
// 結合する」ロジックを、loadWholesaleMasterSearchPage（React state/refに依存する
// コンポーネント内関数）から独立したトップレベルの純粋関数として切り出す。
// loadWholesaleMasterSearchPage側もこの関数を呼ぶことで、ユニットテストが実装と
// 同じ関数を直接検証できるようになる。以前のように「前方一致0件時のみトークン検索」
// という実装に戻った場合、この関数のシグネチャ自体は変わらないため、
// loadWholesaleMasterSearchPage側の呼び出し方が変わっていないかは別途コードレビュー
// で確認する必要があるが、少なくとも「マージ・重複排除ロジック自体」の回帰は
// このテストで検知できる
export function mergeSearchDocs(frontIdDataPairs, tokenIdDataPairs, alreadySeenIds) {
  const seen = new Set(alreadySeenIds || []);
  const toPlain = ([id, data]) => ({ ...data, id, _docId: id });
  const frontDocs = (frontIdDataPairs || [])
    .filter(([id]) => !seen.has(id))
    .map((pair) => { seen.add(pair[0]); return toPlain(pair); });
  const tokenDocs = (tokenIdDataPairs || [])
    .filter(([id]) => !seen.has(id))
    .map((pair) => { seen.add(pair[0]); return toPlain(pair); });
  return { merged: [...frontDocs, ...tokenDocs], seen };
}

function nextOrderNo() {
  const n = nextSeq("order_no_v1");
  return String(n).padStart(6, "0");
}

function nextDeliveryNo() {
  const n = nextSeq("delivery_no_v1");
  return String(n).padStart(6, "0");
}
// 注：請求番号の採番はissueBilling Callableへ移管済み（countersはRulesで書き込み禁止）

// 商品マスタ Excel ダウンロード
// 2026-08 AU版基盤（Phase 3）：marketId引数を追加。AU版では列見出しを英語化し、
// GST（10%/0%の2値のみ）を前提とした表記にする。日本版はmarketId未指定時の
// デフォルト動作として完全に既存のまま（列見出し・税率表記とも一切変更しない）
function downloadProductsAsExcel(productList, filename, marketId) {
  const isAUExport = marketId === "AU";
  const policy = resolveTaxPolicy(marketId);
  // 2026-08（Codexレビュー指摘対応・MINOR）：以前はMath.round固定だったため、
  // 旧データ・欠損データのフォールバック計算でAUのセントが失われていた
  const exportRoundFn = isAUExport ? roundAUD : Math.round;
  const rows = productList.map((p) => {
    // 既存データの税率が不正（policyのallowedRatesに含まれない）な場合、税込価格計算に
    // 推測値を使うと誤った金額を出力してしまうため、税抜側の価格から
    // 逆算せず「税率列に警告文字列」を出して利用者に気づかせる
    const taxRate = safeDisplayTaxRate(p.taxRate, policy);
    const sellPriceInc =
      p.sellPriceInc > 0
        ? p.sellPriceInc
        : p.sellPrice > 0 && taxRate !== null
        ? exportRoundFn(p.sellPrice * (1 + taxRate))
        : (p.sellPrice > 0 ? "" : 0);
    if (isAUExport) {
      return {
        "Barcode": p.barcode ?? "",
        "Product name": p.name ?? "",
        "Unit": p.unit ?? "",
        "Sell price (inc GST)": sellPriceInc || "",
        "Cost price (ex GST)": p.costPrice ?? "",
        "Purchase cost (ex GST)": p.purchaseCost ?? "",
        "Category": p.category ?? "",
        "GST rate": taxRate !== null ? taxRate : `Check value (${JSON.stringify(p.taxRate)})`,
      };
    }
    return {
      "JANコード": p.barcode ?? "",
      "商品名": p.name ?? "",
      "単位": p.unit ?? "個",
      "小売販売価格(税込)": sellPriceInc || "",
      "発注単価(税抜)": p.costPrice ?? "",
      "仕入原価(税抜)": p.purchaseCost ?? "",
      "カテゴリ／部門": p.category ?? "",
      "税率": taxRate !== null ? taxRate : `要確認(${JSON.stringify(p.taxRate)})`,
    };
  });
  // json_to_sheetは空配列を渡すとヘッダー行すら書き出さず、シートが完全に
  // 空白になる（Download templateボタンでこの症状が発生していた）。
  // headerオプションで列名を明示することで、商品0件でもヘッダー行だけは
  // 必ず出力されるようにする。列名はrowsのキーと文字列として完全一致させる
  // 必要があるため、上のrows生成ロジックのキーをそのまま列挙する
  // （import側の受け入れ判定はPRODUCT_IMPORT_HEADER_ALIASESが唯一のSSOTであり、
  // ここで書き出す列名はいずれもそのAU/JPエイリアスに含まれる表記と一致する）
  const headerCols = isAUExport
    ? ["Barcode", "Product name", "Unit", "Sell price (inc GST)", "Cost price (ex GST)", "Purchase cost (ex GST)", "Category", "GST rate"]
    : ["JANコード", "商品名", "単位", "小売販売価格(税込)", "発注単価(税抜)", "仕入原価(税抜)", "カテゴリ／部門", "税率"];
  const ws = XLSX.utils.json_to_sheet(rows, { header: headerCols });
  // 列幅設定
  ws["!cols"] = [
    { wch: 16 }, { wch: 28 }, { wch: 8 },
    { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 18 }, { wch: 8 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, isAUExport ? "Product catalogue" : "商品マスタ");
  XLSX.writeFile(wb, filename);
}

// AU版「Download template」専用：ヘッダー行に加え、日本版の静的テンプレート
// （/商品マスタ登録フォーマット.xlsx）と同様にsample rowsと説明シートを用意する。
// GST 10%商品・GST-free商品それぞれ1行ずつのサンプルを入れる。サンプル行は
// barcode/nameを埋めているため、そのままExcel取り込みしても実商品として登録できる
// （barcodeが空の行は最終確定処理で黙ってskip対象になる仕様のため、
// barcodeも必ず埋めておく必要がある）。列見出しはdownloadProductsAsExcelの
// AU分岐と完全一致させ、PRODUCT_IMPORT_HEADER_ALIASESが受け付ける表記のみを使用する。
//
// Cost price (ex GST) と Purchase cost (ex GST) は別概念（15947-16018行目付近の
// UIフォーム・コメント「発注単価」「仕入原価（将来の棚卸・利益管理用）」で確認済み）：
//   - Cost price = 卸が小売に請求する単価（注文・請求計算で実際に使われる主要な値）
//   - Purchase cost = 卸自身の仕入コスト（任意項目、取引金額計算には使われない）
function downloadAuProductImportTemplate(filename) {
  const headerCols = ["Barcode", "Product name", "Unit", "Sell price (inc GST)", "Cost price (ex GST)", "Purchase cost (ex GST)", "Category", "GST rate"];
  // barcodeは有効なEAN-13チェックディジット付き（実在の商品ではない架空コード）
  const sampleRows = [
    { "Barcode": "9310000000018", "Product name": "Example: Rolled Oats 1kg", "Unit": "each", "Sell price (inc GST)": 6.60, "Cost price (ex GST)": 4.00, "Purchase cost (ex GST)": "", "Category": "Pantry", "GST rate": 0.10 },
    { "Barcode": "9310000000025", "Product name": "Example: Fresh Bananas 1kg", "Unit": "each", "Sell price (inc GST)": 3.50, "Cost price (ex GST)": 2.20, "Purchase cost (ex GST)": "", "Category": "Fresh produce", "GST rate": 0 },
  ];
  const ws = XLSX.utils.json_to_sheet(sampleRows, { header: headerCols });
  ws["!cols"] = [
    { wch: 16 }, { wch: 28 }, { wch: 8 },
    { wch: 16 }, { wch: 14 }, { wch: 14 }, { wch: 18 }, { wch: 8 },
  ];

  // ── Getting started シート：1〜2分で読める概念説明。JP版「概念説明」シートの
  // 役割を踏襲。列の意味・GST/barcode/価格の扱い・入力ルール・使い方の流れを
  // 表形式・箇条書きで整理する。全文言は実装（handleImportFile・
  // PRODUCT_IMPORT_HEADER_ALIASES・確定処理・UIフォーム）で確認済みの事実のみを記載。
  // 注：使用しているxlsxパッケージ（コミュニティ版SheetJS）はセルスタイル
  // （太字・フォントサイズ等）を保存・復元しないため、見出しの区別は大文字化・
  // 区切り線・番号付けなどテキスト自体の書き方で表現する
  const gettingStartedRows = [
    ["OrderLink Product Catalogue Template"],
    [""],
    ["Use this template to upload your product catalogue to OrderLink."],
    ["Enter one product per row in the \"Product catalogue\" sheet. Do not change the column headings."],
    ["Each row represents one product that your customers can order."],
    [""],
    ["HOW IT WORKS"],
    ["1. Download the template"],
    ["2. Enter your products in the Product catalogue sheet"],
    ["3. Save the Excel file (.xlsx)"],
    ["4. Upload it using the \"Import Excel\" button"],
    ["5. Review the import preview"],
    ["6. Confirm to add the products to your catalogue"],
    [""],
    ["COLUMNS"],
    ["Column", "What to enter"],
    ["Barcode", "Required. Rows without a barcode are not saved when you confirm the import. Numbers only."],
    ["Product name", "Required. The name your customers will see when ordering."],
    ["Unit", "How the product is sold, e.g. each, carton, box, pack, kg."],
    ["Sell price (inc GST)", "Optional. The retail price the retailer charges their own customer, including GST. For your reference only — it is not used in orders or invoices. Enter as a decimal amount in Australian dollars, e.g. 6.60."],
    ["Cost price (ex GST)", "Your price to the retailer, excluding GST. This is the price actually used for orders and invoices. Enter as a decimal amount, e.g. 4.00."],
    ["Purchase cost (ex GST)", "Optional. What you paid to buy the product, excluding GST. For your own records only (e.g. margin tracking) — it is not used in orders or invoices."],
    ["Category", "Optional. A group name to help you organise your products, e.g. Pantry, Fresh produce."],
    ["GST rate", "Enter 0.1 for GST-applicable products (10%), or 0 for GST-free products."],
    [""],
    ["RULES"],
    ["- Do not rename the column headings."],
    ["- Enter one product per row."],
    ["- Barcode is required."],
    ["- Prices are entered in Australian dollars."],
    ["- Use 0.1 or 0 for the GST rate column — no other values are accepted."],
    ["- Optional fields (Sell price, Purchase cost, Category) may be left empty."],
    ["- Do not add formulas."],
    ["- Save the file as .xlsx before uploading."],
  ];
  const wsGettingStarted = XLSX.utils.aoa_to_sheet(gettingStartedRows);
  wsGettingStarted["!cols"] = [{ wch: 26 }, { wch: 80 }];

  // handleImportFileはwb.SheetNames[0]（＝ワークブック内で最初のシート）だけを
  // 読む実装のため、説明シートを先に追加すると再アップロード時にそちらが読まれて
  // ヘッダー解決に失敗する。必ずProduct catalogueを1枚目にする
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Product catalogue");
  XLSX.utils.book_append_sheet(wb, wsGettingStarted, "Getting started");
  XLSX.writeFile(wb, filename);
}
// Firestore採番（テナントごと・年度ごとに連番、複数端末でも重複なし）
// 採番キー例: "2025" (4月始まり年度)
function fiscalYear() {
  const d = new Date();
  return d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1; // 4月以降が新年度
}
// 注：納品書番号の採番はissueDeliveryNote / createManualOrder Callableへ移管済み
// （countersコレクションはRulesでクライアント書き込み禁止）

// vibration / beep
function feedbackOnScan() {
  try {
    if (navigator.vibrate) navigator.vibrate(80);
  } catch {}

  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = 880;
    gain.gain.value = 0.02;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    setTimeout(() => {
      osc.stop();
      ctx.close();
    }, 80);
  } catch {}
}

const COL = {
  suppliers: "suppliers",
  products: "products",
  orders: "orders",
};


function normJan(v) {
  if (v == null) return "";
  // Excelが数値扱いすると "490... .0" になることがある
  let s = String(v).trim().replace(/\.0$/, "");
  s = s.replace(/\s/g, "");
  // 数字以外（ハイフン等）は削る
  s = s.replace(/[^\d]/g, "");
  return s;
}

// 2026-08 AU版基盤（Phase 3）：marketId引数を追加。AU版は英語列見出し
// （downloadProductsAsExcelがAU向けに出力する列名と対応）を読み取り、税率空欄時の
// デフォルトはpolicyの最高税率（AUなら0.10=GST、JPなら0.10=標準税率）を使う。
// 日本版はmarketId未指定時、既存の列見出し・デフォルト税率動作を完全維持する
function normalizeImportRows(rows, marketId) {
  const isAUImport = marketId === "AU";
  const policy = resolveTaxPolicy(marketId);
  const defaultRate = Math.max(...policy.allowedRates); // JP: 0.10, AU: 0.10（どちらも標準税率）
  return (rows || [])
    .map((r) => {
      const jan = normJan(isAUImport ? (r["Barcode"] ?? r["JANコード"]) : r["JANコード"]);
      const name = String((isAUImport ? (r["Product name"] ?? r["商品名"]) : r["商品名"]) ?? "").trim();

      // ✅ ここが本体：バーコード空 or 商品名空 は捨てる
      if (!jan || !name) return null;

      const unit = String((isAUImport ? (r["Unit"] ?? r["単位"]) : r["単位"]) ?? "").trim() || (isAUImport ? "" : "個");

      const costPrice = Number(String((isAUImport ? (r["Cost price (ex GST)"] ?? r["原価(税抜)"]) : r["原価(税抜)"]) ?? "0").replace(/,/g, "")) || 0;
      const sellPriceInc = Number(String(
        (isAUImport
          ? (r["Sell price (inc GST)"] ?? r["小売への販売価格(税込)"] ?? r["売価(税込)"] ?? r["売価(税抜)"])
          : (r["小売への販売価格(税込)"] ?? r["売価(税込)"] ?? r["売価(税抜)"])
        ) ?? "0"
      ).replace(/,/g, "")) || 0;

      const taxRate = (() => {
        const raw = String((isAUImport ? (r["GST rate"] ?? r["税率"]) : r["税率"]) ?? "").replace(/[,\s]/g, "").replace(/%$/, "").trim();
        if (raw === "") return defaultRate;
        const n = Number(raw);
        if (!Number.isFinite(n)) return defaultRate;
        if (n > 1) return Math.round(n) / 100; // 8→0.08, 10→0.1
        if (n >= 0) return n;                   // 0.08, 0.1, 0
        return defaultRate;
      })();

      const sellPrice = sellPriceInc > 0 ? Math.round(sellPriceInc / (1 + taxRate)) : 0;

      return {
        barcode: jan,
        name,
        unit,
        costPrice,
        sellPrice,
        sellPriceInc,
        taxRate,
      };
    })
    .filter(Boolean);
}


// 会社情報フォームを独立コンポーネント化 → 入力ごとにApp全体が再レンダリングされる問題を解消
function RetailCompanyInfoPage({ initialProfile, onSave, onBack, isAU = false }) {
  const card = { border: "1px solid #eee", borderRadius: 14, padding: 12, background: "white" };
  const inp  = { padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, fontSize: 16, width: "100%", boxSizing: "border-box" };
  const [form, setForm] = React.useState({
    retailCompany:      initialProfile?.retailCompany      || "",
    retailName:         initialProfile?.retailName         || "",
    retailAddress:      initialProfile?.retailAddress      || "",
    retailTel:          initialProfile?.retailTel          || "",
    retailFax:          initialProfile?.retailFax          || "",
    retailEmail:        initialProfile?.retailEmail        || "",
  });
  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));
  return (
    <div style={{ display: "grid", gap: 12, maxWidth: 520, margin: "0 auto" }}>
      <div style={{ ...card, display: "flex", alignItems: "center", gap: 10 }}>
        <button onClick={onBack} style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #ddd", background: "white", fontWeight: 900, cursor: "pointer" }}>{isAU ? "← Back" : "← 戻る"}</button>
        <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "🏢 Business details" : "🏢 会社情報"}</div>
      </div>
      <div style={{ ...card, display: "grid", gap: 10 }}>
        <div style={{ fontWeight: 700, fontSize: 12, color: "#555" }}>{isAU ? "🛒 Store details (printed on orders as the sender)" : "🛒 自店情報（発注書の発行元に印字）"}</div>
        <input value={form.retailCompany} onChange={set("retailCompany")} placeholder={isAU ? "Company name (e.g. Smith Stores Pty Ltd)" : "社名（例：佐藤商店株式会社）"} style={inp} />
        <input value={form.retailName}    onChange={set("retailName")}    placeholder={isAU ? "Store name (e.g. Smith Supermarket)" : "店舗名（例：佐藤スーパー）"}   style={inp} />
        <input value={form.retailAddress} onChange={set("retailAddress")} placeholder={isAU ? "Address" : "住所"}                       style={inp} />
        <input value={form.retailTel}     onChange={set("retailTel")}     placeholder={isAU ? "Phone" : "TEL"}                        style={inp} />
        <input value={form.retailFax}     onChange={set("retailFax")}     placeholder="Fax"                        style={inp} />
        <input type="email" value={form.retailEmail} onChange={set("retailEmail")} placeholder={isAU ? "Email address" : "メールアドレス"}     style={inp} />
      </div>
      <button onClick={() => onSave(form)}
        style={{ background: "#111", color: "white", padding: "16px", fontSize: 16, fontWeight: 900, borderRadius: 14, border: "none", cursor: "pointer" }}>
        {isAU ? "Save and go back" : "保存して戻る"}
      </button>
    </div>
  );
}

// 2026-08 AU版基盤（Phase 2）：Sample Retailerモーダル。「Retailerが注文を入力すると
// そのままWholesalerに届く」というOrderLinkの核心価値を、卸オーナー自身が一人で
// 体験できる最小構成のUI。実際のRetailerアカウント・招待コード・別tenantは一切
// 作らない——サーバー側のseedDemoData Callable（isDemo:trueを保証する唯一の経路）を
// 通して、選択した商品・数量から実際に注文を生成する。「Place order」を押すまでは
// 何もFirestoreに書き込まれない（事前生成された「受信済み注文」を見せるだけの
// 実装は意図的に避けている）
function SampleRetailerModal({ open, onClose, onOrderPlaced, tenantId, marketId }) {
  const [sampleProducts, setSampleProducts] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [qtyById, setQtyById] = React.useState({});
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (!open || !tenantId) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      try {
        // 自テナントの既存isDemo商品を先に確認する。既にあればそれを再利用し、
        // 無ければseedDemoData(products)で初回のみ生成する（同一tenantで
        // 何度Sample Retailerを開いても、商品が重複投入されないようにするため）
        const existingSnap = await getDocs(
          query(collection(db, "products"), where("tenantId", "==", tenantId), where("isDemo", "==", true))
        );
        let docs = existingSnap.docs;
        if (docs.length === 0) {
          const seedFn = httpsCallable(functions, "seedDemoData");
          await seedFn({ dataType: "products" });
          const afterSeedSnap = await getDocs(
            query(collection(db, "products"), where("tenantId", "==", tenantId), where("isDemo", "==", true))
          );
          docs = afterSeedSnap.docs;
        }
        if (cancelled) return;
        setSampleProducts(docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error("[SampleRetailerModal] load error", e);
        if (!cancelled) setError("Failed to load sample products. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [open, tenantId]);

  if (!open) return null;

  const setQty = (id, qty) => setQtyById((prev) => ({ ...prev, [id]: Math.max(1, Math.round(Number(qty) || 1)) }));

  async function handlePlaceOrder() {
    const lineItems = sampleProducts
      .filter((p) => (qtyById[p.id] || 0) > 0)
      .map((p) => ({ productId: p.id, qty: qtyById[p.id] || 1 }));
    if (lineItems.length === 0) {
      setError("Please select at least one product.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      trackEvent("sample_order_submit");
      const seedFn = httpsCallable(functions, "seedDemoData");
      await seedFn({ dataType: "sampleOrder", lineItems });
      onOrderPlaced?.();
    } catch (e) {
      console.error("[SampleRetailerModal] sampleOrder error", e);
      setError(e?.message || "Failed to place sample order. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "white", borderRadius: 16, padding: 24, maxWidth: 480, width: "100%", maxHeight: "85vh", overflowY: "auto" }}>
        <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 4 }}>🛒 Sample Retailer</div>
        <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 16 }}>
          Pick a few sample products and place an order — just like one of your retail customers would. It will land in your Order management screen instantly.
        </div>

        {loading ? (
          <div style={{ padding: 20, textAlign: "center", color: "#6b7280" }}>Loading sample products…</div>
        ) : sampleProducts.length === 0 ? (
          <div style={{ padding: 20, textAlign: "center", color: "#6b7280" }}>No sample products available. Please try again.</div>
        ) : (
          <div style={{ display: "grid", gap: 10, marginBottom: 16 }}>
            {sampleProducts.map((p) => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 10, border: "1px solid #e5e7eb", borderRadius: 10, padding: "10px 12px" }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{p.name}</div>
                  <div style={{ fontSize: 12, color: "#9ca3af" }}>{formatMoney(p.costPrice, marketId)} / {p.unit}</div>
                </div>
                <input
                  type="number" min={0} step={1}
                  value={qtyById[p.id] ?? 0}
                  onChange={(e) => setQty(p.id, e.target.value)}
                  style={{ width: 64, padding: "8px 10px", borderRadius: 8, border: "1px solid #d1d5db", textAlign: "center" }}
                />
              </div>
            ))}
          </div>
        )}

        {error && <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 12 }}>{error}</div>}

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={onClose} disabled={submitting}
            style={{ flex: 1, padding: "12px", borderRadius: 10, border: "1px solid #d1d5db", background: "white", fontWeight: 700, cursor: submitting ? "not-allowed" : "pointer" }}>
            Cancel
          </button>
          <button onClick={handlePlaceOrder} disabled={submitting || loading || sampleProducts.length === 0}
            style={{ flex: 2, padding: "12px", borderRadius: 10, border: "none", background: submitting ? "#93c5fd" : "#2563eb", color: "white", fontWeight: 900, cursor: submitting ? "not-allowed" : "pointer" }}>
            {submitting ? "Placing order…" : "Place order"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  // 2026-08 AU Ads launch blocker対応：広告クリック由来のgclid/UTMパラメータを
  // 他のどのuseStateイニシャライザ（authMode等）よりも先に、コンポーネントの
  // 最初のレンダリング時点でlocalStorageへキャプチャする。useEffectだと
  // マウント後まで遅延するため、その間に他の初期化処理がURLを書き換える
  // 可能性を避けるには、この位置（他のuseStateより前）が最も確実
  useState(() => { captureAdAttributionFromUrl(); return null; });

  // ===== mode =====
  const [mode, setMode] = useState("retail"); // retail / wholesale
  const [retailView, setRetailView] = useState("home"); // home / order / history / products / summary
  const [janMode, setJanMode] = useState("scan"); // scan | manual
  


  // ===== login form =====
const [email, setEmail] = useState("");
const [password, setPassword] = useState("");
const [authBusy, setAuthBusy] = useState(false);
const [authMode, setAuthMode] = useState(() => {
  // LP から ?signup=true で来た場合は新規登録画面を最初に表示
  const params = new URLSearchParams(window.location.search);
  const mode = params.get("login") === "true" ? "login" : "register";
  return mode;
}); // "login" | "register"
const [showRegisterForm, setShowRegisterForm] = useState(false); // Step2（メール入力）の表示制御
// 2026-08（22回目→23回目→24回目Codexレビュー指摘、MUST-FIX対応）：以前は
// authMode==="register"かつshowRegisterForm===falseというStep1画面の表示条件
// だけでsignup_startを発火させていたが、authModeの初期値は?login=trueが無い
// 限り常に"register"になる設計（未ログインでアプリへ直接アクセスしただけの
// 素の訪問でも同じ画面が表示される）ため、「明確な登録意図がある場合だけ発火」
// という目的を満たしていなかった（22回目対応）。
// 23回目対応では?signup=true・?invite=の2つのURL条件に限定したが、これは
// 「素のURL（/）からStep1画面が表示され、そこでユーザーが実際に"Sign up with
// email"・"Sign up with Google"をクリックする」という、URLパラメータを一切
// 経由しない直接流入・ブックマーク・外部リンク等からの正当な登録開始を
// 見落としていた（24回目Codexレビュー指摘）。
// 個々のURL条件を列挙し続けるのではなく、共通のfireSignupStartOnce(source)を
// 1つ用意し、以下の全ての登録開始経路から呼ぶ設計に変更する：
//   (a) ?signup=true初期表示
//   (b) ?invite=初期表示
//   (c) 素のStep1画面での"Sign up with email"クリック
//   (d) 素のStep1画面での"Sign up with Google"クリック
//   (e) ログイン画面からのSign up切り替え
// ページ内では共通refで一度だけに制限し、ログイン⇄登録の往復・連打による
// 重複送信も防ぐ
const signupStartFiredRef = useRef(false);
function fireSignupStartOnce(source) {
  if (signupStartFiredRef.current) return;
  signupStartFiredRef.current = true;
  trackEvent("signup_start", { source });
}
useEffect(() => {
  if (authMode !== "register" || showRegisterForm) return;
  const params = new URLSearchParams(window.location.search);
  const isFromLp = params.get("signup") === "true";
  const isFromInvite = !!(params.get("invite") || "").trim();
  if (!isFromLp && !isFromInvite) return; // ?signup=true・?invite=いずれも無い（素の訪問）ではここでは発火しない（Step1の登録ボタンクリック時にfireSignupStartOnceが発火する）
  fireSignupStartOnce(isFromLp ? "lp" : "invite");
}, [authMode, showRegisterForm]);

// ✅ 小売店名：次回も自動入力するか（チェックボックス用）
const [rememberShopName, setRememberShopName] = useState(true);



async function handleSignIn(e) {
  e?.preventDefault?.();
  if (!email || !password) {
    alert(isAU ? "Please enter your email address and password" : "メールアドレスとパスワードを入力してください");
    return;
  }

  try {
    setAuthBusy(true);
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message || (isAU ? "Failed to log in" : "ログインに失敗しました"));
  } finally {
    setAuthBusy(false);
  }
}

async function handleGoogleSignIn() {
  try {
    setAuthBusy(true);
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    // 2026-08（24回目Codexレビュー指摘、MUST-FIX対応）：このボタンはログイン画面・
    // 登録画面の両方から共有で呼ばれ、Firebase Authは未登録のGoogleアカウントで
    // あればその場で新規ユーザーを作成する（＝ログイン画面の"Continue with
    // Google"だけを押しても、新規登録が成立し得る）。これまでこの経路には
    // fireSignupStartOnceが一切接続されておらず、signup_startを計測しないまま
    // signup_complete_wholesaleまで到達できてしまう欠落があった。
    // getAdditionalUserInfo(result)?.isNewUserで実際に新規作成された場合のみ
    // 発火させることで、既存ユーザーの通常ログインを誤ってsignup_startとして
    // 計測することを避ける
    if (getAdditionalUserInfo(result)?.isNewUser) {
      fireSignupStartOnce("google_new_user");
    }
  } catch (err) {
    if (err.code !== "auth/popup-closed-by-user") {
      alert(err.message || (isAU ? "Failed to log in with Google" : "Googleログインに失敗しました"));
    }
  } finally {
    setAuthBusy(false);
  }
}

async function handleSignUp(e) {
  e?.preventDefault?.();
  if (!email || !password) {
    alert(isAU ? "Please enter your email address and password" : "メールアドレスとパスワードを入力してください");
    return;
  }

  try {
    setAuthBusy(true);
    await createUserWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message || (isAU ? "Failed to sign up" : "新規登録に失敗しました"));
  } finally {
    setAuthBusy(false);
  }
}


// ✅ sign out（return より上 / App の中に1個だけ）
const handleSignOut = async () => {
  try {
    await signOut(auth);
  } catch (e) {
    console.error(e);
    alert(e?.message || String(e));
  }
};


// ===== auth state =====
const [user, setUser] = useState(null);
const [tenantId, setTenantId] = useState(null);


  // ⚙️ 右上メニュー
  const [menuOpen, setMenuOpen] = useState(false);

  // 会社情報（ヒアリング結果）
  const [tenantProfile, setTenantProfile] = useState(null);
  // 2026-08 AU版基盤（Phase 3）：AU/JP判定はtenantProfile.marketId（Firestore実データ）に
  // 統一する。以前はビルド時環境変数MARKET（firebase.js）とtenantProfile.marketIdの
  // 2系統が混在しており、画面によって判定基準が食い違う恐れがあった（Phase 2の金額系
  // 関数は全てtenantProfile.marketIdを使用済みだったため、UIラベルもこちらへ統一する）。
  // tenantProfile未読込時（初回ロード中・新規登録直後）だけは、画面のちらつきを避ける
  // ためビルド時MARKETへフォールバックする（デプロイ環境が変われば読込完了後は
  // 必ずtenantProfile.marketIdが正になる）
  const isAU = tenantProfile ? tenantProfile.marketId === "AU" : MARKET === "au";
  const [tenantOpen, setTenantOpen] = useState(false);
  const [tenantSaveOk, setTenantSaveOk] = useState(false);
  // 納品設定モーダル
  const [deliverySettingsOpen, setDeliverySettingsOpen] = useState(false);
  const [dsLeadDays, setDsLeadDays] = useState(0);
  const [dsCutoffTime, setDsCutoffTime] = useState("");
  const [dsClosedWeekdays, setDsClosedWeekdays] = useState([]);
  const [dsHolidayDates, setDsHolidayDates] = useState([]);
  const [dsHolidayInput, setDsHolidayInput] = useState("");
  const [dsSaving, setDsSaving] = useState(false);
  const [dsSaved, setDsSaved] = useState(false);
  const [dsHolidayYear, setDsHolidayYear] = useState(new Date().getFullYear());
  const [dsHolidayAddMsg, setDsHolidayAddMsg] = useState("");
  // 小売モードで接続先卸のプロファイル（allowRetailProductEdit などを参照）
  const [wholesaleProfile, setWholesaleProfile] = useState(null);
  // 数量入力中の一時文字列（入力中に confirm が出ないようにするため）
  const [qtyDrafts, setQtyDrafts] = useState({});
  // 2026-08 パフォーマンス改善：受注一覧（未確認注文）の数量＋/－編集を、
  // 以前は押すたびにadjustOrderLines Callableを都度呼んでいたため、その
  // Firestore書き込みをonSnapshotリスナーが検知して注文一覧全体（直近30日・
  // 最大100件）を毎回作り直す重い構造になっていた。編集中はこのローカルstate
  // のみを更新し、Firestoreへの反映は受注確定操作時に一括で行う。
  // 形は { [orderId]: { [lineId]: qty } }。orderId単位で保持することで、
  // 複数の注文を切り替えて見ても編集内容が混ざらない
  const [editedQtyByOrder, setEditedQtyByOrder] = useState({});

  // 2026-08追加：受注確定処理中の注文IDを保持するstate（{ [orderId]: true }）。
  // 「受注確定」ボタン押下直後（Firestore/Functionsのレスポンスを待たず）に即座に
  // trueへ設定し、成功・失敗どちらでも必ずfinallyでfalseへ戻す。orderId単位で
  // 保持することで、他の注文の操作まで巻き込んでロックしない
  const [confirmingOrderIds, setConfirmingOrderIds] = useState({});

  // ✅ 卸：受注確定の確認モーダル
  const [whConfirmOpen, setWhConfirmOpen] = useState(false);

  // ✅ 卸：未処理だけ表示フィルタ
  const [onlyUnprocessed, setOnlyUnprocessed] = useState(false);
  const [showCancelled, setShowCancelled] = useState(false);

  // ===== products (Firestore) =====
  const [catalog, setCatalog] = useState([]);
  const [catalogLoading, setCatalogLoading] = useState(true);
  // 小売自身が登録した商品（qA、onSnapshot購読）。catalogはこれと卸カタログ部分の合成
  const [catalogOwn, setCatalogOwn] = useState([]);
  const [catalogOwnError, setCatalogOwnError] = useState(false);
  // 卸カタログのバーコード完全一致検索結果（ページネーション結果とは独立管理）
  const [wholesaleBarcodeResults, setWholesaleBarcodeResults] = useState([]);
  const [wholesaleBarcodeError, setWholesaleBarcodeError] = useState(false);
  // 「現在バーコード検索モードかどうか」を検索条件から明示的に持つ。
  // wholesaleBarcodeResults.length > 0 のような結果件数からの推測はしない
  // ——0件ヒットの場合に誤ってページネーション結果へフォールバックしてしまうため
  const [isWholesaleBarcodeMode, setIsWholesaleBarcodeMode] = useState(false);
  // ✅ 商品検索・カテゴリフィルタ
  const [catalogSearch, setCatalogSearch] = useState("");
  const [catalogCategory, setCatalogCategory] = useState("");
  // 卸 商品マスタ専用検索（クライアントサイドのみ・catalogSearchと共有しない）
  const [wholesaleMasterSearch, setWholesaleMasterSearch] = useState("");
  const [wholesaleMasterPage, setWholesaleMasterPage] = useState(1);
  // 卸カタログ用デバウンス検索（30,000件対応：Firestoreクエリ変更をキーストローク毎に発火しない）
  const [debouncedWholesaleSearch, setDebouncedWholesaleSearch] = useState("");

  // ===== 卸：商品マスタ画面のカーソルページネーション（2026-08 パフォーマンス改善） =====
  // 旧設計は tenantId 一致の商品を limit なし onSnapshot で毎回全件購読しており、
  // 本番12,163件で初期取得に約6.9秒かかっていた。新設計では「そもそも全件取得しない」
  // ことを目標に、通常ブラウジング・商品名検索・JANコード検索の3経路を完全に分離する：
  //   A) 通常一覧：カーソルページネーション（500件/ページ、現在ページのみリアルタイム購読）
  //   B) 商品名検索：Firestore側 name の前方一致（startAt/endAt）、上限付き
  //   C) JANコード検索：既存の where("barcode","==",sw) 完全一致（変更なし、そのまま維持）
  const WHOLESALE_MASTER_PAGE_SIZE = 500;
  const [wholesaleMasterProducts, setWholesaleMasterProducts] = useState([]);
  const [wholesaleMasterHasMore, setWholesaleMasterHasMore] = useState(false);
  const [wholesaleMasterLoading, setWholesaleMasterLoading] = useState(false);
  const [wholesaleMasterLoadingMore, setWholesaleMasterLoadingMore] = useState(false);
  const [wholesaleMasterError, setWholesaleMasterError] = useState(false);
  // 商品名前方一致検索（Firestore側）専用state。通常一覧(wholesaleMasterProducts)とは
  // 完全に独立させる——読み込み済み500件の中だけを検索する設計は絶対に避ける
  const [wholesaleMasterSearchResults, setWholesaleMasterSearchResults] = useState([]);
  const [wholesaleMasterSearchHasMore, setWholesaleMasterSearchHasMore] = useState(false);
  const [wholesaleMasterSearchLoading, setWholesaleMasterSearchLoading] = useState(false);
  const [wholesaleMasterSearchLoadingMore, setWholesaleMasterSearchLoadingMore] = useState(false);
  const [wholesaleMasterSearchError, setWholesaleMasterSearchError] = useState(false);
  // JANコード完全一致検索専用state
  const [wholesaleMasterBarcodeResults, setWholesaleMasterBarcodeResults] = useState([]);
  const [wholesaleMasterBarcodeLoading, setWholesaleMasterBarcodeLoading] = useState(false);
  const [wholesaleMasterBarcodeError, setWholesaleMasterBarcodeError] = useState(false);

  // ===== 小売：接続済み卸カタログのカーソルページネーション =====
  // 旧方式（name昇順2000件+name降順1000件の二重取得、末尾desc用インデックス欠如で
  // 本番では実質2000件しか取得できず、12,163件中10,163件が通常一覧から永久に
  // 到達不能だった）を廃止し、name+documentIdの複合カーソルによる正規のページネーション
  // に置き換える。これにより理論上何件でも「もっと見る」で全件へ到達可能になる。
  // 状態は「対象卸テナントID」単位で分離し、仕入先切替時に別卸テナントの
  // ページ状態・カーソル・キャッシュが混入しないようにする
  const WHOLESALE_CATALOG_PAGE_SIZE = 500;
  const [wholesaleCatalogProducts, setWholesaleCatalogProducts] = useState([]);
  const [wholesaleCatalogHasMore, setWholesaleCatalogHasMore] = useState(false);
  const [wholesaleCatalogLoading, setWholesaleCatalogLoading] = useState(false);
  const [wholesaleCatalogLoadingMore, setWholesaleCatalogLoadingMore] = useState(false);
  const [wholesaleCatalogError, setWholesaleCatalogError] = useState(false);

  // ===== orders (Firestore) =====
  const [orders, setOrders] = useState([]);
  // ✅ ordersページング用
  const [ordersLastDoc, setOrdersLastDoc] = useState(null);
  const [ordersHasMore, setOrdersHasMore] = useState(false);

  const [csvDefaultSupplierId, setCsvDefaultSupplierId] = useState("");


  // ✅ 売価（表示/計算）はここで統一：sellPrice → price → 0
    const getSellPrice = (p) => {
      const n = Number(p?.sellPrice ?? p?.price ?? 0);
      return Number.isFinite(n) ? n : 0;
    };
    
  // ===== suppliers (Firestore) =====
  const [suppliers, setSuppliers] = useState([]);
  const [shops, setShops] = useState([]); // 卸モード用取引先（小売店）

  const supplierNameMap = useMemo(() => {
    const m = {};
    (suppliers || []).forEach((s) => {
      const name = String(s.name || "");
      const docId = String(s._docId || "");
      const logicalId = String(s.id || s.supplierId || "");

      if (docId) m[docId] = name;
      if (logicalId) m[logicalId] = name;
    });
    // 自社tenantIdは会社名（tenantProfile）で解決
    if (tenantId && tenantProfile?.name) {
      m[tenantId] = tenantProfile.name;
    }
    return m;
  }, [suppliers, tenantId, tenantProfile]);

  const supplierNameById = (id) => supplierNameMap[String(id)] || "";

  // 2026-08 追加：卸視点でresolveCounterpartyKey(order,"fromWholesale")が返す
  // {kind:"tenant",id:retailTenantId} / {kind:"shop",id:shopId} から、
  // shops（自テナントのsuppliersコレクション、他テナント情報は含まない）を使って
  // 表示名を解決するマップ。オンライン発注（placeOrder）由来の注文はorders.shopName
  // フィールド自体を持たないため、o.shopNameへの単純フォールバックだけでは
  // 集計・ランキング画面で常に「不明」になっていた。printDeliveryPopupが納品書印刷時に
  // 行っている「shopsからretailTenantIdで店名を補完する」処理と同じ考え方を、
  // 集計側でも汎用的なキー（kind:id文字列）で引けるようにする
  const shopNameByCounterpartyKey = useMemo(() => {
    const m = {};
    (shops || []).forEach((s) => {
      const name = s.retailName || s.name || s.company || "";
      if (!name) return;
      if (s.retailTenantId) m[`tenant:${s.retailTenantId}`] = name;
      const shopDocId = s._docId || s.id;
      if (shopDocId) m[`shop:${shopDocId}`] = name;
    });
    return m;
  }, [shops]);
  // key: {kind, id} を受け取り、店名を解決する。見つからなければnullを返し、
  // 呼び出し側が「不明」等の表示にフォールバックできるようにする（推測補完はしない）
  const resolveShopDisplayName = (key) => {
    if (!key) return null;
    return shopNameByCounterpartyKey[`${key.kind}:${key.id}`] || null;
  };

  // ===== retail order sheet =====
  const [supplierId, setSupplierId] = useState("");
  const supplierSelected = !!supplierId;
  const [lines, setLines] = useState([]);

  // 発注画面：商品リストの表示/非表示
  const [showQuickList, setShowQuickList] = useState(false);

  // ===== order note (retail) =====
  const [orderNote, setOrderNote] = useState("");
  // 希望納品日（小売側発注時の任意入力）"YYYY-MM-DD" or ""
  const [requestedDeliveryDate, setRequestedDeliveryDate] = useState("");

  // ===== 取引先別売上フィルタ (wholesale) =====
  const [selectedShop, setSelectedShop] = useState("");
  const [shopStartDate, setShopStartDate] = useState("");
  const [shopEndDate, setShopEndDate] = useState("");
  const [draftShopStartDate, setDraftShopStartDate] = useState("");
  const [draftShopEndDate, setDraftShopEndDate] = useState("");
  const [shopRangeOrders, setShopRangeOrders] = useState(null);
  const [shopRangeLoading, setShopRangeLoading] = useState(false);
  // 期間取得が失敗した直後かどうか。trueの間は「未取得（30日分にフォールバック）」
  // ではなく明確にエラー状態として扱い、不完全な代替データを正常値のように
  // 表示しないようにする
  const [shopRangeError, setShopRangeError] = useState(false);
  // 連打・素早い期間変更で複数のfetchShopRangeOrders呼び出しが同時に走った場合に、
  // 先に発行したリクエストが後から解決して新しいリクエストの結果を上書きしないよう、
  // 「自分が最新のリクエストか」を判定するための単調増加ID
  const shopRangeRequestIdRef = useRef(0);
  const [wsSummaryTab, setWsSummaryTab] = useState("monthly");

  // ===== 手書き受注入力 =====
  const [manualShopId, setManualShopId] = useState("");       // 取引先（小売店）
  const [manualLines, setManualLines] = useState([]);          // 明細行
  // 2026-08 重複発注防止：「受注登録」ボタンの連打防止（submitOrderと同じ二重構造）
  const [isSavingManualOrder, setIsSavingManualOrder] = useState(false);
  const manualOrderLockRef = useRef(false);
  const manualOrderRequestIdRef = useRef(null);
  const [manualNote, setManualNote] = useState("");            // 備考
  const [manualSearch, setManualSearch] = useState("");        // 商品検索テキスト
  const [manualSearchOpen, setManualSearchOpen] = useState(false);
  const [manualCategory, setManualCategory] = useState("");     // カテゴリ絞り込み（クライアント側フィルタ）
  const [manualCategoryModalOpen, setManualCategoryModalOpen] = useState(false);
  const [wholesaleCategories, setWholesaleCategories] = useState([]);
  const [manualFsResults, setManualFsResults] = useState([]);   // 手書き入力検索結果（クライアント側フィルタ）
  const [manualFsLoading, setManualFsLoading] = useState(false); // ローカルキャッシュに対する検索処理中（通常は一瞬）
  // 商品マスタ準備状態（テナント全件のprefetch）。"idle"=未開始 "loading"=取得中 "ready"=検索可能 "error"=取得失敗
  const [manualProductsState, setManualProductsState] = useState("idle");

  // 手入力行の一時フォーム
  const [manualInputName, setManualInputName] = useState("");
  const [manualInputBarcode, setManualInputBarcode] = useState("");
  const [manualInputPrice, setManualInputPrice] = useState("");
  const [manualInputCost, setManualInputCost] = useState("");
  const [manualInputTax, setManualInputTax] = useState("0.1");
  const [manualInputQty, setManualInputQty] = useState("1");
  const [manualInputUnit, setManualInputUnit] = useState("");
  const [manualInputOpen, setManualInputOpen] = useState(false);
  const [setupStaffMode, setSetupStaffMode] = useState(false);
  const [setupStaffCode, setSetupStaffCode] = useState("");
  const [setupRole, setSetupRole] = useState(""); // "wholesale" | "retail" | ""
  const [setupName, setSetupName] = useState("");
  const [setupTel, setSetupTel] = useState("");
  const [setupInvoice, setSetupInvoice] = useState("");
  const [setupAddress, setSetupAddress] = useState("");
  const [setupLeadDays, setSetupLeadDays] = useState(1);
  const [setupCutoffTime, setSetupCutoffTime] = useState("15:00");
  const [setupClosedWeekdays, setSetupClosedWeekdays] = useState([0, 6]); // 土日
  const [showManualBanner, setShowManualBanner] = useState(false);
  // 2026-08 AU版基盤（Phase 2）：Sample Retailerモーダルの開閉状態
  const [showSampleRetailerModal, setShowSampleRetailerModal] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [supportMsg, setSupportMsg] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [supportSent, setSupportSent] = useState(false);
  const [supportSending, setSupportSending] = useState(false);

  // ===== 小売集計 期間プリセット（共通定数：state初期値に使うため先に定義）=====
  const _retailNow = new Date();
  const _retailThisMonthStart = `${_retailNow.getFullYear()}-${String(_retailNow.getMonth()+1).padStart(2,"0")}-01`;
  const _retailThisMonthEnd = `${_retailNow.getFullYear()}-${String(_retailNow.getMonth()+1).padStart(2,"0")}-${String(_retailNow.getDate()).padStart(2,"0")}`;

  // ===== 小売集計フィルタ =====
  const [retailSummaryTab, setRetailSummaryTab] = useState("monthly"); // monthly / supplier / product / detail
  const [retailSelectedSupplier, setRetailSelectedSupplier] = useState("");
  const [retailStartDate, setRetailStartDate] = useState(_retailThisMonthStart);
  const [retailEndDate, setRetailEndDate] = useState(_retailThisMonthEnd);
  const [draftRetailStartDate, setDraftRetailStartDate] = useState(_retailThisMonthStart);
  const [draftRetailEndDate, setDraftRetailEndDate] = useState(_retailThisMonthEnd);
  const [retailRangeOrders, setRetailRangeOrders] = useState(null);
  const [retailRangeLoading, setRetailRangeLoading] = useState(false);
  // 期間取得が失敗した直後かどうか。trueの間は「未取得（30日分にフォールバック）」
  // ではなく明確にエラー状態として扱い、不完全な代替データを正常値のように
  // 表示しないようにする
  const [retailRangeError, setRetailRangeError] = useState(false);
  // 連打・素早い期間変更で複数のfetchRetailRangeOrders呼び出しが同時に走った場合に、
  // 先に発行したリクエストが後から解決して新しいリクエストの結果を上書きしないよう、
  // 「自分が最新のリクエストか」を判定するための単調増加ID
  const retailRangeRequestIdRef = useRef(0);
  const [retailSummaryOrders, setRetailSummaryOrders] = useState(null); // 集計用3ヶ月分
  const [retailSummaryLoading, setRetailSummaryLoading] = useState(false);
  // 2クエリのどちらかが失敗した場合に、不完全な結果を正常値として表示しないための
  // エラーフラグ（fetchShopRangeOrders等と同じパターン）
  const [retailSummaryError, setRetailSummaryError] = useState(false);
  // retailSummaryOrdersを実際に取得した瞬間の「今月」の月初Date。月次カード・ラベルの
  // 計算はレンダー時に毎回new Date()し直すのではなく、必ずこの値を基準にする——
  // フェッチ開始からレンダーまでの間に日付が月をまたいだ場合、レンダー時に再計算した
  // 「今月」は実際にはフェッチ範囲に含まれていない月になってしまうため
  // （卸側のwsSummaryFetchedThisMonthと同じ理由・同じパターン）
  const [retailSummaryFetchedThisMonth, setRetailSummaryFetchedThisMonth] = useState(null);

  // ===== 小売集計 期間プリセット（supplier/productタブ用）=====
  const [retailRankPreset, setRetailRankPreset] = useState("当月");
  const [retailRankStart, setRetailRankStart] = useState(_retailThisMonthStart);
  const [retailRankEnd, setRetailRankEnd] = useState(_retailThisMonthEnd);
  const [retailRankRangeOrders, setRetailRankRangeOrders] = useState(null); // issuedAtベース・和集合クエリの取得結果
  // 2クエリのどちらかが失敗した場合に、不完全な結果を正常値として表示しないための
  // エラーフラグ
  const [retailRankRangeError, setRetailRankRangeError] = useState(false);

  // ===== 卸集計 期間プリセット（supplier/productタブ用）=====
  const [wsSummaryPreset, setWsSummaryPreset] = useState("");
  const [wsSummaryStart, setWsSummaryStart] = useState("");
  const [wsSummaryEnd, setWsSummaryEnd] = useState("");
  const [wsSummaryAllOrders, setWsSummaryAllOrders] = useState(null); // 集計用全期間データ（月次タブ専用）
  const [wsSummaryLoading, setWsSummaryLoading] = useState(false);
  // wsSummaryAllOrdersを実際に取得した瞬間の「今月」の月初Date。月次カード・ラベルの
  // 計算はレンダー時に毎回new Date()し直すのではなく、必ずこの値を基準にする——
  // フェッチ開始からレンダーまでの間に日付が月をまたいだ場合、レンダー時に再計算した
  // 「今月」は実際にはフェッチ範囲に含まれていない月になってしまうため
  const [wsSummaryFetchedThisMonth, setWsSummaryFetchedThisMonth] = useState(null);
  // 連打・素早い期間変更で複数のfetchWsSummaryOrders呼び出しが同時に走った場合に、
  // 先に発行したリクエストが後から解決して新しいリクエストの結果を上書きしないよう、
  // 「自分が最新のリクエストか」を判定するための単調増加ID
  const wsSummaryRequestIdRef = useRef(0);
  // 取引先別・商品別ランキングタブ専用のデータソース。月次タブのwsSummaryAllOrdersと
  // 共有すると、ランキングタブで期間を変更した際に月次タブの「今月・先月・先々月」
  // カードが、ランキング用に取得した狭い期間のデータだけで計算されてしまい、
  // 一部の月が実際には注文があるのに0円と表示される不整合が起きるため分離する
  const [wsRankAllOrders, setWsRankAllOrders] = useState(null);
  const [wsRankLoading, setWsRankLoading] = useState(false);
  const wsRankRequestIdRef = useRef(0);

  // ===== shop name (retail) : Firestore (tenants/{tenantId}.shopName) =====
const [shopName, setShopName] = useState("〇〇ショップ");

// shopName を "表示/保存用" に整形（空ならデフォルト）
const shopNameFixed = (String(shopName || "").trim() || "〇〇ショップ");

// ✅ 追加：リモート値・初回ロード管理（ループ防止）
const remoteShopNameRef = useRef("");     // ← nullよりこっち推奨
const shopNameLoadedRef = useRef(false);
// 手書き入力用商品全件キャッシュ。tenantIdをキーとしたMapで保持することで、
// テナント切替時に別テナントの商品が混入することを構造的に防ぐ（1テナント=1エントリ）。
const manualProductsCache = useRef(new Map());
// 現在進行中のフェッチをテナントIDごとに保持する（同一テナントへの同時フェッチ1本を保証）
const manualProductsFetchInFlight = useRef(new Map());
// テナント切替のたびにインクリメントする世代カウンター。A→B→Aのように素早く
// テナントを行き来した場合、古い世代で発行されたフェッチが後から解決しても、
// 現在の世代と一致しない限りキャッシュへの書き込み・in-flight登録の削除を行わない
// （進行中のFirestoreリクエスト自体はキャンセルできないため、結果を無視することで
// 「古い世代の結果が新しい世代の状態を汚染しない」ことを保証する）
const manualProductsGenerationRef = useRef(0);
// 手書き入力画面から「離れるたび」にインクリメントするセッショントークン。テナント切替
// (manualProductsGenerationRef)とは独立に、同一テナント内で画面を離れた場合に、
// 離脱前に発行された再試行等の非同期処理結果が、離脱後の状態を上書きしないように
// するためのガード
const manualProductsSessionTokenRef = useRef(0);

// オンライン発注：接続済み卸カタログのカーソルページネーション用ref。
// 「対象卸テナントID」が変わるたび（＝仕入先切替）に世代をインクリメントし、
// 古い世代で発行されたページ取得が後から解決してもstate（products/cursor/
// hasMore等）を上書きしないことを保証する。A→B→Aの高速切替でも安全。
const wholesaleCatalogGenerationRef = useRef(0);
// 現在の対象卸テナントID。世代インクリメント判定に使う
const wholesaleCatalogLastSeenWholesaleTenantIdRef = useRef(undefined);
// ページ取得中の二重リクエストを防ぐ（同一世代内で同時に複数のgetPageが走らない）。
// 世代ごとに「今その世代でin-flightなリクエストがあるか」を保持する（単純なbooleanだと
// テナント切替時にresetWholesaleCatalogIfTenantChangedが無条件でfalseに戻すため、
// 旧世代のfinallyが新世代のin-flightフラグを誤って解除してしまう競合があった）
const wholesaleCatalogInFlightGenerationRef = useRef(null);
// カーソル（最後に取得したドキュメントのFirestore DocumentSnapshot、startAfterに使う）
const wholesaleCatalogCursorRef = useRef(null);
// 取得済み商品のdocumentId集合（dedupe用）
const wholesaleCatalogSeenIdsRef = useRef(new Set());
// catalogOwn/wholesaleBarcodeResultsクリア判定用：直近でクリアした時点の
// 「supplierId::wholesaleTenantId」。実際に仕入先が変わった時だけクリアし、
// 検索語入力やsuppliers/tenantProfileの参照変化だけでは再クリアしない
const catalogOwnLastSupplierKeyRef = useRef(undefined);
const barcodeLastSupplierKeyRef = useRef(undefined);

// ===== 卸：商品マスタ画面のカーソルページネーション用ref（2026-08 パフォーマンス改善） =====
// テナント切替（卸/小売でmode自体は変わらないが、念のためtenantId変化を検知）のたびに
// 世代をインクリメントし、古い世代のページ取得が後から解決してもstateを上書きしない
// ことを保証する（オンライン発注側 wholesaleCatalogGenerationRef と同じ設計パターン）
const wholesaleMasterGenerationRef = useRef(0);
const wholesaleMasterLastSeenTenantIdRef = useRef(undefined);
const wholesaleMasterInFlightGenerationRef = useRef(null);
const wholesaleMasterCursorRef = useRef(null);
const wholesaleMasterSeenIdsRef = useRef(new Set());
// 「読み込み済みページ」を配列のまま保持する（ページ番号→そのページのdocument配列）。
// 現在購読中ページのonSnapshotが再発火した際、そのページの配列だけを丸ごと
// 置き換えることで、更新・削除・同一ページ内の並び替えを正しく反映できる
// （過去ページはこのonSnapshotの対象外なので変更されない。過去ページへの
// 更新・削除は、編集・削除後に呼ばれる forceReset:true の全体再取得で拾う）
const wholesaleMasterPagesRef = useRef([]); // Array<Array<product>>
const wholesaleMasterCurrentPageIndexRef = useRef(0);
// 商品名検索専用の世代・カーソル・dedupe（通常一覧とは完全に別系統で管理する）
const wholesaleMasterSearchGenerationRef = useRef(0);
const wholesaleMasterSearchInFlightGenerationRef = useRef(null);
const wholesaleMasterSearchCursorRef = useRef(null);
const wholesaleMasterSearchSeenIdsRef = useRef(new Set());
const wholesaleMasterSearchLastKeywordRef = useRef(undefined);
// 直近の失敗が「初回取得」と「もっと見る」のどちらで起きたかを記録する。
// 再試行ボタンは常に isFirstPage:true で呼ぶと、もっと見る失敗時に
// 既に表示済みの結果までクリアしてしまうため、失敗時の文脈を再試行に伝える
const wholesaleMasterSearchFailedOnLoadMoreRef = useRef(false);
const wholesaleMasterFailedOnLoadMoreRef = useRef(false);
// 編集・削除・CSV取込のようなFirestore書き込みを伴う非同期処理は、開始時点の
// mode/wholesaleView/tenantId/検索語をクロージャで捕捉する（deleteProduct等は
// 関数宣言であり、コンポーネントの最新renderを見ているわけではない）。
// 処理完了時（await後）に、開始時点のclosureの値ではなく「今この瞬間」の
// 画面・テナント・検索語を必ずこのrefから読むことで、処理中にユーザーが
// 別テナント・別検索語・別画面へ移動していた場合に、古い状態向けの
// 再取得（別テナントの一覧購読・別キーワードの検索結果上書き等）が
// 実行されてしまう競合を防ぐ
const wholesaleMasterLiveContextRef = useRef({
  mode: undefined,
  wholesaleView: undefined,
  tenantId: undefined,
  isWholesaleMasterNameSearchMode: false,
  wholesaleMasterSearchTrimmed: "",
});
// liveContextの値だけでなく、実際に呼び出す関数自体も最新版を指す必要がある。
// loadWholesaleMasterPage/loadWholesaleMasterSearchPage は useCallback で
// tenantId を依存配列に持つため、テナントが変わるたびに新しい関数として
// 再生成される。mutation完了時に「呼び出し開始時点でclosureに捕捉された
// 古いテナント向けの関数」をそのまま呼ぶと、liveContextで判定だけ最新化しても
// 実際のFirestoreクエリは古いテナントに対して発行されてしまう。そのため
// 関数そのものも常に最新版をrefで保持し、mutation完了後は必ずこのrefを
// 経由して呼び出す
const wholesaleMasterLiveLoadersRef = useRef({
  loadWholesaleMasterPage: null,
  loadWholesaleMasterSearchPage: null,
});


// ✅ どこでも「必ず原価」を返す（priceは見ない＝売価混入を物理的に遮断）
const getCostPriceStrict = (x, fallback = 0) => {
  const v = x?.costPrice ?? x?.cost ?? x?.purchasePrice ?? fallback;
  const s = String(v ?? "").replace(/[¥,\s"]/g, "").trim();
  if (s === "") return fallback;
  const n = Number(s);
  return Number.isFinite(n) ? n : fallback;
};




// 読み込み（リアルタイム同期）
useEffect(() => {
  if (!tenantId) return;

  // tenant切替時に初期化
  shopNameLoadedRef.current = false;
  remoteShopNameRef.current = "";

  const ref = doc(db, "tenants", tenantId);
  const unsub = onSnapshot(ref, (snap) => {
    shopNameLoadedRef.current = true;

    const v = String((snap.exists() ? snap.data()?.shopName : "") || "").trim();
    if (!v) return;

    remoteShopNameRef.current = v;

    // ✅ チェックONのときだけ、リモート値で入力欄を更新（OFFなら上書きしない）
    if (rememberShopName) {
      setShopName((prev) => (String(prev || "").trim() === v ? prev : v));
    }
  });

  return () => unsub();
}, [tenantId, rememberShopName]);

// ✅ Firestoreにshop名未保存の場合、tenantProfile.retailNameで補完
useEffect(() => {
  if (!shopNameLoadedRef.current) return;
  if (remoteShopNameRef.current) return; // 既にFirestoreに保存済みなら不要
  const fallback = (tenantProfile?.retailName || tenantProfile?.name || "").trim();
  if (fallback) setShopName(fallback);
}, [tenantProfile?.retailName, tenantProfile?.name]);

// 保存（checkboxがONのときだけ保存）
useEffect(() => {
  if (!tenantId) return;

  // ✅ OFFなら一切保存しない
  if (!rememberShopName) return;

  // ✅ 初回ロード前は勝手に保存しない
  if (!shopNameLoadedRef.current) return;

  // ✅ リモートと同じなら保存しない（ループ防止）
  if (remoteShopNameRef.current === shopNameFixed) return;

  const t = setTimeout(async () => {
    try {
      const ref = doc(db, "tenants", tenantId);
      await setDoc(
        ref,
        { shopName: shopNameFixed, updatedAt: serverTimestamp() },
        { merge: true }
      );
      remoteShopNameRef.current = shopNameFixed;
    } catch (e) {
      console.error(e);
    }
  }, 400);

  return () => clearTimeout(t);
}, [tenantId, rememberShopName, shopNameFixed]);



  // ===== scan =====
  const [scannerOpen, setScannerOpen] = useState(false);
  const [lastScan, setLastScan] = useState("");


  
  // ===== toast =====
  const [toast, setToast] = useState("");
  function showToast(msg) {
    setToast(msg);
    setTimeout(() => setToast(""), 1800);
  }

  // ===== confirm (retail submit) =====
  const [confirmOpen, setConfirmOpen] = useState(false);
  // 2026-08 重複発注防止：setState単体は非同期のため、高速連打時に複数のhandler呼び出しが
  // 同じrender時点のfalseを見てしまう可能性がある。isSubmittingOrder（UI表示用）とは別に、
  // submitOrderLockRef（useRefによる同期ロック）を二重構造で持つ。ロックの成否判定は
  // 必ずrefを見て行い、stateはボタンの見た目（disabled/処理中表示）だけに使う
  const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
  const submitOrderLockRef = useRef(false);
  // 1回の発注操作（確認モーダルを開いてから送信完了するまで）を通じて同じrequestIdを
  // 使う。連打は同じrequestIdでサーバーに届くため、サーバー側idempotencyで1件に集約される。
  // 新しい発注操作（次にconfirmOpenをtrueにする時）だけ新しいrequestIdを発行する
  const submitOrderRequestIdRef = useRef(null);
// ===== register/edit modal (product) =====
const [regOpen, setRegOpen] = useState(false);
const [regMode, setRegMode] = useState("scanAdd"); // scanAdd / add / edit
const [regEditingId, setRegEditingId] = useState(null);

const [regBarcode, setRegBarcode] = useState("");
const [regName, setRegName] = useState("");
const [regUnit, setRegUnit] = useState("個");
const [regInnerCount, setRegInnerCount] = useState("1");

// ✅ 商品登録モーダル：仕入れ先ID（このモーダル内で使う）
const [regSupplierId, setRegSupplierId] = useState("");

// ✅ 卸は自社ID（tenantId等）/ 小売は選択中の仕入れ先
// ※ tenantId が無いプロジェクトなら supplierSelected を使ってOK
const effectiveSupplierId =
  mode === "wholesale"
    ? String(tenantId || "")
    : String(supplierId || "");



// ✅ 発注単価・小売販売価格・仕入原価（入力欄は文字列で持つ）
const [regCostPrice, setRegCostPrice] = useState("0");
const [regPurchaseCost, setRegPurchaseCost] = useState("0");
const [regSellPrice, setRegSellPrice] = useState("0");
const [regCategory, setRegCategory] = useState("");
const [regSuggestedPrice, setRegSuggestedPrice] = useState("0");
const [manualAddOpen, setManualAddOpen] = useState(false);
const [manualAddName, setManualAddName] = useState("");
const [manualAddUnit, setManualAddUnit] = useState(isAU ? "" : "個");
const [manualAddQty, setManualAddQty] = useState("1");
const [manualAddTaxRate, setManualAddTaxRate] = useState("0.1");
function openAddProduct() {
  if (retailOrderOnly) return; // 発注専用モードでは商品登録不可
  // ✅ 小売だけ「仕入れ先が未選択なら止める」
  if (mode === "retail" && !supplierId) {
    showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
    return;
  }

  setRegMode("add");
  setRegEditingId(null);

  // ✅ 卸：自社（tenantId）固定 / 小売：選択中の仕入れ先
  const sid = mode === "wholesale" ? String(tenantId || "") : String(supplierId || "");
  setRegSupplierId(sid);

  setRegBarcode("");
  setRegName("");
  setRegUnit(isAU ? "" : "個");
  setRegInnerCount("1");
  setRegCostPrice("0");
  setRegSellPrice("0");
  setRegTaxRate(0.1);
  setRegOpen(true);
}



const openManualCategoryModal = () => {
  setManualCategoryModalOpen(true);
  // カテゴリはprefetch完了後に自動セットされる。キャッシュ済みなら即表示。
  const cachedProducts = tenantId ? manualProductsCache.current.get(tenantId) : null;
  if (wholesaleCategories.length === 0 && cachedProducts) {
    const cats = [...new Set(cachedProducts.map(p => p.category).filter(c => c && String(c).trim()))].sort((a, b) => a.localeCompare(b, "ja"));
    setWholesaleCategories(cats);
  }
};

// ===== 卸 商品マスタ画面：表示対象の切り替え（2026-08 パフォーマンス改善） =====
// もはや catalog（旧・全件取得state）は参照しない。debouncedWholesaleSearchの内容で
// 「JANコード検索モード」「商品名検索モード」「通常一覧モード」の3系統から表示対象を
// 選択する。各系統は専用のFirestoreクエリ結果（wholesaleMasterBarcodeResults /
// wholesaleMasterSearchResults / wholesaleMasterProducts）をそのまま使い、
// クライアント側での「読み込み済み分だけを再フィルタ」は行わない
// （読み込み済み500件の外にある商品を検索で発見できることを保証するため）。
// 表示モードの判定は raw な wholesaleMasterSearch ではなく、Firestoreクエリを
// 実際に発火させている debouncedWholesaleSearch を基準にする——rawで判定すると
// デバウンス待ち中（約400ms）に「入力済みだがまだクエリされていないキーワード」
// のモードでラベル付けした古い結果を表示してしまい、もっと見る・再試行が
// 古いキーワードのcursor/dedupe状態のまま新しいキーワードのクエリを叩く
// （テナントを跨がなくても検索語を跨いで結果が混入する）不具合になる
const wholesaleMasterSearchTrimmed = String(debouncedWholesaleSearch || "").trim();
const isWholesaleMasterBarcodeMode = /^\d{8,14}$/.test(wholesaleMasterSearchTrimmed);
const isWholesaleMasterNameSearchMode = !!wholesaleMasterSearchTrimmed && !isWholesaleMasterBarcodeMode;

// mutation完了時（await後）に古いclosureの値ではなく「今この瞬間」の画面状態を
// 参照できるよう、コミット済みの値をrefへ同期する。レンダー中の直接代入では
// React18の並行レンダリングで「破棄されたレンダー」の値がrefに残ってしまう
// 可能性があるため、useLayoutEffectでコミット確定後にのみ同期する
useLayoutEffect(() => {
  wholesaleMasterLiveContextRef.current = {
    mode,
    wholesaleView,
    tenantId,
    isWholesaleMasterNameSearchMode,
    wholesaleMasterSearchTrimmed,
  };
});

const wholesaleProducts = wholesaleMasterProducts;
const wholesaleProductsFiltered = isWholesaleMasterBarcodeMode
  ? wholesaleMasterBarcodeResults
  : isWholesaleMasterNameSearchMode
    ? wholesaleMasterSearchResults
    : wholesaleMasterProducts;

const PRODUCTS_PER_PAGE = 300;
// 検索中（商品名・JANコードいずれも）はFirestore側のページング（もっと見る）に委ね、
// クライアント側の300件区切りページングは通常一覧のみで行う
const wholesaleTotalPages = (isWholesaleMasterBarcodeMode || isWholesaleMasterNameSearchMode)
  ? 1
  : Math.max(1, Math.ceil(wholesaleProductsFiltered.length / PRODUCTS_PER_PAGE));
const wholesaleProductsPaged = (isWholesaleMasterBarcodeMode || isWholesaleMasterNameSearchMode)
  ? wholesaleProductsFiltered
  : wholesaleProductsFiltered.slice(
      (wholesaleMasterPage - 1) * PRODUCTS_PER_PAGE,
      wholesaleMasterPage * PRODUCTS_PER_PAGE
    );

// 小売モードで商品登録・編集・削除を禁止するフラグ
// 卸接続あり → 卸のプロファイルで判定
// 卸未接続（同一テナントで卸/小売切り替え）→ 自身のプロファイルで判定
// どちらも未設定 → デフォルトでロック（安全側）
const _effectiveWholesaleTid =
  String(tenantProfile?.wholesaleTenantId || "").trim() ||
  ((suppliers || []).map(s => String(s.wholesaleTenantId || "").trim()).find(id => !!id) || "");
const _effectiveAllowRetailEdit = _effectiveWholesaleTid
  ? wholesaleProfile?.allowRetailProductEdit
  : tenantProfile?.allowRetailProductEdit;
const retailOrderOnly =
  mode === "retail" &&
  _effectiveAllowRetailEdit !== true;

  // ✅ 共通：商品マスタ画面（卸/小売 共通）
function renderProductsMaster() {
  // supplierId で絞りたいならここで
  const list = supplierId ? products.filter((p) => p.supplierId === supplierId) : products;

  // ✅ 小売のときだけ「仕入れ先選択必須」
  const needSupplier = mode === "retail";
  const canImport = !needSupplier || !!supplierId;
return (
  <div style={{ display: "grid", gap: 12 }}>




    {/* ✅ ヘッダー（ここにボタンをまとめる） */}
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <button
        onClick={openAddProduct}
        style={{
          padding: "10px 12px",
          borderRadius: 12,
          border: "1px solid #111",
          background: "white",
          fontWeight: 900,
        }}
      >
        ＋ 商品追加
      </button>

      <button
        onClick={() => importFileRef.current?.click()}
        disabled={mode === "retail" && !supplierId}
        style={{
          padding: "10px 16px",
          borderRadius: 12,
          border: "none",
          background: mode === "retail" && !supplierId ? "#ccc" : "linear-gradient(135deg,#16a34a,#15803d)",
          color: "white",
          fontWeight: 900,
          fontSize: 14,
          cursor: mode === "retail" && !supplierId ? "not-allowed" : "pointer",
          opacity: mode === "retail" && !supplierId ? 0.6 : 1,
          boxShadow: mode === "retail" && !supplierId ? "none" : "0 2px 8px rgba(22,163,74,0.35)",
          display: "flex", alignItems: "center", gap: 6,
        }}
        title={mode === "retail" && !supplierId ? "先に仕入れ先を選択してください" : ""}
      >
        📥 Excel取り込み
      </button>

      <a
        href="/商品マスタ登録フォーマット.xlsx"
        download="商品マスタ登録フォーマット.xlsx"
        style={{
          padding: "10px 16px",
          borderRadius: 12,
          border: "1px solid #16a34a",
          background: "white",
          color: "#16a34a",
          fontWeight: 900,
          fontSize: 14,
          cursor: "pointer",
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: 6,
          whiteSpace: "nowrap",
        }}
      >
        📋 フォーマットDL
      </a>

      <div style={{ marginLeft: "auto", fontSize: 12, opacity: 0.75 }}>
        {supplierId ? `仕入れ先で絞り込み中` : `全件表示`}
      </div>
    </div>


      <div style={{ overflowX: "auto", border: "1px solid #eee", borderRadius: 12, background: "white" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {(mode === "wholesale"
                ? ["JAN", "商品名", "単位", "発注単価（税抜）", "税率", ""]
                : ["JAN", "商品名", "単位", "発注単価", "小売販売価格", "税率", ""]
              ).map((h) => (
                <th key={h} style={{ textAlign: "left", padding: 10, borderBottom: "1px solid #eee", fontSize: 12 }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {list.map((p) => (
              <tr key={p.id}>
                <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{p.barcode || ""}</td>
                <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12, fontWeight: 900 }}>{p.name}</td>
                <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{p.unit}</td>
                <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>
                  {Number(p.costPrice ?? 0) > 0
                    ? yen(p.costPrice)
                    : <span style={{ color: "#dc2626", fontSize: 11 }}>未登録</span>}
                </td>
                {mode !== "wholesale" && (
                  <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{yen(p.sellPrice ?? p.price ?? 0)}</td>
                )}
                <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>
                  <TaxRateBadge rawTaxRate={p.taxRate} />
                </td>
                <td style={{ padding: 10, borderBottom: "1px solid #f4f4f4", fontSize: 12, whiteSpace: "nowrap" }}>
                  <button
                    onClick={() => openEditProduct(p)}
                    style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", background: "white", fontWeight: 900 }}
                  >
                    編集
                  </button>
                  <span style={{ display: "inline-block", width: 8 }} />
                  <button
                    onClick={() => deleteProduct(p.id)}
                    style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", background: "white", fontWeight: 900 }}
                  >
                    削除
                  </button>
                </td>
              </tr>
            ))}

            {list.length === 0 && (
              <tr>
                <td colSpan={7} style={{ padding: 14, fontSize: 12, opacity: 0.7 }}>
                  商品がありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}







// ===== products csv import modal =====
const [csvOpen, setCsvOpen] = useState(false);
const [csvText, setCsvText] = useState("");
const [csvRows, setCsvRows] = useState([]);       // parse結果（正規化済み）
const [csvErrors, setCsvErrors] = useState([]);   // エラー文字列配列（後方互換のため維持。実際のblocking判定はcsvBlockingErrorsを見る）
const [csvBlockingErrors, setCsvBlockingErrors] = useState([]); // 2026-08 税率修正：確定ボタンの有効/無効とconfirmImportProductsのガードが必ず同じ集合を参照するよう統一した単一の状態
const [csvPreview, setCsvPreview] = useState([]); // 先頭プレビュー
const [csvImporting, setCsvImporting] = useState(false);

// ═══════════════════════════════════════════════════════════════════════
// Excel/CSV商品マスタ取込：共通ヘッダーエイリアス表（2026-08 税率誤登録問題の修正）
// ═══════════════════════════════════════════════════════════════════════
// Excel経路・CSV経路の両方が、この単一のテーブルでヘッダー名→canonicalフィールド名
// を解決する（設計書の「ヘッダーエイリアス表」に対応。以前はExcel経路とCSV経路で
// 別々のヘッダー解決ロジックを持ち、CSV経路は日本語ヘッダーに非対応だった）
// 2026-08 AU版基盤（Phase 3）：AU向け英語列見出し（downloadProductsAsExcelが
// AU向けに出力する列名と対応）をエイリアスへ追加した。日本語列見出しの
// インポート挙動には一切影響しない（追加のみ、既存エイリアスは変更なし）
const PRODUCT_IMPORT_HEADER_ALIASES = {
  barcode: ["JANコード", "ＪＡＮコード", "JAN", "barcode", "jan", "Barcode"],
  name: ["商品名", "レシート名漢", "レシート名仮", "name", "Product name"],
  unit: ["単位", "unit", "Unit"],
  sellPrice: ["小売販売価格(税込)", "売価(税込)", "売単価税込", "sellPrice", "Sell price (inc GST)"],
  costPrice: ["発注単価(税抜)", "原価(税抜)", "原単価税抜", "costPrice", "Cost price (ex GST)"],
  purchaseCost: ["仕入原価(税抜)", "purchaseCost", "Purchase cost (ex GST)"],
  taxKbn: ["税区分", "taxKbn"],
  taxRate: ["税率", "taxRate", "GST rate"],
  category: ["カテゴリ", "部門", "カテゴリ／部門", "category", "Category"],
  suggestedPrice: ["推奨売価", "suggestedPrice"],
  innerCount: ["入り数", "innerCount"],
};

// ヘッダー行（実際にファイルに存在した列名の配列）を受け取り、各canonicalフィールドが
// どの実列名に解決されたかを返す。必須ヘッダー欠落・重複エイリアス・重複ヘッダー名を
// すべて検出し、いずれかがあればエラー一覧を返す（ファイル全体を拒否する）
function resolveProductImportHeaders(headerRow, isAU = false) {
  const errors = [];
  const trimmedHeaders = (headerRow || []).map((h) => String(h ?? "").trim());

  // 重複ヘッダー名そのもの（同じ列名が2回出現）の検出
  const headerCounts = {};
  trimmedHeaders.forEach((h) => { if (h) headerCounts[h] = (headerCounts[h] || 0) + 1; });
  const duplicateHeaderNames = Object.keys(headerCounts).filter((h) => headerCounts[h] > 1);
  if (duplicateHeaderNames.length > 0) {
    errors.push(isAU
      ? `Duplicate headers found: ${duplicateHeaderNames.join(", ")}`
      : `ヘッダーが重複しています: ${duplicateHeaderNames.join(", ")}`);
  }

  const resolved = {}; // canonicalField -> 実際のヘッダー名
  const ambiguousFields = new Set(); // 重複エイリアスが原因で未解決になったフィールド
  Object.entries(PRODUCT_IMPORT_HEADER_ALIASES).forEach(([canonicalField, aliases]) => {
    const matches = aliases.filter((alias) => trimmedHeaders.includes(alias));
    if (matches.length > 1) {
      errors.push(isAU
        ? `Multiple columns match "${canonicalField}" (${matches.join(", ")}). Please keep only one.`
        : `「${canonicalField}」に対応する列が複数あります（${matches.join(", ")}）。どちらか一方にしてください`);
      ambiguousFields.add(canonicalField);
    } else if (matches.length === 1) {
      resolved[canonicalField] = matches[0];
    }
  });

  // 必須ヘッダー検出：barcode/name/taxRateのいずれかが1つも見つからない場合はエラー。
  // 重複エイリアスが原因で未解決の場合は、上の重複エラーで既に説明済みなので
  // 「見つかりません」という誤解を招くメッセージを重ねて出さない
  ["barcode", "name", "taxRate"].forEach((required) => {
    if (!resolved[required] && !ambiguousFields.has(required)) {
      errors.push(isAU
        ? `Required column not found: "${required}" (expected header: ${PRODUCT_IMPORT_HEADER_ALIASES[required].join(" / ")})`
        : `必須列が見つかりません: 「${required}」に対応するヘッダー（${PRODUCT_IMPORT_HEADER_ALIASES[required].join(" / ")}）`);
    }
  });

  return { resolved, errors };
}

// Excel税区分（taxKbn）列の決定的エイリアステーブル。部分文字列マッチング
// （includes("8")等）は誤判定の元になるため使わない。ここに完全一致しない
// 表記（例：「軽減」単体）は「判定不能」として扱い、8%/10%を推測しない。
// 2026-08 AU版基盤（Phase 3）：GST/GST-free用語のエイリアスを追加
const TAX_KBN_ALIASES = {
  "課税10%": 0.10, "標準税率10%": 0.10, "標準": 0.10, "10%課税": 0.10, "課税": 0.10,
  "課税8%": 0.08, "軽減税率8%": 0.08, "軽減税率": 0.08, "軽減8%": 0.08,
  "非課税": 0, "非課税0%": 0,
  "gst": 0.10, "gst 10%": 0.10, "gst10%": 0.10, "taxable": 0.10,
  "gst-free": 0, "gst free": 0, "gstfree": 0,
};

// 税区分文字列をtrimしてTAX_KBN_ALIASESに完全一致させる（部分文字列マッチングはしない）。
// 2026-08 AU版基盤（Phase 3）：policy引数を追加。解決した値がpolicy.allowedRatesに
// 含まれない場合（例：AU_TAX_POLICYで"課税8%"がマッチした場合）は「判定不能」扱いに
// フォールバックし、8%区分が存在しないAU版で誤って0.08を採用しないようにする
function resolveTaxKbn(taxKbnRaw, policy = JAPAN_TAX_POLICY) {
  const normalized = String(taxKbnRaw ?? "").trim();
  const normalizedLower = normalized.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(TAX_KBN_ALIASES, normalized)) {
    const value = TAX_KBN_ALIASES[normalized];
    if (!policy.allowedRates.includes(value)) return { resolved: false, value: null };
    return { resolved: true, value };
  }
  if (Object.prototype.hasOwnProperty.call(TAX_KBN_ALIASES, normalizedLower)) {
    const value = TAX_KBN_ALIASES[normalizedLower];
    if (!policy.allowedRates.includes(value)) return { resolved: false, value: null };
    return { resolved: true, value };
  }
  return { resolved: false, value: null };
}

// Excel/CSV共通：1行分の税率を、税率列(taxRaw)・税区分列(taxKbnRaw)の両方から
// 決定する。両方が有効かつ矛盾していれば行エラー、税率列のみ有効ならそちらを
// 採用、税区分列のみ有効ならそちらを採用、両方無効なら行エラーとする。
// 2026-08 AU版基盤（Phase 3）：policy引数を追加。省略時は既存どおりJAPAN_TAX_POLICY
// （0/0.08/0.10）。AU_TAX_POLICY（0/0.10のみ）を渡すと、AU版インポートで8%を
// 不正税率として拒否する（AU側に8%区分は存在しないため）
function resolveRowTaxRate(taxRaw, taxKbnRaw, policy = JAPAN_TAX_POLICY, isAU = false) {
  const taxRawTrimmed = String(taxRaw ?? "").trim();
  const taxKbnTrimmed = String(taxKbnRaw ?? "").trim();

  const rateResult = taxRawTrimmed ? normalizeTaxRate(taxRawTrimmed, policy) : { ok: false, error: { code: "TAX_RATE_REQUIRED" } };
  const kbnResult = taxKbnTrimmed ? resolveTaxKbn(taxKbnTrimmed, policy) : { resolved: false, value: null };

  if (rateResult.ok && kbnResult.resolved) {
    if (rateResult.value !== kbnResult.value) {
      return { ok: false, error: { code: "TAX_RATE_CLASSIFICATION_MISMATCH", message: isAU
        ? `The tax rate column (${taxRawTrimmed}) and tax category column (${taxKbnTrimmed}) don't match`
        : `税率列（${taxRawTrimmed}）と税区分列（${taxKbnTrimmed}）が矛盾しています` } };
    }
    return { ok: true, value: rateResult.value };
  }
  if (rateResult.ok) return { ok: true, value: rateResult.value };
  if (kbnResult.resolved) return { ok: true, value: kbnResult.value };

  // 両方無効。taxRawが非空で不正だった場合はその具体的なエラーを返す（曖昧な
  // 税区分だけの理由で隠れてしまわないように）
  if (taxRawTrimmed && !rateResult.ok) return rateResult;
  return { ok: false, error: { code: "TAX_RATE_REQUIRED", message: isAU ? "Tax rate is missing or invalid" : "税率が未入力または不正です" } };
}
const [csvImportProgress, setCsvImportProgress] = useState({ current: 0, total: 0, done: false, skipped: 0 });


// ✅ Excel/CSVファイル選択用（隠しinput）
const importFileRef = useRef(null);
const [csvTarget, setCsvTarget] = useState("wholesale"); // "wholesale" | "retail"

// ================================
// ✅ 商品編集モーダルを開く（置き換え版）
// ================================
function openEditProduct(p) {
  if (!p) return;
  if (retailOrderOnly) return; // 発注専用モードでは商品編集不可

  setRegMode("edit");
  setRegEditingId(p.id);

  // ✅ supplierId をモーダルに反映（既存優先、無ければルールで補完）
  const sid = String(
    p.supplierId ||
      (mode === "wholesale" ? (tenantId || "") : (supplierId || "")) ||
      ""
  );
  setRegSupplierId(sid);

  setRegBarcode(String(p.barcode ?? ""));
  setRegName(String(p.name ?? ""));
  setRegUnit(String(p.unit ?? (isAU ? "" : "個")));
  setRegInnerCount(String(p.innerCount ?? "1"));

  // ✅ 入力欄は「文字列」で持つ（カンマ除去）
  const stripComma = (v) => String(v ?? "").replace(/,/g, "").trim();

  setRegCostPrice(stripComma(p.costPrice ?? 0));
  setRegPurchaseCost(stripComma(p.purchaseCost ?? 0));
  setRegCategory(String(p.category ?? ""));
  setRegSuggestedPrice(stripComma(p.suggestedPrice ?? 0));

  // ✅ 税率：既存データが不正（policyのallowedRatesに含まれない）な場合、推測補完せず
  // 編集を止める。ここで黙って標準税率へフォールバックすると、ユーザーが気づかないまま
  // 誤った税率を「正しい値として」再保存してしまう。
  // 2026-08 AU版基盤（Phase 3、Codexレビュー指摘対応・MUST-FIX）：以前はpolicy未指定
  // （常にJAPAN_TAX_POLICY）で呼んでいたため、AU商品に0.08が紛れ込んでいても
  // 「有効」と誤判定してしまっていた。tenantProfile.marketIdに応じたpolicyを渡す
  const editProductPolicy = resolveTaxPolicy(tenantProfile?.marketId);
  const taxResult = normalizeTaxRate(p.taxRate, editProductPolicy);
  if (!taxResult.ok) {
    alert(isAU
      ? `This product's tax rate data is invalid (stored value: ${JSON.stringify(p.taxRate)}).\nPlease check the tax rate before editing.\n${taxResult.error.message}`
      : `この商品の税率データが不正です（保存値: ${JSON.stringify(p.taxRate)}）。\n編集前に税率を確認してください。\n${taxResult.error.message}`);
    return;
  }
  const trRawForSell = taxResult.value;
  setRegTaxRate(trRawForSell);

  // ✅ 売価：編集時は税込で表示（sellPriceInc があればそのまま、なければ税抜→税込変換）
  // 2026-08（Codexレビュー2回目MUST-FIX対応）：以前はMath.round固定だったため、
  // sellPriceIncを持たずsellPriceのみ持つ旧AU商品を編集すると税込価格が
  // 整数ドルへ丸められ、そのまま再保存されてしまっていた
  const sp = getSellPrice(p);
  const editProductRoundFn = isAU ? roundAUD : roundJPY;
  const spIncForEdit = p.sellPriceInc > 0
    ? p.sellPriceInc
    : sp > 0 ? editProductRoundFn(sp * (1 + trRawForSell)) : 0;
  setRegSellPrice(stripComma(spIncForEdit));

  setRegOpen(true);
}



// 2026-08 税率修正：以前はcsvErrorsから独自にフィルタしていたため、確認ボタンの
// disabled判定（csvFatalErrors）とconfirmImportProductsのガード（csvErrors）が
// 異なる集合を参照する不整合があった。now csvBlockingErrorsを単一の権威的な
// blocking集合として両方から参照する
const csvFatalErrors = csvBlockingErrors || [];

const csvMessages = (csvErrors || []).filter((m) => {
  const s = String(m || "");
  return s.startsWith("取込結果:") || s.includes("スキップしました");
});

// ================================
// ✅ 商品削除
// ================================
async function deleteProduct(productId) {
  if (!productId) return;
  if (!window.confirm(isAU ? "This will be deleted. Are you sure?" : "削除します。よろしいですか？")) return;

  try {
    await deleteDoc(doc(db, "products", productId));
    // 卸 商品マスタ画面：削除済み商品が残留したり、次ページのカーソルが
    // 壊れたりしないよう、現在のページ状態を破棄して1ページ目から安全に再取得する。
    // await完了時点でユーザーが別テナント・別検索語・別画面へ移動している
    // 可能性があるため、この関数呼び出し開始時点のclosureの値（mode/
    // wholesaleView/isWholesaleMasterNameSearchMode/wholesaleMasterSearchTrimmed）
    // ではなく、常に最新renderの値を反映するwholesaleMasterLiveContextRefを見る
    const liveCtx = wholesaleMasterLiveContextRef.current;
    if (liveCtx.mode === "wholesale" && liveCtx.wholesaleView === "products") {
      // 呼び出す関数自体もliveLoadersRef経由で最新版（=最新tenantId向けのclosure）
      // を使う。closureで捕捉したloadWholesaleMasterPageをそのまま呼ぶと、
      // mutation実行中にテナントが切り替わっていた場合、liveCtxの判定は
      // 新テナント向けでも、実際のFirestoreクエリは古いテナント向けに
      // 発行されてしまう
      const liveLoaders = wholesaleMasterLiveLoadersRef.current;
      liveLoaders.loadWholesaleMasterPage?.({ isFirstPage: true, forceReset: true });
      // 商品名検索結果はonSnapshotではなくgetDocsによる一回限りの取得のため、
      // 削除がリアルタイムで反映されない。検索表示中であれば同じキーワードで
      // 明示的に再取得し、削除済み商品が検索結果に残り続けないようにする
      if (liveCtx.isWholesaleMasterNameSearchMode && liveCtx.wholesaleMasterSearchTrimmed) {
        liveLoaders.loadWholesaleMasterSearchPage?.(liveCtx.wholesaleMasterSearchTrimmed, { isFirstPage: true });
      }
    }
  } catch (e) {
    console.error(e);
    alert(isAU ? "Failed to delete" : "削除に失敗しました");
  }
}

// ✅ 取込確定（Firestoreへ）卸/小売 両対応
const confirmImportProducts = async () => {
  const isRetail = mode === "retail";
  const isWholesale = mode === "wholesale";

  // ✅ 必須チェック（ここで止める）
  if (isRetail && !supplierId) {
    showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
    return;
  }
  if (isWholesale && !tenantId) {
    showToast(isAU ? "Your company (tenant) is not set" : "会社ID（tenantId）が未設定です");
    return;
  }

  if (!Array.isArray(csvRows) || csvRows.length === 0) {
    showToast(isAU ? "No data to import" : "取込データがありません");
    return;
  }
  // 2026-08 税率修正：ボタンの有効/無効判定（csvBlockingErrors参照）と
  // このガードを同一の状態に統一した。以前はボタンがcsvFatalErrors、
  // このガードがcsvErrors（サマリー・スキップ通知まで含む）という別集合を
  // 見ており、「ボタンは押せるのにクリックすると弾かれる」不整合UXが
  // 起こり得た
  if (Array.isArray(csvBlockingErrors) && csvBlockingErrors.length > 0) {
    alert((isAU ? "Cannot import due to errors.\n\n" : "エラーがあるため取込できません。\n\n") + csvBlockingErrors.slice(0, 30).join("\n"));
    return;
  }

  setCsvImporting(true);
  setCsvImportProgress({ current: 0, total: csvRows.length, done: false, skipped: 0 });
  // UIが描画されるまで待つ（React 18 batching対策）
  await new Promise(resolve => setTimeout(resolve, 80));

  try {
    const chunkSize = 500; // Firestoreのbatch上限
    let written = 0;
    let skipped = 0;

    for (let start = 0; start < csvRows.length; start += chunkSize) {
      const chunk = csvRows.slice(start, start + chunkSize);
      const batch = writeBatch(db);

      chunk.forEach((r) => {
        const barcode = String(r?.barcode ?? "").replace(/\.0$/, "").trim();
        const name = String(r?.name ?? "").trim();
        if (!barcode || !name) {
          skipped += 1;
          return;
        }

        // ✅ rowに埋めてある tenantId/supplierId を優先（なければ画面値）
        const rowTenantId = String(r?.tenantId ?? tenantId ?? "").trim();
        // 卸モードは supplierId = 自社 tenantId で固定（小売は supplierId を使用）
        const rowSupplierId = isWholesale
          ? rowTenantId
          : String(r?.supplierId ?? supplierId ?? "").trim();

        // ✅ 固定ID（再取込で上書き）
        let docId = "";
        if (isWholesale) {
          if (!rowTenantId) {
            skipped += 1;
            return;
          }
          docId = `w__${rowTenantId}__${barcode}`;
        } else {
          if (!rowSupplierId) {
            skipped += 1;
            return;
          }
          docId = rowTenantId
            ? `r__${rowTenantId}__${rowSupplierId}__${barcode}`
            : `r__${rowSupplierId}__${barcode}`;
        }

        // ✅ 書き込み直前の最終防御：taxRateはプレビュー段階の検証を必ず通っているはずだが、
        // ここで再度 assertValidTaxRate を通し、不正値がFirestoreに書き込まれる経路を完全に断つ
        // （0.1への推測フォールバックは行わない。異常時は行ごとskipし処理は継続する）
        // 2026-08（Codexレビュー9回目MINOR対応）：以前はpolicy省略でJP固定
        // だったため、AUの8%はここでは常に弾けていたが「保存直前の最終防御」
        // というコメントと実装が完全には一致していなかった（多層防御の他の層
        // ——CSV解析時のAU policy検証・Firestore Rulesの市場別検証——により
        // 実害は出ていなかった）。市場別policyを明示的に渡す
        let validatedTaxRate;
        try {
          validatedTaxRate = assertValidTaxRate(Number(r?.taxRate), resolveTaxPolicy(tenantProfile?.marketId));
        } catch (e) {
          skipped += 1;
          return;
        }

        const ref = doc(db, "products", docId);

        batch.set(
          ref,
          {
            barcode,
            name,
            nameNormalized: normalizeKana(name),
            searchTokens: buildProductSearchTokens(name),
            unit: String(r?.unit ?? "個"),

            innerCount: Math.max(1, Math.round(Number(r?.innerCount ?? 1) || 1)),
            costPrice: Number(r?.costPrice ?? 0) || 0,
            purchaseCost: Number(r?.purchaseCost ?? 0) || 0,
            sellPrice: Number(r?.sellPrice ?? 0) || 0,
            sellPriceInc: Number(r?.sellPriceInc ?? 0) || 0,
            taxRate: validatedTaxRate,
            category: String(r?.category ?? "").trim(),
            suggestedPrice: Number(r?.suggestedPrice ?? 0) || 0,

            updatedAt: serverTimestamp(),

            ...(rowTenantId ? { tenantId: rowTenantId } : {}),
            ...(rowSupplierId ? { supplierId: rowSupplierId } : {}),

            kind: isWholesale ? "wholesale" : "retail",
          },
          { merge: true }
        );

        written += 1;
      });

      await batch.commit();
      setCsvImportProgress({ current: written, total: csvRows.length, done: false, skipped });
      // チャンク間もUIを更新させる
      await new Promise(resolve => setTimeout(resolve, 0));
    }

    // 完了（showToast・setCsvOpen は完了UIに移譲）
    setCsvImportProgress({ current: written, total: csvRows.length, done: true, skipped });

    // 卸 商品マスタ画面：一括登録で追加・更新された商品を反映するため、
    // 巨大リスナーを再発火させず、1ページ目を明示的に再取得する。
    // CSV取込は件数次第で数百ms〜数秒かかるため、完了時点でユーザーが
    // 別テナント・別検索語・別画面へ移動している可能性がある。開始時点の
    // closure（isWholesale/wholesaleView等）ではなく最新renderの値を
    // 反映するwholesaleMasterLiveContextRefを見る
    const liveCtx = wholesaleMasterLiveContextRef.current;
    if (liveCtx.mode === "wholesale" && liveCtx.wholesaleView === "products") {
      const liveLoaders = wholesaleMasterLiveLoadersRef.current;
      liveLoaders.loadWholesaleMasterPage?.({ isFirstPage: true, forceReset: true });
      // 商品名検索表示中は一回限りのgetDocsのため自動反映されない。
      // 取込結果を検索結果にも反映させるため同じキーワードで明示的に再取得する
      if (liveCtx.isWholesaleMasterNameSearchMode && liveCtx.wholesaleMasterSearchTrimmed) {
        liveLoaders.loadWholesaleMasterSearchPage?.(liveCtx.wholesaleMasterSearchTrimmed, { isFirstPage: true });
      }
    }
  } catch (e) {
    console.error(e);
    alert(isAU ? "Failed to import" : "取込に失敗しました");
  } finally {
    setCsvImporting(false);
  }
};



// ✅ Firestore helper（Appの中に1個だけ・どこからでも呼べる場所に置く）
// 注：A-3フェーズ以降、注文の更新はすべてCallable経由になったため現在は未使用。
// 新Rulesではordersのupdateは note / updatedAt のみ許可される点に注意すること。
// eslint-disable-next-line no-unused-vars
async function patchOrder(orderId, patch) {
  if (!orderId) return;

  // optimistic UI
  setOrders((prev) =>
    (prev || []).map((o) => (String(o.id) === String(orderId) ? { ...o, ...patch } : o))
  );

  await updateDoc(doc(db, "orders", orderId), patch);
}

async function cancelOrder(orderId, orderNo) {
  if (!window.confirm(isAU
    ? `Cancel Order No. ${orderNo || ""}?\nOnce cancelled, it will be excluded from summaries.`
    : `注文No. ${orderNo || ""} をキャンセルしますか？\nキャンセル後は集計から除外されます。`)) return;
  try {
    // statusの変更はcancelOrder Callable限定（Rulesではnote以外の更新が拒否される）
    const cancelOrderFn = httpsCallable(functions, "cancelOrder");
    await cancelOrderFn({ orderId });
    // optimistic UI（サーバー側の確定内容はonSnapshotで反映される）。
    // 2026-08修正（Codexレビュー指摘対応・4ラウンド目）：dateRangeOrdersも同時に
    // 更新する（期間指定タブから開いた注文の表示が古いまま残る問題の修正）
    applyOrderPatchToLocalState(orderId, { status: "キャンセル" });
  } catch (e) {
    console.error(e);
    alert(e?.message || String(e));
  }
}


// ✅ 商品登録モーダルの保存（App直下に1個だけ置く）
async function saveProductFromModal() {
  // ── サブスクリプションガード ──
  if (!isSubscribed && tenantProfile?.role === "wholesale") {
    setShowExpiredModal(true);
    return;
  }
  // ✅ 数値（カンマ/¥/空文字に強い）
  const toNum = (v, fallback = 0) => {
    const s = String(v ?? "").replace(/[¥,\s"]/g, "").trim();
    if (s === "") return fallback;
    const n = Number(s);
    return Number.isFinite(n) ? n : fallback;
  };

  // 2026-08 AU版基盤（Phase 3、Codexレビュー指摘対応・MUST-FIX）：市場別policy/roundFn。
  // 以前はroundJPY・normalizeTaxRate（policy省略時は常にJAPAN_TAX_POLICY）が
  // ハードコードされており、AUでA$19.95を登録するとA$20へ丸められてしまう欠陥があった
  // （CSV/Excelインポート経路は既に対応済みだったが、通常の登録・編集モーダルの
  // 保存処理が取り残されていた）
  const productPolicy = resolveTaxPolicy(tenantProfile?.marketId);
  const productRoundFn = isAU ? roundAUD : roundJPY;

  // ✅ 税率専用：policyのallowedRates以外は明示エラーで停止する（推測変換・fallbackは行わない）
  const toTaxRate = (v) => {
    const result = normalizeTaxRate(v, productPolicy);
    if (!result.ok) {
      throw new Error(result.error.message || "税率が不正です");
    }
    return result.value;
  };

  try {
    if (!tenantId) {
      showToast(isAU ? "Please log in" : "ログインしてください");
      return;
    }

    // ✅ supplierId（モーダルの値優先。卸は tenantId を supplierId 扱い）
    const supplierIdFixed = String(
      regSupplierId ||
        (mode === "wholesale" ? (tenantId || "") : (supplierId || "")) ||
        ""
    ).trim();

    if (mode === "retail" && !supplierIdFixed) {
      showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
      return;
    }

    const barcode = String(regBarcode || "").trim();
    const name = String(regName || "").trim();
    const unit = String(regUnit || (isAU ? "" : "個")).trim() || (isAU ? "" : "個");

    if (!name) return showToast(isAU ? "Please enter a product name" : "商品名を入力してください");
    if (!String(regCategory || "").trim()) return showToast(isAU ? "Please enter a category" : "カテゴリを入力してください");

    // 2026-08 通貨丸め統一（Phase 3でmarketId対応）：商品マスタの金額は保存時点で
    // 必ず市場の通貨単位（JP:整数円、AU:セント）に丸める。ここで丸めておくことで、
    // 以降の qty×price 計算（注文明細・集計）が下流で端数が発生しない
    const costPrice = productRoundFn(toNum(regCostPrice, 0));
const sellPriceInc = productRoundFn(toNum(regSellPrice, 0)); // 入力値は税込
const taxRate = toTaxRate(regTaxRate);

// ✅ 売価：税込入力 → 税抜に変換して保存
const sellPrice = sellPriceInc > 0 ? productRoundFn(sellPriceInc / (1 + taxRate)) : 0;
// ✅ 税込売価も保存しておく（表示用）
const sellPriceIncSaved = sellPriceInc;

// ✅ 互換用 price は必ず原価優先
const compatPrice = costPrice || sellPrice || 0;

const suggestedPrice = productRoundFn(toNum(regSuggestedPrice, 0));

const innerCount = Math.max(1, Math.round(toNum(regInnerCount, 1)));

const payload = {
  tenantId,
  supplierId: supplierIdFixed,
  barcode,
  name,
  nameNormalized: normalizeKana(name),
  searchTokens: buildProductSearchTokens(name),
  unit,
  innerCount,         // 入り数
  costPrice,          // 発注単価（税抜）
  purchaseCost: productRoundFn(toNum(regPurchaseCost, 0)), // 仕入原価（税抜・任意）
  sellPrice,          // 小売販売価格（税抜・税込から変換）
  sellPriceInc: sellPriceIncSaved, // 売価（税込・入力値そのまま）
  price: compatPrice, // ✅ 互換用（原価優先）
  taxRate,
  category: String(regCategory || "").trim(),
  suggestedPrice,     // 推奨売価
  updatedAt: serverTimestamp(),
};


    if (regMode === "edit" && regEditingId) {
      await updateDoc(doc(db, "products", regEditingId), payload);
      showToast(isAU ? "Updated" : "更新しました");
    } else {
      const ref = await addDoc(collection(db, "products"), {
        ...payload,
        createdAt: serverTimestamp(),
      });

      if (regMode === "scanAdd") {
        add(normalizeProductForLine({ id: ref.id, ...payload }));
        showToast(compatPrice <= 0
          ? (isAU ? "Added without a price set (A$0)" : "価格未登録（0円）で追加しました")
          : (isAU ? "Registered and added" : "登録して追加しました"));
      } else {
        showToast(isAU ? "Registered" : "登録しました");
      }
      // 2026-08 AU版基盤（Phase 2）：この保存経路（addDoc、regMode!=="edit"）で
      // 作られる商品はisDemoフィールドを持たない実商品のみ（Sample Retailerの
      // サンプル商品はseedDemoData Callable経由でisDemo:trueとして作られ、
      // このUIモーダルを通らない）。markActivationOnceが内部で既存フラグを
      // 確認するため、2件目以降の登録ではGA4イベントは発火しない
      markActivationOnce("firstRealProductAddedAt", "first_real_product_added");
    }

    // 卸 商品マスタ画面：商品名変更でソート順が変わり別ページへ移動する可能性が
    // あるため、現在ページの state を無効化して1ページ目から安全に再取得する
    // （「リアルタイムっぽく見せる」よりデータ整合性を優先する）。
    // モーダルでの保存はユーザーの確認操作を挟むため完了までの時間が読めず、
    // 完了時点で別テナント・別検索語・別画面に移動している可能性がある。
    // 開始時点のclosure（mode/wholesaleView等）ではなく最新renderの値を
    // 反映するwholesaleMasterLiveContextRefを見る
    const liveCtx = wholesaleMasterLiveContextRef.current;
    if (liveCtx.mode === "wholesale" && liveCtx.wholesaleView === "products") {
      const liveLoaders = wholesaleMasterLiveLoadersRef.current;
      liveLoaders.loadWholesaleMasterPage?.({ isFirstPage: true, forceReset: true });
      // 商品名検索表示中は一回限りのgetDocsのため自動反映されない。
      // 追加・編集した商品を検索結果にも反映させるため同じキーワードで明示的に再取得する
      if (liveCtx.isWholesaleMasterNameSearchMode && liveCtx.wholesaleMasterSearchTrimmed) {
        liveLoaders.loadWholesaleMasterSearchPage?.(liveCtx.wholesaleMasterSearchTrimmed, { isFirstPage: true });
      }
    }

    // ✅ 後始末（入力は文字列で統一）
    setRegOpen(false);
    setRegEditingId(null);
    setRegBarcode("");
    setRegName("");
    setRegUnit(isAU ? "" : "個");
    setRegInnerCount("1");
    setRegCostPrice("0");
    setRegSellPrice("0");
    setRegTaxRate(0.1);
    setRegCategory("");
    setRegSuggestedPrice("0");
  } catch (e) {
    console.error(e);
    alert(e?.message || String(e));
  }
}

// ✅ 小売（仕入れ先必須）
const handleRetailMasterImport = async (e) => {
  const f = e?.target?.files?.[0];
  e.target.value = ""; // 同ファイル再選択OK
  if (!f) return;

  if (!tenantId) return showToast(isAU ? "Your company (tenant) is not set" : "会社（tenant）が未設定です");
  if (!supplierId) return showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");

  await handleImportFile(f);
};

// ✅ 卸（tenantId必須）
const handleWholesaleMasterImport = async (e) => {
  const f = e?.target?.files?.[0];
  e.target.value = "";
  if (!f) return;

  if (!tenantId) return showToast(isAU ? "Your company (tenant) is not set" : "会社（tenant）が未設定です");

  await handleImportFile(f);
};



// ✅ Excel/CSV → csvRows/csvPreview に流す（卸/小売 両対応）
const handleImportFile = async (file) => {
  if (!file) return;

  // ✅ モード別の必須条件
  const isRetail = mode === "retail";
  const isWholesale = mode === "wholesale";

  // 小売：仕入れ先必須
  if (isRetail && !supplierId) {
    showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
    return;
  }

  // 卸：tenantId 必須（あなたの運用に合わせる）
  if (isWholesale && !tenantId) {
    showToast(isAU ? "Your company (tenant) is not set" : "会社ID（tenantId）が未設定です");
    return;
  }

  const name = String(file.name || "").toLowerCase();

  try {
    // ---- CSV ----
    if (name.endsWith(".csv")) {
      const text = await file.text();

      // ✅ 既存CSVパーサーに流す（ただしファイル選択から来るのでモーダルはここで開く）
      parseCsvAndPreview(text);
      setCsvOpen(true);
      return;
    }
    
// ---- Excel (.xlsx/.xls) ----
if (name.endsWith(".xlsx") || name.endsWith(".xls")) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array" });

  const firstSheetName = wb.SheetNames?.[0];
  if (!firstSheetName) throw new Error("シートが見つかりません");

  const sheet = wb.Sheets[firstSheetName];
  const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });
  const headerRow = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" })[0] || [];

  // 2026-08 AU版基盤（Phase 3）：市場別policy/roundFn。marketId未指定時は
  // 既存どおりJAPAN_TAX_POLICY・roundJPY（整数円丸め）を使う
  const importMarketId = tenantProfile?.marketId;
  const importPolicy = resolveTaxPolicy(importMarketId);
  const importRoundFn = importMarketId === "AU" ? roundAUD : roundJPY;

  const rows = [];
  const errors = []; // ✅ "止めるエラー"だけ入れる（サマリー/スキップ通知は入れない）
  const blocking = []; // 2026-08 税率修正：税率・ヘッダー系のエラーは常にblocking扱い
  let skipped = 0;
  let noCategory = 0;

  const toNum = (v) => {
    if (v == null) return 0;
    const s = String(v).trim().replace(/,/g, "").replace(/[¥￥]/g, "");
    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
  };

  // ✅ 2026-08 税率修正：ヘッダー解決（必須列欠落・重複エイリアス・重複ヘッダー名の検出）
  const { resolved: headerMap, errors: headerErrors } = resolveProductImportHeaders(headerRow, isAU);
  if (headerErrors.length > 0) {
    headerErrors.forEach((e) => { errors.push(e); blocking.push(e); });
    setCsvText("");
    setCsvRows([]);
    setCsvPreview([]);
    setCsvErrors(errors);
    setCsvBlockingErrors(blocking);
    setCsvOpen(true);
    return;
  }

  for (let i = 0; i < json.length; i++) {
    const r = json[i] || {};

    const barcodeRaw = headerMap.barcode ? r[headerMap.barcode] : "";
    const nameRaw = headerMap.name ? r[headerMap.name] : "";
    const unitRaw = headerMap.unit ? r[headerMap.unit] : "";
    const sellRaw = (headerMap.sellPrice ? r[headerMap.sellPrice] : 0) || 0;
    const costRaw = (headerMap.costPrice ? r[headerMap.costPrice] : 0) || 0;
    const purchaseCostRaw = (headerMap.purchaseCost ? r[headerMap.purchaseCost] : 0) || 0;
    const taxKbnRaw = headerMap.taxKbn ? r[headerMap.taxKbn] : "";
    const taxRaw = headerMap.taxRate ? r[headerMap.taxRate] : "";
    const categoryRaw = headerMap.category ? r[headerMap.category] : "";
    const suggestedPriceRaw = (headerMap.suggestedPrice ? r[headerMap.suggestedPrice] : sellRaw) || 0;
    const innerCountRaw = (headerMap.innerCount ? r[headerMap.innerCount] : 1) || 1;

    // ✅ テンプレ2行目(説明文)を弾く（あなたのExcelはここが原因）
    const barcodeText = String(barcodeRaw ?? "").trim();
    const nameText = String(nameRaw ?? "").trim();
    if (/必須|任意|例|入力/.test(barcodeText) || /必須|任意|例|入力/.test(nameText)) {
      skipped++;
      continue;
    }

    // ✅ JAN正規化（空白/ハイフン/末尾 .0 などを除去）
    const barcode = normJan(barcodeRaw);
    const productName = String(nameRaw ?? "").trim();

    // 必須チェック：商品名
    if (!productName) {
      skipped++;
      continue;
    }

    // 2026-08 JPY丸め統一（Phase 3でmarketId対応）：Excel取込元データに小数の
    // 単価（例：ケース単価の割り勘計算由来）が含まれることがあるため、保存前に
    // 必ず市場の通貨単位へ丸める（JP:整数円、AU:セント単位）
    const costVal = importRoundFn(toNum(costRaw));

    // ✅ 2026-08 税率修正：税率列・税区分列からfail-closedで税率を決定する。
    // 不正・曖昧・矛盾のいずれかがあれば行全体を書き込み対象から除外し、
    // blockingエラーとして報告する（従来のように黙って10%にフォールバックしない）
    const taxResult = resolveRowTaxRate(taxRaw, taxKbnRaw, importPolicy, isAU);
    if (!taxResult.ok) {
      const allowedRatesText = importPolicy.allowedRates.map(r => `${Math.round(r * 100)}%`).join(" / ");
      const msg = isAU
        ? `L${i + 2} (${productName}): ${taxResult.error.message || "Invalid tax rate"} (entered: "${taxRaw}"${taxKbnRaw ? `, tax category: "${taxKbnRaw}"` : ""}. Allowed values: ${allowedRatesText})`
        : `L${i + 2}（${productName}）: ${taxResult.error.message || "税率が不正です"}（入力値: "${taxRaw}"${taxKbnRaw ? `, 税区分: "${taxKbnRaw}"` : ""}。入力可能値: ${allowedRatesText}）`;
      errors.push(msg);
      blocking.push(msg);
      continue;
    }
    const taxRateVal = taxResult.value;

    if (!String(categoryRaw ?? "").trim()) noCategory++;

    rows.push({
      _rowNo: i + 2, // sheet_to_json はヘッダ行を除外してるので +2 が人間の行番号
      barcode,
      name: productName,
      unit: String(unitRaw ?? "").trim() || (isAU ? "each" : "個"),
      innerCount: Math.max(1, Math.round(toNum(innerCountRaw) || 1)),
      costPrice: costVal,
      purchaseCost: importRoundFn(toNum(purchaseCostRaw)),
      sellPriceInc: importRoundFn(toNum(sellRaw)),
      sellPrice: toNum(sellRaw) > 0 ? importRoundFn(toNum(sellRaw) / (1 + taxRateVal)) : 0,
      taxRate: taxRateVal,
      category: String(categoryRaw ?? "").trim(),
      suggestedPrice: importRoundFn(toNum(suggestedPriceRaw)),

      ...(mode === "retail" ? { supplierId } : {}),
      ...(mode === "wholesale" ? { tenantId } : {}),
    });
  }

  // ✅ 有効行がゼロは "止める"
  if (rows.length === 0) {
    const msg = isAU
      ? "No valid rows found (rows need both a barcode and a product name)"
      : "有効な行が見つかりません（JANコード と 商品名 が入っている行が必要です）";
    errors.push(msg);
    blocking.push(msg);
  }

  // ✅ サマリーは csvErrors に入れない（入れるとボタンが無効化される）
  if (noCategory > 0) {
    errors.push(isAU
      ? `⚠️ ${noCategory} row(s) have no category. They won't appear in manual-entry search. Please add a category before importing.`
      : `⚠️ カテゴリ未入力が ${noCategory} 件あります。手書き入力での検索に出てきません。インポート前にカテゴリを入力してください。`);
  }
  const importSummaryMsg = isAU
    ? `Import result: ${rows.length} valid row(s) / ${skipped} skipped`
    : `取込結果: 有効 ${rows.length} 行 / スキップ ${skipped} 行`;
  if (typeof showToast === "function") {
    showToast(importSummaryMsg);
  } else if (typeof setToast === "function") {
    setToast(importSummaryMsg);
    setTimeout(() => setToast(""), 2500);
  }

  setCsvText("");
  setCsvRows(rows);
  setCsvPreview(rows.slice(0, 30));
  setCsvErrors(errors); // ✅ ここには "止めるエラー" だけ
  setCsvBlockingErrors(blocking); // ✅ 税率・ヘッダー系のエラーは必ずここにも入る
  setCsvOpen(true);
  return;
}



    alert(isAU ? "Supported formats are .csv / .xlsx / .xls" : "対応形式は .csv / .xlsx / .xls です");
  } catch (e) {
    console.error(e);
    alert(isAU ? "Failed to read the file" : "ファイルの読み込みに失敗しました");
  }
};


  // ===== suppliers modal =====
  const [supModalOpen, setSupModalOpen] = useState(false);
  const [supMode, setSupMode] = useState("add"); // add | edit
  const [supEditingId, setSupEditingId] = useState(null); // docId
  const [supName, setSupName] = useState("");
  const [supCompany, setSupCompany] = useState("");
  const [supAddress, setSupAddress] = useState("");
  const [supTel, setSupTel] = useState("");
  const [supFax, setSupFax] = useState("");
  const [supNote, setSupNote] = useState("");
  const [supEmail, setSupEmail] = useState("");           // 追加
  const [supInvoiceNo, setSupInvoiceNo] = useState("");   // 追加
  const [supWholesaleTenantId, setSupWholesaleTenantId] = useState(""); // 卸のtenantId（接続用）

  // ===== shops modal（卸モード用取引先） =====
  const [shopModalOpen, setShopModalOpen] = useState(false);
  const [shopModalMode, setShopModalMode] = useState("add");
  const [shopEditingId, setShopEditingId] = useState(null);
  const [shopModalName, setShopModalName] = useState("");
  const [shopModalCompany, setShopModalCompany] = useState("");
  const [shopModalAddress, setShopModalAddress] = useState("");
  const [shopModalTel, setShopModalTel] = useState("");
  const [shopModalFax, setShopModalFax] = useState("");
  const [shopModalNote, setShopModalNote] = useState("");
  const [shopModalEmail, setShopModalEmail] = useState("");
  const [shopModalInvoiceNo, setShopModalInvoiceNo] = useState("");
  const [shopModalClosingDay, setShopModalClosingDay] = useState("0");   // 締め日（0=末日）
  const [shopModalPaymentDays, setShopModalPaymentDays] = useState("30"); // 支払期限（日数）

  // 請求書発行
  const [billingShopId, setBillingShopId] = useState("");
  const [billingPeriodStart, setBillingPeriodStart] = useState("");
  const [billingPeriodEnd, setBillingPeriodEnd] = useState("");
  const [billingFetchedOrders, setBillingFetchedOrders] = useState(null); // Firestoreから取得した対象期間の納品実績
  const [billingFetching, setBillingFetching] = useState(false);
  const [billingIssuing, setBillingIssuing] = useState(false);
  // このTax Invoice発行操作専用のrequestId。失敗時（ネットワーク断・タイムアウト等、
  // サーバー側の成否が不明な場合）は保持したままにし、ユーザーが再試行しても同じ
  // requestIdで送られるため、サーバー側idempotencyにより二重発行にならない。
  // 成功を確認できた後にだけリセットする（submitOrderRequestIdRefと同じパターン）
  const billingIssueRequestIdRef = useRef(null);
  const [billingFetchError, setBillingFetchError] = useState(false); // 期間実績プレビュー取得の失敗（片側クエリ失敗含む）

  // ✅ 発行済み請求書の履歴（期間実績=billingFetchedOrdersとは完全に別state・別UIで扱う。
  // 発行済み一覧は期間実績へは絶対に混ざらない——issueBillingへの入力にもならない）
  const [billingIssuedInvoices, setBillingIssuedInvoices] = useState(null);
  const [billingIssuedLoading, setBillingIssuedLoading] = useState(false);
  const [billingIssuedError, setBillingIssuedError] = useState(false);
  const [billingPdfLoadingId, setBillingPdfLoadingId] = useState(null); // PDF取得中のinvoiceId
  // 発行済み請求書履歴のstale response対策：取引先を素早く切り替えた際、後から解決した
  // 古いリクエストの結果が新しく選択中の取引先のstateを上書きしないようにする世代カウンター
  const billingIssuedRequestGenerationRef = useRef(0);

  // ================================
// ✅ CSVを解析してプレビュー（超簡易版）
// 想定ヘッダ例: barcode,name,unit,costPrice,sellPrice,taxRate
// ================================
const parseCsvAndPreview = (csvText) => {
  try {
    const text = String(csvText ?? "").replace(/^\uFEFF/, "").trim(); // BOM除去（PapaParseと二重だが後方互換のため維持）
    setCsvText(text);

    // 初期化
    setCsvErrors([]);
    setCsvBlockingErrors([]);
    setCsvRows([]);
    setCsvPreview([]);

    if (!text) {
      const msg = isAU ? "The CSV file is empty" : "CSVが空です";
      setCsvErrors([msg]);
      setCsvBlockingErrors([msg]);
      setCsvOpen(true);
      return;
    }

    const parsed = Papa.parse(text, {
      header: false,
      skipEmptyLines: true,
      dynamicTyping: false, // 全てのセルを文字列として扱い、型判定はnormalizeTaxRate等に一任する
    });

    // ✅ パーサー自体がエラーを検出した場合（未終端クォート等）は行全体をブロックする
    if (parsed.errors && parsed.errors.length > 0) {
      const msgs = parsed.errors.map((e) => isAU
        ? `CSV parse error (around row ${(e.row ?? 0) + 2}): ${e.message}`
        : `CSV解析エラー（行${(e.row ?? 0) + 2}付近）: ${e.message}`);
      setCsvErrors(msgs);
      setCsvBlockingErrors(msgs);
      setCsvOpen(true);
      return;
    }

    const dataRows = parsed.data || [];
    if (dataRows.length < 2) {
      const msg = isAU ? "Not enough rows in the CSV (header + data required)" : "CSVの行数が足りません（ヘッダ＋データが必要）";
      setCsvErrors([msg]);
      setCsvBlockingErrors([msg]);
      setCsvOpen(true);
      return;
    }

    const headerRow = dataRows[0];
    const { resolved: headerMap, errors: headerErrors } = resolveProductImportHeaders(headerRow, isAU);
    if (headerErrors.length > 0) {
      setCsvErrors(headerErrors);
      setCsvBlockingErrors(headerErrors);
      setCsvOpen(true);
      return;
    }
    const headerIndex = {};
    Object.entries(headerMap).forEach(([canonicalField, actualHeaderName]) => {
      headerIndex[canonicalField] = headerRow.findIndex((h) => String(h ?? "").trim() === actualHeaderName);
    });

    const toNum = (v) => {
      if (v == null) return 0;
      const s = String(v).trim().replace(/,/g, "").replace(/[¥￥]/g, "");
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };

    // 2026-08 AU版基盤（Phase 3）：市場別policy/roundFn。marketId未指定時は
    // 既存どおりJAPAN_TAX_POLICY・roundJPY（整数円丸め）を使う
    const importMarketId = tenantProfile?.marketId;
    const importPolicy = resolveTaxPolicy(importMarketId);
    const importRoundFn = importMarketId === "AU" ? roundAUD : roundJPY;

    const rows = [];
    const errors = [];
    const blocking = [];

    for (let idx = 1; idx < dataRows.length; idx++) {
      const cols = dataRows[idx];
      // ✅ 列数が期待するヘッダー数と一致しない場合は列ずれの可能性として行を拒否する
      if (cols.length !== headerRow.length) {
        const msg = isAU
          ? `Row ${idx + 1}: wrong number of columns (expected ${headerRow.length}, got ${cols.length}). Check for unclosed quotes etc.`
          : `行${idx + 1}: 列数が不正です（期待${headerRow.length}列、実際${cols.length}列）。引用符の閉じ忘れ等がないか確認してください`;
        errors.push(msg);
        blocking.push(msg);
        continue;
      }

      const get = (field) => (headerIndex[field] >= 0 ? String(cols[headerIndex[field]] ?? "").trim() : "");
      const barcode = get("barcode");
      const productName = get("name");
      const taxRaw = get("taxRate");
      const taxKbnRaw = get("taxKbn");

      if (!barcode) { const m = isAU ? `Row ${idx + 1}: barcode is empty` : `行${idx + 1}: barcode が空です`; errors.push(m); blocking.push(m); continue; }
      if (!productName) { const m = isAU ? `Row ${idx + 1}: name is empty` : `行${idx + 1}: name が空です`; errors.push(m); blocking.push(m); continue; }

      const taxResult = resolveRowTaxRate(taxRaw, taxKbnRaw, importPolicy, isAU);
      if (!taxResult.ok) {
        const allowedRatesText = importPolicy.allowedRates.map(r => `${Math.round(r * 100)}%`).join(" / ");
        const msg = isAU
          ? `Row ${idx + 1} (${productName}): ${taxResult.error.message || "Invalid tax rate"} (entered: "${taxRaw}"${taxKbnRaw ? `, tax category: "${taxKbnRaw}"` : ""}. Allowed values: ${allowedRatesText})`
          : `行${idx + 1}（${productName}）: ${taxResult.error.message || "税率が不正です"}（入力値: "${taxRaw}"${taxKbnRaw ? `, 税区分: "${taxKbnRaw}"` : ""}。入力可能値: ${allowedRatesText}）`;
        errors.push(msg);
        blocking.push(msg);
        continue;
      }

      // 2026-08 JPY丸め統一（Phase 3でmarketId対応）：CSV取込元データに小数の
      // 単価が含まれることがあるため、保存前に必ず市場の通貨単位へ丸める
      rows.push({
        barcode,
        name: productName,
        unit: get("unit") || (isAU ? "each" : "個"),
        costPrice: importRoundFn(toNum(get("costPrice"))),
        sellPrice: importRoundFn(toNum(get("sellPrice"))),
        purchaseCost: importRoundFn(toNum(get("purchaseCost"))),
        category: get("category"),
        suggestedPrice: importRoundFn(toNum(get("suggestedPrice"))),
        innerCount: Math.max(1, Math.round(toNum(get("innerCount")) || 1)),
        taxRate: taxResult.value,
      });
    }

    if (rows.length === 0 && blocking.length === 0) {
      const msg = isAU ? "No valid rows found" : "有効な行が見つかりません";
      errors.push(msg);
      blocking.push(msg);
    }

    setCsvRows(rows);               // ✅ 全行保持
    setCsvPreview(rows.slice(0, 30)); // ✅ 先頭だけプレビュー
    setCsvErrors(errors);           // ✅ エラー保持
    setCsvBlockingErrors(blocking); // ✅ blocking判定はこちらを見る
    setCsvOpen(true);               // ✅ モーダルを開く（csvPreviewOpen不要）
  } catch (e) {
    console.error(e);
    const msg = isAU ? "Failed to parse the CSV (please check the format)" : "CSV解析に失敗しました（形式を確認してください）";
    setCsvErrors([msg]);
    setCsvBlockingErrors([msg]);
    setCsvOpen(true);
  }
};


// ※「プレビューを開くモーダル」を使うならON（使わないなら消してOK）
const [csvPreviewOpen, setCsvPreviewOpen] = useState(false);


  // ===== product master: open add/edit modal (wholesale) =====
const openAddProductWholesale = () => {
  setRegMode("add");
  setRegEditingId(null);
  setRegBarcode("");
  setRegName("");
  setRegUnit(isAU ? "" : "個");

  setRegCostPrice("0");
  setRegSellPrice("0");
  setRegTaxRate(0.1);

  setRegOpen(true);
};



  const priceGrid = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 };

  const fieldWrap = { display: "grid", gap: 6 };

  const labelRow = { display: "flex", gap: 8, alignItems: "baseline" };

  const labelMain = { fontWeight: 900, fontSize: 12 };

  const labelSub = { fontSize: 11, opacity: 0.65 };

  const moneyBox = {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    alignItems: "center",
    border: "1px solid #ddd",
    borderRadius: 12,
    padding: "0 10px",
    background: "white",
  };

  const moneyPrefix = { fontWeight: 900, opacity: 0.7, paddingRight: 8 };

  const moneyInput = {
    border: "none",
    outline: "none",
    padding: "10px 0",
    width: "100%",
    fontSize: 14,
  };


  // ※ regPrice を残すなら、regPrice→regCostPrice に置換していくのが安全
  const [regTaxRate, setRegTaxRate] = useState(0.1);

  // ===== search modal =====
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  // ===== retail history expand =====
  const [openHistoryIds, setOpenHistoryIds] = useState({});
  function toggleHistory(id) {
    setOpenHistoryIds((prev) => ({ ...prev, [id]: !prev[id] }));
  }
// ===== wholesale =====
const [wholesaleView, setWholesaleView] = useState("home");
const [whSearch, setWhSearch] = useState("");
const [showQRModal, setShowQRModal] = useState(false);

// URLに ?invite=CODE があれば保持（QRスキャン後の自動参加用）
const [pendingInviteCode, setPendingInviteCode] = useState(() => {
  const params = new URLSearchParams(window.location.search);
  return (params.get("invite") || "").trim().toUpperCase();
});

// Stripe 決済完了後のリダイレクト検出
const [checkoutResult, setCheckoutResult] = useState(() => {
  const params = new URLSearchParams(window.location.search);
  const status = params.get("checkout"); // "success" | "cancel"
  if (status) {
    window.history.replaceState({}, "", window.location.pathname);
  }
  return status || null;
});
const [whPage, setWhPage] = useState(0); // ページング（0始まり）
const [selectedOrderId, setSelectedOrderId] = useState(null);

// ✅ 日付範囲フィルタ
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
const [draftStartDate, setDraftStartDate] = useState(""); // 入力中（未確定）
const [draftEndDate, setDraftEndDate] = useState("");     // 入力中（未確定）
const [dateRangeOrders, setDateRangeOrders] = useState(null); // 期間指定取得結果（nullなら通常orders使用）
const [dateRangeLoading, setDateRangeLoading] = useState(false);
// 取得失敗時に「未取得（30日分にフォールバック）」と区別するためのエラーフラグ。
// falseにするだけで（依存配列に含まれないため）自動リトライはしない——
// このuseEffect形式ではなく通常の関数呼び出しなので、ユーザーが再度
// 「絞り込む」ボタンを押すことで再試行される
const [dateRangeError, setDateRangeError] = useState(false);
// 連打・テナント切替中の古いリクエストが新しいテナントの画面に結果を書き込む
// （クロステナントのデータ越境）ことを防ぐための単調増加ID
const dateRangeRequestIdRef = useRef(0);

// 2026-08修正（Codexレビュー指摘対応・4ラウンド目）：selectedOrderはdateRangeOrders
// （期間指定タブでの単発取得結果）をordersより優先して検索する設計になっている。
// 以前はCallable成功後の画面反映がordersのみを更新しており、期間指定タブから
// 開いた注文では、受注確定・欠品化・日付変更・キャンセルが成功してもselectedOrder
// が古いdateRangeOrders側の値を読み続け、画面表示が更新されない問題があった。
// 成功後の状態反映は必ずこの関数を経由し、orders・dateRangeOrdersの両方に
// 同じpatchを適用する
function applyOrderPatchToLocalState(orderId, patch) {
  const applyPatch = (o) => (String(o.id) === String(orderId) ? { ...o, ...patch } : o);
  setOrders((prev) => (prev || []).map(applyPatch));
  setDateRangeOrders((prev) => (prev ? prev.map(applyPatch) : prev));
}



const detailTopRef = useRef(null);

useEffect(() => {
  if (mode === "wholesale" && wholesaleView === "orders" && selectedOrderId) {
    requestAnimationFrame(() => {
      detailTopRef.current?.scrollIntoView({ block: "start", behavior: "auto" });
    });
  }
}, [mode, wholesaleView, selectedOrderId]);




// スキャナーの用途: "order"（発注へ追加） / "reg"（商品登録のJAN入力）
const [scanTarget, setScanTarget] = useState("order");

  // ===== print (delivery) =====
  const [printPick, setPrintPick] = useState(null);
  const [printOrders, setPrintOrders] = useState(null);
  // ✅ 納品書発行前・単価確認モーダル
  const [priceCheckModal, setPriceCheckModal] = useState(null); // { order, editLines }


  // ===== common styles =====
  const S = {
    card: {
      border: "1px solid #eee",
      borderRadius: 14,
      padding: 12,
      background: "white",
    },
    btn: {
      padding: "10px 12px",
      borderRadius: 12,
      border: "1px solid #ddd",
      fontWeight: 900,
      background: "white",
      cursor: "pointer",
    },
    btnPrimary: {
      padding: "10px 12px",
      borderRadius: 12,
      border: "1px solid #111",
      fontWeight: 900,
      background: "#111",
      color: "white",
      cursor: "pointer",
    },
  };

  // ===== auth state（ログイン状態を監視）=====
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u || null);
    });
    return () => unsub();
  }, []);

  // ===== tenantId 解決（users/{uid}.tenantId が無ければ作る）=====
  useEffect(() => {
    (async () => {
      if (!user) {
        setTenantId(null);
        setPendingInviteCode(""); // ログアウト時に招待コードをクリア（別ユーザーへの誤接続防止）
        return;
      }

      const uref = doc(db, "users", user.uid);
      const usnap = await getDoc(uref);

      if (usnap.exists() && usnap.data()?.tenantId) {
        setTenantId(usnap.data().tenantId);
        return;
      }

      // ✅ 初回ログイン：自分の tenant を作る
      // tenants/{tenantId}・users/{uid}.tenantId・招待コード（trading/staff）の発行は、
      // すべてregisterNewTenant Callableがトランザクション内で行う。
      // Rulesではtenants createもusers.tenantIdの書き込みも禁止されているため、この経路以外では作成できない。
      const registerNewTenantFn = httpsCallable(functions, "registerNewTenant");
      const regResult = await registerNewTenantFn({});
      const newTenantId = regResult?.data?.tenantId;
      if (!newTenantId) throw new Error("テナントの作成に失敗しました");

      // 2026-08 AU版基盤（Phase 2）：この経路（users/{uid}にtenantIdが
      // まだ存在しない）に到達するのは、このFirebase Authアカウントが
      // 初めてtenantを持つ瞬間のみ（useEffect冒頭のusnap.exists()判定により、
      // 2回目以降のログインではこの分岐自体に入らないため、再訪問での
      // 重複発火は起こらない）
      trackEvent("first_login");
      setTenantId(newTenantId);
    })().catch((e) => {
      console.error(e);
      alert(e?.message || e);
    });
  }, [user]);

  // tenants/{tenantId} を読み込み（なければ初期値で作成）
  useEffect(() => {
    (async () => {
      try {
        if (!tenantId) return;

        const ref = doc(db, "tenants", tenantId);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          // 招待コードの発行・補完はregisterNewTenant / rotateInviteCode Callableが担う。
          // クライアントからのinviteCode書き込みは新Rulesで禁止されているため、ここでは読むだけにする。
          setTenantProfile({ id: tenantId, ...snap.data() });
        } else {
          // tenantsのcreateはregisterNewTenant Callable限定。ここで作成は行わない
          console.warn("[tenantProfile] テナントドキュメントが存在しません:", tenantId);
          setTenantProfile(null);
        }
      } catch (e) {
        console.error(e);
        alert(e.message);
      }
    })();
  }, [tenantId]);

  // 小売モード：接続先卸のプロファイルを取得（allowRetailProductEdit などを参照するため）
  // wholesaleTenantId は tenantProfile 直接 or 仕入先リストの両方から解決する
  useEffect(() => {
    if (mode !== "retail") { setWholesaleProfile(null); return; }
    const fromProfile = String(tenantProfile?.wholesaleTenantId || "").trim();
    const fromSupplier = (suppliers || [])
      .map(s => String(s.wholesaleTenantId || "").trim())
      .find(id => !!id) || "";
    const wid = fromProfile || fromSupplier;
    if (!wid) { setWholesaleProfile(null); return; }
    (async () => {
      try {
        // 2026-08 Codexレビュー指摘対応（MUST-FIX）：接続先卸のtenants本体（機微
        // フィールドを含む）ではなく、表示専用のpublic/profileサブドキュメントを読む
        const snap = await getDoc(doc(db, "tenants", wid, "public", "profile"));
        setWholesaleProfile(snap.exists() ? snap.data() : null);
      } catch (e) {
        console.error("[wholesaleProfile fetch error]", e);
        setWholesaleProfile(null);
      }
    })();
  }, [mode, tenantProfile?.wholesaleTenantId, suppliers]);

  // 新Firestore Rules（hasOnly方式のアローリスト）に合わせ、
  // tenantProfile全体ではなく変更フィールドのみをpatchとして送る。
  // 会社情報と配送スケジュールはRules側で別のupdateブロックに分かれているため、
  // それぞれ別のsetDoc呼び出しに分割する（1回のupdateで両方に跨るとhasOnlyに拒否される）。
  // 2026-08（Codexレビュー指摘対応・MINOR）：以前は例外をcatchするだけで呼び出し元へ
  // 伝播しなかったため、保存ボタン側が無条件で成功表示（tenantSaveOk=true）を出しており、
  // Firestore書き込み失敗時にも「✓ Saved」と表示されてしまっていた。戻り値で成否を
  // 明示し、呼び出し元が成功時のみ成功表示を出せるようにする
  // 2026-08 Codexレビュー指摘対応（MUST-FIX）：接続先卸/小売が実際に表示に使う
  // フィールドのみのアローリスト。tenants/{id}/public/profileへの同期対象を
  // ここで一元管理し、firestore.rulesのpublicサブコレクションhasOnlyと
  // 同じ集合を保つ（機微フィールド——stripeCustomerId, subscriptionStatus,
  // bank, abn, ownerUid等——は絶対にここに含めない）
  const TENANT_PUBLIC_PROFILE_FIELDS = ["name", "email", "allowRetailProductEdit", "leadDays", "cutoffTime", "closedWeekdays", "holidayDates", "timezone"];

  async function updateTenantSettings(patch) {
    // 2026-08（Codexレビュー2回目MINOR対応）：以前はFirestore書き込み失敗時も
    // setTenantProfileによる楽観的更新（先行実行）がそのまま残り、画面には
    // 「保存されたかのような値」が表示され続けていた。ロールバック用に
    // 更新前のスナップショットを保持しておく
    let previousProfile = null;
    try {
      const settingsPatch = {};
      const schedulePatch = {};
      const auBasisPatch = {};
      for (const [k, v] of Object.entries(patch || {})) {
        if (TENANT_SETTINGS_ALLOWED_FIELDS.includes(k)) settingsPatch[k] = v;
        else if (TENANT_SCHEDULE_ALLOWED_FIELDS.includes(k)) schedulePatch[k] = v;
        else if (TENANT_AU_BASIS_ALLOWED_FIELDS.includes(k)) auBasisPatch[k] = v;
      }
      setTenantProfile(prev => { previousProfile = prev; return { ...(prev || {}), ...patch }; });

      if (Object.keys(settingsPatch).length > 0) {
        await setDoc(doc(db, "tenants", tenantId), { ...settingsPatch, updatedAt: serverTimestamp() }, { merge: true });
      }
      if (Object.keys(schedulePatch).length > 0) {
        await setDoc(doc(db, "tenants", tenantId), { ...schedulePatch, updatedAt: serverTimestamp() }, { merge: true });
      }
      if (Object.keys(auBasisPatch).length > 0) {
        await setDoc(doc(db, "tenants", tenantId), { ...auBasisPatch, updatedAt: serverTimestamp() }, { merge: true });
      }
      // 2026-08 Codexレビュー指摘対応（MUST-FIX）：更新されたフィールドのうち
      // 公開対象のものがあれば、tenants/{id}/public/profileへも同期する。
      // 接続先はこのサブドキュメントのみを読み、親tenants本体（機微フィールドを
      // 含む）へはgetできない
      const publicPatch = {};
      for (const f of TENANT_PUBLIC_PROFILE_FIELDS) {
        if (Object.prototype.hasOwnProperty.call(patch || {}, f)) publicPatch[f] = patch[f];
      }
      if (Object.keys(publicPatch).length > 0) {
        await setDoc(doc(db, "tenants", tenantId, "public", "profile"), { ...publicPatch, updatedAt: serverTimestamp() }, { merge: true });
      }
      showToast(isAU ? "Business details saved" : "会社情報を保存しました");
      return { success: true };
    } catch (e) {
      console.error(e);
      if (previousProfile !== null) setTenantProfile(previousProfile);
      alert(e.message);
      return { success: false, error: e };
    }
  }

  // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：GA4のfirst系
  // イベント（first_real_product_added等）を本当に初回だけ発火させる。
  // 以前はローカルのtenantProfile.activationを見て「未発火」と判断してから
  // GA4送信→setDocという順序だったため、複数タブ・連打・並行リクエストで
  // 同時に「未発火」と判断されGA4が複数回送信されるrace conditionがあった。
  // また、activation map全体をまるごと上書きするsetDocだったため、異なる
  // firstイベントがほぼ同時に発火すると互いのキーを消し合うlost updateの
  // リスクもあった（いずれもCodex指摘）。
  // 対応：claimActivation Callable（Firestore transactionでキー単位の原子的な
  // field path更新を行う）を呼び、実際にこの呼び出しでキーを確保できた
  // （claimed:true）場合のみGA4イベントを送信する。同一tenant・同一key・
  // 同一クライアント内での多重発火防止として、in-flight中のkeyをRefで
  // 追跡し、レスポンスが返る前に同じkeyで再呼び出しされても新規リクエストを
  // 送らないようにする（ネットワーク層のrace condition軽減、正しさの
  // 最終的な保証はサーバー側Callableのtransactionが担う）
  const activationClaimInFlightRef = useRef(new Set());
  async function markActivationOnce(key, eventName, eventParams) {
    if (!tenantId || !key) return;
    if (tenantProfile?.activation?.[key]) return; // ローカルに反映済みのフラグがあれば早期return（サーバー呼び出し自体を避ける最適化）
    if (activationClaimInFlightRef.current.has(key)) return;
    activationClaimInFlightRef.current.add(key);
    try {
      const claimFn = httpsCallable(functions, "claimActivation");
      const result = await claimFn({ key });
      if (result?.data?.claimed) {
        setTenantProfile(prev => ({ ...(prev || {}), activation: { ...(prev?.activation || {}), [key]: true } }));
        if (eventName) trackEvent(eventName, eventParams);
      }
    } catch (e) {
      console.error("[markActivationOnce error]", key, e);
    } finally {
      activationClaimInFlightRef.current.delete(key);
    }
  }

  // 2026-08（23回目Codexレビュー指摘、MUST-FIX対応）：saveSetup内のsignup_complete_wholesale
  // 送信は、role確定（confirmInitialRole）→プロフィール保存（updateTenantSettings）→
  // activation claim（markActivationOnce）→GA4送信、という複数ステップの最後に
  // 位置している。この一連の流れの途中（role確定直後にブラウザが閉じられる、
  // 通信断でupdateTenantSettingsが失敗する等）で中断すると、次回アクセス時には
  // 既にrole確定済みのため「role未設定」を条件とするsaveSetup画面自体に二度と
  // 到達せず、signup_complete_wholesaleが永久に送信されない可能性があった。
  // この保険として、tenantProfileがロードされ「role=wholesaleだが
  // signupCompleteWholesaleAtは未claim」という状態を検知した場合、ログイン後の
  // どのタイミングでも回収できるようにする（claimActivationKeyのtransactionは
  // 何度呼んでも安全＝二重発火しない）。
  // 22回目対応時は「role===wholesale かつ未claim」だけを条件にしていたが、これは
  // signupCompleteWholesaleAt導入前から存在する既存の卸tenant（本来とっくに
  // 登録済みで、GA4的には「新規conversion」ではない）まで対象にしてしまい、
  // 次回ログイン時に誤ってGoogle Ads Primary Conversionとして送信する欠陥が
  // あった（23回目Codexレビュー指摘）。confirmInitialRole側でrole確定時のみ
  // サーバーが記録するsignupCompleteWholesaleEligibleAt（この機能導入後に
  // 新規作成されたwholesale tenantであることの不変マーカー）が無いtenantには
  // 一切反応しないようガードを追加した
  useEffect(() => {
    if (!tenantId || !tenantProfile) return;
    if (tenantProfile.role !== "wholesale") return;
    if (!tenantProfile.signupCompleteWholesaleEligibleAt) return; // 機能導入前からの既存tenantは対象外
    if (tenantProfile.activation?.signupCompleteWholesaleAt) return;
    markActivationOnce("signupCompleteWholesaleAt", "signup_complete_wholesale", { role: "wholesale", market: isAU ? "AU" : "JP" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, tenantProfile?.role, tenantProfile?.signupCompleteWholesaleEligibleAt, tenantProfile?.activation?.signupCompleteWholesaleAt]);

  // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：「実取引先招待」の
  // 完了（＝実際に小売が招待コードで接続してきた瞬間）を検知する。招待コード自体は
  // tenant作成時に自動発行されるため「コードを発行した」時点では意味のある
  // シグナルにならない。
  // 以前はshops.length>0（1件以上）だけを条件にしていたが、shopsには
  // システム接続由来（招待コード経由、retailTenantIdを持つ）だけでなく、
  // 手動登録shop（source:"manual"、retailTenantIdを持たない——卸が取引先情報を
  // 手入力しただけで、実際に小売がOrderLinkに接続した実績はない）も含まれており、
  // 卸が手動で取引先を1件登録しただけで誤発火していた（Codex指摘）。
  // retailTenantIdを持つshop（＝実際にシステム接続が成立した取引先）の件数のみを
  // カウントするよう修正する
  const connectedShopsCount = React.useMemo(
    () => (shops || []).filter((s) => !!s.retailTenantId).length,
    [shops]
  );
  useEffect(() => {
    if (mode !== "wholesale") return;
    if (connectedShopsCount > 0) {
      markActivationOnce("firstRealCustomerInvitedAt", "first_real_customer_invited");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, connectedShopsCount, tenantId]);

  // 2026-08 AU版基盤（Phase 2）：「実注文の初回受信」を検知する。
  // isRealOrder（isDemoでない注文）が1件以上ordersに含まれるようになった
  // タイミングで発火する。Sample Retailerで生成したisDemo:true注文は
  // isRealOrderでfalseになるため、このイベントには影響しない
  useEffect(() => {
    if (mode !== "wholesale") return;
    if ((orders || []).some(isRealOrder)) {
      markActivationOnce("firstRealOrderReceivedAt", "first_real_order_received");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, orders, tenantId]);

  // subscription_startedはサーバー側のみが送信する（Transactional Outbox方式、
  // functions/lib/stripeEventProcessor.js・functions/index.jsのanalyticsOutbox関連参照）。
  // クライアント側からの送信は行わない

  async function joinTenantByCode() {
    if (!user) return;

    // 2026-08（Step 12 E2E検証時に発覚したバグ対応）：window.promptがisAU分岐
    // なしで日本語固定だった
    const code = window.prompt(isAU
      ? "Enter the supplier's invite code (8 characters)\n\nUse this to connect with a supplier who takes your orders through the system."
      : "卸の招待コード（8桁）を入力してください\n\n※ 卸からシステムで受注してもらう場合に使います");
    const inviteCode = String(code || "").trim().toUpperCase();
    if (!inviteCode) return;

    try {
      // 接続処理（招待コード検証・connections作成・suppliersミラー作成・テナント配列更新）は
      // すべてサーバー側のjoinTenantByInviteCode Callableが行う
      const joinTenantByInviteCodeFn = httpsCallable(functions, "joinTenantByInviteCode");
      const result = await joinTenantByInviteCodeFn({ inviteCode });
      const wholesaleTid = result?.data?.wholesaleTenantId;

      // 接続先卸の表示名を取得（接続成立後はRules上getが許可される）。
      // 2026-08 Codexレビュー指摘対応（MUST-FIX）：tenants本体ではなく
      // public/profileサブドキュメントを読む
      let wholesaleInfo = null;
      try {
        const wsnap = await getDoc(doc(db, "tenants", wholesaleTid, "public", "profile"));
        wholesaleInfo = wsnap.exists() ? wsnap.data() : null;
      } catch (e) {
        console.warn("[joinTenantByCode] 卸プロフィール取得に失敗", e);
      }

      setTenantProfile(prev => ({
        ...(prev || {}),
        wholesaleTenantId: wholesaleTid,
        wholesaleName: wholesaleInfo?.name || "",
      }));

      // 卸のメールアドレスが登録されていれば通知メールを起動
      // 2026-08（Step 12 E2E検証時に発覚したバグ対応）：isAU分岐なしで
      // 件名・本文・アラート文言が完全に日本語ハードコードされていた
      const wsEmail = wholesaleInfo?.email;
      if (wsEmail) {
        const myName = tenantProfile?.retailName || tenantProfile?.name || user.email || (isAU ? "Retailer" : "小売店");
        const subject = encodeURIComponent(isAU
          ? `[New connection] ${myName} has joined your ordering system`
          : `【新規接続通知】${myName} が注文システムに参加しました`);
        const body = encodeURIComponent(isAU
          ? (
            `${wholesaleInfo?.name || "Hi"}\n\n` +
            `${myName} has connected to your ordering system.\n\n` +
            `Store: ${myName}\n` +
            `Phone: ${tenantProfile?.retailTel || tenantProfile?.tel || "Not provided"}\n` +
            `Connected: ${new Date().toLocaleString("en-AU")}\n\n` +
            `You can view this in your Order management screen.`
          ) : (
            `${wholesaleInfo?.name || "御中"}\n\n` +
            `${myName} が注文システムに接続しました。\n\n` +
            `■ 店名：${myName}\n` +
            `■ TEL：${tenantProfile?.retailTel || tenantProfile?.tel || "未登録"}\n` +
            `■ 接続日時：${new Date().toLocaleString("ja-JP")}\n\n` +
            `受注一覧からご確認ください。`
          ));
        window.open(`mailto:${wsEmail}?subject=${subject}&body=${body}`);
      }

      alert(isAU
        ? `✅ Connected with "${wholesaleInfo?.name || wholesaleTid}"!\n\nYour orders will now appear in their Order management screen.${wsEmail ? "\n\nA notification email has been started." : ""}`
        : `✅ 卸「${wholesaleInfo?.name || wholesaleTid}」と接続しました！\n\n今後、発注すると卸の受注一覧に届きます。${wsEmail ? "\n\n卸への通知メールを起動しました。" : ""}`);

    } catch (e) {
      console.error(e);
      alert(e?.message || e);
    }
  }

  // ===== 卸起点：小売の招待コードで接続 =====
  async function connectRetailByCode(code) {
    if (!tenantId || !code) return;
    const inviteCode = String(code).trim().toUpperCase();
    try {
      // 接続処理一式はconnectRetailByInviteCode Callableがサーバー側で実行する
      const connectRetailByInviteCodeFn = httpsCallable(functions, "connectRetailByInviteCode");
      const result = await connectRetailByInviteCodeFn({ inviteCode });
      const retailTid = result?.data?.retailTenantId;

      // 表示名はCallableが作成したshop__レコードから取得する
      let shopName = isAU ? "Retailer" : "小売店";
      try {
        const shopSnap = await getDoc(doc(db, "suppliers", `shop__${tenantId}__${retailTid}`));
        if (shopSnap.exists()) shopName = shopSnap.data()?.name || shopName;
      } catch (e) {
        console.warn("[connectRetailByCode] 取引先名の取得に失敗", e);
      }

      alert(isAU
        ? `✅ "${shopName}" was added as a customer!\nTheir orders will now appear in your order list.`
        : `✅「${shopName}」を取引先に追加しました！\n受注一覧に発注が届くようになります。`);
    } catch (e) {
      console.error(e);
      alert(e?.message || e);
    }
  }

  // ===== スタッフとして既存テナントに参加 =====
  async function joinAsStaff(code) {
    if (!user || !code) return;
    const staffCode = String(code).trim().toUpperCase();
    if (!staffCode) return;
    try {
      // コード検証・使い捨て化・users/{uid}.tenantId更新はjoinTenantAsStaff Callableが行う
      const joinTenantAsStaffFn = httpsCallable(functions, "joinTenantAsStaff");
      const result = await joinTenantAsStaffFn({ staffInviteCode: staffCode });
      const targetTenantId = result?.data?.tenantId;
      if (targetTenantId) setTenantId(targetTenantId);
      showToast(isAU ? "✅ Joined!" : "✅ 参加しました！");
    } catch (e) {
      console.error(e);
      alert(e?.message || e);
    }
  }

  // ===== role に基づいてモードを固定 =====
  useEffect(() => {
    if (!tenantProfile?.role) return;
    if (tenantProfile.role === "wholesale") setMode("wholesale");
    if (tenantProfile.role === "retail") setMode("retail");
  }, [tenantProfile?.role]);

  // ===== 仕入先が1件だけなら自動選択 =====
  useEffect(() => {
    if (mode !== "retail") return;
    if (suppliers.length === 1 && !supplierId) {
      setSupplierId(suppliers[0].id);
    }
  }, [suppliers, mode, supplierId]);

  // ===== wholesaleTenantId が設定済みなら sup__ エントリを確実に作成（既存接続ユーザーの修復） =====

  // ===== QRスキャン招待：ログイン後に自動参加 =====
  useEffect(() => {
    if (!tenantId || !pendingInviteCode) return;
    // URLパラメータとstateを両方クリア（別ユーザーがログインしても再発火しないよう）
    window.history.replaceState({}, "", window.location.pathname);
    setPendingInviteCode("");
    (async () => {
      try {
        // 招待コードの検証・接続処理一式はjoinViaQrInviteCode Callableがサーバー側で実行する。
        // 既に接続済みの場合はCallableがalready-existsエラーを返すため、それをそのまま案内に使う。
        const joinViaQrInviteCodeFn = httpsCallable(functions, "joinViaQrInviteCode");
        const result = await joinViaQrInviteCodeFn({ inviteCode: pendingInviteCode });
        const wholesaleTid = result?.data?.wholesaleTenantId;

        const defaultWholesaleName = isAU ? "Supplier" : "卸";
        let wholesaleName = defaultWholesaleName;
        try {
          // 2026-08 Codexレビュー指摘対応（MUST-FIX）：tenants本体ではなく
          // public/profileサブドキュメントを読む
          const wsnap = await getDoc(doc(db, "tenants", wholesaleTid, "public", "profile"));
          if (wsnap.exists()) wholesaleName = wsnap.data()?.name || wholesaleName;
        } catch (e) {
          console.warn("[QR接続] 卸プロフィール取得に失敗", e);
        }

        setTenantProfile(prev => ({
          ...(prev || {}),
          wholesaleTenantId: wholesaleTid,
          wholesaleName: wholesaleName === defaultWholesaleName ? "" : wholesaleName,
        }));

        setMode("retail");
        alert(isAU
          ? `✅ Connected to "${wholesaleName}"!\nYou can now place orders using the order button.`
          : `✅「${wholesaleName}」と接続しました！\n発注ボタンから注文できます。`);
      } catch (e) {
        if (e?.code === "functions/already-exists") {
          alert(isAU ? "You're already connected to this supplier" : "すでにこの卸と接続済みです");
          return;
        }
        console.error(e);
        alert(e?.message || e);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  // ===== suppliers snapshot =====
  useEffect(() => {
    if (!tenantId) {
      setSuppliers([]);
      return () => { };
    }

    const qref = query(collection(db, "suppliers"), where("tenantId", "==", tenantId));

    const unsub = onSnapshot(
      qref,
      (snap) => {
        const list = snap.docs.map((d) => {
          const x = d.data() || {};
          const logicalId = String(x.supplierId || "").trim() || d.id; // ✅ 論理IDが無ければ docId を採用
          return {
            ...x,
            id: logicalId,  // ✅ 画面・選択用
            supplierId: logicalId,
            _docId: d.id,   // ✅ Firestore更新・削除用
          };
        }).filter(x => !x.isShop); // 小売店（isShop:true）は除外

        list.sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "ja"));
        setSuppliers(list);
      },
      (err) => {
        console.error("[suppliers snapshot error]", err);
        alert(err.message);
      }
    );

    return () => unsub();
  }, [tenantId]);

  // ===== shops snapshot（卸モード用取引先） =====
  useEffect(() => {
    if (!tenantId) { setShops([]); return () => {}; }

    // suppliers コレクションから手動追加＋QR接続済み店舗を取得
    const qref = query(collection(db, "suppliers"), where("tenantId", "==", tenantId));
    const unsub = onSnapshot(qref, async (snap) => {
      const allSupDocs = snap.docs.map(d => ({ ...d.data(), id: d.id, _docId: d.id }));
      console.log("[shops DEBUG] suppliersコレクション全件:", allSupDocs.map(d => ({ id: d.id, isShop: d.isShop, retailTenantId: d.retailTenantId, wholesaleTenantId: d.wholesaleTenantId, supplierId: d.supplierId, tenantId: d.tenantId })));
      const fromSuppliers = allSupDocs
        .filter(d => d.isShop === true || d.isShop === "true" || !!d.retailTenantId || (d.isShop !== false && !d.wholesaleTenantId && !d.supplierId));
      console.log("[shops DEBUG] fromSuppliersフィルタ後:", fromSuppliers.map(d => ({ id: d.id, name: d.name })));

      // tenants コレクションから接続済み小売を取得（shop__ ドキュメントのtenantIdが欠損の救済）
      let fromTenants = [];
      try {
        const tsnap = await getDocs(
          query(collection(db, "tenants"), where("wholesaleTenantId", "==", tenantId))
        );
        console.log("[shops DEBUG] 自tenantId:", tenantId);
        console.log("[shops DEBUG] tenants接続済み件数:", tsnap.docs.length, tsnap.docs.map(d => ({ id: d.id, name: d.data().retailName || d.data().name })));
        console.log("[shops DEBUG] suppliers既存:", fromSuppliers.map(s => ({ id: s.id, retailTenantId: s.retailTenantId })));
        const seen = new Set(fromSuppliers.map(s => s.retailTenantId).filter(Boolean));
        const seenDocIds = new Set(fromSuppliers.map(s => s._docId || s.id).filter(Boolean));
        // tenantsの最新データでfromSuppliersの名前を常に上書き（小売が自社情報を更新しても反映）
        for (const td of tsnap.docs) {
          const info = td.data();
          const latestName = info.retailName || info.name || "";
          const latestCompany = info.retailCompany || "";
          const expectedDocId = `shop__${tenantId}__${td.id}`;
          if (seen.has(td.id) || seenDocIds.has(expectedDocId)) {
            // すでにsuppliersにある → tenantsの最新の店舗名で常に上書き
            const existing = fromSuppliers.find(s => s.retailTenantId === td.id || s._docId === expectedDocId);
            if (existing && latestName && !latestName.includes("@")) {
              existing.name = latestName;
              existing.company = latestCompany || existing.company || "";
            }
            continue;
          }
          fromTenants.push({
            id: expectedDocId,
            _docId: expectedDocId,
            tenantId,
            retailTenantId: td.id,
            name: latestName || info.email || (isAU ? "Not set" : "（未設定）"),
            company: latestCompany,
            address: info.retailAddress || info.address || "",
            tel: info.retailTel || info.tel || "",
            fax: info.retailFax || info.fax || "",
            email: info.email || "",
            isShop: true,
            autoRegistered: true,
          });
        }
      } catch(e) { console.warn("[shops tenants fallback]", e.message); }

      const merged = [...fromSuppliers, ...fromTenants];
      merged.sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "ja"));
      console.log("[shops] 件数:", merged.length, merged.map(d => ({ id: d.id, name: d.name, src: d.autoRegistered ? "QR" : "manual" })));
      setShops(merged);
    }, err => { console.error("[shops error]", err); showToast(isAU ? "Failed to load customers" : "取引先の読み込みに失敗しました"); });

    return () => { unsub(); };
  }, [tenantId]);


  // ===== 卸モード：接続済み小売テナントの shop__ ドキュメントを自動補完 =====
  useEffect(() => {
    if (mode !== "wholesale" || !tenantId) return;
    (async () => {
      try {
        // shop__ドキュメントの補完・修復はrepairShopRecords Callableがサーバー側で一括実行する。
        // （クロステナント書き込みになるため、新Rulesではクライアントから実行できない）
        // Callable側はレート制限（5回/分）付きのため、失敗しても警告に留める。
        const repairShopRecordsFn = httpsCallable(functions, "repairShopRecords");
        const result = await repairShopRecordsFn({});
        const repaired = result?.data?.repairedCount || 0;
        if (repaired > 0) console.log("[shop__] 補完/修復:", repaired, "件");
      } catch (e) {
        console.error("[shop__ auto-fill error]", e);
      }
    })();
  }, [mode, tenantId, shops.length]);

  // 卸カタログ検索デバウンス（400ms）：Firestore クエリをキーストローク毎に発火しない
  useEffect(() => {
    // 卸商品マスタ画面では wholesaleMasterSearch
    // 小売発注画面（retailView==="order"）では searchText（発注検索をFirestoreに連動）
    // それ以外では catalogSearch
    const src = (mode === "wholesale" && wholesaleView === "products")
      ? wholesaleMasterSearch
      : (mode === "wholesale" && wholesaleView !== "products")
        ? (/^\d{8,14}$/.test((manualSearch || "").trim()) ? manualSearch.trim() : "")
        : (mode === "retail" && retailView === "order")
          ? searchText
          : catalogSearch;
    const t = setTimeout(() => {
      setCatalogLoading(true);
      setDebouncedWholesaleSearch(src);
    }, 400);
    return () => clearTimeout(t);
  }, [catalogSearch, wholesaleMasterSearch, searchText, manualSearch, mode, wholesaleView, retailView]);

  // ===== 手書き入力 商品マスタ prefetch（全件キャッシュ方式・部分一致検索）=====
  // 「手書き入力」画面を開いた時点（wholesaleView==="manual"に遷移した瞬間）で
  // テナント商品全件を即座に取得開始する。検索文字入力をトリガーにFirestore通信は
  // 一切行わない——検索は常にこのprefetch済みキャッシュに対するローカルfilterのみ。
  //
  // キャッシュはtenantIdをキーとしたMapで保持するため、テナント切替時に別テナントの
  // 商品が混入することはない（1テナント=1エントリ、他テナントのキーを参照しない）。
  // 同一テナント・同一セッション中は、画面を閉じて再度開いてもMapに残っているため
  // 再取得しない。
  //
  // 同一テナントへの同時フェッチは1本のみ保証する：進行中のPromiseを
  // manualProductsFetchInFlight に保持し、後続の呼び出しはそのPromiseを共有する
  // （高速タイピング・再レンダリングで複数の全件取得が並行発火することを防ぐ）。
  // tenantId変更をuseEffectの実行順序に依存せず同期的に検知するためのref。
  // 「テナント切替リセット用の別useEffect（[tenantId]依存）が世代をインクリメント
  // するより先に、このprefetch useEffectが古い世代のまま新テナントのフェッチを
  // 開始してしまう」という競合（Codexレビューで指摘）を防ぐため、fetchManualProducts
  // ForTenant自体の呼び出し直前に、レンダー中の同期処理としてtenantId変更を検知し
  // 世代を進める。これによりeffectの宣言順序に一切依存しない
  const manualProductsLastSeenTenantIdRef = useRef(undefined);
  const bumpManualProductsGenerationIfTenantChanged = (currentTenantId) => {
    if (manualProductsLastSeenTenantIdRef.current !== currentTenantId) {
      manualProductsLastSeenTenantIdRef.current = currentTenantId;
      manualProductsGenerationRef.current++;
      manualProductsCache.current.clear();
      manualProductsFetchInFlight.current.clear();
    }
  };

  const fetchManualProductsForTenant = useCallback((targetTenantId) => {
    if (!targetTenantId) return Promise.resolve([]);
    bumpManualProductsGenerationIfTenantChanged(targetTenantId);
    const cached = manualProductsCache.current.get(targetTenantId);
    if (cached) return Promise.resolve(cached);

    const inFlight = manualProductsFetchInFlight.current.get(targetTenantId);
    if (inFlight) return inFlight;

    // 発行時点の世代を記録する。テナント切替（manualProductsGenerationRef.current++）が
    // 発生した後にこのリクエストが解決しても、世代が一致しない限りキャッシュ・
    // in-flight登録への書き込みを行わない——A→B→Aと素早く切り替えた場合に、
    // Aの古いリクエストがBへの切替後もキャッシュ・in-flightを汚染することを防ぐ
    const generation = manualProductsGenerationRef.current;
    const promise = (async () => {
      const snap = await getDocs(query(collection(db, "products"), where("tenantId", "==", targetTenantId)));
      const all = snap.docs.map(d => ({ ...d.data(), id: d.id, _docId: d.id }));
      if (generation === manualProductsGenerationRef.current) {
        manualProductsCache.current.set(targetTenantId, all);
      }
      return all;
    })().finally(() => {
      // 同じ世代・同じPromiseがまだin-flight登録されている場合のみ消す
      if (generation === manualProductsGenerationRef.current
        && manualProductsFetchInFlight.current.get(targetTenantId) === promise) {
        manualProductsFetchInFlight.current.delete(targetTenantId);
      }
    });
    // finally()が返す派生Promiseは元のPromiseの拒否を引き継ぐため、in-flightには
    // 素のpromiseではなくfinally適用後のものを登録する（呼び出し元は既にcatchしている
    // ため二重ハンドリングにはならない。派生Promiseを未処理のまま放置しない）
    manualProductsFetchInFlight.current.set(targetTenantId, promise);
    return promise;
  }, [db]);

  useEffect(() => {
    if (mode !== "wholesale" || wholesaleView !== "manual") {
      // 画面が非アクティブになるたびセッショントークンを進める。これにより、
      // アクティブだった間に発行された再試行ボタンの非同期処理結果が、画面を
      // 離れた後（同一テナント内でのmode/wholesaleView変更を含む）に解決しても
      // 現在の状態を上書きしなくなる
      manualProductsSessionTokenRef.current++;
      setManualFsResults([]);
      setManualProductsState("idle");
      return;
    }
    if (!tenantId) { setManualFsResults([]); setManualProductsState("idle"); return; }

    if (manualProductsCache.current.has(tenantId)) {
      setManualProductsState("ready");
      return;
    }

    let cancelled = false;
    setManualProductsState("loading");
    fetchManualProductsForTenant(tenantId)
      .then(() => {
        if (cancelled) return;
        // 取得完了時点でまだ同じテナント・同じ画面にいる場合のみ状態を反映する
        // （古いテナント向けのレスポンスが新しいテナント画面のstateを上書きしないように）
        setManualProductsState("ready");
      })
      .catch((e) => {
        console.error("[manualProducts prefetch error]", e);
        if (!cancelled) setManualProductsState("error");
      });
    return () => { cancelled = true; };
  }, [mode, wholesaleView, tenantId, fetchManualProductsForTenant]);

  useEffect(() => {
    if (mode !== "wholesale" || wholesaleView !== "manual") { setManualFsResults([]); return; }
    if (manualProductsState !== "ready") { setManualFsResults([]); return; }
    const raw = (manualSearch || "").trim();
    if (!raw) { setManualFsResults([]); setManualFsLoading(false); return; }

    const allProducts = manualProductsCache.current.get(tenantId) || [];
    setManualFsLoading(true);
    // テキスト・バーコード共にprefetch済みキャッシュから部分一致（Firestore通信なし）
    const norm = (s) => String(s || "").replace(/[ァ-ヶ]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x60)).toLowerCase();
    const q = norm(raw);
    let results = allProducts.filter(p =>
      norm(p.name).includes(q) ||
      norm(p.ruby || "").includes(q) ||
      String(p.barcode || "").includes(raw)
    );
    if (manualCategory) results = results.filter(p => p.category === manualCategory);
    setManualFsResults(results);
    setManualFsLoading(false);
  }, [manualSearch, manualCategory, mode, wholesaleView, tenantId, manualProductsState]);

  // ===== 卸カタログ ページ取得ヘルパー（カーソルページネーション、30,000件対応）=====
  // name昇順 + documentId昇順の複合カーソルで安定ページングする。同名商品が複数
  // 存在してもname単独カーソルでは欠落・重複が起こりうるため、documentIdを
  // タイブレーカーとして必須にする。1ページ = WHOLESALE_CATALOG_PAGE_SIZE件。
  // 呼び出し元がworldesaleTenantId・cursorGeneration・startAfterDocを渡し、
  // このヘルパー自体は「現在の世代と一致する場合のみstateへ反映」というガードを
  // 呼び出し元で行う前提のread-onlyな取得関数として実装する
  const fetchWholesaleCatalogPage = useCallback(async (wholesaleTenantId, afterDoc) => {
    let qref = query(
      collection(db, "products"),
      where("tenantId", "==", wholesaleTenantId),
      orderBy("name", "asc"),
      orderBy(documentId(), "asc"),
      limit(WHOLESALE_CATALOG_PAGE_SIZE)
    );
    if (afterDoc) {
      qref = query(qref, startAfter(afterDoc.data().name, afterDoc.id));
    }
    const snap = await getDocs(qref);
    return snap;
  }, [db]);

  // 仕入先（対象卸テナント）切替を検知し、ページネーション状態を同期的にリセットする。
  // useEffectの実行順序に依存しないよう、呼び出し直前に判定する
  // （手書き入力のfetchManualProductsForTenantと同じ設計パターン）
  // forceは「テナントは変わっていないが、明示的に1ページ目からやり直したい」場合
  // （検索クリア・再試行ボタン）に使う。これがないと、テナント変更検知だけに頼った
  // リセットでは同一テナント内の再実行時にseenIds/cursorがクリアされず、既取得分が
  // 「dedupe」扱いで除外されて1ページ目が消える不具合になる
  const resetWholesaleCatalogIfTenantChanged = (currentWholesaleTenantId, force) => {
    if (force || wholesaleCatalogLastSeenWholesaleTenantIdRef.current !== currentWholesaleTenantId) {
      wholesaleCatalogLastSeenWholesaleTenantIdRef.current = currentWholesaleTenantId;
      wholesaleCatalogGenerationRef.current++;
      wholesaleCatalogCursorRef.current = null;
      wholesaleCatalogSeenIdsRef.current = new Set();
      wholesaleCatalogInFlightGenerationRef.current = null;
      setWholesaleCatalogProducts([]);
      setWholesaleCatalogHasMore(false);
      setWholesaleCatalogError(false);
    }
  };

  // 次ページ取得（初回ページ取得もこれで行う。afterDoc省略時は1ページ目）。
  // 同一世代内での二重リクエストを防ぐため、進行中は無視する。
  // forceReset=true は「検索クリア」「再試行ボタン」など、同一テナントのまま
  // 明示的に1ページ目からやり直したい呼び出しであることを示す
  const loadWholesaleCatalogPage = useCallback(async (wholesaleTenantId, { isFirstPage, forceReset } = {}) => {
    if (!wholesaleTenantId) return;
    resetWholesaleCatalogIfTenantChanged(wholesaleTenantId, isFirstPage && forceReset);
    // 世代に紐付いたin-flightロック：同一世代で既にリクエストが進行中なら二重発行しない。
    // テナント切替（世代インクリメント）が起きると自動的に別世代扱いになるため、
    // 旧世代のfinallyが新世代のロックを誤って解除することはない
    const generation = wholesaleCatalogGenerationRef.current;
    if (wholesaleCatalogInFlightGenerationRef.current === generation) return; // 二重リクエスト禁止
    if (!isFirstPage && !wholesaleCatalogCursorRef.current && wholesaleCatalogSeenIdsRef.current.size > 0) {
      // 1ページ目が既に読み込まれた後、hasMore=falseの状態でさらに呼ばれた場合は何もしない
      return;
    }

    wholesaleCatalogInFlightGenerationRef.current = generation;
    if (isFirstPage) {
      setWholesaleCatalogLoading(true);
      setWholesaleCatalogError(false);
    } else {
      setWholesaleCatalogLoadingMore(true);
    }

    try {
      const snap = await fetchWholesaleCatalogPage(wholesaleTenantId, isFirstPage ? null : wholesaleCatalogCursorRef.current);
      if (generation !== wholesaleCatalogGenerationRef.current) return; // 古い世代の結果は無視
      const newDocs = snap.docs
        .filter((d) => !wholesaleCatalogSeenIdsRef.current.has(d.id)) // dedupe
        .map((d) => ({ ...d.data(), id: d.id, _docId: d.id }));
      newDocs.forEach((p) => wholesaleCatalogSeenIdsRef.current.add(p.id));
      wholesaleCatalogCursorRef.current = snap.docs.length > 0 ? snap.docs[snap.docs.length - 1] : wholesaleCatalogCursorRef.current;
      const hasMore = snap.docs.length === WHOLESALE_CATALOG_PAGE_SIZE;
      setWholesaleCatalogHasMore(hasMore);
      setWholesaleCatalogProducts((prev) => (isFirstPage ? newDocs : [...prev, ...newDocs]));
    } catch (e) {
      console.error("[wholesaleCatalog page fetch error]", e);
      if (generation === wholesaleCatalogGenerationRef.current) {
        setWholesaleCatalogError(true);
      }
    } finally {
      if (wholesaleCatalogInFlightGenerationRef.current === generation) {
        wholesaleCatalogInFlightGenerationRef.current = null;
      }
      if (generation === wholesaleCatalogGenerationRef.current) {
        if (isFirstPage) {
          setWholesaleCatalogLoading(false);
          // 通常ブラウジング（バーコード検索でない）経路では、この1ページ目取得の
          // 完了がcatalogLoadingの解除も兼ねる。catalogLoadingはqA/バーコード検索
          // 側のハンドラでのみ解除されており、通常ページネーションはこれを解除する
          // 経路を持たず、検索ドロップダウンが「検索中...」のまま固まる不具合があった
          setCatalogLoading(false);
        } else {
          setWholesaleCatalogLoadingMore(false);
        }
      }
    }
  }, [fetchWholesaleCatalogPage]);

  // 2026-08 商品検索不具合修正：nameNormalizedフィールドを持たない（＝この修正より
  // 前に登録された）商品、またはnameと不一致になっているnameNormalized/searchTokensを
  // 持つ商品を検出し、バックグラウンドでupdateDocにより自動補完する。通常一覧・検索で
  // 商品が実際に読み込まれたタイミングでの遅延バックフィルのため、一度も読み込まれて
  // いない商品（本番12,163件規模のテナントでは大半）はこれだけでは直らない——
  // その救済として下のrunProductSearchFieldsBackfill（画面のボタンからユーザー自身が
  // 実行する全ページ一括修復）を別途用意している。書き込みはnameNormalized/
  // searchTokensフィールドのみの部分更新（他フィールドへは一切影響しない）
  const wholesaleMasterBackfilledIdsRef = useRef(new Set());
  const productSearchFieldsMatch = (p) => {
    const expectedNameNormalized = normalizeKana(p.name || "");
    const expectedTokens = buildProductSearchTokens(p.name || "");
    const currentTokens = Array.isArray(p.searchTokens) ? p.searchTokens : [];
    const tokensMatch =
      currentTokens.length === expectedTokens.length &&
      [...currentTokens].sort().join(String.fromCharCode(1)) === [...expectedTokens].sort().join(String.fromCharCode(1));
    return { matches: p.nameNormalized === expectedNameNormalized && tokensMatch, expectedNameNormalized, expectedTokens };
  };
  const backfillNameNormalizedIfNeeded = useCallback((docs) => {
    (docs || []).forEach((p) => {
      const id = p._docId || p.id;
      if (!id || wholesaleMasterBackfilledIdsRef.current.has(id)) return;
      const { matches, expectedNameNormalized, expectedTokens } = productSearchFieldsMatch(p);
      if (matches) return;
      wholesaleMasterBackfilledIdsRef.current.add(id);
      updateDoc(doc(db, "products", id), {
        nameNormalized: expectedNameNormalized,
        searchTokens: expectedTokens,
      }).catch((e) => {
        console.error("[nameNormalized/searchTokens backfill error]", id, e);
        wholesaleMasterBackfilledIdsRef.current.delete(id);
      });
    });
  }, [db]);

  // 2026-08 商品検索不具合修正（Codexレビュー指摘対応・MUST-FIX）：本番12,163件規模の
  // 既存商品は、通常一覧・検索の遅延バックフィルだけでは「一度も読み込まれるまで
  // 永久に検索不可」のままになる。本番productsコレクションへの書き込みはユーザーの
  // 明示操作なしに自動実行しない方針のため、商品マスタ画面に「検索用データを一括修復」
  // ボタンを用意し、ユーザー自身の操作で自テナントの全商品ページを確実に走査する。
  // Firestoreセキュリティルール上、自テナント商品への部分更新はクライアントから
  // 既に許可されている（tenantId一致・taxRate維持が条件）。進捗はUIに表示し、
  // 途中経過も画面に反映されるようページ単位でstateを更新する
  const [searchBackfillState, setSearchBackfillState] = useState({ running: false, done: 0, total: null, fixed: 0, failed: 0, error: null });
  const searchBackfillCancelRef = useRef(false);
  // 2026-08 商品検索不具合修正（Codexレビュー指摘対応・2ラウンド目MUST-FIX）：
  // 以前はwriteBatchで最大500件をまとめてcommitしていたため、そのページ内に
  // taxRateが欠損・不正な商品が1件でも含まれていると、Firestoreセキュリティルール
  // hasValidTaxRate（firestore.rules）がバッチ全体を拒否し、正常な商品を含む
  // そのページ全体の修復が失敗、以降のページも走査されなくなっていた
  // （「自テナントの全商品を確実に走査する」という要件を満たせなかった）。
  // batchをやめ、1商品ずつ独立したupdateDocをPromise.allSettledで並行実行する
  // ことで、taxRate不正な商品はその1件だけ失敗として記録し、他の商品の修復は
  // 継続できるようにする。
  // また、runningの二重起動防止をReact stateだけに頼るとstateの反映タイミング次第で
  // すり抜けうるため、useRefによる同期ガード（searchBackfillRunningRef）を追加した。
  // searchBackfillCancelRef自体は既存のまま維持するが、これをtrueにするUI
  // （中断ボタン）は用意していないため、現状は「実行完了まで中断できない」仕様
  const searchBackfillRunningRef = useRef(false);
  const runProductSearchFieldsBackfill = useCallback(async () => {
    if (!tenantId || searchBackfillRunningRef.current) return;
    searchBackfillRunningRef.current = true;
    searchBackfillCancelRef.current = false;
    setSearchBackfillState({ running: true, done: 0, total: null, fixed: 0, failed: 0, error: null });
    const PAGE_SIZE = 500;
    let cursorDoc = null;
    let done = 0;
    let fixed = 0;
    let failed = 0;
    try {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        if (searchBackfillCancelRef.current) break;
        let qref = query(
          collection(db, "products"),
          where("tenantId", "==", tenantId),
          orderBy(documentId(), "asc"),
          limit(PAGE_SIZE)
        );
        if (cursorDoc) qref = query(qref, startAfter(cursorDoc));
        const snap = await getDocs(qref);
        if (snap.empty) break;
        const targets = snap.docs
          .map((d) => {
            const p = { ...d.data(), id: d.id, _docId: d.id };
            const { matches, expectedNameNormalized, expectedTokens } = productSearchFieldsMatch(p);
            return matches ? null : { ref: d.ref, id: d.id, expectedNameNormalized, expectedTokens };
          })
          .filter(Boolean);
        if (targets.length > 0) {
          const results = await Promise.allSettled(
            targets.map((t) => updateDoc(t.ref, { nameNormalized: t.expectedNameNormalized, searchTokens: t.expectedTokens }))
          );
          results.forEach((r, i) => {
            if (r.status === "fulfilled") {
              fixed++;
            } else {
              failed++;
              console.error("[runProductSearchFieldsBackfill item error]", targets[i].id, r.reason);
            }
          });
        }
        done += snap.docs.length;
        setSearchBackfillState({ running: true, done, total: null, fixed, failed, error: null });
        cursorDoc = snap.docs[snap.docs.length - 1];
        if (snap.docs.length < PAGE_SIZE) break;
      }
      setSearchBackfillState({ running: false, done, total: done, fixed, failed, error: null });
      if (searchBackfillCancelRef.current) {
        showToast(isAU ? `Bulk repair cancelled (${fixed} fixed so far)` : `一括修復を中断しました（${fixed}件修復済み）`);
      } else if (failed > 0) {
        showToast(isAU
          ? `Bulk repair of search data complete (${done} checked, ${fixed} fixed, ${failed} failed). Please review the failed products' settings and retry.`
          : `検索用データの一括修復が完了しました（${done}件確認、${fixed}件修復、${failed}件失敗）。失敗分は商品ごとの設定をご確認のうえ再実行してください`);
      } else {
        showToast(isAU
          ? `Bulk repair of search data complete (${done} checked, ${fixed} fixed)`
          : `検索用データの一括修復が完了しました（${done}件確認、${fixed}件修復）`);
      }
    } catch (e) {
      console.error("[runProductSearchFieldsBackfill error]", e);
      setSearchBackfillState({ running: false, done, total: null, fixed, failed, error: e?.message || String(e) });
      showToast(isAU ? "An error occurred during bulk repair. Please try again." : "一括修復中にエラーが発生しました。再度お試しください");
    } finally {
      searchBackfillRunningRef.current = false;
    }
  }, [tenantId, db]);

  // ═══════════════════════════════════════════════════════════════════════
  // 卸：商品マスタ画面（wholesaleView==="products"）のカーソルページネーション
  // （2026-08 パフォーマンス改善）
  // ═══════════════════════════════════════════════════════════════════════
  // 旧設計：tenantId一致の全商品をlimitなしonSnapshotで常時購読。本番12,163件で
  // 初期取得に約6.9秒。検索語確定のたびに同一クエリでもリスナーが解除・再購読され、
  // 30,000件規模では現実的でなかった。
  // 新設計：オンライン発注側のカーソルページネーション（fetchWholesaleCatalogPage等）
  // と同一パターンで、通常一覧を500件/ページに制限する。ただし商品マスタは編集・削除・
  // CSV一括登録を伴う管理画面のため、現在表示中のページだけをonSnapshotでリアルタイム
  // 購読し（編集・削除が即座に反映される）、複数ページに恒久的なリスナーを張り続ける
  // ことはしない。ページを跨ぐ・検索する・再取得する際は都度リスナーを張り替える。
  const fetchWholesaleMasterPage = useCallback((afterDoc, onData, onError) => {
    let qref = query(
      collection(db, "products"),
      where("tenantId", "==", tenantId),
      orderBy("name", "asc"),
      orderBy(documentId(), "asc"),
      limit(WHOLESALE_MASTER_PAGE_SIZE)
    );
    if (afterDoc) {
      qref = query(qref, startAfter(afterDoc.name, afterDoc.docId));
    }
    return onSnapshot(qref, onData, onError);
  }, [db, tenantId]);

  const resetWholesaleMasterIfTenantChanged = (currentTenantId, force) => {
    if (force || wholesaleMasterLastSeenTenantIdRef.current !== currentTenantId) {
      wholesaleMasterLastSeenTenantIdRef.current = currentTenantId;
      wholesaleMasterGenerationRef.current++;
      wholesaleMasterCursorRef.current = null;
      wholesaleMasterSeenIdsRef.current = new Set();
      wholesaleMasterInFlightGenerationRef.current = null;
      wholesaleMasterPagesRef.current = [];
      wholesaleMasterCurrentPageIndexRef.current = 0;
      setWholesaleMasterProducts([]);
      setWholesaleMasterHasMore(false);
      setWholesaleMasterError(false);
    }
  };

  // 現在ページのonSnapshot購読解除用。ページを跨ぐ・再取得するたびに前のページの
  // リスナーを必ず解除してから次を張る（複数ページへの恒久的リスナーの蓄積を防ぐ）
  const wholesaleMasterUnsubRef = useRef(null);

  const loadWholesaleMasterPage = useCallback(({ isFirstPage, forceReset } = {}) => {
    if (!tenantId) return;
    resetWholesaleMasterIfTenantChanged(tenantId, isFirstPage && forceReset);
    const generation = wholesaleMasterGenerationRef.current;
    if (wholesaleMasterInFlightGenerationRef.current === generation) return; // 二重リクエスト禁止
    if (!isFirstPage && !wholesaleMasterCursorRef.current && wholesaleMasterSeenIdsRef.current.size > 0) {
      return; // 1ページ目読み込み後、hasMore=falseの状態でさらに呼ばれた場合は何もしない
    }

    // 前ページのリスナーを解除してから新しいページを購読する
    if (wholesaleMasterUnsubRef.current) {
      wholesaleMasterUnsubRef.current();
      wholesaleMasterUnsubRef.current = null;
    }

    wholesaleMasterInFlightGenerationRef.current = generation;
    if (isFirstPage) {
      setWholesaleMasterLoading(true);
      setWholesaleMasterError(false);
      wholesaleMasterCurrentPageIndexRef.current = 0;
    } else {
      setWholesaleMasterLoadingMore(true);
      wholesaleMasterCurrentPageIndexRef.current = wholesaleMasterPagesRef.current.length;
    }
    const pageIndex = wholesaleMasterCurrentPageIndexRef.current;

    const afterDoc = isFirstPage ? null : wholesaleMasterCursorRef.current;
    const unsub = fetchWholesaleMasterPage(
      afterDoc,
      (snap) => {
        if (generation !== wholesaleMasterGenerationRef.current) return; // 古い世代の結果は無視
        // このページの配列を丸ごと置き換える——append-onlyのdedupeフィルタでは
        // 既に到達済みのdocumentへの更新・削除・並び替えが一覧に反映されないため、
        // 現在購読中ページの中身は毎回スナップショットの内容で完全に上書きする。
        // 過去ページ（このリスナーの対象外）はそのまま保持される
        const pageDocs = snap.docs.map((d) => ({ ...d.data(), id: d.id, _docId: d.id }));
        backfillNameNormalizedIfNeeded(pageDocs);
        wholesaleMasterPagesRef.current[pageIndex] = pageDocs;
        // 末尾より後のページ（このページ再取得前に存在した古いページ）は破棄する
        wholesaleMasterPagesRef.current.length = pageIndex + 1;
        wholesaleMasterSeenIdsRef.current = new Set(
          wholesaleMasterPagesRef.current.flat().map((p) => p.id)
        );
        if (snap.docs.length > 0) {
          const last = snap.docs[snap.docs.length - 1];
          wholesaleMasterCursorRef.current = { name: last.data().name, docId: last.id };
        }
        const hasMore = snap.docs.length === WHOLESALE_MASTER_PAGE_SIZE;
        setWholesaleMasterHasMore(hasMore);
        setWholesaleMasterProducts(wholesaleMasterPagesRef.current.flat());
        wholesaleMasterFailedOnLoadMoreRef.current = false;
        // もっと見る成功後もエラーフラグが残っていると、エラーバナーが
        // 「追加取得に失敗しました」から「一覧取得に失敗しました」に化けたまま
        // 表示され続け、次に押した再試行が誤って forceReset:true の全体再取得に
        // なってしまう（既存データを不要に破棄する）——成功時は必ずクリアする
        setWholesaleMasterError(false);
        if (wholesaleMasterInFlightGenerationRef.current === generation) {
          wholesaleMasterInFlightGenerationRef.current = null;
        }
        if (generation === wholesaleMasterGenerationRef.current) {
          if (isFirstPage) setWholesaleMasterLoading(false);
          else setWholesaleMasterLoadingMore(false);
        }
      },
      (err) => {
        console.error("[wholesaleMaster page fetch error]", err);
        if (wholesaleMasterInFlightGenerationRef.current === generation) {
          wholesaleMasterInFlightGenerationRef.current = null;
        }
        if (generation === wholesaleMasterGenerationRef.current) {
          // もっと見る失敗時は既存ページを破棄しない（forceResetしない）——
          // 失敗した新ページはまだ wholesaleMasterPagesRef に書き込まれていないため、
          // 既存の表示済みページはこの時点でそのまま残っている
          wholesaleMasterFailedOnLoadMoreRef.current = !isFirstPage;
          setWholesaleMasterError(true);
          if (isFirstPage) setWholesaleMasterLoading(false);
          else setWholesaleMasterLoadingMore(false);
        }
      }
    );
    wholesaleMasterUnsubRef.current = unsub;
  }, [tenantId, fetchWholesaleMasterPage, backfillNameNormalizedIfNeeded]);

  // ===== 卸：商品マスタ 商品名 前方一致検索（Firestore側、全テナント商品が対象） =====
  // 読み込み済み500件だけを検索するのではなく、nameNormalized フィールドに対する
  // Firestore側の前方一致クエリ（startAt/endAt）でテナント全商品を対象にする。
  // (tenantId ASC, nameNormalized ASC) インデックスを使用する。
  //
  // 2026-08 本番不具合修正：以前は生の name フィールドへの前方一致のみで、
  // normalizeKana（大文字/小文字・全角/半角・かな統一・空白正規化）を一切
  // 通していなかった。このため商品名が画面表示上「サンキスト　ピーチブレンド1」の
  // ように見えていても、検索語との間に半角/全角・大文字/小文字等の差異が
  // あるだけで前方一致すら成立せず「一致する商品はありません」になっていた。
  // 保存時（saveProductFromModal・CSV取込・サンプル投入）に name と同時に
  // nameNormalized = normalizeKana(name) を保存し、検索時も同じ normalizeKana を
  // キーワードに適用することで、表示に使う name とは独立した正規化済みフィールド同士を
  // 比較する。中間一致（例："ピーチ"）は前方一致の性質上ヒットしない仕様のまま。
  //
  // 2026-08 本番回帰修正：endAtの上限文字にはU+10FFFF（Unicodeが定義する最大のコード
  // ポイント）を使用する。以前はU+F8FF（Unicode私用領域の一部）を使っていたが、これは
  // 全角英数字・全角記号（U+FF01-FF5E）や半角カナ（U+FF61-FF9F）より小さいコード
  // ポイントのため、検索prefixの直後にこれらの文字が続く商品名（例："クッキー＆クリーム
  // のサンダー"の"＆"、"コカ・コーラライフ５００ＰＥＴ"の"５"）が、prefixそのものを
  // 入力し終えた瞬間に検索範囲の上限を超えて結果から消える回帰があった（本番実測で全
  // 商品の約74%が該当）。U+10FFFFはUnicode全体の最大値であり、絵文字等サロゲートペアを
  // 要する文字を含む商品名が将来登録された場合でも同様の問題が起きないようにする
  const WHOLESALE_MASTER_SEARCH_PREFIX_CEILING = String.fromCodePoint(0x10FFFF);
  const WHOLESALE_MASTER_SEARCH_PAGE_SIZE = 500;
  const fetchWholesaleMasterSearchPage = useCallback(async (keyword, afterDoc) => {
    const normKeyword = normalizeKana(keyword);
    const qref = afterDoc
      ? query(
          collection(db, "products"),
          where("tenantId", "==", tenantId),
          orderBy("nameNormalized", "asc"),
          orderBy(documentId(), "asc"),
          startAfter(afterDoc.nameNormalized, afterDoc.docId),
          endAt(normKeyword + WHOLESALE_MASTER_SEARCH_PREFIX_CEILING),
          limit(WHOLESALE_MASTER_SEARCH_PAGE_SIZE)
        )
      : query(
          collection(db, "products"),
          where("tenantId", "==", tenantId),
          orderBy("nameNormalized", "asc"),
          orderBy(documentId(), "asc"),
          startAt(normKeyword),
          endAt(normKeyword + WHOLESALE_MASTER_SEARCH_PREFIX_CEILING),
          limit(WHOLESALE_MASTER_SEARCH_PAGE_SIZE)
        );
    return getDocs(qref);
  }, [db, tenantId]);

  // 2026-08 商品検索不具合修正：「ピーチ」のような、商品名の2語目以降の一部分だけの
  // 中間一致に対応するための補助クエリ。前方一致（fetchWholesaleMasterSearchPage）だけでは
  // ヒットしないため、searchTokens（buildProductSearchTokensで生成した単語プレフィックス配列）
  // に対するarray-containsで検索する。前方一致クエリが1件以上ヒットした場合は追加のFirestore
  // readコストを発生させないよう、呼び出し側は前方一致が0件だった場合にのみこれを呼ぶ
  const fetchWholesaleMasterSearchTokenPage = useCallback(async (keyword) => {
    const normKeyword = normalizeKana(keyword).trim();
    if (!normKeyword) return { docs: [] };
    const qref = query(
      collection(db, "products"),
      where("tenantId", "==", tenantId),
      where("searchTokens", "array-contains", normKeyword),
      limit(WHOLESALE_MASTER_SEARCH_PAGE_SIZE)
    );
    return getDocs(qref);
  }, [db, tenantId]);

  const loadWholesaleMasterSearchPage = useCallback(async (keyword, { isFirstPage } = {}) => {
    if (!tenantId || !keyword) return;
    // キーワードだけでなくtenantIdもキーに含める——同一キーワードのままテナントを
    // 切り替えた場合でも必ず新しい世代とみなし、旧テナントの遅延レスポンスが
    // 新テナントのstateを汚染しないようにする（テナント分離のクライアント側保証）
    const searchIdentityKey = `${tenantId}::${keyword}`;
    // isFirstPage:true は「1ページ目を最初から取得し直す」という要求そのものなので、
    // 同一キーワード・同一テナントへの再入場（identityKeyが変化しない場合）でも
    // 世代を必ずインクリメントし、dedupe用のseenIds・カーソルをリセットする。
    // identityKeyの変化だけで世代インクリメントを判定すると、「同一identityの
    // 前回リクエストがまだ在飛行中に再度isFirstPage:trueで呼ばれるケース」
    // （画面を離れてすぐ同じキーワードで再入場、等）で世代が変わらず、新旧2つの
    // リクエストが同じ世代・同じ空のseenIdsを共有してしまい、どちらか片方が
    // 相手の結果でdedupeされて0件になる競合が発生する。isFirstPage:trueは
    // 常に「新しいセッションの開始」を意味するため、無条件に世代を進める
    wholesaleMasterSearchLastKeywordRef.current = searchIdentityKey;
    if (isFirstPage) {
      wholesaleMasterSearchGenerationRef.current++;
      wholesaleMasterSearchCursorRef.current = null;
      wholesaleMasterSearchSeenIdsRef.current = new Set();
      wholesaleMasterSearchInFlightGenerationRef.current = null;
      setWholesaleMasterSearchResults([]);
      setWholesaleMasterSearchHasMore(false);
      setWholesaleMasterSearchError(false);
    }
    const generation = wholesaleMasterSearchGenerationRef.current;
    if (wholesaleMasterSearchInFlightGenerationRef.current === generation) return;
    if (!isFirstPage && !wholesaleMasterSearchCursorRef.current && wholesaleMasterSearchSeenIdsRef.current.size > 0) {
      return;
    }

    wholesaleMasterSearchInFlightGenerationRef.current = generation;
    if (isFirstPage) {
      setWholesaleMasterSearchLoading(true);
      setWholesaleMasterSearchError(false);
    } else {
      setWholesaleMasterSearchLoadingMore(true);
    }

    try {
      const afterDoc = isFirstPage ? null : wholesaleMasterSearchCursorRef.current;
      const snap = await fetchWholesaleMasterSearchPage(keyword, afterDoc);
      if (generation !== wholesaleMasterSearchGenerationRef.current) return;
      const hasMore = snap.docs.length === WHOLESALE_MASTER_SEARCH_PAGE_SIZE;
      const cursorDoc = snap.docs.length > 0 ? snap.docs[snap.docs.length - 1] : null;
      if (cursorDoc) {
        wholesaleMasterSearchCursorRef.current = { nameNormalized: cursorDoc.data().nameNormalized, docId: cursorDoc.id };
      }

      // 2026-08 商品検索不具合修正（Codexレビュー指摘対応・MUST-FIX）：前方一致が
      // 1件でも見つかると中間一致（"ピーチ"のような2語目以降の一部一致）の商品が
      // 結果から漏れる問題があった（例："ピーチジュース"が前方一致するため、
      // "サンキスト　ピーチブレンド1"がトークン検索されずに欠落する）。
      // 1ページ目は常に前方一致とトークン一致（searchTokensのarray-contains）の
      // 両方を実行し、mergeSearchDocs（トップレベルの純粋関数、テストからも直接
      // 検証可能）で重複排除してマージする。「もっと見る」（isFirstPage:false）は
      // 前方一致の続きのみを追加する——トークン一致は1ページ目で完結する単発
      // クエリのため、2回目以降に再実行すると同じ結果を重複取得するだけになる
      let tokenSnapDocs = [];
      if (isFirstPage) {
        const tokenSnap = await fetchWholesaleMasterSearchTokenPage(keyword);
        if (generation !== wholesaleMasterSearchGenerationRef.current) return;
        tokenSnapDocs = tokenSnap.docs || [];
      }

      const { merged: newDocs, seen } = mergeSearchDocs(
        snap.docs.map((d) => [d.id, d.data()]),
        tokenSnapDocs.map((d) => [d.id, d.data()]),
        wholesaleMasterSearchSeenIdsRef.current
      );
      wholesaleMasterSearchSeenIdsRef.current = seen;
      backfillNameNormalizedIfNeeded(newDocs);
      setWholesaleMasterSearchHasMore(hasMore);
      setWholesaleMasterSearchResults((prev) => (isFirstPage ? newDocs : [...prev, ...newDocs]));
      wholesaleMasterSearchFailedOnLoadMoreRef.current = false;
      // もっと見る成功後もエラーフラグが残っていると、バナー文言が化けたまま
      // 表示され続け、次の再試行が誤った文脈（初回リセット）で実行されてしまう
      setWholesaleMasterSearchError(false);
    } catch (e) {
      console.error("[wholesaleMasterSearch page fetch error]", e);
      if (generation === wholesaleMasterSearchGenerationRef.current) {
        wholesaleMasterSearchFailedOnLoadMoreRef.current = !isFirstPage;
        setWholesaleMasterSearchError(true);
      }
    } finally {
      if (wholesaleMasterSearchInFlightGenerationRef.current === generation) {
        wholesaleMasterSearchInFlightGenerationRef.current = null;
      }
      if (generation === wholesaleMasterSearchGenerationRef.current) {
        if (isFirstPage) setWholesaleMasterSearchLoading(false);
        else setWholesaleMasterSearchLoadingMore(false);
      }
    }
  }, [tenantId, fetchWholesaleMasterSearchPage, fetchWholesaleMasterSearchTokenPage, backfillNameNormalizedIfNeeded]);

  // loadWholesaleMasterPage/loadWholesaleMasterSearchPage は tenantId が変わるたびに
  // 新しい関数として再生成される（useCallbackの依存配列にtenantIdを含むため）。
  // mutation完了後の再取得は必ずこの最新版を経由させる（wholesaleMasterLiveContextRef
  // の値だけを最新化しても、呼び出す関数自体がmutation開始時点の古いテナント向け
  // closureのままでは、実際のFirestoreクエリが古いテナントに飛んでしまうため）。
  // ref代入自体はuseLayoutEffectでコミット確定後にのみ行う
  useLayoutEffect(() => {
    wholesaleMasterLiveLoadersRef.current = {
      loadWholesaleMasterPage,
      loadWholesaleMasterSearchPage,
    };
  });

  // ===== products snapshot =====
  // ✅ 卸モード：
  //   - wholesaleView==="products"（商品マスタ画面）は、もはやこのuseEffectでは
  //     扱わない。全件limitなしonSnapshotは廃止済み（2026-08パフォーマンス改善）。
  //     代わりに専用のカーソルページネーション（loadWholesaleMasterPage等、上部で
  //     定義済み）・商品名検索（loadWholesaleMasterSearchPage）・JANコード検索
  //     （下の「卸：商品マスタ JANコード検索」useEffect）で管理する。
  //   - wholesaleView==="manual"（手書き入力）は専用のfetchManualProductsForTenant。
  // ✅ 小売モード：
  //   A) 自テナントが登録した商品（tenantId == 小売tenantId）→ supplierId で Firestore 絞り込み
  //      （onSnapshotでリアルタイム購読、既存通り）
  //   B) 接続済み卸テナントの商品カタログ → カーソルページネーション
  //      （wholesaleCatalogProducts、上のuseEffectとは別に管理。旧「name昇順2000件+
  //       name降順1000件」の二重取得方式は、末尾desc用の複合インデックスが本番に
  //       存在せず実質的に先頭2000件しか取得できない、かつ非同期完了順序次第で
  //       和集合が崩れるバグがあったため廃止した）
  // qA(own) と wholesaleCatalogProducts をマージして重複排除。
  useEffect(() => {
    // ── 卸モード ──
    if (mode === "wholesale") {
      // 商品マスタ画面は専用のページネーション/検索useEffectで管理するため、
      // ここでは何もしない（catalogはこの画面では使わない）
      if (wholesaleView === "products") {
        setCatalog([]);
        setCatalogLoading(false);
        return () => {};
      } else if (wholesaleView === "manual") {
        // 手書き入力：この汎用catalogは使わない。専用のfetchManualProductsForTenant
        // によるprefetch（画面を開いた時点で商品全件取得を開始）とtenantIdキー付き
        // キャッシュで管理する（別のuseEffect、src/App.js:2523付近）
        setCatalog([]);
        setCatalogLoading(false);
        return () => {};
      } else {
        // 受注一覧など：商品カタログ不要なので読み込まない
        setCatalog([]);
        setCatalogLoading(false);
        return () => {};
      }
    }

    // ── 小売モード ──
    if (!supplierId) {
      setCatalogOwn([]);
      setCatalogLoading(false);
      return () => {};
    }
    // qA（自テナント登録商品）はここでは購読しない。debouncedWholesaleSearchに
    // 依存しない別のuseEffectで管理する——検索語入力のたびにこの巨大な
    // onSnapshotリスナーを解除・再購読すると、無関係な全件再読み込みが
    // 発生してしまうため（下の「qA（own products）購読」useEffect参照）
    return () => {};
  }, [mode, wholesaleView, tenantId, supplierId, debouncedWholesaleSearch, db]);

  // ===== qA（own products）購読 =====
  // 小売が自テナントに登録した商品。tenantId・supplierIdなど「実際の対象」が
  // 変わった時だけ購読し直す。debouncedWholesaleSearch（検索語）はこの
  // クエリ自体に影響しないため依存配列に含めない——含めると検索語入力の
  // たびに全件onSnapshotが解除・再購読され、不要なFirestore再読み込みと
  // catalogOwnの一瞬の空表示（チラつき）が発生する
  useEffect(() => {
    if (mode !== "retail") return;
    if (!supplierId) return;

    const supplierObj = suppliers.find(
      (s) => s.id === supplierId || s.supplierId === supplierId
    );
    const profileWholeTid = String(tenantProfile?.wholesaleTenantId || "").trim();
    const wholesaleTenantId =
      String(supplierObj?.wholesaleTenantId || "").trim() ||
      (profileWholeTid && profileWholeTid === supplierId ? supplierId : "");
    const supplierDocId = String(supplierObj?._docId || "").trim();

    // 仕入先切替直後、新しいqAリスナーの応答を待つ間に前の仕入先のcatalogOwnが
    // 表示され続けるとテナント境界を跨いだ商品混入に見えてしまうため、
    // リスナー再購読前に同期的にクリアする。実際に仕入先識別子が変わった
    // 時だけクリアする（suppliers/tenantProfileの参照だけが変わった再実行では
    // クリアしない）
    const supplierIdentityKey = `${supplierId}::${wholesaleTenantId}`;
    if (catalogOwnLastSupplierKeyRef.current !== supplierIdentityKey) {
      catalogOwnLastSupplierKeyRef.current = supplierIdentityKey;
      setCatalogOwn([]);
    }

    // 既存の (tenantId, name) インデックスを使用。複合インデックス不要で確実に動く。
    const qA = query(
      collection(db, "products"),
      where("tenantId", "==", tenantId),
      orderBy("name")
      // limit なし：仕入先の全商品を取得
    );
    const unsubA = onSnapshot(qA, (snap) => {
      const all = snap.docs.map((d) => ({ ...d.data(), id: d.id, _docId: d.id }));
      // supplierId でクライアント側フィルタ（論理ID・Firestore docId・wholesaleTenantId の3パターン対応）
      const filtered = all.filter((p) => {
        const pid = String(p.supplierId || "").trim();
        if (!pid) return true; // supplierId 未設定は互換表示
        return (
          pid === supplierId ||
          (supplierDocId && pid === supplierDocId) ||
          (wholesaleTenantId && pid === wholesaleTenantId)
        );
      });
      setCatalogOwn(filtered);
      setCatalogOwnError(false);
      if (!wholesaleTenantId) setCatalogLoading(false);
    }, (err) => {
      console.error("[products own error]", err);
      setCatalogOwnError(true);
      setCatalogOwn([]); // 失敗後に古いデータが正常表示され続けないようクリア
      setCatalogLoading(false);
    });

    return () => unsubA();
  }, [db, mode, tenantId, supplierId, suppliers, tenantProfile]);

  // ===== バーコード完全一致検索（卸カタログ） =====
  // バーコード検索（8〜14桁）は通常のページネーション結果(wholesaleCatalogProducts)
  // とは完全に分離する。以前は「バーコード一致クエリ」と「名前順末尾1000件」が
  // 同じ結果集合にマージされてしまい、バーコード検索結果に無関係な商品が
  // 混入する経路があった——ページネーション化に伴いこの経路自体を廃止し、
  // バーコード検索専用の結果だけを独立したstateで管理する。
  // セキュリティルール: resource.data.tenantId == myWholesaleTenantId() → 一致
  useEffect(() => {
    if (mode !== "retail") return;
    if (!supplierId) return;
    const supplierObj = suppliers.find((s) => s.id === supplierId || s.supplierId === supplierId);
    const profileWholeTid = String(tenantProfile?.wholesaleTenantId || "").trim();
    const wholesaleTenantId =
      String(supplierObj?.wholesaleTenantId || "").trim() ||
      (profileWholeTid && profileWholeTid === supplierId ? supplierId : "");

    // qAと同様、実際に仕入先識別子（wholesaleTenantId）が変わった時だけ、
    // 新しいバーコードリスナーの応答を待つ間の旧テナント結果表示を防ぐため
    // 同期的にクリアする（検索語入力だけの再実行ではクリアしない）
    const barcodeSupplierIdentityKey = `${supplierId}::${wholesaleTenantId}`;
    if (barcodeLastSupplierKeyRef.current !== barcodeSupplierIdentityKey) {
      barcodeLastSupplierKeyRef.current = barcodeSupplierIdentityKey;
      setWholesaleBarcodeResults([]);
      setWholesaleBarcodeError(false);
    }

    let unsubBarcode = null;
    const sw = String(debouncedWholesaleSearch || "").trim();
    const isBarcodeSearch = /^\d{8,14}$/.test(sw);
    setIsWholesaleBarcodeMode(Boolean(wholesaleTenantId && isBarcodeSearch));
    if (wholesaleTenantId && isBarcodeSearch) {
      const qBarcode = query(
        collection(db, "products"),
        where("tenantId", "==", wholesaleTenantId),
        where("barcode", "==", sw)
      );
      unsubBarcode = onSnapshot(qBarcode, (snap) => {
        setWholesaleBarcodeResults(snap.docs.map((d) => ({ ...d.data(), id: d.id, _docId: d.id })));
        setWholesaleBarcodeError(false);
        setCatalogLoading(false);
      }, (err) => {
        console.error("[products wholesale barcode error]", err);
        setWholesaleBarcodeError(true);
        setWholesaleBarcodeResults([]); // 失敗後に古い結果が正常表示され続けないようクリア
        setCatalogLoading(false);
      });
    } else {
      setWholesaleBarcodeResults([]);
      setWholesaleBarcodeError(false);
      // バーコード検索でない通常時は、ページネーション経由のloadWholesaleCatalogPage
      // （下の別useEffectでトリガーする）がcatalogLoadingの解除を担当する
    }

    return () => { if (unsubBarcode) unsubBarcode(); };
  }, [db, mode, supplierId, suppliers, tenantProfile, debouncedWholesaleSearch]);

  // ===== 卸カタログ ページネーション起動 =====
  // 仕入先（対象卸テナント）が確定し、かつバーコード検索中でない場合、1ページ目を取得する。
  // 「バーコード検索中だった（isBarcodeSearch=true）→バーコード検索でなくなった」という
  // 遷移が起きた時だけ forceReset: true で明示的に1ページ目からやり直す。それ以外
  // （suppliers配列の参照が変わっただけ等）では同一テナントであれば既存のページ状態を
  // 温存する——force無しだとテナント不変時はresetWholesaleCatalogIfTenantChangedが
  // 何もせず、forceが必須の場面だけを狙い撃ちで区別する必要があるため
  const wasBarcodeSearchRef = useRef(false);
  useEffect(() => {
    if (mode !== "retail") return;
    if (!supplierId) return;
    const supplierObj = suppliers.find((s) => s.id === supplierId || s.supplierId === supplierId);
    const profileWholeTid = String(tenantProfile?.wholesaleTenantId || "").trim();
    const wholesaleTenantId =
      String(supplierObj?.wholesaleTenantId || "").trim() ||
      (profileWholeTid && profileWholeTid === supplierId ? supplierId : "");
    if (!wholesaleTenantId) {
      resetWholesaleCatalogIfTenantChanged("");
      wasBarcodeSearchRef.current = false;
      return;
    }
    const sw = String(debouncedWholesaleSearch || "").trim();
    const isBarcodeSearch = /^\d{8,14}$/.test(sw);
    if (isBarcodeSearch) {
      wasBarcodeSearchRef.current = true;
      return; // バーコード検索中はページネーションを起動しない
    }
    const forceReset = wasBarcodeSearchRef.current; // バーコード検索から戻った直後のみ強制リセット
    wasBarcodeSearchRef.current = false;
    // このuseEffectは suppliers/tenantProfile 等の参照が変わるだけでも再実行される。
    // forceReset=false かつテナントが既に読み込み済み（1ページ目取得済みまたは
    // 取得中）の場合にまで isFirstPage:true を発行すると、dedupeで新規0件を
    // 「1ページ目の結果」として productsState に上書きしてしまい、既存の
    // ページング進捗（2ページ目以降）が消える。テナントが変わっていない・
    // forceでもない再実行では何もしない
    const alreadyInitialized =
      wholesaleCatalogLastSeenWholesaleTenantIdRef.current === wholesaleTenantId &&
      (wholesaleCatalogSeenIdsRef.current.size > 0 || wholesaleCatalogInFlightGenerationRef.current === wholesaleCatalogGenerationRef.current);
    if (!forceReset && alreadyInitialized) {
      // ページ取得をスキップする場合、loadWholesaleCatalogPageのfinallyが
      // 走らないためcatalogLoadingを解除する経路がなくなる。デバウンスeffectが
      // 直前にsetCatalogLoading(true)しているため、ここで明示的に解除しないと
      // 検索ドロップダウンが「検索中...」のまま固まる
      setCatalogLoading(false);
      return;
    }
    loadWholesaleCatalogPage(wholesaleTenantId, { isFirstPage: true, forceReset });
  }, [mode, supplierId, suppliers, tenantProfile, loadWholesaleCatalogPage, debouncedWholesaleSearch]);

  // catalog = own(qA) + wholesale(バーコード検索結果 or ページネーション結果) の合成。
  // 重複排除・ソートのみ行う（Firestore再クエリは発生しない、純粋なクライアント側合成）。
  // どちらを使うかは検索条件から明示的に決まる isWholesaleBarcodeMode で判定する
  // ——結果件数（.length > 0）からの推測はしない。バーコードが0件ヒットの場合に
  // 誤って直前のページネーション結果へフォールバックしてしまうバグを防ぐため
  useEffect(() => {
    const wholesalePart = isWholesaleBarcodeMode ? wholesaleBarcodeResults : wholesaleCatalogProducts;
    const seen = new Set();
    const merged = [];
    for (const p of [...catalogOwn, ...wholesalePart]) {
      const key = p._docId || p.id;
      if (!seen.has(key)) { seen.add(key); merged.push(p); }
    }
    merged.sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "ja"));
    setCatalog(merged);
  }, [catalogOwn, wholesaleBarcodeResults, wholesaleCatalogProducts, isWholesaleBarcodeMode]);

  // ===== 卸：商品マスタ JANコード検索 =====
  // wholesaleMasterSearch（デバウンス後: debouncedWholesaleSearch）が8〜14桁数字の
  // 場合のみ、既存の軽量な where("barcode","==",sw) 完全一致クエリを実行する。
  // 全商品DLを経由しない。バーコード検索でなくなった場合は結果をクリアするだけで、
  // 通常一覧への復帰は下の「卸：商品マスタ 通常一覧起動」useEffectが担当する
  const wholesaleMasterWasBarcodeRef = useRef(false);
  const [wholesaleMasterBarcodeRetryTick, setWholesaleMasterBarcodeRetryTick] = useState(0);
  useEffect(() => {
    if (mode !== "wholesale" || wholesaleView !== "products") return;
    if (!tenantId) return;
    const sw = String(debouncedWholesaleSearch || "").trim();
    const isBarcodeSearch = /^\d{8,14}$/.test(sw);
    if (!isBarcodeSearch) {
      wholesaleMasterWasBarcodeRef.current = false;
      setWholesaleMasterBarcodeResults([]);
      setWholesaleMasterBarcodeError(false);
      return;
    }
    wholesaleMasterWasBarcodeRef.current = true;
    setWholesaleMasterBarcodeLoading(true);
    setWholesaleMasterBarcodeError(false);
    const qref = query(
      collection(db, "products"),
      where("tenantId", "==", tenantId),
      where("barcode", "==", sw)
    );
    const unsub = onSnapshot(qref, (snap) => {
      setWholesaleMasterBarcodeResults(snap.docs.map((d) => ({ ...d.data(), id: d.id, _docId: d.id })));
      setWholesaleMasterBarcodeError(false);
      setWholesaleMasterBarcodeLoading(false);
    }, (err) => {
      console.error("[wholesaleMaster barcode error]", err);
      setWholesaleMasterBarcodeError(true);
      setWholesaleMasterBarcodeResults([]);
      setWholesaleMasterBarcodeLoading(false);
    });
    return () => unsub();
  }, [mode, wholesaleView, tenantId, debouncedWholesaleSearch, db, wholesaleMasterBarcodeRetryTick]);

  // ===== 卸：商品マスタ 商品名検索起動 =====
  // debouncedWholesaleSearchが「JANコードでない非空文字列」の場合のみ、
  // Firestore側の前方一致検索（loadWholesaleMasterSearchPage）を起動する。
  // 通常一覧のカーソルページネーションはこの検索状態に一切影響されない
  // （下の「通常一覧起動」useEffectは検索中かどうかで起動を止めるだけで、
  // 検索語の変化そのものには反応しない設計にする）
  useEffect(() => {
    if (mode !== "wholesale" || wholesaleView !== "products") return;
    if (!tenantId) return;
    const sw = String(debouncedWholesaleSearch || "").trim();
    const isBarcodeSearch = /^\d{8,14}$/.test(sw);
    if (!sw || isBarcodeSearch) {
      // 検索語が空、またはバーコード検索中は商品名検索を起動しない
      wholesaleMasterSearchLastKeywordRef.current = undefined;
      setWholesaleMasterSearchResults([]);
      setWholesaleMasterSearchHasMore(false);
      setWholesaleMasterSearchError(false);
      return;
    }
    loadWholesaleMasterSearchPage(sw, { isFirstPage: true });
  }, [mode, wholesaleView, tenantId, debouncedWholesaleSearch, loadWholesaleMasterSearchPage]);

  // ===== 卸：商品マスタ 通常一覧起動 =====
  // 画面を開いた時点（mode/wholesaleView/tenantIdが確定した時点）で1ページ目を取得する。
  // debouncedWholesaleSearchはこのuseEffectの依存に含めない——検索語入力のたびに
  // 通常一覧のカーソルページネーションを再起動しないため（MUST 5：検索入力と
  // 通常一覧の分離）。テナントが変わっていない・既に初期化済みの場合は何もしない
  useEffect(() => {
    if (mode !== "wholesale" || wholesaleView !== "products") return;
    if (!tenantId) return;
    // 画面を離れる際、現在ページのonSnapshotリスナーは必ず解除される
    // （下の画面離脱クリーンアップuseEffect）。そのため「同一テナントで読み込み
    // 済みデータがある」だけでは購読中かどうかの判定にならない——再入場時に
    // リスナーが実際に張られているか（wholesaleMasterUnsubRef.current）も
    // 必ず確認し、張られていなければキャッシュ済みデータの有無に関わらず
    // 再購読する（さもないと再入場後、一覧が編集・削除に追従しなくなる）
    const alreadySubscribed =
      wholesaleMasterLastSeenTenantIdRef.current === tenantId &&
      wholesaleMasterUnsubRef.current != null;
    const alreadyInFlight =
      wholesaleMasterLastSeenTenantIdRef.current === tenantId &&
      wholesaleMasterInFlightGenerationRef.current === wholesaleMasterGenerationRef.current;
    if (alreadySubscribed || alreadyInFlight) return;
    loadWholesaleMasterPage({ isFirstPage: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, wholesaleView, tenantId]);

  // 画面を離れた場合、現在ページのonSnapshotリスナーを確実に解除する
  // （wholesaleView が "products" でなくなった場合のクリーンアップ）
  useEffect(() => {
    if (mode === "wholesale" && wholesaleView === "products") return;
    if (wholesaleMasterUnsubRef.current) {
      wholesaleMasterUnsubRef.current();
      wholesaleMasterUnsubRef.current = null;
    }
    // リスナー解除だけでなく in-flight マーカーも必ずクリアする。
    // 初回スナップショット/エラーコールバックが届く前に画面を離れると、
    // wholesaleMasterInFlightGenerationRef が「取得中」を指したまま残り、
    // 再入場時の alreadyInFlight 判定が誤って true になって再購読が
    // 一切行われなくなる（リスナーなし・新規リクエストなしで一覧が固まる）
    wholesaleMasterInFlightGenerationRef.current = null;
  }, [mode, wholesaleView]);



        // ===== 小売集計用：3ヶ月分を期間指定取得 =====
    // 集計基準は納品書発行ベースに一本化。期間軸はissuedAtに統一する。
    // 取引先識別の非対称性対応：tenantId（オンライン注文由来）と
    // retailTenantIdFromShop（接続済みshop経由の手書き注文由来、どの卸の手書き注文でも
    // 拾えるようtenantId単位ではなくretailTenantIdFromShopで検索する）の2クエリの
    // 和集合を取る。単一のwholesaleIdを推論して単一shopIdだけをクエリする旧実装は、
    // 複数卸と接続している小売テナントで、推論から漏れた卸の手書き注文を
    // 取りこぼしていたため廃止した。
    useEffect(() => {
      if (!tenantId || mode !== "retail" || retailView !== "summary") return;
      if (retailSummaryLoading) return;
      if (retailSummaryOrders !== null) return;
      if (retailSummaryError) return;
      // tenantId変更等でこのeffectが再実行された際に、古いリクエストの解決が
      // 新しいテナントのstateへ書き込まれてしまう（クロステナントのデータ越境）
      // ことを防ぐためのガード
      let cancelled = false;
      setRetailSummaryLoading(true);
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth() - 2, 1);
      const to = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
      const fetchedThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      // このフェッチが対象とする「今月」を記録する（レンダー時の月ズレ防止）。
      // 同期的にここでセットするだけでなく、後述の成功コールバック内でも
      // 再セットする——このuseEffectとテナントリセット用useEffectの実行順序は
      // 保証されないため、リセット側が後から走ってこの値をnullに戻した場合でも、
      // 最終的にretailSummaryOrdersを書き込む成功コールバックの時点で確実に
      // 対応するアンカーが設定されているようにするため
      setRetailSummaryFetchedThisMonth(fetchedThisMonth);
      // 2クエリのどちらかが失敗した場合、不完全な結果を正常値として表示しては
      // ならないため、片方だけを空扱いにして握りつぶさず、両方を必須として扱う
      Promise.all([
        getDocs(query(collection(db, "orders"), where("tenantId", "==", tenantId))),
        getDocs(query(collection(db, "orders"), where("retailTenantIdFromShop", "==", tenantId))),
      ]).then(([snap1, snap2]) => {
        if (cancelled) return;
        const map = new Map();
        [...snap1.docs, ...snap2.docs].forEach(d => {
          const data = d.data();
          if (!isDeliveredAndCounted(data)) return;
          const ts = data.issuedAt;
          const ms = typeof ts?.toMillis === "function" ? ts.toMillis() : Number(ts || 0);
          if (ms >= from.getTime() && ms <= to.getTime()) {
            map.set(d.id, { id: d.id, ...data });
          }
        });
        setRetailSummaryFetchedThisMonth(fetchedThisMonth);
        setRetailSummaryOrders(Array.from(map.values()));
        setRetailSummaryLoading(false);
      }).catch((e) => {
        if (cancelled) return;
        console.error("[retailSummaryOrders fetch error]", e);
        setRetailSummaryError(true);
        setRetailSummaryLoading(false);
        alert(isAU ? "Failed to load summary data. Please try again." : "集計データの取得に失敗しました。再度お試しください。");
      });
      return () => { cancelled = true; };
      // retailSummaryOrdersを依存配列に含める。tenantId変更時、テナント切替リセット用
      // useEffect（このコンポーネント内の別のuseEffect）がretailSummaryOrdersをnullに
      // 戻すことで、このeffectが再度「取得すべき」と判定できるようにするため
      // （tenantIdだけを依存にしていると、tenantId変更の同一レンダーサイクル内で
      // このeffectが先に走り、まだ旧テナントのretailSummaryOrdersが残っている
      // タイミングで早期returnしてしまい、後からリセットされても再実行されず、
      // 「読み込んでいます...」のまま永久に止まってしまう不具合があった）
    }, [tenantId, mode, retailView, retailSummaryError, retailSummaryOrders]);

        // ===== orders snapshot（過去30日 + limit50 + 卸接続対応）=====
    useEffect(() => {
      if (!tenantId) {
        setOrders([]);
        return () => { };
      }

      const thirtyDaysAgo = Timestamp.fromDate(
        new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
      );

      // 自テナントの注文
      const q1 = query(
        collection(db, "orders"),
        where("tenantId", "==", tenantId),
        where("createdAt", ">=", thirtyDaysAgo),
        orderBy("createdAt", "desc"),
        limit(50)
      );

      // 小売→卸接続経由の注文（wholesaleTenantId == 自分）
      const q2 = query(
        collection(db, "orders"),
        where("wholesaleTenantId", "==", tenantId),
        where("createdAt", ">=", thirtyDaysAgo),
        orderBy("createdAt", "desc"),
        limit(50)
      );

      let snap1Docs = [];
      let snap2Docs = [];

      const mergeAndSet = () => {
        const map = new Map();
        [...snap1Docs, ...snap2Docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));
        const merged = Array.from(map.values()).sort((a, b) => {
          const ta = typeof a.createdAt?.toMillis === "function" ? a.createdAt.toMillis() : (a.createdAt || 0);
          const tb = typeof b.createdAt?.toMillis === "function" ? b.createdAt.toMillis() : (b.createdAt || 0);
          return tb - ta;
        });
        setOrders(merged);
        setOrdersLastDoc(snap1Docs[snap1Docs.length - 1] || null);
        setOrdersHasMore(snap1Docs.length === 50 || snap2Docs.length === 50);
      };

      const unsub1 = onSnapshot(q1, (snap) => {
        snap1Docs = snap.docs;
        mergeAndSet();
      }, (err) => {
        console.error("[orders snapshot q1 error]", err);
        alert(err.message);
      });

      const unsub2 = onSnapshot(q2, (snap) => {
        snap2Docs = snap.docs;
        mergeAndSet();
      }, (err) => {
        // インデックス未作成の場合は警告のみ（小売のみ運用環境で発生）
        console.warn("[orders snapshot q2 - wholesaleTenantId index missing?]", err.message);
      });

      return () => { unsub1(); unsub2(); };
    }, [tenantId]);

    // ===== 卸集計用：期間指定で手動取得 =====
    // 集計基準は納品書発行ベースに一本化。期間軸はissuedAtに統一する。
    // orderBy("issuedAt","desc")は使わない——issuedAtの複合インデックスは
    // ASCENDING方向でデプロイされており、DESC明示ソートはこの向きのインデックスと
    // 一致せずFAILED_PRECONDITIONで失敗する（本番incidentで確認済み）。
    // 取得後にクライアント側でissuedAt降順に並べ替える（retailRankRangeOrders/
    // fetchBillingOrdersと同じパターン）。
    // 2クエリのどちらか一方でも失敗した場合、不完全な集計を正常値として
    // 表示してはならないため、必ず全体を失敗として扱いエラー表示する
    // （catch(() => ({docs: []}))のような片側握りつぶしは使わない）。
    // 共通ヘルパー：卸の指定期間issuedAtクエリを実行し、渡されたsetter群に結果を書き込む。
    // 月次タブ（wsSummaryAllOrders）とランキングタブ（wsRankAllOrders）は、別々の
    // 期間で独立に取得・表示する必要があるため、同じクエリロジックを共有しつつ
    // 書き込み先ステートだけを分離する（月次タブがランキングタブの狭い期間の
    // データで上書きされてしまう不整合を防ぐため）
    const fetchWsOrdersByRange = async (startDate, endDate, { requestIdRef, setLoading, setOrders }) => {
      if (!tenantId || !startDate || !endDate) return;
      const requestId = ++requestIdRef.current;
      setLoading(true);
      setOrders(null);
      try {
        const { start, endExclusive } = toJstDayRange(startDate, endDate);
        const s = Timestamp.fromDate(start);
        const e = Timestamp.fromDate(endExclusive);
        const q1 = query(
          collection(db, "orders"),
          where("tenantId", "==", tenantId),
          where("status", "==", "納品書発行"),
          where("issuedAt", ">=", s),
          where("issuedAt", "<", e)
        );
        const q2 = query(
          collection(db, "orders"),
          where("wholesaleTenantId", "==", tenantId),
          where("status", "==", "納品書発行"),
          where("issuedAt", ">=", s),
          where("issuedAt", "<", e)
        );
        const [snap1, snap2] = await Promise.all([getDocs(q1), getDocs(q2)]);
        if (requestId !== requestIdRef.current) return; // 後続リクエストに追い越された
        const map = new Map();
        [...snap1.docs, ...snap2.docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));
        const merged = Array.from(map.values()).filter(isDeliveredAndCounted).sort((a, b) => {
          const ta = typeof a.issuedAt?.toMillis === "function" ? a.issuedAt.toMillis() : Number(a.issuedAt || 0);
          const tb = typeof b.issuedAt?.toMillis === "function" ? b.issuedAt.toMillis() : Number(b.issuedAt || 0);
          return tb - ta;
        });
        setOrders(merged);
      } catch (e) {
        if (requestId !== requestIdRef.current) return; // 後続リクエストに追い越された
        console.error("[fetchWsOrdersByRange error]", e);
        alert(isAU ? "Failed to load summary data. Please try again." : "集計データの取得に失敗しました。再度お試しください。");
      } finally {
        if (requestId === requestIdRef.current) setLoading(false);
      }
    };

    const fetchWsSummaryOrders = (startDate, endDate) => fetchWsOrdersByRange(startDate, endDate, {
      requestIdRef: wsSummaryRequestIdRef, setLoading: setWsSummaryLoading, setOrders: setWsSummaryAllOrders,
    });
    // ランキング（取引先別・商品別）タブ専用。月次タブのwsSummaryAllOrdersとは
    // 独立したステートに書き込む
    const fetchWsRankOrders = (startDate, endDate) => fetchWsOrdersByRange(startDate, endDate, {
      requestIdRef: wsRankRequestIdRef, setLoading: setWsRankLoading, setOrders: setWsRankAllOrders,
    });

    // ===== wholesaleView が変わったら集計キャッシュをリセット =====
    useEffect(() => {
      if (wholesaleView !== "summary") {
        setWsSummaryAllOrders(null);
        // 進行中のfetchWsSummaryOrdersリクエストがあれば、その結果を無効化する。
        // これをしないと、summaryタブを離れた後に古いリクエストが解決し、
        // 意図せずキャッシュを復元してしまう
        wsSummaryRequestIdRef.current++;
        // 無効化したリクエストのfinallyはリクエストIDが一致しないためloadingを
        // falseに戻せない（意図的な安全側の挙動）。しかしその結果、離脱時に
        // フェッチ中だった場合、loadingがtrueのまま取り残され、summaryタブに
        // 戻った際に「期間選択画面」ではなく「読み込み中...」が永久に表示され続ける
        // 状態になってしまう。ここで明示的にfalseへ戻し、summaryタブに戻った時点で
        // 常に正しい初期状態（期間選択画面）から再開できるようにする
        setWsSummaryLoading(false);
        // ランキングタブ専用データも同様にリセット・無効化・loading解除する
        setWsRankAllOrders(null);
        wsRankRequestIdRef.current++;
        setWsRankLoading(false);
      }
    }, [wholesaleView]);

    // ===== tenantId が変わったら（ログアウト・別テナントへの切り替え・スタッフ参加等）、
    // 期間指定集計まわりの全ステートをリセットし、進行中のリクエストを無効化する。
    // これをしないと、旧テナントで取得中だったリクエストが新テナントに切り替わった後に
    // 解決し、新テナントの画面に旧テナントのデータを書き込んでしまう
    // （テナント間のデータ越境表示という重大な問題になる）ほか、
    // 旧テナントで取得済みだった結果がそのまま新テナントの画面に残り続けてしまう =====
    useEffect(() => {
      wsSummaryRequestIdRef.current++;
      setWsSummaryAllOrders(null);
      setWsSummaryLoading(false);
      wsRankRequestIdRef.current++;
      setWsRankAllOrders(null);
      setWsRankLoading(false);
      shopRangeRequestIdRef.current++;
      setShopRangeOrders(null);
      setShopRangeError(false);
      setShopRangeLoading(false);
      retailRangeRequestIdRef.current++;
      setRetailRangeOrders(null);
      setRetailRangeError(false);
      setRetailRangeLoading(false);
      setRetailSummaryOrders(null);
      setRetailSummaryError(false);
      setRetailSummaryLoading(false);
      setRetailSummaryFetchedThisMonth(null);
      setRetailRankRangeOrders(null);
      setRetailRankRangeError(false);
      dateRangeRequestIdRef.current++;
      setDateRangeOrders(null);
      setDateRangeError(false);
      setDateRangeLoading(false);
      // 手書き入力の商品prefetchキャッシュも破棄する。世代インクリメント・Mapクリア
      // の本体は fetchManualProductsForTenant 呼び出し時に同期的に行われる
      // （bumpManualProductsGenerationIfTenantChanged、useEffectの実行順序に依存しない
      // ようにするための設計）。ここでは画面が「手書き入力」を開いていない間に
      // テナントが切り替わった場合に備えて、UI状態（loading/results）だけを
      // 保険的にリセットしておく
      setManualProductsState("idle");
      setManualFsResults([]);
      // カテゴリはテナント固有の商品マスタから導出される値のため、テナント切替時に
      // 必ずリセットする。残したままだと旧テナントのカテゴリ名が新テナントの画面に
      // 残り続け、かつ選択中のmanualCategoryが新テナントには存在しない値だと
      // 検索結果が常に0件になる不具合が起きる
      setWholesaleCategories([]);
      setManualCategory("");
    }, [tenantId]);

    // ✅ orders 追加読み込み（「もっと見る」ボタン用）
    const loadMoreOrders = async () => {
      if (!tenantId || !ordersLastDoc) return;

      const thirtyDaysAgo = Timestamp.fromDate(
        new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
      );

      const qref = query(
        collection(db, "orders"),
        where("tenantId", "==", tenantId),
        where("createdAt", ">=", thirtyDaysAgo),
        orderBy("createdAt", "desc"),
        startAfter(ordersLastDoc),
        limit(50)
      );

      const snap = await getDocs(qref);
      const more = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setOrders((prev) => [...prev, ...more]);
      setOrdersLastDoc(snap.docs[snap.docs.length - 1] || null);
      setOrdersHasMore(snap.docs.length === 50);
    };



    // ✅ 期間指定でFirestoreから直接取得（tenantId + wholesaleTenantId の両方）。
    // テナント切替中に古いリクエストが解決して新テナントの画面に結果を書き込む
    // （クロステナントのデータ越境）ことを防ぐため、リクエストIDで保護する
    const fetchOrdersByDateRange = async (from, to) => {
      if (!tenantId || !from || !to) return;
      const requestId = ++dateRangeRequestIdRef.current;
      setDateRangeLoading(true);
      // 失敗時に前回（別期間）の結果を残したまま新しい期間として表示してしまうと、
      // 不完全・不正確なデータを正常値であるかのように見せることになるため、
      // 取得開始時点で必ずクリアする（他のfetch*RangeOrdersと同じ安全側の挙動に統一）
      setDateRangeOrders(null);
      setDateRangeError(false);
      try {
        const s = Timestamp.fromDate(new Date(from + " 00:00:00"));
        const e = Timestamp.fromDate(new Date(to + " 23:59:59"));
        // 2クエリのどちらかが失敗した場合、不完全な結果を正常値として表示しては
        // ならないため、片方だけを空扱いにして握りつぶさず、両方を必須として扱う
        const [snap1, snap2] = await Promise.all([
          getDocs(query(collection(db, "orders"),
            where("tenantId", "==", tenantId),
            where("createdAt", ">=", s), where("createdAt", "<=", e),
            orderBy("createdAt", "desc"))),
          getDocs(query(collection(db, "orders"),
            where("wholesaleTenantId", "==", tenantId),
            where("createdAt", ">=", s), where("createdAt", "<=", e),
            orderBy("createdAt", "desc"))),
        ]);
        if (requestId !== dateRangeRequestIdRef.current) return; // 後続リクエストに追い越された
        const map = new Map();
        [...snap1.docs, ...snap2.docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));
        setDateRangeOrders(Array.from(map.values()).sort((a, b) => {
          const ta = typeof a.createdAt?.toMillis === "function" ? a.createdAt.toMillis() : 0;
          const tb = typeof b.createdAt?.toMillis === "function" ? b.createdAt.toMillis() : 0;
          return tb - ta;
        }));
      } catch (e) {
        if (requestId !== dateRangeRequestIdRef.current) return; // 後続リクエストに追い越された
        console.error(e);
        // 失敗時は「未取得」として30日分の通常一覧にフォールバックしてはならない
        // （指定した期間と異なる不完全なデータを、あたかも取得結果であるかのように
        // 見せてしまうため）。dateRangeErrorをtrueにして、表示側で明示的に
        // エラー状態と分かるようにする
        setDateRangeError(true);
        alert((isAU ? "Failed to load period: " : "期間取得エラー: ") + e.message);
      } finally {
        if (requestId === dateRangeRequestIdRef.current) setDateRangeLoading(false);
      }
    };

    // ✅ 卸 取引先指定タブ用（tenantId + wholesaleTenantId の両方）。
    // 集計基準は納品書発行ベースに一本化。期間軸はissuedAtに統一する。
    // orderBy("issuedAt","desc")は使わない（ASCENDING方向インデックスと不一致で
    // FAILED_PRECONDITIONになるため）。取得後にクライアント側で降順ソートする。
    // 2クエリの片方だけ失敗して不完全な結果を正常値として表示することを防ぐため、
    // どちらのクエリも.catch()で握りつぶさず、失敗はそのまま外側のtry/catchに
    // 伝播させて集計全体を失敗として扱う。
    const fetchShopRangeOrders = async (from, to) => {
      if (!tenantId || !from || !to) return;
      // 素早い連続リクエストで、先発のリクエストが後発の結果を上書きしないよう、
      // このリクエスト固有のIDを発行し、応答時に「まだ最新か」を確認する
      const requestId = ++shopRangeRequestIdRef.current;
      setShopRangeLoading(true);
      // 失敗時に前回（別期間）の結果を残したまま新しい期間のラベルで表示してしまうと、
      // 不完全・不正確な集計値を正常値であるかのように見せることになるため、
      // 取得開始時点で必ずクリアする（fetchWsSummaryOrdersと同じ安全側の挙動に統一）
      setShopRangeOrders(null);
      // 「未取得（30日分にフォールバック可）」と「取得失敗」を区別するため、
      // 取得開始時点でエラーフラグも必ずクリアする
      setShopRangeError(false);
      try {
        const { start, endExclusive } = toJstDayRange(from, to);
        const s = Timestamp.fromDate(start);
        const e = Timestamp.fromDate(endExclusive);
        const [snap1, snap2] = await Promise.all([
          getDocs(query(collection(db, "orders"),
            where("tenantId", "==", tenantId), where("status", "==", "納品書発行"),
            where("issuedAt", ">=", s), where("issuedAt", "<", e))),
          getDocs(query(collection(db, "orders"),
            where("wholesaleTenantId", "==", tenantId), where("status", "==", "納品書発行"),
            where("issuedAt", ">=", s), where("issuedAt", "<", e))),
        ]);
        if (requestId !== shopRangeRequestIdRef.current) return; // 後続リクエストに追い越された
        const map = new Map();
        [...snap1.docs, ...snap2.docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));
        setShopRangeOrders(Array.from(map.values()).filter(isDeliveredAndCounted).sort((a, b) => {
          const ta = typeof a.issuedAt?.toMillis === "function" ? a.issuedAt.toMillis() : Number(a.issuedAt || 0);
          const tb = typeof b.issuedAt?.toMillis === "function" ? b.issuedAt.toMillis() : Number(b.issuedAt || 0);
          return tb - ta;
        }));
      } catch (e) {
        if (requestId !== shopRangeRequestIdRef.current) return; // 後続リクエストに追い越された
        console.error(e);
        // エラー時は「未取得」として30日分の簡易表示にフォールバックしてはならない
        // （指定した期間と異なる不完全なデータを、あたかも取得結果であるかのように
        // 見せてしまうため）。shopRangeErrorをtrueにして、表示側で明示的に
        // エラー状態と分かるようにする
        setShopRangeError(true);
        alert(isAU ? "Failed to load summary data. Please try again." : "集計データの取得に失敗しました。再度お試しください。");
      } finally {
        if (requestId === shopRangeRequestIdRef.current) setShopRangeLoading(false);
      }
    };

    // ✅ 小売 期間・仕入先指定タブ用。
    // 集計基準は納品書発行ベースに一本化。期間軸はissuedAtに統一する。
    // tenantId（オンライン注文由来）とretailTenantIdFromShop（接続済みshop経由の
    // 手書き注文由来）の2クエリの和集合を取る——tenantIdクエリだけでは、卸が作成した
    // 手書き注文（tenantIdが卸自身になる）を取りこぼすため。
    // orderBy("issuedAt","desc")は使わない（ASCENDING方向インデックスと不一致で
    // FAILED_PRECONDITIONになるため）。取得後にクライアント側で降順ソートする。
    // 2クエリの片方だけ失敗して不完全な結果を正常値として表示することを防ぐため、
    // どちらのクエリも.catch()で握りつぶさず、失敗はそのまま外側のtry/catchに
    // 伝播させて集計全体を失敗として扱う。
    const fetchRetailRangeOrders = async (from, to) => {
      if (!tenantId || !from || !to) return;
      // 素早い連続リクエストで、先発のリクエストが後発の結果を上書きしないよう、
      // このリクエスト固有のIDを発行し、応答時に「まだ最新か」を確認する
      const requestId = ++retailRangeRequestIdRef.current;
      setRetailRangeLoading(true);
      // 失敗時に前回（別期間）の結果を残したまま新しい期間のラベルで表示してしまうと、
      // 不完全・不正確な集計値を正常値であるかのように見せることになるため、
      // 取得開始時点で必ずクリアする（fetchWsSummaryOrdersと同じ安全側の挙動に統一）
      setRetailRangeOrders(null);
      // 「未取得（30日分にフォールバック可）」と「取得失敗」を区別するため、
      // 取得開始時点でエラーフラグも必ずクリアする
      setRetailRangeError(false);
      try {
        const { start, endExclusive } = toJstDayRange(from, to);
        const s = Timestamp.fromDate(start);
        const e = Timestamp.fromDate(endExclusive);
        const [snap1, snap2] = await Promise.all([
          getDocs(query(
            collection(db, "orders"),
            where("tenantId", "==", tenantId), where("status", "==", "納品書発行"),
            where("issuedAt", ">=", s), where("issuedAt", "<", e)
          )),
          getDocs(query(
            collection(db, "orders"),
            where("retailTenantIdFromShop", "==", tenantId), where("status", "==", "納品書発行"),
            where("issuedAt", ">=", s), where("issuedAt", "<", e)
          )),
        ]);
        if (requestId !== retailRangeRequestIdRef.current) return; // 後続リクエストに追い越された
        const map = new Map();
        [...snap1.docs, ...snap2.docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));
        setRetailRangeOrders(Array.from(map.values()).filter(isDeliveredAndCounted).sort((a, b) => {
          const ta = typeof a.issuedAt?.toMillis === "function" ? a.issuedAt.toMillis() : Number(a.issuedAt || 0);
          const tb = typeof b.issuedAt?.toMillis === "function" ? b.issuedAt.toMillis() : Number(b.issuedAt || 0);
          return tb - ta;
        }));
      } catch (e) {
        if (requestId !== retailRangeRequestIdRef.current) return; // 後続リクエストに追い越された
        console.error(e);
        // エラー時は「未取得」として30日分の簡易表示にフォールバックしてはならない
        // （指定した期間と異なる不完全なデータを、あたかも取得結果であるかのように
        // 見せてしまうため）。retailRangeErrorをtrueにして、表示側で明示的に
        // エラー状態と分かるようにする
        setRetailRangeError(true);
        alert(isAU ? "Failed to load summary data. Please try again." : "集計データの取得に失敗しました。再度お試しください。");
      } finally {
        if (requestId === retailRangeRequestIdRef.current) setRetailRangeLoading(false);
      }
    };

    // ✅ 小売 仕入先別・商品別ランキングタブ用。ランキングUIは「当月」〜「1年」まで
    // 選択できるが、集計は必ずissuedAtベース・tenantId/retailTenantIdFromShop和集合
    // クエリで取得したデータのみを使う（30日/50件制限のグローバル購読ordersステートを
    // データソースにすると、選択期間より短い範囲しか反映されず、卸売上集計・請求候補
    // 合計と食い違う）
    useEffect(() => {
      if (!tenantId || mode !== "retail" || !retailRankStart || !retailRankEnd) return;
      if (new Date(retailRankStart) > new Date(retailRankEnd)) return;
      let cancelled = false;
      setRetailRankRangeOrders(null);
      setRetailRankRangeError(false);
      (async () => {
        try {
          const { start, endExclusive } = toJstDayRange(retailRankStart, retailRankEnd);
          const s = Timestamp.fromDate(start);
          const e = Timestamp.fromDate(endExclusive);
          // 2クエリのどちらかが失敗した場合、不完全な結果を正常値として表示しては
          // ならないため、片方だけを空扱いにして握りつぶさず、両方を必須として扱う
          const [snap1, snap2] = await Promise.all([
            getDocs(query(
              collection(db, "orders"),
              where("tenantId", "==", tenantId), where("status", "==", "納品書発行"),
              where("issuedAt", ">=", s), where("issuedAt", "<", e)
            )),
            getDocs(query(
              collection(db, "orders"),
              where("retailTenantIdFromShop", "==", tenantId), where("status", "==", "納品書発行"),
              where("issuedAt", ">=", s), where("issuedAt", "<", e)
            )),
          ]);
          if (cancelled) return;
          const map = new Map();
          [...snap1.docs, ...snap2.docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));
          setRetailRankRangeOrders(Array.from(map.values()).filter(isDeliveredAndCounted));
        } catch (e) {
          console.error("[retailRankRangeOrders fetch error]", e);
          if (!cancelled) {
            setRetailRankRangeError(true);
            alert(isAU ? "Failed to load summary data. Please try again." : "集計データの取得に失敗しました。再度お試しください。");
          }
        }
      })();
      return () => { cancelled = true; };
    }, [tenantId, mode, retailRankStart, retailRankEnd]);

    // ✅ 請求書発行用：指定期間・指定取引先の「納品実績」をFirestoreから取得する。
    // 請求書発行は「未請求債権を管理する機能」ではなく、指定期間の納品実績を
    // そのまま請求書にする単純な機能とする（2026-08 仕様簡素化）。
    // 表示・請求対象の唯一の条件は status=="納品書発行" AND 対象取引先 AND
    // issuedAtが指定期間内 AND 非test/demo のみであり、過去にいずれかの請求書へ
    // 含めたことがあるか（billedInvoiceId/isUnbilled）は一切参照しない。
    // 同一期間を何度指定しても、過去に請求書を発行済みかどうかに関わらず毎回
    // 同じ納品実績・同じ金額が表示され、同一期間・同一取引先への再発行も許容する。
    // この結果はissueBilling呼び出し自体には渡さない（標準経路はshopId・期間のみ
    // 送信し、サーバーが同一トランザクション内で同じ条件により対象を権威的に
    // 再決定する——プレビューとissueBillingは常に同じ集合を対象とする）。
    // 取引先照合はresolveCounterpartyKey(o, "fromWholesale")による正規識別子で行う。
    const fetchBillingOrders = async (shopId, from, to) => {
      if (!tenantId || !from || !to) return;
      setBillingFetching(true);
      try {
        // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：請求期間の
        // プレビューもissueBilling（サーバー側）と同じtenantProfile.timezoneを
        // 基準にする——プレビューとissueBillingが異なる期間境界を見てしまうと、
        // 「プレビューに出た注文と実際に発行された請求書の対象が食い違う」という
        // 致命的な不整合が起きるため
        const { start, endExclusive } = toJstDayRange(from, to, tenantProfile?.timezone || "Asia/Tokyo");
        const s = Timestamp.fromDate(start);
        const e = Timestamp.fromDate(endExclusive);
        // 片側クエリだけが失敗した場合に、残った側だけで「完全な期間実績」であるかのように
        // 見せてしまうと、発行直前のユーザー判断を誤らせる（実際にissueBillingが確定させる
        // 対象とプレビューが食い違って見える）。そのため個別に.catch()で握りつぶさず、
        // どちらか一方でも失敗したらプレビュー全体を失敗として扱う
        const [snap1, snap2] = await Promise.all([
          getDocs(query(collection(db, "orders"),
            where("tenantId", "==", tenantId), where("status", "==", "納品書発行"),
            where("issuedAt", ">=", s), where("issuedAt", "<", e))),
          getDocs(query(collection(db, "orders"),
            where("wholesaleTenantId", "==", tenantId), where("status", "==", "納品書発行"),
            where("issuedAt", ">=", s), where("issuedAt", "<", e))),
        ]);
        const map = new Map();
        [...snap1.docs, ...snap2.docs].forEach(d => map.set(d.id, { id: d.id, ...d.data() }));

        const shopDataForKey = (shops || []).find(sp => String(sp.id || sp._docId) === String(shopId));
        const selectedKey = shopDataForKey
          ? (shopDataForKey.retailTenantId
              ? { kind: "tenant", id: shopDataForKey.retailTenantId }
              : { kind: "shop", id: shopDataForKey.id || shopDataForKey._docId })
          : null;

        const all = Array.from(map.values()).filter(o => {
          if (!isDeliveredAndCounted(o)) return false;
          if (!shopId) return true;
          if (!selectedKey) return false;
          return partnerKeyEquals(resolveCounterpartyKey(o, "fromWholesale"), selectedKey);
        }).sort((a, b) => {
          const ta = typeof a.issuedAt?.toMillis === "function" ? a.issuedAt.toMillis() : 0;
          const tb = typeof b.issuedAt?.toMillis === "function" ? b.issuedAt.toMillis() : 0;
          return ta - tb;
        });
        setBillingFetchedOrders(all);
        setBillingFetchError(false);
      } catch (e) {
        console.error(e);
        // 不完全な期間実績を正常値として表示しない。nullのままにしてエラー表示に倒す
        setBillingFetchedOrders(null);
        setBillingFetchError(true);
        alert((isAU ? "Failed to load deliveries: " : "納品実績取得エラー: ") + e.message);
      } finally {
        setBillingFetching(false);
      }
    };

    // ✅ 発行済み請求書の履歴一覧を取得する。指定期間の納品実績（billingFetchedOrders/
    // fetchBillingOrders）とは完全に独立したstate・処理であり、この結果が
    // 期間実績へ混ざることは絶対にない（issueBillingへの入力にもならない、
    // read-onlyな表示専用）。invoices履歴は「A.指定期間の納品実績」とは別概念の
    // 「B.過去に発行した請求書」を表示するためだけのものであり、invoiceの存在が
    // 期間実績（A）を消すことは絶対にない。
    // tenantId==自テナント かつ shopId==選択中の取引先 で絞り込む——tenantIdの
    // 等号条件がFirestore Security Rulesのlist許可条件と一致することがテナント
    // 境界を守る前提（firestore.rules:230-233参照）
    const fetchBillingIssuedInvoices = async (shopId) => {
      // 取引先を素早く切り替えた場合、後から解決した古いリクエストの結果が
      // 現在選択中の取引先のstateを上書きしないよう、世代カウンターでガードする
      // （A選択→即B選択のような操作で、Aのレスポンスが後から返ってきてもBの
      // 画面にAの請求書が表示されてしまうことを防ぐ）
      billingIssuedRequestGenerationRef.current += 1;
      const generation = billingIssuedRequestGenerationRef.current;

      if (!tenantId || !shopId) {
        if (generation === billingIssuedRequestGenerationRef.current) {
          setBillingIssuedInvoices(null);
          setBillingIssuedError(false);
        }
        return;
      }
      setBillingIssuedLoading(true);
      try {
        const snap = await getDocs(query(
          collection(db, "invoices"),
          where("tenantId", "==", tenantId),
          where("shopId", "==", shopId),
          orderBy("createdAt", "desc"),
          limit(50)
        ));
        if (generation !== billingIssuedRequestGenerationRef.current) return; // 古い世代の結果は無視
        const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setBillingIssuedInvoices(list);
        setBillingIssuedError(false);
      } catch (e) {
        console.error("[billing issued invoices fetch error]", e);
        if (generation !== billingIssuedRequestGenerationRef.current) return; // 古い世代の結果は無視
        // 空一覧を正常値として表示しない。nullのままエラー表示に倒す
        setBillingIssuedInvoices(null);
        setBillingIssuedError(true);
      } finally {
        if (generation === billingIssuedRequestGenerationRef.current) {
          setBillingIssuedLoading(false);
        }
      }
    };

    // ✅ 発行済み請求書のPDF表示/再印刷。保存済みPDFを第一選択とし
    // （getPartnerPdfUrl経由の署名URL、write-once保存された発行時点の厳密な記録）、
    // PDFがStorageに存在しない場合のみ、invoiceドキュメントのデータ
    // （invoiceItems・billedPartySnapshot、いずれも発行時点の不変スナップショット）
    // からprintBillingPopupで再構成表示するフォールバックを使う
    const viewOrReprintInvoice = async (invoice) => {
      const invoiceId = invoice.id;
      setBillingPdfLoadingId(invoiceId);
      try {
        const getPartnerPdfUrlFn = httpsCallable(functions, "getPartnerPdfUrl");
        const result = await getPartnerPdfUrlFn({ documentType: "billing", documentId: invoiceId });
        const url = result?.data?.url;
        if (url) {
          window.open(url, "_blank", "noopener,noreferrer");
          return;
        }
        // 成功応答なのにurlが空/欠落しているのは想定外の不正な応答であり、
        // 「保存済みPDFが存在しない」ことの確証にはならない（サーバー側の応答不備を
        // PDF未生成と誤認してフォールバックしてしまうと、実際には存在するPDFが
        // 見過ごされる可能性がある）。フォールバックせず明示的にエラー表示する
        console.error("[getPartnerPdfUrl] success response missing url", result?.data);
        alert(isAU ? "The PDF result was invalid. Please try again shortly." : "PDFの取得結果が不正です。しばらくしてから再試行してください。");
      } catch (e) {
        // フォールバック（invoiceデータからの再構成表示）は、サーバー側が
        // 「認可は通過したが保存済みPDFが存在しない」ことを明示的に示すエラー
        // （failed-precondition + "PDF_NOT_FOUND"、functions/index.js:getPartnerPdfUrl）
        // の場合のみに限定する。認可失敗は意図的に別のエラーコード(not-found)で
        // 返るため、この分岐では絶対にフォールバックしない——認可失敗時に
        // フォールバックしてしまうと、権限のない相手にも請求書データ
        // （invoiceItems・billedPartySnapshot）を使った再構成表示を許してしまう。
        // レート制限・メンテナンス中・通信障害等、その他のエラーもフォールバックせず
        // 明示的にエラーを伝え、再試行を促す（要件3：保存済みPDFの誤った取りこぼし防止）
        const code = e?.code || "";
        const reason = e?.details?.reason || "";
        if (code === "functions/failed-precondition" && reason === "PDF_NOT_FOUND") {
          printBillingPopup({ invoiceId, invoice });
        } else {
          console.error("[getPartnerPdfUrl error]", e);
          alert((isAU ? "Failed to load the PDF. Please try again shortly.: " : "PDFの取得に失敗しました。しばらくしてから再試行してください。: ") + (e?.message || String(e)));
        }
      } finally {
        setBillingPdfLoadingId(null);
      }
    };

    // 取引先選択が変わるたびに発行済み請求書履歴を再取得する。未請求候補
    // （billingFetchedOrders）とは別state・別トリガーであり、互いに干渉しない
    useEffect(() => {
      if (mode !== "wholesale" || wholesaleView !== "billing") return;
      if (!billingShopId) {
        setBillingIssuedInvoices(null);
        setBillingIssuedError(false);
        return;
      }
      fetchBillingIssuedInvoices(billingShopId);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, wholesaleView, billingShopId, tenantId]);

    const openSupAdd = () => {
      setSupMode("add");
      setSupEditingId(null);
      setSupName("");
      setSupCompany("");
      setSupAddress("");
      setSupTel("");
      setSupFax("");
      setSupNote("");
      setSupEmail("");
      setSupInvoiceNo("");
      setSupWholesaleTenantId("");
      setSupModalOpen(true);
    };

    const openSupEdit = (s) => {
      setSupMode("edit");
      setSupEditingId(s?._docId || s?.id || null);
      setSupName(String(s?.name || ""));
      setSupCompany(String(s?.company || ""));
      setSupAddress(String(s?.address || ""));
      setSupTel(String(s?.tel || ""));
      setSupFax(String(s?.fax || ""));
      setSupNote(String(s?.note || ""));
      setSupEmail(String(s?.email || ""));
      setSupInvoiceNo(String(s?.invoiceNo || ""));
      setSupWholesaleTenantId(String(s?.wholesaleTenantId || ""));
      setSupModalOpen(true);
    };

    const closeSupModal = () => setSupModalOpen(false);

    const saveSupplier = async () => {
      if (!tenantId) return alert(isAU ? "Missing tenantId" : "tenantId がありません");

      const name = String(supName || "").trim();
      if (!name) return alert(isAU ? "Please enter a supplier name" : "仕入先名を入力してください");

      // Rulesのsuppliers updateブロックが許可するフィールドのみ。
      // tenantId/source は不変、supplierId/wholesaleTenantId はcreate時も送信禁止。
      const data = {
        name,
        company: String(supCompany || "").trim(),
        address: String(supAddress || "").trim(),
        tel: String(supTel || "").trim(),
        fax: String(supFax || "").trim(),
        note: String(supNote || "").trim(),
        email: String(supEmail || "").trim(),
        invoiceNo: String(supInvoiceNo || "").trim(),
        updatedAt: serverTimestamp(),
      };

      try {
        if (supMode === "add") {
          await addDoc(collection(db, "suppliers"), {
            ...data,
            tenantId: String(tenantId),
            source: "manual",
            createdAt: serverTimestamp(),
          });
          showToast(isAU ? "Supplier added" : "仕入先を追加しました");
        } else {
          if (!supEditingId) return alert(isAU ? "Missing edit ID" : "編集IDがありません");
          await updateDoc(doc(db, "suppliers", supEditingId), data);
          showToast(isAU ? "Supplier updated" : "仕入先を更新しました");
        }
        setSupModalOpen(false);
      } catch (e) {
        console.error(e);
        alert(e?.message || String(e));
      }
    };


    // ✅ 仕入先削除（置き換え版）
    const deleteSupplier = async (s) => {
      if (!tenantId) return showToast(isAU ? "Please log in" : "ログインしてください");

      // ✅ _docId 優先。無ければ id。
      const docId = s?._docId || s?.id;
      if (!docId) return showToast(isAU ? "Could not find the item to delete" : "削除対象が見つかりません");

      // 接続由来（sup__/shop__）のレコードはRulesで削除不可。解除は接続解除機能から行う
      if (/^(shop|sup)__/.test(String(docId))) {
        showToast(isAU ? "This supplier is connected. Disconnect first to remove it." : "接続中の取引先です。削除するには接続を解除してください");
        return;
      }

      const ok = window.confirm(isAU ? `Delete "${s?.name || ""}"? Are you sure?` : `「${s?.name || ""}」を削除します。よろしいですか？`);
      if (!ok) return;

      try {
        await deleteDoc(doc(db, "suppliers", docId));
        showToast(isAU ? "Supplier deleted" : "仕入れ先を削除しました");
      } catch (e) {
        console.error(e);
        showToast(e?.message ? (isAU ? `Failed to delete: ${e.message}` : `削除に失敗しました: ${e.message}`) : (isAU ? "Failed to delete" : "削除に失敗しました"));
      }
    };

    // ===== shops CRUD（卸モード用取引先） =====
    const openShopAdd = () => {
      setShopModalMode("add");
      setShopEditingId(null);
      setShopModalName("");
      setShopModalCompany("");
      setShopModalAddress("");
      setShopModalTel("");
      setShopModalFax("");
      setShopModalNote("");
      setShopModalEmail("");
      setShopModalInvoiceNo("");
      setShopModalClosingDay("0");
      setShopModalPaymentDays("30");
      setShopModalOpen(true);
    };
    const openShopEdit = (s) => {
      setShopModalMode("edit");
      setShopEditingId(s._docId || s.id);
      setShopModalName(String(s.name || ""));
      setShopModalCompany(String(s.company || ""));
      setShopModalAddress(String(s.address || ""));
      setShopModalTel(String(s.tel || ""));
      setShopModalFax(String(s.fax || ""));
      setShopModalNote(String(s.note || ""));
      setShopModalEmail(String(s.email || ""));
      setShopModalInvoiceNo(String(s.invoiceNo || ""));
      setShopModalClosingDay(String(s.closingDay ?? "0"));
      setShopModalPaymentDays(String(s.paymentDays ?? "30"));
      setShopModalOpen(true);
    };
    const closeShopModal = () => setShopModalOpen(false);
    const saveShop = async () => {
      if (!tenantId) return alert(isAU ? "Please log in" : "ログインしてください");
      // ── サブスクリプションガード ──
      if (!isSubscribed) { setShowExpiredModal(true); return; }
      const name = String(shopModalName || "").trim();
      if (!name) return alert(isAU ? "Please enter a store name" : "店名を入力してください");
      // Rulesのsuppliers updateブロックが許可するフィールドのみ（tenantId/source/isShopは不変）
      const data = {
        name,
        company: String(shopModalCompany || "").trim(),
        address: String(shopModalAddress || "").trim(),
        tel: String(shopModalTel || "").trim(),
        fax: String(shopModalFax || "").trim(),
        note: String(shopModalNote || "").trim(),
        email: String(shopModalEmail || "").trim(),
        invoiceNo: String(shopModalInvoiceNo || "").trim(),
        closingDay: Number(shopModalClosingDay ?? 0),    // 締め日（0=末日）
        paymentDays: Number(shopModalPaymentDays ?? 30), // 支払期限（日数）
        updatedAt: serverTimestamp(),
      };
      try {
        if (shopModalMode === "add") {
          await addDoc(collection(db, "suppliers"), {
            ...data,
            tenantId,
            source: "manual",
            isShop: true,
            createdAt: serverTimestamp(),
          });
          showToast(isAU ? "Customer added" : "取引先を追加しました");
        } else {
          if (!shopEditingId) return alert(isAU ? "Missing edit ID" : "編集IDがありません");
          await updateDoc(doc(db, "suppliers", shopEditingId), data);
          showToast(isAU ? "Customer updated" : "取引先を更新しました");
        }
        setShopModalOpen(false);
      } catch (e) {
        console.error(e);
        alert(e?.message || String(e));
      }
    };
    const deleteShop = async (s) => {
      if (!tenantId) return showToast(isAU ? "Please log in" : "ログインしてください");
      const docId = s._docId || s.id;
      if (!docId) return showToast(isAU ? "Could not find the item to delete" : "削除対象が見つかりません");
      // 接続由来（shop__/sup__）のレコードはRulesで削除不可。解除は接続解除機能から行う
      if (/^(shop|sup)__/.test(String(docId))) {
        showToast(isAU ? "This customer is connected. Disconnect first to remove it." : "接続中の取引先です。削除するには接続を解除してください");
        return;
      }
      const ok = window.confirm(isAU ? `Delete "${s?.name || ""}"? Are you sure?` : `「${s?.name || ""}」を削除します。よろしいですか？`);
      if (!ok) return;
      try {
        await deleteDoc(doc(db, "suppliers", docId));
        showToast(isAU ? "Customer deleted" : "取引先を削除しました");
      } catch (e) {
        console.error(e);
        showToast(e?.message ? (isAU ? `Failed to delete: ${e.message}` : `削除に失敗しました: ${e.message}`) : (isAU ? "Failed to delete" : "削除に失敗しました"));
      }
    };

    // 2026-08（Codexレビュー3回目MUST-FIX対応）：手書き受注の単価解決を単一の
    // 関数に一本化する。以前はプレビュー計算（mSubtotal/mTax・明細リスト表示）が
    // 明細自身のcostPrice/priceだけを見ていた一方、保存処理（saveManualOrderInner）は
    // 商品マスタ（catalog）に同一商品が見つかればmasterProduct.costPriceを優先する
    // 設計になっており、手動編集値とカタログ値が食い違う場合や、商品マスタ更新後に
    // ローカルcatalogの反映が遅れている場合に、画面表示された金額と実際の保存単価が
    // 異なってしまっていた。プレビュー・保存の両方が必ずこの関数を通ることで、
    // 「どちらの値を優先するか」の判断が1箇所に集約される
    const resolveManualLineUnitPrice = (l, roundFn) => {
      const masterProduct = (catalog || []).find(p =>
        (l.barcode && String(p.barcode || "") === String(l.barcode)) ||
        (l.id && p.id === l.id)
      );
      const rawCostVal = Number(l.costPrice ?? 0) > 0 ? Number(l.costPrice) : Number(l.price ?? 0);
      const costVal = roundFn(rawCostVal);
      // 発注単価（集計・請求が参照する値）はマスタのcostPriceを最優先。
      // マスタに見つからない場合のみ明細入力値へフォールバックする
      const priceVal = masterProduct?.costPrice > 0 ? roundFn(Number(masterProduct.costPrice)) : costVal;
      const taxRate = masterProduct?.taxRate != null ? Number(masterProduct.taxRate) : Number(l.taxRate);
      return { costVal, priceVal, taxRate, masterProduct };
    };

    // ===== 手書き受注保存 =====
    const saveManualOrder = async (goDelivery = false, linesOverride = null) => {
      // 2026-08 重複発注防止：submitOrderと同じ二重構造（同期ref lock＋UI表示用state）。
      // 「受注登録」ボタンの連打・二重保存を防ぐ
      if (manualOrderLockRef.current) return;
      manualOrderLockRef.current = true;
      setIsSavingManualOrder(true);
      try {
        await saveManualOrderInner(goDelivery, linesOverride);
      } finally {
        manualOrderLockRef.current = false;
        setIsSavingManualOrder(false);
      }
    };

    const saveManualOrderInner = async (goDelivery = false, linesOverride = null) => {
      if (!tenantId) return alert(isAU ? "Please log in" : "ログインしてください");
      // ── サブスクリプションガード ──
      if (!isSubscribed) { setShowExpiredModal(true); return; }
      if (!manualShopId) return alert(isAU ? "Please select a customer (retailer)" : "取引先（小売店）を選択してください");
      const sourceLines = linesOverride || manualLines;
      if (sourceLines.length === 0) return alert(isAU ? "Please enter at least one line item" : "明細を1行以上入力してください");

      // ✅ 原価ガード：原価 0/空 の明細が1件でもあれば確定不可
      const missingCostLines = sourceLines.filter(l => {
        const cp = Number(l.costPrice ?? 0);
        const p = Number(l.price ?? 0);
        return !(cp > 0 || p > 0);
      });
      if (missingCostLines.length > 0) {
        alert(isAU
          ? `${missingCostLines.length} line item(s) have no cost price set.\n` +
            missingCostLines.map((l) => `- ${l.name || "Unknown"}`).join("\n") +
            "\n\nPlease enter a cost price for all items before registering."
          : `原価未登録の明細が ${missingCostLines.length} 件あります。\n` +
            missingCostLines.map((l) => `・${l.name || "不明"}`).join("\n") +
            "\n\n原価をすべて入力してから登録してください。"
        );
        return;
      }

      const shop = shops.find(s => s.id === manualShopId || s._docId === manualShopId) || {};

      // 2026-08 緊急修正：line.priceは「小売→卸の発注単価（costPrice、UI表示名「発注単価」）」に
      // 統一する。以前はplaceOrderがproduct.sellPrice（小売販売価格＝卸取引に無関係な消費者向け
      // 価格）を参照している前提でline.priceをsellVal（sellPrice優先）に合わせていたが、
      // placeOrder側のフィールド参照自体が取り違えバグだったため、その前提ごと誤りだった。
      // 今回placeOrderをcostPrice参照に修正したため、手書き注文側も同じcostPriceへ統一する
      // （sellPriceを請求単価に使うと、卸の集計・請求が消費者向け価格で計算されてしまう）
      // 2026-08 AU版基盤（Phase 3、Codexレビュー指摘対応・MUST-FIX）：以前はroundJPYが
      // 固定で使われており、AU注文の明細（例：A$19.95）がCallable送信前にA$20へ
      // 丸められてしまっていた。さらに3回目レビューで、プレビューと保存が別々に
      // マスタ解決ロジックを実装していたため単価ソース自体が食い違うケースが
      // あることが判明し、resolveManualLineUnitPrice関数へ一本化した
      const manualSubmitRoundFn = isAU ? roundAUD : roundJPY;
      const lines = sourceLines.map(l => {
        const { costVal, priceVal, taxRate } = resolveManualLineUnitPrice(l, manualSubmitRoundFn);
        return {
          id: l.id || `M-${Date.now()}-${Math.random()}`,
          barcode: l.barcode || "",
          name: l.name || "",
          unit: l.unit || "",
          innerCount: Math.max(1, Math.round(Number(l.innerCount ?? 1) || 1)),
          price: priceVal,             // 発注単価 — 集計・請求はこれを参照する
          costPrice: costVal,          // 原価スナップショット
          costPriceSnapshot: costVal,  // 明示的に原価スナップ
          // 0.1への推測フォールバックはしない。マスタ値優先、なければ明細入力値をそのまま渡し、
          // 不正ならcreateManualOrder Callable側のassertValidTaxRateがfail-closedで拒否する
          taxRate,
          qty: Number(l.qty || 0),
        };
      });
      // 金額はcreateManualOrder Callableがサーバー側で再計算・確定する

      // この保存操作専用のrequestId。連打・再試行は同じIDを再利用し、
      // サーバー側idempotencyで1件に集約される。成功後にのみリセットする
      if (!manualOrderRequestIdRef.current) {
        manualOrderRequestIdRef.current = generateRequestId();
      }
      const requestId = manualOrderRequestIdRef.current;

      try {
        // 注文番号・納品書番号の採番、counters更新、orderSnapshot生成はすべて
        // createManualOrder Callableがトランザクション内で行う（ordersのcreateはRulesで禁止）
        const createManualOrderFn = httpsCallable(functions, "createManualOrder");
        const result = await createManualOrderFn({
          retailShopId: shop._docId || manualShopId,
          lines,
          note: manualNote.trim(),
          issueDeliveryImmediately: !!goDelivery,
          requestId,
        });
        const orderNo = result?.data?.orderNo;
        const newOrderId = result?.data?.orderId;
        showToast(isAU ? `Order registered (Order No. ${orderNo})` : `受注登録しました（注文No. ${orderNo}）`);
        // フォームリセット
        setManualShopId("");
        setManualLines([]);
        setManualNote("");
        // 画面遷移・フォームリセットが完了した後にrequestIdを破棄する
        manualOrderRequestIdRef.current = null;

        if (goDelivery) {
          // 発行済みの納品書情報をサーバー側の確定値から読み直して印刷する
          let issuedOrder = null;
          try {
            const osnap = await getDoc(doc(db, "orders", newOrderId));
            if (osnap.exists()) issuedOrder = { id: osnap.id, ...osnap.data() };
          } catch (e) {
            console.warn("[手書き受注] 発行後の注文取得に失敗", e);
          }
          setWholesaleView("orders");
          if (issuedOrder?.deliveryNo) {
            showToast(isAU ? `Delivery Note No. ${issuedOrder.deliveryNo} issued` : `納品書No. ${issuedOrder.deliveryNo} を発行しました`);
            printDeliveryPopup(issuedOrder, issuedOrder.deliveryNo, issuedOrder.issuedAt);
          }
        } else {
          setWholesaleView("orders");
        }
      } catch (e) {
        console.error(e);
        alert(e?.message || String(e));
      }
    };




    async function seedInitialProductsIfEmpty() {
  // ✅ 未ログイン（tenantIdなし）では何もしない（alertしない）
  if (!tenantId) return;

  try {
    // 1) products が空かチェック
    const qProducts = query(collection(db, "products"), where("tenantId", "==", tenantId));
    const prodSnap = await getDocs(qProducts);
    if (!prodSnap.empty) {
      // alertやめたいなら return だけでOK
      // showToast があるなら showToast(`productsが既にあります: ${prodSnap.size}件`);
      return;
    }

    // 2) suppliers が存在するか確認
    const qSup = query(collection(db, "suppliers"), where("tenantId", "==", tenantId));
    const supSnap = await getDocs(qSup);
    if (supSnap.empty) {
      // showToast があるなら showToast("先に suppliers初期投入 を押してください");
      return;
    }

    // 3) デモ商品（supplierId を直指定）
    const init = [
      { supplierId: "s1", barcode: "4900000000011", name: "キャベツ", unit: "玉", sellPrice: 180, taxRate: 0.1 },
      { supplierId: "s1", barcode: "4900000000028", name: "トマト", unit: "kg", sellPrice: 480, taxRate: 0.1 },
      { supplierId: "s2", barcode: "4900000000035", name: "豚バラ", unit: "kg", sellPrice: 1280, taxRate: 0.1 },
      { supplierId: "s3", barcode: "4900000000042", name: "サーモン", unit: "切", sellPrice: 380, taxRate: 0.1 },
    ];

    for (const p of init) {
      await addDoc(collection(db, "products"), {
        tenantId,
        supplierId: p.supplierId,

        barcode: String(p.barcode || ""),
        name: String(p.name || ""),
        nameNormalized: normalizeKana(String(p.name || "")),
        searchTokens: buildProductSearchTokens(String(p.name || "")),
        unit: String(p.unit || ""),

        // ✅ いまの設計（原価/売価）に合わせる
       costPrice: toNum(p.costPrice, 0),
sellPrice: toNum(p.sellPrice, 0),


        taxRate: Number(p.taxRate ?? 0.1),
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
    }

    // showToast("products初期投入 完了");
  } catch (e) {
    console.error(e);
    // showToast(`products初期投入でエラー: ${e?.message || e}`);
  }
}

  // ===== 卸：初回オンボーディング用サンプル商品投入 =====
  async function seedWholesaleSampleProducts() {
    if (!tenantId) return;
    try {
      const snap = await getDocs(query(collection(db, "products"), where("tenantId", "==", tenantId)));
      if (!snap.empty) { showToast(isAU ? "Products already exist" : "商品がすでにあります"); return; }
      // 2026-08（Codexレビュー指摘対応・MUST-FIX）：サンプルデータ自体が日本の
      // 食材名・8%軽減税率固定でハードコードされており、AU版UIから到達可能な
      // ボタン（"Add sample products"）経由でAU顧客にも表示されてしまっていた
      const samples = isAU
        ? [
            { name: "Cabbage",       unit: "each", sellPrice: 4.5,  taxRate: 0.10 },
            { name: "Tomato",        unit: "kg",   sellPrice: 6.9,  taxRate: 0.10 },
            { name: "Pork Belly",    unit: "kg",   sellPrice: 18.5, taxRate: 0.10 },
            { name: "Salmon Fillet", unit: "each", sellPrice: 9.9,  taxRate: 0.10 },
            { name: "Leek",          unit: "each", sellPrice: 2.2,  taxRate: 0.10 },
          ]
        : [
            { name: "キャベツ",   unit: "玉", sellPrice: 180,  taxRate: 0.08 },
            { name: "トマト",     unit: "kg", sellPrice: 480,  taxRate: 0.08 },
            { name: "豚バラ肉",   unit: "kg", sellPrice: 1280, taxRate: 0.08 },
            { name: "サーモン",   unit: "切", sellPrice: 380,  taxRate: 0.08 },
            { name: "白ネギ",     unit: "本", sellPrice: 120,  taxRate: 0.08 },
          ];
      for (const p of samples) {
        await addDoc(collection(db, "products"), {
          tenantId,
          supplierId: tenantId,
          barcode: "",
          name: p.name,
          nameNormalized: normalizeKana(p.name),
          searchTokens: buildProductSearchTokens(p.name),
          unit: p.unit,
          costPrice: 0,
          sellPrice: p.sellPrice,
          taxRate: p.taxRate,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        });
      }
      showToast(isAU ? 'Added 5 sample products. You can edit or remove them from "Products".' : "サンプル商品を5件追加しました。「商品登録」で編集・削除できます");
    } catch (e) {
      console.error(e);
      showToast(isAU ? "An error occurred" : "エラーが発生しました");
    }
  }

  // ===== 小売：初回オンボーディング用テスト発注作成 =====
  async function createSampleRetailOrder() {
    if (!tenantId) return;
    const wtid = _effectiveWholesaleTid;
    if (!wtid) { showToast(isAU ? "You need to connect with a supplier first (Settings > invite code)" : "先に卸との接続が必要です（設定から招待コードで接続）"); return; }
    try {
      const snap = await getDocs(query(collection(db, "products"), where("tenantId", "==", wtid)));
      if (snap.empty) { showToast(isAU ? "Your supplier doesn't have any products yet" : "卸側にまだ商品がありません"); return; }
      const items = snap.docs.slice(0, 3).map(d => ({ id: d.id, ...d.data() }));
      const lines = items.map(p => {
        const costVal = Number(p.costPrice ?? 0);
        return {
          id: p.id,
          name: p.name || "",
          qty: 2,
          unit: p.unit || "",
          price: costVal,           // 互換用：原価
          costPrice: costVal,       // 原価スナップショット
          taxRate: p.taxRate ?? 0.1,
          barcode: p.barcode || "",
        };
      });
      // ordersのcreateはRulesで禁止のため、placeOrder Callable経由で作成する。
      // 明細内容・金額・注文番号はすべてサーバー側で商品マスタから再計算される。
      // 2026-08（Step 12 E2E検証時に発覚したバグ対応・MUST-FIX）：requestId未指定
      // だったため、サーバー側buildIdempotencyKeyDocIdのフォーマットチェックに
      // 落ち、テスト発注（Sample Retailer機能）が常に"requestIdの形式が不正です"
      // で失敗していた。他のplaceOrder呼び出しと同様generateRequestId()で発行する
      const placeOrderFn = httpsCallable(functions, "placeOrder");
      await placeOrderFn({
        wholesaleTenantId: wtid,
        lines: lines.map(l => ({ productDocId: l.id, qty: l.qty })),
        note: "",
        scheduledDeliveryDate: null,
        requestId: generateRequestId(),
      });
      showToast(isAU ? 'Test order created! Check the "History" tab.' : "テスト発注を作成しました！「履歴」タブで確認できます");
    } catch (e) {
      console.error(e);
      showToast(isAU ? "An error occurred" : "エラーが発生しました");
    }
  }

    // ===== derived: products by supplier（クライアントサイド検索・フィルタ）=====
    const products = useMemo(() => {
      if (!supplierId) return [];
      let list = catalog || [];
      // キーワード検索（部分一致 + カナ正規化）
      const kw = normalizeKana(String(catalogSearch || "").trim());
      if (kw) {
        list = list.filter(
          (p) =>
            normalizeKana(String(p.name || "")).includes(kw) ||
            String(p.barcode || "").includes(catalogSearch.trim()) ||
            normalizeKana(String(p.category || "")).includes(kw)
        );
      }
      // カテゴリフィルタ（完全一致）
      const cat = String(catalogCategory || "").trim();
      if (cat) {
        list = list.filter((p) => String(p.category || "") === cat);
      }
      // 検索・フィルタなしの場合は発注頻度上位20件のみ表示（画面軽量化）
      if (!kw && !cat) {
        list = [...list]
          .sort((a, b) => (Number(b.orderCount) || 0) - (Number(a.orderCount) || 0))
          .slice(0, 20);
      }
      return list;
    }, [catalog, supplierId, catalogSearch, catalogCategory]);

    function selectSupplier(nextId) {
      setSupplierId(nextId);
      setLines([]);
      setSearchOpen(false);
      setSearchText("");
      setShowQuickList(false);
    }

    // ===== add line / qty control =====
    function add(product) {
      if (!product) return;

      if (!supplierSelected) {
        showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
        return;
      }

      // 仕入先チェック：卸接続済みの場合は wholesaleTenantId でも照合
      const supplierObj = suppliers.find(
        (s) => s.id === supplierId || s.supplierId === supplierId
      );
      const wholeTenantId = String(supplierObj?.wholesaleTenantId || "").trim();
      const pid = String(product?.supplierId || "").trim();
      const ptid = String(product?.tenantId || "").trim();
      const isFromSelectedSupplier =
        !pid || // supplierId 未設定の商品は許可
        pid === supplierId || // 手動仕入先の論理ID一致
        (wholeTenantId && (pid === wholeTenantId || ptid === wholeTenantId)); // 卸接続一致
      if (!isFromSelectedSupplier) {
        showToast(isAU ? "This product does not belong to the selected supplier" : "選択中の仕入れ先の商品ではありません");
        return;
      }

      setLines((prev) => {
        const idx = prev.findIndex((l) => l.id === product.id);
        if (idx >= 0) {
          const next = [...prev];
          next[idx] = { ...next[idx], qty: Number(next[idx].qty || 0) + 1 };
          return next;
        }
        return [...prev, { ...product, qty: 1 }];
      });
    }

    function setQty(lineId, qty) {
      const q = Number(qty);

      if (q <= 0) {
        const target = lines.find((l) => l.id === lineId);
        const name = target?.name || (isAU ? "this item" : "この商品");

        const ok = window.confirm(isAU ? `Remove "${name}" from the order?` : `「${name}」を明細から削除しますか？`);
        if (!ok) return;

        setLines((prev) => prev.filter((l) => l.id !== lineId));
        return;
      }

      setLines((prev) => prev.map((l) => (l.id === lineId ? { ...l, qty: q } : l)));
    }

    function inc(lineId, delta) {
      setLines((prev) =>
        prev
          .map((l) => {
            if (l.id !== lineId) return l;
            const q = Number(l.qty || 0) + delta;
            return { ...l, qty: q };
          })
          .filter((l) => Number(l.qty || 0) > 0)
      );
    }

    function removeLine(lineId) {
      setLines((prev) => prev.filter((l) => l.id !== lineId));
    }

   // ===== totals（calcOrderTotals に統一） =====
const { subtotal, taxTotal, total } = useMemo(() => {
  // 原価統一：卸・小売ともに getCostPriceStrict で価格解決してから calcOrderTotals へ
  const resolved = lines.map(l => ({
    ...l,
    price: getCostPriceStrict(l),
  }));
  const r = calcOrderTotals(resolved);
  return { subtotal: r.subtotal, taxTotal: r.taxTotal, total: r.grandTotal };
}, [lines]);



   // ================================
// ✅ find by barcode（supplierを正しく決めて検索）
// ================================
function getEffectiveSupplierId() {
  // 小売：選択した仕入れ先ID
  // 卸：自社(tenantId)を supplierId として扱う
  return mode === "wholesale"
    ? String(tenantId || "").trim()
    : String(supplierId || "").trim();
}

function ensureSupplierReady() {
  const sid = getEffectiveSupplierId();
  if (!sid) {
    feedbackOnScan?.();
    setLastScan?.(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
    setTimeout(() => setLastScan?.(""), 1200);
    showToast?.(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
    return null;
  }
  return sid;
}

function findByBarcode(code) {
  const c = String(code || "").trim();
  if (!c) return null;

  // 仕入先未選択チェック（supplierId の個別照合は catalog が既に正しくフィルタ済みのため不要）
  const sid = ensureSupplierReady();
  if (!sid) return null;

  // Excelインポート時に先頭ゼロが失われた場合の対応（例: "0490..." → "490..."）
  const stripLeadingZeros = (s) => String(s || "").trim().replace(/^0+(\d)/, "$1");
  const cNorm = stripLeadingZeros(c);

  // ✅ productsはUI表示用（未検索時は上位20件のみ）のため catalog を直接検索する
  const pool = catalog || [];
  return (
    pool.find(
      (p) =>
        String(p?.barcode || "").trim() === c ||
        stripLeadingZeros(p?.barcode) === cNorm
    ) || null
  );
}

// ================================
// ✅ add by barcode（未登録ならscanAddでモーダルへ）
// ================================
async function addByBarcode(code) {
  const sid = ensureSupplierReady();
  if (!sid) return;

  const bc = String(code || "").trim();
  if (!bc) return;

  let found = findByBarcode(bc);

  // ✅ catalogにない場合はFirestoreに直接問い合わせ（件数制限で漏れた商品を救済）
  if (!found) {
    try {
      const stripLeadingZeros = (s) => String(s || "").trim().replace(/^0+(\d)/, "$1");
      const bcNorm = stripLeadingZeros(bc);
      // 卸テナントIDを解決
      const wtid = (() => {
        if (mode === "wholesale") return tenantId;
        const sup = (suppliers || []).find(s => s.id === sid || s.supplierId === sid);
        return String(sup?.wholesaleTenantId || "").trim() || String(tenantProfile?.wholesaleTenantId || "").trim() || "";
      })();
      const searchTids = [...new Set([tenantId, wtid].filter(Boolean))];
      for (const tid of searchTids) {
        const snap = await getDocs(query(
          collection(db, "products"),
          where("tenantId", "==", tid),
          where("barcode", "==", bc)
        ));
        if (!snap.empty) { found = { ...snap.docs[0].data(), id: snap.docs[0].id, _docId: snap.docs[0].id }; break; }
        // 先頭ゼロ落ち対応
        if (bcNorm !== bc) {
          const snap2 = await getDocs(query(
            collection(db, "products"),
            where("tenantId", "==", tid),
            where("barcode", "==", bcNorm)
          ));
          if (!snap2.empty) { found = { ...snap2.docs[0].data(), id: snap2.docs[0].id, _docId: snap2.docs[0].id }; break; }
        }
      }
    } catch (e) {
      console.warn("[addByBarcode] Firestore fallback error:", e);
    }
  }

  if (found) {
    // ✅ ここが重要：lines に入れる時点で、明細に必要な情報を必ず持たせる
    const base = normalizeProductForLine(found) || {};

    // ✅ 原価/売価をここで確定（数値化）
    const cost = Number(base.costPrice ?? found.costPrice ?? 0) || 0;
    const sell = Number(base.sellPrice ?? found.sellPrice ?? 0) || 0;

    // ✅ 表示/計算用の単価（原価優先）
    const unitPrice = cost; // 原価のみ
    const unitPriceType = cost > 0 ? "cost" : "none";

    const line = {
      ...base,

      // ✅ キーになるもの（これが無いと明細で引けない）
      barcode: String(base.barcode ?? found.barcode ?? bc).trim(),

      // ✅ 明細表示に必要な情報
      name: String(base.name ?? found.name ?? "").trim(),
      unit: String(base.unit ?? found.unit ?? "個").trim() || "個",

      // ✅ 単価系：両方持たせる（納品書は原価優先で使える）
      costPrice: cost,
      sellPrice: sell,

      // ✅ 明細で表示する「単価」（原価優先）
      unitPrice,           // ← 追加
      unitPriceType,       // ← 追加（"cost" | "sell" | "none"）

      price: cost,     // 原価スナップショット（0なら未登録）

      sellPrice: sell, // 売価は保持のみ

taxRate: (() => { const t = base.taxRate ?? found.taxRate; return t != null ? Number(t) : 0.1; })(),

// qty は normalize 側にあるはずだけど保険
qty: Number(base.qty ?? 1) || 1,

    };

    add(line);

    feedbackOnScan?.();
    setLastScan?.(isAU ? `Added: ${line.name || line.barcode}` : `追加：${line.name || line.barcode}`);
    setTimeout(() => setLastScan?.(""), 1200);
    return;
  }

  // 未登録JAN → 発注専用モードの場合は登録不可
  if (retailOrderOnly) {
    feedbackOnScan?.();
    setLastScan?.(isAU ? "Not registered in the product master" : "商品マスタに登録されていません");
    setTimeout(() => setLastScan?.(""), 1200);
    showToast?.(isAU ? "Not registered in the product master" : "商品マスタに登録されていません");
    return;
  }

  // 未登録JAN → 登録モーダル（scanAdd）
  feedbackOnScan?.();
  setLastScan?.(isAU ? `Unregistered barcode: ${bc}` : `未登録JAN：${bc}`);
  setTimeout(() => setLastScan?.(""), 1200);

  setRegMode("scanAdd");
  setRegEditingId(null);

  // ✅ supplierId を正しくセット（卸=tenantId、小売=supplierId）
  setRegSupplierId(sid);

  setRegBarcode(bc);
  setRegName("");
  setRegUnit(isAU ? "" : "個");
  setRegCostPrice("0");
  setRegSellPrice("0");
  setRegTaxRate(0.1);
  setRegOpen(true);
}



// ✅ lines に入れる前に price を "必ず原価" で埋める（売価は単価に使わせない）
function normalizeProductForLine(p) {
  // 既に上で定義してる toNum があるなら、ここは消して toNum(v) を使ってOK
  const toNumLocal = (v, fallback = 0) => {
    const s = String(v ?? "").replace(/[¥,\s"]/g, "").trim();
    if (s === "") return fallback;
    const n = Number(s);
    return Number.isFinite(n) ? n : fallback;
  };

  // ✅ 原価のソースは costPrice 優先。price は「旧データが原価を入れてた場合の保険」にだけ使う
  const cost = toNumLocal(p?.costPrice ?? p?.cost ?? p?.purchasePrice, 0); // 原価のみ（売価代用なし）

  // ✅ 売価は保存・表示用に保持するだけ（単価=price には絶対入れない）
  const sell = toNumLocal(p?.sellPrice, 0);

  return {
    ...p,

    // ✅ 互換 price は "必ず原価"
    price: cost,

    // ✅ 原価も必ず持つ
    costPrice: cost,

    // ✅ 売価は保持だけ（計算で使わない）
    sellPrice: sell,
  };
}

    // ===== submit order (retail -> Firestore) =====
    async function submitOrder() {
      // 2026-08 重複発注防止：まず同期的なref lockで即座に二重実行を防ぐ。
      // setStateは非同期のため、isSubmittingOrderだけのチェックだと高速連打時に
      // 複数のhandler呼び出しが同じrender時点のfalseを見てしまう可能性がある
      if (submitOrderLockRef.current) return;
      submitOrderLockRef.current = true;
      setIsSubmittingOrder(true);

      try {
        await submitOrderInner();
      } finally {
        // 成功・失敗を問わず必ずロックを解除する。ただし成功時は画面遷移
        // （setRetailView("history")）が先に完了してから解除されるよう、
        // submitOrderInner内で遷移まで済ませてからここに戻ってくる
        submitOrderLockRef.current = false;
        setIsSubmittingOrder(false);
      }
    }

    async function submitOrderInner() {
      if (!supplierSelected) {
        showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
        return;
      }
      if (lines.length === 0) return;

      if (!tenantId) return alert(isAU ? "Not logged in (no tenant ID)" : "tenantIdなし（未ログイン）");

      // 注文番号・仕入先名はplaceOrder Callableがサーバー側で確定する

      // 予定納品日の計算（卸設定をもとに注文時点で確定）
      // 2026-08 AU版基盤（Phase 2）：timezoneはwholesaleProfile（発注先卸の
      // tenantドキュメント）側の値を使う——締め時間・営業日判定は卸の
      // タイムゾーン基準で行うべきロジックのため。未設定時は既存どおりAsia/Tokyo
      // 2026-08 Codexレビュー指摘対応（MUST-FIX）：確認モーダル側（openConfirmOrder
      // 相当）は既にisAU分岐でAustralia/Sydneyへフォールバックしていたが、
      // ここ（実際の発注送信処理）はAsia/Tokyo固定のままだった。wholesaleProfileが
      // 未取得の場合に確認画面と実処理で異なるtimezoneが使われ、最短納品日・
      // 休業日判定が食い違う可能性があったため統一する
      const wsSettings = {
        leadDays: wholesaleProfile?.leadDays ?? 0,
        cutoffTime: wholesaleProfile?.cutoffTime ?? null,
        closedWeekdays: wholesaleProfile?.closedWeekdays ?? [],
        holidayDates: wholesaleProfile?.holidayDates ?? [],
        timezone: wholesaleProfile?.timezone || (isAU ? "Australia/Sydney" : "Asia/Tokyo"),
      };
      const now = new Date();
      const calcedDeliveryDate = calcDeliveryDate(now, wsSettings);

      // 希望納品日のバリデーション
      // 注：requestedDeliveryDateはplaceOrder Callable側で
      // scheduledDeliveryDateと同じ値が自動設定されるため、個別送信は不要
      // eslint-disable-next-line no-unused-vars
      let finalRequestedDate = null;
      let finalScheduledDate = calcedDeliveryDate;
      if (requestedDeliveryDate) {
        // 最短納品日より前はNG
        if (requestedDeliveryDate < calcedDeliveryDate) {
          alert(isAU
            ? `Requested delivery date must be on or after the earliest available date (${formatAUDate(calcedDeliveryDate)})`
            : `希望納品日は最短納品可能日（${formatJPDate(calcedDeliveryDate)}）以降で指定してください`);
          return;
        }
        // 休日はNG
        // 2026-08 Codexレビュー指摘対応（MINOR）：isHolidayの第4引数（timezone）を
        // 渡していなかった。wsSettings.timezone（AU/JPで既に分岐済み）を明示的に渡す
        if (isHoliday(requestedDeliveryDate, wsSettings.closedWeekdays, wsSettings.holidayDates, wsSettings.timezone)) {
          alert(isAU
            ? `The requested delivery date (${formatAUDate(requestedDeliveryDate)}) falls on a closed day. Please choose a different date.`
            : `希望納品日（${formatJPDate(requestedDeliveryDate)}）は休業日です。別の日付を選択してください`);
          return;
        }
        finalRequestedDate = requestedDeliveryDate;
        finalScheduledDate = requestedDeliveryDate;
      }

      const wholesaleTidForOrder = tenantProfile?.wholesaleTenantId || null;
      if (!wholesaleTidForOrder) { alert(isAU ? "You need to connect with a supplier first" : "卸との接続が必要です"); return; }

      // 明細は productDocId + qty のみ送る。商品名・単価・原価・税率・金額・注文番号は
      // すべてサーバー側（placeOrder Callable）が商品マスタから引き直して確定する。
      // 商品マスタに存在しない行（手入力商品など）は送れないため除外する。
      const callableLines = lines
        .filter((l) => !!l.id)
        .map((l) => ({ productDocId: l.id, qty: Number(l.qty || 0) }));
      if (callableLines.length === 0) {
        alert(isAU ? "There's nothing to order (select a product from the catalogue)" : "発注できる商品がありません（商品マスタに登録された商品を選択してください）");
        return;
      }

      // このsubmit操作専用のrequestId。確認モーダルを開いた時点で発行済みのはずだが、
      // 何らかの理由で未発行なら（直接呼び出し等の防御的フォールバック）ここで生成する。
      // 連打は同じrequestIdを再利用し、成功して初めて次の発注のためにリセットする
      if (!submitOrderRequestIdRef.current) {
        submitOrderRequestIdRef.current = generateRequestId();
      }
      const requestId = submitOrderRequestIdRef.current;

      try {
        // ordersのcreateとproducts.orderCountの加算はplaceOrder Callableが一括で行う
        const placeOrderFn = httpsCallable(functions, "placeOrder");
        const placeResult = await placeOrderFn({
          wholesaleTenantId: wholesaleTidForOrder,
          lines: callableLines,
          note: orderNote.trim() || "",
          scheduledDeliveryDate: finalScheduledDate || null,
          requestId,
        });
        const orderNo = placeResult?.data?.orderNo;

        showToast(isAU ? `Order placed (Order No. ${orderNo})` : `発注しました（注文No. ${orderNo}）`);
        setLines([]);
        setOrderNote("");
        setRequestedDeliveryDate("");
        setRetailView("history");
        setConfirmOpen(false);
        // 画面遷移・カートクリアが完了した後にrequestIdを破棄する。ここより前に
        // リセットすると、遷移前の一瞬に再クリックされた場合に別注文として
        // 扱われてしまう可能性があるため、必ず最後に行う
        submitOrderRequestIdRef.current = null;
      } catch (e) {
        console.error(e);
        alert(e.message);
        // 失敗時はrequestIdを保持したままにする。ユーザーが再試行した場合、
        // 同じrequestIdで送られるため、「サーバーは成功したがレスポンスが
        // 届かなかった」ケースでも二重発注にならない（サーバー側idempotencyが
        // 同じorderId/orderNoを返す）。明らかなバリデーションエラー等で
        // 注文が作られていないことが明白な場合でも、同じrequestIdの再利用は
        // 安全（サーバー側は「未作成」を検知して新規に作成し直す）
      }
    }

    // ===== wholesale actions =====
async function markSeenByWholesale(orderId) {
  try {
    const markOrderSeenFn = httpsCallable(functions, "markOrderSeen");
    await markOrderSeenFn({ orderId });
    // 2026-08修正（Codexレビュー指摘対応・4ラウンド目、一貫性のため）：
    // dateRangeOrdersも同時に更新する
    applyOrderPatchToLocalState(orderId, { seenByWholesale: true });
  } catch (e) {
    console.error(e);
    alert(e?.message || String(e));
  }
}

async function confirmOrder(orderId) {
  // ── サブスクリプションガード ──
  if (!isSubscribed) {
    setShowExpiredModal(true);
    return false;
  }
  // 2026-08追加：処理開始を即座にUIへ反映する（Firestore/Functionsのレスポンスを
  // 待たない）。成功・失敗・途中のreturnを問わず必ずfinallyで解除する
  setConfirmingOrderIds((prev) => ({ ...prev, [orderId]: true }));
  try {
    // 2026-08 パフォーマンス改善：受注確定前にローカルでの数量編集
    // （editedQtyByOrder）が残っていれば、adjustOrderLines Callableへ
    // まとめて1回だけ送信してからconfirmOrderを呼ぶ。個々の＋/－操作では
    // Firestoreへ書き込まず、確定操作でだけ書き込む設計。
    // 2026-08修正（Codexレビュー指摘対応MUST-FIX2）：別端末で既にこの注文が
    // 受注確定・変更されていた場合、adjustOrderLines自体がサーバー側で
    // status!=="未確認"を検知しFAILED_PRECONDITIONで拒否するため送信は失敗するが、
    // エラーメッセージが分かりにくい。ここで明示的に検知し、ユーザーに
    // 「最新の内容を確認してください」と案内した上で処理を中止する
    const localEdits = editedQtyByOrder[orderId];
    if (localEdits && Object.keys(localEdits).length > 0) {
      const latestSnap = await getDoc(doc(db, "orders", orderId));
      const latestStatus = latestSnap.exists() ? String(latestSnap.data().status || "未確認").trim() : null;
      if (latestStatus !== "未確認") {
        alert(isAU
          ? "This order has already been updated by another operation.\nYour unsaved quantity changes will be discarded — please review the latest details."
          : "この注文は別の操作により既に更新されています。\n未保存の数量変更を破棄し、最新の内容を確認してください。");
        setEditedQtyByOrder((prev) => {
          const next = { ...prev };
          delete next[orderId];
          return next;
        });
        return false;
      }
      // 2026-08修正（Codexレビュー指摘対応MUST-FIX3）：localEditsのキーは配列index。
      // サーバー送信時は、その位置にある行が本物のid/barcodeを持っていれば
      // lineIdとして併送し（サーバー側で一意一致を検証、なければindexへ
      // フォールバックする設計）、持たない場合はindexのみで照合させる。
      // 2026-08修正（Codexレビュー指摘対応・競合検知、2ラウンド目）：この端末が
      // 編集を開始した時点の数量（expectedQty）も併送する。サーバー側は
      // トランザクション内で対象行の現在値がexpectedQtyと一致することを検証し、
      // 一致しなければ「他の変更と競合しています」として拒否する（他端末が
      // 編集開始後にこの行を書き換えていた場合の無警告上書き＝lost updateを防ぐ）
      const latestLines = latestSnap.data().lines || [];
      const lineAdjustments = Object.entries(localEdits).map(([indexStr, edited]) => {
        const idx = Number(indexStr);
        const l = latestLines[idx];
        const realId = l ? String(l.id || l.barcode || "") : "";
        return { lineId: realId || null, index: idx, newQty: edited.qty, expectedQty: edited.expectedQty };
      });
      const adjustOrderLinesFn = httpsCallable(functions, "adjustOrderLines");
      await adjustOrderLinesFn({ orderId, lineAdjustments });
      setEditedQtyByOrder((prev) => {
        const next = { ...prev };
        delete next[orderId];
        return next;
      });
    }

    // ✅ 原価ガード：原価 0/空 の明細が1件でもあれば確定不可
    // ordersステートは30日分のみのため、Firestoreから直接取得
    // （直前でadjustOrderLinesを実行した可能性があるため、必ず最新を取り直す）
    const snap = await getDoc(doc(db, "orders", orderId));
    const targetOrder = snap.exists() ? { id: snap.id, ...snap.data() } : (orders || []).find((o) => String(o.id) === String(orderId));
    const targetLines = getOrderLines(targetOrder);
    const missingCost = targetLines.filter((l) => {
      const cp = Number(l.costPrice ?? l.costPriceSnapshot ?? 0);
      return !(cp > 0);
    });
    if (missingCost.length > 0) {
      alert(
        `原価未登録の明細が ${missingCost.length} 件あります。\n` +
        missingCost.map((l) => `・${l.name || "不明"}`).join("\n") +
        "\n\n原価をすべて登録してから受注確定してください。"
      );
      return false;
    }

    // 実際の確定処理はconfirmOrder Callable（サーバー側でも同じ原価ガードを実施）
    const confirmOrderFn = httpsCallable(functions, "confirmOrder");
    await confirmOrderFn({ orderId });
    // 2026-08修正（Codexレビュー指摘対応・5ラウンド目）：以前はstatus/seenByWholesale
    // のみをpatchしていたが、ローカル数量編集があった場合は直前のadjustOrderLinesで
    // lines・金額（subtotal/tax/total等）もFirestore側で更新されている。patchだけでは
    // それらが両stateへ反映されず、期間指定タブでは「確定成功後に画面の数量・金額が
    // 編集前の値へ戻って見える」不具合になる。Firestoreから注文全体を再取得し、
    // その全内容で両配列を更新する（markOutOfStock等の他ハンドラと同じ方式に統一）
    const refreshed = await getDoc(doc(db, "orders", orderId));
    if (refreshed.exists()) {
      applyOrderPatchToLocalState(orderId, { id: refreshed.id, ...refreshed.data() });
    }
    showToast(isAU ? "Order confirmed" : "受注確定しました");
    return true;
  } catch (e) {
    console.error(e);
    alert(e?.message || String(e));
    return false;
  } finally {
    // 2026-08追加：成功・失敗いずれの経路でも、また原価ガード等の早期returnでも
    // 必ずここを通り処理中フラグを解除する（永久ロック防止）
    setConfirmingOrderIds((prev) => {
      if (!prev[orderId]) return prev;
      const next = { ...prev };
      delete next[orderId];
      return next;
    });
  }
}
// 2026-08 パフォーマンス改善：卸の数量調整（未確認注文のみ）。
// 以前は＋/－を押すたびにadjustOrderLines Callableを即時呼び、その書き込みを
// onSnapshotリスナーが検知して注文一覧全体を作り直す重い構造だった。
// 1以上への変更はローカルstate（editedQtyByOrder）のみを更新し、実際の
// Firestore反映は受注確定操作（confirmOrder実行前）でまとめて行う。
// 0への変更は「欠品」という不可逆・小売通知を伴う操作のため、従来通り
// 確認ダイアログ→即時Callable呼び出しのままにする（ローカルstate化しない）。
//
// 2026-08修正（Codexレビュー指摘対応MUST-FIX3）：以前はeditedQtyByOrderの
// キーにlineId（id/barcodeが無い明細ではrow${idx}という合成ID）を使っており、
// confirmOrderが一括送信する際にサーバー側のid/barcodeと照合できない
// ケースがあった。行の追加・削除が起きない数量変更の性質上、配列indexは
// 安定して対象行を特定できるため、editedQtyByOrderのキーは常にlineIndex
// （curLines内でのその行の位置）にする。サーバー側へはlineId（本物のid/
// barcodeがあれば）とindexの両方を送り、サーバーはlineIdが一意に一致すれば
// それを、一致しなければindexを使う（adjustDeliveryDateと同じ設計）
function setOrderLineQty(orderId, curLines, lineIndex, lineId, qty) {
  const q = Number(qty);
  const pickId = String(lineId || "");
  const cur = (curLines || [])[lineIndex];
  const curQty = Number(cur?.qty || 0);

  // 数量0は「明細から削除」ではなく欠品扱い（Callableは行削除をサポートしない）。
  // 不可逆・小売への通知を伴う操作のため、ローカルstate化せず即時確認・即時保存のまま
  if (q <= 0 && curQty > 0) {
    const name = cur?.name || (isAU ? "this item" : "この商品");
    const ok = window.confirm(isAU ? `Mark "${name}" as out of stock (qty 0)?` : `「${name}」を欠品（数量0）にしますか？`);
    if (!ok) return;
    (async () => {
      try {
        const adjustOrderLinesFn = httpsCallable(functions, "adjustOrderLines");
        await adjustOrderLinesFn({ orderId, lineAdjustments: [{ lineId: pickId || null, index: lineIndex, outOfStock: true }] });
        // 欠品は即時確定のため、もしローカル編集が残っていれば整合性のため破棄する
        setEditedQtyByOrder((prev) => {
          if (!prev[orderId]) return prev;
          const next = { ...prev };
          const orderEdits = { ...next[orderId] };
          delete orderEdits[lineIndex];
          next[orderId] = orderEdits;
          return next;
        });
      } catch (e) {
        console.error(e);
        alert(e?.message || String(e));
      }
    })();
    return;
  }

  // 1以上への変更はローカルstateのみ更新（Firestore書き込みなし、即時反映）。
  // 2026-08修正（Codexレビュー指摘対応・競合検知、2ラウンド目）：editedQtyByOrderの
  // 各エントリに、編集を開始した時点でこの端末が見ていた数量（expectedQty）も
  // 一緒に記録する。同じ行を連続でクリックしても、expectedQtyは最初の編集開始時点の
  // 値のまま更新しない（2回目以降のcurQtyは既にローカル編集後の値なので、それを
  // expectedQtyにしてしまうと本来の「編集開始時点の値」比較ができなくなる）。
  // confirmOrder実行時、この値をサーバーへ送り、Firestore上の現在値と一致しない
  // 場合は競合とみなして拒否する（他端末が編集開始後にこの行を変更した場合の
  // 無警告上書き＝lost updateを防ぐ）
  setEditedQtyByOrder((prev) => {
    const orderEdits = prev[orderId] || {};
    const existing = orderEdits[lineIndex];
    const expectedQty = existing !== undefined ? existing.expectedQty : curQty;
    return {
      ...prev,
      [orderId]: { ...orderEdits, [lineIndex]: { qty: q, expectedQty } },
    };
  });
}

// 欠品マーク（卸が行を outOfStock:true にして数量0で保持）
async function markOutOfStock(orderId, lineIndex, lineId) {
  // 2026-08修正（Codexレビュー指摘対応・3ラウンド目）：以前はordersのみを検索
  // 対象にしていたため、期間指定タブから開いた注文（dateRangeOrdersにしか
  // 存在しない）では対象が見つからず、確認ダイアログも出ずに無反応で終了して
  // いた。selectedOrderのuseMemoと同じ検索順序（dateRangeOrders優先→orders）に
  // 統一する
  const curOrder =
    (dateRangeOrders || []).find((o) => String(o.id) === String(orderId)) ||
    (orders || []).find((o) => String(o.id) === String(orderId));
  const curLines = [...getOrderLines(curOrder)];
  const cur = curLines[lineIndex];
  if (!cur) return;
  const name = cur.name || (isAU ? "this item" : "この商品");
  const ok = window.confirm(isAU
    ? `Mark "${name}" as out of stock?\n(This will record 0 shipped and notify the retailer it's out of stock)`
    : `「${name}」を欠品にしますか？\n（出荷数0として記録され、小売に欠品として通知されます）`);
  if (!ok) return;

  try {
    // 欠品マーク（qty=0 + outOfStock:true）と金額再計算はadjustOrderLines Callableが行う。
    // 2026-08修正（Codexレビュー指摘対応MUST-FIX3）：lineId（本物のid/barcodeが
    // あれば）とindexの両方を送り、サーバー側が一致数に応じて安全に照合する
    const adjustOrderLinesFn = httpsCallable(functions, "adjustOrderLines");
    await adjustOrderLinesFn({ orderId, lineAdjustments: [{ lineId: lineId || null, index: lineIndex, outOfStock: true }] });
    // 欠品は即時確定のため、もしローカル編集が残っていれば整合性のため破棄する
    setEditedQtyByOrder((prev) => {
      if (!prev[orderId]) return prev;
      const next = { ...prev };
      const orderEdits = { ...next[orderId] };
      delete orderEdits[lineIndex];
      next[orderId] = orderEdits;
      return next;
    });
    // 2026-08修正（Codexレビュー指摘対応・4ラウンド目）：以前はordersや
    // dateRangeOrdersを一切更新しておらず、欠品成功後も画面表示（数量・欠品バッジ）
    // が変わらないまま残っていた。Callableのレスポンスはlines配列自体を含まないため、
    // Firestoreから最新の注文を再取得し、その内容でordersとdateRangeOrdersの
    // 両方を更新する
    const refreshed = await getDoc(doc(db, "orders", orderId));
    if (refreshed.exists()) {
      applyOrderPatchToLocalState(orderId, { id: refreshed.id, ...refreshed.data() });
    }
    showToast(isAU ? `"${name}" marked as out of stock` : `「${name}」を欠品にしました`);
  } catch (e) {
    console.error(e);
    alert(e?.message || String(e));
  }
}


    // 2026-08追加：納品書＋受領書2ページ綴りPDF化のため、納品書の「<head>スタイル
    // ＋<body>中身」を生成する部分を独立関数に切り出す。printDeliveryPopup（単独印刷）
    // とprintDeliveryWithReceiptPopup（2ページ綴り印刷）の両方から呼ばれる、
    // 納品書HTML生成の唯一の参照元。データモデル・帳票としての意味は元のまま変更しない
    function buildDeliveryNoteHtmlParts(order, deliveryNo, issuedAt) {
      const o = order || {};
      const t = tenantProfile || {};
      // 2026-08 AU版基盤：帳票（納品書・受領書）の実印刷内容はこれまでmarketId
      // 分岐がなく、AUテナントでも常に日本語ラベルで印刷されていた（MUST-FIX）。
      // 金額計算・丸め（disp/_yen等）は元々marketId対応済みだったため、ここでは
      // ラベル文字列のみをmarketId==="AU"で英語に分岐する
      const isAUDoc = t.marketId === "AU";
      const defaultShopLabel = isAUDoc ? "Unnamed store" : "〇〇ショップ";
      // retailTenantIdがあればshopsから正しい店名・住所・電話を補完
      if (o.retailTenantId) {
        const shopRef = (shops || []).find(s => s.retailTenantId === o.retailTenantId || s._tenantId === o.retailTenantId);
        if (shopRef) {
          if (!o.shopName || o.shopName === "〇〇ショップ" || o.shopName === "Unnamed store") o.shopName = shopRef.retailName || shopRef.name || o.shopName;
          if (!o.shopCompany) o.shopCompany = shopRef.company || shopRef.retailName || shopRef.name || "";
          if (!o.shopTel) o.shopTel = shopRef.retailTel || shopRef.tel || "";
          if (!o.shopAddress) o.shopAddress = shopRef.address || "";
        }
      }
      // 2026-08 丸め統一（Codexレビュー指摘対応・v2）：帳票専用に独自定義していた
      // ローカルフォーマッタ・独自の明細集計ロジックを廃止し、getDisplayOrderAmounts
      // （全帳票・全画面共通の表示用金額導出関数）に一本化する。これにより、同一注文
      // について納品書・受領書・請求書・画面内プレビューが必ず同じ金額を表示する
      // 2026-08 AU版基盤（Phase 2）：marketIdはtenantProfile.marketId由来。
      // 未設定（既存の日本版tenant全て）ならformatMoney/formatMoneyRawは
      // 内部でyen()/yenRaw()と完全に同じ結果を返すため、日本版の帳票表示は
      // 一切変わらない
      const _yen = (n) => formatMoney(n, t.marketId);
      const _yenRaw = (n) => formatMoneyRaw(n, t.marketId);
      // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：金額計算自体
      // （SSOT）にもt.marketIdを渡す。以前は表示フォーマット（_yen/_yenRaw）だけ
      // market対応し、getDisplayOrderAmounts自体はJPY丸め・JP税率区分固定のまま
      // 呼んでいたため、AU tenantの帳票でも小計・税額の計算自体がJPYで行われて
      // しまっていた
      const disp = getDisplayOrderAmounts(o, t.marketId);
      const lines = disp.lines;
      const _fd = ts => {
        if (!ts) return "";
        let d;
        if (ts?.toDate) d = ts.toDate();
        else if (ts?.seconds) d = new Date(ts.seconds * 1000);
        else d = new Date(ts);
        if (isNaN(d?.getTime())) return "";
        return isAUDoc
          ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`
          : `${d.getFullYear()}年${d.getMonth()+1}月${d.getDate()}日`;
      };
      // 商品名・バーコード・単位等は取引先・小売側が登録した文字列であり、印刷用
      // HTMLへ直接埋め込む前にescapeHtmlを通す（同一オリジンのprint iframeへの
      // HTML/script注入防止）
      // 2026-08修正（Codexレビュー指摘対応・MUST-FIX1、2ラウンド目で確定）：
      // 明細の行金額は円単位に丸めて表示する（yenRawの生値表示は、複数の
      // 小数単価行がある場合に明細合計と小計が数学的に一致し得ないため撤回）。
      // 明細行を丸めた金額の合計とSSOT小計に差が生じる場合は、合計欄に
      // 「端数調整」として明示する（黙って特定行へ配賦しない）
      // 2026-08（Codexレビュー3回目MUST-FIX対応）：以前はroundJPYが固定で使われており、
      // AU tenantの納品書でも商品参考売価（suggestedPrice/sellPriceInc）が整数ドルへ
      // 丸められてしまっていた（例：A$19.95がA$20.00と印字される）。請求小計・GST計算
      // 自体はdisp（getDisplayOrderAmounts、既にmarket対応済み）から取得しているため
      // 影響しないが、帳票上の商品単価表示が誤っていた
      const deliveryNoteRoundFn = t.marketId === "AU" ? roundAUD : roundJPY;
      const lineRows = lines.map(l => {
        const cp = l.unitPrice;
        const amt = l.lineAmount;
        const sp = deliveryNoteRoundFn(Number(l.suggestedPrice || l.sellPriceInc || 0));
        return `<tr>
          <td style="padding:5px 8px;border:1px solid #ccc">${escapeHtml(l.name||"")}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">${escapeHtml(l.barcode||"")}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${l.qty||0}</td>
          <td style="padding:5px 8px;border:1px solid #ccc">${escapeHtml(l.unit||"")}${Number(l.innerCount||1)>=2?(isAUDoc?`<br/><span style="font-size:10px;color:#666">(pack of ${escapeHtml(l.innerCount)})</span>`:`<br/><span style="font-size:10px;color:#666">（${escapeHtml(l.innerCount)}入）</span>`):""}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${cp>0?_yenRaw(cp):(isAUDoc?"Not set":"未登録")}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${l.displayTaxRate === null ? `<span style="color:#dc2626">${isAUDoc?"GST rate error":"税率エラー"}</span>` : Math.round(l.displayTaxRate*100)+"%"}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${cp>0?_yen(amt):"-"}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right;color:#555">${sp>0?_yen(sp):"-"}</td>
        </tr>`;
      }).join("");
      const _subtotalRecalc = disp.subtotal;
      const _totalRecalc = disp.total;
      const _sub8 = disp.subtotal8, _sub10 = disp.subtotal10, _tax8 = disp.tax8, _tax10 = disp.tax10;
      // 2026-08修正（Codexレビュー指摘対応・MUST-FIX1、3ラウンド目で確定）：
      // 明細行を円単位に丸めて表示するため、明細行の丸め済み金額を単純合計した値
      // （_lineAmountSumTotal）とSSOT小計（_subtotalRecalc）に差が生じることがある
      // （旧データの小数単価のみ、新規注文では常に0）。差を黙って無視せず、
      // 「明細金額計 → 端数調整 → 小計」の順で明示する（小計の後に足すと二重加算
      // に見えるとCodexレビューで指摘されたため、小計より前に置く）
      const _lineAmountSumTotal = disp.lineAmountSumTotal;
      const _roundingAdj = disp.roundingAdjustmentTotal;
      // 発行元(tenantProfile)・納品先(order.shop*)ともにユーザー編集可能なフィールドを
      // 含むため、印刷用HTMLへ埋め込む全ての文字列値をescapeHtmlに通す
      // （同一オリジンのprint iframeへのHTML/script注入防止）
      const deliveryNoEsc = escapeHtml(deliveryNo);
      const shopTitleEsc = escapeHtml(o.shopCompany || o.shopName || defaultShopLabel);
      const shopNameEsc = escapeHtml(o.shopName || "");
      const shopAddressEsc = escapeHtml(o.shopAddress || "");
      const shopTelEsc = escapeHtml(o.shopTel || "");
      const shopFaxEsc = escapeHtml(o.shopFax || "");
      const orderNoEsc = escapeHtml(o.orderNo || "");
      const issuerNameEsc = escapeHtml(t.name || "");
      const issuerAddressEsc = escapeHtml(t.address || "");
      const issuerTelEsc = escapeHtml(t.tel || "");
      const issuerFaxEsc = escapeHtml(t.fax || "");
      const issuerInvoiceNoEsc = t.invoiceNo ? escapeHtml(String(t.invoiceNo).replace(/^T/, "")) : "";
      const issuerBankEsc = escapeHtml(t.bank || "");
      const noteEsc = escapeHtml(o.note || "");
      const noteTemplateEsc = escapeHtml(t.noteTemplate || "");

      // 2026-08：納品書の<title>・<body>中身・（単独印刷用の）フルHTML文書を
      // 1回の計算で全て組み立てる。titleText/bodyHtmlは2ページ綴りPDF生成
      // （printDeliveryWithReceiptPopup）から、htmlは単独印刷（printDeliveryPopup）
      // ・PDF自動保存（saveDeliveryPdf）から使う。帳票の内容自体は変更しない
      const titleText = isAUDoc ? `Delivery Note No.${deliveryNoEsc}` : `納品書 No.${deliveryNoEsc}`;
      // ★ @page margin:0 + body padding:15mm にすることでA4幅(794px)と印刷領域を一致させる
      const styleText = `
  body{font-family:${isAUDoc ? '"Segoe UI","Helvetica Neue",Arial,sans-serif' : '"Hiragino Sans","Meiryo",sans-serif'};font-size:13px;color:#111;margin:0;padding:15mm;}
  table{border-collapse:collapse;width:100%;}
  @page{margin:0;size:A4;}
  @media print{html,body{height:auto;min-height:0;}}`;
      const bodyHtml = isAUDoc ? `<div style="display:flex;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:16px">
  <div style="font-size:26px;font-weight:900;letter-spacing:2px">DELIVERY NOTE</div>
  <div style="margin-left:auto;text-align:right">
    <div style="font-weight:700">Delivery No. ${deliveryNoEsc}</div>
    <div style="font-size:12px;opacity:.7">Issued: ${_fd(issuedAt)}</div>
  </div>
</div>
<div style="display:flex;gap:16px;margin-bottom:16px">
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">Deliver to</div>
    <div style="font-weight:900;font-size:16px">${shopTitleEsc}</div>
    ${(o.shopCompany&&o.shopName)?`<div style="font-size:12px;margin-top:2px">Store: ${shopNameEsc}</div>`:""}
    ${o.shopAddress?`<div style="font-size:12px;margin-top:2px">${shopAddressEsc}</div>`:""}
    ${o.shopTel?`<div style="font-size:12px;margin-top:2px">Tel: ${shopTelEsc}</div>`:""}
    ${o.shopFax?`<div style="font-size:12px;margin-top:2px">Fax: ${shopFaxEsc}</div>`:""}
    <div style="margin-top:8px;font-size:11px;opacity:.6">Order No: ${orderNoEsc}</div>
    <div style="font-size:11px;opacity:.6">Order date: ${_fd(o.createdAt)}</div>
  </div>
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px;text-align:right">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">From</div>
    <div style="font-weight:900;font-size:15px">${issuerNameEsc}</div>
    ${t.address?`<div style="font-size:12px;margin-top:2px">${issuerAddressEsc}</div>`:""}
    ${t.tel?`<div style="font-size:12px;margin-top:2px">Tel: ${issuerTelEsc}</div>`:""}
    ${t.fax?`<div style="font-size:12px;margin-top:2px">Fax: ${issuerFaxEsc}</div>`:""}
    ${t.abn?`<div style="font-size:11px;margin-top:6px;font-weight:700">ABN</div><div style="font-size:11px">${escapeHtml(String(t.abn))}</div>`:""}
    ${t.bank?`<div style="font-size:11px;margin-top:4px;opacity:.8">Bank details: ${issuerBankEsc}</div>`:""}
  </div>
</div>
<table style="margin-top:12px;font-size:12px">
  <thead><tr style="background:#f4f4f4">
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">Product</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">Barcode</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">Qty</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">Unit</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">Unit price<br/><span style="font-size:10px;font-weight:400">(ex GST)</span></th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">GST</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">Amount<br/><span style="font-size:10px;font-weight:400">(ex GST)</span></th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right;color:#555">Suggested price<br/><span style="font-size:10px;font-weight:400">(inc GST)</span></th>
  </tr></thead>
  <tbody>${lineRows}</tbody>
</table>
<div style="display:flex;gap:16px;align-items:flex-start;margin-top:16px">
  <div style="flex:1">
    ${o.note?`<div style="border:1px solid #ccc;border-radius:4px;padding:10px;font-size:12px"><div style="font-weight:700;margin-bottom:4px">Notes</div><div>${noteEsc}</div></div>`:""}
    ${t.noteTemplate?`<div style="margin-top:8px;font-size:11px;opacity:.7">${noteTemplateEsc}</div>`:""}
  </div>
  <div style="min-width:220px">
    <table style="font-size:12px">
      ${_roundingAdj!==0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;color:#666">Line total</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;color:#666">${_yen(_lineAmountSumTotal)}</td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;color:#666">Rounding adjustment</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;color:#666">${_roundingAdj>0?"+":""}${_yen(_roundingAdj)}</td></tr>`:""}
      <tr><td style="padding:5px 8px;border:1px solid #ccc">Subtotal (ex GST)</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;font-weight:700">${_yen(_subtotalRecalc)}</td></tr>
      ${_sub10>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">GST 10%</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(_tax10)}</td></tr>`:""}
      <tr><td style="padding:7px 8px;border:2px solid #111;font-weight:900;font-size:14px">Total (inc GST)</td><td style="padding:7px 8px;border:2px solid #111;text-align:right;font-weight:900;font-size:14px">${_yen(_totalRecalc)}</td></tr>
    </table>
  </div>
</div>` : `<div style="display:flex;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:16px">
  <div style="font-size:26px;font-weight:900;letter-spacing:6px">納　品　書</div>
  <div style="margin-left:auto;text-align:right">
    <div style="font-weight:700">納品書No. ${deliveryNoEsc}</div>
    <div style="font-size:12px;opacity:.7">発行日：${_fd(issuedAt)}</div>
  </div>
</div>
<div style="display:flex;gap:16px;margin-bottom:16px">
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">納品先</div>
    <div style="font-weight:900;font-size:16px">${shopTitleEsc} 御中</div>
    ${(o.shopCompany&&o.shopName)?`<div style="font-size:12px;margin-top:2px">店名：${shopNameEsc}</div>`:""}
    ${o.shopAddress?`<div style="font-size:12px;margin-top:2px">${shopAddressEsc}</div>`:""}
    ${o.shopTel?`<div style="font-size:12px;margin-top:2px">TEL：${shopTelEsc}</div>`:""}
    ${o.shopFax?`<div style="font-size:12px;margin-top:2px">FAX：${shopFaxEsc}</div>`:""}
    <div style="margin-top:8px;font-size:11px;opacity:.6">注文No：${orderNoEsc}</div>
    <div style="font-size:11px;opacity:.6">発注日：${_fd(o.createdAt)}</div>
  </div>
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px;text-align:right">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">発行元</div>
    <div style="font-weight:900;font-size:15px">${issuerNameEsc}</div>
    ${t.address?`<div style="font-size:12px;margin-top:2px">${issuerAddressEsc}</div>`:""}
    ${t.tel?`<div style="font-size:12px;margin-top:2px">TEL：${issuerTelEsc}</div>`:""}
    ${t.fax?`<div style="font-size:12px;margin-top:2px">FAX：${issuerFaxEsc}</div>`:""}
    ${t.invoiceNo?`<div style="font-size:11px;margin-top:6px;font-weight:700">適格請求書発行事業者番号</div><div style="font-size:11px">T${issuerInvoiceNoEsc}</div>`:""}
    ${t.bank?`<div style="font-size:11px;margin-top:4px;opacity:.8">振込先：${issuerBankEsc}</div>`:""}
  </div>
</div>
<table style="margin-top:12px;font-size:12px">
  <thead><tr style="background:#f4f4f4">
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">商品名</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">JAN</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">数量</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">単位</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">単価<br/><span style="font-size:10px;font-weight:400">(税抜)</span></th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">税率</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">金額<br/><span style="font-size:10px;font-weight:400">(税抜)</span></th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right;color:#555">推奨売価<br/><span style="font-size:10px;font-weight:400">(税込)</span></th>
  </tr></thead>
  <tbody>${lineRows}</tbody>
</table>
<div style="display:flex;gap:16px;align-items:flex-start;margin-top:16px">
  <div style="flex:1">
    ${o.note?`<div style="border:1px solid #ccc;border-radius:4px;padding:10px;font-size:12px"><div style="font-weight:700;margin-bottom:4px">備考</div><div>${noteEsc}</div></div>`:""}
    ${t.noteTemplate?`<div style="margin-top:8px;font-size:11px;opacity:.7">${noteTemplateEsc}</div>`:""}
  </div>
  <div style="min-width:220px">
    <table style="font-size:12px">
      ${_roundingAdj!==0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;color:#666">明細金額計</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;color:#666">${_yen(_lineAmountSumTotal)}</td></tr>
      <tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;color:#666">端数調整</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;color:#666">${_roundingAdj>0?"+":""}${_yen(_roundingAdj)}</td></tr>`:""}
      <tr><td style="padding:5px 8px;border:1px solid #ccc">小計（税抜）</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;font-weight:700">${_yen(_subtotalRecalc)}</td></tr>
      ${_sub8>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">※ 8%対象消費税（軽減）</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(_tax8)}</td></tr>`:""}
      ${_sub10>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">　 10%対象消費税</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(_tax10)}</td></tr>`:""}
      <tr><td style="padding:7px 8px;border:2px solid #111;font-weight:900;font-size:14px">合計（税込）</td><td style="padding:7px 8px;border:2px solid #111;text-align:right;font-weight:900;font-size:14px">${_yen(_totalRecalc)}</td></tr>
    </table>
  </div>
</div>`;
      const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"/><title>${titleText}</title><style>${styleText}</style></head><body>${bodyHtml}</body></html>`;
      return { titleText, styleText, bodyHtml, html };
    }

    // ✅ 納品書ポップアップ印刷（単独発行・再印刷用）
    function printDeliveryPopup(order, deliveryNo, issuedAt) {
      const o = order || {};
      // 2026-08 AU版基盤（Phase 2）：サンプル注文の帳票プレビューを開いた
      // タイミングを計測する（Getting Started後半の「Delivery Noteを確認」体験）
      if (o.isDemo) trackEvent("sample_document_view", { doc_type: "delivery_note" });
      const { html } = buildDeliveryNoteHtmlParts(order, deliveryNo, issuedAt);
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:0;";
      document.body.appendChild(iframe);
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
      setTimeout(() => iframe.contentWindow.print(), 100);
      // PDF自動保存（finalizeDeliveryPdf Callable経由。保存先パスはサーバー側で導出される）
      if (o.id) saveDeliveryPdf(o.id, html);
    }

    // 2026-08 AU版基盤（Phase 2）：AU向けTax Invoice（ABN・GST amount・
    // Total including GST表記）の最小構成HTML。日本版の適格請求書テンプレート
    // （printBillingPopup本体）は一切変更せず、完全に独立した関数として新設する。
    // 入力（invoice, t=tenantProfile）は日本版と共通のFirestoreスキーマを使う——
    // invoiceItems・subtotal・tax・total・billedPartySnapshot等のフィールド自体は
    // marketに依存しないため、新しいデータモデルを作る必要はない。
    // GST内訳は日本版のsubtotal8/tax8（軽減税率区分）を使わず、subtotal10/tax10
    // （GST標準税率）とsubtotal0（GST-free）のみを表示する
    function buildTaxInvoiceHtml({ invoice }) {
      // 2026-08 Codexレビュー指摘対応（MUST-FIX）：発行者情報は発行時点の
      // issuerSnapshot（issueBillingが不変スナップショットとして保存）を優先する。
      // これにより、発行後に事業者名・住所・ABN・銀行口座を変更しても、過去に
      // 発行済みの請求書の再印刷内容は変わらない。issuerSnapshot未保存のレガシー
      // レコード（本セッション以前に発行されたもの）のみ現在のtenantProfileへ
      // フォールバックする
      const t = invoice.issuerSnapshot || tenantProfile || {};
      const _yen = (n) => formatMoney(n, "AU");
      const _fd = s => s ? escapeHtml(String(s).replace(/-/g, "/")) : "";
      const items = invoice.invoiceItems || [];
      const shop = invoice.billedPartySnapshot || {};
      const breakdownAvailable = invoice.taxBreakdownAvailable !== false;

      const createdAtDate = invoice.createdAt?.toDate ? invoice.createdAt.toDate()
        : (invoice.createdAt?.seconds ? new Date(invoice.createdAt.seconds * 1000) : null);
      const issueDateStr = createdAtDate
        ? `${createdAtDate.getFullYear()}-${String(createdAtDate.getMonth()+1).padStart(2,"0")}-${String(createdAtDate.getDate()).padStart(2,"0")}`
        : "";

      // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：ATO Tax
      // Invoice要件（供給内容・数量・単価・課税区分の明確化）に対応するため、
      // 納品書単位のサマリー行の下に、その納品書に含まれる商品明細（数量・単価・
      // 課税区分）を表示する。金額はissueBilling側でgetDisplayOrderAmounts
      // （金額SSOT）から保存したitem.linesの値のみを使う
      const orderRows = items.map(item => {
        const d = item.deliveryDate?.toDate ? item.deliveryDate.toDate()
          : (item.deliveryDate?.seconds ? new Date(item.deliveryDate.seconds * 1000) : null);
        const dateStr = d ? `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,"0")}/${String(d.getDate()).padStart(2,"0")}` : "";
        const noText = item.deliveryNo ? "No." + escapeHtml(item.deliveryNo) : escapeHtml(item.orderNo || "");
        const summaryRow = `<tr>
          <td style="padding:5px 8px;border:1px solid #ccc">${escapeHtml(dateStr)}</td>
          <td style="padding:5px 8px;border:1px solid #ccc">${noText}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(item.subtotal||0)}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(item.tax||0)}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right;font-weight:700">${_yen(item.total||0)}</td>
        </tr>`;
        const itemLines = Array.isArray(item.lines) ? item.lines : [];
        const lineDetailRows = itemLines.map(l => {
          const taxLabel = l.taxRate === 0 ? "GST-free" : (l.taxRate === 0.10 ? "GST 10%" : "—");
          return `<tr>
            <td style="padding:3px 8px 3px 20px;border:1px solid #eee;font-size:11px;color:#555" colspan="2">${escapeHtml(l.name)} × ${l.qty} ${escapeHtml(l.unit)} @ ${_yen(l.unitPrice)} (${taxLabel})</td>
            <td style="padding:3px 8px;border:1px solid #eee;font-size:11px;color:#555;text-align:right" colspan="3">${_yen(l.lineAmount)}</td>
          </tr>`;
        }).join("");
        return summaryRow + lineDetailRows;
      }).join("");

      // GST内訳：標準税率10%（subtotal10/tax10）とGST-free 0%（subtotal0）のみ。
      // 日本版のsubtotal8（軽減税率）はAU側では常に0のため表示しない
      const breakdownHtml = breakdownAvailable
        ? `${invoice.subtotal10>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">Taxable sales (ex GST)</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.subtotal10||0)}</td></tr>`:""}
           ${invoice.subtotal10>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">&nbsp;&nbsp;GST amount</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.tax10||0)}</td></tr>`:""}
           ${invoice.subtotal0>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">GST-free sales</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.subtotal0||0)}</td></tr>`:""}`
        : `<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px" colspan="2">Tax breakdown unavailable (legacy record)</td></tr>`;

      const billingNoEsc = escapeHtml(invoice.billingNo);
      const shopTitleEsc = escapeHtml(shop.company || shop.name || invoice.shopName || "");
      const shopNameEsc = escapeHtml(shop.name || "");
      const shopAddressEsc = escapeHtml(shop.address || "");
      const shopTelEsc = escapeHtml(shop.tel || "");
      const issuerNameEsc = escapeHtml(t.name || "");
      const issuerAddressEsc = escapeHtml(t.address || "");
      const issuerTelEsc = escapeHtml(t.tel || "");
      // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：ABNは
      // 専用のt.abnフィールドを参照する。以前はt.invoiceNo（日本の適格請求書
      // 発行事業者番号と兼用）を流用していたが、両者は全く異なる制度の識別子
      // であり、同じフィールドで兼用するのは設計として不適切だった
      const issuerAbnEsc = t.abn ? escapeHtml(String(t.abn).replace(/\s+/g, "")) : "";

      const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"/><title>Tax Invoice No.${billingNoEsc}</title><style>
  body{font-family:Arial,Helvetica,sans-serif;font-size:13px;color:#111;margin:0;padding:15mm;}
  table{border-collapse:collapse;width:100%;}
  @page{margin:0;size:A4;}
  @media print{html,body{height:auto;min-height:0;}}
</style></head><body>
<div style="display:flex;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:16px">
  <div style="font-size:26px;font-weight:900;letter-spacing:2px">TAX INVOICE</div>
  <div style="margin-left:auto;text-align:right">
    <div style="font-weight:700">Invoice No. ${billingNoEsc}</div>
    <div style="font-size:12px;opacity:.7">Issue date: ${_fd(issueDateStr)}</div>
    ${invoice.paymentDueDate ? `<div style="font-size:12px;font-weight:700;color:#c00;">Payment due: ${_fd(invoice.paymentDueDate)}</div>` : ""}
  </div>
</div>
<div style="display:flex;gap:16px;margin-bottom:16px">
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">Billed to</div>
    <div style="font-weight:900;font-size:16px">${shopTitleEsc}</div>
    ${(shop.company&&shop.name)?`<div style="font-size:12px;margin-top:2px">${shopNameEsc}</div>`:""}
    ${shop.address?`<div style="font-size:12px;margin-top:2px">${shopAddressEsc}</div>`:""}
    ${shop.tel?`<div style="font-size:12px;margin-top:2px">Tel: ${shopTelEsc}</div>`:""}
    <div style="margin-top:8px;font-size:11px;opacity:.6">Billing period: ${_fd(invoice.periodStartDisplay)} - ${_fd(invoice.periodEndDisplay)}</div>
  </div>
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px;text-align:right">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">From</div>
    <div style="font-weight:900;font-size:15px">${issuerNameEsc}</div>
    ${t.address?`<div style="font-size:12px;margin-top:2px">${issuerAddressEsc}</div>`:""}
    ${t.tel?`<div style="font-size:12px;margin-top:2px">Tel: ${issuerTelEsc}</div>`:""}
    ${t.abn?`<div style="font-size:11px;margin-top:6px;font-weight:700">ABN</div><div style="font-size:11px">${issuerAbnEsc}</div>`:""}
  </div>
</div>
<table style="margin-top:12px;font-size:12px">
  <thead><tr style="background:#f4f4f4">
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">Delivery date</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">Delivery note no.</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">Subtotal (ex GST)</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">GST</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">Total (inc GST)</th>
  </tr></thead>
  <tbody>${orderRows}</tbody>
</table>
<div style="display:flex;justify-content:flex-end;margin-top:16px">
  <table style="font-size:12px;min-width:260px">
    ${breakdownHtml}
    <tr><td style="padding:5px 8px;border:1px solid #ccc">Subtotal (ex GST)</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;font-weight:700">${_yen(invoice.subtotal)}</td></tr>
    <tr><td style="padding:7px 8px;border:2px solid #111;font-weight:900;font-size:15px">Total (inc GST)</td><td style="padding:7px 8px;border:2px solid #111;text-align:right;font-weight:900;font-size:15px">${_yen(invoice.total)}</td></tr>
  </table>
</div>
</body></html>`;
      return html;
    }

    // ✅ 請求書ポップアップ印刷（複数注文まとめて）。
    // 入力は必ず、issueBilling発行成功後にinvoices/{invoiceId}を読み直した
    // 権威的なinvoiceドキュメント（またはその再読込結果）のみとする。発行前プレビュー
    // （billingOrders）や、注文コレクションの再クエリは使わない——請求書は「相手・
    // 金額・対象注文」について発行時点の不変スナップショットとして完結している。
    function printBillingPopup({ invoiceId, invoice }) {
      // 2026-08 AU版基盤（Phase 2）：marketId==="AU"の場合、以降の日本版の
      // 適格請求書テンプレート生成ロジックを完全にスキップし、buildTaxInvoiceHtmlの
      // 結果をそのまま印刷する。日本版（marketId未設定・"JP"）の処理経路は
      // このif文の下にそのまま残っており、一切変更していない
      if ((tenantProfile || {}).marketId === "AU") {
        // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・2ラウンド目MUST-FIX）：
        // ATO要件を満たさないTax Invoiceの印刷・PDF保存を発行前にfail-closedで
        // 止める。1ラウンド目はrecipient identityのみのガードだったが、
        // 発行元自身のidentity・ABNが空でも生成できてしまう不備をCodexに
        // 指摘された。以下を全て満たさない限り印刷・PDF保存を行わない：
        //   - 発行元の名称（issuerSnapshot.name、未保存のレガシーはtenantProfile.name）
        //   - 発行元のABN（issuerSnapshot.abn、基本書式：11桁の数字）
        //   - A$1,000以上の場合はrecipient identity（名称または住所）
        // 2026-08 Codexレビュー指摘対応（MUST-FIX）：発行時点のissuerSnapshotを
        // 優先する（現在のtenantProfileではない）。これにより発行後の事業者名・
        // ABN変更が過去請求書の表示・fail-closed判定に影響しなくなる
        const t2 = invoice.issuerSnapshot || tenantProfile || {};
        if (!String(t2.name || "").trim()) {
          alert("Your business name is not set. Please add it in Settings before printing a Tax Invoice.");
          return;
        }
        const abnDigits = String(t2.abn || "").replace(/\s+/g, "");
        if (!isValidAbnChecksum(abnDigits)) {
          alert("Your ABN is missing or not valid. Please add a valid ABN in Settings before printing a Tax Invoice.");
          return;
        }
        // 2026-08 Codexレビュー指摘対応：請求書は発行時点でbilledPartySnapshotを
        // 不変スナップショットとして確定済みのため、以降に顧客マスタ（shops）を
        // 更新しても当該invoiceの表示は変わらない。「顧客情報を更新してから
        // 印刷」という以前の文言は誤解を招くため、再発行が必要である旨に修正する
        const shopSnap = invoice.billedPartySnapshot || {};
        const hasRecipientIdentity = !!(shopSnap.company || shopSnap.name || shopSnap.address);
        if (Number(invoice.total || 0) >= 1000 && !hasRecipientIdentity) {
          alert("This Tax Invoice is A$1,000 or more but has no recipient name or address recorded. Under ATO rules, invoices of this size must show the recipient's identity. This invoice was already finalised without that information — please update the customer's details and issue a new Tax Invoice for this period instead of reprinting this one.");
          return;
        }
        const auHtml = buildTaxInvoiceHtml({ invoice });
        const auIframe = document.createElement("iframe");
        auIframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:0;";
        document.body.appendChild(auIframe);
        auIframe.contentDocument.write(auHtml);
        auIframe.contentDocument.close();
        auIframe.contentWindow.onafterprint = () => document.body.removeChild(auIframe);
        setTimeout(() => auIframe.contentWindow.print(), 100);
        if (invoiceId) saveBillingPdf(invoiceId, auHtml);
        return;
      }
      const t = tenantProfile || {};
      // 2026-08 丸め統一：帳票専用に独自定義していたローカルフォーマッタを廃止し、
      // グローバルなyen()（roundJPYで整数円に丸めてから表示）へ統一する。
      // 集計画面と帳票が同じ丸め規則を共有することで、同一取引の金額が
      // 画面間で食い違わないようにする
      // 2026-08 AU版基盤（Phase 2）：marketId未設定時はyen()と完全に同じ結果
      const _yen = (n) => formatMoney(n, t.marketId);
      // 表示用日付文字列はユーザー入力由来ではなくサーバー発行のdisplay文字列だが、
      // 念のためHTML注入経路として扱いescapeHtmlを通す
      const _fd = s => s ? escapeHtml(String(s).replace(/-/g, "/")) : "";
      const items = invoice.invoiceItems || [];
      const shop = invoice.billedPartySnapshot || {};
      const breakdownAvailable = invoice.taxBreakdownAvailable !== false;

      // 発行日は請求書ドキュムントのcreatedAt（不変・コミット時点で確定）を使う。
      // 再印刷しても発行日が変わらないようにするため（new Date()は使わない）
      const createdAtDate = invoice.createdAt?.toDate ? invoice.createdAt.toDate()
        : (invoice.createdAt?.seconds ? new Date(invoice.createdAt.seconds * 1000) : null);
      const issueDateStr = createdAtDate
        ? `${createdAtDate.getFullYear()}-${String(createdAtDate.getMonth()+1).padStart(2,"0")}-${String(createdAtDate.getDate()).padStart(2,"0")}`
        : "";

      // 注文行（納品日と伝票番号と金額）。invoiceItemsの事前集計値をそのまま使う。
      // deliveryNo/orderNoは取引先が間接的に影響できる文字列のためescapeHtmlを通す
      const orderRows = items.map(item => {
        const d = item.deliveryDate?.toDate ? item.deliveryDate.toDate()
          : (item.deliveryDate?.seconds ? new Date(item.deliveryDate.seconds * 1000) : null);
        const dateStr = d ? `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,"0")}/${String(d.getDate()).padStart(2,"0")}` : "";
        const noText = item.deliveryNo ? "No." + escapeHtml(item.deliveryNo) : escapeHtml(item.orderNo || "");
        return `<tr>
          <td style="padding:5px 8px;border:1px solid #ccc">${escapeHtml(dateStr)}</td>
          <td style="padding:5px 8px;border:1px solid #ccc">${noText}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(item.subtotal||0)}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(item.tax||0)}</td>
          <td style="padding:5px 8px;border:1px solid #ccc;text-align:right;font-weight:700">${_yen(item.total||0)}</td>
        </tr>`;
      }).join("");

      // 税率別サマリー。内訳を持たない旧orderSnapshotの注文が1件でも混ざっていれば、
      // 一部合算を全体であるかのように表示せず「内訳データなし」とする。
      // 「ご請求金額」は必ず請求書ドキュメントの権威的なtotalをそのまま表示する
      const breakdownHtml = breakdownAvailable
        ? `${invoice.subtotal10>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">10%対象（税抜）</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.subtotal10||0)}</td></tr>`:""}
           ${invoice.subtotal10>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">　 消費税10%</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.tax10||0)}</td></tr>`:""}
           ${invoice.subtotal8>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">※8%対象（税抜・軽減）</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.subtotal8||0)}</td></tr>`:""}
           ${invoice.subtotal8>0?`<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px">　 消費税8%</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right">${_yen(invoice.tax8||0)}</td></tr>`:""}`
        : `<tr><td style="padding:5px 8px;border:1px solid #ccc;font-size:11px" colspan="2">税率別内訳：利用不可（一部旧形式の納品書を含みます）</td></tr>`;

      // 発行元(tenantProfile)・請求先(billedPartySnapshot)ともに、ユーザーが編集可能な
      // フィールド（会社名・住所・電話・振込先・備考テンプレート等）を含むため、
      // 印刷用HTMLへ埋め込む全ての文字列値をescapeHtmlに通す（HTML/script注入防止）
      const billingNoEsc = escapeHtml(invoice.billingNo);
      const shopTitleEsc = escapeHtml(shop.company || shop.name || invoice.shopName || "");
      const shopNameEsc = escapeHtml(shop.name || "");
      const shopAddressEsc = escapeHtml(shop.address || "");
      const shopTelEsc = escapeHtml(shop.tel || "");
      const issuerNameEsc = escapeHtml(t.name || "");
      const issuerAddressEsc = escapeHtml(t.address || "");
      const issuerTelEsc = escapeHtml(t.tel || "");
      const issuerFaxEsc = escapeHtml(t.fax || "");
      const issuerInvoiceNoEsc = t.invoiceNo ? escapeHtml(String(t.invoiceNo).replace(/^T/, "")) : "";
      const issuerBankEsc = escapeHtml(t.bank || "");
      const noteTemplateEsc = escapeHtml(t.noteTemplate || "");

      const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"/><title>請求書 No.${billingNoEsc}</title><style>
  body{font-family:"Hiragino Sans","Meiryo",sans-serif;font-size:13px;color:#111;margin:0;padding:15mm;}
  table{border-collapse:collapse;width:100%;}
  @page{margin:0;size:A4;}
  @media print{html,body{height:auto;min-height:0;}}
</style></head><body>
<div style="display:flex;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:16px">
  <div style="font-size:26px;font-weight:900;letter-spacing:6px">請　求　書</div>
  <div style="margin-left:auto;text-align:right">
    <div style="font-weight:700">請求書No. ${billingNoEsc}</div>
    <div style="font-size:12px;opacity:.7">発行日：${_fd(issueDateStr)}</div>
    ${invoice.paymentDueDate ? `<div style="font-size:12px;font-weight:700;color:#c00;">お支払期限：${_fd(invoice.paymentDueDate)}</div>` : ""}
  </div>
</div>
<div style="display:flex;gap:16px;margin-bottom:16px">
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">請求先</div>
    <div style="font-weight:900;font-size:16px">${shopTitleEsc} 御中</div>
    ${(shop.company&&shop.name)?`<div style="font-size:12px;margin-top:2px">店名：${shopNameEsc}</div>`:""}
    ${shop.address?`<div style="font-size:12px;margin-top:2px">${shopAddressEsc}</div>`:""}
    ${shop.tel?`<div style="font-size:12px;margin-top:2px">TEL：${shopTelEsc}</div>`:""}
    <div style="margin-top:8px;font-size:11px;opacity:.6">請求期間：${_fd(invoice.periodStartDisplay)} 〜 ${_fd(invoice.periodEndDisplay)}</div>
  </div>
  <div style="flex:1;border:1px solid #ccc;border-radius:6px;padding:12px;text-align:right">
    <div style="font-size:11px;opacity:.6;margin-bottom:4px">発行元</div>
    <div style="font-weight:900;font-size:15px">${issuerNameEsc}</div>
    ${t.address?`<div style="font-size:12px;margin-top:2px">${issuerAddressEsc}</div>`:""}
    ${t.tel?`<div style="font-size:12px;margin-top:2px">TEL：${issuerTelEsc}</div>`:""}
    ${t.fax?`<div style="font-size:12px;margin-top:2px">FAX：${issuerFaxEsc}</div>`:""}
    ${t.invoiceNo?`<div style="font-size:11px;margin-top:6px;font-weight:700">適格請求書発行事業者番号</div><div style="font-size:11px">T${issuerInvoiceNoEsc}</div>`:""}
    ${t.bank?`<div style="font-size:11px;margin-top:4px;opacity:.8">振込先：${issuerBankEsc}</div>`:""}
  </div>
</div>
<table style="margin-top:12px;font-size:12px">
  <thead><tr style="background:#f4f4f4">
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">納品日</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:left">納品書No.</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">小計（税抜）</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">消費税</th>
    <th style="padding:6px 8px;border:1px solid #ccc;text-align:right">金額（税込）</th>
  </tr></thead>
  <tbody>${orderRows}</tbody>
</table>
<div style="display:flex;justify-content:flex-end;margin-top:16px">
  <table style="font-size:12px;min-width:240px">
    ${breakdownHtml}
    <tr><td style="padding:5px 8px;border:1px solid #ccc">合計（税抜）</td><td style="padding:5px 8px;border:1px solid #ccc;text-align:right;font-weight:700">${_yen(invoice.subtotal)}</td></tr>
    <tr><td style="padding:7px 8px;border:2px solid #111;font-weight:900;font-size:15px">ご請求金額（税込）</td><td style="padding:7px 8px;border:2px solid #111;text-align:right;font-weight:900;font-size:15px">${_yen(invoice.total)}</td></tr>
  </table>
</div>
${t.noteTemplate?`<div style="margin-top:16px;font-size:11px;opacity:.7">${noteTemplateEsc}</div>`:""}
</body></html>`;
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:0;";
      document.body.appendChild(iframe);
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
      setTimeout(() => iframe.contentWindow.print(), 100);
      // PDF自動保存（finalizeBillingPdf Callable経由。invoiceIdが分かる場合のみ）
      if (invoiceId) saveBillingPdf(invoiceId, html);
    }

    // 2026-08追加：受領書の「<head>スタイル＋<body>中身」を生成する部分を独立関数に
    // 切り出す。printReceiptPopup（単独印刷）とprintDeliveryWithReceiptPopup
    // （2ページ綴り印刷）の両方から呼ばれる、受領書HTML生成の唯一の参照元
    function buildReceiptHtmlParts(order, deliveryNo, issuedAt) {
      const o = order || {};
      // 金額の唯一の参照元はサーバーが発行時に確定したorderSnapshot（存在しない
      // 旧データのみトップレベル値にフォールバック）
      const t = tenantProfile || {};
      // 2026-08 AU版基盤：納品書テンプレートと同様、受領書の実印刷内容も
      // marketId分岐がなく常に日本語だった（MUST-FIX）
      const isAUDoc = t.marketId === "AU";
      // 2026-08 丸め統一（Codexレビュー指摘対応・v2）：帳票専用に独自定義していた
      // ローカルフォーマッタを廃止し、納品書・請求書・画面内プレビューと同一の
      // getDisplayOrderAmountsから合計金額を取得する（snap.totalの直接参照は廃止）
      // 2026-08 AU版基盤（Phase 2）：marketId未設定時はyen()と完全に同じ結果
      const _yen = (n) => formatMoney(n, t.marketId);
      // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）：
      // 金額計算自体（SSOT）にもt.marketIdを渡す
      const disp = getDisplayOrderAmounts(o, t.marketId);
      const lines = disp.lines;
      const _fd = ts => {
        if (!ts) return "";
        let d;
        if (ts?.toDate) d = ts.toDate();
        else if (ts?.seconds) d = new Date(ts.seconds * 1000);
        else d = new Date(ts);
        if (isNaN(d?.getTime())) return "";
        return isAUDoc
          ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`
          : `${d.getFullYear()}年${d.getMonth()+1}月${d.getDate()}日`;
      };
      const totalItems = lines.reduce((s,l)=>s+Number(l.qty||0),0);
      // 2026-08修正（本番改修：受領書の納品日誤表示の是正）：以前は本文の「納品日」
      // 欄に issuedAt（帳票発行日時）をそのまま表示していた。右上に既に「発行日」
      // 欄があるため、本文の「納品日」に発行日と同じ日付が入るのは意味的に誤り。
      // 正しくは注文の予定納品日（scheduledDeliveryDate）を表示する。
      // 明細ごとに個別のscheduledDeliveryDateを持てる仕様のため、
      // 1) 明細に個別値があればそれを使う、無ければヘッダー値へフォールバック
      //    （画面の受注一覧・納品書と同じフォールバック規則）
      // 2) 全明細が同一日付ならその日付をそのまま表示
      // 3) 明細ごとに異なる日付が混在する場合は「複数日（明細参照）」とし、
      //    納品書側の明細列で個別の日付を確認できることを示す
      // 4) 日付が1件も特定できない場合は空欄のまま（従来通り"-"のような
      //    ハードコードはしない）
      const orderSnap = o.orderSnapshot || o;
      const headerFallbackDate = orderSnap.scheduledDeliveryDate || o.scheduledDeliveryDate || "";
      const lineDeliveryDates = lines.map(l => l.scheduledDeliveryDate || headerFallbackDate).filter(Boolean);
      const uniqueDeliveryDates = [...new Set(lineDeliveryDates)];
      // scheduledDeliveryDateは"YYYY-MM-DD"形式の文字列のため、タイムゾーン非依存の
      // formatJPDate（文字列を直接年月日へ分解する）を使う。issuedAt等のFirestore
      // Timestamp用の_fdとは変換方式が異なるため使い分ける
      let deliveryDateDisplay = "";
      if (uniqueDeliveryDates.length === 1) {
        deliveryDateDisplay = isAUDoc ? uniqueDeliveryDates[0] : formatJPDate(uniqueDeliveryDates[0]);
      } else if (uniqueDeliveryDates.length > 1) {
        deliveryDateDisplay = isAUDoc ? "Multiple dates (see line items)" : "複数日（明細参照）";
      }
      // 発行元・納品先ともにユーザー編集可能なフィールドを含むため、印刷用HTMLへ
      // 埋め込む全ての文字列値をescapeHtmlに通す（同一オリジンのprint iframeへの
      // HTML/script注入防止）
      const deliveryNoEsc = escapeHtml(deliveryNo);
      const shopNameEsc = escapeHtml(o.shopName || (isAUDoc ? "Unnamed store" : "〇〇ショップ"));
      const orderNoEsc = escapeHtml(o.orderNo || "");
      const issuerNameEsc = escapeHtml(t.name || "");
      const deliveryDateDisplayEsc = escapeHtml(deliveryDateDisplay);
      const titleText = isAUDoc ? `Receipt No.${deliveryNoEsc}` : `受領書 No.${deliveryNoEsc}`;
      const styleText = `
  body{font-family:${isAUDoc ? '"Segoe UI","Helvetica Neue",Arial,sans-serif' : '"Hiragino Sans","Meiryo",sans-serif'};font-size:13px;color:#111;margin:0;padding:15mm;}
  table{border-collapse:collapse;width:100%;}
  @page{margin:0;size:A4;}
  @media print{html,body{height:auto;min-height:0;}}`;
      const bodyHtml = isAUDoc ? `<div style="display:flex;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:20px">
  <div style="font-size:26px;font-weight:900;letter-spacing:2px">RECEIPT</div>
  <div style="margin-left:auto;text-align:right">
    <div style="font-weight:700;font-size:12px">Delivery No. ${deliveryNoEsc}</div>
    <div style="font-size:11px;opacity:.7">Issued: ${_fd(issuedAt)}</div>
  </div>
</div>
<div style="display:flex;gap:20px;align-items:flex-start">
  <div style="flex:1">
    <p style="font-size:14px;margin:0 0 18px">This confirms receipt of the goods listed below.</p>
    <table style="font-size:13px">
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8;width:110px">Deliver to</td><td style="padding:7px 12px;border:1px solid #ccc;font-weight:900">${shopNameEsc}</td></tr>
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8">Order No.</td><td style="padding:7px 12px;border:1px solid #ccc">${orderNoEsc}</td></tr>
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8">Delivery date</td><td style="padding:7px 12px;border:1px solid #ccc">${deliveryDateDisplayEsc || "—"}</td></tr>
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8">Items</td><td style="padding:7px 12px;border:1px solid #ccc">${lines.length} product(s) / ${totalItems} unit(s) total</td></tr>
      <tr><td style="padding:9px 12px;border:2px solid #111;background:#f8f8f8;font-weight:700;font-size:14px">Total amount</td><td style="padding:9px 12px;border:2px solid #111;font-weight:900;font-size:17px">${_yen(disp.total)} (inc GST)</td></tr>
    </table>
    ${t.name?`<div style="margin-top:20px;font-size:12px;opacity:.6">From: ${issuerNameEsc}</div>`:""}
  </div>
  <div style="width:160px;flex-shrink:0">
    <table style="width:100%;border:1px solid #333;font-size:12px">
      <tr><td style="text-align:center;padding:4px;background:#f8f8f8;border-bottom:1px solid #333">Received stamp</td></tr>
      <tr><td style="height:80px"></td></tr>
    </table>
    <table style="width:100%;border:1px solid #333;margin-top:12px;font-size:12px">
      <tr><td style="text-align:center;padding:4px;background:#f8f8f8;border-bottom:1px solid #333">Date received</td></tr>
      <tr><td style="padding:10px 12px;font-size:13px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td></tr>
    </table>
  </div>
</div>` : `<div style="display:flex;align-items:flex-end;border-bottom:2px solid #111;padding-bottom:10px;margin-bottom:20px">
  <div style="font-size:26px;font-weight:900;letter-spacing:6px">受　領　書</div>
  <div style="margin-left:auto;text-align:right">
    <div style="font-weight:700;font-size:12px">納品書No. ${deliveryNoEsc}</div>
    <div style="font-size:11px;opacity:.7">発行日：${_fd(issuedAt)}</div>
  </div>
</div>
<div style="display:flex;gap:20px;align-items:flex-start">
  <div style="flex:1">
    <p style="font-size:14px;margin:0 0 18px">下記の通り、正に受領いたしました。</p>
    <table style="font-size:13px">
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8;width:110px">納品先</td><td style="padding:7px 12px;border:1px solid #ccc;font-weight:900">${shopNameEsc}</td></tr>
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8">注文No.</td><td style="padding:7px 12px;border:1px solid #ccc">${orderNoEsc}</td></tr>
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8">予定納品日</td><td style="padding:7px 12px;border:1px solid #ccc">${deliveryDateDisplayEsc || "—"}</td></tr>
      <tr><td style="padding:7px 12px;border:1px solid #ccc;background:#f8f8f8">品目数</td><td style="padding:7px 12px;border:1px solid #ccc">${lines.length}品目 / 計${totalItems}点</td></tr>
      <tr><td style="padding:9px 12px;border:2px solid #111;background:#f8f8f8;font-weight:700;font-size:14px">合計金額</td><td style="padding:9px 12px;border:2px solid #111;font-weight:900;font-size:17px">${_yen(disp.total)}（税込）</td></tr>
    </table>
    ${t.name?`<div style="margin-top:20px;font-size:12px;opacity:.6">発行元：${issuerNameEsc}</div>`:""}
  </div>
  <div style="width:160px;flex-shrink:0">
    <table style="width:100%;border:1px solid #333;font-size:12px">
      <tr><td style="text-align:center;padding:4px;background:#f8f8f8;border-bottom:1px solid #333">受領印</td></tr>
      <tr><td style="height:80px"></td></tr>
    </table>
    <table style="width:100%;border:1px solid #333;margin-top:12px;font-size:12px">
      <tr><td style="text-align:center;padding:4px;background:#f8f8f8;border-bottom:1px solid #333">受領日</td></tr>
      <tr><td style="padding:10px 12px;font-size:13px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日</td></tr>
    </table>
  </div>
</div>`;
      const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"/><title>${titleText}</title><style>${styleText}</style></head><body>${bodyHtml}</body></html>`;
      return { titleText, styleText, bodyHtml, html };
    }

    // ✅ 受領書ポップアップ印刷（単独発行・再印刷用）
    function printReceiptPopup(order, deliveryNo, issuedAt) {
      const { html } = buildReceiptHtmlParts(order, deliveryNo, issuedAt);
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:0;";
      document.body.appendChild(iframe);
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
      setTimeout(() => iframe.contentWindow.print(), 100);
    }

    // 2026-08追加：納品書発行時に、納品書＋受領書を1つのPDF（2ページ綴り）として
    // 出力する。データモデル（納品書・受領書それぞれの帳票としての意味・既存の
    // ステータス・保存先）は統合せず、あくまで印刷用HTMLの結合のみを行う。
    // 受領書の前に強制改ページ（page-break-before:always）を入れることで、
    // 納品書が複数ページになった場合でも「納品書の最終ページの次から受領書」
    // という正しい構造になる（固定の2ページ目という決め打ちはしない）
    function printDeliveryWithReceiptPopup(order, deliveryNo, issuedAt) {
      const o = order || {};
      const deliveryParts = buildDeliveryNoteHtmlParts(order, deliveryNo, issuedAt);
      const receiptParts = buildReceiptHtmlParts(order, deliveryNo, issuedAt);
      const titleText = (tenantProfile || {}).marketId === "AU"
        ? `Delivery Note & Receipt No.${escapeHtml(deliveryNo)}`
        : `納品書・受領書 No.${escapeHtml(deliveryNo)}`;
      // page-break-before（レガシー）とbreak-before（現行のCSS Fragmentation仕様）の
      // 両方を指定する。納品書の内容量に関わらず、その要素の直前で必ず改ページされる
      // （納品書が複数ページになった場合も「最終ページの次」から受領書が始まる。
      // 固定の2ページ目という決め打ちにはならない）
      // 2026-08修正（本番改修：受領書レイアウトの是正）：body{padding:15mm}は
      // ページ全体の外周に一度だけ適用され、強制改ページ後の新しいページには
      // 上方向の余白が引き継がれない（ブラウザの印刷ページネーションの一般的な
      // 挙動）。そのため結合版PDFでは受領書ページだけが上端ギリギリから始まって
      // いた。.op-receipt-page自身にbodyと同じpadding-top（15mm）を持たせることで、
      // 改ページ後も納品書と同じ本文開始位置になるようにする
      const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"/><title>${titleText}</title><style>
${deliveryParts.styleText}
  .op-receipt-page{page-break-before:always;break-before:page;padding-top:15mm;}
</style></head><body>
<div>${deliveryParts.bodyHtml}</div>
<div class="op-receipt-page">${receiptParts.bodyHtml}</div>
</body></html>`;
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:0;";
      document.body.appendChild(iframe);
      iframe.contentDocument.write(html);
      iframe.contentDocument.close();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
      setTimeout(() => iframe.contentWindow.print(), 100);
      // PDF自動保存は納品書のみ従来通り実施（保存先パス・データモデルは分離を維持）
      if (o.id) saveDeliveryPdf(o.id, deliveryParts.html);
    }

    // ✅ 納品書（確定後）
    async function openPrintDelivery(order) {
      // ✅ 抜け道封鎖：受注確定済み（"受注確定" or "納品書発行"）のみ進む
      const st = String(order?.status || "").trim();
      if (st !== "受注確定" && st !== "納品書発行") {
        alert(isAU
          ? `You need to confirm the order before issuing a delivery note.\n\nCurrent status: ${st || "Unconfirmed"}`
          : "納品書を発行するには、先に受注確定が必要です。\n\n現在のステータス：" + (st || "未確認"));
        return;
      }

      // ✅ 原価ガード：原価 0 の明細があれば発行不可
      const orderLinesForPrint = (order.lines && order.lines.length > 0) ? order.lines : getOrderLines(order);
      const missingCostForPrint = orderLinesForPrint.filter((l) => {
        const cp = Number(l.costPrice ?? l.costPriceSnapshot ?? 0);
        return !(cp > 0);
      });
      if (missingCostForPrint.length > 0) {
        alert(isAU
          ? (
            `${missingCostForPrint.length} line(s) are missing a cost price.\n` +
            missingCostForPrint.map((l) => `- ${l.name || "Unknown"}`).join("\n") +
            "\n\nPlease enter a cost price for all lines before issuing the delivery note."
          ) : (
            `原価未登録の明細が ${missingCostForPrint.length} 件あります。\n` +
            missingCostForPrint.map((l) => `・${l.name || "不明"}`).join("\n") +
            "\n\n原価をすべて登録してから納品書を発行してください。"
          ));
        return;
      }

      // ✅ 初回だけ status/deliveryNo を確定（再印刷で上書きしない）。
      // 納品書番号の採番・orderSnapshot生成はissueDeliveryNote Callableがサーバー側で行う。
      let dn = order?.deliveryNo;
      if (st !== "納品書発行" || !order?.deliveryNo) {
        try {
          const issueDeliveryNoteFn = httpsCallable(functions, "issueDeliveryNote");
          const issueResult = await issueDeliveryNoteFn({ orderId: order.id });
          dn = issueResult?.data?.deliveryNo || dn;
          // 2026-08修正（Codexレビュー指摘対応・4/5ラウンド目）：暫定的にstatus等の
          // 一部フィールドだけpatchする。直後にFirestoreから発行済みドキュメント
          // 全体（issuedDoc）を読み直す処理があるため、そちらで両stateへの
          // 全内容反映まで完了する（下記issuedDoc取得後の処理を参照）
          applyOrderPatchToLocalState(order.id, { status: "納品書発行", deliveryNo: dn, seenByWholesale: true });
        } catch (e) {
          console.error(e);
          alert(e?.message || String(e));
          return;
        }
      }

      // ✅ 印刷対象の金額・明細は、クライアント側のローカルorderオブジェクトからは
      // 絶対に組み立てない。原価入力確定（confirmOrderCostPrices、明細合計を一度だけ
      // 丸める別経路）と、納品書発行（issueDeliveryNote、行ごと丸めのSSOT）とで
      // 丸め方式が異なるため、ローカルorderの金額はこの時点で発行時の確定値と
      // 一致している保証がない。必ずFirestoreから発行済みドキュメントを読み直し、
      // その値（orderSnapshotまたはトップレベルのsubtotal/tax/total）のみを使う。
      let issuedDoc;
      try {
        const snap = await getDoc(doc(db, "orders", order.id));
        if (!snap.exists()) throw new Error(isAU ? "Order not found" : "注文が見つかりません");
        issuedDoc = { id: snap.id, ...snap.data() };
      } catch (e) {
        console.error(e);
        alert((isAU ? "Failed to retrieve the issued document. Please try again.\n" : "発行済みの内容を取得できませんでした。もう一度お試しください。\n") + (e?.message || String(e)));
        return;
      }
      if (issuedDoc.status !== "納品書発行" || !issuedDoc.deliveryNo) {
        alert(isAU ? "Could not confirm the delivery note was issued. Please try again." : "納品書の発行が確認できませんでした。もう一度お試しください。");
        return;
      }
      // 2026-08修正（Codexレビュー指摘対応・5ラウンド目）：issuedAt・orderSnapshot等を
      // 含む発行済みドキュメント全体をorders・dateRangeOrdersの両方へ反映する
      applyOrderPatchToLocalState(order.id, issuedDoc);

      // 2026-08：納品書発行操作では、納品書＋受領書を1つのPDF（2ページ綴り）として
      // 出力する。受領書単独発行（別ボタン）はprintReceiptPopupのまま維持し、
      // 個別再印刷にも引き続き使える
      showToast(isAU ? `Printing delivery note No. ${issuedDoc.deliveryNo} (delivery note + receipt)` : `納品書No. ${issuedDoc.deliveryNo} を印刷します（納品書＋受領書）`);
      printDeliveryWithReceiptPopup(issuedDoc, issuedDoc.deliveryNo, issuedDoc.issuedAt);
    }

    // ✅ ピッキングリスト（確定前）
    function openPrintPicking(order) {
      setPrintOrders(null);

      const snapshot = JSON.parse(JSON.stringify({ ...order, lines: getOrderLines(order) }));
      setPrintPick({ issuedAt: Date.now(), orderSnapshot: snapshot });

      showToast(isAU ? "Printing picking list" : "ピッキングリストを印刷します");
      setTimeout(() => window.print(), 80);
    }

    // ✅ 受注リスト（一覧）
    function openPrintOrdersList() {
      setPrintPick(null);

      const snapshot = JSON.parse(
        JSON.stringify((orders || []).map((o) => ({ ...o, lines: getOrderLines(o) })))
      );
      setPrintOrders({ issuedAt: Date.now(), ordersSnapshot: snapshot });

      showToast(isAU ? "Printing order list" : "受注リストを印刷します");
      setTimeout(() => window.print(), 80);
    }



    // ✅ 画面側の呼び出し名ズレを吸収（openPickingPrint/openDeliveryPrint）
    function openPickingPrint(order) {
      return openPrintPicking(order);
    }
    function openDeliveryPrint(order) {
      return openPrintDelivery(order);
    }
const retailHistory = useMemo(() => orders, [orders]);

// ===== 小売発注：仕入先ごとの過去発注履歴商品（直近30日 orders から集計）=====
const retailHistoryProducts = useMemo(() => {
  if (mode !== "retail" || !supplierId) return [];
  // 2026-08（受注キャンセル機能再設計、Codexレビュー指摘MINOR対応）：発注履歴画面
  // （retailHistory）ではキャンセル済み注文もグレーアウト表示で残す設計だが、
  // 「よく注文する商品」は実際の発注実績を示す集計であり、キャンセルされた注文を
  // 通常注文として算入すると集計方針（キャンセルは通常注文として扱わない）と矛盾する
  const supplierOrders = orders.filter(o =>
    (o.status || "") !== "キャンセル" &&
    (String(o.supplierId || "") === String(supplierId) ||
      String(o.wholesaleTenantId || "") === String(supplierId))
  );
  const productMap = new Map();
  supplierOrders.forEach(order => {
    (order.lines || []).forEach(line => {
      const key = line.id || line.barcode || line.name;
      if (!key) return;
      if (productMap.has(key)) {
        const ex = productMap.get(key);
        ex.totalQty += Number(line.qty || 0);
        ex.orderCount += 1;
      } else {
        productMap.set(key, { ...line, totalQty: Number(line.qty || 0), orderCount: 1 });
      }
    });
  });
  return Array.from(productMap.values())
    .sort((a, b) => b.orderCount - a.orderCount || b.totalQty - a.totalQty)
    .slice(0, 20);
}, [supplierId, orders, mode]);

// ===== トライアル残り日数 =====
const trialDaysLeft = useMemo(() => {
  if (!tenantProfile?.trialEndsAt) return null;
  const status = tenantProfile?.subscriptionStatus || tenantProfile?.plan;
  if (status && status !== "trial") return null;
  const end = tenantProfile.trialEndsAt?.toDate?.() || new Date(tenantProfile.trialEndsAt);
  const diff = Math.ceil((end - new Date()) / (1000 * 60 * 60 * 24));
  return diff;
}, [tenantProfile?.trialEndsAt, tenantProfile?.subscriptionStatus, tenantProfile?.plan]);

// ===== 利用可否（trial期間内 or 課金済み）=====
const isSubscribed = useMemo(() => {
  const status = tenantProfile?.subscriptionStatus || tenantProfile?.plan;
  if (status === "active") return true;
  if (status === "trial" || !status) {
    // trialEndsAt が無い（旧アカウント）は許可
    if (!tenantProfile?.trialEndsAt) return true;
    return trialDaysLeft !== null && trialDaysLeft > 0;
  }
  return false;
}, [tenantProfile?.subscriptionStatus, tenantProfile?.plan, tenantProfile?.trialEndsAt, trialDaysLeft]);

// 取引先数（参照用・制限なし）
const retailerCount = useMemo(() => {
  return (shops || []).filter(s => s.tenantId === tenantId || s.ownerTenantId === tenantId).length;
}, [shops, tenantId]);

// 取引先数制限なし（プラン統一により常にfalse）
const isRetailerLimitReached = false;

// ===== 制限ガード：非購読時に操作を止めてモーダルを開く =====
const [showExpiredModal, setShowExpiredModal] = useState(false);

const requireSubscription = (fn) => {
  if (isSubscribed) return fn();
  setShowExpiredModal(true);
};

// ===== Stripe 決済セッション作成 =====
const [checkoutLoading, setCheckoutLoading] = useState(false);
const [showPlanModal, setShowPlanModal] = useState(false);

const handleCheckout = async (plan) => {
  if (!tenantId || !user) return;
  setCheckoutLoading(true);
  try {
    // 2026-08 AU版基盤（Phase 2）：Stripe Checkoutセッション作成を試みた
    // タイミングで送信する。実際に契約が完了したかどうかはStripe Webhook側の
    // 処理結果に依存するため、checkout_start自体は「ここまで進んだ」という
    // ファネル計測に徹する（subscription_startedとは別イベント）
    trackEvent("checkout_start", { plan });
    const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
    const result = await createCheckoutSession({ tenantId, plan });
    if (result.data?.url) {
      window.location.href = result.data.url;
    } else {
      alert(isAU ? "Failed to open the checkout page." : "決済ページの取得に失敗しました。");
    }
  } catch (err) {
    console.error("checkout error:", err);
    alert((isAU ? "An error occurred: " : "エラーが発生しました: ") + (err.message || err));
  } finally {
    setCheckoutLoading(false);
  }
};

// ===== 手書き入力：取引先の過去発注履歴商品（直近30日 orders から集計）=====
const shopHistoryProducts = useMemo(() => {
  if (!manualShopId || mode !== "wholesale" || wholesaleView !== "manual") return [];
  const selectedShop = shops.find(s => s.id === manualShopId);
  if (!selectedShop) return [];
  // 2026-08（受注キャンセル機能再設計、Codexレビュー2回目指摘MINOR対応）：
  // retailHistoryProducts（小売側「よく注文する商品」）と同型の集計。
  // キャンセル済み注文の明細を頻出商品候補として算入しないよう除外する
  const shopOrders = orders.filter(o =>
    (o.status || "") !== "キャンセル" &&
    (o.shopId === manualShopId ||
      (o.shopName && selectedShop.name && o.shopName === selectedShop.name) ||
      (selectedShop.company && o.shopCompany === selectedShop.company))
  );
  const productMap = new Map();
  shopOrders.forEach(order => {
    (order.lines || []).forEach(line => {
      const key = line.id || line.name;
      if (!key) return;
      if (productMap.has(key)) {
        const ex = productMap.get(key);
        ex.totalQty += Number(line.qty || 0);
        ex.orderCount += 1;
      } else {
        // 商品マスタのtaxRateで上書き（過去注文の誤ったtaxRateを修正）
        const master = (products || []).find(p =>
          (line.id && p.id === line.id) ||
          (line.barcode && String(p.barcode || "") === String(line.barcode))
        );
        // 商品マスタが正しければそちらを優先。マスタ・過去明細どちらも不正なら
        // 0.1へ推測せず、選択時にassertValidTaxRateで弾かれるよう不正値のまま保持する
        const taxRate = safeDisplayTaxRate(master?.taxRate) ?? Number(line.taxRate);
        productMap.set(key, { ...line, taxRate, totalQty: Number(line.qty || 0), orderCount: 1 });
      }
    });
  });
  return Array.from(productMap.values())
    .sort((a, b) => b.orderCount - a.orderCount || b.totalQty - a.totalQty)
    .slice(0, 20);
}, [manualShopId, orders, shops, products, mode, wholesaleView]);

// ✅ selectedOrder を1回だけ作る（明細linesも必ず配列化）
// 2026-08 パフォーマンス改善：editedQtyByOrder にこの注文のローカル編集値が
// あれば、Firestoreへ保存する前でもlines・小計・税額・合計へ即時反映する。
// 金額の再計算は必ずgetDisplayOrderAmounts（唯一のSSOT）を経由し、
// 別の独自計算ロジックを新設しない
const selectedOrder = useMemo(() => {
  // ✅ 日付指定時は dateRangeOrders も検索対象にする（2ページ目以降の明細が開けないバグ対策）
  const o =
    (dateRangeOrders || []).find((x) => String(x.id) === String(selectedOrderId)) ||
    (orders || []).find((x) => String(x.id) === String(selectedOrderId)) ||
    null;
  if (!o) return null;
  const baseLines = getOrderLines(o);
  // 2026-08修正（Codexレビュー指摘対応MUST-FIX2）：数量編集は"未確認"注文でしか
  // 行えない（setOrderLineQtyの呼び出し元UIがisUnconfirmedLocalの場合のみ表示
  // される）。しかし別端末で同じ注文が既に受注確定・数量変更されていた場合、
  // このタブのeditedQtyByOrderには古いローカル編集が残ったままになり得る。
  // statusが"未確認"以外になったサーバー側の値をローカル編集で上書きし続けると、
  // 「ボタンは無効なのに数量・合計だけ古い値のまま」という食い違いが起きる
  // （納品書発行時はFirestoreを再取得するため実害はないが、画面表示が誤る）。
  // statusが"未確認"の場合のみローカル編集を適用する
  const orderStatusNow = String(o.status || "未確認").trim();
  const localEdits = orderStatusNow === "未確認" ? editedQtyByOrder[o.id] : null;
  if (!localEdits || Object.keys(localEdits).length === 0) {
    return { ...o, lines: baseLines };
  }
  // 2026-08修正（Codexレビュー指摘対応MUST-FIX3）：editedQtyByOrderのキーは
  // lineIdではなく配列index（行の追加・削除が起きない数量変更において安定）。
  // 値は{qty, expectedQty}の形（expectedQtyは競合検知用、表示には使わない）
  const editedLines = baseLines.map((l, idx) => {
    const edited = localEdits[idx];
    if (edited === undefined) return l;
    return { ...l, qty: edited.qty };
  });
  // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）
  const disp = getDisplayOrderAmounts({ orderSnapshot: { lines: editedLines } }, tenantProfile?.marketId);
  return {
    ...o,
    lines: editedLines,
    subtotal: disp.subtotal, tax: disp.tax, total: disp.total,
    subtotal8: disp.subtotal8, subtotal10: disp.subtotal10, tax8: disp.tax8, tax10: disp.tax10,
  };
}, [orders, dateRangeOrders, selectedOrderId, editedQtyByOrder]);

// 2026-08修正（Codexレビュー指摘対応MUST-FIX2）：注文のstatusがサーバー側で
// "未確認"以外へ変わった（別端末での受注確定等）ことを検知したら、
// この注文に対するローカル数量編集（editedQtyByOrder）を破棄する。
// selectedOrderのuseMemo自体はstatus!=="未確認"の間ローカル編集を無視するが、
// 編集内容をstateに残したままにすると、ユーザーが気づかないまま古い編集が
// 残り続けるため、検知した時点で明示的にクリーンアップする
useEffect(() => {
  // 2026-08修正（Codexレビュー指摘対応・クリーンアップ範囲、2ラウンド目）：
  // 以前はordersのみを走査していたが、詳細パネルのselectedOrderはordersに
  // 加えてdateRangeOrders（期間指定タブでの単発取得結果）も検索対象にする
  // 設計になっている。期間指定タブから開いた注文はdateRangeOrdersからしか
  // 見つからない場合があり、ordersだけを見るこのeffectではstatus変化を
  // 検知できずローカル編集が残り続けてしまう。両方を走査する
  [...(orders || []), ...(dateRangeOrders || [])].forEach((o) => {
    if (!o?.id || !editedQtyByOrder[o.id]) return;
    const st = String(o.status || "未確認").trim();
    if (st !== "未確認") {
      setEditedQtyByOrder((prev) => {
        if (!prev[o.id]) return prev;
        const next = { ...prev };
        delete next[o.id];
        return next;
      });
    }
  });
}, [orders, dateRangeOrders, editedQtyByOrder]);


    // ✅ status判定を1箇所に集約
    const orderStatus = (selectedOrder?.status || "未確認").trim();
    const isUnconfirmed = orderStatus === "未確認";
    const isConfirmed = orderStatus === "受注確定";
    const canDelivery = isConfirmed || orderStatus === "納品書発行"; // ✅ 納品書発行ボタン活性条件

    // ✅ ステータス色
    function statusMeta(status) {
      // 2026-08（Step 12 E2E検証時に発覚したバグ対応）：statusの内部値
      // （"納品書発行"等）自体はデータモデルの一部で市場非依存のまま維持し、
      // 表示ラベルのみisAU分岐する
      const s = status || "未確認";
      if (s === "納品書発行") return { label: isAU ? "Delivery note issued" : "納品書発行", bg: "#dcfce7", color: "#166534" };
      if (s === "受注確定") return { label: isAU ? "Confirmed" : "受注確定", bg: "#dbeafe", color: "#1d4ed8" };
      if (s === "キャンセル") return { label: isAU ? "Cancelled" : "キャンセル", bg: "#f3f4f6", color: "#6b7280" };
      return { label: isAU ? "Unconfirmed" : "未確認", bg: "#fee2e2", color: "#dc2626" };
    }

    // ===== wholesale orders search =====
    const filteredOrders = useMemo(() => {
      const q = String(whSearch || "").trim().toLowerCase();
      // 期間指定取得済みならそちらを使う、なければ通常の30日分。
      // ただしdateRangeErrorがtrue（直前の期間取得が失敗した）の間は、
      // 30日分の通常一覧へのフォールバックを使わない——指定した期間と異なる
      // 不完全なデータを、あたかも取得結果であるかのように表示してしまうため
      let result = dateRangeError ? [] : (dateRangeOrders !== null ? dateRangeOrders : (orders || []));

      // キャンセルは showCancelled が true のときだけ含める
      if (!showCancelled) {
        result = result.filter((o) => (o.status || "") !== "キャンセル");
      }

      // テキスト検索
      if (!q) return result;
      const terms = q.split(/\s+/).filter(Boolean);

      return result.filter((o) => {
        const orderNo = String(o.orderNo || "");
        const shop = String(o.shopName || "");
        const supplier = supplierNameById(o.supplierId) || String(o.supplierId || "");
        const status = String(o.status || "");
        const linesText = getOrderLines(o).map((l) => `${l.name || ""} ${l.barcode || ""}`).join(" ");
        const hay = `${orderNo} ${shop} ${supplier} ${status} ${linesText}`.toLowerCase();
        return terms.every((t) => hay.includes(t));
      });
    }, [orders, dateRangeOrders, dateRangeError, whSearch, supplierNameById, showCancelled]);

    // ✅ フィルタ後に「未確認だけ」を適用した表示用配列
    const displayOrders = useMemo(() => {
      const base = filteredOrders || [];
      if (!onlyUnprocessed) return base;
      return base.filter((o) => (o.status || "") !== "納品書発行");
    }, [filteredOrders, onlyUnprocessed]);

    // 2026-08 AU版基盤（Phase 2）：件数バッジ（unprocessedCount/newCount）は
    // 実運用の状況把握に使われる数値のため、isRealOrderでサンプル注文
    // （isDemo:true）を除外する。受注一覧そのもの（displayOrders・orders）は
    // サンプル注文を含めたまま表示する——「Sample Retailerで送信した注文が
    // 実際に受注一覧に表示される」という体験自体がPhase 2の核心的な価値であり、
    // 一覧表示からデモ注文を隠してしまうとその体験ができなくなるため
    const unprocessedCount = useMemo(() => {
      return (orders || []).filter((o) => {
        if (!isRealOrder(o)) return false;
        const s = o.status || "";
        return s !== "納品書発行" && s !== "キャンセル";
      }).length;
    }, [orders]);

    const newCount = useMemo(() => {
      return (filteredOrders || []).filter((o) => {
        if (!isRealOrder(o)) return false;
        const s = o.status || "";
        return s !== "キャンセル" && (!o.seenByWholesale || s === "未確認");
      }).length;
    }, [filteredOrders]);

    // ===== retail search（商品名検索 強化版）=====
    // ✅ Firestore直接検索（catalog/ページネーション未取得分を救済する短期フォールバック）
    // 注意：これは30,000件規模での根本解決ではない。検索語ごとに対象テナントの
    // 商品を無制限に全件取得するため、商品数が非常に多いテナントでは依然として
    // 重い操作になる。中長期的には書き込み時に正規化した検索フィールド
    // （正規化バーコード・正規化商品名の前方一致等）を持たせ、Firestoreの
    // 範囲クエリで絞り込む設計、またはAlgolia等の専用検索サービスへの移行が必要。
    // 今回の短期改善では「同じ検索語で何度も全件DLしない」ことと「重複フェッチ
    // 防止・仕入先フィルタ必須化・エラーの握りつぶし禁止」までを対応する
    const [fsSearchResults, setFsSearchResults] = useState([]);
    const [fsSearchError, setFsSearchError] = useState(false);
    // 検索語×対象テナント集合をキーとした結果キャッシュ（同一条件での再DLを防ぐ）
    const fsSearchCacheRef = useRef(new Map());
    // 進行中フェッチの共有Promise（同一キーへの同時フェッチ1本を保証）
    const fsSearchInFlightRef = useRef(new Map());
    // 仕入先切替・検索語変更時に古いリクエストの結果を無視するための世代カウンター
    const fsSearchGenerationRef = useRef(0);

    useEffect(() => {
      const kw = normalizeKana(String(searchText || "").trim());
      // 仕入先変更・検索語変更のたびに世代を進める。これにより、直前の検索語や
      // 直前の仕入先向けに発行された古いリクエストが後から解決しても、
      // その結果が現在の状態を上書きしない
      fsSearchGenerationRef.current++;
      const generation = fsSearchGenerationRef.current;
      // 検索語・仕入先が変わった時点で即座に前回の結果をクリアする。generationガードは
      // 「古いPromiseの結果を新しいstateに書き込ませない」ことしか保証しないため、
      // 新しいフェッチが完了するまでの間、前の仕入先・前の検索語向けの結果が
      // 表示され続けてしまう（テナント境界を跨いだ商品混入に見える）不具合があった
      setFsSearchResults([]);
      if (kw.length < 2) { setFsSearchError(false); return; }
      if (!supplierId) { setFsSearchError(false); return; }

      const sup = (suppliers || []).find(s => s.id === supplierId || s.supplierId === supplierId);
      const wtid = String(sup?.wholesaleTenantId || "").trim();
      const supplierDocId = String(sup?._docId || "").trim();
      // 検索対象テナント。プロファイルのwholesaleTenantIdへの無条件フォールバックは
      // 廃止する——複数仕入先接続時に選択中でない卸を検索してしまう不具合があった
      const tids = [...new Set([tenantId, wtid].filter(Boolean))];
      if (tids.length === 0) { setFsSearchError(false); return; }

      const cacheKey = `${kw}::${tids.slice().sort().join(",")}`;

      const doFetch = () => {
        const cached = fsSearchCacheRef.current.get(cacheKey);
        if (cached) return Promise.resolve(cached);
        const inFlight = fsSearchInFlightRef.current.get(cacheKey);
        if (inFlight) return inFlight;

        const promise = (async () => {
          // 2テナント（自テナント＋卸テナント）は並列取得する（直列だと2倍待たされる）。
          // どちらか一方でも失敗したら、不完全な結果を正常値として返さず全体を失敗とする
          const snaps = await Promise.all(
            tids.map((tid) => getDocs(query(collection(db, "products"), where("tenantId", "==", tid))))
          );
          const all = [];
          snaps.forEach((snap) => {
            snap.docs.forEach((d) => all.push({ ...d.data(), id: d.id, _docId: d.id }));
          });
          fsSearchCacheRef.current.set(cacheKey, all);
          return all;
        })().finally(() => {
          if (fsSearchInFlightRef.current.get(cacheKey) === promise) {
            fsSearchInFlightRef.current.delete(cacheKey);
          }
        });
        fsSearchInFlightRef.current.set(cacheKey, promise);
        return promise;
      };

      const timer = setTimeout(() => {
        doFetch()
          .then((all) => {
            if (generation !== fsSearchGenerationRef.current) return; // 古い世代の結果は無視
            const terms = kw.split(/\s+/).filter(Boolean);
            // 仕入先フィルタを必須化する。自テナント登録商品はsupplierIdが選択中の
            // 仕入先と一致するものだけを対象にする（未設定は互換表示として許容）。
            // 卸テナント自身が保有する商品（tenantId==wtid）はそのテナント自体が
            // 対象卸なので無条件に対象とする
            const matched = all.filter((p) => {
              if (p.tenantId === tenantId) {
                const pid = String(p.supplierId || "").trim();
                if (pid && pid !== supplierId && pid !== supplierDocId && pid !== wtid) return false;
              }
              const name = normalizeKana(p.name || "");
              const bc = String(p.barcode || "");
              const cat = normalizeKana(p.category || "");
              return terms.every((t) => name.includes(t) || bc.includes(t) || cat.includes(t));
            });
            setFsSearchResults(matched);
            setFsSearchError(false);
          })
          .catch((e) => {
            console.error("[fsSearch error]", e);
            if (generation !== fsSearchGenerationRef.current) return;
            setFsSearchResults([]);
            setFsSearchError(true);
          });
      }, 300);
      return () => { clearTimeout(timer); };
    }, [searchText, tenantId, supplierId, suppliers, db]);

    const searchResults = useMemo(() => {
      const q = normalizeKana(String(searchText || "").trim());
      const terms = q.split(/\s+/).filter(Boolean);
      const pool = catalog.length > 0 ? catalog : [];
      if (!terms.length) return pool.slice(0, 30);
      const catalogMatched = pool.filter((p) => {
        const name = normalizeKana(p.name || "");
        const category = normalizeKana(p.category || "");
        const bc = String(p.barcode || "");
        return terms.every((t) => name.includes(t) || bc.includes(t) || category.includes(t));
      });
      // catalogにないものをfsSearchResultsで補完（fsSearchErrorがtrueの間は、
      // 不完全な結果を正常値のように見せないため補完しない）
      if (fsSearchError) return catalogMatched.slice(0, 50);
      const catalogIds = new Set(catalogMatched.map(p => p._docId || p.id));
      const extra = (fsSearchResults || []).filter(p => !catalogIds.has(p._docId || p.id));
      return [...catalogMatched, ...extra].slice(0, 50);
    }, [searchText, catalog, fsSearchResults, fsSearchError]);

    // ===== PDF生成 → Firebase Storage保存 =====
    // HTMLからPDFを生成し、base64文字列として返す（Storageへの直接書き込みは行わない）。
    // 実際の保存はfinalizeDeliveryPdf / finalizeBillingPdf Callable経由（write-once）で行う。
    async function renderPdfBase64(htmlContent) {
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;left:-9999px;top:-9999px;width:794px;height:1123px;border:none;";
      document.body.appendChild(iframe);
      try {
        iframe.contentDocument.open();
        iframe.contentDocument.write(htmlContent);
        iframe.contentDocument.close();
        await new Promise(r => setTimeout(r, 800));
        const canvas = await html2canvas(iframe.contentDocument.body, {
          scale: 1.5, useCORS: true, allowTaint: true,
          width: 794, windowWidth: 794,
        });
        const pdf = new jsPDF({ unit: "px", format: "a4", orientation: "portrait" });
        const pdfW = pdf.internal.pageSize.getWidth();
        const pdfH = (canvas.height * pdfW) / canvas.width;
        pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, pdfW, pdfH);
        // datauristringは "data:application/pdf;filename=...;base64,XXXX" 形式
        const dataUri = pdf.output("datauristring");
        return String(dataUri).split(",")[1] || null;
      } finally {
        if (iframe.parentNode) document.body.removeChild(iframe);
      }
    }

    // 納品書PDFをCallable経由で保存（同一納品書番号での上書きはサーバー側で拒否される）
    async function saveDeliveryPdf(orderId, htmlContent) {
      try {
        const pdfBase64 = await renderPdfBase64(htmlContent);
        if (!pdfBase64) return;
        const finalizeDeliveryPdfFn = httpsCallable(functions, "finalizeDeliveryPdf");
        await finalizeDeliveryPdfFn({ orderId, pdfBase64 });
      } catch (e) {
        console.error("[納品書PDF保存エラー]", e);
      }
    }

    // 請求書PDFをCallable経由で保存
    async function saveBillingPdf(invoiceId, htmlContent) {
      try {
        const pdfBase64 = await renderPdfBase64(htmlContent);
        if (!pdfBase64) return;
        const finalizeBillingPdfFn = httpsCallable(functions, "finalizeBillingPdf");
        await finalizeBillingPdfFn({ invoiceId, pdfBase64 });
      } catch (e) {
        console.error("[請求書PDF保存エラー]", e);
      }
    }

    // ✅ ログイン前
    if (!user) {
      return (
        <div style={{ padding: 16, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" }}>
          <div
            style={{
              maxWidth: 420,
              margin: "40px auto",
              border: "1px solid #eee",
              borderRadius: 14,
              padding: 16,
              background: "white",
            }}
          >
            {pendingInviteCode && (
              <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: 10, padding: "10px 14px", marginBottom: 12, fontSize: 13, fontWeight: 700, color: "#2e7d32" }}>
                {isAU ? <>🤝 You've been invited by a supplier<br /><span style={{ fontWeight: 400 }}>Logging in or signing up will connect you automatically</span></>
                  : <>🤝 卸から招待されています<br /><span style={{ fontWeight: 400 }}>ログインまたは新規登録すると自動で接続されます</span></>}
              </div>
            )}

            {authMode === "login" ? (
              <>
                <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 4 }}>{isAU ? "Log in" : "ログイン"}</div>
                <div style={{ display: "grid", gap: 12 }}>
                  <button
                    onClick={() => {
                      // 2026-08（22回目→24回目Codexレビュー指摘、MUST-FIX対応）：ログイン
                      // 画面からユーザーが能動的に登録タブへ切り替える操作は、明確な
                      // 登録意図のシグナル。共通のfireSignupStartOnce経由にすることで
                      // signupStartFiredRefによる重複防止が正しく機能する（以前は
                      // ここだけtrackEventを直接呼んでおり、ログイン⇄登録を往復すると
                      // 複数回送信されるバグがあった）
                      setAuthMode("register");
                      setEmail("");
                      setPassword("");
                      fireSignupStartOnce("login_screen_switch");
                    }}
                    style={{ width: "100%", padding: "14px", borderRadius: 12, border: "none", background: "#1a56db", color: "white", fontWeight: 900, fontSize: 16, cursor: "pointer", letterSpacing: 1 }}
                  >
                    {isAU ? "🎁 Sign up" : "🎁 新規登録"}
                  </button>
                  <button
                    onClick={handleGoogleSignIn}
                    disabled={authBusy}
                    style={{ padding: "12px", borderRadius: 12, border: "1.5px solid #ddd", background: "white", color: "#333", fontWeight: 700, fontSize: 14, cursor: authBusy ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}
                  >
                    <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                    {isAU ? "Continue with Google" : "Googleアカウントで登録・またはログイン"}
                  </button>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ flex: 1, height: 1, background: "#eee" }} />
                    <span style={{ fontSize: 12, color: "#aaa" }}>{isAU ? "Already registered (email/password)" : "既に登録済のお客様（メール/パスワード）"}</span>
                    <div style={{ flex: 1, height: 1, background: "#eee" }} />
                  </div>
                  <input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={isAU ? "Email address" : "メールアドレス"}
                    autoComplete="email"
                    inputMode="email"
                    style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 700, fontSize: 15 }}
                  />
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={isAU ? "Password" : "パスワード"}
                    type="password"
                    autoComplete="current-password"
                    style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 700, fontSize: 15 }}
                  />
                  <button
                    onClick={handleSignIn}
                    disabled={authBusy || !email.trim() || password.length < 6}
                    style={{ padding: "14px", borderRadius: 12, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 16, cursor: authBusy ? "not-allowed" : "pointer", opacity: authBusy || !email.trim() || password.length < 6 ? 0.5 : 1 }}
                  >
                    {isAU ? "Log in" : "ログイン"}
                  </button>
                  <div style={{ textAlign: "center" }}>
                    <button
                      onClick={async () => {
                        const addr = email.trim() || window.prompt(isAU ? "Enter your registered email address" : "登録したメールアドレスを入力してください");
                        if (!addr) return;
                        try {
                          await sendPasswordResetEmail(auth, addr);
                          alert(isAU
                            ? `A password reset email has been sent to "${addr}".\nClick the link in the email to reset your password.`
                            : `「${addr}」にパスワードリセットメールを送信しました。\nメールのリンクをクリックして再設定してください。`);
                        } catch (e) {
                          alert(isAU ? "Failed to send email. Please check the address." : "送信に失敗しました。メールアドレスを確認してください。");
                        }
                      }}
                      style={{ background: "none", border: "none", color: "#666", fontSize: 13, cursor: "pointer", textDecoration: "underline", padding: "4px 0" }}
                    >
                      {isAU ? "Forgot your password?" : "パスワードを忘れた方はこちら"}
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* ── Step 1: アカウント作成ボタン ── */}
                {!showRegisterForm ? (
                  <>
                    <div style={{ textAlign: "center", padding: "8px 0 24px" }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: "#1a56db", background: "#eff6ff", display: "inline-block", padding: "4px 14px", borderRadius: 20, marginBottom: 16 }}>{isAU ? "🎁 30-day free trial" : "🎁 30日間 無料トライアル"}</div>
                      <div style={{ fontWeight: 900, fontSize: 24, marginBottom: 8, color: "#111827" }}>{isAU ? "Try OrderLink for free" : "OrderLink を無料で試す"}</div>
                      <div style={{ fontSize: 13, color: "#666", marginBottom: 28, lineHeight: 1.7 }}>
                        {isAU ? (
                          <>No meetings needed. Start using it the day you sign up.<br />After 30 days, it's a monthly subscription by card. Cancel any time.</>
                        ) : (
                          <>打ち合わせ不要。登録したその日から使えます。<br />30日後はクレカで月額サブスク。いつでもキャンセル可。</>
                        )}
                      </div>
                      <button
                        onClick={() => {
                          // 2026-08（24回目Codexレビュー指摘、MUST-FIX対応）：素のURL
                          // （/?signup=true・?invite=いずれも無い直接流入・ブックマーク・
                          // 外部リンク等）からStep1画面が表示され、ここで実際にGoogle登録を
                          // クリックした瞬間も、URLパラメータの有無に関わらず明確な登録開始
                          // 意図として計測する
                          fireSignupStartOnce("register_step1_google");
                          handleGoogleSignIn();
                        }}
                        disabled={authBusy}
                        style={{ width: "100%", padding: "14px", borderRadius: 10, border: "1.5px solid #ddd", background: "white", color: "#333", fontWeight: 700, fontSize: 15, cursor: authBusy ? "not-allowed" : "pointer", marginBottom: 10, display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}
                      >
                        <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                        {isAU ? "Sign up with Google" : "Googleアカウントで登録"}
                      </button>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                        <div style={{ flex: 1, height: 1, background: "#eee" }} />
                        <span style={{ fontSize: 12, color: "#aaa" }}>{isAU ? "or" : "または"}</span>
                        <div style={{ flex: 1, height: 1, background: "#eee" }} />
                      </div>
                      <button
                        onClick={() => {
                          // 2026-08（24回目Codexレビュー指摘、MUST-FIX対応）：Googleボタンと
                          // 同じ理由。素のURLからのメール登録クリックも登録開始意図として計測する
                          fireSignupStartOnce("register_step1_email");
                          setShowRegisterForm(true);
                        }}
                        style={{ width: "100%", padding: "14px", borderRadius: 10, border: "none", background: "#1a56db", color: "white", fontWeight: 900, fontSize: 16, cursor: "pointer", letterSpacing: 1, marginBottom: 16 }}
                      >
                        {isAU ? "Sign up with email →" : "メールアドレスで登録 →"}
                      </button>
                      <div style={{ display: "flex", justifyContent: "center", gap: 20, fontSize: 12, color: "#888", marginBottom: 20 }}>
                        {isAU ? (
                          <>
                            <span>✅ No sales calls</span>
                            <span>✅ Set up in 10 minutes</span>
                          </>
                        ) : (
                          <>
                            <span>✅ 営業マン不要</span>
                            <span>✅ 最短10分でスタート</span>
                          </>
                        )}
                      </div>
                      <div style={{ borderTop: "1px solid #eee", paddingTop: 16 }}>
                        <div style={{ fontSize: 13, color: "#666", marginBottom: 8 }}>{isAU ? "Already have an account?" : "すでにアカウントをお持ちの方"}</div>
                        <button
                          onClick={() => { setAuthMode("login"); setEmail(""); setPassword(""); }}
                          style={{ padding: "10px 24px", borderRadius: 10, border: "1px solid #ddd", background: "white", fontWeight: 700, fontSize: 14, cursor: "pointer", color: "#333" }}
                        >
                          {isAU ? "Log in" : "ログイン"}
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  /* ── Step 2: メール・パスワード入力 ── */
                  <>
                    <div style={{ textAlign: "center", marginBottom: 20 }}>
                      <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 6, color: "#111827" }}>{isAU ? "Sign up with email" : "メールアドレスを登録"}</div>
                      <div style={{ fontSize: 13, color: "#666" }}>{isAU ? "Set the email and password you'll use to log in" : "ログインに使うメールとパスワードを設定してください"}</div>
                    </div>
                    <div style={{ display: "grid", gap: 12 }}>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={isAU ? "Email address" : "メールアドレス"}
                        autoComplete="email"
                        inputMode="email"
                        autoFocus
                        style={{ padding: "13px 14px", borderRadius: 10, border: "1.5px solid #ddd", fontWeight: 700, fontSize: 15 }}
                      />
                      <input
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder={isAU ? "Password (6+ characters)" : "パスワード（6文字以上）"}
                        type="password"
                        autoComplete="new-password"
                        style={{ padding: "13px 14px", borderRadius: 10, border: "1.5px solid #ddd", fontWeight: 700, fontSize: 15 }}
                      />
                      <button
                        onClick={handleSignUp}
                        disabled={authBusy || !email.trim() || password.length < 6}
                        style={{ padding: "15px", borderRadius: 10, border: "none", background: "#1a56db", color: "white", fontWeight: 900, fontSize: 16, cursor: authBusy ? "not-allowed" : "pointer", opacity: authBusy || !email.trim() || password.length < 6 ? 0.5 : 1, letterSpacing: 1 }}
                      >
                        {isAU
                          ? (authBusy ? "Signing up..." : "Start your free 30 days →")
                          : (authBusy ? "登録中..." : "30日間 無料で始める →")}
                      </button>
                      <div style={{ fontSize: 11, color: "#999", textAlign: "center" }}>
                        {isAU ? (
                          <>By signing up, you agree to our <a href="/terms-au.html" target="_blank" rel="noreferrer" style={{ color: "#666" }}>Terms of Service</a></>
                        ) : (
                          <><a href="https://order-link.info/terms.html" target="_blank" rel="noreferrer" style={{ color: "#666" }}>利用規約</a>に同意の上、登録してください</>
                        )}
                      </div>
                      <button
                        onClick={() => { setShowRegisterForm(false); setEmail(""); setPassword(""); }}
                        style={{ padding: "10px", borderRadius: 10, border: "none", background: "transparent", fontSize: 13, color: "#888", cursor: "pointer" }}
                      >
                        {isAU ? "← Back" : "← 戻る"}
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      );
    }

    // ✅ プロファイル読み込み中（Firestoreからの取得完了前に本画面を見せない）
    if (tenantProfile === null) {
      return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", fontFamily: "system-ui, -apple-system, sans-serif" }}>
          <style>{`@keyframes _spin { to { transform: rotate(360deg); } }`}</style>
          <div style={{ textAlign: "center" }}>
            <span style={{ display: "block", width: 44, height: 44, border: "5px solid #eee", borderTopColor: "#111", borderRadius: "50%", animation: "_spin 0.8s linear infinite", margin: "0 auto 16px" }} />
            <div style={{ color: "#888", fontSize: 14 }}>{isAU ? "Loading..." : "読み込み中..."}</div>
          </div>
        </div>
      );
    }

    // ✅ 初期設定（role未設定 かつ 名前も未設定の新規アカウント）
    if (tenantProfile !== null && !tenantProfile?.role && !tenantProfile?.retailName && !tenantProfile?.name) {
      const isInvited = !!pendingInviteCode; // QR招待経由 → 小売確定

      const saveSetup = async (role, nameVal, telVal, invoiceVal, addressVal) => {
        if (!nameVal.trim()) { alert(isAU ? "Please enter a name" : "名前を入力してください"); return; }
        // roleの確定はconfirmInitialRole Callable限定（Rulesではroleフィールドの
        // クライアント書き込みが禁止されている）。プロフィール項目はupdateTenantSettings経由で保存する。
        // 注：retailAllowProductEditはRulesのアローリストに無いため送信しない
        // （正式な綴りはallowRetailProductEditで、設定画面から個別に変更できる）
        const data = role === "retail"
          ? { retailName: nameVal.trim(), retailTel: telVal.trim() }
          : (() => {
            const thisYear = new Date().getFullYear();
            const autoHolidays = setupClosedWeekdays.includes(0)
              ? [...getHolidaysByYear(thisYear), ...getHolidaysByYear(thisYear + 1)].map(h => h.date)
              : [];
            return { name: nameVal.trim(), tel: telVal.trim(), invoiceNo: (invoiceVal || "").trim(), address: (addressVal || "").trim(), leadDays: setupLeadDays, cutoffTime: setupCutoffTime, closedWeekdays: setupClosedWeekdays, holidayDates: autoHolidays };
          })();
        try {
          const confirmInitialRoleFn = httpsCallable(functions, "confirmInitialRole");
          // 2026-08 AU Ads launch blocker対応：LP到達時にlocalStorageへ保存した
          // gclid/UTMをここでtenant docへ引き継ぐ（サーバー側でホワイトリスト・
          // サニタイズしてから書き込まれる。confirmInitialRoleFn自体が失敗しても
          // role確定に影響を与えない付随情報のため、読み取り失敗時はundefinedのまま渡す）
          const adAttribution = readStoredAdAttribution() || undefined;
          await confirmInitialRoleFn({ role, adAttribution });
        } catch (e) {
          // 既にrole確定済みの場合（failed-precondition）は続行し、プロフィール保存だけ行う
          if (e?.code !== "functions/failed-precondition") {
            console.error(e);
            alert(e?.message || e);
            return;
          }
        }
        // 2026-08（Codexレビュー指摘、MUST-FIX対応）：confirmInitialRoleFnの成功・
        // failed-precondition（既に確定済み）いずれの場合も、この時点でlocalStorageの
        // adAttributionは役目を終えている（成功時はtenantへスナップショット済み、
        // failed-precondition時は既存tenantの値が優先されもう使われない）。同一
        // ブラウザでの別アカウント登録に古い帰属情報が持ち越されるのを防ぐため、
        // ここで明示的にクリアする
        clearStoredAdAttribution();
        await updateTenantSettings(data);
        setTenantProfile(p => ({ ...(p || {}), role }));
        setMode(role);
        if (role === "wholesale") setShowManualBanner(true);
        // 2026-08 AU Ads launch blocker対応：signup_start発火・adAttribution取得は
        // この時点で既に完了しているため、ここでURL（?signup=true&utm_source=...）を
        // クリーンアップする。以前は登録画面確定と同時（マウント直後）に消していたが、
        // それだとGA4/adAttribution capture側がURLパラメータを読み取る前に消える
        // 競合があったため、実際に読み終わったこのタイミングまで遅らせた
        window.history.replaceState({}, "", window.location.pathname);
        // 2026-08 AU版基盤（Phase 2）：以前はここでregistration_completeを送信していたが、
        // Phase 2で導入するファネル計測イベント体系（signup_start/signup_complete/
        // first_login等）と名称が重複し、GA4上でファネル分析が二重化する問題があった
        // （ユーザー指示：registration_completeとsignup_completeの重複整理）。
        // signup_completeへ統一する。日本版はこれまでregistration_completeという
        // イベント名でGA4に送信していたため、日本版のGA4ダッシュボード側で
        // registration_complete系のレポート・アラートを設定している場合は
        // signup_completeへの名称変更に合わせて更新が必要になる点に留意
        trackEvent("signup_complete", { role });
        // 2026-08 AU Ads launch blocker対応：Google Ads Primary Conversion用に
        // wholesale roleでの登録完了だけを区別する専用イベント。retailer signup・
        // staff join（joinAsStaff、この関数を経由しない）では発火しない。
        // confirmInitialRoleのリトライ（上のcatchでfailed-preconditionを無視して
        // 続行するケース）でも、markActivationOnce側のサーバーtransactionが
        // 一度だけしかclaimed:trueを返さないため、GA4への二重送信は起きない
        if (role === "wholesale") {
          markActivationOnce("signupCompleteWholesaleAt", "signup_complete_wholesale", { role: "wholesale", market: isAU ? "AU" : "JP" });
        }
      };

      // QR招待経由 → 小売として直接設定画面
      if (isInvited) {
        return (
          <div style={{ padding: 16, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" }}>
            <div style={{ maxWidth: 420, margin: "40px auto", border: "1px solid #eee", borderRadius: 14, padding: 20, background: "white" }}>
              <div style={{ background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, fontWeight: 700, color: "#2e7d32" }}>
                {isAU ? "🤝 You'll be connected to your supplier" : "🤝 卸との接続が完了します"}
              </div>
              <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 4 }}>{isAU ? "🏪 Getting started" : "🏪 初期設定"}</div>
              <div style={{ fontSize: 13, color: "#666", marginBottom: 20 }}>{isAU ? "Please enter your store details" : "店舗情報を入力してください"}</div>
              <div style={{ display: "grid", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 4 }}>{isAU ? "Store name" : "店舗名"} <span style={{ color: "red" }}>{isAU ? "*required" : "*必須"}</span></div>
                  <input id="setup-name" placeholder={isAU ? "e.g. Smith's Cafe" : "例：居酒屋 山田"} style={{ width: "100%", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, boxSizing: "border-box", fontSize: 15 }} />
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 4 }}>{isAU ? "Phone (optional)" : "電話番号（任意）"}</div>
                  <input id="setup-tel" placeholder={isAU ? "e.g. 04XX XXX XXX" : "例：03-1234-5678"} inputMode="tel" style={{ width: "100%", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, boxSizing: "border-box", fontSize: 15 }} />
                </div>
                <button
                  onClick={() => saveSetup("retail", document.getElementById("setup-name")?.value || "", document.getElementById("setup-tel")?.value || "")}
                  style={{ padding: "14px", borderRadius: 12, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 16, cursor: "pointer", marginTop: 8 }}
                >
                  {isAU ? "Save and get started" : "保存して始める"}
                </button>
              </div>
            </div>
          </div>
        );
      }

      // 直接登録 → 役割選択

      return (
        <div style={{ minHeight: "100vh", background: "#f8faff", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" }}>
          <div style={{ width: "100%", maxWidth: 440 }}>
            {/* ロゴ */}
            <div style={{ textAlign: "center", marginBottom: 28 }}>
              <img src="/logo.png" alt="OrderLink" style={{ height: 56, objectFit: "contain", mixBlendMode: "multiply" }} />
              <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>{isAU ? "Order management, made simple" : "受発注クラウドシステム"}</div>
            </div>

            <div style={{ background: "white", borderRadius: 16, padding: 28, boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>

            {/* 役割未選択 */}
            {!setupRole && !setupStaffMode ? (
              <>
                <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 6, color: "#111827" }}>{isAU ? "Choose your account type" : "アカウントの種類を選択"}</div>
                <div style={{ fontSize: 13, color: "#888", marginBottom: 24 }}>{isAU ? "How will you be using OrderLink?" : "どちらの立場で使いますか？"}</div>
                <div style={{ display: "grid", gap: 12 }}>
                  <button onClick={() => setSetupRole("wholesale")}
                    style={{ padding: "20px 18px", borderRadius: 12, border: "2px solid #111827", background: "#111827", color: "white", fontWeight: 900, fontSize: 16, cursor: "pointer", textAlign: "left" }}>
                    {isAU ? "📦 I'm a supplier / wholesaler" : "📦 卸として使う"}
                    <div style={{ fontSize: 12, fontWeight: 400, marginTop: 4, opacity: 0.8 }}>{isAU ? "Receive orders from retailers and issue delivery notes" : "小売店から発注を受ける・納品書を発行する"}</div>
                  </button>
                  <button onClick={() => setSetupRole("retail")}
                    style={{ padding: "20px 18px", borderRadius: 12, border: "1px solid #ddd", background: "white", fontWeight: 900, fontSize: 16, cursor: "pointer", textAlign: "left", color: "#111827" }}>
                    {isAU ? "🛒 I'm a retailer / customer" : "🛒 小売として使う"}
                    <div style={{ fontSize: 12, fontWeight: 400, marginTop: 4, color: "#888" }}>{isAU ? "Order from your supplier, scan barcodes to order" : "卸に発注する・JANスキャンで発注"}</div>
                  </button>
                  <button onClick={() => setSetupStaffMode(true)}
                    style={{ padding: "14px 18px", borderRadius: 12, border: "1px solid #eee", background: "#f8f8f8", fontWeight: 700, fontSize: 14, cursor: "pointer", textAlign: "left", color: "#555" }}>
                    {isAU ? "👥 Join an existing business as staff" : "👥 既存の会社にスタッフとして参加"}
                    <div style={{ fontSize: 11, fontWeight: 400, marginTop: 3, color: "#999" }}>{isAU ? "If you have a staff invite code from an admin" : "管理者からスタッフ招待コードをもらった場合"}</div>
                  </button>
                </div>
              </>
            ) : setupRole && !setupStaffMode ? (
              /* 役割選択後 → 名前入力フォーム */
              <>
                <button onClick={() => setSetupRole("")} style={{ background: "none", border: "none", color: "#888", fontSize: 13, cursor: "pointer", marginBottom: 16, padding: 0 }}>{isAU ? "← Back" : "← 戻る"}</button>
                <div style={{ fontWeight: 900, fontSize: 20, marginBottom: 6, color: "#111827" }}>
                  {isAU
                    ? (setupRole === "wholesale" ? "📦 Business details" : "🛒 Store details")
                    : (setupRole === "wholesale" ? "📦 卸の情報を入力" : "🛒 店舗情報を入力")}
                </div>
                <div style={{ fontSize: 13, color: "#888", marginBottom: 24 }}>
                  {isAU
                    ? (setupRole === "wholesale" ? "Try it free for 30 days" : "Connect with your invited supplier to start ordering")
                    : (setupRole === "wholesale" ? "30日間無料でお試しいただけます" : "招待された卸と接続して発注を開始できます")}
                </div>
                <div style={{ display: "grid", gap: 14 }}>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: "#444" }}>
                      {isAU
                        ? (setupRole === "wholesale" ? "Business name" : "Store name")
                        : (setupRole === "wholesale" ? "会社名・屋号" : "店舗名")} <span style={{ color: "#1a56db" }}>{isAU ? "*required" : "*必須"}</span>
                    </div>
                    <input
                      value={setupName}
                      onChange={e => setSetupName(e.target.value)}
                      placeholder={isAU
                        ? (setupRole === "wholesale" ? "e.g. Smith Wholesale Pty Ltd" : "e.g. Smith's Cafe")
                        : (setupRole === "wholesale" ? "例：山田青果株式会社" : "例：居酒屋 山田")}
                      style={{ width: "100%", padding: "13px 14px", borderRadius: 10, border: "1px solid #ddd", fontSize: 15, fontWeight: 700, boxSizing: "border-box", outline: "none" }}
                    />
                  </div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: "#444" }}>{isAU ? "Phone (optional)" : "電話番号（任意）"}</div>
                    <input
                      value={setupTel}
                      onChange={e => setSetupTel(e.target.value)}
                      placeholder={isAU ? "e.g. 04XX XXX XXX" : "例：03-1234-5678"}
                      inputMode="tel"
                      style={{ width: "100%", padding: "13px 14px", borderRadius: 10, border: "1px solid #ddd", fontSize: 15, boxSizing: "border-box", outline: "none" }}
                    />
                  </div>
                  {setupRole === "wholesale" && (
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: "#444" }}>{isAU ? "Address (optional)" : "住所（任意）"}</div>
                      <input
                        value={setupAddress}
                        onChange={e => setSetupAddress(e.target.value)}
                        placeholder={isAU ? "e.g. 12 Smith St, Sydney NSW 2000" : "例：東京都渋谷区〇〇1-2-3"}
                        style={{ width: "100%", padding: "13px 14px", borderRadius: 10, border: "1px solid #ddd", fontSize: 15, boxSizing: "border-box", outline: "none" }}
                      />
                      <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>{isAU ? "Shown on delivery notes and invoices. You can change this later in Settings." : "納品書・請求書に印字されます。後から設定画面で変更できます。"}</div>
                    </div>
                  )}
                  {setupRole === "wholesale" && !isAU && (
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: "#444" }}>インボイス登録番号（任意）</div>
                      <input
                        value={setupInvoice}
                        onChange={e => setSetupInvoice(e.target.value)}
                        placeholder="例：T1234567890123"
                        style={{ width: "100%", padding: "13px 14px", borderRadius: 10, border: "1px solid #ddd", fontSize: 15, boxSizing: "border-box", outline: "none" }}
                      />
                      <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>納品書に自動で印字されます。後から設定画面で変更できます。</div>
                    </div>
                  )}
                  {/* 2026-08 AU版基盤（Phase 3）：ABNは日本のインボイス登録番号（T+13桁）とは
                      別のフィールド（tenants.abn）。初期設定時点では未入力のままにし、
                      Settings画面（Business Setup）で入力を促す（Tax Invoice発行前に必須） */}
                  {setupRole === "wholesale" && isAU && (
                    <div style={{ fontSize: 11, color: "#999", background: "#f8faff", border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 12px" }}>
                      💡 You can add your ABN in Settings once you've signed up — you'll need it before printing a Tax Invoice.
                    </div>
                  )}
                  {setupRole === "wholesale" && (
                    <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: "16px 14px", background: "#f8faff", display: "grid", gap: 14 }}>
                      <div style={{ fontSize: 13, fontWeight: 800, color: "#111827" }}>{isAU ? "📦 Delivery settings (can be changed later)" : "📦 納品日設定（後から変更可）"}</div>
                      <div style={{ fontSize: 12, color: "#4b5563", lineHeight: 1.7, background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 12px" }}>
                        {isAU
                          ? "These settings are used to automatically calculate the earliest delivery date shown to retailers. You can change them any time in Settings."
                          : "この設定をもとに、小売店へ表示する最短納品可能日を自動計算します。登録後も設定画面からいつでも変更できます。"}
                      </div>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: "#444" }}>{isAU ? "Lead time (business days from order to delivery)" : "リード日数（発注から納品までの営業日数）"}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <input
                            type="number"
                            min={0}
                            max={30}
                            value={setupLeadDays}
                            onChange={e => setSetupLeadDays(Number(e.target.value))}
                            style={{ width: 72, padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontSize: 15, fontWeight: 700, textAlign: "center" }}
                          />
                          <span style={{ fontSize: 14, color: "#555" }}>{isAU ? "days" : "日"}</span>
                        </div>
                        <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>{isAU ? "0 = same-day delivery, 1 = next business day, 2 = the business day after that" : "0日＝当日納品、1日＝翌営業日、2日＝翌々営業日"}</div>
                      </div>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6, color: "#444" }}>{isAU ? "Order cutoff time (orders after this go to the next business day)" : "受注締め時間（この時間を過ぎると翌営業日受付）"}</div>
                        <input
                          type="time"
                          value={setupCutoffTime}
                          onChange={e => setSetupCutoffTime(e.target.value)}
                          style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontSize: 15, fontWeight: 700 }}
                        />
                      </div>
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 8, color: "#444" }}>{isAU ? "Closed days" : "定休日"}</div>
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                          {(isAU ? [
                            { label: "Sat & Sun", days: [0, 6] },
                            { label: "Sun only", days: [0] },
                            { label: "None", days: [] },
                          ] : [
                            { label: "土日", days: [0, 6] },
                            { label: "日祝", days: [0] },
                            { label: "土日祝", days: [0, 6] },
                            { label: "なし", days: [] },
                          ]).map(p => (
                            <button
                              key={p.label}
                              type="button"
                              onClick={() => setSetupClosedWeekdays(p.days)}
                              style={{ padding: "6px 14px", borderRadius: 20, border: "1px solid", borderColor: JSON.stringify(setupClosedWeekdays) === JSON.stringify(p.days) ? "#1a56db" : "#ddd", background: JSON.stringify(setupClosedWeekdays) === JSON.stringify(p.days) ? "#e8f0fe" : "white", color: JSON.stringify(setupClosedWeekdays) === JSON.stringify(p.days) ? "#1a56db" : "#555", fontWeight: 700, fontSize: 13, cursor: "pointer" }}
                            >
                              {p.label}
                            </button>
                          ))}
                        </div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                          {(isAU ? ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] : ["日", "月", "火", "水", "木", "金", "土"]).map((d, i) => (
                            <label key={i} style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 13, cursor: "pointer" }}>
                              <input
                                type="checkbox"
                                checked={setupClosedWeekdays.includes(i)}
                                onChange={() => {
                                  setSetupClosedWeekdays(prev =>
                                    prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i].sort()
                                  );
                                }}
                              />
                              {d}
                            </label>
                          ))}
                        </div>
                        {(setupClosedWeekdays.includes(0) || setupClosedWeekdays.includes(6)) ? (
                          <div style={{ fontSize: 11, color: "#1a56db", marginTop: 4 }}>
                            {isAU ? "🎌 Public holidays for 2025–2026 have been set automatically (you can change this later)" : "🎌 祝日: 2025〜2026年の祝日を自動設定済み（後から変更可）"}
                          </div>
                        ) : (
                          <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>{isAU ? "You can add public holidays later in Settings" : "祝日は後から設定画面で追加できます"}</div>
                        )}
                      </div>
                    </div>
                  )}
                  <button
                    onClick={() => saveSetup(setupRole, setupName, setupTel, setupInvoice, setupAddress)}
                    style={{ padding: "14px", borderRadius: 10, border: "none", background: "#111827", color: "white", fontWeight: 900, fontSize: 16, cursor: "pointer", marginTop: 4 }}
                  >
                    {isAU
                      ? (setupRole === "wholesale" ? "Start your free trial" : "Save and get started")
                      : (setupRole === "wholesale" ? "無料トライアルを開始する" : "保存して始める")}
                  </button>
                </div>
              </>
            ) : (
              <div style={{ display: "grid", gap: 12 }}>
                <div style={{ background: "#f0f7ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "12px 14px", fontSize: 13, color: "#1e40af" }}>
                  {isAU ? "👥 Enter the 8-character staff invite code from your admin" : "👥 管理者から受け取ったスタッフ招待コード（8桁）を入力してください"}
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <input
                    value={setupStaffCode}
                    onChange={e => setSetupStaffCode(e.target.value.toUpperCase())}
                    placeholder={isAU ? "Staff invite code (8 characters)" : "スタッフ招待コード（8桁）"}
                    maxLength={8}
                    style={{ flex: 1, padding: "12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 16, fontWeight: 700, letterSpacing: 3, textAlign: "center" }}
                  />
                  <button
                    onClick={() => joinAsStaff(setupStaffCode)}
                    style={{ padding: "12px 18px", borderRadius: 10, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 14, cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    {isAU ? "Join" : "参加する"}
                  </button>
                </div>
                <button onClick={() => setSetupStaffMode(false)} style={{ fontSize: 13, color: "#888", background: "none", border: "none", cursor: "pointer", textDecoration: "underline" }}>
                  {isAU ? "← Back" : "← 戻る"}
                </button>
              </div>
            )}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={{ background: "#f6f6f6", minHeight: "100vh", fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: 16 }}>
          {/* トライアルバナー */}
          {trialDaysLeft !== null && tenantProfile?.role === "wholesale" && (
            trialDaysLeft > 0 ? (
              <div style={{ background: trialDaysLeft <= 7 ? "#fff3cd" : "#e8f5e9", border: `1px solid ${trialDaysLeft <= 7 ? "#ffc107" : "#a5d6a7"}`, borderRadius: 8, padding: "10px 16px", marginBottom: 12, fontSize: 13, fontWeight: 700, color: trialDaysLeft <= 7 ? "#7c5a00" : "#2e7d32", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <span>{isAU ? <>🎁 Free trial — <strong>{trialDaysLeft} days</strong> left</> : <>🎁 無料トライアル期間中 — 残り <strong>{trialDaysLeft}日</strong></>}</span>
                <button
                  onClick={() => setShowPlanModal(true)}
                  style={{ background: "#111827", color: "#fff", border: "none", borderRadius: 6, padding: "6px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  {isAU ? "Upgrade to a paid plan" : "有料プランに移行する"}
                </button>
              </div>
            ) : (
              <div style={{ background: "#eff6ff", border: "1px solid #fca5a5", borderRadius: 8, padding: "12px 16px", marginBottom: 12, fontSize: 13, fontWeight: 700, color: "#991b1b", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <span>{isAU ? "⚠️ Your free trial has ended. Upgrade to a paid plan to keep using OrderLink." : "⚠️ トライアル期間が終了しました。引き続きご利用いただくには有料プランへの移行が必要です。"}</span>
                <button
                  onClick={() => setShowPlanModal(true)}
                  style={{ background: "#991b1b", color: "#fff", border: "none", borderRadius: 6, padding: "8px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  {isAU ? "Choose a plan" : "プランを選択する"}
                </button>
              </div>
            )
          )}

          {/* トライアル期限切れモーダル */}
          {showExpiredModal && createPortal(
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
              <div style={{ background: "#fff", borderRadius: 12, padding: 32, maxWidth: 440, width: "100%", textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>🔒</div>
                <h2 style={{ fontSize: 20, fontWeight: 900, color: "#111827", margin: "0 0 10px" }}>{isAU ? "Your free trial has ended" : "無料トライアルが終了しました"}</h2>
                <p style={{ fontSize: 14, color: "#666", margin: "0 0 24px", lineHeight: 1.7 }}>
                  {isAU ? <>You'll need to upgrade to a paid plan to keep using OrderLink.<br />All your data is kept safe.</> : <>引き続きご利用いただくには、有料プランへの移行が必要です。<br />データはすべて保持されます。</>}
                </p>
                <button
                  onClick={() => { setShowExpiredModal(false); setShowPlanModal(true); }}
                  style={{ width: "100%", background: "#1a56db", color: "#fff", border: "none", borderRadius: 8, padding: "12px 0", fontWeight: 700, fontSize: 15, cursor: "pointer", marginBottom: 10 }}
                >
                  {isAU ? "Choose a plan to continue" : "プランを選択して続ける"}
                </button>
                <button
                  onClick={() => setShowExpiredModal(false)}
                  style={{ width: "100%", background: "transparent", border: "1px solid #ddd", borderRadius: 8, padding: "10px 0", fontSize: 13, color: "#666", cursor: "pointer" }}
                >
                  {isAU ? "Close (view only)" : "閉じる（閲覧のみ）"}
                </button>
              </div>
            </div>,
            document.body
          )}

          {/* プラン選択モーダル */}
          {showPlanModal && createPortal(
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
              <div style={{ background: "#fff", borderRadius: 12, padding: 32, maxWidth: 440, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
                <h2 style={{ margin: "0 0 6px", fontSize: 20, color: "#111827" }}>{isAU ? "Upgrade to a paid plan" : "有料プランへ移行"}</h2>
                <p style={{ margin: "0 0 24px", fontSize: 13, color: "#666" }}>{isAU ? "No setup fee, just a monthly subscription" : "初期費用ゼロ ＋ 月額料金"}</p>
                <div style={{ border: "2px solid #1a56db", borderRadius: 10, padding: 24, marginBottom: 20 }}>
                  <div style={{ fontSize: 15, fontWeight: 800, color: "#111827", marginBottom: 4 }}>OrderLink</div>
                  {isAU ? (
                    <div style={{ fontSize: 30, fontWeight: 900, color: "#1a56db", marginBottom: 2 }}>A$250<span style={{ fontSize: 13, fontWeight: 400, color: "#666" }}>/month (ex GST)</span></div>
                  ) : (
                    <div style={{ fontSize: 30, fontWeight: 900, color: "#1a56db", marginBottom: 2 }}>¥20,000<span style={{ fontSize: 13, fontWeight: 400, color: "#666" }}>/月（税別）</span></div>
                  )}
                  <div style={{ fontSize: 12, color: "#888", marginBottom: 16 }}>{isAU ? "Unlimited customers, products, and orders" : "取引先数・商品数・受注件数すべて無制限"}</div>
                  <ul style={{ fontSize: 12, color: "#444", paddingLeft: 16, margin: "0 0 20px", lineHeight: 1.8 }}>
                    {isAU ? (
                      <>
                        <li>Digital order management</li>
                        <li>Barcode scan ordering</li>
                        <li>PDF delivery notes</li>
                        <li>Unlimited customers</li>
                        <li>Email support</li>
                      </>
                    ) : (
                      <>
                        <li>受発注デジタル化</li>
                        <li>JANスキャン発注</li>
                        <li>納品書PDF発行</li>
                        <li>取引先数無制限</li>
                        <li>メールサポート</li>
                      </>
                    )}
                  </ul>
                  <button
                    onClick={() => handleCheckout("starter")}
                    disabled={checkoutLoading}
                    style={{ width: "100%", background: "#1a56db", color: "#fff", border: "none", borderRadius: 8, padding: "12px 0", fontWeight: 700, fontSize: 15, cursor: checkoutLoading ? "not-allowed" : "pointer", opacity: checkoutLoading ? 0.6 : 1 }}
                  >
                    {isAU
                      ? (checkoutLoading ? "Processing..." : "Subscribe to this plan")
                      : (checkoutLoading ? "処理中..." : "このプランで決済する")}
                  </button>
                </div>
                <button
                  onClick={() => setShowPlanModal(false)}
                  style={{ width: "100%", background: "transparent", border: "1px solid #ddd", borderRadius: 8, padding: "8px 0", fontSize: 13, color: "#666", cursor: "pointer" }}
                >
                  {isAU ? "Cancel" : "キャンセル"}
                </button>
              </div>
            </div>,
            document.body
          )}
          {/* Stripe 決済完了トースト */}
          {checkoutResult === "success" && (
            <div style={{ background: "#d1fae5", border: "1px solid #6ee7b7", borderRadius: 8, padding: "12px 16px", marginBottom: 12, fontSize: 14, fontWeight: 700, color: "#065f46", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{isAU ? "🎉 You're now on a paid plan! Thanks for continuing with OrderLink." : "🎉 有料プランへの移行が完了しました！引き続きご利用ください。"}</span>
              <button onClick={() => setCheckoutResult(null)} style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: 18, color: "#065f46" }}>×</button>
            </div>
          )}
          {checkoutResult === "cancel" && (
            <div style={{ background: "#fef9c3", border: "1px solid #fde047", borderRadius: 8, padding: "12px 16px", marginBottom: 12, fontSize: 13, color: "#713f12", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{isAU ? "Checkout was cancelled. You can keep using your free trial." : "決済がキャンセルされました。引き続きトライアルをご利用いただけます。"}</span>
              <button onClick={() => setCheckoutResult(null)} style={{ background: "transparent", border: "none", cursor: "pointer", fontSize: 18, color: "#713f12" }}>×</button>
            </div>
          )}

          {/* header */}
          <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" }}>
            {tenantProfile?.role ? (
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <img
                  src={orderlinkLogo}
                  alt="OrderLink"
                  style={{
                    width: 190,
                    height: "auto",
                    objectFit: "contain",
                    mixBlendMode: "multiply",
                    display: "block",
                  }}
                />
                {mode === "wholesale" && (
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", letterSpacing: 1, borderLeft: "1px solid #e5e7eb", paddingLeft: 10 }}>
                    {isAU ? "Wholesale management" : "卸管理システム"}
                  </div>
                )}
              </div>
            ) : (
              <div style={{ fontSize: 18, fontWeight: 900 }}>{isAU ? "Order Demo" : "受発注デモ"}</div>
            )}

            {/* 右側ボタン群：メインメニューのみ表示 */}
            <div style={{ marginLeft: "auto", display: (retailView === "home" && mode === "retail") || (wholesaleView === "home" && mode === "wholesale") ? "flex" : "none", gap: 8, flexWrap: "wrap", alignItems: "flex-end" }}>
              <button
                onClick={joinTenantByCode}
                style={{
                  padding: "8px 10px",
                  borderRadius: 10,
                  border: "1px solid #ddd",
                  fontWeight: 900,
                  background: "white",
                  cursor: "pointer",
                }}
                title={isAU ? "Enter an invite code to join the same business" : "招待コード(tenantId)を入力して同じ会社に参加"}
              >
                {isAU ? "🤝 Join with invite code" : "🤝 招待コードで参加"}
              </button>

              {/* モード切替：role未設定（デモ）のみ表示 */}
              {!tenantProfile?.role && (
                <>
                  <button
                    onClick={() => setMode("retail")}
                    style={{
                      padding: "8px 10px",
                      borderRadius: 10,
                      border: mode === "retail" ? "2px solid #111" : "1px solid #ddd",
                      fontWeight: 800,
                      background: "white",
                    }}
                  >
                    {isAU ? "Retail mode" : "小売モード"}
                  </button>
                  <button
                    onClick={() => setMode("wholesale")}
                    style={{
                      padding: "8px 10px",
                      borderRadius: 10,
                      border: mode === "wholesale" ? "2px solid #111" : "1px solid #ddd",
                      fontWeight: 800,
                      background: "white",
                    }}
                  >
                    {isAU ? "Wholesale mode" : "卸モード"}
                  </button>
                </>
              )}

              {/* テスト・投入：デモアカウントのみ表示
                  （Firestoreテスト保存・件数チェックは本番運用に不要なため削除済み） */}
              {!tenantProfile?.role && (
                <>
                  <button onClick={seedInitialProductsIfEmpty} disabled={!user || !tenantId}>
                    {isAU ? "Seed initial products" : "products初期投入"}
                  </button>
                </>
              )}

              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                <div style={{ fontSize: 11, color: "#6b7280" }}>{user?.email}</div>
                <button
                  onClick={handleSignOut}
                  style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer" }}
                >
                  {isAU ? "Log out" : "ログアウト"}
                </button>
              </div>
            </div>
            {/* ログアウトはサブページでも表示 */}
            {!((retailView === "home" && mode === "retail") || (wholesaleView === "home" && mode === "wholesale")) && (
              <button
                onClick={handleSignOut}
                style={{ marginLeft: "auto", padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer" }}
              >
                {isAU ? "Log out" : "ログアウト"}
              </button>
            )}
          </div>

          {/* toast */}
          {toast && (
            <div
              style={{
                position: "fixed",
                top: 14,
                left: "50%",
                transform: "translateX(-50%)",
                background: "#111",
                color: "white",
                padding: "10px 14px",
                borderRadius: 999,
                fontWeight: 800,
                zIndex: 9999,
                boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
              }}
            >
              {toast}
            </div>
          )}


          {/* last scan banner */}
          {lastScan && (
            <div
              style={{
                position: "fixed",
                top: 58,
                left: "50%",
                transform: "translateX(-50%)",
                background: "white",
                border: "1px solid #ddd",
                padding: "8px 12px",
                borderRadius: 12,
                fontWeight: 800,
                zIndex: 9999,
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              }}
            >
              {lastScan}
            </div>
          )}


{/* ✅ hidden file input（アプリ全体で1個だけ / どの画面でも存在する） */}
<input
  ref={importFileRef}
  type="file"
  accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xlsx,.xls"
  style={{ display: "none" }}
  onChange={(e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    handleImportFile(f); // ✅ ここに統一
  }}
/>


            {/* ✅ この下に、他の wholesale / retail ブロックも全部続けて入れる */}
      


        {/* ===== retail ===== */}
{mode === "retail" && (
  <div
    style={{
      display: "grid",
      gap: 12,
      paddingBottom: retailView === "order" ? 96 : 0,
    }}
  >
    {/* ✅ retail header（ホーム以外で表示） */}
    {retailView !== "home" && (
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          background: "white",
          padding: "10px 12px",
          borderBottom: "1px solid #eee",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 1fr auto",
            alignItems: "center",
          }}
        >
          {/* 左：戻る（孤立） */}
          <div>
            <button
              onClick={() => {
                setRetailView("home");
                setConfirmOpen(false);
                setSearchOpen(false);
                setRegOpen(false);
                setScannerOpen(false);
              }}
              style={{
                ...S.btn,
                background: "#111",
                color: "white",
                width: "auto",
              }}
            >
              {isAU ? "← Menu" : "← メニュー"}
            </button>
          </div>

          {/* 中央：タイトル */}
          <div style={{ textAlign: "center", fontWeight: 900 }}>
            {retailView === "order" && (isAU ? "Order" : "発注")}
            {retailView === "history" && (isAU ? "History" : "履歴")}
            {retailView === "products" && (isAU ? "Products & Pricing" : "商品登録・価格変更")}
            {retailView === "summary" && (isAU ? "Summary" : "集計")}
            {retailView === "suppliers" && (isAU ? "Suppliers" : "仕入先登録")}
            {retailView === "settings" && (isAU ? "Settings" : "設定")}
            {retailView === "connection" && (isAU ? "Connection & invite code" : "接続・招待コード")}
            {retailView === "company-info" && (isAU ? "Business details" : "会社情報")}
          </div>

          {/* 右：空（レイアウト保持用） */}
          <div />
        </div>
      </div>
    )}

    {/* ✅ 小売：仕入れ先選択（発注・商品登録で必須） */}
    {(retailView === "order" || retailView === "products") && (
      <SupplierSelector
        suppliers={suppliers}
        supplierId={supplierId}
        onSelect={selectSupplier}
        supplierNameById={supplierNameById}
        isAU={isAU}
      />
    )}


              {/* ✅ retail home（メインメニュー）
                  2026-08（Step 12 E2E検証時に発覚したバグ対応）：小売メインメニュー
                  全体がisAU分岐なしで完全に日本語ハードコードされていた */}
              {retailView === "home" && (
                <div style={{ display: "grid", gap: 12, maxWidth: 520, margin: "0 auto" }}>
                  <div style={{ ...S.card }}>
                    <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "Retail menu" : "小売メニュー"}</div>
                    <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>{isAU ? "Tap to go to each feature" : "タップして各機能に進みます"}</div>
                  </div>

                  <button onClick={() => setRetailView("order")} style={{ ...S.btn, textAlign: "left", padding: "40px 20px", background: "#10b981", color: "white", border: "none" }}>
                    <div style={{ fontSize: 22, fontWeight: 900 }}>{isAU ? "🛒 Place an order" : "🛒 発注する"}</div>
                    <div style={{ fontSize: 13, opacity: 0.85, marginTop: 6 }}>{isAU ? "Scan a barcode or search products to build and send your order" : "JANスキャン / 商品検索で明細を作って送信"}</div>
                  </button>

                  <button onClick={() => setRetailView("history")} style={{ ...S.btn, textAlign: "left", padding: "16px 14px" }}>
                    {isAU ? "🕘 History" : "🕘 履歴"}
                    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>{isAU ? "View past orders and supplier changes" : "過去の発注・卸変更の確認"}</div>
                  </button>

                  <button onClick={() => setRetailView("summary")} style={{ ...S.btn, textAlign: "left", padding: "16px 14px" }}>
                    {isAU ? "📊 Summary" : "📊 集計"}
                    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>{isAU ? "By month, supplier, and more" : "月別・仕入れ先別など"}</div>
                  </button>

                  <button onClick={() => setRetailView("settings")} style={{ ...S.btn, textAlign: "left", padding: "16px 14px" }}>
                    {isAU ? "⚙️ Settings" : "⚙️ 設定"}
                    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>{isAU ? "Business details, supplier connection, suppliers" : "会社情報・卸との接続・仕入先の管理"}</div>
                  </button>

                  {/* 初回オンボーディング：発注が0件 & 卸接続済みのときのみ表示 */}
                  {orders.length === 0 && _effectiveWholesaleTid && (
                    <div style={{ border: "2px dashed #4a90e2", borderRadius: 12, padding: "14px 16px", background: "#f0f6ff" }}>
                      <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 6, color: "#1a5fb4" }}>{isAU ? "🚀 Try it out first" : "🚀 まず動作確認してみましょう"}</div>
                      <div style={{ fontSize: 12, color: "#888", marginBottom: 10 }}>
                        {isAU ? (
                          <>Create a test order using your supplier's products.<br />Check that it arrives in your supplier's "Order management" screen.</>
                        ) : (
                          <>卸の商品を使ってテスト発注を作成します。<br />卸側の「受注一覧」に届くか確認できます。</>
                        )}
                      </div>
                      <button
                        onClick={createSampleRetailOrder}
                        style={{ padding: "10px 20px", borderRadius: 10, background: "#4a90e2", color: "white", border: "none", fontWeight: 900, cursor: "pointer", fontSize: 14 }}
                      >
                        {isAU ? "Create a test order" : "テスト発注を作成する"}
                      </button>
                    </div>
                  )}
                </div>
              )}



              {/* ===== order ===== */}
              {retailView === "order" && (
                <div style={{ display: "grid", gap: 12 }}>
        
                 {/* 小売店名
                     2026-08（Step 12 E2E検証時に発覚したバグ対応）：isAU分岐なしで
                     完全に日本語ハードコードされていた */}
<div style={{ maxWidth: 720 }}>
  <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 6 }}>
    <div style={{ fontWeight: 900 }}>{isAU ? "Store name" : "小売店名"}</div>

    <label
      style={{
        marginLeft: "auto",
        display: "flex",
        gap: 6,
        alignItems: "center",
        fontSize: 12,
        opacity: 0.8,
        userSelect: "none",
      }}
    >
     <input
  type="checkbox"
  checked={rememberShopName}
  onChange={(e) => setRememberShopName(e.target.checked)}
/>
      {isAU ? "Remember for next time" : "次回も自動入力"}
    </label>
  </div>

  <input
    value={shopName}
    onChange={(e) => setShopName(e.target.value)}
    placeholder={isAU ? "e.g. Smith's Cafe" : "例：〇〇ショップ"}
    style={{
      width: "100%",
      padding: "10px 12px",
      borderRadius: 12,
      border: "1px solid #ddd",
      fontWeight: 800,
      background: "white",
    }}
  />

  {shopNameFixed && (shopName || "").trim() && (
    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 6 }}>
      {isAU ? `✓ Saved on this device: ${(shopName || "").trim()}` : `✓ この端末に保存：${(shopName || "").trim()}`}
    </div>
  )}

  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
    {isAU ? "* Shown on the supplier's order list and delivery note" : "※ 卸の受注一覧・納品書に表示されます"}
  </div>
</div>

{/* 備考 */}
<div style={{ maxWidth: 720, marginTop: 12 }}>
  <div style={{ fontWeight: 900, marginBottom: 6 }}>{isAU ? "Notes (optional)" : "備考（任意）"}</div>
  <textarea
    value={orderNote}
    onChange={(e) => setOrderNote(e.target.value)}
    placeholder={isAU ? "e.g. Please deliver by the 5th" : "例：〇日までに納品希望"}
    rows={3}
    style={{
      width: "100%",
      padding: "10px 12px",
      borderRadius: 12,
      border: "1px solid #ddd",
      fontWeight: 700,
      background: "white",
      fontFamily: "inherit",
      resize: "vertical",
    }}
  />
  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
    {isAU ? "* Shown on the purchase order and delivery note" : "※ 発注書・納品書に記載されます"}
  </div>
</div>

                  {/* add zone */}
                  <div
                    style={{
                      marginTop: 8,
                      marginBottom: 12,
                      padding: 12,
                      borderRadius: 14,
                      background: "#f7f7f7",
                      display: "grid",
                      gap: 10,
                      maxWidth: 720,
                    }}
                  >
                    <button
                      onClick={() => supplierSelected && (setJanMode("scan"), setScannerOpen(true))}
                      disabled={!supplierSelected}
                      style={{
                        width: "100%",
                        padding: "14px 12px",
                        borderRadius: 12,
                        border: "none",
                        fontWeight: 900,
                        fontSize: 16,
                        background: !supplierSelected ? "#888" : "#111",
                        color: "white",
                        cursor: !supplierSelected ? "not-allowed" : "pointer",
                        opacity: !supplierSelected ? 0.7 : 1,
                      }}
                      title={!supplierSelected ? (isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください") : ""}
                    >
                      {isAU ? "📷 Scan barcode to add product" : "📷 JANスキャンして商品追加"}
                    </button>

                    {/* 手動入力で追加（バーコードなし商品対応）
                        2026-08（Codexレビュー6回目MUST-FIX対応）：この手動追加で
                        カートに入る明細にはidが付与されないため、発注送信時の
                        callableLinesフィルタ（!!l.id）で黙って除外され、そもそも
                        発注が成立しない（市場共通の既存不具合）。サーバー側で
                        手動明細を安全に扱う専用契約が未実装のため、AU版では
                        機能自体を一時的に非表示にする。日本版は既存動作を
                        変更しないため現状のまま残す（別途対応要検討） */}
                    {!isAU && (
                    <div>
                      <button
                        onClick={() => supplierSelected && setManualAddOpen(v => !v)}
                        disabled={!supplierSelected}
                        style={{
                          width: "100%", padding: "12px", borderRadius: 12,
                          border: "1px solid #ddd", fontWeight: 900, fontSize: 14,
                          background: "white", color: !supplierSelected ? "#888" : "#333",
                          cursor: !supplierSelected ? "not-allowed" : "pointer",
                        }}
                      >
                        ✏️ 商品名で手動入力して追加
                      </button>
                      {manualAddOpen && (
                        <div style={{ marginTop: 8, padding: 12, background: "#f9f9f9", borderRadius: 12, border: "1px solid #eee", display: "grid", gap: 8 }}>
                          <input
                            value={manualAddName}
                            onChange={e => setManualAddName(e.target.value)}
                            placeholder={isAU ? "Product name (required)" : "商品名（必須）"}
                            style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14 }}
                            autoFocus
                          />
                          <div style={{ display: "flex", gap: 8 }}>
                            <input
                              value={manualAddUnit}
                              onChange={e => setManualAddUnit(e.target.value)}
                              placeholder={isAU ? "Unit (e.g. carton, kg)" : "単位（例：個・kg）"}
                              style={{ flex: 1, padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14 }}
                            />
                            <input
                              value={manualAddQty}
                              onChange={e => setManualAddQty(e.target.value)}
                              placeholder={isAU ? "Qty" : "数量"}
                              inputMode="numeric"
                              style={{ width: 80, padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14 }}
                            />
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <div style={{ fontSize: 13, color: "#555", fontWeight: 700, whiteSpace: "nowrap" }}>{isAU ? "GST" : "税率"}</div>
                            {/* 2026-08（Codexレビュー5回目MUST-FIX対応）：AU_TAX_POLICYは
                                0%/10%のみを許可し8%区分は存在しない。以前はJP版と同じ
                                10%/8%/0%の3択をAU版でも表示しており、ユーザーが正規のUI
                                操作で8%を選択してもサーバー側assertValidTaxRateが必ず
                                拒否する（発注できない）という機能不整合があった */}
                            <select
                              value={manualAddTaxRate}
                              onChange={e => setManualAddTaxRate(e.target.value)}
                              style={{ flex: 1, padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14 }}
                            >
                              {isAU ? (
                                <>
                                  <option value="0.1">GST 10%</option>
                                  <option value="0">GST-free (0%)</option>
                                </>
                              ) : (
                                <>
                                  <option value="0.1">10%（標準税率）</option>
                                  <option value="0.08">8%（軽減税率）</option>
                                  <option value="0">非課税</option>
                                </>
                              )}
                            </select>
                          </div>
                          <div style={{ fontSize: 11, color: "#888" }}>{isAU ? "* The supplier will enter the price when confirming your order" : "※ 単価は卸が受注確認時に入力します"}</div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              onClick={() => setManualAddOpen(false)}
                              style={{ flex: 1, padding: "10px", borderRadius: 10, border: "1px solid #ddd", background: "white", fontWeight: 900 }}
                            >{isAU ? "Cancel" : "キャンセル"}</button>
                            <button
                              onClick={() => {
                                const name = manualAddName.trim();
                                if (!name) return showToast(isAU ? "Please enter a product name" : "商品名を入力してください");
                                const qty = Math.max(1, parseInt(manualAddQty) || 1);
                                add({ name, unit: manualAddUnit || (isAU ? "" : "個"), qty, costPrice: 0, price: 0, barcode: "", taxRate: Number(manualAddTaxRate) });
                                showToast(isAU ? `Added ${name} (the supplier will set the price)` : `${name} を追加しました（卸が受注時に単価を入力します）`);
                                setManualAddName(""); setManualAddUnit(isAU ? "" : "個"); setManualAddQty("1"); setManualAddTaxRate("0.1"); setManualAddOpen(false);
                              }}
                              style={{ flex: 2, padding: "10px", borderRadius: 10, border: "none", background: "#111", color: "white", fontWeight: 900 }}
                            >{isAU ? "Add" : "追加する"}</button>
                          </div>
                        </div>
                      )}
                    </div>
                    )}

                    <div style={{ position: "relative" }}>
                      <input
                        value={searchText}
                        onChange={e => { setSearchText(e.target.value); setSearchOpen(true); }}
                        onFocus={() => setSearchOpen(true)}
                        onBlur={() => setTimeout(() => setSearchOpen(false), 200)}
                        disabled={!supplierSelected}
                        placeholder={supplierSelected ? (isAU ? "🔎 Search by product name or barcode" : "🔎 商品名・JANで検索") : (isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください")}
                        style={{
                          width: "100%",
                          padding: "12px 14px",
                          borderRadius: 12,
                          border: searchText ? "2px solid #2563eb" : "1px solid #ddd",
                          fontWeight: 700,
                          fontSize: 14,
                          boxSizing: "border-box",
                          background: !supplierSelected ? "#f2f2f2" : "white",
                          cursor: !supplierSelected ? "not-allowed" : "text",
                          outline: "none",
                        }}
                      />
                      {searchOpen && supplierSelected && (catalogLoading || wholesaleCatalogLoading || wholesaleCatalogError || catalogOwnError || wholesaleBarcodeError || (fsSearchError && searchText.trim().length >= 2) || searchResults.length > 0) && (
                        <div style={{
                          position: "absolute", top: "100%", left: 0, right: 0,
                          background: "white", border: "1px solid #ddd", borderRadius: 12,
                          zIndex: 500, maxHeight: 320, overflowY: "auto",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
                        }}>
                          {(catalogLoading || wholesaleCatalogLoading) && (
                            <div style={{ padding: "14px 16px", display: "flex", alignItems: "center", gap: 8, color: "#888", fontSize: 13 }}>
                              <span style={{
                                display: "inline-block", width: 14, height: 14,
                                border: "2px solid #ddd", borderTopColor: "#555",
                                borderRadius: "50%", animation: "spin 0.7s linear infinite", flexShrink: 0,
                              }} />
                              {isAU ? "Searching..." : "検索中..."}
                            </div>
                          )}
                          {wholesaleCatalogError && (
                            <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 10, color: "#b91c1c", fontSize: 13, background: "#fef2f2" }}>
                              <span>{isAU ? "⚠ Failed to load product data. Please try again." : "⚠ 商品データの取得に失敗しました。再試行してください。"}</span>
                              <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  const supplierObjForRetry = suppliers.find((s) => s.id === supplierId || s.supplierId === supplierId);
                                  const profileWholeTidForRetry = String(tenantProfile?.wholesaleTenantId || "").trim();
                                  const retryWholesaleTenantId =
                                    String(supplierObjForRetry?.wholesaleTenantId || "").trim() ||
                                    (profileWholeTidForRetry && profileWholeTidForRetry === supplierId ? supplierId : "");
                                  if (retryWholesaleTenantId) loadWholesaleCatalogPage(retryWholesaleTenantId, { isFirstPage: true, forceReset: true });
                                }}
                                style={{ padding: "4px 10px", borderRadius: 8, border: "none", background: "#b91c1c", color: "white", fontWeight: 700, fontSize: 11, cursor: "pointer", flexShrink: 0 }}
                              >
                                {isAU ? "Retry" : "再試行"}
                              </button>
                            </div>
                          )}
                          {catalogOwnError && (
                            <div style={{ padding: "12px 14px", color: "#b91c1c", fontSize: 13, background: "#fef2f2" }}>
                              {isAU ? "⚠ Failed to load registered products. The list shown may be incomplete." : "⚠ 登録商品の取得に失敗しました。表示中の商品は不完全な可能性があります。"}
                            </div>
                          )}
                          {wholesaleBarcodeError && (
                            <div style={{ padding: "12px 14px", color: "#b91c1c", fontSize: 13, background: "#fef2f2" }}>
                              {isAU ? "⚠ Barcode/product code search failed. Please try again." : "⚠ JAN/商品コード検索に失敗しました。再試行してください。"}
                            </div>
                          )}
                          {fsSearchError && searchText.trim().length >= 2 && (
                            <div style={{ padding: "12px 14px", color: "#b45309", fontSize: 13, background: "#fffbeb" }}>
                              {isAU ? "⚠ Search results may be incomplete (some products could not be retrieved)." : "⚠ 検索結果が不完全な可能性があります（一部の商品を取得できませんでした）。"}
                            </div>
                          )}
                          {searchResults.map(p => {

                            const cp = getCostPriceStrict(p);
                            return (
                              <div
                                key={p.id}
                                onClick={() => {
                                  add(normalizeProductForLine(p));
                                  showToast(isAU ? `Added ${p.name}` : `${p.name} を追加`);
                                  setSearchText("");
                                  setSearchOpen(false);
                                }}
                                style={{
                                  padding: "10px 14px", cursor: "pointer",
                                  borderBottom: "1px solid #f4f4f4",
                                  display: "flex", justifyContent: "space-between", alignItems: "center",
                                }}
                              >
                                <div>
                                  <div style={{ fontWeight: 700, fontSize: 13 }}>{p.name}</div>
                                  <div style={{ fontSize: 11, opacity: 0.6 }}>{p.barcode || (isAU ? "No barcode" : "JANなし")}{p.unit ? ` / ${p.unit}` : ""}</div>
                                </div>
                                <div style={{ fontWeight: 900, fontSize: 13, flexShrink: 0, marginLeft: 8 }}>
                                  {cp <= 0 ? <span style={{ color: "#b45309", fontSize: 11 }}>{isAU ? "No cost price" : "原価未登録"}</span> : formatMoney(cp, tenantProfile?.marketId)}
                                </div>
                              </div>
                            );
                          })}
                          {!searchText.trim() && wholesaleCatalogHasMore && (
                            <button
                              type="button"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                const supplierObjForMore = suppliers.find((s) => s.id === supplierId || s.supplierId === supplierId);
                                const profileWholeTidForMore = String(tenantProfile?.wholesaleTenantId || "").trim();
                                const moreWholesaleTenantId =
                                  String(supplierObjForMore?.wholesaleTenantId || "").trim() ||
                                  (profileWholeTidForMore && profileWholeTidForMore === supplierId ? supplierId : "");
                                if (moreWholesaleTenantId) loadWholesaleCatalogPage(moreWholesaleTenantId, { isFirstPage: false });
                              }}
                              disabled={wholesaleCatalogLoadingMore}
                              style={{ width: "100%", padding: "10px 14px", border: "none", borderTop: "1px solid #eee", background: "white", color: "#2563eb", fontWeight: 700, fontSize: 13, cursor: wholesaleCatalogLoadingMore ? "default" : "pointer" }}
                            >
                              {wholesaleCatalogLoadingMore ? (isAU ? "Loading..." : "読み込み中...") : (isAU ? "Show more products" : "商品をもっと見る")}
                            </button>
                          )}
                        </div>
                      )}
                    </div>

                    <div style={{ fontSize: 12, opacity: 0.7 }}>{isAU ? "* If the barcode won't scan, try searching by product name instead" : "※ JANが読めない場合は商品名検索を使ってください"}</div>
                  </div>

                  {/* よく注文する商品（過去30日履歴） */}
                  {supplierId && retailHistoryProducts.length > 0 && (
                    <div style={{ maxWidth: 720, border: "1px solid #e0f0ff", borderRadius: 14, padding: 16, background: "#f0f8ff", marginBottom: 12 }}>
                      <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 10, color: "#1a6bbf" }}>
                        {isAU ? "🕐 Frequently ordered (last 30 days)" : "🕐 よく注文する商品（直近30日）"}
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                        {retailHistoryProducts.map((p, idx) => {
                          const master = (products || []).find(m => m.id === p.id || (p.barcode && String(m.barcode || "") === String(p.barcode)));
                          const productToAdd = master ? normalizeProductForLine(master) : normalizeProductForLine(p);
                          const alreadyAdded = lines.some(l => l.id === p.id || (p.barcode && String(l.barcode || "") === String(p.barcode)));
                          const unitPrice = Number(productToAdd.costPrice || productToAdd.price || 0);
                          return (
                            <button
                              key={idx}
                              onClick={() => add(productToAdd)}
                              style={{
                                padding: "8px 12px", borderRadius: 20,
                                border: alreadyAdded ? "2px solid #1a6bbf" : "1px solid #b3d4f5",
                                background: alreadyAdded ? "#dbeafe" : "white",
                                cursor: "pointer", textAlign: "left",
                                display: "flex", flexDirection: "column", gap: 2,
                              }}
                            >
                              <span style={{ fontWeight: 700, fontSize: 13, color: "#1a3a5c" }}>{p.name}</span>
                              <span style={{ fontSize: 11, color: "#555" }}>
                                {isAU
                                  ? `${p.orderCount}x / total ${p.totalQty}${p.unit || ""}`
                                  : `${p.orderCount}回 / 計${p.totalQty}${p.unit || ""}`}
                                {unitPrice > 0 ? ` · ${formatMoney(unitPrice, tenantProfile?.marketId)}` : ""}
                                {alreadyAdded ? " ✓" : ""}
                              </span>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                 {/* lines */}
<div>
  <div style={{ fontWeight: 900, marginBottom: 6 }}>{isAU ? "Order items" : "明細"}</div>

  {lines.length === 0 ? (
    <div style={{ opacity: 0.7 }}>{isAU ? "(None yet)" : "（まだありません）"}</div>
  ) : (
    <div style={{ display: "grid", gap: 8, maxWidth: 720 }}>
      {lines.map((l) => {
        const canEdit = true; // ✅ retail の下書きは常に編集可能

        // ✅ barcode をキーにマスタ(products)から引く（lineに無くてもOK）
        const bc = String(l.barcode || "").trim();
        const p =
          (products || []).find((x) => String(x.barcode || "").trim() === bc) ||
          null;

        const displayName =
          String(l.name || p?.name || "").trim() || (isAU ? "(Unnamed product)" : "（商品名未登録）");
        const displayUnit =
          String(l.unit || p?.unit || "個").trim() || "個";
        const displayTaxRate = (() => {
          // 商品マスタのtaxRateを優先（過去注文の誤ったtaxRateを表示上修正）
          if (p?.taxRate != null) return Number(p.taxRate);
          if (l.taxRate != null) return Number(l.taxRate);
          return 0.1;
        })();

        // ✅ 単価は「原価優先」：納品書/卸送信の思想に合わせる
        // 優先: lineのcostPrice → masterのcostPrice → lineのprice → masterのsellPrice/price
        const unitPrice = Number(l.costPrice ?? l.price ?? 0) || 0; // 原価のみ

        const lineTotal = Number(l.qty || 0) * unitPrice;

        return (
          <div
            key={l.id}
            style={{
              border: "1px solid #eee",
              padding: 10,
              borderRadius: 12,
              background: "white",
              display: "grid",
              gap: 8,
            }}
          >
            {/* ✅ 商品名・JAN */}
            <div style={{ fontWeight: 900 }}>
              {displayName}
              {bc ? (
                <span
                  style={{
                    fontWeight: 700,
                    opacity: 0.7,
                    marginLeft: 8,
                    fontSize: 12,
                  }}
                >
                  {isAU ? `Barcode: ${bc}` : `JAN: ${bc}`}
                </span>
              ) : null}
            </div>

            {/* ✅ 編集可の時だけ注意書き */}
            {canEdit ? (
              <div style={{ fontSize: 12, opacity: 0.7 }}>
                {isAU ? "* Quantity can only be changed while the order is \"unconfirmed\" (not editable once confirmed)" : "※ 数量変更は「未確認」のときだけ可能（確定後は編集できません）"}
              </div>
            ) : null}

            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {/* ✅ 確定後は操作UIを無効化 */}
              <button
                onClick={() => { if (canEdit) { setQtyDrafts(p => { const n={...p}; delete n[l.id]; return n; }); inc(l.id, -1); } }}
                disabled={!canEdit}
                style={{
                  padding: "8px 10px",
                  borderRadius: 10,
                  border: "1px solid #ddd",
                  fontWeight: 900,
                  opacity: canEdit ? 1 : 0.4,
                  cursor: canEdit ? "pointer" : "not-allowed",
                }}
              >
                −
              </button>

              <input
                value={qtyDrafts[l.id] !== undefined ? qtyDrafts[l.id] : l.qty}
                onChange={(e) => { if (canEdit) setQtyDrafts(p => ({ ...p, [l.id]: e.target.value })); }}
                onBlur={() => {
                  if (!canEdit) return;
                  const draft = qtyDrafts[l.id];
                  if (draft === undefined) return;
                  setQtyDrafts(p => { const n={...p}; delete n[l.id]; return n; });
                  setQty(l.id, draft);
                }}
                disabled={!canEdit}
                inputMode="numeric"
                style={{
                  width: 90,
                  padding: "10px 12px",
                  borderRadius: 10,
                  border: "1px solid #ddd",
                  textAlign: "center",
                  fontWeight: 900,
                  opacity: canEdit ? 1 : 0.6,
                }}
              />

              <button
                onClick={() => { if (canEdit) { setQtyDrafts(p => { const n={...p}; delete n[l.id]; return n; }); inc(l.id, 1); } }}
                disabled={!canEdit}
                style={{
                  padding: "8px 10px",
                  borderRadius: 10,
                  border: "1px solid #ddd",
                  fontWeight: 900,
                  opacity: canEdit ? 1 : 0.4,
                  cursor: canEdit ? "pointer" : "not-allowed",
                }}
              >
                ＋
              </button>

              {/* ✅ 単位/税率/単価種別 */}
              <div style={{ opacity: 0.8 }}>
                {isAU ? (
                  <>Unit: {displayUnit} / GST: {Math.round((displayTaxRate * 100) || 0)}%</>
                ) : (
                  <>単位：{displayUnit} / 税率：{Math.round((displayTaxRate * 100) || 0)}%</>
                )}
                <span style={{ marginLeft: 8, fontSize: 12, opacity: 0.75 }}>
                  {isAU
                    ? `(Price: ${(l.costPrice ?? p?.costPrice) != null ? "cost" : "sell"})`
                    : `（単価：${(l.costPrice ?? p?.costPrice) != null ? "原価" : "売価"}）`}
                </span>
              </div>

              <div style={{ marginLeft: "auto", fontWeight: 900 }}>
                {unitPrice > 0 ? formatMoney(lineTotal, tenantProfile?.marketId) : <span style={{ color: "#b45309", fontSize: 13 }}>{isAU ? "No cost price" : "原価未登録"}</span>}
              </div>

              <button
                onClick={() => canEdit && removeLine(l.id)}
                disabled={!canEdit}
                style={{
                  padding: "8px 10px",
                  borderRadius: 10,
                  border: "1px solid #ddd",
                  fontWeight: 900,
                  opacity: canEdit ? 1 : 0.4,
                  cursor: canEdit ? "pointer" : "not-allowed",
                }}
              >
                {isAU ? "Remove" : "削除"}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  )}
</div>



                  {/* totals */}
                  <div style={{ maxWidth: 720, borderTop: "1px solid #eee", paddingTop: 10 }}>
                    <div style={{ display: "grid", gap: 6 }}>
                      <div style={{ display: "flex" }}>
                        <div style={{ opacity: 0.8 }}>{isAU ? "Subtotal" : "小計"}</div>
                        <div style={{ marginLeft: "auto", fontWeight: 900 }}>{formatMoney(subtotal, tenantProfile?.marketId)}</div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ opacity: 0.8 }}>{isAU ? "GST" : "消費税"}</div>
                        <div style={{ marginLeft: "auto", fontWeight: 900 }}>{formatMoney(taxTotal, tenantProfile?.marketId)}</div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ opacity: 0.9, fontWeight: 900 }}>{isAU ? "Total" : "合計"}</div>
                        <div style={{ marginLeft: "auto", fontWeight: 900, fontSize: 18 }}>{formatMoney(total, tenantProfile?.marketId)}</div>
                      </div>
                    </div>
                  </div>

                  {/* bottom fixed order bar */}
                  <div
                    style={{
                      position: "fixed",
                      left: 0,
                      right: 0,
                      bottom: 0,
                      padding: 12,
                      background: "white",
                      borderTop: "1px solid #ddd",
                      boxShadow: "0 -6px 20px rgba(0,0,0,0.08)",
                      zIndex: 999,
                    }}
                  >
                    <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", alignItems: "center", gap: 12 }}>
                      <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? `Total: ${formatMoney(total, tenantProfile?.marketId)}` : `合計：${yen(total)}`}</div>

                      <button
                        onClick={() => {
                          // 新しい発注操作の開始。この操作専用のrequestIdを1回だけ発行する
                          submitOrderRequestIdRef.current = generateRequestId();
                          setConfirmOpen(true);
                        }}
                        disabled={!supplierSelected || lines.length === 0}
                        style={{
                          marginLeft: "auto",
                          padding: "14px 16px",
                          borderRadius: 14,
                          border: "1px solid #111",
                          background: !supplierSelected || lines.length === 0 ? "#888" : "#111",
                          color: "white",
                          fontWeight: 900,
                          fontSize: 16,
                          width: 180,
                          cursor: !supplierSelected || lines.length === 0 ? "not-allowed" : "pointer",
                        }}
                        title={!supplierSelected ? (isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください") : ""}
                      >
                        {isAU ? "Send to supplier" : "卸へ送信（発注）"}
                      </button>
                    </div>
                  </div>
                </div>
              )}


{/* ===== products master（小売）===== */}
{retailView === "products" && (
  <div style={{ display: "grid", gap: 10 }}>
    {/* タイトル行（ボタン右寄せ） */}
    <div
      style={{
        display: "flex",
        gap: 8,
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%", // ✅ 横幅を確保（これが無いと変な位置になりやすい）
      }}
    >
      <div style={{ fontWeight: 900 }}>{isAU ? "Products (by supplier)" : "商品登録（仕入れ先ごと）"}</div>

<div style={{ marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>

{/* ✅ Excel/CSV取り込み・商品追加：発注専用モードでは非表示 */}
{!retailOrderOnly && (<>
<button
  type="button"
  onClick={() => {
    if (!supplierId) {
      showToast(isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください");
      return;
    }
    setCsvTarget("retail");
    importFileRef.current?.click();
  }}
  style={{
    padding: "10px 16px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg,#16a34a,#15803d)",
    color: "white",
    fontWeight: 900,
    fontSize: 14,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(22,163,74,0.35)",
    display: "flex", alignItems: "center", gap: 6,
  }}
>
  {isAU ? "📥 Import Excel" : "📥 Excel取り込み"}
</button>
<button
  type="button"
  onClick={() => {
    const list = supplierId
      ? products.filter((p) => p.supplierId === supplierId)
      : products;
    if (list.length === 0) {
      showToast(isAU ? "No products to download" : "ダウンロードする商品がありません");
      return;
    }
    const label = supplierId
      ? (suppliers.find((s) => s.id === supplierId)?.name ?? supplierId)
      : (isAU ? "All suppliers" : "全仕入先");
    downloadProductsAsExcel(list, isAU ? `Products_${label}.xlsx` : `商品マスタ_${label}.xlsx`, tenantProfile?.marketId);
  }}
  style={{
    padding: "10px 16px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    color: "white",
    fontWeight: 900,
    fontSize: 14,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(37,99,235,0.35)",
    display: "flex", alignItems: "center", gap: 6,
  }}
>
  {isAU ? "📤 Export Excel" : "📤 Excel DL"}
</button>



        {/* 既存：商品追加 */}
        <button
          onClick={openAddProduct}
          style={{
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid #111",
            fontWeight: 900,
            background: "#111",
            color: "white",
          }}
        >
          {isAU ? "+ Add product" : "＋ 商品追加"}
        </button>
</>)}
      </div>
    </div>

    {/* 状態表示（任意：いらなければ消してOK） */}
    <div style={{ fontSize: 12, opacity: 0.75 }}>
      {isAU
        ? (supplierId ? "Filtered by supplier" : "Please select a supplier")
        : (supplierId ? "仕入れ先で絞り込み中" : "仕入れ先を選択してください")}
    </div>

    {/* ✅ 商品検索バー（キーワード・カテゴリ） */}
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <input
        type="text"
        placeholder={isAU ? "Search by product name..." : "商品名で検索..."}
        value={catalogSearch}
        onChange={(e) => { setCatalogSearch(e.target.value); setCatalogLoading(true); }}
        style={{ flex: 1, minWidth: 160, padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontSize: 14 }}
      />
      <input
        type="text"
        placeholder={isAU ? "Category (e.g. Vegetables)" : "カテゴリ（例：野菜）"}
        value={catalogCategory}
        onChange={(e) => setCatalogCategory(e.target.value)}
        style={{ width: 140, padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontSize: 14 }}
      />
      {(catalogSearch || catalogCategory) && (
        <button
          onClick={() => { setCatalogSearch(""); setCatalogCategory(""); }}
          style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer" }}
        >
          {isAU ? "Clear" : "クリア"}
        </button>
      )}
      <div style={{ fontSize: 12, opacity: 0.7, display: "flex", alignItems: "center", gap: 6 }}>
        {catalogLoading ? (
          <>
            <span style={{
              display: "inline-block", width: 14, height: 14, border: "2px solid #ddd",
              borderTopColor: "#111", borderRadius: "50%",
              animation: "spin 0.7s linear infinite",
            }} />
            <span>{isAU ? "Loading..." : "読み込み中..."}</span>
          </>
        ) : (
          isAU
            ? (catalogSearch || catalogCategory ? `Search results: ${products.length}` : `Frequently ordered (top ${products.length})`)
            : (catalogSearch || catalogCategory ? `検索結果: ${products.length}件` : `よく発注する商品 上位${products.length}件`)
        )}
      </div>
    </div>




    {/* 本体 */}
    {!supplierId ? (
      <div style={{ opacity: 0.7 }}>
        {isAU ? "(Please select a supplier first. Products are managed per supplier.)" : "（先に仕入れ先を選択してください。商品は仕入れ先ごとに管理されます）"}
      </div>
    ) : (
      <div style={{ display: "grid", gap: 8 }}>
        {products.length === 0 ? (
          <div style={{ opacity: 0.7 }}>
            {isAU ? '(No products for this supplier yet. Use "+ Add product" above to register one.)' : "（この仕入れ先の商品はまだありません。右上の「＋商品追加」から登録してください）"}
          </div>
        ) : (
          products.map((p) => (
            <div
              key={p.id}
              style={{
                border: "1px solid #eee",
                borderRadius: 14,
                padding: 12,
                background: "white",
                display: "grid",
                gap: 8,
              }}
            >
              {/* 上段 */}
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <div style={{ fontWeight: 900 }}>{p.name}</div>

                <div style={{ opacity: 0.7, fontSize: 12 }}>
                  {p.barcode ? (isAU ? `Barcode: ${p.barcode}` : `JAN: ${p.barcode}`) : (isAU ? "No barcode" : "JANなし")}
                </div>

                <div style={{ marginLeft: "auto", fontWeight: 900 }}>
                  {(() => {
                    const cp = getCostPriceStrict(p);
                    return cp <= 0 ? (
                      <span style={{ color: "#b45309" }}>{isAU ? "No cost price" : "原価未登録"}</span>
                    ) : (
                      formatMoney(cp, tenantProfile?.marketId)
                    );
                  })()}
                </div>
              </div>

              {/* 下段 */}
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div style={{ opacity: 0.8 }}>
                  {isAU ? <>Unit: <b>{p.unit || "each"}</b></> : <>単位：<b>{p.unit || "個"}</b></>}
                </div>

                <div style={{ opacity: 0.8 }}>
                  {isAU ? "GST: " : "税率："}
                  <b><TaxRateBadge rawTaxRate={p.taxRate} isAU={isAU} /></b>
                </div>

                {!retailOrderOnly && (
                <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                  <button
                    onClick={() => openEditProduct(p)}
                    style={{
                      padding: "8px 10px",
                      borderRadius: 10,
                      border: "1px solid #111",
                      fontWeight: 900,
                      background: "white",
                    }}
                  >
                    {isAU ? "Edit" : "編集"}
                  </button>

                  <button
                    onClick={() => deleteProduct(p.id)}
                    style={{
                      padding: "8px 10px",
                      borderRadius: 10,
                      border: "1px solid #ddd",
                      fontWeight: 900,
                      background: "white",
                    }}
                  >
                    {isAU ? "Delete" : "削除"}
                  </button>
                </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    )}
  </div>
)}

              {/* ===== history ===== */}
              {retailView === "history" && (
                <div>
                  <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
                    <h3 style={{ margin: 0 }}>{isAU ? "Order history" : "発注履歴（小売）"}</h3>
                    <div style={{ fontSize: 12, opacity: 0.7, marginLeft: 4 }}>
                      {isAU ? `Last 30 days · showing ${retailHistory.length}` : `直近30日 · ${retailHistory.length}件表示中`}
                    </div>
                  </div>

                  {retailHistory.length === 0 ? (
                    <div style={{ opacity: 0.7 }}>{isAU ? "(No orders yet)" : "（まだありません）"}</div>
                  ) : (
                    <div style={{ display: "grid", gap: 8, maxWidth: 820 }}>
                      {retailHistory.map((h) => {
                        const isCancelled = (h.status || "") === "キャンセル";
                        const hMeta = statusMeta(h.status);
                        return (
                        <div key={h.id} style={{ border: `1px solid ${isCancelled ? "#e5e7eb" : "#eee"}`, borderRadius: 14, padding: 14, background: isCancelled ? "#f9fafb" : "white", opacity: isCancelled ? 0.7 : 1 }}>
                          {/* 1行目: 注文No. + バッジ */}
                          <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap", marginBottom: 4 }}>
                            <div style={{ fontWeight: 900, fontSize: 14, textDecoration: isCancelled ? "line-through" : "none", color: isCancelled ? "#9ca3af" : undefined }}>
                              {isAU ? `Order No. ${h.orderNo}` : `注文No. ${h.orderNo}`}
                            </div>
                            {isCancelled && (
                              <span style={{ padding: "2px 8px", borderRadius: 999, background: "#f3f4f6", color: "#6b7280", fontSize: 11, fontWeight: 900 }}>{isAU ? "Cancelled" : "キャンセル済み"}</span>
                            )}
                            {!isCancelled && h.changedByWholesale && (
                              <span style={{ padding: "2px 8px", borderRadius: 999, background: "#ef4444", color: "white", fontSize: 11, fontWeight: 900 }}
                                title={h.changedAt ? (isAU ? `Quantity changed by supplier: ${jdate(h.changedAt, "en-AU")}` : `卸が数量を変更しました：${jdate(h.changedAt)}`) : (isAU ? "Quantity changed by supplier" : "卸が数量を変更しました")}>
                                {isAU ? "Changed" : "変更あり"}
                              </span>
                            )}
                          </div>
                          {/* 2行目: 日付 + 合計金額 */}
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                            <div style={{ fontSize: 12, color: "#888" }}>{jdate(h.createdAt, isAU ? "en-AU" : "ja-JP")}</div>
                            <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
                              <div style={{ fontWeight: 900, fontSize: 16, color: isCancelled ? "#9ca3af" : "#111", textDecoration: isCancelled ? "line-through" : "none" }}>{formatMoney(h.total, tenantProfile?.marketId)}</div>
                              <div style={{ fontSize: 11, color: "#888", fontWeight: 700 }}>{isAU ? "inc GST" : "税込"}</div>
                            </div>
                          </div>
                          {/* 3行目: 仕入先・状態・納品日 */}
                          <div style={{ fontSize: 13, color: "#555", marginBottom: 10, display: "flex", gap: 12, flexWrap: "wrap" }}>
                            <div>{isAU ? "Supplier: " : "仕入先："}<b style={{ color: "#111" }}>{h.supplierName}</b></div>
                            <div>{isAU ? "Status: " : "状態："}<b style={{ color: isCancelled ? "#6b7280" : "#2563eb" }}>{hMeta.label}</b></div>
                            {(() => {
                              const ls = h.lines || [];
                              const lineDates = ls.map(l => l.scheduledDeliveryDate).filter(Boolean);
                              const uniqueDates = [...new Set(lineDates)].sort();
                              if (uniqueDates.length > 1) {
                                // 分納：商品名と日付を一覧表示
                                return (
                                  <div>
                                    <span style={{ padding: "1px 7px", borderRadius: 4, background: "#fff7ed", color: "#ea580c", fontSize: 11, fontWeight: 900, marginRight: 6 }}>{isAU ? "📦 Split delivery" : "📦 分納あり"}</span>
                                    {ls.map((l, i) => l.scheduledDeliveryDate ? (
                                      <div key={i} style={{ fontSize: 12, color: "#1a56db", fontWeight: 700, marginTop: 2 }}>
                                        {isAU ? `${l.name}: ${formatAUDate(l.scheduledDeliveryDate)}` : `${l.name}：${formatJPDate(l.scheduledDeliveryDate)}`}
                                      </div>
                                    ) : null)}
                                  </div>
                                );
                              }
                              // 分納なし：従来通り1行表示
                              const displayDate = uniqueDates[0] || h.scheduledDeliveryDate;
                              return displayDate ? (
                                <div>{isAU ? "Delivery date: " : "予定納品日："}<b style={{ color: "#1a56db" }}>{isAU ? formatAUDate(displayDate) : formatJPDate(displayDate)}</b></div>
                              ) : null;
                            })()}
                            {h.requestedDeliveryDate && (
                              <div>{isAU ? "Requested date: " : "希望納品日："}<b style={{ color: "#7c3aed" }}>{isAU ? formatAUDate(h.requestedDeliveryDate) : formatJPDate(h.requestedDeliveryDate)}</b></div>
                            )}
                          </div>
                          {/* 明細ボタン（全幅・タップしやすい） */}
                          <button onClick={() => toggleHistory(h.id)}
                            style={{ width: "100%", padding: "9px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer", fontSize: 13 }}>
                            {isAU
                              ? (openHistoryIds[h.id] ? "▲ Hide details" : "▼ View details")
                              : (openHistoryIds[h.id] ? "▲ 明細を閉じる" : "▼ 明細を見る")}
                          </button>
                          {/* 明細リスト */}
                          {openHistoryIds[h.id] && (
                            <div style={{ marginTop: 10, display: "grid", gap: 8, borderTop: "1px solid #f0f0f0", paddingTop: 10 }}>
                              {getOrderLines(h).map((l) => {
                                const changed = (h.changedLineIds || []).includes(l.id);
                                const before = h.changedQtyBefore ? h.changedQtyBefore[l.id] : null;
                                const after = Number(l.qty || 0);
                                // 商品ごとの予定納品日（なければ注文ヘッダーの値）
                                const lineDelivDate = l.scheduledDeliveryDate || h.scheduledDeliveryDate || null;
                                return (
                                  <div key={l.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
                                    <div style={{ fontWeight: 700, flex: 1, fontSize: 13 }}>
                                      {l.name}
                                      {changed && <span style={{ marginLeft: 6, padding: "1px 6px", borderRadius: 999, background: "#fee2e2", color: "#b91c1c", fontSize: 11, fontWeight: 900 }}>{isAU ? "Changed by supplier" : "卸変更"}</span>}
                                      {changed && before != null && <span style={{ marginLeft: 4, fontSize: 12, fontWeight: 900, color: "#b91c1c" }}>{before}→{after}</span>}
                                      {lineDelivDate && (
                                        <div style={{ fontSize: 11, color: "#1a56db", fontWeight: 700, marginTop: 2 }}>
                                          {isAU ? `Delivery date: ${formatAUDate(lineDelivDate)}` : `予定納品日: ${formatJPDate(lineDelivDate)}`}
                                        </div>
                                      )}
                                    </div>
                                    <div style={{ fontWeight: 900, fontSize: 13, whiteSpace: "nowrap", textAlign: "right" }}>
                                      {l.qty}{l.unit}<br/>
                                      <span style={{ fontSize: 12, color: "#555" }}>{formatMoney(l.price, tenantProfile?.marketId)}<span style={{ fontSize: 10, fontWeight: 700, color: "#888", marginLeft: 2 }}>{isAU ? "ex GST/unit" : "税抜/個"}</span></span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                      })}
                    </div>
                  )}
                  {/* ✅ もっと見るボタン（過去30日以前のデータ読み込み） */}
                  {ordersHasMore && (
                    <div style={{ marginTop: 12, textAlign: "center" }}>
                      <button
                        onClick={loadMoreOrders}
                        style={{ padding: "10px 24px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer" }}
                      >
                        {isAU ? "Load more" : "もっと見る"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* ===== 小売 summary（集計）完全版 ===== */}
          {mode === "retail" && retailView === "summary" && (() => {
            // 月次カードの基準月は、フェッチ実行時に記録したretailSummaryFetchedThisMonthを
            // 使う（レンダー時にnew Date()し直さない）。フェッチ〜レンダーの間に日付が
            // 月をまたいでも、実際に取得済みのデータ範囲とカードの対象月が一致し続けることを
            // 保証するため。念のためnullの場合のみ現在時刻にフォールバック
            const thisMonth = retailSummaryFetchedThisMonth || new Date(new Date().getFullYear(), new Date().getMonth(), 1);
            const lastMonth = new Date(thisMonth.getFullYear(), thisMonth.getMonth() - 1, 1);
            const lastLastMonth = new Date(thisMonth.getFullYear(), thisMonth.getMonth() - 2, 1);

            // 集計基準は「納品書発行ベース」に一本化（発注ベース・受注確定ベースは廃止）。
            // 期間軸はissuedAtに統一する。
            const getOrderDate = (o) => {
              const ts = o.issuedAt;
              return new Date(typeof ts?.toMillis === "function" ? ts.toMillis() : ts || 0);
            };
            const isCountedOrder = isDeliveredAndCounted;

            if (retailSummaryLoading) {
              return <div style={{ padding: 40, textAlign: "center", color: "#888", fontSize: 14 }}>{isAU ? "Loading summary data..." : "集計データを読み込んでいます..."}</div>;
            }
            if (retailSummaryError) {
              return (
                <div style={{ padding: 40, textAlign: "center" }}>
                  <div style={{ color: "#dc2626", fontSize: 14, marginBottom: 12 }}>{isAU ? "⚠ Failed to load summary data." : "⚠ 集計データの取得に失敗しました。"}</div>
                  <button
                    onClick={() => setRetailSummaryError(false)}
                    style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 13, cursor: "pointer" }}
                  >
                    {isAU ? "Retry" : "再試行"}
                  </button>
                </div>
              );
            }
            if (retailSummaryOrders === null) {
              return <div style={{ padding: 40, textAlign: "center", color: "#888", fontSize: 14 }}>{isAU ? "Loading summary data..." : "集計データを読み込んでいます..."}</div>;
            }

            const getMonthOrders = (month) =>
              retailSummaryOrders.filter((o) => {
                if (!isCountedOrder(o)) return false;
                const d = getOrderDate(o);
                return d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth();
              });

            // 集計はgetOrderAmounts（内部的にgetDisplayOrderAmountsへ委譲、唯一の
            // 金額計算元）の単純合算で行う。税率内訳（tax8/tax10）の信頼性は
            // 注文単位で判定する——集計対象群全体に対して1つのbreakdownAvailableを
            // 持たせると、1件でも内訳が信頼できない注文が混ざるだけで他の全注文の
            // 正しいtax8が丸ごと0円に破棄されてしまうバグがあったため（2026-08修正）。
            // 2026-08修正（Codexレビュー指摘対応・v4）：以前はtax8/tax10のnull判定で
            // 「内訳なしの旧データ」を検知していたが、getOrderAmountsは常に数値の
            // tax8/tax10を返すためこの判定は機能しない。代わりにhasInvalidRates
            // （不正税率の明細を含み、有効行だけのtax8/tax10合計が実際の税額より
            // 過少になり得る注文）を判定に使う。該当注文は自分自身のtaxのみを
            // tax10へ暫定計上し、他の注文の内訳には一切影響しない
            const calcTax = (ords) => {
              let subtotal = 0, tax8 = 0, tax10 = 0, total = 0;
              ords.forEach((o) => {
                const a = getOrderAmounts(o, tenantProfile?.marketId);
                subtotal += a.subtotal; total += a.total;
                if (a.hasInvalidRates) { tax10 += a.tax; }
                else { tax8 += a.tax8; tax10 += a.tax10; }
              });
              return { subtotal, tax8, tax10, total };
            };

            const thisMonthOrders = getMonthOrders(thisMonth);
            const lastMonthOrders = getMonthOrders(lastMonth);
            const lastLastMonthOrders = getMonthOrders(lastLastMonth);
            const thisMonthStats = calcTax(thisMonthOrders);
            const lastMonthStats = calcTax(lastMonthOrders);
            const lastLastMonthStats = calcTax(lastLastMonthOrders);
            const monthDiff = lastMonthStats.total > 0
              ? ((thisMonthStats.total - lastMonthStats.total) / lastMonthStats.total * 100).toFixed(1)
              : 0;

            // ===== 期間プリセット計算ヘルパー（仕入先別・商品別タブ用）=====
            const applyRetailRankPreset = (preset) => {
              const n = new Date();
              const pad = (v) => String(v).padStart(2, "0");
              const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
              let s, e;
              if (preset === "当月") {
                s = fmt(new Date(n.getFullYear(), n.getMonth(), 1));
                e = fmt(n);
              } else if (preset === "前月") {
                const lm = new Date(n.getFullYear(), n.getMonth() - 1, 1);
                const lme = new Date(n.getFullYear(), n.getMonth(), 0);
                s = fmt(lm); e = fmt(lme);
              } else if (preset === "3ヶ月") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 2, 1)); e = fmt(n);
              } else if (preset === "半年") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 5, 1)); e = fmt(n);
              } else if (preset === "1年") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 11, 1)); e = fmt(n);
              }
              setRetailRankPreset(preset);
              setRetailRankStart(s);
              setRetailRankEnd(e);
            };
            const retailRankPresetLabelsEn = { "当月": "This month", "前月": "Last month", "3ヶ月": "3 months", "半年": "6 months", "1年": "1 year" };

            // 期間フィルタ済み orders（仕入先別・商品別ランキング用）。
            // データソースは必ずretailRankRangeOrders（issuedAtベース・
            // tenantId/retailTenantIdFromShop和集合クエリの取得結果）を使う——
            // 30日/50件制限のグローバル購読ordersを使うと、選択期間（当月〜1年）を
            // 正しく反映できず、卸売上集計・請求候補合計と食い違う
            const rankFilteredOrders = (() => {
              if (!retailRankStart || !retailRankEnd) return [];
              if (new Date(retailRankStart) > new Date(retailRankEnd)) return [];
              return retailRankRangeOrders || [];
            })();

            const rankDateError = retailRankStart && retailRankEnd && new Date(retailRankStart) > new Date(retailRankEnd);

            // 仕入先別集計（期間指定）— 仕入先一覧に登録済みの supplierId のみ集計
            // supplierId / id / _docId のすべてを登録してIDの表記ゆれを吸収
            const knownSupplierIds = new Set();
            (suppliers || []).forEach(s => {
              if (s.supplierId) knownSupplierIds.add(String(s.supplierId));
              if (s.id) knownSupplierIds.add(String(s.id));
              if (s._docId) knownSupplierIds.add(String(s._docId));
            });
            // 注文単位の合計金額は必ずgetOrderAmounts（orderSnapshot参照）で合算する。
            // 明細内訳（商品別集計）だけはlines走査を許容するが、合計金額の算出には使わない
            const supplierStatsAll = {};
            rankFilteredOrders.forEach((o) => {
              const sid = o.supplierId || "";
              if (!sid || !knownSupplierIds.has(String(sid))) return; // 仕入先一覧にないものは除外
              if (!supplierStatsAll[sid]) {
                supplierStatsAll[sid] = { name: supplierNameById(sid) || sid, subtotal: 0, tax8: 0, tax10: 0, count: 0 };
              }
              const a = getOrderAmounts(o, tenantProfile?.marketId);
              supplierStatsAll[sid].subtotal += a.subtotal;
              // 2026-08修正（Codexレビュー指摘対応・v4）：tax8/tax10のnull判定は
              // 機能しなくなったため、hasInvalidRatesで判定する
              if (!a.hasInvalidRates) {
                supplierStatsAll[sid].tax8 += a.tax8;
                supplierStatsAll[sid].tax10 += a.tax10;
              } else {
                supplierStatsAll[sid].tax10 += a.tax; // 内訳が信頼できない場合は10%枠に暫定計上（合計totalは正しい値のまま）
              }
              supplierStatsAll[sid].count += 1;
            });
            const supplierRanking = Object.values(supplierStatsAll)
              .map(s => ({ ...s, total: s.subtotal + s.tax8 + s.tax10 }))
              .sort((a, b) => b.total - a.total);

            // 商品別集計（期間指定）
            const productStatsAll = {};
            rankFilteredOrders.forEach((o) => {
              getOrderLines(o).forEach((l) => {
                const pid = l.id || l.barcode || l.name || "不明";
                if (!productStatsAll[pid]) {
                  productStatsAll[pid] = { name: l.name || (isAU ? "Unknown" : "不明"), qty: 0, subtotal: 0, tax8: 0, tax10: 0 };
                }
                const r = calcOrderTotals([l]);
                productStatsAll[pid].qty += Number(l.qty || 0);
                productStatsAll[pid].subtotal += r.subtotal;
                productStatsAll[pid].tax8 += r.tax8;
                productStatsAll[pid].tax10 += r.tax10;
              });
            });
            const productRanking = Object.values(productStatsAll)
              .map(p => ({ ...p, total: p.subtotal + p.tax8 + p.tax10 }))
              .sort((a, b) => b.total - a.total);

            // 仕入先別・期間指定集計。
            // retailRangeErrorがtrue（直前の期間取得が失敗した）の間は、30日分の
            // グローバル購読ordersへのフォールバックを使わない——指定した期間と異なる
            // 不完全なデータを、あたかも取得結果であるかのように表示してしまうため
            const filteredDetailOrders = (() => {
              if (retailRangeError) return [];
              const base = retailRangeOrders !== null ? retailRangeOrders : (orders || []);
              return base.filter((o) => {
                if (!isCountedOrder(o)) return false;
                if (retailSelectedSupplier && o.supplierId !== retailSelectedSupplier) return false;
                // 期間はFirestore取得済みの場合はスキップ、未取得の場合のみクライアントフィルタ
                if (retailRangeOrders === null && (retailStartDate || retailEndDate)) {
                  const d = getOrderDate(o);
                  if (retailStartDate && d < new Date(retailStartDate + " 00:00:00")) return false;
                  if (retailEndDate && d > new Date(retailEndDate + " 23:59:59")) return false;
                }
                return true;
              });
            })();
            const detailStats = calcTax(filteredDetailOrders);

            // 仕入先別期間内商品集計
            const detailProductSummary = {};
            filteredDetailOrders.forEach((o) => {
              getOrderLines(o).forEach((l) => {
                const pid = l.name || "不明";
                if (!detailProductSummary[pid]) {
                  detailProductSummary[pid] = { name: l.name || (isAU ? "Unknown" : "不明"), qty: 0, amount: 0 };
                }
                detailProductSummary[pid].qty += Number(l.qty || 0);
                detailProductSummary[pid].amount += Number(l.qty || 0) * Number(l.price || 0);
              });
            });
            const detailProductList = Object.values(detailProductSummary)
              .sort((a, b) => b.amount - a.amount);

            const supplierOptions = (suppliers || []).map(s => ({ sid: s.supplierId || s.id, name: s.name }));

            // タブスタイル
            const tabStyle = (active) => ({
              padding: "8px 16px",
              borderRadius: 10,
              border: active ? "2px solid #111" : "1px solid #ddd",
              background: active ? "#111" : "white",
              color: active ? "white" : "#333",
              fontWeight: 900,
              fontSize: 13,
              cursor: "pointer",
              whiteSpace: "nowrap",
            });

            return (
              <div style={{ display: "grid", gap: 14, maxWidth: 960 }}>
                {/* タブ切り替え */}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                  <button style={tabStyle(retailSummaryTab === "monthly")} onClick={() => setRetailSummaryTab("monthly")}>{isAU ? "📅 Monthly" : "📅 月別"}</button>
                  <button style={tabStyle(retailSummaryTab === "supplier")} onClick={() => setRetailSummaryTab("supplier")}>{isAU ? "🏪 By supplier" : "🏪 仕入先別"}</button>
                  <button style={tabStyle(retailSummaryTab === "product")} onClick={() => setRetailSummaryTab("product")}>{isAU ? "📦 By product" : "📦 商品別"}</button>
                  <button style={tabStyle(retailSummaryTab === "detail")} onClick={() => setRetailSummaryTab("detail")}>{isAU ? "🔍 Period & supplier" : "🔍 期間・仕入先指定"}</button>
                  <span style={{ marginLeft: "auto", fontSize: 11, color: "#7c3aed", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 6, padding: "3px 8px", fontWeight: 700 }}>{isAU ? "🧾 Based on delivery notes issued" : "🧾 納品書発行ベースで集計"}</span>
                </div>

                {/* ===== 月別タブ ===== */}
                {retailSummaryTab === "monthly" && (
                  <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                    <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 12 }}>{isAU ? "📅 Monthly order value" : "📅 月別発注額"}</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10 }}>
                      {[
                        { month: thisMonth, stats: thisMonthStats, ords: thisMonthOrders, label: "今月", labelEn: "This month" },
                        { month: lastMonth, stats: lastMonthStats, ords: lastMonthOrders, label: "先月", labelEn: "Last month" },
                        { month: lastLastMonth, stats: lastLastMonthStats, ords: lastLastMonthOrders, label: "先々月", labelEn: "2 months ago" },
                      ].map(({ month, stats, ords, label, labelEn }) => (
                        <div key={label} style={{ padding: 14, border: "1px solid #eee", borderRadius: 12 }}>
                          <div style={{ fontSize: 12, opacity: 0.75 }}>
                            {isAU
                              ? `${month.toLocaleString("en-AU", { month: "long" })} ${month.getFullYear()} (${labelEn})`
                              : `${month.getFullYear()}年${month.getMonth() + 1}月（${label}）`}
                          </div>
                          <div style={{ fontSize: 22, fontWeight: 900, marginTop: 6 }}>{formatMoney(stats.total, tenantProfile?.marketId)}</div>
                          <div style={{ fontSize: 11, marginTop: 8, opacity: 0.85, display: "grid", gap: 2 }}>
                            <div>{isAU ? `Subtotal (ex. tax): ${formatMoney(stats.subtotal, tenantProfile?.marketId)}` : `小計（税抜）：${formatMoney(stats.subtotal, tenantProfile?.marketId)}`}</div>
                            {!isAU && <div>消費税8%：{formatMoney(stats.tax8, tenantProfile?.marketId)}</div>}
                            {!isAU && <div>消費税10%：{formatMoney(stats.tax10, tenantProfile?.marketId)}</div>}
                          </div>
                          <div style={{ fontSize: 12, marginTop: 6, opacity: 0.6 }}>{isAU ? `${ords.length} orders` : `${ords.length}件`}</div>
                        </div>
                      ))}
                    </div>
                    <div style={{ marginTop: 12, fontSize: 13, opacity: 0.85 }}>
                      {isAU ? "vs last month: " : "前月比："}
                      <span style={{ fontWeight: 900, color: Number(monthDiff) >= 0 ? "#dc2626" : "#16a34a" }}>
                        {Number(monthDiff) >= 0 ? "+" : ""}{monthDiff}%
                      </span>
                    </div>
                  </div>
                )}

                {/* ===== 仕入先別タブ ===== */}
                {retailSummaryTab === "supplier" && (
                  <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                    <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 12 }}>{isAU ? "🏪 Order ranking by supplier" : "🏪 仕入先別発注ランキング"}</div>
                    {/* 期間プリセット */}
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                        {["当月","前月","3ヶ月","半年","1年"].map(p => (
                          <button key={p} onClick={() => applyRetailRankPreset(p)}
                            style={{ padding: "5px 12px", borderRadius: 8, border: retailRankPreset === p ? "2px solid #111" : "1px solid #ddd", background: retailRankPreset === p ? "#111" : "white", color: retailRankPreset === p ? "white" : "#333", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
                            {isAU ? retailRankPresetLabelsEn[p] : p}
                          </button>
                        ))}
                      </div>
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                        <input type="date" value={retailRankStart}
                          onChange={e => { setRetailRankStart(e.target.value); setRetailRankPreset(""); }}
                          style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                        <span style={{ fontSize: 13 }}>{isAU ? "–" : "〜"}</span>
                        <input type="date" value={retailRankEnd}
                          onChange={e => { setRetailRankEnd(e.target.value); setRetailRankPreset(""); }}
                          style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                      </div>
                      {rankDateError && <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>{isAU ? "⚠ Start date is after the end date" : "⚠ 開始日が終了日より後になっています"}</div>}
                      {retailRankStart && retailRankEnd && !rankDateError && (
                        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                          {isAU ? `📅 Summary period: ${retailRankStart} – ${retailRankEnd}` : `📅 集計期間：${retailRankStart} 〜 ${retailRankEnd}`}
                        </div>
                      )}
                    </div>
                    {retailRankRangeError ? (
                      <div style={{ opacity: 0.85, fontSize: 13, color: "#dc2626" }}>{isAU ? "⚠ Failed to load summary data. Please try again." : "⚠ 集計データの取得に失敗しました。再度お試しください。"}</div>
                    ) : retailRankRangeOrders === null ? (
                      <div style={{ opacity: 0.7, fontSize: 13 }}>{isAU ? "Loading..." : "取得中..."}</div>
                    ) : supplierRanking.length === 0 ? (
                      <div style={{ opacity: 0.7, fontSize: 13 }}>{isAU ? "(No data)" : "（データなし）"}</div>
                    ) : (
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 580 }}>
                          <thead>
                            <tr style={{ borderBottom: "2px solid #eee", background: "#fafafa" }}>
                              <th style={{ textAlign: "left", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Rank" : "順位"}</th>
                              <th style={{ textAlign: "left", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Supplier" : "仕入先"}</th>
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Orders" : "件数"}</th>
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Subtotal (ex GST)" : "小計（税抜）"}</th>
                              {!isAU && <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>税8%</th>}
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "GST 10%" : "税10%"}</th>
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Total" : "合計"}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {supplierRanking.map((s, idx) => (
                              <tr key={idx} style={{ borderBottom: "1px solid #f4f4f4", background: idx % 2 === 0 ? "white" : "#fafafa" }}>
                                <td style={{ padding: "8px 6px", fontWeight: 900, color: idx === 0 ? "#d97706" : idx === 1 ? "#9ca3af" : idx === 2 ? "#b45309" : "#333" }}>
                                  {idx + 1}
                                </td>
                                <td style={{ padding: "8px 6px", fontWeight: 700 }}>{s.name}</td>
                                <td style={{ padding: "8px 6px", textAlign: "right" }}>{isAU ? s.count : `${s.count}件`}</td>
                                <td style={{ padding: "8px 6px", textAlign: "right" }}>{formatMoney(s.subtotal, tenantProfile?.marketId)}</td>
                                {!isAU && <td style={{ padding: "8px 6px", textAlign: "right" }}>{formatMoney(s.tax8, tenantProfile?.marketId)}</td>}
                                <td style={{ padding: "8px 6px", textAlign: "right" }}>{formatMoney(s.tax10, tenantProfile?.marketId)}</td>
                                <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>{formatMoney(s.total, tenantProfile?.marketId)}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr style={{ borderTop: "2px solid #eee", background: "#f9fafb" }}>
                              <td colSpan={2} style={{ padding: "8px 6px", fontWeight: 900, fontSize: 13 }}>{isAU ? "Total" : "合計"}</td>
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {isAU ? supplierRanking.reduce((a, s) => a + s.count, 0) : `${supplierRanking.reduce((a, s) => a + s.count, 0)}件`}
                              </td>
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {formatMoney(supplierRanking.reduce((a, s) => a + s.subtotal, 0), tenantProfile?.marketId)}
                              </td>
                              {!isAU && <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {formatMoney(supplierRanking.reduce((a, s) => a + s.tax8, 0), tenantProfile?.marketId)}
                              </td>}
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {formatMoney(supplierRanking.reduce((a, s) => a + s.tax10, 0), tenantProfile?.marketId)}
                              </td>
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900, fontSize: 14 }}>
                                {formatMoney(supplierRanking.reduce((a, s) => a + s.total, 0), tenantProfile?.marketId)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}
                  </div>
                )}

                {/* ===== 商品別タブ ===== */}
                {retailSummaryTab === "product" && (
                  <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                    <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 12 }}>{isAU ? "📦 Order ranking by product" : "📦 商品別発注ランキング"}</div>
                    {/* 期間プリセット */}
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                        {["当月","前月","3ヶ月","半年","1年"].map(p => (
                          <button key={p} onClick={() => applyRetailRankPreset(p)}
                            style={{ padding: "5px 12px", borderRadius: 8, border: retailRankPreset === p ? "2px solid #111" : "1px solid #ddd", background: retailRankPreset === p ? "#111" : "white", color: retailRankPreset === p ? "white" : "#333", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
                            {isAU ? retailRankPresetLabelsEn[p] : p}
                          </button>
                        ))}
                      </div>
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                        <input type="date" value={retailRankStart}
                          onChange={e => { setRetailRankStart(e.target.value); setRetailRankPreset(""); }}
                          style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                        <span style={{ fontSize: 13 }}>〜</span>
                        <input type="date" value={retailRankEnd}
                          onChange={e => { setRetailRankEnd(e.target.value); setRetailRankPreset(""); }}
                          style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                      </div>
                      {rankDateError && <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>{isAU ? "⚠ Start date is after the end date" : "⚠ 開始日が終了日より後になっています"}</div>}
                      {retailRankStart && retailRankEnd && !rankDateError && (
                        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                          {isAU ? `📅 Summary period: ${retailRankStart} – ${retailRankEnd}` : `📅 集計期間：${retailRankStart} 〜 ${retailRankEnd}`}
                        </div>
                      )}
                    </div>
                    {retailRankRangeError ? (
                      <div style={{ opacity: 0.85, fontSize: 13, color: "#dc2626" }}>{isAU ? "⚠ Failed to load summary data. Please try again." : "⚠ 集計データの取得に失敗しました。再度お試しください。"}</div>
                    ) : retailRankRangeOrders === null ? (
                      <div style={{ opacity: 0.7, fontSize: 13 }}>{isAU ? "Loading..." : "取得中..."}</div>
                    ) : productRanking.length === 0 ? (
                      <div style={{ opacity: 0.7, fontSize: 13 }}>{isAU ? "(No data)" : "（データなし）"}</div>
                    ) : (
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 580 }}>
                          <thead>
                            <tr style={{ borderBottom: "2px solid #eee", background: "#fafafa" }}>
                              <th style={{ textAlign: "left", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Rank" : "順位"}</th>
                              <th style={{ textAlign: "left", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Product" : "商品名"}</th>
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Qty ordered" : "発注数"}</th>
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Subtotal (ex GST)" : "小計（税抜）"}</th>
                              {!isAU && <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>税8%</th>}
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "GST 10%" : "税10%"}</th>
                              <th style={{ textAlign: "right", padding: "8px 6px", fontSize: 12 }}>{isAU ? "Total" : "合計"}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {productRanking.map((p, idx) => (
                              <tr key={idx} style={{ borderBottom: "1px solid #f4f4f4", background: idx % 2 === 0 ? "white" : "#fafafa" }}>
                                <td style={{ padding: "8px 6px", fontWeight: 900, color: idx === 0 ? "#d97706" : idx === 1 ? "#9ca3af" : idx === 2 ? "#b45309" : "#333" }}>
                                  {idx + 1}
                                </td>
                                <td style={{ padding: "8px 6px", fontWeight: 700 }}>{p.name}</td>
                                <td style={{ padding: "8px 6px", textAlign: "right" }}>{p.qty}</td>
                                <td style={{ padding: "8px 6px", textAlign: "right" }}>{formatMoney(p.subtotal, tenantProfile?.marketId)}</td>
                                {!isAU && <td style={{ padding: "8px 6px", textAlign: "right" }}>{formatMoney(p.tax8, tenantProfile?.marketId)}</td>}
                                <td style={{ padding: "8px 6px", textAlign: "right" }}>{formatMoney(p.tax10, tenantProfile?.marketId)}</td>
                                <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>{formatMoney(p.total, tenantProfile?.marketId)}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr style={{ borderTop: "2px solid #eee", background: "#f9fafb" }}>
                              <td colSpan={2} style={{ padding: "8px 6px", fontWeight: 900, fontSize: 13 }}>{isAU ? "Total" : "合計"}</td>
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {productRanking.reduce((a, p) => a + p.qty, 0)}
                              </td>
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {formatMoney(productRanking.reduce((a, p) => a + p.subtotal, 0), tenantProfile?.marketId)}
                              </td>
                              {!isAU && <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {formatMoney(productRanking.reduce((a, p) => a + p.tax8, 0), tenantProfile?.marketId)}
                              </td>}
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900 }}>
                                {formatMoney(productRanking.reduce((a, p) => a + p.tax10, 0), tenantProfile?.marketId)}
                              </td>
                              <td style={{ padding: "8px 6px", textAlign: "right", fontWeight: 900, fontSize: 14 }}>
                                {formatMoney(productRanking.reduce((a, p) => a + p.total, 0), tenantProfile?.marketId)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}
                  </div>
                )}

                {/* ===== 期間・仕入先指定タブ ===== */}
                {retailSummaryTab === "detail" && (
                  <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                    <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 12 }}>{isAU ? "🔍 Summary by period & supplier" : "🔍 期間・仕入先指定集計"}</div>

                    {/* フィルター */}
                    <div style={{ display: "grid", gap: 10, marginBottom: 16 }}>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 4 }}>{isAU ? "Supplier" : "仕入先"}</div>
                        <select
                          value={retailSelectedSupplier}
                          onChange={(e) => setRetailSelectedSupplier(e.target.value)}
                          style={{ width: "100%", padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700, fontSize: 13 }}
                        >
                          <option value="">{isAU ? "All suppliers" : "すべての仕入先"}</option>
                          {supplierOptions.map(({ sid, name }) => (
                            <option key={sid} value={sid}>{name}</option>
                          ))}
                        </select>
                      </div>
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                        <div style={{ fontWeight: 700, fontSize: 12, whiteSpace: "nowrap" }}>{isAU ? "Period" : "期間"}</div>
                        <input
                          type="date"
                          value={draftRetailStartDate}
                          onChange={(e) => setDraftRetailStartDate(e.target.value)}
                          style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700, fontSize: 13 }}
                        />
                        <span style={{ opacity: 0.7 }}>{isAU ? "–" : "〜"}</span>
                        <input
                          type="date"
                          value={draftRetailEndDate}
                          onChange={(e) => setDraftRetailEndDate(e.target.value)}
                          style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700, fontSize: 13 }}
                        />
                        <button
                          onClick={async () => {
                            setRetailStartDate(draftRetailStartDate);
                            setRetailEndDate(draftRetailEndDate);
                            if (draftRetailStartDate && draftRetailEndDate) {
                              await fetchRetailRangeOrders(draftRetailStartDate, draftRetailEndDate);
                            } else {
                              retailRangeRequestIdRef.current++; // 進行中のリクエストがあれば無効化する
                              setRetailRangeOrders(null);
                              setRetailRangeError(false);
                            }
                          }}
                          style={{ padding: "8px 14px", borderRadius: 10, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 12, cursor: "pointer", whiteSpace: "nowrap" }}
                        >
                          {isAU ? (retailRangeLoading ? "Loading…" : "🔍 Filter") : (retailRangeLoading ? "取得中…" : "🔍 絞り込む")}
                        </button>
                        {(retailStartDate || retailEndDate || retailSelectedSupplier) && (
                          <button
                            onClick={() => {
                              retailRangeRequestIdRef.current++; // 進行中のリクエストがあれば無効化する
                              setRetailStartDate(""); setRetailEndDate(""); setDraftRetailStartDate(""); setDraftRetailEndDate(""); setRetailSelectedSupplier(""); setRetailRangeOrders(null); setRetailRangeError(false);
                            }}
                            style={{ padding: "6px 12px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer", fontSize: 12 }}
                          >
                            {isAU ? "Clear" : "クリア"}
                          </button>
                        )}
                      </div>
                      {retailRangeOrders !== null && retailStartDate && retailEndDate && (
                        <div style={{ fontSize: 11, color: "#1d4ed8", background: "#dbeafe", borderRadius: 6, padding: "3px 8px", display: "inline-block" }}>
                          {isAU ? `📅 ${retailStartDate} – ${retailEndDate} (all results loaded)` : `📅 ${retailStartDate} 〜 ${retailEndDate}（全件取得済み）`}
                        </div>
                      )}
                    </div>

                    {/* 集計結果。
                        retailRangeLoadingを最優先でチェックする——期間取得の
                        リクエスト送信中（retailRangeOrders===null・retailRangeError===false
                        の間）に、filteredDetailOrdersが30日分のグローバル購読ordersへ
                        フォールバックした結果を、指定期間の正常な取得結果であるかの
                        ように一瞬表示してしまうことを防ぐ */}
                    {retailRangeLoading ? (
                      <div style={{ opacity: 0.7, fontSize: 13, padding: "16px 0" }}>{isAU ? "Loading..." : "取得中..."}</div>
                    ) : retailRangeError ? (
                      <div style={{ opacity: 0.85, fontSize: 13, padding: "16px 0", color: "#dc2626" }}>
                        {isAU ? "⚠ Failed to load summary data. Please try again." : "⚠ 集計データの取得に失敗しました。再度お試しください。"}
                      </div>
                    ) : filteredDetailOrders.length === 0 ? (
                      <div style={{ opacity: 0.7, fontSize: 13, padding: "16px 0" }}>{isAU ? "(No matching data)" : "（該当データなし）"}</div>
                    ) : (
                      <div style={{ display: "grid", gap: 12 }}>
                        {/* サマリーカード */}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 8 }}>
                          <div style={{ padding: 12, background: "#f9fafb", borderRadius: 10, border: "1px solid #eee" }}>
                            <div style={{ fontSize: 11, opacity: 0.7 }}>{isAU ? "Orders" : "発注件数"}</div>
                            <div style={{ fontSize: 20, fontWeight: 900, marginTop: 4 }}>{isAU ? filteredDetailOrders.length : `${filteredDetailOrders.length}件`}</div>
                          </div>
                          <div style={{ padding: 12, background: "#f9fafb", borderRadius: 10, border: "1px solid #eee" }}>
                            <div style={{ fontSize: 11, opacity: 0.7 }}>{isAU ? "Subtotal (ex GST)" : "小計（税抜）"}</div>
                            <div style={{ fontSize: 18, fontWeight: 900, marginTop: 4 }}>{formatMoney(detailStats.subtotal, tenantProfile?.marketId)}</div>
                          </div>
                          {!isAU && <div style={{ padding: 12, background: "#f9fafb", borderRadius: 10, border: "1px solid #eee" }}>
                            <div style={{ fontSize: 11, opacity: 0.7 }}>消費税8%</div>
                            <div style={{ fontSize: 18, fontWeight: 900, marginTop: 4 }}>{formatMoney(detailStats.tax8, tenantProfile?.marketId)}</div>
                          </div>}
                          <div style={{ padding: 12, background: "#f9fafb", borderRadius: 10, border: "1px solid #eee" }}>
                            <div style={{ fontSize: 11, opacity: 0.7 }}>{isAU ? "GST 10%" : "消費税10%"}</div>
                            <div style={{ fontSize: 18, fontWeight: 900, marginTop: 4 }}>{formatMoney(detailStats.tax10, tenantProfile?.marketId)}</div>
                          </div>
                          <div style={{ padding: 12, background: "#111", borderRadius: 10, border: "1px solid #111" }}>
                            <div style={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>{isAU ? "Total (incl. tax)" : "合計（税込）"}</div>
                            <div style={{ fontSize: 20, fontWeight: 900, marginTop: 4, color: "white" }}>{formatMoney(detailStats.total, tenantProfile?.marketId)}</div>
                          </div>
                        </div>

                        {/* 商品別内訳 */}
                        {detailProductList.length > 0 && (
                          <div>
                            <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 8 }}>{isAU ? "Breakdown by product" : "商品別内訳"}</div>
                            <div style={{ overflowX: "auto" }}>
                              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 400 }}>
                                <thead>
                                  <tr style={{ borderBottom: "2px solid #eee", background: "#fafafa" }}>
                                    <th style={{ textAlign: "left", padding: "7px 6px", fontSize: 12 }}>{isAU ? "Product" : "商品名"}</th>
                                    <th style={{ textAlign: "right", padding: "7px 6px", fontSize: 12 }}>{isAU ? "Qty ordered" : "発注数"}</th>
                                    <th style={{ textAlign: "right", padding: "7px 6px", fontSize: 12 }}>{isAU ? "Subtotal (ex. tax)" : "小計（税抜）"}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {detailProductList.map((p, idx) => (
                                    <tr key={idx} style={{ borderBottom: "1px solid #f4f4f4", background: idx % 2 === 0 ? "white" : "#fafafa" }}>
                                      <td style={{ padding: "7px 6px", fontWeight: 700 }}>{p.name}</td>
                                      <td style={{ padding: "7px 6px", textAlign: "right" }}>{p.qty}</td>
                                      <td style={{ padding: "7px 6px", textAlign: "right", fontWeight: 700 }}>{formatMoney(p.amount, tenantProfile?.marketId)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                        {/* 対象発注一覧 */}
                        <div>
                          <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 8 }}>{isAU ? "Matching orders" : "対象発注一覧"}</div>
                          <div style={{ display: "grid", gap: 6 }}>
                            {filteredDetailOrders.map((o, idx) => {
                              const oStats = calcTax([o]);
                              const d = getOrderDate(o);
                              const dateStr = isAU
                                ? `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`
                                : `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,"0")}/${String(d.getDate()).padStart(2,"0")}`;
                              return (
                                <div key={idx} style={{ padding: "10px 12px", border: "1px solid #eee", borderRadius: 10, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 6, fontSize: 13 }}>
                                  <div>
                                    <span style={{ fontWeight: 700 }}>{supplierNameById(o.supplierId) || o.supplierName || (isAU ? "Unknown" : "不明")}</span>
                                    <span style={{ marginLeft: 8, opacity: 0.6, fontSize: 11 }}>{dateStr}</span>
                                    {o.orderNo && <span style={{ marginLeft: 8, opacity: 0.6, fontSize: 11 }}>No.{o.orderNo}</span>}
                                  </div>
                                  <div style={{ fontWeight: 900 }}>{formatMoney(oStats.total, tenantProfile?.marketId)}</div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })()}

          {/* ===== 小売 設定 ===== */}
          {mode === "retail" && retailView === "settings" && (
            <div style={{ display: "grid", gap: 12, maxWidth: 520, margin: "0 auto" }}>
              <div style={{ ...S.card }}>
                <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "Settings" : "設定"}</div>
                <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>{isAU ? "Manage business details and suppliers" : "会社情報・仕入先の管理"}</div>
              </div>
              <button
                onClick={() => setRetailView("company-info")}
                style={{ ...S.btn, textAlign: "left", padding: "20px 18px" }}
              >
                <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "🏢 Business details" : "🏢 会社情報"}</div>
                <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>{isAU ? "Edit your store details and summary basis" : "自店情報の編集・集計基準"}</div>
              </button>
              <button
                onClick={() => setRetailView("connection")}
                style={{ ...S.btn, textAlign: "left", padding: "20px 18px" }}
              >
                <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "🔗 Connection & invite code" : "🔗 接続・招待コード"}</div>
                <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>{isAU ? "View your invite code and manage supplier connections" : "自社の招待コード確認・卸との接続管理"}</div>
              </button>
              <button
                onClick={() => setRetailView("suppliers")}
                style={{ ...S.btn, textAlign: "left", padding: "20px 18px" }}
              >
                <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "📠 Add supplier" : "📠 仕入先追加"}</div>
                <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>{isAU ? "Manually register and manage fax/phone suppliers" : "FAX・電話の仕入先を手動登録・管理"}</div>
              </button>
            </div>
          )}

          {/* ===== 小売 会社情報（ページ型） ===== */}
          {mode === "retail" && retailView === "company-info" && (
            <RetailCompanyInfoPage
              initialProfile={tenantProfile}
              onBack={() => setRetailView("settings")}
              onSave={async (form) => {
                await updateTenantSettings(form);
                setRetailView("settings");
              }}
              isAU={isAU}
            />
          )}

          {/* ===== 小売 接続・招待コード ===== */}
          {mode === "retail" && retailView === "connection" && (
            <div style={{ display: "grid", gap: 12, maxWidth: 520, margin: "0 auto" }}>
              {/* 自社の招待コード */}
              <div style={{ ...S.card, display: "grid", gap: 10 }}>
                <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Your invite code" : "自社の招待コード"}</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <div style={{ flex: 1, background: "#111", color: "#fff", padding: "12px 14px", borderRadius: 10, fontSize: 24, fontWeight: 900, letterSpacing: 6, fontFamily: "monospace", textAlign: "center" }}>
                    {tenantProfile?.inviteCode || "--------"}
                  </div>
                  <button
                    onClick={() => { navigator.clipboard.writeText(tenantProfile?.inviteCode || ""); showToast(isAU ? "Copied" : "コピーしました"); }}
                    style={{ padding: "8px 14px", borderRadius: 8, border: "1px solid #ddd", background: "white", fontWeight: 900, fontSize: 13, cursor: "pointer" }}
                  >
                    {isAU ? "📋 Copy" : "📋 コピー"}
                  </button>
                </div>
                <div style={{ fontSize: 12, color: "#888" }}>{isAU ? "Give this code to a supplier to be registered as their customer" : "仕入先（卸）にこのコードを伝えると、取引先として登録されます"}</div>
              </div>

              {/* スタッフ招待コード */}
              <div style={{ ...S.card, display: "grid", gap: 10 }}>
                <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "👥 Staff invite code" : "👥 スタッフ招待コード"}</div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <div style={{ flex: 1, background: "#f0f7ff", border: "1px solid #bfdbfe", color: "#1e40af", padding: "12px 14px", borderRadius: 10, fontSize: 22, fontWeight: 900, letterSpacing: 6, fontFamily: "monospace", textAlign: "center" }}>
                    {tenantProfile?.staffInviteCode || "--------"}
                  </div>
                  <button
                    onClick={() => { navigator.clipboard.writeText(tenantProfile?.staffInviteCode || ""); showToast(isAU ? "Copied" : "コピーしました"); }}
                    style={{ padding: "8px 14px", borderRadius: 8, border: "1px solid #ddd", background: "white", fontWeight: 900, fontSize: 13, cursor: "pointer" }}
                  >
                    {isAU ? "📋 Copy" : "📋 コピー"}
                  </button>
                </div>
                <div style={{ fontSize: 12, color: "#888" }}>{isAU ? "Share this with staff at your company to give them access to the same data" : "同じ会社のスタッフに共有すると、同じデータにアクセスできます"}</div>
              </div>

              {/* 卸との接続状況 */}
              <div style={{ ...S.card, display: "grid", gap: 10 }}>
                <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Supplier connection" : "卸との接続"}</div>
                {tenantProfile?.wholesaleTenantId ? (
                  <div style={{ display: "grid", gap: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                      <span style={{ padding: "6px 12px", borderRadius: 8, background: "#d1fae5", color: "#065f46", fontSize: 13, fontWeight: 700 }}>
                        {isAU ? `✅ Connected: ${tenantProfile?.wholesaleName || tenantProfile.wholesaleTenantId}` : `✅ 接続中：${tenantProfile?.wholesaleName || tenantProfile.wholesaleTenantId}`}
                      </span>
                      <button
                        onClick={async () => {
                          if (!window.confirm(isAU ? "Disconnect from this supplier?" : "卸との接続を解除しますか？")) return;
                          const wid = tenantProfile?.wholesaleTenantId;
                          if (!wid) return;
                          try {
                            const disconnectFromWholesaleFn = httpsCallable(functions, "disconnectFromWholesale");
                            await disconnectFromWholesaleFn({ wholesaleTenantId: wid });
                            setTenantProfile(prev => ({ ...(prev || {}), wholesaleTenantId: null, wholesaleName: "" }));
                            showToast(isAU ? "Disconnected" : "接続を解除しました");
                          } catch (e) {
                            console.error(e);
                            alert(e.message);
                          }
                        }}
                        style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #fca5a5", background: "white", color: "#dc2626", fontSize: 12, fontWeight: 700, cursor: "pointer" }}
                      >
                        {isAU ? "Disconnect" : "解除"}
                      </button>
                    </div>
                    <div style={{ fontSize: 12, color: "#888" }}>{isAU ? "Orders you place go straight to the supplier's order list" : "発注すると卸の受注一覧に直接届きます"}</div>
                  </div>
                ) : (
                  <div style={{ display: "grid", gap: 10 }}>
                    <div style={{ fontSize: 13, color: "#888" }}>{isAU ? "Not connected (using fax/phone)" : "未接続（FAX運用中）"}</div>
                    <button
                      onClick={joinTenantByCode}
                      style={{ padding: "12px 16px", borderRadius: 10, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 14, cursor: "pointer" }}
                    >
                      {isAU ? "🔗 Connect with a supplier" : "🔗 卸と接続する"}
                    </button>
                    <div style={{ fontSize: 12, color: "#888" }}>{isAU ? "Get an 8-character invite code from your supplier to connect" : "卸から招待コード（8桁）をもらって入力すると接続できます"}</div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ===== 小売 仕入先登録 ===== */}
          {mode === "retail" && retailView === "suppliers" && (
            <div style={{ display: "grid", gap: 12 }}>
              <CenterWrap>
                <div style={{ display: "grid", gap: 10 }}>
                  <div style={{ ...S.card }}>
                    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                      <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "Suppliers" : "仕入先一覧"}</div>
                      <div style={{ marginLeft: "auto", fontSize: 12, opacity: 0.7 }}>{isAU ? `${suppliers.length}` : `${suppliers.length} 件`}</div>
                    </div>
                    <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>{isAU ? "Manage supplier names and fax numbers" : "仕入先名 / FAX番号を管理します"}</div>
                  </div>

                  {/* 接続方法の案内 */}
                  <div style={{ background: "#f0f7ff", border: "1px solid #bfdbfe", borderRadius: 12, padding: "14px 16px", display: "grid", gap: 10 }}>
                    <div style={{ fontWeight: 900, fontSize: 13 }}>{isAU ? "📋 How to add a supplier" : "📋 仕入先の登録方法"}</div>
                    <div style={{ display: "grid", gap: 8 }}>
                      <div style={{ background: "white", borderRadius: 10, padding: "10px 12px", border: "1px solid #dbeafe" }}>
                        <div style={{ fontWeight: 700, fontSize: 13 }}>{isAU ? "If your supplier also uses this system" : "このシステムを使っている卸と繋ぐ場合"}</div>
                        <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>{isAU ? 'Get an 8-character invite code from your supplier and enter it under ⚙️ Settings → Business details → "Connect with a supplier". The supplier will be added automatically.' : "卸から招待コード（8桁）をもらい、⚙️ 設定・会社情報 →「卸と接続する」で入力してください。仕入先は自動で登録されます。"}</div>
                        <button
                          onClick={() => setTenantOpen(true)}
                          style={{ marginTop: 8, padding: "6px 14px", borderRadius: 8, border: "1px solid #111", background: "#111", color: "white", fontWeight: 900, fontSize: 12, cursor: "pointer" }}
                        >
                          {isAU ? "⚙️ Open Settings & business details" : "⚙️ 設定・会社情報を開く"}
                        </button>
                      </div>
                      <div style={{ background: "white", borderRadius: 10, padding: "10px 12px", border: "1px solid #dbeafe" }}>
                        <div style={{ fontWeight: 700, fontSize: 13 }}>{isAU ? "To register a fax/phone supplier" : "FAX・電話の仕入先を登録する場合"}</div>
                        <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>{isAU ? 'Use "+ Add supplier" below to manually register the supplier name and fax number. Orders will be sent automatically by fax.' : "下の「＋ 仕入先を追加」から仕入先名・FAX番号を手動登録してください。発注時にオートFAXが送信されます。"}</div>
                      </div>
                    </div>
                  </div>
                  {suppliers.length === 0 ? (
                    <div style={{ opacity: 0.7 }}>{isAU ? "(No suppliers yet)" : "（仕入先がまだありません）"}</div>
                  ) : (
                    suppliers.map((s) => (
                      <div key={s.id} style={{ border: "1px solid #eee", borderRadius: 14, padding: 14, background: "white" }}>
                        <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 900, fontSize: 15 }}>{s.name}</div>
                            {s.company && <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>{s.company}</div>}
                            {s.address && <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>📍 {s.address}</div>}
                            <div style={{ display: "flex", gap: 12, marginTop: 4, flexWrap: "wrap" }}>
                              {s.tel && <div style={{ fontSize: 12, opacity: 0.75 }}>📞 {s.tel}</div>}
                              {s.fax && <div style={{ fontSize: 12, opacity: 0.75 }}>📠 {s.fax}</div>}
                            </div>
                            {s.note && <div style={{ fontSize: 11, opacity: 0.6, marginTop: 4, fontStyle: "italic" }}>{s.note}</div>}
                          </div>
                          <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                            <button onClick={() => openSupEdit(s)} style={{ ...S.btn }}>{isAU ? "Edit" : "編集"}</button>
                            <button onClick={() => deleteSupplier(s)} style={{ ...S.btn, border: "1px solid #ddd" }}>{isAU ? "Delete" : "削除"}</button>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  <button onClick={openSupAdd} style={{ ...S.btnPrimary, padding: "14px 14px", borderRadius: 14 }}>
                    {isAU ? "+ Add supplier" : "＋ 仕入先を追加"}
                  </button>
                </div>
              </CenterWrap>
            </div>
          )}

          {/* ===== 小売 仕入先 追加・編集モーダル ===== */}
          {supModalOpen && (
            <div
              style={{ position: "fixed", inset: 0, zIndex: 16000, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
              onClick={closeSupModal}
            >
              <div
                style={{ background: "white", borderRadius: 18, padding: 24, width: "100%", maxWidth: 480, display: "grid", gap: 14, maxHeight: "90vh", overflowY: "auto" }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{ fontWeight: 900, fontSize: 18 }}>
                  {isAU ? (supMode === "add" ? "Add supplier" : "Edit supplier") : (supMode === "add" ? "仕入先を追加" : "仕入先を編集")}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Supplier name" : "仕入先名"} <span style={{ color: "#e11d48" }}>*</span></div>
                  <input
                    value={supName}
                    onChange={(e) => setSupName(e.target.value)}
                    placeholder={isAU ? "e.g. Smith Meats" : "例）佐藤精肉"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, fontWeight: 700, boxSizing: "border-box" }}
                  />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Company name" : "社名（法人名）"}</div>
                  <input
                    value={supCompany}
                    onChange={(e) => setSupCompany(e.target.value)}
                    placeholder={isAU ? "e.g. Smith Meats Pty Ltd" : "例）株式会社佐藤精肉店"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                  />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Address" : "住所"}</div>
                  <input
                    value={supAddress}
                    onChange={(e) => setSupAddress(e.target.value)}
                    placeholder={isAU ? "e.g. 123 George St, Sydney NSW" : "例）東京都渋谷区〇〇1-2-3"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                  />
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Phone" : "TEL"}</div>
                    <input
                      value={supTel}
                      onChange={(e) => setSupTel(e.target.value)}
                      placeholder={isAU ? "e.g. 02 1234 5678" : "例）03-1234-5678"}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                    />
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>Fax</div>
                    <input
                      value={supFax}
                      onChange={(e) => setSupFax(e.target.value)}
                      placeholder={isAU ? "e.g. 02 1234 5679" : "例）03-1234-5679"}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                    />
                  </div>
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Notes" : "備考"}</div>
                  <textarea
                    value={supNote}
                    onChange={(e) => setSupNote(e.target.value)}
                    placeholder={isAU ? "Contact person, order days, etc." : "担当者名・発注曜日など"}
                    rows={3}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box", resize: "vertical" }}
                  />
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Email address" : "メールアドレス"}</div>
                  <input
                    type="email"
                    value={supEmail}
                    onChange={(e) => setSupEmail(e.target.value)}
                    placeholder={isAU ? "e.g. order@supplier.com.au" : "例）order@supplier.co.jp"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                  />
                </div>
                {/* 2026-08 Codexレビュー指摘対応：インボイス登録番号（日本の適格請求書
                    発行事業者番号、T+13桁）はAU版では意味を持たない日本専用制度のため、
                    AU版では欄自体を非表示にする（invoiceNoフィールドの書き込み自体は
                    isAUでも許可されたままだが、UIには出さない） */}
                {!isAU && (
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>インボイス登録番号</div>
                  <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: 10, overflow: "hidden" }}>
                    <span style={{ padding: "10px 10px 10px 12px", background: "#f5f5f5", fontWeight: 900, fontSize: 15, color: "#333", borderRight: "1px solid #ddd" }}>T</span>
                    <input
                      value={supInvoiceNo.replace(/^T/, "")}
                      onChange={(e) => setSupInvoiceNo("T" + e.target.value.replace(/\D/g, "").slice(0, 13))}
                      placeholder="1234567890123"
                      maxLength={13}
                      inputMode="numeric"
                      style={{ flex: 1, padding: "10px 12px", border: "none", fontSize: 14, outline: "none" }}
                    />
                    <span style={{ padding: "10px 12px", fontSize: 12, color: supInvoiceNo.replace(/^T/, "").length === 13 ? "#16a34a" : "#aaa", whiteSpace: "nowrap" }}>
                      {supInvoiceNo.replace(/^T/, "").length}/13
                    </span>
                  </div>
                </div>
                )}
                {/* 卸のtenantId直接入力は廃止。卸との接続は招待コード（joinTenantByInviteCode Callable）経由に一本化された。
                    新Firestore Rulesでも手動supplierへのwholesaleTenantId書き込みは禁止されている。 */}
                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={closeSupModal} style={{ ...S.btn, flex: 1, padding: "12px 0" }}>{isAU ? "Cancel" : "キャンセル"}</button>
                  <button onClick={saveSupplier} style={{ ...S.btnPrimary, flex: 2, padding: "12px 0" }}>
                    {isAU ? (supMode === "add" ? "Add" : "Save") : (supMode === "add" ? "追加する" : "保存する")}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ✅ wholesale header（ホーム戻り） */}
          {mode === "wholesale" && wholesaleView !== "home" && (
            <div
              style={{
                position: "sticky",

                top: 0,
                zIndex: 2000,
                background: "white",
                borderBottom: "1px solid #eee",
              }}
            >
              {/* ✅ 中央寄せ幅をメインと揃える */}
              <div style={{ maxWidth: 860, margin: "0 auto", padding: "10px 12px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 1fr auto",
                    alignItems: "center",
                    gap: 10,
                    position: "relative", // ✅ 中央タイトルの基準
                  }}
                >
                  {/* 左：戻る（1個だけ） */}
                  <div>
                    <button
                      onClick={() => {
                        setWholesaleView("home");
                        setSelectedOrderId(null);
                        setWhSearch("");
                        setOnlyUnprocessed(false);
                      }}
                      style={{
                        ...S.btnPrimary,
                        padding: "12px 14px",
                        borderRadius: 14,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isAU ? "← Menu" : "← メニュー"}
                    </button>
                  </div>

                  {/* ✅ 中央：タイトル（常に中央に見える） */}
                  <div
                    style={{
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                      fontWeight: 900,
                      textAlign: "center",
                      pointerEvents: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {/* 2026-08 AU版基盤（Phase 2）：先進部分のみ英語化（ユーザー指示による
                        スコープ限定）。isAU（tenantProfile.marketId==="AU"）の場合のみ
                        英語ラベルへ切り替える。日本版はisAU===falseのため既存の
                        日本語ラベルのまま一切変更しない */}
                    {wholesaleView === "orders" && (isAU ? "Wholesale / Order management" : "卸 / 受注一覧")}
                    {wholesaleView === "products" && (isAU ? "Wholesale / Products" : "卸 / 商品登録・価格変更")}
                    {wholesaleView === "summary" && (isAU ? "Wholesale / Summary" : "卸 / 集計")}
                    {wholesaleView === "manual" && (isAU ? "Wholesale / Manual entry" : "卸 / 手書き入力")}
                    {wholesaleView === "suppliers" && (isAU ? "Wholesale / Customers" : "卸 / 取引先（小売店）")}
                    {wholesaleView === "billing" && (isAU ? "Wholesale / Invoices" : "卸 / 請求書発行")}
                    {wholesaleView === "settings" && (isAU ? "Settings" : "設定")}
                    {wholesaleView === "connection" && (isAU ? "Connection / Invite code" : "接続・招待コード")}
                  </div>

                  {/* 右：ボタン群 */}
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, flexWrap: "wrap" }}>
                    {wholesaleView === "suppliers" && (
                      <button onClick={openSupAdd} style={{ ...S.btn, border: "1px solid #111" }}>
                        {isAU ? "+ Add customer" : "＋ 小売店追加"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ✅ wholesale home（メインメニュー） */}
          {mode === "wholesale" && wholesaleView === "home" && (
            <div style={{ display: "grid", gap: 16, maxWidth: 1100, margin: "0 auto" }}>

              {/* 2026-08 AU版基盤（Phase 2）：Getting Startedバナー。
                  AU版（isAU）かつ、まだSample Retailerを開始していない
                  tenantにのみ表示する。過剰なチュートリアルにならないよう、
                  「Try a sample order」への導線1つに絞る */}
              {isAU && !tenantProfile?.activation?.sampleModeStartedAt && (
                <div style={{ background: "linear-gradient(135deg,#eff6ff,#eef2ff)", border: "2px solid #2563eb", borderRadius: 14, padding: "20px 24px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                  <div style={{ flex: 1, minWidth: 220 }}>
                    <div style={{ fontWeight: 900, fontSize: 16, color: "#1e40af", marginBottom: 4 }}>👋 Welcome to OrderLink</div>
                    <div style={{ fontSize: 13, color: "#3b82f6" }}>See how it works in under a minute — place a sample order as a retailer and watch it land here.</div>
                  </div>
                  <button
                    onClick={() => { trackEvent("sample_mode_start"); setShowSampleRetailerModal(true); }}
                    style={{ padding: "12px 22px", borderRadius: 10, background: "#2563eb", color: "white", fontWeight: 900, fontSize: 14, border: "none", cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    🛒 Try a sample order
                  </button>
                </div>
              )}

              {/* 2026-08 AU版基盤（Phase 2）：Reset sample data。isDemo:trueの
                  データのみを削除するresetSampleData Callableを呼ぶ。実データ
                  （isDemoでない商品・注文）には一切触れない設計はサーバー側の
                  固定クエリで保証されている（クライアント側は削除条件を指定できない）。
                  Sample Retailerを一度でも開始したtenantにのみ表示し、もう一度
                  体験し直せるようにする */}
              {isAU && tenantProfile?.activation?.sampleModeStartedAt && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    onClick={async () => {
                      if (!window.confirm("This will delete all sample products and sample orders (isDemo data only). Your real data will not be affected. Continue?")) return;
                      try {
                        const resetFn = httpsCallable(functions, "resetSampleData");
                        const result = await resetFn({});
                        showToast(`Sample data reset (${result.data?.deletedProducts || 0} products, ${result.data?.deletedOrders || 0} orders removed)`);
                      } catch (e) {
                        console.error("[resetSampleData error]", e);
                        alert(e?.message || "Failed to reset sample data. Please try again.");
                      }
                    }}
                    style={{ padding: "8px 14px", borderRadius: 8, border: "1px solid #d1d5db", background: "white", color: "#6b7280", fontWeight: 700, fontSize: 12, cursor: "pointer" }}
                  >
                    ↺ Reset sample data
                  </button>
                </div>
              )}

              {/* 導入マニュアルバナー
                  2026-08（Step 12 E2E検証時に発覚したバグ対応）：PDFマニュアル
                  （/manual.pdf、/受発注システム_卸向け導入マニュアル.pdf）とExcel
                  テンプレート（/商品マスタ登録フォーマット.xlsx）はいずれも日本版
                  専用ファイルで、AU版向けの英語版が用意されていない。かつ本文・
                  ボタン文言もisAU分岐されておらず常に日本語固定だった。
                  AU向けファイルを用意するまでの間、AU版ではバナー自体を非表示にする */}
              {showManualBanner && !isAU && (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  <div style={{ background: "#eff6ff", border: "2px solid #2563eb", borderRadius: 14, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 900, fontSize: 15, color: "#1e40af", marginBottom: 4 }}>📖 卸向け導入マニュアルをダウンロードしてください</div>
                      <div style={{ fontSize: 13, color: "#3b82f6" }}>取引先招待・商品登録・受注管理の手順をまとめています</div>
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <a href="/manual.pdf" download style={{ padding: "10px 20px", borderRadius: 8, background: "#2563eb", color: "white", fontWeight: 900, fontSize: 14, textDecoration: "none" }}>
                        ⬇ ダウンロード
                      </a>
                      <button onClick={() => setShowManualBanner(false)} style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid #bfdbfe", background: "white", color: "#6b7280", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                        閉じる
                      </button>
                    </div>
                  </div>
                  <div style={{ background: "#f0fdf4", border: "2px solid #16a34a", borderRadius: 14, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 900, fontSize: 15, color: "#15803d", marginBottom: 4 }}>📋 商品マスタをExcelで一括登録しましょう</div>
                      <div style={{ fontSize: 13, color: "#16a34a" }}>フォーマットをダウンロードして商品名・単価・税率を入力、取り込むだけで完了です</div>
                    </div>
                    <a href="/商品マスタ登録フォーマット.xlsx" download="商品マスタ登録フォーマット.xlsx" style={{ padding: "10px 20px", borderRadius: 8, background: "#16a34a", color: "white", fontWeight: 900, fontSize: 14, textDecoration: "none", whiteSpace: "nowrap" }}>
                      ⬇ フォーマットDL
                    </a>
                  </div>
                </div>
              )}

              {/* 受注一覧（最重要・強調表示） */}
              <button
                onClick={() => setWholesaleView("orders")}
                style={{
                  background: newCount > 0 ? "#eff6ff" : "#f8fafc",
                  border: newCount > 0 ? "2px solid #2563eb" : "1px solid #e2e8f0",
                  borderRadius: 14,
                  padding: "40px 28px",
                  textAlign: "left",
                  cursor: "pointer",
                  transition: "all 0.15s",
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,99,235,0.12)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
              >
                <div style={{ fontSize: 36 }}>📥</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 900, fontSize: 18, color: "#1e40af", marginBottom: 4 }}>{isAU ? "Order management" : "受注一覧"}</div>
                  <div style={{ fontSize: 13, color: "#64748b" }}>{isAU ? "Review orders from retailers, adjust quantities, confirm, and issue delivery notes" : "小売からの発注確認・数量調整・受注確定・納品書発行"}</div>
                </div>
                {newCount > 0 && (
                  <div style={{ background: "#ef4444", color: "white", borderRadius: 999, padding: "4px 14px", fontSize: 13, fontWeight: 900, whiteSpace: "nowrap", flexShrink: 0 }}>
                    {isAU ? `New ${newCount}` : `新規 ${newCount}件`}
                  </div>
                )}
              </button>

              {/* 2カラムグリッド */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>

                <button
                  onClick={() => setWholesaleView("products")}
                  style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", textAlign: "left", cursor: "pointer", transition: "all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize: 24, marginBottom: 8 }}>🏷️</div>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Products" : "商品マスタ管理"}</div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>{isAU ? "Register products, change prices, import from Excel" : "商品登録・価格変更・Excel取込"}</div>
                </button>

                <button
                  onClick={() => setWholesaleView("manual")}
                  style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", textAlign: "left", cursor: "pointer", transition: "all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize: 24, marginBottom: 8 }}>✍️</div>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Manual entry" : "手書き入力"}</div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>{isAU ? "Manually enter phone/fax orders" : "FAX・電話の受注を手入力"}</div>
                </button>

                <button
                  onClick={() => setWholesaleView("summary")}
                  style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", textAlign: "left", cursor: "pointer", transition: "all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize: 24, marginBottom: 8 }}>📊</div>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Sales Summary" : "集計"}</div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>{isAU ? "View sales by month, customer, or product" : "月別・取引先別・商品別の売上確認"}</div>
                </button>

                <button
                  onClick={() => setWholesaleView("billing")}
                  style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", textAlign: "left", cursor: "pointer", transition: "all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize: 24, marginBottom: 8 }}>🧾</div>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Tax Invoices" : "請求書発行"}</div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>{isAU ? "Issue a tax invoice for a customer and date range" : "期間・取引先を指定して請求書を発行"}</div>
                </button>

                <button
                  onClick={() => setWholesaleView("settings")}
                  style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", textAlign: "left", cursor: "pointer", transition: "all 0.15s" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize: 24, marginBottom: 8 }}>⚙️</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Settings" : "設定"}</div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#1a56db", background: "#eff6ff", borderRadius: 6, padding: "4px 10px" }}>{isAU ? "👥 Invite customers here" : "👥 取引先の招待はこちら"}</div>
                  </div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>{isAU ? "Business details, invite code, manage customers" : "会社情報・招待コード・取引先の管理"}</div>
                </button>

                {!isAU && (
                <a
                  href="/受発注システム_卸向け導入マニュアル.pdf"
                  download="受発注システム_卸向け導入マニュアル.pdf"
                  style={{ background: "white", border: "1px solid #e2e8f0", borderRadius: 12, padding: "20px 22px", textAlign: "left", textDecoration: "none", display: "block", transition: "all 0.15s", cursor: "pointer" }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ fontSize: 24, marginBottom: 8 }}>📄</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                    <div style={{ fontWeight: 900, fontSize: 15, color: "#1e293b" }}>導入マニュアルDL</div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#b45309", background: "#fffbeb", borderRadius: 6, padding: "4px 10px" }}>📖 まずはここから</div>
                  </div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>はじめての方はこちら（PDF）</div>
                </a>
                )}

              </div>

              {/* 初回オンボーディング：商品が0件のときのみ表示
                  2026-08（Step 12 E2E検証時に発覚したバグ対応）：isAU分岐なしで
                  完全に日本語ハードコードされていた */}
              {wholesaleProducts.length === 0 && (
                <div style={{ border: "2px dashed #f0a500", borderRadius: 12, padding: "16px 20px", background: "#fffbf0" }}>
                  <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 6, color: "#b37800" }}>{isAU ? "🚀 Add some sample products to get started" : "🚀 最初にサンプル商品を追加しましょう"}</div>
                  <div style={{ fontSize: 12, color: "#888", marginBottom: 10 }}>
                    {isAU
                      ? 'Adds 5 sample products so you can try things out. You can edit or remove them anytime from "Products".'
                      : "動作確認用のサンプル商品（5件）を追加します。あとから「商品マスタ管理」で自由に編集・削除できます。"}
                  </div>
                  <button
                    onClick={seedWholesaleSampleProducts}
                    style={{ padding: "10px 20px", borderRadius: 10, background: "#f0a500", color: "white", border: "none", fontWeight: 900, cursor: "pointer", fontSize: 14 }}
                  >
                    {isAU ? "Add sample products" : "サンプル商品を追加する"}
                  </button>
                </div>
              )}
            </div>
          )}

{/* QR招待モーダル */}
{showQRModal && tenantProfile?.inviteCode && (
  <div
    onClick={() => setShowQRModal(false)}
    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 9000, display: "flex", alignItems: "center", justifyContent: "center" }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{ background: "white", borderRadius: 16, padding: 28, maxWidth: 360, width: "90%", textAlign: "center" }}
    >
      <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 4 }}>{isAU ? "📱 Invite a retailer" : "📱 小売店を招待"}</div>
      <div style={{ fontSize: 13, color: "#666", marginBottom: 20 }}>
        {isAU ? <>Scanning this QR code on a phone<br />connects automatically</> : <>このQRコードをスマホで読み取ると<br />自動で接続されます</>}
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
        <QRCodeSVG
          value={`${process.env.REACT_APP_HOSTING_URL || window.location.origin}/?invite=${tenantProfile.inviteCode}`}
          size={220}
          level="M"
        />
      </div>
      <div style={{ fontSize: 12, color: "#999", marginBottom: 8 }}>{isAU ? "Invite code" : "招待コード"}</div>
      <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: 4, marginBottom: 20 }}>
        {tenantProfile.inviteCode}
      </div>
      <button
        onClick={() => setShowQRModal(false)}
        style={{ padding: "10px 32px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, cursor: "pointer", fontSize: 15 }}
      >
        {isAU ? "Close" : "閉じる"}
      </button>
    </div>
  </div>
)}

{/* ===== 受注一覧リスト（selectedOrder がないとき） ===== */}
{mode === "wholesale" && wholesaleView === "orders" && !selectedOrder && (
  <div style={{ display: "grid", gap: 10 }}>

    {/* 検索 + フィルター */}
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <input
        value={whSearch}
        onChange={(e) => { setWhSearch(e.target.value); setWhPage(0); }}
        placeholder={isAU ? "Search by order no. / retailer / product" : "注文No / 小売店名 / 商品名で検索"}
        style={{
          flex: 1, minWidth: 180, padding: "10px 12px",
          borderRadius: 12, border: "1px solid #ddd", fontWeight: 700,
        }}
      />
      
      <input
        type="date"
        value={draftStartDate}
        onChange={(e) => setDraftStartDate(e.target.value)}
        style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 700 }}
      />
      <span style={{ opacity: 0.7, fontWeight: 700 }}>〜</span>
      <input
        type="date"
        value={draftEndDate}
        onChange={(e) => setDraftEndDate(e.target.value)}
        style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 700 }}
      />
      <button
        onClick={async () => {
          setStartDate(draftStartDate);
          setEndDate(draftEndDate);
          setWhPage(0);
          if (draftStartDate && draftEndDate) {
            await fetchOrdersByDateRange(draftStartDate, draftEndDate);
          } else {
            // 進行中のリクエストがあれば無効化し、ローディング・エラー状態も
            // 明示的にクリアする（無効化されたリクエストのfinallyはIDが
            // 一致しないためloadingを戻せず、放置すると「取得中…」のまま
            // 固まって見えてしまう）
            dateRangeRequestIdRef.current++;
            setDateRangeOrders(null); // 期間未指定なら通常に戻す
            setDateRangeError(false);
            setDateRangeLoading(false);
          }
        }}
        style={{ padding: "10px 14px", borderRadius: 12, border: "none", background: "#111", color: "white", fontWeight: 900, cursor: "pointer", whiteSpace: "nowrap" }}
      >
        {dateRangeLoading ? (isAU ? "Loading…" : "取得中…") : (isAU ? "🔍 Filter" : "🔍 絞り込む")}
      </button>

      {(startDate || endDate) && (
        <button
          onClick={() => {
            // 進行中のリクエストがあれば無効化し、ローディング・エラー状態も
            // 明示的にクリアする（理由は上記「絞り込む」ボタンと同じ）
            dateRangeRequestIdRef.current++;
            setStartDate(""); setEndDate(""); setDraftStartDate(""); setDraftEndDate(""); setWhPage(0); setDateRangeOrders(null);
            setDateRangeError(false);
            setDateRangeLoading(false);
          }}
          style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer" }}
        >
          {isAU ? "Clear" : "クリア"}
        </button>
      )}

      <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap" }}>
        <input
          type="checkbox"
          checked={onlyUnprocessed}
          onChange={(e) => { setOnlyUnprocessed(e.target.checked); setWhPage(0); }}
        />
        {isAU ? `Unprocessed only (${unprocessedCount})` : `未処理のみ（${unprocessedCount}件）`}
      </label>
      <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap", color: "#6b7280" }}>
        <input
          type="checkbox"
          checked={showCancelled}
          onChange={(e) => { setShowCancelled(e.target.checked); setWhPage(0); }}
        />
        {isAU ? "Show cancelled" : "キャンセル表示"}
      </label>
      <button
        onClick={openPrintOrdersList}
        style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 900, background: "white" }}
      >
        {isAU ? "🖨 Print list" : "🖨 一覧印刷"}
      </button>
    </div>

    {/* 件数 + ページング */}
    {(() => {
      const PAGE_SIZE = 50;
      const totalCount = displayOrders.length;
      const totalPages = Math.ceil(totalCount / PAGE_SIZE);
      const pagedOrders = displayOrders.slice(whPage * PAGE_SIZE, (whPage + 1) * PAGE_SIZE);
      const pageStart = whPage * PAGE_SIZE + 1;
      const pageEnd = Math.min((whPage + 1) * PAGE_SIZE, totalCount);

      return (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <div style={{ fontSize: 12, opacity: 0.7 }}>
              {dateRangeLoading
                ? (isAU ? "Loading…" : "取得中…")
                : (totalCount > 0
                  ? (isAU ? `${pageStart}–${pageEnd} of ${totalCount}` : `${pageStart}〜${pageEnd} 件目 / 全${totalCount}件`)
                  : (isAU ? "0" : "0件"))}
              {dateRangeOrders !== null && startDate && endDate && !dateRangeLoading && (
                <span style={{ marginLeft: 8, padding: "2px 8px", borderRadius: 6, background: "#dbeafe", color: "#1d4ed8", fontWeight: 700, fontSize: 11 }}>
                  📅 {startDate} 〜 {endDate}
                </span>
              )}
              {newCount > 0 && (
                <span style={{ marginLeft: 8, padding: "2px 8px", borderRadius: 999, background: "#ef4444", color: "white", fontWeight: 900, fontSize: 11 }}>
                  {isAU ? `New ${newCount}` : `新着 ${newCount}`}
                </span>
              )}
            </div>
            {totalPages > 1 && (
              <div style={{ marginLeft: "auto", display: "flex", gap: 4, alignItems: "center" }}>
                <button
                  onClick={() => setWhPage(p => Math.max(0, p - 1))}
                  disabled={whPage === 0}
                  style={{ padding: "5px 10px", borderRadius: 8, border: "1px solid #ddd", background: whPage === 0 ? "#f4f4f4" : "white", fontWeight: 900, cursor: whPage === 0 ? "default" : "pointer", fontSize: 13, opacity: whPage === 0 ? 0.4 : 1 }}
                >
                  ‹
                </button>
                {Array.from({ length: totalPages }, (_, i) => i).filter(i => Math.abs(i - whPage) <= 2 || i === 0 || i === totalPages - 1).reduce((acc, i, idx, arr) => {
                  if (idx > 0 && i - arr[idx - 1] > 1) acc.push("…");
                  acc.push(i);
                  return acc;
                }, []).map((item, idx) =>
                  item === "…"
                    ? <span key={`ellipsis-${idx}`} style={{ fontSize: 13, opacity: 0.5, padding: "0 2px" }}>…</span>
                    : <button key={item} onClick={() => setWhPage(item)}
                        style={{ padding: "5px 10px", borderRadius: 8, border: item === whPage ? "2px solid #111" : "1px solid #ddd", background: item === whPage ? "#111" : "white", color: item === whPage ? "white" : "#333", fontWeight: 900, cursor: "pointer", fontSize: 13, minWidth: 34 }}>
                        {item + 1}
                      </button>
                )}
                <button
                  onClick={() => setWhPage(p => Math.min(totalPages - 1, p + 1))}
                  disabled={whPage >= totalPages - 1}
                  style={{ padding: "5px 10px", borderRadius: 8, border: "1px solid #ddd", background: whPage >= totalPages - 1 ? "#f4f4f4" : "white", fontWeight: 900, cursor: whPage >= totalPages - 1 ? "default" : "pointer", fontSize: 13, opacity: whPage >= totalPages - 1 ? 0.4 : 1 }}
                >
                  ›
                </button>
              </div>
            )}
          </div>

          {/* 一覧テーブル
              2026-08（Step 12 E2E検証時に発覚したバグ対応）：Order management
              テーブル全体がisAU分岐なしで完全に日本語ハードコードされていた */}
          {pagedOrders.length === 0 ? (
            <div style={{ opacity: 0.7, padding: 12 }}>{isAU ? "(No orders)" : "（受注データがありません）"}</div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: "#f8f9fa", borderBottom: "2px solid #e5e7eb" }}>
                    <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 900, fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{isAU ? "Status" : "状態"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 900, fontSize: 12, color: "#6b7280" }}>{isAU ? "Retailer" : "店名"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 900, fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{isAU ? "Order No." : "注文No"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "right", fontWeight: 900, fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{isAU ? "Qty" : "点数"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "right", fontWeight: 900, fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{isAU ? "Total (inc GST)" : "金額(税込)"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 900, fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{isAU ? "Order date" : "受注日時"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 900, fontSize: 12, color: "#6b7280", whiteSpace: "nowrap" }}>{isAU ? "Delivery date" : "予定納品日"}</th>
                    <th style={{ padding: "10px 12px", textAlign: "center", fontWeight: 900, fontSize: 12, color: "#6b7280" }}>{isAU ? "Actions" : "操作"}</th>
                  </tr>
                </thead>
                <tbody>
                  {pagedOrders.map((o) => {
                    const meta = statusMeta(o.status);
                    const lineCount = getOrderLines(o).reduce((s, l) => s + Number(l.qty || 0), 0);
                    const isNew = !o.seenByWholesale || o.status === "未確認";
                    const accentColor =
                      o.status === "納品書発行" ? "#16a34a" :
                      o.status === "受注確定"   ? "#2563eb" :
                      o.status === "キャンセル" ? "#9ca3af" :
                      "#ef4444";
                    return (
                      <tr
                        key={o.id}
                        onClick={() => {
                          // 2026-08 AU版基盤（Phase 2）：サンプル注文をこの卸画面で
                          // 初めて開いた瞬間を検知する。seenByWholesaleがまだfalseの
                          // 時点（＝このクリックで初めて開封される）でのみ発火させる
                          // ことで、同じ注文を何度も開いた場合の重複発火を避ける
                          if (o.isDemo && !o.seenByWholesale) trackEvent("sample_order_received");
                          setSelectedOrderId(o.id); markSeenByWholesale(o.id);
                        }}
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          background: isNew ? "#fff8f8" : "white",
                          cursor: "pointer",
                          borderLeft: `3px solid ${accentColor}`,
                          transition: "background 0.1s",
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = isNew ? "#fff0f0" : "#f8f9fa"}
                        onMouseLeave={e => e.currentTarget.style.background = isNew ? "#fff8f8" : "white"}
                      >
                        {/* ステータス */}
                        <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: 3, alignItems: "flex-start" }}>
                            <span style={{ padding: "2px 8px", borderRadius: 999, background: meta.bg, color: meta.color, fontSize: 11, fontWeight: 900, whiteSpace: "nowrap" }}>
                              {meta.label}
                            </span>
                            {isNew && <span style={{ padding: "1px 6px", borderRadius: 999, background: "#ef4444", color: "white", fontSize: 10, fontWeight: 900 }}>NEW</span>}
                            {o.changedByWholesale && <span style={{ padding: "1px 6px", borderRadius: 999, background: "#f97316", color: "white", fontSize: 10, fontWeight: 900 }}>数量変更</span>}
                          </div>
                        </td>
                        {/* 店名 */}
                        <td style={{ padding: "10px 12px", fontWeight: 900, fontSize: 14 }}>
                          {o.shopName || o.shopCompany || (isAU ? "Unnamed store" : "〇〇ショップ")}
                          {o.shopCompany && o.shopName && o.shopCompany !== o.shopName && (
                            <div style={{ fontSize: 11, fontWeight: 400, color: "#9ca3af" }}>{o.shopCompany}</div>
                          )}
                        </td>
                        {/* 注文No */}
                        <td style={{ padding: "10px 12px", color: "#6b7280", fontWeight: 700, whiteSpace: "nowrap" }}>
                          No.{o.orderNo}
                        </td>
                        {/* 点数 */}
                        <td style={{ padding: "10px 12px", textAlign: "right", color: "#6b7280", whiteSpace: "nowrap" }}>
                          {isAU ? lineCount : `${lineCount}点`}
                        </td>
                        {/* 金額 */}
                        <td style={{ padding: "10px 12px", textAlign: "right", fontWeight: 900, fontSize: 15, color: o.status === "キャンセル" ? "#9ca3af" : "#111", whiteSpace: "nowrap" }}>
                          {formatMoney(o.total, tenantProfile?.marketId)}
                        </td>
                        {/* 日時 */}
                        <td style={{ padding: "10px 12px", color: "#9ca3af", fontSize: 12, whiteSpace: "nowrap" }}>
                          {jdate(o.createdAt, isAU ? "en-AU" : "ja-JP")}
                        </td>
                        {/* 予定納品日 */}
                        <td style={{ padding: "10px 12px", fontSize: 12, whiteSpace: "nowrap" }}>
                          {o.scheduledDeliveryDate ? (
                            <span style={{ color: "#1a56db", fontWeight: 700 }}>{isAU ? formatAUDate(o.scheduledDeliveryDate) : formatJPDate(o.scheduledDeliveryDate)}</span>
                          ) : (
                            <span style={{ color: "#d1d5db" }}>{isAU ? "Not set" : "未設定"}</span>
                          )}
                          {o.requestedDeliveryDate && o.requestedDeliveryDate !== o.scheduledDeliveryDate && (
                            <div style={{ fontSize: 10, color: "#9ca3af" }}>{isAU ? `Requested: ${formatAUDate(o.requestedDeliveryDate)}` : `希望：${formatJPDate(o.requestedDeliveryDate)}`}</div>
                          )}
                          {(() => {
                            const ls = o.lines || [];
                            const dates = ls.map(l => l.scheduledDeliveryDate).filter(Boolean);
                            const unique = [...new Set(dates)];
                            return unique.length > 1 ? (
                              <div style={{ fontSize: 10, color: "#ea580c", fontWeight: 700, marginTop: 2 }}>{isAU ? "📦 Split delivery" : "📦 分納あり"}</div>
                            ) : null;
                          })()}
                        </td>
                        {/* 操作 */}
                        <td style={{ padding: "10px 12px", textAlign: "center", whiteSpace: "nowrap" }}>
                          {/* 2026-08（受注キャンセル機能再設計）：請求済み（billedInvoiceIdあり）の
                              注文は、サーバー側assertOrderMutableが必ず拒否するため、事前に
                              ボタン自体を非表示にしてユーザーへの無駄なエラー表示を避ける */}
                          {(o.status || "") !== "キャンセル" && !o.billedInvoiceId && (
                            <button
                              onClick={(e) => { e.stopPropagation(); cancelOrder(o.id, o.orderNo); }}
                              style={{ padding: "4px 10px", borderRadius: 6, border: "1px solid #e5e7eb", background: "white", color: "#9ca3af", fontSize: 11, fontWeight: 700, cursor: "pointer" }}
                            >
                              {isAU ? "Cancel" : "キャンセル"}
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* 下部ページング（2ページ以上あるとき） */}
          {totalPages > 1 && (
            <div style={{ display: "flex", gap: 4, alignItems: "center", justifyContent: "center", paddingTop: 4 }}>
              <button onClick={() => { setWhPage(p => Math.max(0, p - 1)); window.scrollTo(0,0); }} disabled={whPage === 0}
                style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #ddd", background: whPage === 0 ? "#f4f4f4" : "white", fontWeight: 900, cursor: whPage === 0 ? "default" : "pointer", opacity: whPage === 0 ? 0.4 : 1 }}>
                {isAU ? "‹ Prev" : "‹ 前へ"}
              </button>
              <span style={{ fontSize: 13, opacity: 0.7, padding: "0 8px" }}>{isAU ? `Page ${whPage + 1} / ${totalPages}` : `${whPage + 1} / ${totalPages} ページ`}</span>
              <button onClick={() => { setWhPage(p => Math.min(totalPages - 1, p + 1)); window.scrollTo(0,0); }} disabled={whPage >= totalPages - 1}
                style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #ddd", background: whPage >= totalPages - 1 ? "#f4f4f4" : "white", fontWeight: 900, cursor: whPage >= totalPages - 1 ? "default" : "pointer", opacity: whPage >= totalPages - 1 ? 0.4 : 1 }}>
                {isAU ? "Next ›" : "次へ ›"}
              </button>
            </div>
          )}
        </>
      );
    })()}
  </div>
)}

{/* ✅ 詳細（同じ CenterWrap の中で表示する） */}
{selectedOrder && (() => {
  const status = String(selectedOrder?.status || "未確認").trim();
  const isUnconfirmedLocal = status === "未確認";
  // 2026-08修正（本番改修：単価表示不整合の是正、Codexレビュー指摘対応・2ラウンド目）：
  // linesLocal（表示用、_lineId/_key付与）とlinesLocalDisp（金額計算用、
  // getDisplayOrderAmountsの結果）を、必ず同じ正規化済み配列normalizedLinesから
  // 導出する。以前はgetOrderLinesSafe(selectedOrder)を独立して呼んでおり、内部で
  // 再度同じ正規化処理を実行していたため「たまたま同じ結果になる」ことに依存
  // していた（将来どちらかの実装だけが変更されるとindex対応が壊れるリスクが
  // あった）。normalizeOrderLines/decorateLinesSafeへ分離したことで、
  // ここでは1回だけ計算したnormalizedLinesを両方の入力にする
  const normalizedLines = normalizeOrderLines(selectedOrder);
  const linesLocal = decorateLinesSafe(normalizedLines);
  // 2026-08 AU版基盤（Phase 2、Codexレビュー指摘対応・MUST-FIX）
  const linesLocalDisp = getDisplayOrderAmounts({ orderSnapshot: { lines: normalizedLines } }, tenantProfile?.marketId).lines;
  const hasMissingCost = linesLocal.some((l) => {
    const cp = Number(l.costPrice ?? l.costPriceSnapshot ?? 0);
    return !(cp > 0);
  });

  // 2026-08（Step 12 E2E検証時に発覚したバグ対応）：statusの内部値（日本語）を
  // そのままバッジに表示しており、isAU分岐がなかった。labelを追加して表示のみ分離する
  const statusBadge = (() => {
    if (status === "納品書発行") return { dot: "🟢", label: isAU ? "Delivery note issued" : "納品書発行", bg: "#dcfce7", color: "#166534", border: "#86efac" };
    if (status === "受注確定")  return { dot: "🟡", label: isAU ? "Confirmed" : "受注確定", bg: "#fffbeb", color: "#92400e", border: "#fcd34d" };
    if (status === "キャンセル") return { dot: "⚫", label: isAU ? "Cancelled" : "キャンセル", bg: "#f3f4f6", color: "#6b7280", border: "#d1d5db" };
    return                              { dot: "🔴", label: isAU ? "Unconfirmed" : "未確認", bg: "#eff6ff", color: "#991b1b", border: "#fca5a5" };
  })();

  // 2026-08追加：この注文が受注確定処理中かどうか（processing state）。
  // 数量＋/－・日付変更・欠品化・キャンセル等、同一注文の整合性に影響する
  // 操作は全てこのフラグを見てロックする
  const isConfirmingThisOrder = !!confirmingOrderIds[selectedOrder.id];

  // 2026-08修正（Codexレビュー指摘対応MUST-FIX1）：「一覧に戻る」ボタンが
  // ヘッダー・下部の2箇所にあり、以前は下部のみ未保存ローカル編集の確認・破棄
  // 処理を持っていた。ヘッダー側は確認なしで画面を離れられ、editedQtyByOrderが
  // 破棄されないまま残るため、同じ注文を開き直すと古いローカル編集が再表示される
  // 問題があった。両ボタンから同一のこの関数を呼ぶことで一本化する
  const handleBackToList = () => {
    const hasUnsaved = !!(editedQtyByOrder[selectedOrder.id] && Object.keys(editedQtyByOrder[selectedOrder.id]).length > 0);
    if (hasUnsaved) {
      const ok = window.confirm(isAU
        ? 'Your quantity changes are not saved. Discard them and go back to the list?\n(To save, use "Confirm order")'
        : "数量の変更が保存されていません。破棄して一覧に戻りますか？\n（保存するには「受注確定」を行ってください）");
      if (!ok) return;
      setEditedQtyByOrder((prev) => {
        const next = { ...prev };
        delete next[selectedOrder.id];
        return next;
      });
    }
    setSelectedOrderId(null);
  };

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <div ref={detailTopRef} />

      {/* ── ヘッダーカード ── */}
      <div style={{
        position: "sticky", top: 0, zIndex: 20,
        background: "white", border: "1px solid #e5e7eb",
        borderRadius: 10, padding: "14px 16px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        display: "grid", gap: 12,
      }}>
        {/* 戻るボタン
            2026-08（Step 12 E2E検証時に発覚したバグ対応）：注文詳細画面
            全体がisAU分岐なしで完全に日本語ハードコードされていた */}
        <div>
          <button
            onClick={handleBackToList}
            style={{ background: "white", border: "1px solid #d1d5db", borderRadius: 8, color: "#374151", fontWeight: 700, fontSize: 13, cursor: "pointer", padding: "7px 14px", display: "flex", alignItems: "center", gap: 4 }}
          >{isAU ? "← Back to order list" : "← 受注一覧に戻る"}</button>
        </div>
        {/* 受注情報カード */}
        <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
          {/* 左：店舗名・注文情報 */}
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 4 }}>{selectedOrder.shopName || (isAU ? "Unnamed store" : "〇〇ショップ")}</div>
            <div style={{ fontSize: 13, color: "#6b7280", display: "flex", gap: 12, flexWrap: "wrap" }}>
              <span>{isAU ? `Order No. ${selectedOrder.orderNo}` : `注文No. ${selectedOrder.orderNo}`}</span>
              <span>{isAU ? `Order date: ${jdate(selectedOrder.createdAt, "en-AU")}` : `受注日時: ${jdate(selectedOrder.createdAt)}`}</span>
              {selectedOrder.scheduledDeliveryDate && (
                <span style={{ color: "#1a56db", fontWeight: 700 }}>
                  {isAU ? `Delivery date: ${formatAUDate(selectedOrder.scheduledDeliveryDate)}` : `予定納品日: ${formatJPDate(selectedOrder.scheduledDeliveryDate)}`}
                  {(() => {
                    const ls = selectedOrder.lines || [];
                    const dates = ls.map(l => l.scheduledDeliveryDate).filter(Boolean);
                    const unique = [...new Set(dates)];
                    return unique.length > 1 ? <span style={{ marginLeft: 6, padding: "1px 7px", borderRadius: 4, background: "#fff7ed", color: "#ea580c", fontSize: 11, fontWeight: 900 }}>{isAU ? "📦 Split delivery" : "📦 分納あり"}</span> : null;
                  })()}
                </span>
              )}
              {selectedOrder.requestedDeliveryDate && (
                <span style={{ color: "#7c3aed", fontWeight: 700 }}>{isAU ? `Requested delivery: ${formatAUDate(selectedOrder.requestedDeliveryDate)}` : `希望納品日: ${formatJPDate(selectedOrder.requestedDeliveryDate)}`}</span>
              )}
            </div>
          </div>
          {/* 中央：ステータスバッジ */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <span style={{
              padding: "6px 16px", borderRadius: 8, fontSize: 13, fontWeight: 900,
              background: statusBadge.bg, color: statusBadge.color, border: `1px solid ${statusBadge.border}`,
            }}>{statusBadge.dot} {statusBadge.label}</span>
            {selectedOrder.changedByWholesale && (
              <span style={{ padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 900, background: "#fff7ed", color: "#c2410c", border: "1px solid #fed7aa" }}>{isAU ? "Quantity changed" : "数量変更済"}</span>
            )}
          </div>
          {/* 右：金額 */}
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ fontSize: 12, color: "#9ca3af" }}>
              {isAU
                ? `Subtotal ${formatMoney(selectedOrder.subtotal || 0, tenantProfile?.marketId)} / GST ${formatMoney(selectedOrder.tax || 0, tenantProfile?.marketId)}`
                : `小計 ${formatMoney(selectedOrder.subtotal || 0, tenantProfile?.marketId)} ／ 税 ${formatMoney(selectedOrder.tax || 0, tenantProfile?.marketId)}`}
            </div>
            <div style={{ fontWeight: 900, fontSize: 24, lineHeight: 1.2 }}>{isAU ? `Total ${formatMoney(selectedOrder.total, tenantProfile?.marketId)}` : `合計 ${formatMoney(selectedOrder.total, tenantProfile?.marketId)}`}</div>
          </div>
        </div>

        {/* ボタン群 */}
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", borderTop: "1px solid #f3f4f6", paddingTop: 12 }}>
          {isUnconfirmedLocal && (
            <button
              onClick={() => {
                if (isConfirmingThisOrder) return;
                if (hasMissingCost) {
                  const editLines = linesLocal.map(l => {
                    const cp = Number(l.costPrice ?? 0); const p = Number(l.price ?? 0);
                    const effectivePrice = cp > 0 ? cp : p;
                    return { ...l, _editPrice: String(effectivePrice), _wasZero: effectivePrice === 0 };
                  });
                  setPriceCheckModal({ order: selectedOrder, editLines, mode: "confirm" });
                } else { setWhConfirmOpen(true); }
              }}
              disabled={isConfirmingThisOrder}
              style={{ padding: "9px 22px", borderRadius: 8, border: "none", background: isConfirmingThisOrder ? "#999" : (hasMissingCost ? "#f59e0b" : "#111"), color: "white", fontWeight: 900, fontSize: 14, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}
            >{isConfirmingThisOrder
              ? (<><span style={{ display: "inline-block", animation: "spin 0.8s linear infinite" }}>⟳</span>{isAU ? "Confirming…" : "受注確定中…"}</>)
              : (hasMissingCost ? (isAU ? "⚠ Enter cost price to confirm" : "⚠ 原価入力して確定") : (isAU ? "✅ Confirm order" : "✅ 受注確定"))}</button>
          )}
          <button
            onClick={() => (status === "受注確定" || status === "納品書発行") && openDeliveryPrint(selectedOrder)}
            disabled={status !== "受注確定" && status !== "納品書発行"}
            style={{ padding: "9px 18px", borderRadius: 8, border: "1px solid #111", background: (status === "受注確定" || status === "納品書発行") ? "#111" : "#f3f4f6", color: (status === "受注確定" || status === "納品書発行") ? "white" : "#aaa", fontWeight: 900, fontSize: 14, cursor: (status === "受注確定" || status === "納品書発行") ? "pointer" : "not-allowed" }}
          >{isAU ? "🖨 Issue delivery note" : "🖨 納品書発行"}</button>
          <button
            onClick={async () => {
              if (status !== "納品書発行") return;
              // 印刷対象はローカルstateではなく、必ずFirestoreの発行済みドキュメントを読み直す
              // （openPrintDeliveryと同じ理由：発行前の中間状態の金額を印字してしまうのを防ぐ）
              try {
                const snap = await getDoc(doc(db, "orders", selectedOrder.id));
                if (!snap.exists()) { alert(isAU ? "Order not found" : "注文が見つかりませんでした"); return; }
                const issuedDoc = { id: snap.id, ...snap.data() };
                if (issuedDoc.status !== "納品書発行" || !issuedDoc.deliveryNo) {
                  alert(isAU ? "Could not confirm the delivery note was issued. Please try again." : "納品書の発行が確認できませんでした。もう一度お試しください。");
                  return;
                }
                printReceiptPopup(issuedDoc, issuedDoc.deliveryNo, issuedDoc.issuedAt);
              } catch (e) {
                console.error(e);
                alert((isAU ? "Failed to retrieve the issued document. Please try again.\n" : "発行済みの内容を取得できませんでした。もう一度お試しください。\n") + (e?.message || String(e)));
              }
            }}
            disabled={status !== "納品書発行"}
            style={{ padding: "9px 14px", borderRadius: 8, border: "1px solid #d1d5db", background: status === "納品書発行" ? "white" : "#f3f4f6", color: status === "納品書発行" ? "#374151" : "#aaa", fontWeight: 700, fontSize: 13, cursor: status === "納品書発行" ? "pointer" : "not-allowed" }}
          >{isAU ? "📋 Issue receipt" : "📋 受領書発行"}</button>
          <button
            onClick={() => openPickingPrint(selectedOrder)}
            disabled={isConfirmingThisOrder}
            style={{ padding: "9px 14px", borderRadius: 8, border: "1px solid #d1d5db", background: "white", color: isConfirmingThisOrder ? "#aaa" : "#374151", fontWeight: 700, fontSize: 13, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer" }}
          >{isAU ? "📋 Picking list" : "📋 ピッキングリスト"}</button>
          <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
            {/* 2026-08（受注キャンセル機能再設計）：請求済み（billedInvoiceIdあり）の
                注文は、サーバー側assertOrderMutableが必ず拒否するため、事前に
                ボタン自体を非表示にしてユーザーへの無駄なエラー表示を避ける */}
            {status !== "キャンセル" && !selectedOrder?.billedInvoiceId && (
              <button
                onClick={() => { if (isConfirmingThisOrder) return; cancelOrder(selectedOrder.id, selectedOrder.orderNo); setSelectedOrderId(null); }}
                disabled={isConfirmingThisOrder}
                style={{ padding: "9px 14px", borderRadius: 8, border: "1px solid #fca5a5", background: "white", color: isConfirmingThisOrder ? "#f3aaaa" : "#dc2626", fontWeight: 700, fontSize: 13, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer" }}
              >{isAU ? "Cancel" : "キャンセル"}</button>
            )}
          </div>
        </div>
      </div>

      {/* ── 商品明細（4カラムカード） ── */}
      <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: 10, overflow: "hidden" }}>
        {/* カラムヘッダー */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 200px 140px 120px",
          padding: "8px 16px",
          background: "#f9fafb",
          borderBottom: "1px solid #e5e7eb",
          fontSize: 12, fontWeight: 700, color: "#6b7280",
        }}>
          <div>{isAU ? "Product" : "商品情報"}</div>
          <div style={{ textAlign: "center" }}>{isAU ? "Qty" : "数量"}</div>
          <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            <span>{isAU ? "Delivery date" : "予定納品日"}</span>
            {/* 2026-08追加：全商品の納品予定日を一括変更するボタン。誤操作防止のため
                日付選択後に確認ダイアログを出し、明細別変更と明確に区別する */}
            {status !== "納品書発行" && (
              <button
                disabled={isConfirmingThisOrder}
                onClick={() => {
                  if (isConfirmingThisOrder) return;
                  const input = document.createElement("input");
                  input.type = "date";
                  input.style.position = "fixed";
                  input.style.opacity = "0";
                  input.style.pointerEvents = "none";
                  document.body.appendChild(input);
                  input.addEventListener("change", async () => {
                    const newDate = input.value;
                    document.body.removeChild(input);
                    if (!newDate) return;
                    const lines = selectedOrder.lines || [];
                    const targets = lines.filter(l => !l.outOfStock);
                    if (targets.length === 0) return;
                    const ok = window.confirm(isAU
                      ? `Change the delivery date for all ${targets.length} item(s) to ${formatAUDate(newDate)}?`
                      : `全商品（${targets.length}件）の納品予定日を ${formatJPDate(newDate)} に変更します。よろしいですか？`);
                    if (!ok) return;
                    try {
                      const adjustDeliveryDateFn = httpsCallable(functions, "adjustDeliveryDate");
                      // 2026-08修正（Codexレビュー指摘対応MUST-FIX3）：_lineId（id/barcode
                      // 不在時の合成ID）はサーバー側lines[]に存在しないため送らない。
                      // 本物のid/barcodeが無い行はlineId:nullとし、常にindexで照合させる
                      const lineDateAdjustments = targets.map((l) => ({
                        lineId: l.id || l.barcode || null,
                        index: lines.indexOf(l),
                        scheduledDeliveryDate: newDate,
                      }));
                      await adjustDeliveryDateFn({ orderId: selectedOrder.id, lineDateAdjustments });
                      const refreshed = await getDoc(doc(db, "orders", selectedOrder.id));
                      if (refreshed.exists()) {
                        // 2026-08修正（Codexレビュー指摘対応・4ラウンド目）：dateRangeOrdersも
                        // 同時に更新する（期間指定タブから開いた注文の表示が古いまま残る問題の修正）
                        applyOrderPatchToLocalState(selectedOrder.id, { id: refreshed.id, ...refreshed.data() });
                      }
                      showToast(isAU ? "Updated the delivery date for all products" : "全商品の納品予定日を変更しました");
                    } catch (err) {
                      console.error("[deliveryDate bulk] トランザクション失敗:", err);
                      alert((isAU ? "Failed to save: " : "保存に失敗しました：") + err.message);
                    }
                  }, { once: true });
                  input.click();
                }}
                style={{ fontSize: 10, padding: "2px 8px", borderRadius: 4, border: "1px solid #d1d5db", background: isConfirmingThisOrder ? "#f3f4f6" : "white", color: isConfirmingThisOrder ? "#aaa" : "#6b7280", fontWeight: 700, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer" }}
              >{isAU ? "Update all" : "全商品を一括変更"}</button>
            )}
          </div>
          <div style={{ textAlign: "right" }}>{isAU ? "Subtotal" : "小計"}</div>
        </div>

        {linesLocal.length === 0 ? (
          <div style={{ padding: 24, textAlign: "center", color: "#9ca3af" }}>{isAU ? "(No line items)" : "（明細がありません）"}</div>
        ) : linesLocal.map((l, idx) => {
          const qty = Number(l.qty || 0);
          const unit = Number(l.price || 0);
          const rowKey = l._key || `${String(l.id || "")}-${String(l.barcode || "")}-${idx}`;
          // 2026-08修正（Codexレビュー指摘対応MUST-FIX3）：サーバーへ送る識別子は
          // 本物のid/barcodeのみとする（_lineIdはid/barcode不在時にクライアントが
          // 合成するrow${idx}形式のIDで、サーバー側lines[]には存在しないため
          // 照合できない）。本物が無い行はlineId=nullとし、常にidx（配列index）で
          // サーバー側に照合させる
          const lineId = l.id || l.barcode || null;
          // 商品ごとの予定納品日（なければ注文ヘッダーの値を表示）
          const lineDate = l.scheduledDeliveryDate || selectedOrder.scheduledDeliveryDate || "";

          return (
            <div
              key={rowKey}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 200px 140px 120px",
                alignItems: "center",
                padding: "12px 16px",
                borderTop: idx === 0 ? "none" : "1px solid #f3f4f6",
                background: l.outOfStock ? "#eff6ff" : "white",
              }}
            >
              {/* 左：商品情報 */}
              <div style={{ minWidth: 0, paddingRight: 12 }}>
                <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 3 }}>
                  {l.name || (isAU ? "(No product name)" : "（商品名なし）")}
                  {l.outOfStock && (
                    <span style={{ marginLeft: 8, padding: "2px 7px", borderRadius: 4, background: "#fee2e2", color: "#dc2626", fontSize: 11, fontWeight: 900 }}>{isAU ? "Out of stock" : "欠品"}</span>
                  )}
                </div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>
                  {(() => {
                    // 2026-08修正（本番改修：単価表示不整合の是正）：以前はここで
                    // unit（=l.price、金額SSOT上は既に税抜の発注単価）を「税込単価」
                    // として扱い、taxRateで割って税抜へ逆算していた
                    // （unitExTax = Math.round(unit/(1+taxRate))）。price自体が
                    // 既に税抜であるため、この逆算は二重の誤りで、納品書・受注確定
                    // モーダル・getDisplayOrderAmountsが表示する値（例：¥150）より
                    // 常に小さい値（例：¥139）が表示されていた。
                    // 単価の意味を他画面と統一するため、getDisplayOrderAmountsの
                    // 明細（disp.lines[idx]）が持つunitPrice（=l.price、丸めない
                    // 生値）とdisplayTaxRate（SSOTと同じくl.taxRateを一次情報源とする
                    // safeDisplayTaxRateの結果）をそのまま使う。商品マスタのtaxRateを
                    // 優先していた旧ロジックも、発注時点の税率（l.taxRate、SSOTが
                    // 使う値）とズレる可能性があったため廃止する
                    const dispLine = linesLocalDisp[idx];
                    const taxRate = dispLine?.displayTaxRate ?? null;
                    if (taxRate === null) {
                      return [
                        l.barcode && (isAU ? `Barcode: ${l.barcode}` : `JAN: ${l.barcode}`),
                        l.unit && (isAU ? `Unit: ${l.unit}` : `単位: ${l.unit}`),
                        isAU ? "Tax rate error (please check)" : "税率エラー（要確認）",
                      ].filter(Boolean).join("　");
                    }
                    const taxPct = Math.round(taxRate * 100);
                    const unitExTax = dispLine.unitPrice;
                    // 2026-08修正：この税額は明細1行の参考値であり、注文全体で
                    // 確定する税額（getDisplayOrderAmountsのtax8/tax10、行ごとに
                    // 丸めて税率区分ごとに積算した値）とは別物。数量が1ではない
                    // 行では「単価×税率」の参考値と「行金額×税率」の確定値は
                    // 一致しない場合があるため、「単価あたりの参考税額」であることが
                    // 分かる文言にする
                    // 2026-08（Codexレビュー3回目MINOR対応）：以前はMath.round固定で、
                    // AUではA$19.94×10%がA$2.00（正しくはA$1.99）と表示されていた
                    const taxAmtPerUnit = (isAU ? roundAUD : Math.round)(unitExTax * taxRate);
                    return isAU ? [
                      l.barcode && `Barcode: ${l.barcode}`,
                      l.unit && `Unit: ${l.unit}`,
                      unitExTax > 0 && `Ex GST: ${formatMoney(unitExTax, tenantProfile?.marketId)}`,
                      unitExTax > 0 && `GST ${taxPct}% (per unit, indicative): ${formatMoney(taxAmtPerUnit, tenantProfile?.marketId)}`,
                    ].filter(Boolean).join("  ") : [
                      l.barcode && `JAN: ${l.barcode}`,
                      l.unit && `単位: ${l.unit}`,
                      unitExTax > 0 && `税抜: ${formatMoney(unitExTax, tenantProfile?.marketId)}`,
                      unitExTax > 0 && `消費税${taxPct}%(単価あたり参考): ${formatMoney(taxAmtPerUnit, tenantProfile?.marketId)}`,
                    ].filter(Boolean).join("　");
                  })()}
                </div>
              </div>

              {/* 中央：数量調整 */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                {l.outOfStock ? (
                  <span style={{ fontSize: 13, color: "#dc2626", fontWeight: 700 }}>{isAU ? "Not shipped" : "出荷なし"}</span>
                ) : isUnconfirmedLocal ? (
                  <>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <button
                        onClick={() => { setQtyDrafts(p => { const n = {...p}; delete n[rowKey]; return n; }); setOrderLineQty(selectedOrder.id, linesLocal, idx, lineId, Math.max(0, qty - 1)); }}
                        disabled={isConfirmingThisOrder}
                        style={{ width: 44, height: 44, borderRadius: 8, border: "1px solid #d1d5db", background: "white", fontWeight: 600, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer", fontSize: 18, lineHeight: 1, opacity: isConfirmingThisOrder ? 0.5 : 1 }}
                      >−</button>
                      <input
                        value={qtyDrafts[rowKey] !== undefined ? qtyDrafts[rowKey] : qty}
                        onChange={(e) => setQtyDrafts(p => ({ ...p, [rowKey]: e.target.value }))}
                        onBlur={() => { const draft = qtyDrafts[rowKey]; if (draft === undefined) return; setQtyDrafts(p => { const n = {...p}; delete n[rowKey]; return n; }); setOrderLineQty(selectedOrder.id, linesLocal, idx, lineId, draft); }}
                        inputMode="numeric"
                        disabled={isConfirmingThisOrder}
                        style={{ width: 64, height: 44, borderRadius: 8, border: "1px solid #d1d5db", textAlign: "center", fontWeight: 600, fontSize: 18, opacity: isConfirmingThisOrder ? 0.5 : 1 }}
                      />
                      <button
                        onClick={() => { setQtyDrafts(p => { const n = {...p}; delete n[rowKey]; return n; }); setOrderLineQty(selectedOrder.id, linesLocal, idx, lineId, qty + 1); }}
                        disabled={isConfirmingThisOrder}
                        style={{ width: 44, height: 44, borderRadius: 8, border: "1px solid #d1d5db", background: "white", fontWeight: 600, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer", fontSize: 18, lineHeight: 1, opacity: isConfirmingThisOrder ? 0.5 : 1 }}
                      >＋</button>
                    </div>
                    <button
                      onClick={() => markOutOfStock(selectedOrder.id, idx, lineId)}
                      disabled={isConfirmingThisOrder}
                      style={{ padding: "4px 14px", borderRadius: 6, border: "1px solid #fca5a5", background: "#fff5f5", color: "#dc2626", fontWeight: 700, fontSize: 12, cursor: isConfirmingThisOrder ? "not-allowed" : "pointer", opacity: isConfirmingThisOrder ? 0.5 : 1 }}
                    >{isAU ? "Out of stock" : "欠品"}</button>
                  </>
                ) : (
                  <span style={{ fontWeight: 700, fontSize: 18 }}>{qty}</span>
                )}
              </div>

              {/* 予定納品日 */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                <input
                  type="date"
                  value={lineDate}
                  disabled={l.outOfStock || isConfirmingThisOrder}
                  onChange={async (e) => {
                    const newDate = e.target.value;
                    try {
                      // 2026-08修正（本番改修：明細別納品予定日）：この明細行のみを
                      // 更新する。ヘッダーのscheduledDeliveryDateは（以前と異なり）
                      // 自動再計算しない——他の未設定の明細行はこのヘッダー値へ
                      // フォールバック表示するため、ヘッダーが動くと対象外の行の
                      // 表示まで連動して変わって見える不具合があった
                      const adjustDeliveryDateFn = httpsCallable(functions, "adjustDeliveryDate");
                      await adjustDeliveryDateFn({
                        orderId: selectedOrder.id,
                        lineDateAdjustments: [{ lineId, index: idx, scheduledDeliveryDate: newDate }],
                      });
                      // 保存成功後、表示中の注文データを最新状態へ更新。
                      // 2026-08修正（Codexレビュー指摘対応・4ラウンド目）：dateRangeOrdersも
                      // 同時に更新する（期間指定タブから開いた注文の表示が古いまま残る問題の修正）
                      const refreshed = await getDoc(doc(db, "orders", selectedOrder.id));
                      if (refreshed.exists()) {
                        applyOrderPatchToLocalState(selectedOrder.id, { id: refreshed.id, ...refreshed.data() });
                      }
                    } catch (err) {
                      console.error("[deliveryDate] トランザクション失敗:", err);
                      alert((isAU ? "Failed to save: " : "保存に失敗しました：") + err.message);
                    }
                  }}
                  style={{
                    fontSize: 12, border: "1px solid #d1d5db", borderRadius: 6,
                    padding: "4px 6px", color: "#1a56db", fontWeight: 700,
                    cursor: (l.outOfStock || isConfirmingThisOrder) ? "not-allowed" : "pointer",
                    background: (l.outOfStock || isConfirmingThisOrder) ? "#f3f4f6" : "white",
                    width: 120,
                  }}
                />
                {!l.scheduledDeliveryDate && selectedOrder.scheduledDeliveryDate && (
                  <div style={{ fontSize: 10, color: "#9ca3af" }}>{isAU ? "Header value" : "ヘッダー値"}</div>
                )}
              </div>

              {/* 右：小計 */}
              <div style={{ textAlign: "right", fontWeight: 900, fontSize: 16, color: l.outOfStock ? "#9ca3af" : "#111" }}>
                {l.outOfStock ? "—" : formatMoney(qty * unit, tenantProfile?.marketId)}
              </div>
            </div>
          );
        })}

        {/* 合計フッター */}
        {linesLocal.length > 0 && (
          <div style={{
            borderTop: "2px solid #e5e7eb", padding: "12px 16px",
            background: "#f9fafb", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 20,
          }}>
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              {isAU
                ? `Subtotal ${formatMoney(selectedOrder.subtotal || 0, tenantProfile?.marketId)} / GST ${formatMoney(selectedOrder.tax || 0, tenantProfile?.marketId)}`
                : `小計 ${formatMoney(selectedOrder.subtotal || 0, tenantProfile?.marketId)} ／ 消費税 ${formatMoney(selectedOrder.tax || 0, tenantProfile?.marketId)}`}
            </span>
            <span style={{ fontWeight: 900, fontSize: 18 }}>{isAU ? `Total ${formatMoney(selectedOrder.total, tenantProfile?.marketId)}` : `合計 ${formatMoney(selectedOrder.total, tenantProfile?.marketId)}`}</span>
          </div>
        )}
      </div>

      {/* 下部：一覧に戻るボタン */}
      <div style={{ paddingTop: 8, paddingBottom: 24 }}>
        <button
          onClick={handleBackToList}
          style={{ width: "100%", padding: "14px", borderRadius: 10, border: "1px solid #e5e7eb", background: "white", color: "#374151", fontWeight: 700, fontSize: 15, cursor: "pointer" }}
        >{isAU ? "← Back to order list" : "← 受注一覧に戻る"}</button>
      </div>
    </div>
  );
})()}



{/* ===== products（卸 商品登録） ===== */}
{mode === "wholesale" && wholesaleView === "products" && (
  <div style={{ display: "grid", gap: 12, maxWidth: 920 }}>
    {/* ヘッダー */}
    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "Product catalogue" : "商品マスタ（卸）"}</div>

      <div style={{ fontSize: 12, opacity: 0.7 }}>
        {isAU ? `Your products (ID: ${String(tenantId || "")})` : `管理対象：自社商品（ID: ${String(tenantId || "")})`}
      </div>

      {/* 2026-08 商品検索不具合修正（Codexレビュー指摘対応・MUST-FIX）：
          既存商品（この修正より前に登録された商品）は検索用フィールド
          （nameNormalized/searchTokens）を持たないため、通常一覧・検索で
          実際に読み込まれるまで商品名検索から漏れ続ける。ユーザー自身の
          操作で自テナントの全商品ページを確実に走査し、不足分だけを
          updateDocで補完するツールとして提供する */}
      <button
        type="button"
        disabled={searchBackfillState.running}
        onClick={() => {
          if (!tenantId) { showToast(isAU ? "Business not set up yet" : "会社（tenant）が未設定です"); return; }
          if (searchBackfillState.running) return;
          if (!window.confirm(isAU
            ? "This will repair search data for all your products.\nAny products that don't show up in name search will be fixed automatically.\nThis may take a while if you have many products. Continue?"
            : "検索用データを一括修復します。\n自社の全商品を確認し、商品名検索でヒットしない商品があれば自動的に修復します。\n件数が多い場合は時間がかかることがあります。続行しますか？")) return;
          runProductSearchFieldsBackfill();
        }}
        style={{
          padding: "10px 16px",
          borderRadius: 12,
          border: "1px solid #ddd",
          background: searchBackfillState.running ? "#f3f4f6" : "white",
          color: "#374151",
          fontWeight: 900,
          fontSize: 14,
          cursor: searchBackfillState.running ? "not-allowed" : "pointer",
          display: "flex", alignItems: "center", gap: 6,
        }}
        title={isAU ? "Run this if older products don't show up in name search" : "商品名検索でヒットしない旧商品がある場合に実行してください"}
      >
        {searchBackfillState.running
          ? (isAU
              ? `🔧 Repairing… (checked ${searchBackfillState.done}, fixed ${searchBackfillState.fixed}${searchBackfillState.failed > 0 ? `, failed ${searchBackfillState.failed}` : ""})`
              : `🔧 修復中…（${searchBackfillState.done}件確認・${searchBackfillState.fixed}件修復${searchBackfillState.failed > 0 ? `・${searchBackfillState.failed}件失敗` : ""}）`)
          : (isAU ? "🔧 Repair search data" : "🔧 検索用データを一括修復")}
      </button>

      {!searchBackfillState.running && searchBackfillState.error && (
        <div style={{ fontSize: 12, color: "#b91c1c", fontWeight: 700 }}>
          {isAU ? `Repair error: ${searchBackfillState.error}` : `一括修復エラー: ${searchBackfillState.error}`}
        </div>
      )}
      {!searchBackfillState.running && !searchBackfillState.error && searchBackfillState.failed > 0 && (
        <div style={{ fontSize: 12, color: "#b91c1c", fontWeight: 700 }}>
          {isAU
            ? `${searchBackfillState.failed} product(s) couldn't be repaired due to a tax rate or connection issue. Please check them in the product edit screen and try again.`
            : `${searchBackfillState.failed}件の商品は税率などの設定、または通信・権限上の問題により修復できませんでした。商品編集画面で内容をご確認のうえ再実行してください`}
        </div>
      )}

      <div style={{ marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap" }}>
 <button
  type="button"
  onClick={() => {
    if (!tenantId) {
      showToast(isAU ? "Business not set up yet" : "会社（tenant）が未設定です");
      return;
    }
    setCsvTarget("wholesale");
    importFileRef.current?.click();
  }}
  style={{
    padding: "10px 16px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg,#16a34a,#15803d)",
    color: "white",
    fontWeight: 900,
    fontSize: 14,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(22,163,74,0.35)",
    display: "flex", alignItems: "center", gap: 6,
  }}
>
  {isAU ? "📥 Import Excel" : "📥 Excel取り込み"}
</button>
<button
  type="button"
  onClick={async () => {
    showToast(isAU ? "Loading..." : "取得中...");
    try {
      const snap = await getDocs(query(collection(db, "products"), where("tenantId", "==", tenantId), orderBy("name")));
      const all = snap.docs.map(d => ({ ...d.data(), id: d.id }));
      if (all.length === 0) { showToast(isAU ? "No products to download" : "ダウンロードする商品がありません"); return; }
      downloadProductsAsExcel(all, isAU ? "product_catalogue.xlsx" : "商品マスタ_卸.xlsx", tenantProfile?.marketId);
      showToast(isAU ? `Downloaded ${all.length} products` : `${all.length}件をダウンロードしました`);
    } catch(e) { showToast((isAU ? "Download error: " : "取得エラー: ") + e.message); }
  }}
  style={{
    padding: "10px 16px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    color: "white",
    fontWeight: 900,
    fontSize: 14,
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(37,99,235,0.35)",
    display: "flex", alignItems: "center", gap: 6,
  }}
>
  {isAU ? "📤 Export Excel" : "📤 Excel DL"}
</button>

{isAU ? (
  // 2026-08 AU版基盤（Phase 3）：AU向けの固定フォーマットファイルは用意していない
  // （日本版は/public配下に静的な.xlsxを置いている）。代わりに、GST 10%商品・
  // GST-free商品のサンプル行とGetting startedシート（概念説明）を持つテンプレートを
  // downloadAuProductImportTemplateでその場で生成する
  <button
    type="button"
    onClick={() => downloadAuProductImportTemplate("product_import_template.xlsx")}
    style={{
      padding: "10px 16px",
      borderRadius: 12,
      border: "1px solid #16a34a",
      background: "white",
      color: "#16a34a",
      fontWeight: 900,
      fontSize: 14,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: 6,
      whiteSpace: "nowrap",
    }}
  >
    📋 Download template
  </button>
) : (
  <a
    href="/商品マスタ登録フォーマット.xlsx"
    download="商品マスタ登録フォーマット.xlsx"
    style={{
      padding: "10px 16px",
      borderRadius: 12,
      border: "1px solid #16a34a",
      background: "white",
      color: "#16a34a",
      fontWeight: 900,
      fontSize: 14,
      cursor: "pointer",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      gap: 6,
      whiteSpace: "nowrap",
    }}
  >
    📋 フォーマットDL
  </a>
)}

        <button
          onClick={openAddProductWholesale}
          style={{
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid #111",
            fontWeight: 900,
            background: "#111",
            color: "white",
          }}
        >
          {isAU ? "+ Add product" : "＋ 商品追加"}
        </button>
      </div>
    </div>

    {/* 検索バー */}
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <input
        type="text"
        placeholder={isAU ? "Search by product name or barcode..." : "商品名・JANコードで検索..."}
        value={wholesaleMasterSearch}
        onChange={(e) => { setWholesaleMasterSearch(e.target.value); setWholesaleMasterPage(1); }}
        style={{ flex: 1, minWidth: 160, padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontSize: 14 }}
      />
      {wholesaleMasterSearch && (
        <button
          onClick={() => { setWholesaleMasterSearch(""); setWholesaleMasterPage(1); }}
          style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer" }}
        >
          {isAU ? "Clear" : "クリア"}
        </button>
      )}
      <div style={{ fontSize: 12, opacity: 0.7 }}>
        {isAU ? (
          isWholesaleMasterBarcodeMode
            ? `Barcode search results: ${wholesaleMasterBarcodeResults.length}`
            : isWholesaleMasterNameSearchMode
              ? `Search results: ${wholesaleMasterSearchResults.length}${wholesaleMasterSearchHasMore ? "+" : ""}`
              : `Total: ${wholesaleMasterProducts.length}${wholesaleMasterHasMore ? "+" : ""}`
        ) : (
          isWholesaleMasterBarcodeMode
            ? `JAN検索結果: ${wholesaleMasterBarcodeResults.length}件`
            : isWholesaleMasterNameSearchMode
              ? `検索結果: ${wholesaleMasterSearchResults.length}件${wholesaleMasterSearchHasMore ? "以上" : ""}`
              : `全${wholesaleMasterProducts.length}件${wholesaleMasterHasMore ? "以上" : ""}`
        )}
      </div>
    </div>

    {/* エラー表示・再試行（一覧領域のみ、全画面オーバーレイは使わない） */}
    {isWholesaleMasterBarcodeMode && wholesaleMasterBarcodeError && (
      <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, padding: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div style={{ color: "#b91c1c", fontSize: 13, fontWeight: 700 }}>{isAU ? "Barcode search failed" : "JANコード検索に失敗しました"}</div>
        <button
          onClick={() => setWholesaleMasterBarcodeRetryTick((t) => t + 1)}
          style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #b91c1c", color: "#b91c1c", background: "white", fontWeight: 900, cursor: "pointer" }}
        >
          {isAU ? "Retry" : "再試行"}
        </button>
      </div>
    )}
    {isWholesaleMasterNameSearchMode && wholesaleMasterSearchError && (
      <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, padding: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div style={{ color: "#b91c1c", fontSize: 13, fontWeight: 700 }}>
          {isAU
            ? (wholesaleMasterSearchFailedOnLoadMoreRef.current ? "Failed to load more search results" : "Product name search failed")
            : (wholesaleMasterSearchFailedOnLoadMoreRef.current ? "追加の検索結果取得に失敗しました" : "商品名検索に失敗しました")}
        </div>
        <button
          onClick={() => loadWholesaleMasterSearchPage(wholesaleMasterSearchTrimmed, { isFirstPage: !wholesaleMasterSearchFailedOnLoadMoreRef.current })}
          style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #b91c1c", color: "#b91c1c", background: "white", fontWeight: 900, cursor: "pointer" }}
        >
          {isAU ? "Retry" : "再試行"}
        </button>
      </div>
    )}
    {!isWholesaleMasterBarcodeMode && !isWholesaleMasterNameSearchMode && wholesaleMasterError && (
      <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 12, padding: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div style={{ color: "#b91c1c", fontSize: 13, fontWeight: 700 }}>
          {isAU
            ? (wholesaleMasterFailedOnLoadMoreRef.current ? "Failed to load more products" : "Failed to load product list")
            : (wholesaleMasterFailedOnLoadMoreRef.current ? "追加の商品取得に失敗しました" : "商品一覧の取得に失敗しました")}
        </div>
        <button
          onClick={() => wholesaleMasterFailedOnLoadMoreRef.current
            ? loadWholesaleMasterPage({ isFirstPage: false })
            : loadWholesaleMasterPage({ isFirstPage: true, forceReset: true })}
          style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #b91c1c", color: "#b91c1c", background: "white", fontWeight: 900, cursor: "pointer" }}
        >
          {isAU ? "Retry" : "再試行"}
        </button>
      </div>
    )}

    {/* 初期読み込み中：一覧領域だけにローディング表示（全画面オーバーレイは使わない） */}
    {((isWholesaleMasterBarcodeMode && wholesaleMasterBarcodeLoading) ||
      (isWholesaleMasterNameSearchMode && wholesaleMasterSearchLoading) ||
      (!isWholesaleMasterBarcodeMode && !isWholesaleMasterNameSearchMode && wholesaleMasterLoading)) && (
      <div style={{ textAlign: "center", padding: "24px 0", opacity: 0.6, fontSize: 13 }}>{isAU ? "Loading…" : "読み込み中…"}</div>
    )}

    {/* 一覧 */}
    <div style={{ display: "grid", gap: 8 }}>
      {(!((isWholesaleMasterBarcodeMode && wholesaleMasterBarcodeLoading) ||
        (isWholesaleMasterNameSearchMode && wholesaleMasterSearchLoading) ||
        (!isWholesaleMasterBarcodeMode && !isWholesaleMasterNameSearchMode && wholesaleMasterLoading))) &&
      wholesaleProductsFiltered.length === 0 ? (
        <div style={{ opacity: 0.7 }}>
          {isAU
            ? (isWholesaleMasterBarcodeMode || isWholesaleMasterNameSearchMode
                ? `No products match "${wholesaleMasterSearch}"`
                : "(No products yet. Use \"+ Add product\" above to register one.)")
            : (isWholesaleMasterBarcodeMode || isWholesaleMasterNameSearchMode
                ? `「${wholesaleMasterSearch}」に一致する商品はありません`
                : "（商品はまだありません。右上の「＋商品追加」から登録してください）")}
        </div>
      ) : (
        wholesaleProductsPaged.map((p) => (
          <div
            key={p.id}
            style={{
              border: "1px solid #eee",
              borderRadius: 14,
              padding: 12,
              background: "white",
              display: "grid",
              gap: 8,
            }}
          >
            {/* 上段：商品名・JAN */}
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{ fontWeight: 900 }}>{p.name}</div>
              <div style={{ opacity: 0.6, fontSize: 12 }}>
                {isAU
                  ? (p.barcode ? `Barcode: ${p.barcode}` : "No barcode")
                  : (p.barcode ? `JAN: ${p.barcode}` : "JANなし")}
              </div>
            </div>

            {/* 下段：価格・税率・単位 */}
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
              {/* 発注単価（税抜） */}
              <div style={{ fontSize: 13 }}>
                <span style={{ color: "#94a3b8", fontSize: 11, marginRight: 4 }}>{isAU ? "Cost price (ex GST)" : "発注単価（税抜）"}</span>
                {getCostPriceStrict(p) <= 0 ? (
                  <span style={{ color: "#b45309", fontWeight: 700 }}>{isAU ? "Not set" : "未登録"}</span>
                ) : (
                  <span style={{ fontWeight: 900 }}>{formatMoney(getCostPriceStrict(p), tenantProfile?.marketId)}</span>
                )}
              </div>

              {/* 発注単価（税込）*/}
              {getCostPriceStrict(p) > 0 && (
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  {safeDisplayTaxRate(p.taxRate, resolveTaxPolicy(tenantProfile?.marketId)) === null
                    ? <span style={{ color: "#dc2626" }}>{isAU ? "Can't show price inc GST due to a tax rate error" : "税率エラーのため税込価格を表示できません"}</span>
                    : (isAU
                        ? `inc GST ${formatMoney(roundAUD(getCostPriceStrict(p) * (1 + safeDisplayTaxRate(p.taxRate, resolveTaxPolicy(tenantProfile?.marketId)))), tenantProfile?.marketId)}`
                        : `税込 ${yen(Math.round(getCostPriceStrict(p) * (1 + safeDisplayTaxRate(p.taxRate))))}`)}
                </div>
              )}

              {/* 小売販売価格（任意）*/}
              {(p.sellPriceInc > 0 || p.sellPrice > 0) && (
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  <span style={{ color: "#94a3b8", fontSize: 11, marginRight: 4 }}>{isAU ? "Retail sell price" : "小売販売価格"}</span>
                  {p.sellPriceInc > 0 || safeDisplayTaxRate(p.taxRate, resolveTaxPolicy(tenantProfile?.marketId)) !== null
                    ? formatMoney(p.sellPriceInc > 0 ? p.sellPriceInc : (isAU ? roundAUD : Math.round)(p.sellPrice * (1 + safeDisplayTaxRate(p.taxRate, resolveTaxPolicy(tenantProfile?.marketId)))), tenantProfile?.marketId)
                    : <span style={{ color: "#dc2626" }}>{isAU ? "Tax rate error" : "税率エラー"}</span>}
                  <span style={{ fontSize: 10, color: "#94a3b8", marginLeft: 2 }}>{isAU ? "inc GST" : "税込"}</span>
                </div>
              )}

              <div style={{ fontSize: 12, color: "#64748b" }}>
                {isAU ? "Unit: " : "単位："}<b>{p.unit || (isAU ? "" : "個")}</b>
              </div>

              <div style={{ fontSize: 12, color: "#64748b" }}>
                {isAU ? "GST: " : "税率："}
                <b>
                  {safeDisplayTaxRate(p.taxRate, resolveTaxPolicy(tenantProfile?.marketId)) === 0
                    ? (isAU ? "GST-free" : "非課税")
                    : <TaxRateBadge rawTaxRate={p.taxRate} isAU={isAU} />}
                </b>
              </div>

              <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                <button
                  onClick={() => openEditProduct(p)}
                  style={{
                    padding: "8px 10px",
                    borderRadius: 10,
                    border: "1px solid #111",
                    fontWeight: 900,
                    background: "white",
                  }}
                >
                  {isAU ? "Edit" : "編集"}
                </button>

                <button
                  onClick={() => deleteProduct(p.id)}
                  style={{
                    padding: "8px 10px",
                    borderRadius: 10,
                    border: "1px solid #ddd",
                    fontWeight: 900,
                    background: "white",
                  }}
                >
                  {isAU ? "Delete" : "削除"}
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>

    {/* ページング（読み込み済み分のクライアント側300件区切り。検索なし時のみ表示） */}
    {!isWholesaleMasterBarcodeMode && !isWholesaleMasterNameSearchMode && wholesaleTotalPages > 1 && (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, padding: "12px 0" }}>
        <button
          onClick={() => setWholesaleMasterPage(p => Math.max(1, p - 1))}
          disabled={wholesaleMasterPage === 1}
          style={{ padding: "8px 16px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, cursor: wholesaleMasterPage === 1 ? "default" : "pointer", opacity: wholesaleMasterPage === 1 ? 0.4 : 1, background: "white" }}
        >
          {isAU ? "◀ Prev" : "◀ 前へ"}
        </button>
        <div style={{ fontSize: 13, fontWeight: 700 }}>
          {isAU ? (
            <>
              Page {wholesaleMasterPage} / {wholesaleTotalPages}
              <span style={{ fontWeight: 400, opacity: 0.6, marginLeft: 8 }}>
                ({(wholesaleMasterPage - 1) * PRODUCTS_PER_PAGE + 1}–{Math.min(wholesaleMasterPage * PRODUCTS_PER_PAGE, wholesaleProductsFiltered.length)})
              </span>
            </>
          ) : (
            <>
              {isAU ? `Page ${wholesaleMasterPage} / ${wholesaleTotalPages}` : `${wholesaleMasterPage} / ${wholesaleTotalPages} ページ`}
              <span style={{ fontWeight: 400, opacity: 0.6, marginLeft: 8 }}>
                {isAU
                  ? `(${(wholesaleMasterPage - 1) * PRODUCTS_PER_PAGE + 1}-${Math.min(wholesaleMasterPage * PRODUCTS_PER_PAGE, wholesaleProductsFiltered.length)})`
                  : `(${(wholesaleMasterPage - 1) * PRODUCTS_PER_PAGE + 1}〜${Math.min(wholesaleMasterPage * PRODUCTS_PER_PAGE, wholesaleProductsFiltered.length)}件)`}
              </span>
            </>
          )}
        </div>
        <button
          onClick={() => setWholesaleMasterPage(p => Math.min(wholesaleTotalPages, p + 1))}
          disabled={wholesaleMasterPage === wholesaleTotalPages}
          style={{ padding: "8px 16px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, cursor: wholesaleMasterPage === wholesaleTotalPages ? "default" : "pointer", opacity: wholesaleMasterPage === wholesaleTotalPages ? 0.4 : 1, background: "white" }}
        >
          {isAU ? "Next ▶" : "次へ ▶"}
        </button>
      </div>
    )}

    {/* もっと見る：通常一覧（Firestoreから次の500件を取得。下部だけローディング表示、
        既存の表示済み商品は消さない） */}
    {!isWholesaleMasterBarcodeMode && !isWholesaleMasterNameSearchMode && wholesaleMasterHasMore && (
      <div style={{ textAlign: "center", padding: "12px 0" }}>
        <button
          onClick={() => loadWholesaleMasterPage({ isFirstPage: false })}
          disabled={wholesaleMasterLoadingMore}
          style={{ padding: "10px 20px", borderRadius: 10, border: "1px solid #111", fontWeight: 900, background: "white", cursor: wholesaleMasterLoadingMore ? "default" : "pointer", opacity: wholesaleMasterLoadingMore ? 0.6 : 1 }}
        >
          {isAU ? (wholesaleMasterLoadingMore ? "Loading…" : "Load more") : (wholesaleMasterLoadingMore ? "読み込み中…" : "もっと見る")}
        </button>
      </div>
    )}

    {/* もっと見る：商品名検索結果（大量ヒット時にDOMを一度に大量生成しないための追加取得） */}
    {isWholesaleMasterNameSearchMode && wholesaleMasterSearchHasMore && (
      <div style={{ textAlign: "center", padding: "12px 0" }}>
        <button
          onClick={() => loadWholesaleMasterSearchPage(wholesaleMasterSearchTrimmed, { isFirstPage: false })}
          disabled={wholesaleMasterSearchLoadingMore}
          style={{ padding: "10px 20px", borderRadius: 10, border: "1px solid #111", fontWeight: 900, background: "white", cursor: wholesaleMasterSearchLoadingMore ? "default" : "pointer", opacity: wholesaleMasterSearchLoadingMore ? 0.6 : 1 }}
        >
          {isAU ? (wholesaleMasterSearchLoadingMore ? "Loading…" : "Load more") : (wholesaleMasterSearchLoadingMore ? "読み込み中…" : "もっと見る")}
        </button>
      </div>
    )}
  </div>
)}



          {/* ===== 卸 設定 ===== */}
          {mode === "wholesale" && wholesaleView === "settings" && (() => {
            const settingCard = {
              background: "white",
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              padding: "24px 28px",
              textAlign: "left",
              cursor: "pointer",
              transition: "all 0.15s",
              display: "flex",
              alignItems: "center",
              gap: 20,
              width: "100%",
            };
            const hoverOn  = e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)"; };
            const hoverOff = e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; };
            const categoryLabel = (icon, label) => (
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
                <span style={{ fontSize: 15 }}>{icon}</span>
                <span style={{ fontSize: 12, fontWeight: 900, color: "#64748b", letterSpacing: 1 }}>{label}</span>
                <div style={{ flex: 1, height: 1, background: "#e5e7eb" }} />
              </div>
            );
            return (
              <div style={{ display: "grid", gap: 16, maxWidth: 1100, margin: "0 auto" }}>

                {/* ページタイトル
                    2026-08（Step 12 E2E検証時に発覚したバグ対応）：Settings画面
                    全体がisAU分岐なしで完全に日本語ハードコードされていた */}
                <div>
                  <div style={{ fontWeight: 900, fontSize: 18 }}>{isAU ? "Settings" : "設定"}</div>
                  <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 4 }}>{isAU ? "Business details, connections, and customers" : "会社情報・接続・取引先の管理"}</div>
                </div>

                {/* 基本設定 */}
                {categoryLabel("🏢", isAU ? "General" : "基本設定")}
                <button
                  onClick={() => setTenantOpen(true)}
                  style={settingCard}
                  onMouseEnter={hoverOn} onMouseLeave={hoverOff}
                >
                  <div style={{ fontSize: 32 }}>🏢</div>
                  <div>
                    <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Business details" : "会社情報"}</div>
                    <div style={{ fontSize: 13, color: "#94a3b8" }}>{isAU ? "Business name, address, ABN, reporting settings" : "会社名・住所・インボイス番号・集計基準の設定"}</div>
                  </div>
                  <div style={{ marginLeft: "auto", color: "#cbd5e1", fontSize: 18 }}>›</div>
                </button>

                {/* 受注・納品設定 */}
                {categoryLabel("📦", isAU ? "Orders & Delivery" : "受注・納品設定")}
                <button
                  onClick={() => {
                    const p = tenantProfile || {};
                    setDsLeadDays(p.leadDays ?? 0);
                    setDsCutoffTime(p.cutoffTime ?? "");
                    setDsClosedWeekdays(p.closedWeekdays ?? []);
                    setDsHolidayDates(p.holidayDates ?? []);
                    setDsHolidayInput("");
                    setDsSaved(false);
                    setDsHolidayYear(new Date().getFullYear());
                    setDsHolidayAddMsg("");
                    setDeliverySettingsOpen(true);
                  }}
                  style={settingCard}
                  onMouseEnter={hoverOn} onMouseLeave={hoverOff}
                >
                  <div style={{ fontSize: 32 }}>📦</div>
                  <div>
                    <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Delivery settings" : "納品日設定"}</div>
                    <div style={{ fontSize: 13, color: "#94a3b8" }}>{isAU ? "Lead time, order cutoff, closed days, individual holidays" : "リード日数・注文締め時間・定休日・個別休業日"}</div>
                  </div>
                  <div style={{ marginLeft: "auto", color: "#cbd5e1", fontSize: 18 }}>›</div>
                </button>

                {/* 接続管理 */}
                {categoryLabel("🔗", isAU ? "Connections" : "接続管理")}
                <button
                  onClick={() => setWholesaleView("connection")}
                  style={settingCard}
                  onMouseEnter={hoverOn} onMouseLeave={hoverOff}
                >
                  <div style={{ fontSize: 32 }}>🔗</div>
                  <div>
                    <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Connection / Invite code" : "接続・招待コード"}</div>
                    <div style={{ fontSize: 13, color: "#94a3b8" }}>{isAU ? "View invite code for retailers, generate QR code, invite staff" : "小売店への招待コード確認・QR発行・スタッフ招待"}</div>
                  </div>
                  <div style={{ marginLeft: "auto", color: "#cbd5e1", fontSize: 18 }}>›</div>
                </button>

                {/* 取引先管理 */}
                {categoryLabel("👥", isAU ? "Customers" : "取引先管理")}
                <button
                  onClick={() => setWholesaleView("suppliers")}
                  style={settingCard}
                  onMouseEnter={hoverOn} onMouseLeave={hoverOff}
                >
                  <div style={{ fontSize: 32 }}>👥</div>
                  <div>
                    <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>{isAU ? "Manage customers" : "取引先（小売店）管理"}</div>
                    <div style={{ fontSize: 13, color: "#94a3b8" }}>{isAU ? "Add, edit, or remove phone/fax order customers" : "FAX・電話注文先の登録・編集・削除"}</div>
                  </div>
                  <div style={{ marginLeft: "auto", color: "#cbd5e1", fontSize: 18 }}>›</div>
                </button>

              </div>
            );
          })()}

          {/* ===== 卸 接続・招待コード ===== */}
          {mode === "wholesale" && wholesaleView === "connection" && (
            <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gap: 20 }}>

              {/* ページタイトル
                  2026-08（Step 12 E2E検証時に発覚したバグ対応）：招待コード画面
                  全体がisAU分岐なしで完全に日本語ハードコードされていた */}
              <div>
                <div style={{ fontWeight: 900, fontSize: 18 }}>{isAU ? "Connection / Invite code" : "接続・招待コード"}</div>
                <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 4 }}>{isAU ? "Invite retailers to start ordering" : "小売店を招待して受発注を開始します"}</div>
              </div>

              {/* 2カラムレイアウト */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, alignItems: "start" }}>

                {/* 左カラム：招待フロー */}
                <div style={{ display: "grid", gap: 16 }}>

                  {/* STEP 1 */}
                  <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: 12, padding: "24px 24px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                      <div style={{ background: "#1e293b", color: "white", borderRadius: 999, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 13, flexShrink: 0 }}>1</div>
                      <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Invite a retailer" : "小売店を招待する"}</div>
                    </div>

                    {/* QRコード（推奨・メイン） */}
                    <button
                      onClick={() => setShowQRModal(true)}
                      style={{ width: "100%", background: "#1e293b", border: "2px solid #1e293b", borderRadius: 12, padding: "18px 20px", textAlign: "left", cursor: "pointer", display: "flex", alignItems: "center", gap: 14, transition: "all 0.15s", color: "white" }}
                      onMouseEnter={e => { e.currentTarget.style.background = "#334155"; e.currentTarget.style.borderColor = "#334155"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "#1e293b"; e.currentTarget.style.borderColor = "#1e293b"; }}
                    >
                      <span style={{ fontSize: 28 }}>📱</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                          <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Invite via QR code" : "QRコードで招待"}</div>
                          <span style={{ background: "#16a34a", color: "white", fontSize: 10, fontWeight: 900, padding: "2px 8px", borderRadius: 999, letterSpacing: 1 }}>{isAU ? "Recommended" : "推奨"}</span>
                        </div>
                        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.65)" }}>{isAU ? "Just scan with a phone — no code to type" : "スマホで読み取るだけ・コード入力不要"}</div>
                      </div>
                    </button>

                    {/* QR招待の手順 */}
                    <div style={{ background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 10, padding: "10px 14px", fontSize: 12, color: "#1e293b", lineHeight: 2.2 }}>
                      {isAU ? (
                        <>
                          ① Show the QR code using the button above<br />
                          ② The retailer scans it with their phone<br />
                          ③ They sign up — connection completes automatically<br />
                          ④ They can start ordering the same day
                        </>
                      ) : (
                        <>
                          ① 上のボタンからQRコードを表示<br />
                          ② 小売店のスマホで読み取る<br />
                          ③ そのまま新規登録 → 自動で接続完了<br />
                          ④ その日から発注できる
                        </>
                      )}
                    </div>

                    {/* 招待コード（サブ） */}
                    <div style={{ marginTop: 4 }}>
                      <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 8 }}>{isAU ? "Or send the invite code by email/text" : "または招待コードをLINE・メールで送る"}</div>
                      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        <div style={{ flex: 1, background: "#f8fafc", border: "1px solid #e5e7eb", color: "#1e293b", padding: "12px 14px", borderRadius: 10, fontSize: 22, fontWeight: 900, letterSpacing: 8, fontFamily: "monospace", textAlign: "center" }}>
                          {tenantProfile?.inviteCode || "--------"}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          <button
                            onClick={() => { navigator.clipboard.writeText(tenantProfile?.inviteCode || ""); showToast(isAU ? "Copied" : "コピーしました"); }}
                            style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid #e5e7eb", background: "white", fontWeight: 900, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}
                          >
                            {isAU ? "📋 Copy" : "📋 コピー"}
                          </button>
                          <button
                            onClick={async () => {
                              if (!window.confirm(isAU ? "Regenerate the invite code?\nExisting connections will not be affected." : "招待コードを再生成しますか？\n既存の接続には影響しません。")) return;
                              try {
                                // コード生成・衝突検査・旧コード削除はrotateInviteCode Callableが行う
                                const rotateInviteCodeFn = httpsCallable(functions, "rotateInviteCode");
                                const result = await rotateInviteCodeFn({});
                                const newCode = result?.data?.inviteCode;
                                if (newCode) setTenantProfile(p => ({ ...(p || {}), inviteCode: newCode }));
                                showToast(isAU ? "Invite code regenerated" : "招待コードを再生成しました");
                              } catch (e) {
                                console.error(e);
                                alert(e?.message || e);
                              }
                            }}
                            style={{ padding: "7px 12px", borderRadius: 8, border: "1px solid #e5e7eb", background: "white", fontWeight: 700, fontSize: 11, cursor: "pointer", color: "#94a3b8" }}
                          >
                            {isAU ? "🔄 Regenerate" : "🔄 再生成"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* STEP 2 */}
                  <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: 12, padding: "24px 24px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                      <div style={{ background: "#1e293b", color: "white", borderRadius: 999, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 13, flexShrink: 0 }}>2</div>
                      <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "The retailer joins" : "小売店が参加する"}</div>
                    </div>
                    <div style={{ fontSize: 13, color: "#475569", marginBottom: 12 }}>
                      {isAU ? "Share these steps with the retailer:" : "小売店に以下の手順を伝えてください："}
                    </div>
                    <div style={{ background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 10, padding: "10px 14px", fontSize: 12, color: "#1e293b", lineHeight: 2.2 }}>
                      {isAU ? (
                        <>
                          ① Go to app.order-link.info<br />
                          ② Sign up with an email address<br />
                          ③ Choose "I'm a retailer"<br />
                          ④ Choose "Join with invite code" and enter the code above<br />
                          ⑤ Connected — they can start ordering the same day
                        </>
                      ) : (
                        <>
                          ① app.order-link.info を開く<br />
                          ② メールアドレスで新規登録<br />
                          ③「小売として使う」を選ぶ<br />
                          ④「接続コードで参加」を選び、上のコードを入力する<br />
                          ⑤ 接続完了・その日から発注できる
                        </>
                      )}
                    </div>
                    <div style={{ marginTop: 12, fontSize: 12, color: "#94a3b8" }}>
                      {isAU ? "* Free for retailers, always" : "※ 小売店の利用料はずっと無料です"}
                    </div>
                  </div>

                  {/* 社内スタッフ追加（下部） */}
                  <div style={{ background: "#f0f7ff", border: "1px solid #bfdbfe", borderRadius: 12, padding: "20px 24px" }}>
                    <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 12, color: "#1e40af" }}>{isAU ? "👥 Add a staff member" : "👥 社内スタッフを追加する"}</div>
                    <div style={{ fontSize: 13, color: "#475569", marginBottom: 12, lineHeight: 1.8 }}>
                      {isAU ? "Share these steps with your staff member:" : "スタッフに以下の手順を伝えてください："}<br />
                      <span style={{ display: "inline-block", marginTop: 6, background: "white", border: "1px solid #bfdbfe", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#1e40af", lineHeight: 2 }}>
                        {isAU ? (
                          <>
                            ① Go to app.order-link.info<br />
                            ② Sign up with their own email address<br />
                            ③ Choose "Join an existing business as staff"<br />
                            ④ Enter the code below
                          </>
                        ) : (
                          <>
                            ① app.order-link.info を開く<br />
                            ② 自分のメールアドレスで新規登録<br />
                            ③「既存の会社にスタッフとして参加」を選ぶ<br />
                            ④ 下のコードを入力する
                          </>
                        )}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                      <div style={{ flex: 1, background: "white", border: "1px solid #bfdbfe", color: "#1e40af", padding: "10px 14px", borderRadius: 8, fontSize: 20, fontWeight: 900, letterSpacing: 6, fontFamily: "monospace", textAlign: "center" }}>
                        {tenantProfile?.staffInviteCode || "--------"}
                      </div>
                      <button
                        onClick={() => { navigator.clipboard.writeText(tenantProfile?.staffInviteCode || ""); showToast(isAU ? "Copied" : "コピーしました"); }}
                        style={{ padding: "10px 16px", borderRadius: 8, border: "1px solid #bfdbfe", background: "white", fontWeight: 900, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}
                      >
                        {isAU ? "📋 Copy" : "📋 コピー"}
                      </button>
                    </div>
                  </div>

                </div>

                {/* 右カラム：接続済み店舗一覧 */}
                <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: 12, padding: "24px 24px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                    <div style={{ background: "#16a34a", color: "white", borderRadius: 999, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: 13, flexShrink: 0 }}>✓</div>
                    <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "Connected retailers" : "接続済みの小売店"}</div>
                    <div style={{ marginLeft: "auto", background: "#f1f5f9", borderRadius: 999, padding: "2px 10px", fontSize: 12, fontWeight: 700, color: "#64748b" }}>
                      {isAU ? `${shops.filter(s => s.isShop).length}` : `${shops.filter(s => s.isShop).length}店舗`}
                    </div>
                  </div>

                  {shops.filter(s => s.isShop).length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#94a3b8" }}>
                      <div style={{ fontSize: 32, marginBottom: 12 }}>🏪</div>
                      <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>{isAU ? "No connections yet" : "まだ接続されていません"}</div>
                      <div style={{ fontSize: 12 }}>{isAU ? "Send the invite code on the left to a retailer" : "左の招待コードを小売店に送ってください"}</div>
                    </div>
                  ) : (
                    <div style={{ display: "grid", gap: 8 }}>
                      {shops.filter(s => s.isShop).map((s, idx) => (
                        <div key={s.id || idx} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: "#f8fafc", borderRadius: 10, border: "1px solid #f1f5f9" }}>
                          <div style={{ width: 36, height: 36, background: "#e2e8f0", borderRadius: 999, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>🏪</div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: 700, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {s.name || (isAU ? "(Unnamed store)" : "（店舗名未設定）")}
                            </div>
                            {(s.tel || s.address) && (
                              <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {[s.tel, s.address].filter(Boolean).join("　")}
                              </div>
                            )}
                          </div>
                          <div style={{ width: 8, height: 8, borderRadius: 999, background: "#16a34a", flexShrink: 0 }} title={isAU ? "Connected" : "接続中"} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

              </div>
            </div>
          )}

          {mode === "wholesale" && wholesaleView === "suppliers" && (
            <div style={{ display: "grid", gap: 8 }}>
              <CenterWrap>
                <div style={{ display: "grid", gap: 6 }}>

                  {/* 案内バー：1行コンパクト
                      2026-08（Step 12 E2E検証時に発覚したバグ対応）：Customer招待の
                      中核画面（取引先/Customers一覧）がisAU分岐なしで完全に日本語
                      ハードコードされていた */}
                  <div style={{ display: "flex", gap: 8, alignItems: "center", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 12px", flexWrap: "wrap" }}>
                    <span style={{ fontSize: 12, color: "#374151" }}>
                      🔗 <strong>{isAU ? "Retailers already using OrderLink" : "OrderLink利用中の小売店"}</strong>{isAU ? " register automatically when you share your invite code →" : "は招待コードを共有すると自動登録 →"}
                    </span>
                    <button
                      onClick={() => setTenantOpen(true)}
                      style={{ padding: "3px 10px", borderRadius: 6, border: "1px solid #6b7280", background: "white", fontWeight: 700, fontSize: 11, cursor: "pointer", whiteSpace: "nowrap" }}
                    >
                      {isAU ? "Open invite code" : "招待コードを開く"}
                    </button>
                    <span style={{ fontSize: 12, color: "#374151", marginLeft: 8 }}>
                      📝 <strong>{isAU ? "Customers who order by phone/fax" : "FAX・電話注文の取引先"}</strong>{isAU ? ' can be added manually via "+ Add customer" above' : "は右上「＋ 小売店追加」から手動登録"}
                    </span>
                  </div>

                  {/* 件数ラベル */}
                  <div style={{ fontSize: 12, color: "#6b7280", padding: "2px 2px" }}>{isAU ? `${shops.length} customer(s)` : `取引先 ${shops.length} 件`}</div>

                  {/* 取引先一覧 */}
                  {shops.length === 0 ? (
                    <div style={{ padding: "32px 0", textAlign: "center", color: "#9ca3af", fontSize: 13 }}>{isAU ? "No customers registered yet" : "取引先がまだ登録されていません"}</div>
                  ) : (
                    shops.map((s) => {
                      const isConnected = s.uid || s.tenantId || s.connectedAt;
                      const shopName = s.company || (s.name && !s.name.includes("@") ? s.name : (isAU ? "(Unnamed store)" : "（店名未設定）"));
                      const subName = s.company && s.name && !s.name.includes("@") && s.company !== s.name ? s.name : null;
                      return (
                        <div key={s.id} style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: "10px 14px", background: "white", display: "flex", alignItems: "center", gap: 12 }}>
                          <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                            <div style={{ minWidth: 160 }}>
                              <div style={{ fontWeight: 800, fontSize: 14 }}>{shopName}</div>
                              {subName && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 1 }}>{isAU ? `Store: ${subName}` : `担当店舗：${subName}`}</div>}
                            </div>
                            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                              {s.tel && <div style={{ fontSize: 12, color: "#6b7280" }}>📞 {s.tel}</div>}
                              {s.fax && <div style={{ fontSize: 12, color: "#6b7280" }}>📠 {s.fax}</div>}
                              {s.address && <div style={{ fontSize: 12, color: "#6b7280" }}>📍 {s.address}</div>}
                            </div>
                            <span style={{
                              fontSize: 11, padding: "2px 8px", borderRadius: 20, whiteSpace: "nowrap",
                              background: isConnected ? "#ecfdf5" : "#f3f4f6",
                              color: isConnected ? "#059669" : "#9ca3af",
                              border: isConnected ? "1px solid #a7f3d0" : "1px solid #e5e7eb"
                            }}>
                              {isConnected ? (isAU ? "🟢 Connected via OrderLink" : "🟢 OrderLink接続") : (isAU ? "⚪ Manually added" : "⚪ 手動登録")}
                            </span>
                            {s.note && <div style={{ fontSize: 11, color: "#9ca3af", fontStyle: "italic" }}>{s.note}</div>}
                          </div>
                          <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                            <button onClick={() => openShopEdit(s)} style={{ ...S.btn }}>{isAU ? "Edit" : "編集"}</button>
                            <button onClick={() => deleteShop(s)} style={{ ...S.btn, border: "1px solid #ddd" }}>{isAU ? "Delete" : "削除"}</button>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </CenterWrap>
            </div>
          )}

          {/* ===== 手書き入力 カテゴリ選択モーダル ===== */}
          {manualCategoryModalOpen && (
            <div
              style={{ position: "fixed", inset: 0, zIndex: 16000, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
              onClick={() => setManualCategoryModalOpen(false)}
            >
              <div
                style={{ background: "white", borderRadius: 20, padding: 24, width: "100%", maxWidth: 720, maxHeight: "80vh", overflowY: "auto" }}
                onClick={e => e.stopPropagation()}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                  <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "Select a category" : "カテゴリを選択"}</div>
                  <button onClick={() => setManualCategoryModalOpen(false)} style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #ddd", cursor: "pointer", background: "white", fontWeight: 700 }}>✕</button>
                </div>
                {catalogLoading ? (
                  <div style={{ textAlign: "center", padding: 32, opacity: 0.6, fontSize: 14 }}>{isAU ? "Loading product catalogue..." : "商品マスタ読み込み中..."}</div>
                ) : wholesaleCategories.length === 0 ? (
                  <div style={{ opacity: 0.6, fontSize: 14 }}>{isAU ? "No categories found. Please add categories in your product catalogue." : "カテゴリが見つかりません。商品マスタにカテゴリを登録してください。"}</div>
                ) : (
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: 8 }}>
                    {wholesaleCategories.map(cat => (
                      <button
                        key={cat}
                        onClick={() => { setManualCategory(cat); setManualSearch(""); setManualCategoryModalOpen(false); }}
                        style={{ padding: "12px 10px", borderRadius: 10, border: manualCategory === cat ? "2px solid #111" : "1px solid #ddd", fontWeight: manualCategory === cat ? 900 : 400, cursor: "pointer", background: manualCategory === cat ? "#111" : "white", color: manualCategory === cat ? "white" : "#333", fontSize: 13 }}
                      >
                        {cat}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ===== 卸 取引先追加・編集モーダル ===== */}
          {shopModalOpen && (
            <div
              style={{ position: "fixed", inset: 0, zIndex: 16000, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
              onClick={closeShopModal}
            >
              <div
                style={{ background: "white", borderRadius: 18, padding: 24, width: "100%", maxWidth: 480, display: "grid", gap: 14, maxHeight: "90vh", overflowY: "auto" }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{ fontWeight: 900, fontSize: 18 }}>
                  {isAU
                    ? (shopModalMode === "add" ? "🏪 Add customer" : "🏪 Edit customer")
                    : (shopModalMode === "add" ? "🏪 取引先を追加" : "🏪 取引先を編集")}
                </div>

                {/* 店名 */}
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Store name" : "店名"} <span style={{ color: "#e11d48" }}>*</span></div>
                  <input
                    value={shopModalName}
                    onChange={(e) => setShopModalName(e.target.value)}
                    placeholder={isAU ? "e.g. Smith Supermarket" : "例）〇〇スーパー"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, fontWeight: 700, boxSizing: "border-box" }}
                  />
                </div>

                {/* 社名 */}
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Company name" : "社名（法人名）"}</div>
                  <input
                    value={shopModalCompany}
                    onChange={(e) => setShopModalCompany(e.target.value)}
                    placeholder={isAU ? "e.g. Smith Foods Pty Ltd" : "例）株式会社〇〇フード"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                  />
                </div>

                {/* 住所 */}
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Address" : "住所"}</div>
                  <input
                    value={shopModalAddress}
                    onChange={(e) => setShopModalAddress(e.target.value)}
                    placeholder={isAU ? "e.g. 123 George St, Sydney NSW" : "例）東京都渋谷区〇〇1-2-3"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                  />
                </div>

                {/* TEL / FAX */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Phone" : "TEL"}</div>
                    <input
                      value={shopModalTel}
                      onChange={(e) => setShopModalTel(e.target.value)}
                      placeholder={isAU ? "e.g. 02 1234 5678" : "例）03-1234-5678"}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                    />
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>Fax</div>
                    <input
                      value={shopModalFax}
                      onChange={(e) => setShopModalFax(e.target.value)}
                      placeholder={isAU ? "e.g. 02 1234 5679" : "例）03-1234-5679"}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                    />
                  </div>
                </div>

                {/* 備考 */}
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Notes" : "備考"}</div>
                  <textarea
                    value={shopModalNote}
                    onChange={(e) => setShopModalNote(e.target.value)}
                    placeholder={isAU ? "Contact person, delivery days, etc." : "担当者名・配達曜日など"}
                    rows={3}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box", resize: "vertical" }}
                  />
                </div>

                {/* メールアドレス */}
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Email address" : "メールアドレス"}</div>
                  <input
                    type="email"
                    value={shopModalEmail}
                    onChange={(e) => setShopModalEmail(e.target.value)}
                    placeholder={isAU ? "e.g. shop@example.com" : "例）shop@example.co.jp"}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box" }}
                  />
                </div>

                {/* インボイス登録番号
                    2026-08（Step 12 E2E検証時に発覚したバグ対応）：この欄は日本の
                    適格請求書発行事業者番号（インボイス番号）専用で、AUには
                    存在しない制度。AU版では取引先ごとのこの入力欄自体は残しつつ
                    ラベルのみ中立化する（取引先個別のABN等を今後扱う余地は残す） */}
                {!isAU && (
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>インボイス登録番号</div>
                  <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: 10, overflow: "hidden" }}>
                    <span style={{ padding: "10px 10px 10px 12px", background: "#f5f5f5", fontWeight: 900, fontSize: 15, color: "#333", borderRight: "1px solid #ddd" }}>T</span>
                    <input
                      value={shopModalInvoiceNo.replace(/^T/, "")}
                      onChange={(e) => setShopModalInvoiceNo("T" + e.target.value.replace(/\D/g, "").slice(0, 13))}
                      placeholder="1234567890123"
                      maxLength={13}
                      inputMode="numeric"
                      style={{ flex: 1, padding: "10px 12px", border: "none", fontSize: 14, outline: "none" }}
                    />
                    <span style={{ padding: "10px 12px", fontSize: 12, color: shopModalInvoiceNo.replace(/^T/, "").length === 13 ? "#16a34a" : "#aaa", whiteSpace: "nowrap" }}>
                      {shopModalInvoiceNo.replace(/^T/, "").length}/13
                    </span>
                  </div>
                </div>
                )}

                {/* 締め日・支払期限 */}
                <div style={{ display: "flex", gap: 10 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Billing cutoff day" : "締め日"}</div>
                    <select value={shopModalClosingDay} onChange={e => setShopModalClosingDay(e.target.value)}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14 }}>
                      <option value="0">{isAU ? "End of month" : "末日締め"}</option>
                      {[5,10,15,20,25].map(d => (
                        <option key={d} value={String(d)}>{isAU ? `${d}${d === 1 ? "st" : d === 2 ? "nd" : d === 3 ? "rd" : "th"} of the month` : `毎月${d}日締め`}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{isAU ? "Payment due" : "支払期限"}</div>
                    <select value={shopModalPaymentDays} onChange={e => setShopModalPaymentDays(e.target.value)}
                      style={{ width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14 }}>
                      <option value="30">{isAU ? "End of following month (30 days)" : "翌月末（30日後）"}</option>
                      <option value="60">{isAU ? "End of month after next (60 days)" : "翌々月末（60日後）"}</option>
                      <option value="15">{isAU ? "15 days" : "15日後"}</option>
                      <option value="7">{isAU ? "7 days" : "7日後"}</option>
                    </select>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={closeShopModal} style={{ ...S.btn, flex: 1, padding: "12px 0" }}>{isAU ? "Cancel" : "キャンセル"}</button>
                  <button onClick={saveShop} style={{ ...S.btnPrimary, flex: 2, padding: "12px 0" }}>
                    {isAU ? (shopModalMode === "add" ? "Add" : "Save") : (shopModalMode === "add" ? "追加する" : "保存する")}
                  </button>
                </div>
              </div>
            </div>
          )}


          {/* ===== 請求書発行 ===== */}
          {mode === "wholesale" && wholesaleView === "billing" && (() => {
            const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
            const selectedShop = shops.find(s => String(s.id||s._docId) === String(billingShopId));

            // 締め日から期間を自動計算
            const calcPeriod = (offset = -1) => {
              const today = new Date();
              const cd = Number(selectedShop?.closingDay ?? 0);
              if (cd === 0) {
                // 末日締め
                const end = new Date(today.getFullYear(), today.getMonth() + offset + 1, 0);
                const start = new Date(end.getFullYear(), end.getMonth(), 1);
                return { start: fmt(start), end: fmt(end) };
              } else {
                const end = new Date(today.getFullYear(), today.getMonth() + offset, cd);
                const start = new Date(end.getFullYear(), end.getMonth() - 1, cd + 1);
                return { start: fmt(start), end: fmt(end) };
              }
            };

            // 支払期限計算
            const calcDueDate = () => {
              if (!billingPeriodEnd) return "";
              const d = new Date(billingPeriodEnd);
              const pd = Number(selectedShop?.paymentDays ?? 30);
              d.setDate(d.getDate() + pd);
              return fmt(d);
            };

            // 対象注文はFirestoreから取得済みのデータを使用（30日キャッシュではなく全期間対応）
            const billingOrders = billingFetchedOrders || [];

            // プレビュー表示も必ずgetOrderAmounts（orderSnapshot参照）を使う。
            // 発行時にトップレベルとスナップショットの値は同期されるため通常は
            // 食い違わないが、単一の金額参照経路に統一しておく
            const billingTotal = billingOrders.reduce((s, o) => s + getOrderAmounts(o, tenantProfile?.marketId).total, 0);
            const billingSub   = billingOrders.reduce((s, o) => s + getOrderAmounts(o, tenantProfile?.marketId).subtotal, 0);
            const billingTax   = billingOrders.reduce((s, o) => s + getOrderAmounts(o, tenantProfile?.marketId).tax, 0);
            console.log("[billingOrders]", billingOrders.map(o => ({ id: o.id, total: o.total, subtotal: o.subtotal, tax: o.tax })));

            return (
              <div style={{ display: "grid", gap: 14, maxWidth: 960 }}>

                {/* 取引先選択 */}
                <div style={{ ...S.card }}>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>{isAU ? "① Select a customer" : "① 請求先（取引先）を選択"}</div>
                  <select value={billingShopId} onChange={e => { setBillingShopId(e.target.value); setBillingFetchedOrders(null); }}
                    style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14 }}>
                    <option value="">{isAU ? "-- Select a customer --" : "-- 取引先を選択 --"}</option>
                    {(shops || []).map(s => (
                      <option key={s.id||s._docId} value={s.id||s._docId}>{s.company || s.name}</option>
                    ))}
                  </select>
                  {selectedShop && (
                    <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>
                      {isAU
                        ? `Billing cutoff: ${(selectedShop.closingDay == null || selectedShop.closingDay === 0) ? "End of month" : `${selectedShop.closingDay} of the month`}, Payment due: ${selectedShop.paymentDays || 30} days after`
                        : `締め日：${(selectedShop.closingDay == null || selectedShop.closingDay === 0) ? "末日" : `毎月${selectedShop.closingDay}日`}支払期限：${selectedShop.paymentDays || 30}日後`}
                    </div>
                  )}
                </div>

                {/* 請求期間 */}
                <div style={{ ...S.card }}>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>{isAU ? "② Select the billing period" : "② 請求期間を指定"}</div>
                  <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
                    {(isAU ? ["Last month", "This month"] : ["先月分", "今月分"]).map((label, i) => (
                      <button key={label} onClick={() => {
                        const p = calcPeriod(i === 0 ? -1 : 0);
                        setBillingPeriodStart(p.start);
                        setBillingPeriodEnd(p.end);
                        setBillingFetchedOrders(null);
                      }} style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #ddd", background: "white", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                        {label}
                      </button>
                    ))}
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                    <input type="date" value={billingPeriodStart} onChange={e => { setBillingPeriodStart(e.target.value); setBillingFetchedOrders(null); }}
                      style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                    <span>〜</span>
                    <input type="date" value={billingPeriodEnd} onChange={e => { setBillingPeriodEnd(e.target.value); setBillingFetchedOrders(null); }}
                      style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                  </div>
                  {billingShopId && billingPeriodStart && billingPeriodEnd && (
                    <button onClick={() => fetchBillingOrders(billingShopId, billingPeriodStart, billingPeriodEnd)}
                      disabled={billingFetching}
                      style={{ marginTop: 10, padding: "9px 20px", borderRadius: 8, border: "none", background: billingFetching ? "#9ca3af" : "#2563eb", color: "white", fontWeight: 700, fontSize: 13, cursor: billingFetching ? "not-allowed" : "pointer" }}>
                      {billingFetching ? (isAU ? "Loading..." : "読み込み中...") : (isAU ? "🔍 Fetch orders (preview)" : "🔍 対象注文を取得（プレビュー）")}
                    </button>
                  )}
                  {billingPeriodEnd && (
                    <div style={{ marginTop: 6, fontSize: 12, color: "#666" }}>
                      {isAU ? `Estimated due date: ${calcDueDate()}` : `支払期限（目安）：${calcDueDate()}`}
                    </div>
                  )}
                </div>

                {/* 対象期間の納品実績一覧 */}
                {billingFetchError && (
                  <div style={{ ...S.card, background: "#fef2f2", border: "1px solid #fecaca" }}>
                    <div style={{ color: "#b91c1c", fontSize: 13, fontWeight: 700 }}>
                      {isAU ? "⚠ Failed to load deliveries. Please try again." : "⚠ 納品実績の取得に失敗しました。再試行してください。"}
                    </div>
                  </div>
                )}
                {billingShopId && billingPeriodStart && billingPeriodEnd && billingFetchedOrders !== null && (
                  <div style={{ ...S.card }}>
                    <div style={{ fontWeight: 900, marginBottom: 10 }}>{isAU ? "③ Deliveries in this period" : "③ 対象期間の納品実績"}</div>
                    {billingFetching ? (
                      <div style={{ fontSize: 13, color: "#666", padding: "12px 0" }}>{isAU ? "Loading..." : "読み込み中..."}</div>
                    ) : billingOrders.length === 0 ? (
                      <div style={{ fontSize: 13, color: "#999", padding: "12px 0" }}>{isAU ? "No deliveries found for this period" : "該当する納品実績がありません"}</div>
                    ) : (
                      <>
                        {billingOrders.map(o => (
                          <div key={o.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f0f0f0", fontSize: 13 }}>
                            <div>
                              <span style={{ fontWeight: 700 }}>{o.deliveryNo ? (isAU ? "Delivery No." + o.deliveryNo : "納品書No."+o.deliveryNo) : o.orderNo}</span>
                              <span style={{ marginLeft: 8, color: "#888" }}>
                                {o.issuedAt?.toDate ? o.issuedAt.toDate().toLocaleDateString(isAU ? "en-AU" : "ja-JP") : ""}
                              </span>
                            </div>
                            <div style={{ fontWeight: 700 }}>{formatMoney(getOrderAmounts(o, tenantProfile?.marketId).total, tenantProfile?.marketId)}</div>
                          </div>
                        ))}
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, paddingTop: 10, borderTop: "2px solid #111", fontWeight: 900 }}>
                          <div>{isAU ? `Total (${billingOrders.length})` : `合計（${billingOrders.length}件）`}</div>
                          <div style={{ fontSize: 18 }}>{formatMoney(billingTotal, tenantProfile?.marketId)}</div>
                        </div>
                        <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                          {isAU
                            ? `Subtotal: ${formatMoney(billingSub, tenantProfile?.marketId)}  GST: ${formatMoney(billingTax, tenantProfile?.marketId)}`
                            : `税抜：${formatMoney(billingSub, tenantProfile?.marketId)}　消費税：${formatMoney(billingTax, tenantProfile?.marketId)}`}
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* 発行ボタン。標準経路：shopId・期間・支払期日のみを送信し、orderIdsは送らない。
                    サーバーが同一トランザクション内で「期間内・同一取引先・納品書発行済み・
                    非test/demo」の全適格注文（＝③に表示されている納品実績と同じ集合）を
                    権威的に確定し、その全件を請求対象とする。
                    発行後のPDF生成は、発行前プレビュー（billingOrders）ではなく、必ず
                    invoices/{invoiceId}を読み直した内容だけを入力とする。
                    発行後もbillingFetchedOrdersをクリアしない——請求書発行はこの画面上の
                    「期間実績」を消費する操作ではないため、同じ期間を指定し続ければ
                    発行前と同じ納品実績・同じ金額が表示され続けなければならない
                    （同一期間・同一取引先への再発行も許容する仕様） */}
                {billingOrders.length > 0 && (
                  <button disabled={billingIssuing} onClick={async () => {
                    // 二重クリック・連打防止：送信中は再入不可にする（requestIdは
                    // このガードで守られた1回の実行につき1個だけ生成される）
                    if (billingIssuing) return;
                    setBillingIssuing(true);
                    // 連打は同じrequestIdを再利用し、成功を確認できて初めて次回発行のために
                    // リセットする（未発行ならここで新規生成する防御的フォールバック）
                    if (!billingIssueRequestIdRef.current) {
                      billingIssueRequestIdRef.current = generateRequestId();
                    }
                    const requestId = billingIssueRequestIdRef.current;
                    try {
                      const dueDate = calcDueDate();
                      const issueBillingFn = httpsCallable(functions, "issueBilling");
                      const billingResult = await issueBillingFn({
                        shopId: billingShopId,
                        periodStart: billingPeriodStart,
                        periodEnd: billingPeriodEnd,
                        paymentDueDate: dueDate,
                        requestId,
                      });
                      const invoiceId = billingResult?.data?.invoiceId;
                      const bn = billingResult?.data?.billingNo;
                      // 発行成功後、権威的な請求書ドキュメントを読み直してから印刷する
                      const invoiceSnap = await getDoc(doc(db, "invoices", invoiceId));
                      const invoice = invoiceSnap.exists() ? invoiceSnap.data() : null;
                      if (invoice) {
                        printBillingPopup({ invoiceId, invoice });
                      }
                      showToast(isAU ? `Tax invoice ${bn} issued` : `請求書 ${bn} を発行しました`);
                      // 発行済み一覧に今回のinvoiceを反映する（履歴の再取得。期間実績への
                      // 混入は起きない——別stateへの単純な再フェッチ）
                      fetchBillingIssuedInvoices(billingShopId);
                      // 成功を確認できた後にだけrequestIdを破棄する（ここより前にリセット
                      // すると、成否不明な失敗時の再試行が新しいrequestIdになってしまう）
                      billingIssueRequestIdRef.current = null;
                    } catch (e) {
                      console.error(e);
                      showToast((isAU ? "An error occurred: " : "エラーが発生しました: ") + (e?.message || String(e)));
                      // 失敗時はrequestIdを保持したままにする。ユーザーが再試行した場合、
                      // 同じrequestIdで送られるため、「サーバーは成功したがレスポンスが
                      // 届かなかった」ケースでも二重発行にならない（サーバー側idempotencyが
                      // 既存invoiceId/billingNoをそのまま返す）
                    } finally {
                      setBillingIssuing(false);
                    }
                  }} style={{ ...S.btnPrimary, padding: "14px 0", fontSize: 15, fontWeight: 900, opacity: billingIssuing ? 0.6 : 1, cursor: billingIssuing ? "not-allowed" : "pointer" }}>
                    {billingIssuing ? (isAU ? "Issuing…" : "発行中…") : (isAU ? "🧾 Issue & print tax invoice (bills all orders in this period)" : "🧾 請求書を発行・印刷（期間内の全件を請求）")}
                  </button>
                )}

                {/* ===== 発行済み請求書（履歴） =====
                    未請求候補（billingFetchedOrders/③対象注文セクション）とは完全に
                    独立したstate・独立したUIセクション。ここに表示される内容が
                    新規請求候補へ混ざることはない。同一期間で複数回発行されていても
                    invoiceドキュメント単位で1行ずつ表示し、統合・上書きしない */}
                {billingShopId && (
                  <div style={{ ...S.card }}>
                    <div style={{ fontWeight: 900, marginBottom: 10 }}>{isAU ? "Issued invoices" : "発行済み請求書"}</div>
                    {billingIssuedLoading ? (
                      <div style={{ fontSize: 13, color: "#666", padding: "12px 0" }}>{isAU ? "Loading..." : "読み込み中..."}</div>
                    ) : billingIssuedError ? (
                      <div style={{ fontSize: 13, color: "#b91c1c", fontWeight: 700, padding: "12px 0" }}>
                        {isAU ? "⚠ Failed to load issued invoices. Please try again." : "⚠ 発行済み請求書の取得に失敗しました。再試行してください。"}
                        <button onClick={() => fetchBillingIssuedInvoices(billingShopId)}
                          style={{ marginLeft: 10, padding: "4px 10px", borderRadius: 8, border: "none", background: "#b91c1c", color: "white", fontWeight: 700, fontSize: 11, cursor: "pointer" }}>
                          {isAU ? "Retry" : "再試行"}
                        </button>
                      </div>
                    ) : !billingIssuedInvoices || billingIssuedInvoices.length === 0 ? (
                      <div style={{ fontSize: 13, color: "#999", padding: "12px 0" }}>{isAU ? "No invoices issued yet" : "発行済みの請求書はありません"}</div>
                    ) : (
                      billingIssuedInvoices.map(inv => {
                        const createdAtStr = inv.createdAt?.toDate ? inv.createdAt.toDate().toLocaleString(isAU ? "en-AU" : "ja-JP") : "";
                        const isCurrentPdfLoading = billingPdfLoadingId === inv.id;
                        return (
                          <div key={inv.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "1px solid #f0f0f0", fontSize: 13, gap: 10 }}>
                            <div>
                              <div style={{ fontWeight: 700 }}>
                                {inv.billingNo}
                                <span style={{ marginLeft: 8, fontWeight: 400, color: "#666" }}>
                                  {inv.periodStartDisplay} 〜 {inv.periodEndDisplay}
                                </span>
                              </div>
                              <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                                {isAU ? `Issued: ${createdAtStr}   Due: ${inv.paymentDueDate || "-"}` : `発行日：${createdAtStr}　支払期日：${inv.paymentDueDate || "-"}`}
                              </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
                              <div style={{ fontWeight: 900, fontSize: 15 }}>{formatMoney(inv.total, tenantProfile?.marketId)}</div>
                              <button onClick={() => viewOrReprintInvoice(inv)}
                                disabled={isCurrentPdfLoading}
                                style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #2563eb", background: "white", color: "#2563eb", fontWeight: 700, fontSize: 12, cursor: isCurrentPdfLoading ? "not-allowed" : "pointer" }}>
                                {isCurrentPdfLoading ? (isAU ? "Loading..." : "取得中...") : (isAU ? "View / Reprint" : "表示／再印刷")}
                              </button>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                )}
              </div>
            );
          })()}

          {/* ===== summary / manual（仮） ===== */}
          {mode === "wholesale" && wholesaleView === "summary" && (() => {
            // 集計ロジック（期間指定取得データ使用）
            const summaryOrders = wsSummaryAllOrders || [];

            // 期間未指定 or 未取得の場合は期間選択UIのみ表示
            if (!wsSummaryAllOrders && !wsSummaryLoading) {
              const now = new Date();
              const pad = (v) => String(v).padStart(2, "0");
              const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
              // labelは内部識別子としてもwsSummaryPreset stateにそのまま保存され、
              // applyWsSummaryPreset関数（下方）内の日本語文字列比較にも使われるため、
              // 識別子自体は変更しない。表示だけenLabelでAU分岐する
              const presets = [
                { label: "当月", enLabel: "This month", s: fmt(new Date(now.getFullYear(), now.getMonth(), 1)), e: fmt(now) },
                { label: "前月", enLabel: "Last month", s: fmt(new Date(now.getFullYear(), now.getMonth()-1, 1)), e: fmt(new Date(now.getFullYear(), now.getMonth(), 0)) },
                { label: "3ヶ月", enLabel: "3 months", s: fmt(new Date(now.getFullYear(), now.getMonth()-2, 1)), e: fmt(now) },
                { label: "半年", enLabel: "6 months", s: fmt(new Date(now.getFullYear(), now.getMonth()-5, 1)), e: fmt(now) },
                { label: "1年", enLabel: "1 year", s: fmt(new Date(now.getFullYear(), now.getMonth()-11, 1)), e: fmt(now) },
              ];
              return (
                <div style={{ padding: "32px 16px", maxWidth: 480, margin: "0 auto" }}>
                  <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 20 }}>{isAU ? "📊 Select a period to summarise" : "📊 集計する期間を選択"}</div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
                    {presets.map(p => (
                      <button key={p.label} onClick={() => { setWsSummaryStart(p.s); setWsSummaryEnd(p.e); setWsSummaryPreset(p.label); }}
                        style={{ padding: "8px 14px", borderRadius: 8, border: wsSummaryPreset === p.label ? "2px solid #1a56db" : "1px solid #ddd", background: wsSummaryPreset === p.label ? "#eff6ff" : "white", color: wsSummaryPreset === p.label ? "#1a56db" : "#333", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                        {isAU ? p.enLabel : p.label}
                      </button>
                    ))}
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 20, flexWrap: "wrap" }}>
                    <input type="date" value={wsSummaryStart} onChange={ev => { setWsSummaryStart(ev.target.value); setWsSummaryPreset(""); }}
                      style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14 }} />
                    <span>〜</span>
                    <input type="date" value={wsSummaryEnd} onChange={ev => { setWsSummaryEnd(ev.target.value); setWsSummaryPreset(""); }}
                      style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14 }} />
                  </div>
                  <button
                    disabled={!wsSummaryStart || !wsSummaryEnd || new Date(wsSummaryStart) > new Date(wsSummaryEnd)}
                    onClick={() => {
                      // 月次タブは常に「今月・先月・先々月」の3枚固定カードを表示するため、
                      // ユーザーが選んだ期間に関わらず、必ず先々月の月初〜当月末までの
                      // 3ヶ月分を取得する。ユーザー選択期間だけを取得すると、選択期間外の
                      // 月のカードが実際にはデータがあるのに0円と表示されてしまう。
                      // また、このクリック時点の「今月」を記録しておき、レンダー時は
                      // 常にこの記録済みの値を基準に月を計算する（フェッチ〜レンダーの
                      // 間に日付が月をまたいでも、取得済みデータの範囲とラベル・カードの
                      // 対象月がズレないようにするため）
                      const fetchThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                      const fetchFrom = fmt(new Date(now.getFullYear(), now.getMonth() - 2, 1));
                      const fetchTo = fmt(new Date(now.getFullYear(), now.getMonth() + 1, 0));
                      setWsSummaryFetchedThisMonth(fetchThisMonth);
                      fetchWsSummaryOrders(fetchFrom, fetchTo);
                      // 2026-08 回帰修正：この関門ボタンはwsSummaryAllOrders（月次タブ用）
                      // のみを取得しており、取引先別・商品別タブ専用のwsRankAllOrdersは
                      // 一度も取得されないままだった。そのため、ここで初めて期間を選んで
                      // 集計画面に入ると、月次タブは表示されるが取引先別・商品別タブは
                      // wsRankAllOrders===nullのまま「期間を指定して集計してください」と
                      // 表示され続ける回帰バグがあった。ここでユーザーが選択した期間
                      // （wsSummaryStart/wsSummaryEnd）でランキング用データも同時に
                      // 取得し、タブを切り替えた時点で即座に表示されるようにする
                      fetchWsRankOrders(wsSummaryStart, wsSummaryEnd);
                    }}
                    style={{ width: "100%", padding: "14px", borderRadius: 10, background: (!wsSummaryStart || !wsSummaryEnd) ? "#ccc" : "#1a56db", color: "white", fontWeight: 900, fontSize: 15, border: "none", cursor: (!wsSummaryStart || !wsSummaryEnd) ? "default" : "pointer" }}>
                    {isAU ? "Summarise this period" : "この期間で集計する"}
                  </button>
                </div>
              );
            }

            if (wsSummaryLoading) {
              return <div style={{ padding: 40, textAlign: "center", color: "#888", fontSize: 14 }}>{isAU ? "Loading summary data..." : "集計データを読み込んでいます..."}</div>;
            }

            // 月次カード・ラベルの基準月は、フェッチ実行時に記録したwsSummaryFetchedThisMonthを
            // 使う（レンダー時にnew Date()し直さない）。フェッチ〜レンダーの間に日付が
            // 月をまたいでも、実際に取得済みのデータ範囲とカード・ラベルの対象月が
            // 一致し続けることを保証するため。念のためnullの場合のみ現在時刻にフォールバック
            const thisMonth = wsSummaryFetchedThisMonth || new Date(new Date().getFullYear(), new Date().getMonth(), 1);
            const lastMonth = new Date(thisMonth.getFullYear(), thisMonth.getMonth() - 1, 1);
            const lastLastMonth = new Date(thisMonth.getFullYear(), thisMonth.getMonth() - 2, 1);

            // 集計基準は「納品書発行ベース」に一本化。期間軸はissuedAtに統一する。
            const getMonthOrders = (month) => {
              return summaryOrders.filter((o) => {
                if (!isDeliveredAndCounted(o)) return false;
                const ts = o.issuedAt;
                const d = new Date(typeof ts?.toMillis === "function" ? ts.toMillis() : ts || 0);
                return d.getFullYear() === month.getFullYear() && d.getMonth() === month.getMonth();
              });
            };

            const thisMonthOrders = getMonthOrders(thisMonth);
            const lastMonthOrders = getMonthOrders(lastMonth);
            const lastLastMonthOrders = getMonthOrders(lastLastMonth);

            // 集計は必ずorderSnapshotの単純合算のみで行う（唯一の金額計算元。
            // 小売月次のcalcTaxと同一の計算経路にすることで、受け入れ条件
            // 「小売仕入集計＝卸売上集計」を満たす）。
            // 税率内訳（tax8/tax10）の信頼性は注文単位で判定する——集計対象群全体に
            // 対して1つのbreakdownAvailableを持たせると、1件でも内訳が信頼できない
            // 注文が混ざるだけで他の全注文の正しいtax8が丸ごと0円に破棄されてしまう
            // バグがあったため（2026-08修正）。2026-08修正（Codexレビュー指摘対応・v4）：
            // tax8/tax10のnull判定は常に数値を返す設計になったため機能しなくなった。
            // 代わりにhasInvalidRatesで「内訳が信頼できない注文」を判定する。
            // 該当注文は自分自身のtaxのみをtax10へ暫定計上し、他の注文の内訳には
            // 一切影響しない
            const calcTax = (ords) => {
              let subtotal = 0, tax8 = 0, tax10 = 0, total = 0;
              ords.forEach((o) => {
                const a = getOrderAmounts(o, tenantProfile?.marketId);
                subtotal += a.subtotal; total += a.total;
                if (a.hasInvalidRates) { tax10 += a.tax; }
                else { tax8 += a.tax8; tax10 += a.tax10; }
              });
              return { subtotal, tax8, tax10, total };
            };
            
            const thisMonthStats = calcTax(thisMonthOrders);
            const lastMonthStats = calcTax(lastMonthOrders);
            const lastLastMonthStats = calcTax(lastLastMonthOrders);
            
            const monthDiff = lastMonthStats.total > 0 
              ? ((thisMonthStats.total - lastMonthStats.total) / lastMonthStats.total * 100).toFixed(1) 
              : 0;
            
            // ===== 卸集計 期間プリセットヘルパー =====
            const applyWsSummaryPreset = (preset) => {
              const n = new Date();
              const pad = (v) => String(v).padStart(2, "0");
              const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
              let s, e;
              if (preset === "当月") {
                s = fmt(new Date(n.getFullYear(), n.getMonth(), 1)); e = fmt(n);
              } else if (preset === "前月") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 1, 1));
                e = fmt(new Date(n.getFullYear(), n.getMonth(), 0));
              } else if (preset === "3ヶ月") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 2, 1)); e = fmt(n);
              } else if (preset === "半年") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 5, 1)); e = fmt(n);
              } else if (preset === "1年") {
                s = fmt(new Date(n.getFullYear(), n.getMonth() - 11, 1)); e = fmt(n);
              }
              setWsSummaryPreset(preset);
              setWsSummaryStart(s);
              setWsSummaryEnd(e);
              // ランキングタブ専用のwsRankAllOrdersを新しい期間で再取得する。
              // 月次タブのwsSummaryAllOrdersはここでは変更しない——共有すると、
              // ランキングタブで選んだ狭い期間のデータで月次タブの「今月・先月・
              // 先々月」カードが上書きされ、実際には注文がある月が0円と表示される
              // 不整合が生じるため（両タブは独立したデータソースを持つ）
              fetchWsRankOrders(s, e);
            };

            const wsRankDateError = wsSummaryStart && wsSummaryEnd && new Date(wsSummaryStart) > new Date(wsSummaryEnd);

            // 期間フィルタ済み orders（取引先別・商品別ランキング用）。
            // 集計基準は納品書発行ベースに一本化、期間軸はissuedAtに統一する。
            // データソースは月次タブと共有しないwsRankAllOrders専用ステートを使う
            const rankSourceOrders = wsRankAllOrders || [];
            const wsRankFilteredOrders = (() => {
              if (!wsSummaryStart || !wsSummaryEnd || wsRankDateError) return [];
              const { start, endExclusive } = toJstDayRange(wsSummaryStart, wsSummaryEnd);
              return rankSourceOrders.filter((o) => {
                if (!isDeliveredAndCounted(o)) return false;
                const ts = o.issuedAt;
                const ms = typeof ts?.toMillis === "function" ? ts.toMillis() : (ts ? new Date(ts).getTime() : 0);
                return ms >= start.getTime() && ms < endExclusive.getTime();
              });
            })();

            // 期間プリセットUI共通パーツ（卸）。プリセット識別子（日本語）自体は
            // applyWsSummaryPreset内の文字列比較に使われるため変更しない
            const WS_SUMMARY_PRESET_LABELS = { "当月": "This month", "前月": "Last month", "3ヶ月": "3 months", "半年": "6 months", "1年": "1 year" };
            const WsSummaryPeriodUI = () => (
              <div style={{ marginBottom: 10 }}>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
                  {["当月","前月","3ヶ月","半年","1年"].map(p => (
                    <button key={p} onClick={() => applyWsSummaryPreset(p)}
                      style={{ padding: "5px 12px", borderRadius: 8, border: wsSummaryPreset === p ? "2px solid #111" : "1px solid #ddd", background: wsSummaryPreset === p ? "#111" : "white", color: wsSummaryPreset === p ? "white" : "#333", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>
                      {isAU ? WS_SUMMARY_PRESET_LABELS[p] : p}
                    </button>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <input type="date" value={wsSummaryStart}
                    onChange={e => {
                      const v = e.target.value;
                      setWsSummaryStart(v); setWsSummaryPreset("");
                      // 両端の日付が揃った時点でランキング専用データを再取得する
                      // （月次タブのwsSummaryAllOrdersはここでは変更しない）
                      if (v && wsSummaryEnd && new Date(v) <= new Date(wsSummaryEnd)) fetchWsRankOrders(v, wsSummaryEnd);
                    }}
                    style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                  <span style={{ fontSize: 13 }}>〜</span>
                  <input type="date" value={wsSummaryEnd}
                    onChange={e => {
                      const v = e.target.value;
                      setWsSummaryEnd(v); setWsSummaryPreset("");
                      if (wsSummaryStart && v && new Date(wsSummaryStart) <= new Date(v)) fetchWsRankOrders(wsSummaryStart, v);
                    }}
                    style={{ padding: "5px 8px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13 }} />
                </div>
                {wsRankDateError && <div style={{ color: "#dc2626", fontSize: 12, marginTop: 4 }}>{isAU ? "⚠ Start date is after end date" : "⚠ 開始日が終了日より後になっています"}</div>}
                {wsSummaryStart && wsSummaryEnd && !wsRankDateError && (
                  <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                    {isAU ? `📅 Period: ${wsSummaryStart} – ${wsSummaryEnd}` : `📅 集計期間：${wsSummaryStart} 〜 ${wsSummaryEnd}`}
                  </div>
                )}
              </div>
            );

            // 取引先別集計（期間指定）。グルーピングはresolveCounterpartyKeyによる
            // 正規識別子で行う（o.shopName文字列照合だと、shopNameを持たないオンライン
            // 注文が集計から漏れる欠陥があった）。合計金額はgetOrderAmountsの単純合算のみ。
            // 税率内訳の信頼性は注文単位で判定する——取引先グループ全体に対して1つの
            // breakdownAvailableを持たせると、その取引先の1件でも内訳が信頼できない
            // 注文が混ざるだけで、他の注文の正しいtax8が丸ごと0円に破棄され、かつ
            // totalまでtax8/tax10からの再構成で誤った値になっていたバグがあった
            // （2026-08修正）。totalは常に各注文のa.totalを直接合算する。
            // 2026-08修正（Codexレビュー指摘対応・v4）：tax8/tax10のnull判定は
            // 機能しなくなったため、hasInvalidRatesで判定する
            const shopStats = {};
            wsRankFilteredOrders.forEach((o) => {
              const key = resolveCounterpartyKey(o, "fromWholesale");
              const keyStr = key ? `${key.kind}:${key.id}` : "unknown";
              if (!shopStats[keyStr]) {
                // 2026-08 修正：オンライン発注由来の注文はo.shopNameを持たないため
                // 常に「不明」になっていた。shopsからretailTenantId/shopIdで
                // 名前を解決できる場合はそちらを優先する（他テナント情報の参照はしない、
                // shopsは自テナントのsuppliersコレクションのみに限定されている）
                const resolvedName = resolveShopDisplayName(key);
                shopStats[keyStr] = { name: o.shopName || resolvedName || "不明", subtotal: 0, tax8: 0, tax10: 0, total: 0, count: 0 };
              }
              const a = getOrderAmounts(o, tenantProfile?.marketId);
              shopStats[keyStr].subtotal += a.subtotal;
              shopStats[keyStr].total += a.total;
              if (a.hasInvalidRates) { shopStats[keyStr].tax10 += a.tax; }
              else { shopStats[keyStr].tax8 += a.tax8; shopStats[keyStr].tax10 += a.tax10; }
              shopStats[keyStr].count += 1;
            });
            const supplierRanking = Object.values(shopStats)
              .sort((a, b) => b.total - a.total).slice(0, 10);

            // 商品別集計（期間指定）
            const productStats = {};
            wsRankFilteredOrders.forEach((o) => {
              getOrderLines(o).forEach((l) => {
                const pid = l.id || l.barcode || l.name || "不明";
                if (!productStats[pid]) {
                  productStats[pid] = { name: l.name || "不明", qty: 0, subtotal: 0, tax8: 0, tax10: 0 };
                }
                const r = calcOrderTotals([l]);
                productStats[pid].qty += Number(l.qty || 0);
                productStats[pid].subtotal += r.subtotal;
                productStats[pid].tax8 += r.tax8;
                productStats[pid].tax10 += r.tax10;
              });
            });
            const productRanking = Object.values(productStats).map(p => ({
              ...p, total: p.subtotal + p.tax8 + p.tax10
            })).sort((a, b) => b.total - a.total).slice(0, 10);
            
            return (
              <div style={{ display: "grid", gap: 12, maxWidth: 920 }}>
                {/* 期間表示＋変更ボタン。月次タブは常に「今月・先月・先々月」の3ヶ月固定で
                    集計するため、ここには実際にfetchWsSummaryOrdersへ渡した3ヶ月分の
                    範囲を表示する（wsSummaryStart/wsSummaryEndはランキングタブ用の
                    ユーザー選択期間であり、月次タブの実際の取得範囲とは異なるため使わない）*/}
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 13, color: "#444", fontWeight: 700 }}>
                    {isAU
                      ? `📅 ${lastLastMonth.toLocaleDateString("en-AU", { month: "short", year: "numeric" })} – ${thisMonth.toLocaleDateString("en-AU", { month: "short", year: "numeric" })} (last 3 months)`
                      : `📅 ${lastLastMonth.getFullYear()}年${lastLastMonth.getMonth() + 1}月 〜 ${thisMonth.getFullYear()}年${thisMonth.getMonth() + 1}月（直近3ヶ月）`}
                  </span>
                  <button onClick={() => setWsSummaryAllOrders(null)}
                    style={{ padding: "5px 14px", borderRadius: 8, border: "1px solid #ddd", background: "white", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                    {isAU ? "Refresh" : "再取得"}
                  </button>
                </div>
                {/* タブ */}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                  {(isAU
                    ? [["monthly","📅 Monthly"],["supplier","🏪 By customer"],["product","📦 By product"],["shop","📈 Customer detail"]]
                    : [["monthly","📅 月別"],["supplier","🏪 取引先別"],["product","📦 商品別"],["shop","📈 取引先指定"]]
                  ).map(([key, label]) => (
                    <button key={key} onClick={() => setWsSummaryTab(key)} style={{ padding: "8px 16px", borderRadius: 10, border: wsSummaryTab === key ? "2px solid #111" : "1px solid #ddd", background: wsSummaryTab === key ? "#111" : "white", color: wsSummaryTab === key ? "white" : "#333", fontWeight: 900, fontSize: 13, cursor: "pointer", whiteSpace: "nowrap" }}>{label}</button>
                  ))}
                  <span style={{ marginLeft: "auto", fontSize: 11, color: "#7c3aed", background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: 6, padding: "3px 8px", fontWeight: 700 }}>{isAU ? "🧾 Based on issued delivery notes" : "🧾 納品書発行ベースで集計"}</span>
                </div>
                {wsSummaryTab === "monthly" && <div>
                {/* 月別売上 */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 14, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 10 }}>{isAU ? "📊 Monthly sales" : "📊 月別売上"}</div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10 }}>
                    {[
                      { month: thisMonth, stats: thisMonthStats, orders: thisMonthOrders, label: isAU ? "This month" : "今月" },
                      { month: lastMonth, stats: lastMonthStats, orders: lastMonthOrders, label: isAU ? "Last month" : "先月" },
                      { month: lastLastMonth, stats: lastLastMonthStats, orders: lastLastMonthOrders, label: isAU ? "2 months ago" : "先々月" }
                    ].map(({ month, stats, orders: ords, label }) => (
                      <div key={label} style={{ padding: 12, border: "1px solid #eee", borderRadius: 12 }}>
                        <div style={{ fontSize: 12, opacity: 0.75 }}>
                          {isAU
                            ? `${month.toLocaleDateString("en-AU", { month: "short", year: "numeric" })} (${label})`
                            : `${month.getFullYear()}年${month.getMonth() + 1}月（${label}）`}
                        </div>
                        <div style={{ fontSize: 20, fontWeight: 900, marginTop: 6 }}>{formatMoney(stats.total, tenantProfile?.marketId)}</div>
                        <div style={{ fontSize: 11, marginTop: 6, opacity: 0.8 }}>
                          {isAU ? (
                            <>
                              <div>Subtotal (ex GST): {formatMoney(stats.subtotal, tenantProfile?.marketId)}</div>
                              <div>GST 10%: {formatMoney(stats.tax10, tenantProfile?.marketId)}</div>
                            </>
                          ) : (
                            <>
                              <div>小計（税抜）：{yen(stats.subtotal)}</div>
                              <div>消費税8%：{yen(stats.tax8)}</div>
                              <div>消費税10%：{yen(stats.tax10)}</div>
                            </>
                          )}
                        </div>
                        <div style={{ fontSize: 12, marginTop: 4, opacity: 0.7 }}>
                          {isAU ? `${ords.length} orders` : `${ords.length}件`}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, fontSize: 13, opacity: 0.8 }}>
                    {isAU ? "vs last month: " : "前月比："}
                    <span style={{ fontWeight: 900, color: monthDiff >= 0 ? "#16a34a" : "#dc2626" }}>
                      {monthDiff >= 0 ? "+" : ""}{monthDiff}%
                    </span>
                  </div>
                </div>

                </div>}
                {wsSummaryTab === "supplier" && <div>
                {/* 取引先別ランキング */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 14, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 10 }}>{isAU ? "🏪 Sales ranking by customer" : "🏪 取引先別売上ランキング"}</div>
                  <WsSummaryPeriodUI />
                  {!wsSummaryStart || !wsSummaryEnd ? (
                    <div style={{ opacity: 0.6, fontSize: 13, padding: "12px 0" }}>{isAU ? "↑ Select a date range to see the ranking" : "↑ 期間を指定して集計してください"}</div>
                  ) : wsRankLoading ? (
                    <div style={{ opacity: 0.7, fontSize: 13, padding: "12px 0" }}>{isAU ? "Loading..." : "取得中..."}</div>
                  ) : wsRankAllOrders === null ? (
                    <div style={{ opacity: 0.6, fontSize: 13, padding: "12px 0" }}>{isAU ? "↑ Select a date range to see the ranking" : "↑ 期間を指定して集計してください"}</div>
                  ) : supplierRanking.length === 0 ? (
                    <div style={{ opacity: 0.7 }}>{isAU ? "(No data)" : "（データなし）"}</div>
                  ) : (
                    <div style={{ overflowX: "auto" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 600 }}>
                        <thead>
                          <tr style={{ borderBottom: "1px solid #eee" }}>
                            <th style={{ textAlign: "left", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Rank" : "順位"}</th>
                            <th style={{ textAlign: "left", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Customer" : "取引先（小売店）"}</th>
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Orders" : "件数"}</th>
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Subtotal" : "小計"}</th>
                            {!isAU && <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>税8%</th>}
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "GST 10%" : "税10%"}</th>
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Total" : "合計"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {supplierRanking.map((s, idx) => (
                            <tr key={idx} style={{ borderBottom: "1px solid #f4f4f4" }}>
                              <td style={{ padding: "8px 4px", fontWeight: 900 }}>{idx + 1}</td>
                              <td style={{ padding: "8px 4px", fontWeight: 900 }}>{s.name}</td>
                              <td style={{ padding: "8px 4px", textAlign: "right" }}>{isAU ? s.count : `${s.count}件`}</td>
                              <td style={{ padding: "8px 4px", textAlign: "right" }}>{formatMoney(s.subtotal, tenantProfile?.marketId)}</td>
                              {!isAU && <td style={{ padding: "8px 4px", textAlign: "right" }}>{yen(s.tax8)}</td>}
                              <td style={{ padding: "8px 4px", textAlign: "right" }}>{formatMoney(s.tax10, tenantProfile?.marketId)}</td>
                              <td style={{ padding: "8px 4px", textAlign: "right", fontWeight: 900 }}>{formatMoney(s.total, tenantProfile?.marketId)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                </div>}
                {wsSummaryTab === "product" && <div>
                {/* 商品別ランキング */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 14, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 10 }}>{isAU ? "📦 Sales ranking by product" : "📦 商品別売上ランキング"}</div>
                  <WsSummaryPeriodUI />
                  {!wsSummaryStart || !wsSummaryEnd ? (
                    <div style={{ opacity: 0.6, fontSize: 13, padding: "12px 0" }}>{isAU ? "↑ Select a date range to see the ranking" : "↑ 期間を指定して集計してください"}</div>
                  ) : wsRankLoading ? (
                    <div style={{ opacity: 0.7, fontSize: 13, padding: "12px 0" }}>{isAU ? "Loading..." : "取得中..."}</div>
                  ) : wsRankAllOrders === null ? (
                    <div style={{ opacity: 0.6, fontSize: 13, padding: "12px 0" }}>{isAU ? "↑ Select a date range to see the ranking" : "↑ 期間を指定して集計してください"}</div>
                  ) : productRanking.length === 0 ? (
                    <div style={{ opacity: 0.7 }}>{isAU ? "(No data)" : "（データなし）"}</div>
                  ) : (
                    <div style={{ overflowX: "auto" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 600 }}>
                        <thead>
                          <tr style={{ borderBottom: "1px solid #eee" }}>
                            <th style={{ textAlign: "left", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Rank" : "順位"}</th>
                            <th style={{ textAlign: "left", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Product" : "商品名"}</th>
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Qty sold" : "販売数"}</th>
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Subtotal" : "小計"}</th>
                            {!isAU && <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>税8%</th>}
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "GST 10%" : "税10%"}</th>
                            <th style={{ textAlign: "right", padding: "8px 4px", fontSize: 12 }}>{isAU ? "Total" : "合計"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productRanking.map((p, idx) => (
                            <tr key={idx} style={{ borderBottom: "1px solid #f4f4f4" }}>
                              <td style={{ padding: "8px 4px", fontWeight: 900 }}>{idx + 1}</td>
                              <td style={{ padding: "8px 4px", fontWeight: 900 }}>{p.name}</td>
                              <td style={{ padding: "8px 4px", textAlign: "right" }}>{p.qty}</td>
                              <td style={{ padding: "8px 4px", textAlign: "right" }}>{formatMoney(p.subtotal, tenantProfile?.marketId)}</td>
                              {!isAU && <td style={{ padding: "8px 4px", textAlign: "right" }}>{yen(p.tax8)}</td>}
                              <td style={{ padding: "8px 4px", textAlign: "right" }}>{formatMoney(p.tax10, tenantProfile?.marketId)}</td>
                              <td style={{ padding: "8px 4px", textAlign: "right", fontWeight: 900 }}>{formatMoney(p.total, tenantProfile?.marketId)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                </div>}
                {wsSummaryTab === "shop" && <div>
                {/* 取引先別売上 */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 14, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 16, marginBottom: 10 }}>{isAU ? "📈 Sales by customer" : "📈 取引先別売上"}</div>
                  {(() => {
                    // 取引先一覧（shopIdベース。取引先識別はresolveCounterpartyKeyに統一する
                    // ——o.shopName文字列照合は、オンライン注文がshopNameを持たないため
                    // 取りこぼす欠陥があった）
                    const shopList = (shops || []).map(s => ({ id: s.id || s._docId, name: s.company || s.name || s.id })).filter(s => s.id);
                    const selectedShopEntry = shopList.find(s => s.id === selectedShop) || null;
                    const selectedShopData = selectedShopEntry
                      ? (shops || []).find(s => (s.id || s._docId) === selectedShopEntry.id)
                      : null;
                    const selectedPartnerKey = selectedShopData
                      ? (selectedShopData.retailTenantId
                          ? { kind: "tenant", id: selectedShopData.retailTenantId }
                          : { kind: "shop", id: selectedShopData.id || selectedShopData._docId })
                      : null;

                    // データソース：期間指定取得済みならそちら、なければ通常の30日分。
                    // ただしshopRangeErrorがtrue（直前の期間取得が失敗した）の間は、
                    // 30日分のグローバル購読ordersへのフォールバックを使わない——
                    // 指定した期間と異なる不完全なデータを、あたかも取得結果である
                    // かのように表示してしまうため
                    const baseOrders = shopRangeError ? [] : (shopRangeOrders !== null ? shopRangeOrders : (orders || []));

                    // フィルタリング。集計基準は納品書発行ベースに一本化、取引先照合は
                    // resolveCounterpartyKey(o, "fromWholesale")による正規識別子で行う
                    const filteredShopOrders = baseOrders.filter((o) => {
                      if (!isDeliveredAndCounted(o)) return false;
                      if (selectedPartnerKey && !partnerKeyEquals(resolveCounterpartyKey(o, "fromWholesale"), selectedPartnerKey)) return false;
                      return true;
                    });

                    // 合計金額は必ずgetOrderAmounts（orderSnapshot参照）の単純合算で算出する。
                    // 商品別内訳（表示補助）のみ明細走査を許容する
                    const productSummary = {};
                    filteredShopOrders.forEach(o => getOrderLines(o).forEach((l) => {
                      const pid = l.name || "不明";
                      if (!productSummary[pid]) productSummary[pid] = { name: l.name || "不明", qty: 0, amount: 0 };
                      productSummary[pid].qty += Number(l.qty || 0);
                      productSummary[pid].amount += Number(l.qty || 0) * Number(l.price || 0);
                    }));
                    // 税率内訳の信頼性は注文単位で判定する——集計対象群全体に対して1つの
                    // breakdownAvailableを持たせると、1件でも内訳が信頼できない注文が
                    // 混ざるだけで他の全注文の正しいtax8が丸ごと0円に破棄されてしまう
                    // バグがあったため（2026-08修正）。2026-08修正（Codexレビュー指摘
                    // 対応・v4）：tax8/tax10のnull判定は機能しなくなったため、
                    // hasInvalidRatesで判定する。該当注文は自分自身のtaxのみを
                    // tax10へ暫定計上し、他の注文の内訳には一切影響しない
                    let subtotal = 0, tax8 = 0, tax10 = 0, total = 0;
                    filteredShopOrders.forEach((o) => {
                      const a = getOrderAmounts(o, tenantProfile?.marketId);
                      subtotal += a.subtotal; total += a.total;
                      if (a.hasInvalidRates) { tax10 += a.tax; }
                      else { tax8 += a.tax8; tax10 += a.tax10; }
                    });
                    const productList = Object.values(productSummary).sort((a, b) => b.amount - a.amount).slice(0, 10);

                    return (
                      <div style={{ display: "grid", gap: 10 }}>
                        {/* 検索条件 */}
                        <div style={{ display: "grid", gap: 8 }}>
                          <div>
                            <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 4 }}>{isAU ? "Customer" : "取引先（小売店）"}</div>
                            <select
                              value={selectedShop}
                              onChange={(e) => setSelectedShop(e.target.value)}
                              style={{ width: "100%", padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700 }}
                            >
                              <option value="">{isAU ? "All" : "すべて"}</option>
                              {shopList.map(s => (
                                <option key={s.id} value={s.id}>{s.name}</option>
                              ))}
                            </select>
                          </div>

                          <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                            <div style={{ fontWeight: 700, fontSize: 12 }}>{isAU ? "Date range" : "期間"}</div>
                            <input
                              type="date"
                              value={draftShopStartDate}
                              onChange={(e) => setDraftShopStartDate(e.target.value)}
                              style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700 }}
                            />
                            <span style={{ opacity: 0.7 }}>〜</span>
                            <input
                              type="date"
                              value={draftShopEndDate}
                              onChange={(e) => setDraftShopEndDate(e.target.value)}
                              style={{ padding: "8px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700 }}
                            />
                            <button
                              onClick={async () => {
                                setShopStartDate(draftShopStartDate);
                                setShopEndDate(draftShopEndDate);
                                if (draftShopStartDate && draftShopEndDate) {
                                  await fetchShopRangeOrders(draftShopStartDate, draftShopEndDate);
                                } else {
                                  shopRangeRequestIdRef.current++; // 進行中のリクエストがあれば無効化する
                                  setShopRangeOrders(null);
                                  setShopRangeError(false);
                                }
                              }}
                              style={{ padding: "7px 14px", borderRadius: 10, border: "none", background: "#111", color: "white", fontWeight: 900, fontSize: 12, cursor: "pointer", whiteSpace: "nowrap" }}
                            >
                              {shopRangeLoading ? (isAU ? "Loading…" : "取得中…") : (isAU ? "🔍 Filter" : "🔍 絞り込む")}
                            </button>
                            {(shopStartDate || shopEndDate) && (
                              <button
                                onClick={() => {
                                  shopRangeRequestIdRef.current++; // 進行中のリクエストがあれば無効化する
                                  setShopStartDate(""); setShopEndDate(""); setDraftShopStartDate(""); setDraftShopEndDate(""); setShopRangeOrders(null); setShopRangeError(false);
                                }}
                                style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", cursor: "pointer", fontSize: 12 }}
                              >
                                {isAU ? "Clear" : "クリア"}
                              </button>
                            )}
                          </div>
                          {shopRangeOrders !== null && shopStartDate && shopEndDate && (
                            <div style={{ fontSize: 11, color: "#1d4ed8", background: "#dbeafe", borderRadius: 6, padding: "3px 8px", display: "inline-block" }}>
                              {isAU ? `📅 ${shopStartDate} – ${shopEndDate} (all data loaded)` : `📅 ${shopStartDate} 〜 ${shopEndDate}（全件取得済み）`}
                            </div>
                          )}
                        </div>

                        {/* サマリー */}
                        {shopRangeLoading ? (
                          <div style={{ opacity: 0.7, fontSize: 13, marginTop: 8 }}>{isAU ? "Loading..." : "取得中..."}</div>
                        ) : shopRangeError ? (
                          <div style={{ opacity: 0.85, fontSize: 13, marginTop: 8, color: "#dc2626" }}>
                            {isAU ? "⚠ Failed to load summary data. Please try again." : "⚠ 集計データの取得に失敗しました。再度お試しください。"}
                          </div>
                        ) : (!selectedShop && shopRangeOrders === null) ? (
                          <div style={{ opacity: 0.6, fontSize: 13, marginTop: 8 }}>{isAU ? "↑ Select a customer or date range" : "↑ 取引先または期間を指定してください"}</div>
                        ) : filteredShopOrders.length === 0 ? (
                          <div style={{ opacity: 0.7, fontSize: 13, marginTop: 8 }}>{isAU ? "(No matching data)" : "（該当データなし）"}</div>
                        ) : (
                          <div style={{ display: "grid", gap: 8, marginTop: 8 }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, fontSize: 13 }}>
                              {isAU ? (
                                <>
                                  <div>Orders: <b>{filteredShopOrders.length}</b></div>
                                  <div style={{ textAlign: "right" }}>Subtotal: <b>{formatMoney(subtotal, tenantProfile?.marketId)}</b></div>
                                  <div>GST 10%: <b>{formatMoney(tax10, tenantProfile?.marketId)}</b></div>
                                </>
                              ) : (
                                <>
                                  <div>取引回数：<b>{filteredShopOrders.length}件</b></div>
                                  <div style={{ textAlign: "right" }}>小計：<b>{yen(subtotal)}</b></div>
                                  <div>消費税8%：<b>{yen(tax8)}</b></div>
                                  <div style={{ textAlign: "right" }}>消費税10%：<b>{yen(tax10)}</b></div>
                                </>
                              )}
                            </div>
                            <div style={{ paddingTop: 6, borderTop: "1px solid #eee", fontWeight: 900, textAlign: "right" }}>
                              {isAU ? `Total (inc GST): ${formatMoney(total, tenantProfile?.marketId)}` : `合計（税込）：${yen(total)}`}
                            </div>
                            {productList.length > 0 && (
                              <div style={{ marginTop: 6 }}>
                                <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 4 }}>{isAU ? "Top 5 products" : "商品TOP5"}</div>
                                <div style={{ fontSize: 12 }}>
                                  {productList.slice(0, 5).map((p, idx) => (
                                    <div key={idx} style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}>
                                      <span>{p.name}</span>
                                      <span style={{ fontWeight: 700 }}>{formatMoney(p.amount, tenantProfile?.marketId)}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
                </div>}
              </div>
            );
          })()}
          {mode === "wholesale" && wholesaleView === "manual" && (() => {
            // prefetch済みキャッシュに対するローカル検索結果をそのまま使用（Firestore通信なし）
            const searchResult = manualFsResults;

            // 明細の合計計算（原価優先）。不正な税率の行は税額計算に含めず
            // hasInvalidTaxRateで呼び出し側に通知する（0.1への推測は行わない。
            // 最終確定はcreateManualOrder Callableのサーバー側検証が担保する）。
            // 2026-08 AU版基盤（Phase 3）：市場別policy/roundFnを使う。AU版は
            // AU_TAX_POLICY（8%区分を許可しない）とAUD centsの丸めを使う
            const manualTaxPolicy = resolveTaxPolicy(tenantProfile?.marketId);
            const manualRoundFn = isAU ? roundAUD : Math.round;
            // 2026-08（Codexレビュー2回目・3回目MUST-FIX対応）：以前は未丸めの単価を
            // そのまま数量倍しており保存処理と丸め順序が一致していなかった（2回目で
            // 対応）。さらに、プレビューは明細自身のcostPrice/priceだけを見ていた一方、
            // 保存処理は商品マスタ（catalog）優先で単価を解決していたため、手動編集値と
            // カタログ値が食い違う場合に表示金額と実際の保存単価がずれていた（3回目で
            // 発覚）。resolveManualLineUnitPriceへ一本化し、プレビュー・保存の両方が
            // 必ず同じ単価解決ロジックを通るようにする。
            // 2026-08（Codexレビュー4回目MUST-FIX対応）：単価（priceVal）は統一した
            // 一方、税率は依然としてプレビュー側がl.taxRate（明細自身の値）を参照し、
            // 保存側はresolveManualLineUnitPriceが返すtaxRate（マスタ優先）を使って
            // いたため、商品マスタの税率が明細と異なる場合（例：明細GST-free、
            // マスタGST10%）にプレビューGSTと実際の保存GSTが一致しなかった。
            // 税率もresolveManualLineUnitPriceの返り値に統一する
            let mSubtotal = 0, mTax = 0, mHasInvalidTaxRate = false;
            (manualLines || []).forEach(l => {
              const { priceVal, taxRate: resolvedTaxRate } = resolveManualLineUnitPrice(l, manualRoundFn);
              const amt = priceVal * Number(l.qty || 0);
              mSubtotal += amt;
              const tr = safeDisplayTaxRate(resolvedTaxRate, manualTaxPolicy);
              if (tr === null) { mHasInvalidTaxRate = true; return; }
              mTax += manualRoundFn(amt * tr);
            });
            const mTotal = mSubtotal + mTax;

            const lineStyle = { padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box", width: "100%" };
            const labelStyle = { fontWeight: 700, fontSize: 12, marginBottom: 4 };

            return (
              <div style={{ display: "grid", gap: 14, maxWidth: 960, paddingBottom: 120 }}>

                {/* ① 取引先選択 */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 10 }}>{isAU ? "① Customer" : "① 取引先（小売店）"}</div>
                  {shops.length === 0 ? (
                    <div style={{ display: "grid", gap: 10 }}>
                      <div style={{ fontSize: 13, opacity: 0.7 }}>{isAU ? "No customers registered yet." : "取引先が登録されていません。"}</div>
                      <button
                        onClick={() => { setShopModalMode("add"); setShopModalName(""); setShopModalCompany(""); setShopModalAddress(""); setShopModalTel(""); setShopModalFax(""); setShopModalNote(""); setShopModalEmail(""); setShopModalInvoiceNo(""); setShopModalOpen(true); }}
                        style={{ padding: "10px 16px", borderRadius: 10, background: "#111", color: "white", fontWeight: 900, fontSize: 14, border: "none", cursor: "pointer", width: "fit-content" }}
                      >
                        {isAU ? "+ Add customer" : "＋ 取引先を追加"}
                      </button>
                    </div>
                  ) : (
                    <select
                      value={manualShopId}
                      onChange={e => setManualShopId(e.target.value)}
                      style={{ ...lineStyle, fontWeight: manualShopId ? 900 : 400 }}
                    >
                      <option value="">{isAU ? "-- Select a customer --" : "-- 小売店を選択 --"}</option>
                      {shops.map(s => {
                        const displayName = (s.name && !s.name.includes("@") ? s.name : "") || (s.company && !s.company.includes("@") ? s.company : "") || s.name || s.id;
                        return <option key={s.id} value={s.id}>{displayName}</option>;
                      })}
                    </select>
                  )}
                  {manualShopId && (() => {
                    const sh = shops.find(s => s.id === manualShopId);
                    if (!sh) return null;
                    return (
                      <div style={{ marginTop: 8, fontSize: 12, opacity: 0.75, display: "grid", gap: 2 }}>
                        {sh.address && <div>📍 {sh.address}</div>}
                        {sh.tel && <div>📞 {sh.tel}</div>}
                        {sh.fax && <div>📠 {sh.fax}</div>}
                      </div>
                    );
                  })()}
                </div>

                {/* よく注文する商品（過去30日履歴） */}
                {manualShopId && shopHistoryProducts.length > 0 && (
                  <div style={{ border: "1px solid #e0f0ff", borderRadius: 14, padding: 16, background: "#f0f8ff" }}>
                    <div style={{ fontWeight: 900, fontSize: 14, marginBottom: 10, color: "#1a6bbf" }}>
                      {isAU ? "🕐 Frequently ordered (last 30 days)" : "🕐 よく注文する商品（直近30日）"}
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {shopHistoryProducts.map((p, idx) => {
                        const costVal = Number(p.costPrice ?? 0) > 0 ? Number(p.costPrice) : Number(p.price ?? 0);
                        const addProduct = () => {
                          // taxRateは推測補完せず生値のまま渡す。不正ならcreateManualOrder Callable側で拒否される
                          const newLine = { id: p.id, barcode: p.barcode || "", name: p.name, unit: p.unit || "", price: costVal, costPrice: costVal, taxRate: Number(p.taxRate), qty: 1 };
                          if (mode === "wholesale" && !(costVal > 0)) {
                            setPriceCheckModal({
                              order: null,
                              mode: "manual-line-add",
                              editLines: [newLine],
                              onComplete: (updatedLines) => {
                                setManualLines(prev => {
                                  const exists = prev.findIndex(l => l.id === newLine.id);
                                  if (exists >= 0) {
                                    const next = [...prev];
                                    next[exists] = { ...next[exists], qty: next[exists].qty + 1, costPrice: updatedLines[0].costPrice, price: updatedLines[0].costPrice };
                                    return next;
                                  }
                                  return [...prev, updatedLines[0]];
                                });
                              }
                            });
                          } else {
                            setManualLines(prev => {
                              const exists = prev.findIndex(l => l.id === p.id);
                              if (exists >= 0) {
                                const next = [...prev];
                                next[exists] = { ...next[exists], qty: next[exists].qty + 1 };
                                return next;
                              }
                              return [...prev, newLine];
                            });
                          }
                        };
                        const alreadyAdded = manualLines.some(l => l.id === p.id);
                        return (
                          <button
                            key={idx}
                            onClick={addProduct}
                            style={{
                              padding: "8px 12px", borderRadius: 20,
                              border: alreadyAdded ? "2px solid #1a6bbf" : "1px solid #b3d4f5",
                              background: alreadyAdded ? "#dbeafe" : "white",
                              cursor: "pointer", textAlign: "left",
                              display: "flex", flexDirection: "column", gap: 2,
                            }}
                          >
                            <span style={{ fontWeight: 700, fontSize: 13, color: "#1a3a5c" }}>{p.name}</span>
                            <span style={{ fontSize: 11, color: "#555" }}>
                              {isAU ? `${p.orderCount}x / total ${p.totalQty}${p.unit || ""}` : `${p.orderCount}回 / 計${p.totalQty}${p.unit || ""}`}
                              {costVal > 0 ? ` · ${formatMoney(costVal, tenantProfile?.marketId)}` : ""}
                              {alreadyAdded ? " ✓" : ""}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* ② 明細入力 */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 12 }}>{isAU ? "② Order lines" : "② 明細入力"}</div>

                  {/* 商品マスタから検索して追加 */}
                  <div style={{ marginBottom: 12 }}>
                    <div style={labelStyle}>{isAU ? "Search products (name or barcode)" : "商品マスタから検索（商品名・読み仮名の部分一致 or JANコード）"}</div>
                    {manualProductsState === "loading" && (
                      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 12px", borderRadius: 10, border: "1px solid #ddd", background: "#fafafa", color: "#666", fontSize: 13, marginBottom: 8 }}>
                        <span style={{ display: "inline-block", width: 16, height: 16, border: "2px solid #ddd", borderTopColor: "#555", borderRadius: "50%", animation: "spin 0.7s linear infinite", flexShrink: 0 }} />
                        {isAU ? "Preparing product data…" : "商品データを準備しています…"}
                      </div>
                    )}
                    {manualProductsState === "error" && (
                      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, border: "1px solid #fca5a5", background: "#fef2f2", color: "#b91c1c", fontSize: 13, marginBottom: 8 }}>
                        <span>{isAU ? "⚠ Failed to load product data. Please retry." : "⚠ 商品データの取得に失敗しました。再試行してください。"}</span>
                        <button
                          type="button"
                          onClick={() => {
                            // クリック時点の「テナント世代」と「画面セッショントークン」の
                            // 両方をクロージャに固定する。世代はテナント切替（[tenantId]の
                            // 変更）で、セッショントークンは画面離脱（mode/wholesaleViewが
                            // "manual"でなくなること）で、それぞれ独立にインクリメントされる。
                            // 結果が返ってきた時点でどちらかが変化していれば、その間に
                            // テナント切替または画面離脱が起きたと判定し、状態を上書きしない
                            const retryGeneration = manualProductsGenerationRef.current;
                            const retrySessionToken = manualProductsSessionTokenRef.current;
                            const isStale = () =>
                              retryGeneration !== manualProductsGenerationRef.current ||
                              retrySessionToken !== manualProductsSessionTokenRef.current;
                            manualProductsCache.current.delete(tenantId);
                            setManualProductsState("loading");
                            fetchManualProductsForTenant(tenantId)
                              .then(() => {
                                if (isStale()) return;
                                setManualProductsState("ready");
                              })
                              .catch((e) => {
                                console.error("[manualProducts retry error]", e);
                                if (isStale()) return;
                                setManualProductsState("error");
                              });
                          }}
                          style={{ padding: "4px 12px", borderRadius: 8, border: "none", background: "#b91c1c", color: "white", fontWeight: 700, fontSize: 12, cursor: "pointer", flexShrink: 0 }}
                        >
                          {isAU ? "Retry" : "再試行"}
                        </button>
                      </div>
                    )}
                    <div style={{ position: "relative" }}>
                      <div style={{ display: "flex", gap: 8 }}>
                        <input
                          value={manualSearch}
                          onChange={e => { setManualSearch(e.target.value); setManualSearchOpen(true); }}
                          onFocus={() => setManualSearchOpen(true)}
                          onBlur={() => setTimeout(() => setManualSearchOpen(false), 200)}
                          disabled={manualProductsState !== "ready"}
                          placeholder={
                            manualProductsState === "ready"
                              ? (isAU ? "Enter product name or barcode..." : "商品名を入力 or JANコード...")
                              : (isAU ? "Please wait for product data to load..." : "商品データの準備が完了するまでお待ちください...")
                          }
                          style={{ ...lineStyle, flex: 1, ...(manualProductsState !== "ready" ? { background: "#f3f4f6", cursor: "not-allowed" } : {}) }}
                        />
                        <button
                          type="button"
                          onClick={() => { setScanTarget("manual"); setScannerOpen(true); setJanMode("scan"); }}
                          style={{ padding: "10px 14px", borderRadius: 10, border: "1px solid #ddd", background: "white", cursor: "pointer", fontSize: 20, flexShrink: 0 }}
                          title={isAU ? "Scan barcode with camera" : "カメラでJANスキャン"}
                        >
                          📷
                        </button>
                      </div>
                      {manualSearchOpen && manualSearch.trim() && manualProductsState === "ready" && (
                        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "white", border: "1px solid #ddd", borderRadius: 10, zIndex: 100, maxHeight: 240, overflowY: "auto", boxShadow: "0 4px 16px rgba(0,0,0,0.12)" }}>
                          {manualFsLoading && (
                            <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 8, color: "#888", fontSize: 13 }}>
                              <span style={{ display: "inline-block", width: 14, height: 14, border: "2px solid #ddd", borderTopColor: "#555", borderRadius: "50%", animation: "spin 0.7s linear infinite", flexShrink: 0 }} />
                              {isAU ? "Searching..." : "検索中..."}
                            </div>
                          )}
                          {!manualFsLoading && searchResult.length === 0 && (
                            <div style={{ padding: "12px 14px", color: "#888", fontSize: 13 }}>
                              {isAU ? `No products match "${manualSearch}"` : `「${manualSearch}」に一致する商品が見つかりません`}
                            </div>
                          )}
                          {!manualFsLoading && searchResult.map(p => (
                            <div
                              key={p.id}
                              onClick={() => {
                                // taxRateは推測補完せず生値のまま渡す。不正ならcreateManualOrder Callable側で拒否される
                                const newLine = { id: p.id, barcode: p.barcode || "", name: p.name, unit: p.unit || "", price: Number(p.costPrice || 0), costPrice: Number(p.costPrice || 0), taxRate: Number(p.taxRate), qty: 1 };
                                if (mode === "wholesale" && !(Number(p.costPrice) > 0)) {
                                  // 原価未登録 → priceCheckModalで入力させる
                                  setPriceCheckModal({
                                    order: null,
                                    mode: "manual-line-add",
                                    editLines: [newLine],
                                    onComplete: (updatedLines) => {
                                      setManualLines(prev => {
                                        const exists = prev.findIndex(l => l.id === newLine.id);
                                        if (exists >= 0) {
                                          const next = [...prev];
                                          next[exists] = { ...next[exists], qty: next[exists].qty + 1, costPrice: updatedLines[0].costPrice, price: updatedLines[0].costPrice };
                                          return next;
                                        }
                                        return [...prev, updatedLines[0]];
                                      });
                                    }
                                  });
                                } else {
                                  setManualLines(prev => {
                                    const exists = prev.findIndex(l => l.id === p.id);
                                    if (exists >= 0) {
                                      const next = [...prev];
                                      next[exists] = { ...next[exists], qty: next[exists].qty + 1 };
                                      return next;
                                    }
                                    return [...prev, newLine];
                                  });
                                }
                                setManualSearch("");
                                setManualSearchOpen(false);
                              }}
                              style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f4f4f4", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                            >
                              <div>
                                <div style={{ fontWeight: 700, fontSize: 13 }}>{p.name}</div>
                                <div style={{ fontSize: 11, opacity: 0.6 }}>{p.barcode || ""}{p.unit ? ` / ${p.unit}` : ""}</div>
                              </div>
                              <div style={{ fontWeight: 900, fontSize: 13 }}>{formatMoney(p.costPrice || p.price || 0, tenantProfile?.marketId)}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* 手入力で追加 */}
                  <div style={{ marginBottom: 12 }}>
                    <button
                      onClick={() => setManualInputOpen(v => !v)}
                      style={{ padding: "8px 14px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 700, fontSize: 13, cursor: "pointer", background: manualInputOpen ? "#111" : "white", color: manualInputOpen ? "white" : "#333" }}
                    >
                      {isAU ? "✏️ Add manually" : "✏️ 手入力で追加"}
                    </button>
                    {manualInputOpen && (
                      <div style={{ marginTop: 10, padding: 14, background: "#fafafa", borderRadius: 12, display: "grid", gap: 10 }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                          <div>
                            <div style={labelStyle}>{isAU ? "Product name *" : "商品名 *"}</div>
                            <input value={manualInputName} onChange={e => setManualInputName(e.target.value)} placeholder={isAU ? "e.g. Sparkling Water 24pk" : "例）キャベツ"} style={lineStyle} />
                          </div>
                          <div>
                            <div style={labelStyle}>{isAU ? "Barcode" : "JANコード"}</div>
                            <input value={manualInputBarcode} onChange={e => setManualInputBarcode(e.target.value)} placeholder={isAU ? "e.g. 9310000000011" : "例）4900000000011"} style={lineStyle} />
                          </div>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8 }}>
                          {mode !== "wholesale" && (
                          <div>
                            <div style={labelStyle}>{isAU ? "Sell price (ex GST)" : "売価（税抜）"}</div>
                            <input type="number" value={manualInputPrice} onChange={e => setManualInputPrice(e.target.value)} placeholder="0" style={lineStyle} />
                          </div>
                          )}
                          <div>
                            <div style={labelStyle}>{isAU ? "Cost price (ex GST)" : "原価（税抜）"}</div>
                            <input type="number" value={manualInputCost} onChange={e => setManualInputCost(e.target.value)} placeholder="0" style={lineStyle} />
                          </div>
                          <div>
                            <div style={labelStyle}>{isAU ? "GST rate" : "税率"}</div>
                            <select value={manualInputTax} onChange={e => setManualInputTax(e.target.value)} style={lineStyle}>
                              {isAU ? (
                                <>
                                  <option value="0.1">GST 10%</option>
                                  <option value="0">GST-free (0%)</option>
                                </>
                              ) : (
                                <>
                                  <option value="0.1">10%</option>
                                  <option value="0.08">8%</option>
                                  <option value="0">非課税</option>
                                </>
                              )}
                            </select>
                          </div>
                          <div>
                            <div style={labelStyle}>{isAU ? "Quantity" : "数量"}</div>
                            <input type="number" value={manualInputQty} onChange={e => setManualInputQty(e.target.value)} placeholder="1" style={lineStyle} />
                          </div>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, alignItems: "flex-end" }}>
                          <div>
                            <div style={labelStyle}>{isAU ? "Unit" : "単位"}</div>
                            <input value={manualInputUnit} onChange={e => setManualInputUnit(e.target.value)} placeholder={isAU ? "e.g. carton, kg, each" : "例）玉・kg・本"} style={lineStyle} />
                          </div>
                          <button
                            onClick={() => {
                              if (!manualInputName.trim()) return alert(isAU ? "Please enter a product name" : "商品名を入力してください");
                              const newLine = {
                                id: `M-${Date.now()}`,
                                barcode: manualInputBarcode.trim(),
                                name: manualInputName.trim(),
                                unit: manualInputUnit.trim(),
                                price: Number(manualInputCost || manualInputPrice || 0),
                                costPrice: Number(manualInputCost || 0),
                                taxRate: Number(manualInputTax || 0.1),
                                qty: Number(manualInputQty || 1),
                              };
                              if (mode === "wholesale" && !(Number(newLine.costPrice) > 0)) {
                                // 原価未登録 → priceCheckModalで入力させてから追加
                                setPriceCheckModal({
                                  order: null,
                                  mode: "manual-line-add",
                                  editLines: [newLine],
                                  onComplete: (updatedLines) => {
                                    setManualLines(prev => [...prev, updatedLines[0]]);
                                  }
                                });
                              } else {
                                setManualLines(prev => [...prev, newLine]);
                              }
                              setManualInputName(""); setManualInputBarcode(""); setManualInputPrice("");
                              setManualInputCost(""); setManualInputQty("1"); setManualInputUnit("");
                              setManualInputOpen(false);
                            }}
                            style={{ padding: "10px 18px", borderRadius: 10, background: "#111", color: "white", fontWeight: 900, fontSize: 13, cursor: "pointer", border: "none", whiteSpace: "nowrap" }}
                          >
                            {isAU ? "+ Add" : "＋ 追加"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* 明細リスト */}
                  {manualLines.length === 0 ? (
                    <div style={{ fontSize: 13, opacity: 0.5, padding: "16px 0", textAlign: "center" }}>{isAU ? "(No lines yet)" : "（明細がまだありません）"}</div>
                  ) : (
                    <div style={{ display: "grid", gap: 6 }}>
                      {manualLines.map((l, idx) => {
                        // 2026-08（Codexレビュー2回目・3回目・4回目MUST-FIX対応）：保存処理と
                        // 同じresolveManualLineUnitPriceを使い、単価・税率の両方の解決
                        // ロジックを統一する（4回目レビューで、単価は統一済みだが税率は
                        // l.taxRate（明細自身の値）のまま参照しており、マスタ税率と食い違う
                        // ケースでプレビューGSTと保存GSTが一致しないことが発覚した）。
                        // isMissingCost判定は元々costPrice単独（priceフォールバックなし）を
                        // 見ていたため、マスタ優先後の表示用cpとは別にrawCpForMissingCheckで判定する
                        const rawCpForMissingCheck = Number(l.costPrice ?? 0);
                        const { priceVal: cp, taxRate: resolvedLineTaxRate } = resolveManualLineUnitPrice(l, manualRoundFn);
                        const amt = cp * Number(l.qty || 0);
                        const lineTaxRate = safeDisplayTaxRate(resolvedLineTaxRate, manualTaxPolicy);
                        const tax = lineTaxRate === null ? 0 : manualRoundFn(amt * lineTaxRate);
                        const isMissingCost = mode === "wholesale" && !(rawCpForMissingCheck > 0);
                        return (
                          <div key={l.id} style={{ padding: "10px 12px", border: isMissingCost ? "1.5px solid #fca5a5" : "1px solid #eee", borderRadius: 10, background: isMissingCost ? "#fff5f5" : "white" }}>
                            <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                              <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 900, fontSize: 13 }}>{l.name}</div>
                                <div style={{ fontSize: 11, opacity: 0.6, marginTop: 2 }}>
                                  {l.barcode && (isAU ? `Barcode: ${l.barcode}　` : `JAN: ${l.barcode}　`)}
                                  {isAU ? "GST: " : "税率: "}<TaxRateBadge rawTaxRate={resolvedLineTaxRate} isAU={isAU} />
                                </div>
                                {isMissingCost && (
                                  <button
                                    onClick={() => setPriceCheckModal({
                                      order: null,
                                      mode: "manual-line-add",
                                      editLines: [{ ...l }],
                                      onComplete: (updatedLines) => {
                                        setManualLines(prev => prev.map((x, i) => i === idx ? { ...x, costPrice: updatedLines[0].costPrice, price: updatedLines[0].costPrice } : x));
                                      }
                                    })}
                                    style={{ marginTop: 4, padding: "3px 10px", borderRadius: 6, background: "#dc2626", color: "white", border: "none", fontSize: 11, fontWeight: 700, cursor: "pointer" }}
                                  >
                                    {isAU ? "⚠ Enter cost price" : "⚠ 原価を入力"}
                                  </button>
                                )}
                              </div>
                              <div style={{ textAlign: "right", fontSize: 13, flexShrink: 0 }}>
                                {isMissingCost
                                  ? <div style={{ color: "#dc2626", fontWeight: 700, fontSize: 12 }}>{isAU ? "Cost not set" : "原価未登録"}</div>
                                  : <div style={{ fontWeight: 900 }}>{formatMoney(amt + tax, tenantProfile?.marketId)}</div>
                                }
                                <div style={{ fontSize: 11, opacity: 0.6 }}>
                                  {isMissingCost ? "—" : formatMoney(cp, tenantProfile?.marketId)} × {l.qty}{l.unit}
                                </div>
                              </div>
                              <button
                                onClick={() => setManualLines(prev => prev.filter((_, i) => i !== idx))}
                                style={{ padding: "4px 8px", borderRadius: 8, border: "1px solid #ddd", background: "white", cursor: "pointer", fontSize: 12, flexShrink: 0 }}
                              >✕</button>
                            </div>
                            {/* 数量調整 */}
                            <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8 }}>
                              <span style={{ fontSize: 12, opacity: 0.7 }}>{isAU ? "Qty: " : "数量："}</span>
                              <button onClick={() => setManualLines(prev => prev.map((x, i) => i === idx ? { ...x, qty: Math.max(1, x.qty - 1) } : x))}
                                style={{ width: 28, height: 28, borderRadius: 8, border: "1px solid #ddd", background: "white", cursor: "pointer", fontWeight: 900 }}>－</button>
                              <input
                                type="number"
                                value={l.qty}
                                onChange={e => setManualLines(prev => prev.map((x, i) => i === idx ? { ...x, qty: Math.max(1, Number(e.target.value) || 1) } : x))}
                                style={{ width: 52, textAlign: "center", padding: "4px 6px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, fontWeight: 900 }}
                              />
                              <button onClick={() => setManualLines(prev => prev.map((x, i) => i === idx ? { ...x, qty: x.qty + 1 } : x))}
                                style={{ width: 28, height: 28, borderRadius: 8, border: "1px solid #ddd", background: "white", cursor: "pointer", fontWeight: 900 }}>＋</button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* ③ 備考 */}
                <div style={{ border: "1px solid #eee", borderRadius: 14, padding: 16, background: "white" }}>
                  <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 10 }}>{isAU ? "③ Notes" : "③ 備考"}</div>
                  <textarea
                    value={manualNote}
                    onChange={e => setManualNote(e.target.value)}
                    placeholder={isAU ? "Delivery time, special instructions, etc." : "配達日時・特記事項など"}
                    rows={3}
                    style={{ ...lineStyle, resize: "vertical" }}
                  />
                </div>

                {/* ④ 合計・保存 */}
                {manualLines.length > 0 && (
                  <div style={{ border: "2px solid #111", borderRadius: 14, padding: 16, background: "white" }}>
                    <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 10 }}>{isAU ? "④ Total" : "④ 合計"}</div>
                    <div style={{ display: "grid", gap: 4, fontSize: 13, marginBottom: 14 }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>{isAU ? "Subtotal (ex GST)" : "小計（税抜）"}</span><span style={{ fontWeight: 700 }}>{formatMoney(mSubtotal, tenantProfile?.marketId)}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>{isAU ? "GST" : "消費税"}</span><span style={{ fontWeight: 700 }}>{formatMoney(mTax, tenantProfile?.marketId)}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 8, borderTop: "1px solid #eee", fontSize: 18, fontWeight: 900 }}>
                        <span>{isAU ? "Total (inc GST)" : "合計（税込）"}</span><span>{formatMoney(mTotal, tenantProfile?.marketId)}</span>
                      </div>
                      {mHasInvalidTaxRate && (
                        <div style={{ color: "#dc2626", fontWeight: 700, fontSize: 12 }}>
                          {isAU
                            ? "⚠ Some lines have an invalid tax rate (not included in the GST total). This will be rejected on save."
                            : "⚠ 税率が不正な明細があります（消費税額に含まれていません）。保存時にエラーになります"}
                        </div>
                      )}
                    </div>
                    {/* ✅ 原価未登録チェック */}
                    {(() => {
                      const missingManualCost = manualLines.filter(l => {
                        const cp = Number(l.costPrice ?? 0);
                        const p = Number(l.price ?? 0);
                        return !(cp > 0 || p > 0);
                      });
                      const hasMissingManualCost = missingManualCost.length > 0;
                      return (
                        <>
                          {hasMissingManualCost && (
                            <div style={{ marginBottom: 10, padding: "8px 12px", background: "#eff6ff", border: "1px solid #fca5a5", borderRadius: 8, fontSize: 12, color: "#dc2626", fontWeight: 700 }}>
                              {isAU
                                ? `⚠ ${missingManualCost.length} product(s) are missing a cost price. Please enter it before saving.`
                                : `⚠ 原価未登録の商品が ${missingManualCost.length} 件あります。原価を入力してください。`}
                            </div>
                          )}
                          <div style={{ display: "grid", gap: 10 }}>
                            <button
                              disabled={hasMissingManualCost || isSavingManualOrder}
                              onClick={() => {
                                saveManualOrder(true);
                              }}
                              style={{ padding: "14px", borderRadius: 12, background: (hasMissingManualCost || isSavingManualOrder) ? "#e5e7eb" : "#111", color: (hasMissingManualCost || isSavingManualOrder) ? "#9ca3af" : "white", fontWeight: 900, fontSize: 15, cursor: (hasMissingManualCost || isSavingManualOrder) ? "not-allowed" : "pointer", border: "none", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
                            >
                              {isSavingManualOrder ? (
                                <>
                                  <span style={{ display: "inline-block", width: 14, height: 14, border: "2px solid rgba(0,0,0,0.2)", borderTopColor: "#666", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
                                  {isAU ? "Processing…" : "処理中…"}
                                </>
                              ) : (isAU ? "🖨 Save order & issue delivery note" : "🖨 受注登録して納品書を発行")}
                            </button>
                            <button
                              disabled={hasMissingManualCost || isSavingManualOrder}
                              onClick={() => {
                                saveManualOrder(false);
                              }}
                              style={{ padding: "14px", borderRadius: 12, background: "white", color: (hasMissingManualCost || isSavingManualOrder) ? "#9ca3af" : "#111", fontWeight: 900, fontSize: 14, cursor: (hasMissingManualCost || isSavingManualOrder) ? "not-allowed" : "pointer", border: (hasMissingManualCost || isSavingManualOrder) ? "2px solid #e5e7eb" : "2px solid #111" }}
                            >
                              {isSavingManualOrder ? (isAU ? "Processing…" : "処理中…") : (isAU ? "💾 Save order only (issue delivery note later)" : "💾 受注登録のみ（納品書は後で）")}
                            </button>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}
              </div>
            );
          })()}

          {/* ===== confirm modal（小売 発注確認）===== */}
          {confirmOpen && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                display: "grid",
                placeItems: "center",
                zIndex: 10000,
                padding: 16,
              }}
            >
              <div style={{ width: "min(760px, 100%)", background: "white", borderRadius: 14, padding: 14 }}>
                <div style={{ fontWeight: 900, marginBottom: 8 }}>{isAU ? "Submit this order?" : "この内容で発注しますか？"}</div>

                <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 10 }}>
                  {isAU ? (
                    <>Supplier: <b>{supplierNameById(supplierId) || supplierId}</b> / Items: <b>{lines.length}</b> / Total: <b>{formatMoney(total, tenantProfile?.marketId)}</b></>
                  ) : (
                    <>仕入れ先：<b>{supplierNameById(supplierId) || supplierId}</b> ／ 明細：<b>{lines.length} 件</b> ／ 合計：<b>{yen(total)}</b></>
                  )}
                </div>

                {orderNote.trim() && (
                  <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 10 }}>
                    {isAU ? <>Notes: <b>{orderNote}</b></> : <>備考：<b>{orderNote}</b></>}
                  </div>
                )}

                {/* 納品日セクション */}
                {(() => {
                  const wsSettings = {
                    leadDays: wholesaleProfile?.leadDays ?? 0,
                    cutoffTime: wholesaleProfile?.cutoffTime ?? null,
                    closedWeekdays: wholesaleProfile?.closedWeekdays ?? [],
                    holidayDates: wholesaleProfile?.holidayDates ?? [],
                    // 2026-08 Codexレビュー指摘対応（MINOR）：wholesaleProfile未取得時の
                    // フォールバックが常にAsia/Tokyoだった。AUテナントでは
                    // Australia/Sydneyへフォールバックする（実運用ではwholesaleProfile.timezoneが
                    // public/profileから正しく複製されるため、通常はこのフォールバックへは
                    // 到達しない想定）
                    timezone: wholesaleProfile?.timezone || (isAU ? "Australia/Sydney" : "Asia/Tokyo"),
                  };
                  const calcedDate = calcDeliveryDate(new Date(), wsSettings);
                  return (
                    <div style={{ background: "#f8fafc", borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
                      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 6, fontWeight: 700 }}>{isAU ? "📅 Delivery date" : "📅 納品日"}</div>
                      <div style={{ fontSize: 13, color: "#374151", marginBottom: 10 }}>
                        {isAU ? (
                          <>Earliest possible delivery: <b style={{ color: "#1a56db" }}>{formatAUDate(calcedDate)}</b></>
                        ) : (
                          <>最短納品可能日：<b style={{ color: "#1a56db" }}>{formatJPDate(calcedDate)}</b></>
                        )}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 13, color: "#374151", whiteSpace: "nowrap" }}>{isAU ? "Requested delivery date (optional):" : "希望納品日（任意）："}</span>
                        <input
                          type="date"
                          value={requestedDeliveryDate}
                          min={calcedDate}
                          onChange={e => setRequestedDeliveryDate(e.target.value)}
                          style={{ padding: "6px 10px", borderRadius: 8, border: "1px solid #ddd", fontSize: 13, fontWeight: 700 }}
                        />
                        {requestedDeliveryDate && (
                          <button
                            onClick={() => setRequestedDeliveryDate("")}
                            style={{ fontSize: 12, color: "#94a3b8", background: "none", border: "none", cursor: "pointer" }}
                          >{isAU ? "Clear" : "クリア"}</button>
                        )}
                      </div>
                      {requestedDeliveryDate && isHoliday(requestedDeliveryDate, wsSettings.closedWeekdays, wsSettings.holidayDates, wsSettings.timezone) && (
                        <div style={{ fontSize: 12, color: "#dc2626", marginTop: 6 }}>{isAU ? "⚠ The selected date is a non-operating day" : "⚠ 選択した日付は休業日です"}</div>
                      )}
                    </div>
                  );
                })()}

                <div style={{ border: "1px solid #eee", borderRadius: 12, overflow: "hidden", marginBottom: 12 }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "2fr 1.2fr 0.9fr",
                      gap: 8,
                      padding: "10px 12px",
                      background: "#fafafa",
                      fontWeight: 900,
                      fontSize: 13,
                    }}
                  >
                    <div>{isAU ? "Product" : "商品名"}</div>
                    <div style={{ textAlign: "right" }}>{isAU ? "Qty" : "個数"}</div>
                    <div style={{ textAlign: "right" }}>{isAU ? "Amount" : "金額"}</div>
                  </div>

                  <div style={{ maxHeight: 320, overflow: "auto" }}>
                    {lines.map((l) => {
                      const amount = Number(l.qty || 0) * Number(l.price || 0);

                      return (
                        <div
                          key={l.id}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 1.2fr 0.9fr",
                            gap: 8,
                            padding: "10px 12px",
                            borderTop: "1px solid #eee",
                            alignItems: "center",
                            fontSize: 14,
                            background: "white",
                          }}
                        >
                          <div style={{ fontWeight: 900 }}>{l.name}</div>

                          <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, alignItems: "center" }}>
                            <button
                              onClick={() => { setQtyDrafts(p => { const n={...p}; delete n[l.id]; return n; }); inc(l.id, -1); }}
                              style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900 }}
                            >
                              −
                            </button>

                            <input
                              value={qtyDrafts[l.id] !== undefined ? qtyDrafts[l.id] : l.qty}
                              onChange={(e) => setQtyDrafts(p => ({ ...p, [l.id]: e.target.value }))}
                              onBlur={() => {
                                const draft = qtyDrafts[l.id];
                                if (draft === undefined) return;
                                setQtyDrafts(p => { const n={...p}; delete n[l.id]; return n; });
                                setQty(l.id, draft);
                              }}
                              inputMode="numeric"
                              style={{
                                width: 70,
                                padding: "8px 10px",
                                borderRadius: 10,
                                border: "1px solid #ddd",
                                textAlign: "center",
                                fontWeight: 900,
                              }}
                            />

                            <button
                              onClick={() => { setQtyDrafts(p => { const n={...p}; delete n[l.id]; return n; }); inc(l.id, 1); }}
                              style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900 }}
                            >
                              ＋
                            </button>
                          </div>

                          <div style={{ textAlign: "right", fontWeight: 900 }}>
                            {/* ✅ 原価優先で表示（売価混入防止） */}
                            {Number(l.costPrice ?? 0) <= 0 ? <span style={{ color: "#b45309" }}>{isAU ? "No cost price" : "原価未登録"}</span> : formatMoney(Number(l.qty || 0) * Number(l.costPrice), tenantProfile?.marketId)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div style={{ display: "grid", gap: 6, marginBottom: 12 }}>
                  <div style={{ display: "flex" }}>
                    <div style={{ opacity: 0.8 }}>{isAU ? "Subtotal" : "小計"}</div>
                    <div style={{ marginLeft: "auto", fontWeight: 900 }}>{formatMoney(subtotal, tenantProfile?.marketId)}</div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ opacity: 0.8 }}>{isAU ? "GST" : "消費税"}</div>
                    <div style={{ marginLeft: "auto", fontWeight: 900 }}>{formatMoney(taxTotal, tenantProfile?.marketId)}</div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ opacity: 0.9, fontWeight: 900 }}>{isAU ? "Total" : "合計"}</div>
                    <div style={{ marginLeft: "auto", fontWeight: 900, fontSize: 18 }}>{formatMoney(total, tenantProfile?.marketId)}</div>
                  </div>
                </div>

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    background: "white",
                    paddingTop: 10,
                    marginTop: 10,
                    borderTop: "1px solid #eee",
                  }}
                >
                  <div style={{ display: "grid", gap: 8 }}>
                    <button
                      onClick={submitOrder}
                      disabled={isSubmittingOrder}
                      style={{
                        width: "100%",
                        padding: "16px 14px",
                        background: isSubmittingOrder ? "#888" : "#111",
                        color: "white",
                        borderRadius: 14,
                        border: "1px solid #111",
                        fontWeight: 900,
                        fontSize: 16,
                        cursor: isSubmittingOrder ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                      }}
                    >
                      {isSubmittingOrder ? (
                        <>
                          <span style={{ display: "inline-block", width: 16, height: 16, border: "2px solid rgba(255,255,255,0.4)", borderTopColor: "white", borderRadius: "50%", animation: "spin 0.7s linear infinite" }} />
                          {isAU ? "Submitting order…" : "発注処理中…"}
                        </>
                      ) : (isAU ? "✅ Submit this order" : "✅ この内容で送信する")}
                    </button>

                    <button
                      onClick={() => setConfirmOpen(false)}
                      disabled={isSubmittingOrder}
                      style={{
                        width: "100%",
                        padding: "12px 14px",
                        borderRadius: 14,
                        border: "1px solid #ddd",
                        background: "white",
                        fontWeight: 900,
                        fontSize: 14,
                        cursor: isSubmittingOrder ? "not-allowed" : "pointer",
                        opacity: isSubmittingOrder ? 0.5 : 1,
                      }}
                    >
                      {isAU ? "Cancel" : "キャンセル"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ===== wholesale confirm modal ===== */}
  {/* ✅ 卸：受注確定モーダル（中だけスクロール／下ボタン固定） */}
{whConfirmOpen && selectedOrder && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "grid",
      placeItems: "center",
      zIndex: 12000,
      padding: 16,
    }}
    onClick={() => { if (!confirmingOrderIds[selectedOrder.id]) setWhConfirmOpen(false); }} // 外側クリックで閉じる（処理中は不可）
  >
    <div
      style={{
        width: "min(860px, 100%)",
        maxHeight: "min(86vh, 760px)", // ✅ 画面内に収める
        background: "white",
        borderRadius: 14,
        border: "1px solid #eee",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      onClick={(e) => e.stopPropagation()} // 中クリックで閉じない
    >
      {/* ヘッダー
          2026-08（Step 12 E2E検証時に発覚したバグ対応）：受注確定確認モーダル
          全体がisAU分岐なしで完全に日本語ハードコードされていた */}
      <div style={{ padding: 12, borderBottom: "1px solid #eee" }}>
        <div style={{ fontWeight: 900, fontSize: 16 }}>{isAU ? "Confirm this order?" : "受注確定しますか？"}</div>
        <div style={{ fontSize: 12, opacity: 0.75, marginTop: 4 }}>
          {isAU ? (
            <>Retailer: <b>{selectedOrder.shopName || "Unnamed store"}</b> / Order No.: <b>{selectedOrder.orderNo}</b></>
          ) : (
            <>小売店：<b>{selectedOrder.shopName || "〇〇ショップ"}</b> ／ 仕入先：<b>{selectedOrder.supplierName || ""}</b> ／ 注文No.：<b>{selectedOrder.orderNo}</b></>
          )}
        </div>
      </div>

 {/* ✅ 本文（ここだけスクロール） */}
<div
  style={{
    padding: 12,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    flex: "1 1 auto",
    minHeight: 0,
    display: "grid",
    gap: 10,
  }}
>
  {/* 明細 */}
  <div style={{ border: "1px solid #eee", borderRadius: 12 }}>
    {(getOrderLines(selectedOrder) || []).map((l, idx) => {
      const qty = Number(l.qty || 0);
      const unit = Number(l.price || 0);
      const amount = qty * unit;

      // ✅ key被り対策（これで「全件出ない」を潰す）
      const rowKey = `${String(l.id || "")}-${String(l.barcode || "")}-${idx}`;

      return (
        <div
          key={rowKey}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: 8,
            padding: "10px 12px",
            borderTop: idx === 0 ? "none" : "1px solid #eee",
            alignItems: "center",
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 900, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {l.name}
            </div>
            <div style={{ fontSize: 12, opacity: 0.75 }}>
              {isAU ? (
                <>{l.barcode ? `Barcode: ${l.barcode}` : "No barcode"} / Unit: {l.unit || ""} / Price: {unit <= 0 ? "Not set" : <>{formatMoney(unit, tenantProfile?.marketId)}<span style={{ fontSize: 10, marginLeft: 2 }}>ex GST</span></>}</>
              ) : (
                <>{l.barcode ? `JAN: ${l.barcode}` : "JANなし"} ／ 単位：{l.unit || ""} ／ 単価：{unit <= 0 ? "価格未登録" : <>{formatMoney(unit, tenantProfile?.marketId)}<span style={{ fontSize: 10, marginLeft: 2 }}>税抜</span></>}</>
              )}
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button
              onClick={() => setOrderLineQty(selectedOrder.id, selectedOrder.lines, idx, l.id || l.barcode || null, Math.max(0, qty - 1))}
              disabled={!!confirmingOrderIds[selectedOrder.id]}
              style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", opacity: confirmingOrderIds[selectedOrder.id] ? 0.5 : 1, cursor: confirmingOrderIds[selectedOrder.id] ? "not-allowed" : "pointer" }}
            >−</button>
            <div style={{ minWidth: 40, textAlign: "center", fontWeight: 900 }}>{qty}{l.unit || ""}</div>
            <button
              onClick={() => setOrderLineQty(selectedOrder.id, selectedOrder.lines, idx, l.id || l.barcode || null, qty + 1)}
              disabled={!!confirmingOrderIds[selectedOrder.id]}
              style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #ddd", fontWeight: 900, background: "white", opacity: confirmingOrderIds[selectedOrder.id] ? 0.5 : 1, cursor: confirmingOrderIds[selectedOrder.id] ? "not-allowed" : "pointer" }}
            >＋</button>
            <div style={{ minWidth: 80, textAlign: "right", fontWeight: 900 }}>
              {unit <= 0 ? "—" : formatMoney(amount, tenantProfile?.marketId)}
            </div>
          </div>
        </div>
      );
    })}
  </div>

  {/* 合計 */}
  <div style={{ display: "grid", gap: 4, borderTop: "1px solid #eee", paddingTop: 8 }}>
    <div style={{ display: "flex", fontSize: 13, color: "#555" }}>
      <div>{isAU ? "Subtotal (ex GST)" : "小計（税抜）"}</div>
      <div style={{ marginLeft: "auto" }}>{formatMoney(selectedOrder.subtotal || 0, tenantProfile?.marketId)}</div>
    </div>
    <div style={{ display: "flex", fontSize: 13, color: "#555" }}>
      <div>{isAU ? "GST" : "消費税"}</div>
      <div style={{ marginLeft: "auto" }}>{formatMoney(selectedOrder.tax || 0, tenantProfile?.marketId)}</div>
    </div>
    <div style={{ display: "flex", borderTop: "1px solid #ddd", paddingTop: 6, marginTop: 2 }}>
      <div style={{ fontWeight: 900 }}>{isAU ? "Total (inc GST)" : "合計（税込）"}</div>
      <div style={{ marginLeft: "auto", fontWeight: 900, fontSize: 17 }}>{formatMoney(selectedOrder.total || 0, tenantProfile?.marketId)}</div>
    </div>
  </div>
</div>


      {/* ✅ 下ボタン固定（常に見える） */}
      <div
        style={{
          padding: 12,
          borderTop: "1px solid #eee",
          background: "white",
          display: "flex",
          gap: 8,
          justifyContent: "flex-end",
        }}
      >
        <button
          onClick={() => setWhConfirmOpen(false)}
          disabled={!!confirmingOrderIds[selectedOrder.id]}
          style={{ ...S.btn, border: "1px solid #ddd", background: "white", opacity: confirmingOrderIds[selectedOrder.id] ? 0.5 : 1, cursor: confirmingOrderIds[selectedOrder.id] ? "not-allowed" : "pointer" }}
        >
          {isAU ? "Cancel" : "キャンセル"}
        </button>

        <button
          onClick={async () => {
            // 2026-08追加：確定操作中の連打を防ぐ。confirmOrder自体もconfirmingOrderIdsを
            // 管理するが、モーダルを閉じるタイミングをここで制御するため、処理中は
            // 何もしない（disabledと二重で守る）
            if (confirmingOrderIds[selectedOrder.id]) return;
            try {
              // 2026-08修正（Codexレビュー指摘対応・MINOR）：以前はconfirmOrderの
              // 成否に関わらずawait後に無条件でモーダルを閉じており、原価不足等で
              // 失敗した場合もモーダルが閉じてしまい、あたかも成功したかのように
              // 見えていた（永久ロックではないがUX上紛らわしい）。confirmOrderが
              // 成功時にtrue、失敗・中止時にfalseを返すようにし、trueの場合のみ
              // モーダルを閉じる。falseの場合はモーダルを開いたままにして、
              // ユーザーがalertのエラー内容を確認した上で再試行できるようにする
              const ok = await confirmOrder(selectedOrder.id);
              if (ok) setWhConfirmOpen(false);
            } catch (e) {
              console.error(e);
              alert(e?.message || String(e));
            }
          }}
          disabled={!!confirmingOrderIds[selectedOrder.id]}
          style={{
            ...S.btn, border: "1px solid #111",
            background: confirmingOrderIds[selectedOrder.id] ? "#666" : "#111", color: "white",
            cursor: confirmingOrderIds[selectedOrder.id] ? "not-allowed" : "pointer",
            display: "inline-flex", alignItems: "center", gap: 6,
          }}
        >
          {confirmingOrderIds[selectedOrder.id] ? (
            <>
              <span style={{ display: "inline-block", animation: "spin 0.8s linear infinite" }}>⟳</span>
              {isAU ? "Confirming…" : "受注確定中…"}
            </>
          ) : (
            isAU ? "✅ Confirm this order" : "✅ この内容で受注確定"
          )}
        </button>
      </div>
    </div>
  </div>
)}


          {/* ===== tenant profile modal ===== */}
{tenantOpen && (
  <div
    onClick={() => setTenantOpen(false)} // 背景クリックで閉じる
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "grid",
      placeItems: "center",
      zIndex: 15000,
      padding: 16,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()} // 中身クリックで閉じない
      style={{
        width: "min(720px, 100%)",
        background: "white",
        borderRadius: 14,
        padding: 14,
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <div style={{ fontWeight: 900 }}>{isAU ? "Settings & Business details" : "設定・会社情報"}</div>
        <button
          onClick={() => setTenantOpen(false)}
          style={{
            marginLeft: "auto",
            padding: "8px 10px",
            borderRadius: 10,
            border: "1px solid #ddd",
            background: "white",
            fontWeight: 900,
          }}
        >
          {isAU ? "Close" : "閉じる"}
        </button>
      </div>

      {!tenantProfile ? (
        <div style={{ marginTop: 12, opacity: 0.7 }}>{isAU ? "Loading..." : "読み込み中..."}</div>
      ) : (
        <div style={{ marginTop: 12, display: "grid", gap: 12 }}>

          {/* ===== 卸として使う情報（卸モードのみ） ===== */}
          {mode === "wholesale" && isAU && (
            // 2026-08 AU版基盤（Phase 3）：AU向けBusiness Setup。日本版の単一address
            // 自由入力ではなく、Suburb/State/Postcode/Countryへ分解した豪州住所形式を使う。
            // インボイス登録番号（日本の適格請求書発行事業者番号、T+13桁）はJP専用のため
            // 表示せず、代わりにABN（11桁）を表示する。timezoneはPhase 1のdateUtils.js/
            // zonedTimeToUtcが前提とするIANA名で、tenant単位のtimezone専用hasOnlyブロック
            // （firestore.rules）経由でupdateTenantSettings/onClick保存時に別書き込みされる
            <div style={{ display: "grid", gap: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 12, color: "#555" }}>📦 Business details (shown on delivery notes &amp; invoices)</div>
              <input value={tenantProfile?.name || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), name: e.target.value }))} placeholder="Business name" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: 12, overflow: "hidden" }}>
                <span style={{ padding: "12px 10px 12px 14px", background: "#f5f5f5", fontWeight: 900, fontSize: 13, color: "#333", borderRight: "1px solid #ddd" }}>ABN</span>
                <input
                  value={tenantProfile?.abn || ""}
                  onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), abn: e.target.value.replace(/\D/g, "").slice(0, 11) }))}
                  placeholder="11 digit ABN"
                  maxLength={11}
                  inputMode="numeric"
                  style={{ flex: 1, padding: "12px", border: "none", fontWeight: 800, outline: "none" }}
                />
                <span style={{ padding: "12px", fontSize: 12, color: (tenantProfile?.abn || "").length === 11 ? "#16a34a" : "#aaa", whiteSpace: "nowrap" }}>
                  {(tenantProfile?.abn || "").length}/11
                </span>
              </div>
              <input value={tenantProfile?.address || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), address: e.target.value }))} placeholder="Street address" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <input value={tenantProfile?.suburb || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), suburb: e.target.value }))} placeholder="Suburb" style={{ flex: "2 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
                <select value={tenantProfile?.state || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), state: e.target.value }))} style={{ flex: "1 1 100px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, background: "white" }}>
                  <option value="">State</option>
                  {AU_STATE_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
                <input value={tenantProfile?.postcode || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), postcode: e.target.value.replace(/\D/g, "").slice(0, 4) }))} placeholder="Postcode" maxLength={4} inputMode="numeric" style={{ flex: "1 1 100px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              </div>
              <input value={tenantProfile?.country || "Australia"} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), country: e.target.value }))} placeholder="Country" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <input value={tenantProfile?.tel || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), tel: e.target.value }))} placeholder="Phone" style={{ flex: "1 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
                <input type="email" value={tenantProfile?.email || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), email: e.target.value }))} placeholder="Email" style={{ flex: "1 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: "#555", fontWeight: 700, marginBottom: 4 }}>Timezone</div>
                <select
                  value={tenantProfile?.timezone || "Australia/Sydney"}
                  onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), timezone: e.target.value }))}
                  style={{ width: "100%", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, background: "white" }}
                >
                  {AU_TIMEZONE_OPTIONS.map(tz => <option key={tz.value} value={tz.value}>{tz.label}</option>)}
                </select>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>Used to calculate billing periods and delivery dates</div>
              </div>
              <input value={tenantProfile?.bank || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), bank: e.target.value }))} placeholder="Bank details (optional, shown on invoices)" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <textarea value={tenantProfile?.noteTemplate || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), noteTemplate: e.target.value }))} placeholder="Note template (e.g. how to report an issue with a delivery)" rows={3} style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, resize: "vertical" }} />
            </div>
          )}
          {mode === "wholesale" && !isAU && (
            <div style={{ display: "grid", gap: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 12, color: "#555" }}>📦 会社情報（納品書の発行元に印字）</div>
              <input value={tenantProfile?.name || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), name: e.target.value }))} placeholder="会社名（例：山田青果株式会社）" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <input value={tenantProfile?.address || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), address: e.target.value }))} placeholder="住所" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <input value={tenantProfile?.tel || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), tel: e.target.value }))} placeholder="TEL" style={{ flex: "1 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
                <input value={tenantProfile?.fax || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), fax: e.target.value }))} placeholder="FAX" style={{ flex: "1 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              </div>
              <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: 12, overflow: "hidden" }}>
                <span style={{ padding: "12px 10px 12px 14px", background: "#f5f5f5", fontWeight: 900, fontSize: 16, color: "#333", borderRight: "1px solid #ddd" }}>T</span>
                <input
                  value={(tenantProfile?.invoiceNo || "").replace(/^T/, "")}
                  onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), invoiceNo: "T" + e.target.value.replace(/\D/g, "").slice(0, 13) }))}
                  placeholder="インボイス登録番号（任意）"
                  maxLength={13}
                  inputMode="numeric"
                  style={{ flex: 1, padding: "12px", border: "none", fontWeight: 800, outline: "none" }}
                />
                <span style={{ padding: "12px", fontSize: 12, color: (tenantProfile?.invoiceNo || "").replace(/^T/, "").length === 13 ? "#16a34a" : "#aaa", whiteSpace: "nowrap" }}>
                  {(tenantProfile?.invoiceNo || "").replace(/^T/, "").length}/13
                </span>
              </div>
              <input type="email" value={tenantProfile?.email || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), email: e.target.value }))} placeholder="メールアドレス" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <input value={tenantProfile?.bank || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), bank: e.target.value }))} placeholder="振込先（任意）" style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <textarea value={tenantProfile?.noteTemplate || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), noteTemplate: e.target.value }))} placeholder="備考テンプレ（欠品時の連絡方法など）" rows={3} style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, resize: "vertical" }} />
            </div>
          )}

          {/* ===== 小売として使う情報（小売モードのみ） ===== */}
          {mode === "retail" && (
            <div style={{ display: "grid", gap: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 12, color: "#555" }}>{isAU ? "🛒 Store details (printed on orders as the sender)" : "🛒 自店情報（発注書の発行元に印字）"}</div>
              <input value={tenantProfile?.retailCompany || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), retailCompany: e.target.value }))} placeholder={isAU ? "Company name (e.g. Smith Trading Pty Ltd)" : "社名（例：佐藤商店株式会社）"} style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <input value={tenantProfile?.retailName || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), retailName: e.target.value }))} placeholder={isAU ? "Store name (e.g. Smith Supermarket)" : "店舗名（例：佐藤スーパー）"} style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <input value={tenantProfile?.retailAddress || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), retailAddress: e.target.value }))} placeholder={isAU ? "Address" : "住所"} style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <input value={tenantProfile?.retailTel || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), retailTel: e.target.value }))} placeholder="TEL" style={{ flex: "1 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
                <input value={tenantProfile?.retailFax || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), retailFax: e.target.value }))} placeholder="FAX" style={{ flex: "1 1 180px", padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
              </div>
              <input type="email" value={tenantProfile?.retailEmail || ""} onChange={(e) => setTenantProfile((p) => ({ ...(p||{}), retailEmail: e.target.value }))} placeholder={isAU ? "Email address" : "メールアドレス"} style={{ padding: "12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }} />
            </div>
          )}

          {/* ===== 集計基準設定 ===== */}
          <div style={{ borderTop: "1px solid #eee", paddingTop: 14, display: "grid", gap: 10 }}>
            <div style={{ fontWeight: 900, fontSize: 13, color: "#444" }}>{isAU ? "📊 Settings" : "📊 集計基準"}</div>
            {/* 卸モードのみ：接続小売の商品管理ポリシー */}
            {mode === "wholesale" && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", border: "1px solid #eee", borderRadius: 12, background: "#fafafa" }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 13 }}>{isAU ? "Retailer product management" : "接続小売の商品管理"}</div>
                <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                  {isAU
                    ? <>Current: <b>{tenantProfile?.allowRetailProductEdit ? "Can add/edit products" : "Order only (recommended)"}</b></>
                    : <>現在：<b>{tenantProfile?.allowRetailProductEdit ? "登録・編集あり" : "発注のみ（推奨）"}</b></>
                  }
                </div>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                {[[false, isAU ? "Order only" : "発注のみ"], [true, isAU ? "Can edit" : "登録・編集あり"]].map(([val, label]) => (
                  <button key={String(val)}
                    onClick={() => setTenantProfile(p => ({ ...(p || {}), allowRetailProductEdit: val }))}
                    style={{
                      padding: "6px 12px", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer",
                      border: (tenantProfile?.allowRetailProductEdit ?? false) === val ? "2px solid #111" : "1px solid #ddd",
                      background: (tenantProfile?.allowRetailProductEdit ?? false) === val ? "#111" : "white",
                      color: (tenantProfile?.allowRetailProductEdit ?? false) === val ? "white" : "#333",
                    }}>
                    {label}
                  </button>
                ))}
              </div>
            </div>
            )}
          </div>

          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", borderTop: "1px solid #eee", paddingTop: 12, marginTop: 6 }}>
            <button
              onClick={() => setTenantOpen(false)}
              style={{
                padding: "10px 12px",
                borderRadius: 12,
                border: "1px solid #ddd",
                background: "white",
                fontWeight: 900,
              }}
            >
              {isAU ? "Cancel" : "キャンセル"}
            </button>
            <button
              onClick={async () => {
                // 2026-08 AU版基盤（Phase 3、Codexレビュー指摘対応・MINOR）：Country入力欄は
                // 表示上プレースホルダー的に"Australia"を見せているが、ユーザーが未入力の
                // 間はtenantProfile.country自体が存在せず保存patchにも入らなかった。
                // 保存時点でAU版かつ未入力（空白のみを含む）ならAustraliaを明示的に補完する
                const patch = (isAU && !String(tenantProfile?.country || "").trim())
                  ? { ...tenantProfile, country: "Australia" }
                  : tenantProfile;
                const result = await updateTenantSettings(patch);
                if (result?.success) {
                  setTenantSaveOk(true);
                  setTimeout(() => setTenantSaveOk(false), 2500);
                }
              }}
              style={{
                padding: "10px 14px",
                borderRadius: 12,
                border: tenantSaveOk ? "1px solid #16a34a" : "1px solid #111",
                background: tenantSaveOk ? "#16a34a" : "#111",
                color: "white",
                fontWeight: 900,
                transition: "background 0.2s",
              }}
            >
              {tenantSaveOk ? (isAU ? "✓ Saved" : "✓ 保存しました") : (isAU ? "Save" : "保存")}
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
)}




          {/* ===== 納品日設定モーダル ===== */}
          {deliverySettingsOpen && (() => {
            const DOW_LABELS = isAU ? ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] : ["日", "月", "火", "水", "木", "金", "土"];
            const PRESET_HOLIDAY_YEARS = Array.from({ length: HOLIDAY_DATA_RANGE.to - HOLIDAY_DATA_RANGE.from + 1 }, (_, i) => HOLIDAY_DATA_RANGE.from + i);

            const toggleWeekday = (d) => {
              setDsClosedWeekdays(prev =>
                prev.includes(d) ? prev.filter(x => x !== d) : [...prev, d]
              );
            };

            // 定休日プリセット適用
            const applyPreset = (preset) => {
              const hasExisting = dsClosedWeekdays.length > 0 || dsHolidayDates.length > 0;
              if (hasExisting && !window.confirm(isAU ? "This will overwrite your current closed-day settings. Are you sure?" : "現在の定休日設定を上書きします。よろしいですか？")) return;
              if (preset === "none") {
                setDsClosedWeekdays([]);
              } else if (preset === "sat-sun") {
                setDsClosedWeekdays([0, 6]);
              } else if (preset === "sun-hol") {
                setDsClosedWeekdays([0]);
                // 今年・来年の祝日を一括追加
                const thisYear = new Date().getFullYear();
                const dates = [
                  ...getHolidaysByYear(thisYear),
                  ...getHolidaysByYear(thisYear + 1),
                ].map(h => h.date);
                setDsHolidayDates(prev => [...new Set([...prev, ...dates])].sort());
              } else if (preset === "sat-sun-hol") {
                setDsClosedWeekdays([0, 6]);
                // 今年・来年の祝日を一括追加
                const thisYear = new Date().getFullYear();
                const dates = [
                  ...getHolidaysByYear(thisYear),
                  ...getHolidaysByYear(thisYear + 1),
                ].map(h => h.date);
                setDsHolidayDates(prev => [...new Set([...prev, ...dates])].sort());
              }
            };

            // 祝日を一括追加
            const addHolidaysByYear = (year) => {
              const dates = getHolidaysByYear(year).map(h => h.date);
              const toAdd = dates.filter(d => !dsHolidayDates.includes(d));
              if (toAdd.length === 0) {
                setDsHolidayAddMsg(isAU ? `All ${year} public holidays are already added` : `${year}年の祝日はすでにすべて登録済みです`);
              } else {
                setDsHolidayDates(prev => [...new Set([...prev, ...toAdd])].sort());
                setDsHolidayAddMsg(isAU ? `Added ${toAdd.length} public holiday(s) for ${year}` : `${year}年の祝日を${toAdd.length}件追加しました`);
              }
              setTimeout(() => setDsHolidayAddMsg(""), 4000);
            };

            // 個別日付を手動追加
            const addHoliday = () => {
              const v = dsHolidayInput.trim();
              if (!v.match(/^\d{4}-\d{2}-\d{2}$/)) return alert(isAU ? "Please enter the date in YYYY-MM-DD format" : "YYYY-MM-DD形式で入力してください");
              if (dsHolidayDates.includes(v)) return;
              setDsHolidayDates(prev => [...prev, v].sort());
              setDsHolidayInput("");
            };

            const removeHoliday = (d) => setDsHolidayDates(prev => prev.filter(x => x !== d));

            const save = async () => {
              if (dsLeadDays < 0) return alert(isAU ? "Lead days must be 0 or more" : "リード日数は0以上で入力してください");
              setDsSaving(true);
              try {
                // updateTenantSettings経由に統一（Rulesのスケジュール用updateブロックに対応）
                await updateTenantSettings({
                  leadDays: Number(dsLeadDays),
                  cutoffTime: dsCutoffTime || null,
                  closedWeekdays: dsClosedWeekdays,
                  holidayDates: dsHolidayDates,
                });
                setDsSaved(true);
                setTimeout(() => setDsSaved(false), 2000);
              } catch (e) {
                alert((isAU ? "Save error: " : "保存エラー: ") + (e?.message || e));
              } finally {
                setDsSaving(false);
              }
            };

            // プリセットの現在状態ラベル
            const presetActive = (() => {
              const cw = dsClosedWeekdays;
              if (cw.length === 0) return "none";
              if (cw.includes(0) && cw.includes(6) && cw.length === 2) {
                // 祝日が個別休業日に1件以上入っていれば土日祝、なければ土日
                return dsHolidayDates.length > 0 ? "sat-sun-hol" : "sat-sun";
              }
              if (cw.includes(0) && !cw.includes(6) && cw.length === 1) return "sun-hol";
              return null;
            })();

            return (
              <div
                onClick={() => setDeliverySettingsOpen(false)}
                style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "grid", placeItems: "center", zIndex: 15000, padding: 16 }}
              >
                <div
                  onClick={e => e.stopPropagation()}
                  style={{ background: "white", borderRadius: 16, padding: 28, width: "min(96vw, 580px)", maxHeight: "92vh", overflowY: "auto", boxShadow: "0 24px 60px rgba(0,0,0,0.2)" }}
                >
                  <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 4 }}>{isAU ? "📦 Delivery settings" : "📦 納品日設定"}</div>
                  <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 20 }}>{isAU ? "These settings are used to auto-calculate the expected delivery date for new orders. Existing orders are not affected." : "新規注文の予定納品日を自動計算するための設定です。既存注文には影響しません。"}</div>

                  {/* リード日数 */}
                  <div style={{ marginBottom: 20 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{isAU ? "Base lead time (business days)" : "基本リード日数（営業日）"}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="number" min={0} max={30} value={dsLeadDays}
                        onChange={e => setDsLeadDays(Number(e.target.value))}
                        style={{ width: 80, padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontWeight: 700, fontSize: 15, textAlign: "center" }}
                      />
                      <span style={{ fontSize: 14, color: "#64748b" }}>{isAU ? "day(s) (0 = same day as order)" : "日（0=注文受付日当日）"}</span>
                    </div>
                    <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{isAU ? "Example: set to 2, order placed Monday → expected delivery Wednesday" : "例：2に設定し月曜受付→水曜が予定納品日"}</div>
                  </div>

                  {/* 締め時間 */}
                  <div style={{ marginBottom: 20 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{isAU ? "Order cutoff time" : "注文締め時間（日本時間）"}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="time" value={dsCutoffTime}
                        onChange={e => setDsCutoffTime(e.target.value)}
                        style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontWeight: 700, fontSize: 15 }}
                      />
                      <button onClick={() => setDsCutoffTime("")}
                        style={{ fontSize: 12, color: "#94a3b8", background: "none", border: "none", cursor: "pointer", textDecoration: "underline" }}
                      >{isAU ? "Clear (no cutoff time)" : "クリア（締め時間なし）"}</button>
                    </div>
                    <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{isAU ? "If not set, orders are always treated as received same-day. Orders placed exactly at the cutoff time are treated as same-day." : "未設定の場合は常に当日受付扱い。締め時間ちょうどは当日受付。"}</div>
                  </div>

                  {/* 定休日プリセット */}
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{isAU ? "Closed days (weekly)" : "定休日（毎週）"}</div>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
                      {(isAU ? [
                        { key: "sat-sun",     label: "Sat/Sun",   desc: "Sat & Sun" },
                        { key: "none",        label: "None",   desc: "No closed days" },
                      ] : [
                        { key: "sat-sun",     label: "土日",   desc: "土・日" },
                        { key: "sun-hol",     label: "日祝",   desc: "日＋祝日" },
                        { key: "sat-sun-hol", label: "土日祝", desc: "土・日＋祝日" },
                        { key: "none",        label: "なし",   desc: "定休日なし" },
                      ]).map(p => (
                        <button key={p.key} onClick={() => applyPreset(p.key)}
                          style={{
                            padding: "7px 14px", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer",
                            border: presetActive === p.key ? "2px solid #1a56db" : "1.5px solid #ddd",
                            background: presetActive === p.key ? "#eff6ff" : "white",
                            color: presetActive === p.key ? "#1a56db" : "#374151",
                          }}
                          title={p.desc}
                        >{p.label}</button>
                      ))}
                    </div>
                    {/* 曜日個別トグル */}
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                      {DOW_LABELS.map((label, i) => (
                        <button key={i} onClick={() => toggleWeekday(i)}
                          style={{
                            padding: "7px 13px", borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: "pointer",
                            border: dsClosedWeekdays.includes(i) ? "2px solid #1a56db" : "1.5px solid #ddd",
                            background: dsClosedWeekdays.includes(i) ? "#eff6ff" : "white",
                            color: dsClosedWeekdays.includes(i) ? "#1a56db" : "#374151",
                          }}
                        >{label}</button>
                      ))}
                    </div>
                    <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 6 }}>
                      {isAU ? "Current closed days: " : "現在の定休日："}{dsClosedWeekdays.length === 0 ? (isAU ? "None" : "なし") : dsClosedWeekdays.map(d => DOW_LABELS[d]).join(isAU ? ", " : "・")}
                    </div>
                  </div>

                  {/* 祝日セクション（日本専用機能） */}
                  {!isAU && (
                  <div style={{ background: "#f8fafc", borderRadius: 10, padding: "16px", marginBottom: 20, marginTop: 8 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>🎌 祝日を個別休業日に追加</div>
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 12, lineHeight: 1.6 }}>
                      祝日は自動休業ではありません。必要な年の祝日を個別休業日に追加してください。<br />
                      <span style={{ color: "#94a3b8" }}>祝日データ収録期間：{HOLIDAY_DATA_RANGE.from}年〜{HOLIDAY_DATA_RANGE.to}年</span>
                    </div>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      <select
                        value={dsHolidayYear}
                        onChange={e => setDsHolidayYear(Number(e.target.value))}
                        style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #ddd", fontWeight: 700, fontSize: 14 }}
                      >
                        {PRESET_HOLIDAY_YEARS.map(y => (
                          <option key={y} value={y}>{y}年</option>
                        ))}
                      </select>
                      <button
                        onClick={() => addHolidaysByYear(dsHolidayYear)}
                        style={{ padding: "8px 16px", borderRadius: 8, background: "#7c3aed", color: "white", fontWeight: 700, fontSize: 13, border: "none", cursor: "pointer" }}
                      >祝日を追加</button>
                      {/* 土日祝プリセット用ショートカット */}
                      <button
                        onClick={() => {
                          applyPreset("sat-sun-hol");
                          addHolidaysByYear(dsHolidayYear);
                        }}
                        style={{ padding: "8px 16px", borderRadius: 8, background: "#0f172a", color: "white", fontWeight: 700, fontSize: 13, border: "none", cursor: "pointer" }}
                      >土日祝を一括設定</button>
                    </div>
                    {dsHolidayAddMsg && (
                      <div style={{ fontSize: 13, color: "#16a34a", fontWeight: 700, marginTop: 8 }}>✓ {dsHolidayAddMsg}</div>
                    )}
                  </div>
                  )}

                  {/* 個別休業日 */}
                  <div style={{ marginBottom: 24 }}>
                    <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{isAU ? "Individual closed dates (e.g. year-end, summer break)" : "個別休業日（年末年始・夏季休業など）"}</div>
                    <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
                      <input
                        type="date" value={dsHolidayInput}
                        onChange={e => setDsHolidayInput(e.target.value)}
                        style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontWeight: 700, fontSize: 14, flex: 1 }}
                      />
                      <button onClick={addHoliday}
                        style={{ padding: "10px 18px", borderRadius: 8, background: "#1a56db", color: "white", fontWeight: 700, fontSize: 14, border: "none", cursor: "pointer" }}
                      >{isAU ? "Add" : "追加"}</button>
                    </div>
                    {dsHolidayDates.length === 0 ? (
                      <div style={{ fontSize: 13, color: "#94a3b8" }}>{isAU ? "No closed dates registered" : "登録された休業日はありません"}</div>
                    ) : (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 5, maxHeight: 180, overflowY: "auto" }}>
                        {dsHolidayDates.map(d => (
                          <div key={d} style={{ display: "flex", alignItems: "center", gap: 3, background: "#f1f5f9", borderRadius: 6, padding: "3px 8px", fontSize: 12, fontWeight: 700 }}>
                            {d}
                            <button onClick={() => removeHoliday(d)}
                              style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: 13, padding: 0, lineHeight: 1 }}
                            >×</button>
                          </div>
                        ))}
                      </div>
                    )}
                    {dsHolidayDates.length > 0 && (
                      <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 6 }}>{isAU ? `${dsHolidayDates.length} registered` : `${dsHolidayDates.length}件登録済み`}</div>
                    )}
                  </div>

                  {/* ボタン */}
                  <div style={{ display: "flex", gap: 12 }}>
                    <button onClick={() => setDeliverySettingsOpen(false)}
                      style={{ flex: 1, padding: "12px", borderRadius: 10, border: "1px solid #ddd", background: "white", fontWeight: 700, fontSize: 14, cursor: "pointer" }}
                    >{isAU ? "Cancel" : "キャンセル"}</button>
                    <button onClick={save} disabled={dsSaving}
                      style={{ flex: 2, padding: "12px", borderRadius: 10, border: "none", background: dsSaved ? "#16a34a" : "#1a56db", color: "white", fontWeight: 900, fontSize: 14, cursor: dsSaving ? "not-allowed" : "pointer", opacity: dsSaving ? 0.7 : 1 }}
                    >
                      {isAU
                        ? (dsSaved ? "✓ Saved" : dsSaving ? "Saving..." : "Save")
                        : (dsSaved ? "✓ 保存しました" : dsSaving ? "保存中..." : "保存")}
                    </button>
                  </div>
                </div>
              </div>
            );
          })()}

          {/* ===== 単価確認モーダル（受注確定前）===== */}
          {priceCheckModal && (() => {
            const inputRefs = {};
            const isLineAddMode = priceCheckModal.mode === "manual-line-add";
            const isConfirmMode = !isLineAddMode && (priceCheckModal.mode === "confirm" || priceCheckModal.mode === "manual-confirm");
            const isManualMode = priceCheckModal.mode === "manual-delivery" || priceCheckModal.mode === "manual-confirm";
            const modalTitle = isAU
              ? (isLineAddMode ? "💴 Enter cost price to add" : isConfirmMode ? "✅ Confirm cost price before order confirmation" : "🖨 Confirm cost price before issuing delivery note")
              : (isLineAddMode ? "💴 原価を入力して追加" : isConfirmMode ? "✅ 受注確定前の原価確認" : "🖨 納品書発行前の原価確認");
            const modalDesc = isAU
              ? (isLineAddMode ? "Cost price is not set. Please enter it before adding to the order." : `Some items have no cost price set. Please enter it before ${isConfirmMode ? "confirming this order" : "issuing the delivery note"}.`)
              : (isLineAddMode ? "原価が未登録です。入力してから明細に追加します。" : `原価が未登録の商品があります。入力してから${isConfirmMode ? "受注確定" : "納品書発行"}してください。`);
            const confirmLabel = isAU
              ? (isLineAddMode ? "✅ Confirm cost price and add" : isConfirmMode ? "✅ Save cost price and confirm order" : "🖨 Save cost price and issue delivery note")
              : (isLineAddMode ? "✅ 原価を確定して追加" : isConfirmMode ? "✅ 原価を保存して受注確定へ" : "🖨 原価を保存して納品書発行");
            return (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
              <div style={{ background: "white", borderRadius: 16, padding: 24, width: "min(96vw, 560px)", maxHeight: "85vh", overflowY: "auto", boxShadow: "0 24px 60px rgba(0,0,0,0.2)" }}>
                <div style={{ fontWeight: 900, fontSize: 17, marginBottom: 4 }}>
                  {modalTitle}
                </div>
                <div style={{ fontSize: 12, color: "#888", marginBottom: 16 }}>
                  {modalDesc}
                </div>

                {/* 明細一覧 */}
                <div style={{ display: "grid", gap: 8, marginBottom: 20 }}>
                  {priceCheckModal.editLines.map((l, idx) => {
                    const cp = Number(l.costPrice ?? 0);
                    const p = Number(l.price ?? 0);
                    const effectivePrice = cp > 0 ? cp : p;
                    const isZero = effectivePrice === 0;
                    return (
                      <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10, alignItems: "center",
                        padding: "10px 12px", borderRadius: 10,
                        border: isZero ? "1.5px solid #fca5a5" : "1px solid #d1fae5",
                        background: isZero ? "#fff5f5" : "#f0fdf4" }}>
                        <div>
                          <div style={{ fontWeight: 900, fontSize: 13 }}>{l.name || (isAU ? "Unknown" : "不明")}</div>
                          <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>{isAU ? `Qty: ${l.qty}${l.unit || ""}` : `数量：${l.qty}${l.unit || ""}`}</div>
                          {isZero && <div style={{ fontSize: 11, color: "#dc2626", fontWeight: 700 }}>{isAU ? "⚠ Please enter a cost price" : "⚠ 原価を入力してください"}</div>}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 2 }}>
                          <div style={{ fontSize: 11, color: "#555", fontWeight: 700 }}>{isAU ? "Unit price (ex GST)" : "単価（税抜）"}</div>
                          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                            <span style={{ fontSize: 13, opacity: 0.6 }}>{isAU ? "$" : "¥"}</span>
                            <input
                              type="number"
                              ref={el => { if(el) inputRefs[idx] = el; }}
                              defaultValue={effectivePrice > 0 ? effectivePrice : ""}
                              placeholder="0"
                              inputMode="numeric"
                              autoFocus={idx === 0}
                              style={{ width: 100, padding: "6px 8px", borderRadius: 8,
                                border: isZero ? "1.5px solid #fca5a5" : "1.5px solid #86efac",
                                fontWeight: 900, fontSize: 14, textAlign: "right" }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* ボタン */}
                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                  <button
                    onClick={() => setPriceCheckModal(null)}
                    style={{ padding: "10px 20px", borderRadius: 10, border: "1px solid #ddd",
                      background: "white", fontWeight: 900, cursor: "pointer", fontSize: 13 }}
                  >
                    {isAU ? "Cancel" : "キャンセル"}
                  </button>
                  <button
                    onClick={async () => {
                      const order = priceCheckModal.order;
                      const editLines = priceCheckModal.editLines;

                      // DOMから直接inputの値を読む
                      const updatedLines = editLines.map((l, idx) => {
                        const { _editPrice, _wasZero, ...rest } = l;
                        const inputEl = inputRefs[idx];
                        const inputVal = inputEl ? Number(inputEl.value) || 0 : (Number(l.costPrice||l.price||0));
                        return {
                          ...rest,
                          price: inputVal,
                          costPrice: inputVal || rest.costPrice || 0,
                        };
                      });

                      // manual-line-add：onCompleteコールバックで明細に追加
                      if (isLineAddMode) {
                        if (priceCheckModal.onComplete) priceCheckModal.onComplete(updatedLines);
                        setPriceCheckModal(null);
                        return;
                      }

                      // Firestoreに原価を保存（手書き入力モードはorderがnullなのでスキップ）
                      if (order && order.id) {
                        try {
                          // 原価の反映と金額再計算はconfirmOrderCostPrices Callableが行う
                          const confirmOrderCostPricesFn = httpsCallable(functions, "confirmOrderCostPrices");
                          await confirmOrderCostPricesFn({
                            orderId: order.id,
                            priceUpdates: updatedLines.map((l) => ({ lineId: l.id, costPrice: Number(l.costPrice || 0) })),
                          });
                        } catch (e) {
                          alert((isAU ? "Save error: " : "保存エラー: ") + (e?.message || e));
                          return;
                        }
                      }

                      setPriceCheckModal(null);

                      if (isConfirmMode) {
                        // 受注確定モーダルへ
                        setWhConfirmOpen(true);
                      } else if (priceCheckModal.mode === "manual-delivery") {
                        // 手書き入力：原価反映してから受注登録＋納品書発行
                        const newLines = priceCheckModal.editLines.map((l, i) => {
                          const { _editPrice, _wasZero, ...rest } = l;
                          const inputEl = inputRefs[i];
                          const val = inputEl ? Number(inputEl.value) || 0 : Number(l.costPrice || l.price || 0);
                          return { ...rest, price: val, costPrice: val };
                        });
                        await saveManualOrder(true, newLines);
                      } else if (priceCheckModal.mode === "manual-confirm") {
                        // 手書き入力：原価反映してから受注登録のみ
                        const newLines = priceCheckModal.editLines.map((l, i) => {
                          const { _editPrice, _wasZero, ...rest } = l;
                          const inputEl = inputRefs[i];
                          const val = inputEl ? Number(inputEl.value) || 0 : Number(l.costPrice || l.price || 0);
                          return { ...rest, price: val, costPrice: val };
                        });
                        await saveManualOrder(false, newLines);
                      } else {
                        openDeliveryPrint({ ...order, lines: updatedLines });
                      }
                    }}
                    style={{ padding: "10px 24px", borderRadius: 10, border: "none",
                      background: "#111", color: "white", fontWeight: 900, cursor: "pointer", fontSize: 13 }}
                  >
                    {confirmLabel}
                  </button>
                </div>
              </div>
            </div>
            );
          })()}

          {/* ===== register modal（商品登録）===== */}
          {regOpen && !retailOrderOnly && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                display: "grid",
                placeItems: "center",
                zIndex: 10000,
                padding: 16,
              }}
            >
              <div
                style={{
                  width: "min(560px, 100%)",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  background: "white",
                  borderRadius: 14,
                  padding: 14,
                  boxSizing: "border-box",
                }}
              >
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
                  <div style={{ fontWeight: 900 }}>
                    {isAU
                      ? (regMode === "edit" ? "Edit product" : "Add product")
                      : (regMode === "edit" ? "商品を編集" : "商品登録")}
                  </div>

                  <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                    <button
                      onClick={() => setRegOpen(false)}
                      style={{
                        padding: "8px 10px",
                        borderRadius: 10,
                        border: "1px solid #ddd",
                        background: "white",
                        fontWeight: 900,
                      }}
                    >
                      {isAU ? "Close" : "閉じる"}
                    </button>
                  </div>
                </div>

{/* JAN */}
<div style={{ display: "flex", gap: 8, alignItems: "center" }}>
  <input
    value={regBarcode}
    onChange={(e) => setRegBarcode(e.target.value)}
    placeholder={isAU ? "Barcode (optional)" : "JANコード（任意）"}
    inputMode="numeric"
    style={{
      flex: 1,
      padding: "12px 12px",
      borderRadius: 12,
      border: "1px solid #ddd",
      fontWeight: 800,
    }}
  />

  <button
    type="button"
    onClick={() => setScannerOpen(true)}
    style={{
      padding: "12px 12px",
      borderRadius: 12,
      border: "1px solid #111",
      background: "white",
      fontWeight: 900,
      whiteSpace: "nowrap",
    }}
  >
    📷
  </button>
</div>

{/* 商品名 */}
<input
  value={regName}
  onChange={(e) => setRegName(e.target.value)}
  placeholder={isAU ? "Product name (required)" : "商品名（必須）"}
  style={{ padding: "12px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }}
/>


{/* 単位・入り数 */}
<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
  <div style={{ display: "grid", gap: 4 }}>
    <div style={{ fontWeight: 900, fontSize: 12 }}>{isAU ? "Unit" : "単位"}</div>
    <input
      value={regUnit}
      onChange={(e) => setRegUnit(e.target.value)}
      placeholder={isAU ? "e.g. carton / kg / each" : "個 / kg / 玉"}
      style={{ padding: "12px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }}
    />
  </div>
  <div style={{ display: "grid", gap: 4 }}>
    <div style={{ fontWeight: 900, fontSize: 12 }}>{isAU ? "Pack size" : "入り数"}</div>
    <input
      value={regInnerCount}
      onChange={(e) => setRegInnerCount(e.target.value)}
      inputMode="numeric"
      placeholder={isAU ? "e.g. 12" : "例：12"}
      style={{ padding: "12px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800 }}
    />
  </div>
</div>


{/* 発注単価・小売販売価格・仕入原価 */}
{(() => {
  const toNum = (v, fallback = 0) => {
    const s = String(v ?? "").replace(/[¥,\s"]/g, "").trim();
    if (s === "") return fallback;
    const n = Number(s);
    return Number.isFinite(n) ? n : fallback;
  };

  const spInc = toNum(regSellPrice, 0);    // 小売販売価格（税込）
  const cp = toNum(regCostPrice, 0);        // 発注単価（税抜）
  const pc = toNum(regPurchaseCost, 0);     // 仕入原価（税抜）
  const tr = Number(regTaxRate ?? 0.1) || 0;
  // 2026-08（Codexレビュー2回目MINOR対応）：参考計算表示（税込参考・税抜換算・粗利）も
  // AU版ではroundAUDを使う。保存値そのものへの影響はないが、表示が整数ドルに
  // 誤って丸まっていた
  const referenceRoundFn = isAU ? roundAUD : Math.round;

  const spEx = spInc > 0 ? referenceRoundFn(spInc / (1 + tr)) : 0;
  const cpInc = cp > 0 ? referenceRoundFn(cp * (1 + tr)) : 0;
  // 粗利：発注単価 vs 小売販売価格（税抜）
  const grossProfit = spEx > 0 && cp > 0 ? spEx - cp : null;
  const grossRate = spEx > 0 && cp > 0 ? ((spEx - cp) / spEx * 100).toFixed(1) : null;

  const currencySymbol = isAU ? "$" : "¥";
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {/* 左：発注単価（税抜入力） */}
        <div style={{ display: "grid", gap: 6 }}>
          <div style={{ fontWeight: 900, fontSize: 12 }}>
            {isAU ? "Cost price" : "発注単価"}
            <span style={{ fontSize: 11, fontWeight: 400, marginLeft: 4, color: "#666" }}>{isAU ? " (ex GST)" : "（税抜で入力）"}</span>
          </div>
          <div style={{
            display: "grid", gridTemplateColumns: "auto 1fr",
            alignItems: "center", border: "1px solid #ddd",
            borderRadius: 12, padding: "0 10px", background: "white",
          }}>
            <div style={{ fontWeight: 900, opacity: 0.7, paddingRight: 8 }}>{currencySymbol}</div>
            <input
              value={regCostPrice}
              onChange={(e) => setRegCostPrice(e.target.value)}
              inputMode={isAU ? "decimal" : "numeric"}
              placeholder="0"
              style={{ border: "none", outline: "none", padding: "10px 0", width: "100%", fontSize: 14 }}
            />
          </div>
          <div style={{ fontSize: 12, opacity: 0.7 }}>
            {isAU ? `Inc GST: ${cpInc > 0 ? formatMoney(cpInc, tenantProfile?.marketId) : "—"}` : `税込参考：${cpInc > 0 ? yen(cpInc) : "—"}`}
          </div>
        </div>

        {/* 右：小売販売価格（税込入力・任意） */}
        <div style={{ display: "grid", gap: 6 }}>
          <div style={{ fontWeight: 900, fontSize: 12 }}>
            {isAU ? "Retail sell price" : "小売販売価格"}
            <span style={{ fontSize: 11, fontWeight: 400, marginLeft: 4, color: "#2563eb" }}>{isAU ? " (inc GST, optional)" : "（税込・任意）"}</span>
          </div>
          <div style={{
            display: "grid", gridTemplateColumns: "auto 1fr",
            alignItems: "center", border: "2px solid #2563eb",
            borderRadius: 12, padding: "0 10px", background: "#eff6ff",
          }}>
            <div style={{ fontWeight: 900, opacity: 0.7, paddingRight: 8 }}>{currencySymbol}</div>
            <input
              value={regSellPrice}
              onChange={(e) => setRegSellPrice(e.target.value)}
              inputMode={isAU ? "decimal" : "numeric"}
              placeholder="0"
              style={{ border: "none", outline: "none", padding: "10px 0", width: "100%", fontSize: 14, background: "transparent" }}
            />
          </div>
          <div style={{ fontSize: 12, opacity: 0.7 }}>
            {isAU ? `Ex GST: ${spEx > 0 ? formatMoney(spEx, tenantProfile?.marketId) : "—"}` : `税抜換算：${spEx > 0 ? yen(spEx) : "—"}`}
          </div>
        </div>
      </div>

      {/* 仕入原価（任意） */}
      <div style={{ display: "grid", gap: 6 }}>
        <div style={{ fontWeight: 900, fontSize: 12 }}>
          {isAU ? "Purchase cost" : "仕入原価"}
          <span style={{ fontSize: 11, fontWeight: 400, marginLeft: 4, color: "#888" }}>{isAU ? " (ex GST, optional)" : "（税抜・任意）"}</span>
        </div>
        <div style={{
          display: "grid", gridTemplateColumns: "auto 1fr",
          alignItems: "center", border: "1px solid #e5e7eb",
          borderRadius: 12, padding: "0 10px", background: "#f9fafb",
        }}>
          <div style={{ fontWeight: 900, opacity: 0.5, paddingRight: 8 }}>{currencySymbol}</div>
          <input
            value={regPurchaseCost}
            onChange={(e) => setRegPurchaseCost(e.target.value)}
            inputMode={isAU ? "decimal" : "numeric"}
            placeholder={isAU ? "0 (for future stocktake / margin tracking)" : "0（将来の棚卸・利益管理用）"}
            style={{ border: "none", outline: "none", padding: "10px 0", width: "100%", fontSize: 14, background: "transparent", color: "#555" }}
          />
        </div>
      </div>

      {/* 粗利表示 */}
      {grossProfit !== null && (
        <div style={{ fontSize: 12, padding: "6px 10px", background: grossProfit >= 0 ? "#f0fdf4" : "#eff6ff",
          borderRadius: 8, color: grossProfit >= 0 ? "#16a34a" : "#dc2626", fontWeight: 700 }}>
          {isAU
            ? `Gross margin: ${formatMoney(grossProfit, tenantProfile?.marketId)} (${grossRate}%, ex GST)`
            : `粗利：${yen(grossProfit)}（粗利率 ${grossRate}%）※税抜ベース`}
        </div>
      )}

      <div style={{ fontSize: 11, opacity: 0.6 }}>
        {isAU
          ? "* Cost price is entered ex GST. Retail sell price is entered inc GST → converted and stored ex GST."
          : "※ 発注単価は税抜入力　小売販売価格は税込入力 → 税抜に変換して保存"}
      </div>
    </div>
  );
})()}

{/* 税率 */}
<div style={{ display: "grid", gap: 6 }}>
  <div style={{ fontWeight: 900, fontSize: 12 }}>{isAU ? "GST rate" : "税率"}</div>
  {/* 2026-08 AU版基盤（Phase 3）：AU_TAX_POLICYはallowedRates=[0, 0.10]のみ
      （8%区分は存在しない）。AU版では選択肢自体を10%/GST-freeの2択に絞り、
      日本版のみ既存どおり10%/8%/0%の3択を維持する */}
  <select
    value={String(regTaxRate)}
    onChange={(e) => setRegTaxRate(Number(e.target.value))}
    style={{ padding: "12px 12px", borderRadius: 12, border: "1px solid #ddd", fontWeight: 800, background: "white" }}
  >
    {isAU ? (
      <>
        <option value="0.1">GST 10%</option>
        <option value="0">GST-free (0%)</option>
      </>
    ) : (
      <>
        <option value="0.1">10%</option>
        <option value="0.08">8%</option>
        <option value="0">0%（非課税）</option>
      </>
    )}
  </select>
</div>

{/* カテゴリ */}
<div style={{ display: "grid", gap: 6 }}>
  <div style={{ fontWeight: 900, fontSize: 12 }}>{isAU ? "Category (required)" : "カテゴリ（必須）"}</div>
  <input
    value={regCategory}
    onChange={(e) => setRegCategory(e.target.value)}
    placeholder={isAU ? "e.g. Beverages / Dry goods / Fresh produce" : "例：野菜 / 精肉 / 飲料"}
    style={{ padding: "12px 14px", borderRadius: 12, border: "1px solid #ddd", fontSize: 14 }}
  />
</div>

{/* 推奨売価 */}
<div style={{ display: "grid", gap: 6 }}>
  <div style={{ fontWeight: 900, fontSize: 12 }}>{isAU ? "Suggested retail price (inc GST, optional)" : "推奨売価（税込・任意）"}</div>
  <input
    value={regSuggestedPrice}
    onChange={(e) => setRegSuggestedPrice(e.target.value)}
    placeholder={isAU ? "e.g. 19.95" : "例：198"}
    inputMode={isAU ? "decimal" : "numeric"}
    style={{ padding: "12px 14px", borderRadius: 12, border: "1px solid #ddd", fontSize: 14 }}
  />
  <div style={{ fontSize: 11, opacity: 0.6 }}>{isAU ? "Shown as a reference on delivery notes" : "納品書に参考として記載されます"}</div>
</div>

{/* 保存ボタン */}
<div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 10 }}>
  <button
    onClick={() => setRegOpen(false)}
    style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", background: "white", fontWeight: 900 }}
  >
    {isAU ? "Cancel" : "キャンセル"}
  </button>
  <button
    onClick={saveProductFromModal}
    style={{ padding: "10px 14px", borderRadius: 12, border: "1px solid #111", background: "#111", color: "white", fontWeight: 900 }}
  >
    {isAU ? "Save" : "保存"}
  </button>
</div>
              </div>
            </div>
          )}

    {csvOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      zIndex: 10000,
      padding: 16,

      // ✅ 画面外に伸びたら "背景側" がスクロール
      overflowY: "auto",
    }}
  >
    <div
      style={{
        width: "min(760px, 100%)",
        margin: "0 auto",
        background: "white",
        borderRadius: 14,
        padding: 14,

        // ✅ 画面内に収める（上下パディングぶんも考慮）
        maxHeight: "calc(100vh - 32px)",

        // ✅ ヘッダー/本文/フッター構造にする
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
      }}
    >
      {/* ===== header ===== */}
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
        <div style={{ fontWeight: 900 }}>{isAU ? "Import product catalogue (Excel/CSV)" : "商品マスタ Excel/CSV取り込み"}</div>
        <button
          onClick={() => setCsvOpen(false)}
          style={{
            marginLeft: "auto",
            padding: "8px 10px",
            borderRadius: 10,
            border: "1px solid #ddd",
            background: "white",
            fontWeight: 900,
          }}
        >
          {isAU ? "Close" : "閉じる"}
        </button>
      </div>

      {/* ===== body (scrollable) ===== */}
      <div
        style={{
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          paddingRight: 6, // スクロールバー対策
          display: "grid",
          gap: 10,
        }}
      >
        <div style={{ fontSize: 12, opacity: 0.75 }}>
          {isAU
            ? "Required: barcode, name, unit / Optional: costPrice, sellPrice, taxRate, supplierId (taxRate defaults to 10% GST if blank)"
            : "必須: barcode,name,unit / 任意: costPrice,sellPrice,taxRate,supplierId（taxRate空なら0.1扱い）"}
        </div>

        <textarea
          value={csvText}
          onChange={(e) => setCsvText(e.target.value)}
          placeholder={isAU
            ? `e.g.\nbarcode,name,unit,costPrice,sellPrice,taxRate,supplierId\n930...,Product A,carton,60,80,10%,SUP-001`
            : `例:\nbarcode,name,unit,costPrice,sellPrice,taxRate,supplierId\n490...,商品A,個,60,80,10%,SUP-001`}
          style={{
            width: "100%",
            height: 160,
            border: "1px solid #ddd",
            borderRadius: 12,
            padding: 10,
            boxSizing: "border-box",
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            fontSize: 12,
          }}
        />

        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <button
            onClick={() => parseCsvAndPreview(csvText)}
            style={{
              padding: "10px 12px",
              borderRadius: 12,
              border: "1px solid #111",
              background: "white",
              fontWeight: 900,
            }}
          >
            {isAU ? "Parse & preview" : "解析してプレビュー"}
          </button>

          <div style={{ marginLeft: "auto", fontSize: 12, opacity: 0.75 }}>{isAU ? `Parsed: ${csvRows.length}` : `解析済み: ${csvRows.length} 件`}</div>
        </div>

        {csvErrors.length > 0 && (
          <div style={{ border: "1px solid #f2c2c2", background: "#fff5f5", borderRadius: 12, padding: 10 }}>
            <div style={{ fontWeight: 900, marginBottom: 6 }}>{isAU ? `Errors (${csvErrors.length})` : `エラー（${csvErrors.length}）`}</div>
            <div style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
              {csvErrors.slice(0, 20).join("\n")}
              {csvErrors.length > 20 ? (isAU ? `\n...and ${csvErrors.length - 20} more` : `\n...他 ${csvErrors.length - 20} 件`) : ""}
            </div>
          </div>
        )}

        {csvPreview.length > 0 && (
          <div style={{ display: "grid", gap: 8 }}>
            <div style={{ fontWeight: 900 }}>{isAU ? `Preview (first ${csvPreview.length})` : `プレビュー（先頭 ${csvPreview.length} 件）`}</div>

            <div style={{ overflowX: "auto", border: "1px solid #eee", borderRadius: 12 }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {["barcode", "name", "unit", "costPrice", "sellPrice", "taxRate", "supplierId"].map((h) => (
                      <th
                        key={h}
                        style={{ textAlign: "left", padding: 8, borderBottom: "1px solid #eee", fontSize: 12 }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {csvPreview.map((r) => (
                    <tr key={`${r._rowNo}-${r.barcode}`}>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.barcode}</td>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.name}</td>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.unit}</td>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.costPrice}</td>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.sellPrice}</td>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.taxRate}</td>
                      <td style={{ padding: 8, borderBottom: "1px solid #f4f4f4", fontSize: 12 }}>{r.supplierId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* ===== footer (sticky) ===== */}
      <div
        style={{
          marginTop: 10,
          paddingTop: 10,
          borderTop: "1px solid #eee",
          background: "white",

          // ✅ ここが "画面下に固定" の本体
          position: "sticky",
          bottom: 0,

          display: "flex",
          gap: 8,
          alignItems: "center",
        }}
      >
        <button
          onClick={() => setCsvOpen(false)}
          style={{ padding: "10px 12px", borderRadius: 12, border: "1px solid #ddd", background: "white", fontWeight: 900 }}
        >
          {isAU ? "Cancel" : "キャンセル"}
        </button>

        {/* ✅ Firestoreへ確定登録 */}
        <button
         disabled={
  csvImporting ||
  csvFatalErrors.length > 0 ||
  csvRows.length === 0 ||
  (mode === "retail" && !supplierId) ||
  (mode === "wholesale" && !tenantId)
}
          onClick={confirmImportProducts}
          style={{
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid #111",
            background:
  csvImporting ||
  csvFatalErrors.length > 0 ||
  csvRows.length === 0 ||
  (mode === "retail" && !supplierId) ||
  (mode === "wholesale" && !tenantId)
    ? "#eee"
    : "white",

opacity:
  csvImporting ||
  csvFatalErrors.length > 0 ||
  csvRows.length === 0 ||
  (mode === "retail" && !supplierId) ||
  (mode === "wholesale" && !tenantId)
    ? 0.6
    : 1,

            cursor: csvImporting ? "not-allowed" : "pointer",
            marginLeft: "auto",
          }}
          title={
            mode === "retail" && !supplierId
              ? (isAU ? "Please select a supplier first" : "先に仕入れ先を選択してください")
              : mode === "wholesale" && !tenantId
              ? (isAU ? "Business not set up yet" : "tenantId がありません")
              : csvErrors.length > 0
              ? (isAU ? "Please resolve the errors before importing" : "エラーを解消してから取込してください")
              : ""
          }
        >
          {isAU
            ? (csvImporting ? "Importing..." : "Import these products")
            : (csvImporting ? "取込中..." : "この内容で登録（Firestoreへ）")}
        </button>

        <div style={{ fontSize: 12, opacity: 0.75 }}>
          {isAU
            ? "* Matching key: business = tenantId+barcode / retailer = (tenantId)+supplierId+barcode"
            : "※ 上書きキー：卸＝tenantId+barcode / 小売＝(tenantId)+supplierId+barcode"}
        </div>
      </div>
    </div>
  </div>
)}


        </div> {/* ← ✅ これを追加 */}

        {/* ===== search modal ===== */}
      {/* ===== JAN Scanner / Manual modal ===== */}
{scannerOpen && (
  <div
    className="modalOverlay"
    onClick={() => {
      setScannerOpen(false);
      setJanMode("scan");
    }}
  >
    <div
      className="modalContent"
      onClick={(e) => e.stopPropagation()} // ✅ 中を押しても閉じない
    >
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <button
          type="button"
          onClick={() => setJanMode("scan")}
          style={{
            flex: 1,
            padding: 10,
            fontWeight: 900,
            background: janMode === "scan" ? "#000" : "#eee",
            color: janMode === "scan" ? "#fff" : "#000",
            borderRadius: 10,
          }}
        >
          {isAU ? "Scan" : "スキャン"}
        </button>

        <button
          type="button"
          onClick={() => setJanMode("manual")}
          style={{
            flex: 1,
            padding: 10,
            fontWeight: 900,
            background: janMode === "manual" ? "#000" : "#eee",
            color: janMode === "manual" ? "#fff" : "#000",
            borderRadius: 10,
          }}
        >
          {isAU ? "Manual entry" : "手入力"}
        </button>
      </div>

      {janMode === "scan" ? (
        <JanScanner
          onDetected={(jan) => {
            const code = String(jan || "").trim();

            if (scanTarget === "reg") {
              setRegBarcode(code);
              showToast(isAU ? `Barcode entered: ${code}` : `JAN入力：${code}`);
            } else if (scanTarget === "manual") {
              setManualSearch(code);
              setManualSearchOpen(true);
            } else {
              addByBarcode(code);
            }

            setScannerOpen(false);
            setJanMode("scan");
          }}
          onFallbackManual={() => setJanMode("manual")}
          isAU={isAU}
        />
      ) : (
        <JanManual
          isAU={isAU}
          onSubmit={(jan) => {
            const code = String(jan || "").trim();

            if (scanTarget === "reg") {
              setRegBarcode(code);
              showToast(isAU ? `Barcode entered: ${code}` : `JAN入力：${code}`);
            } else if (scanTarget === "manual") {
              setManualSearch(code);
              setManualSearchOpen(true);
            } else {
              addByBarcode(code);
            }

            setScannerOpen(false);
            setJanMode("scan");
          }}
        />
      )}

      <div style={{ marginTop: 12 }}>
        <button
          type="button"
          onClick={() => {
            setScannerOpen(false);
            setJanMode("scan");
          }}
          style={{ width: "100%", padding: 10, borderRadius: 10 }}
        >
          {isAU ? "Close" : "閉じる"}
        </button>
      </div>
    </div>
  </div>
)}


        {/* ===== Print Area ===== */}
        <div className="print-area">
          {printPick && (
            <div style={{ padding: 16 }}>
              <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
                <div style={{ fontSize: 22, fontWeight: 900 }}>{isAU ? "Picking List" : "ピッキングリスト"}</div>
                <div style={{ marginLeft: "auto", fontSize: 12, opacity: 0.8 }}>{jdate(printPick.issuedAt, isAU ? "en-AU" : "ja-JP")}</div>
              </div>

              <div style={{ marginTop: 10, display: "grid", gap: 4, fontSize: 12 }}>
                <div>{isAU ? "Order No: " : "注文No："}{printPick.orderSnapshot.orderNo}</div>
                <div>{isAU ? "Retailer: " : "小売店："}{printPick.orderSnapshot.shopName || (isAU ? "Unnamed Shop" : "〇〇ショップ")}</div>
                <div>{isAU ? "Order date: " : "発注日時："}{jdate(printPick.orderSnapshot.createdAt, isAU ? "en-AU" : "ja-JP")}</div>
              </div>

              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 12 }} border="1" cellPadding="6">
                <thead>
                  <tr>
                    <th align="left">{isAU ? "Product" : "商品"}</th>
                    <th align="left">{isAU ? "Barcode" : "JAN"}</th>
                    <th align="right">{isAU ? "Qty" : "数量"}</th>
                    <th align="left">{isAU ? "Unit" : "単位"}</th>
                    <th align="left">{isAU ? "Shelf/Notes" : "棚/備考"}</th>
                    <th align="left">{isAU ? "Check" : "チェック"}</th>
                  </tr>
                </thead>
                <tbody>
                  {(printPick.orderSnapshot.lines || []).map((l) => (
                    <tr key={l.id}>
                      <td>{l.name || (isAU ? "Unknown" : "不明")}</td>
                      <td>{l.barcode || ""}</td>
                      <td align="right">{l.qty}</td>
                      <td>{l.unit}</td>
                      <td>　</td>
                      <td>☐</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}


    {printOrders && (
  <div style={{ padding: 16 }}>
    <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
      <div style={{ fontSize: 22, fontWeight: 900 }}>{isAU ? "Order List" : "受注リスト"}</div>
      <div style={{ marginLeft: "auto", fontSize: 12, opacity: 0.8 }}>
        {jdate(printOrders.issuedAt, isAU ? "en-AU" : "ja-JP")}
      </div>
    </div>

    <table
      style={{ width: "100%", borderCollapse: "collapse", marginTop: 12 }}
      border="1"
      cellPadding="6"
    >
      <thead>
        <tr>
          <th align="left">{isAU ? "Order Date" : "注文日時"}</th>
          <th align="left">{isAU ? "Retailer" : "小売店"}</th>
          <th align="right">{isAU ? "Items" : "点数"}</th>
          <th align="right">{isAU ? "Total" : "合計"}</th>
          <th align="left">{isAU ? "Status" : "状態"}</th>
          <th align="left">{isAU ? "Check" : "チェック"}</th>
        </tr>
      </thead>

      <tbody>
        {(printOrders.ordersSnapshot || []).map((o) => {
          const itemCount = getOrderLines(o).reduce(
            (s, l) => s + Number(l.qty || 0),
            0
          );

          return (
            <tr key={o.id || o.orderNo}>
              <td>{jdate(o.createdAt, isAU ? "en-AU" : "ja-JP")}</td>
              <td>{o.shopName || (isAU ? "Unnamed Shop" : "〇〇ショップ")}</td>
              <td align="right">{itemCount}</td>
              <td align="right">{formatMoney(o.total, tenantProfile?.marketId)}</td>
              <td>{isAU
                ? (o.status === "納品書発行" ? "Delivery note issued"
                  : o.status === "受注確定" ? "Confirmed"
                  : o.status === "キャンセル" ? "Cancelled"
                  : o.status === "未確認" ? "Unconfirmed"
                  : o.status)
                : o.status}</td>
              <td>☐</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
)}


{/* ── CSV取込 進捗オーバーレイ（Portal経由でbodyに直接描画） ── */}
{(csvImporting || csvImportProgress.done) && createPortal(
  <div style={{
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 99999,
  }}>
    <div style={{
      background: "white", borderRadius: 24, padding: "40px 36px",
      width: 340, textAlign: "center", boxShadow: "0 16px 60px rgba(0,0,0,0.35)",
    }}>
      {csvImportProgress.done ? (
        <>
          <div style={{ fontSize: 64, marginBottom: 12, lineHeight: 1 }}>✅</div>
          <div style={{ fontWeight: 900, fontSize: 22, marginBottom: 10, color: "#111" }}>{isAU ? "Import complete!" : "取込完了！"}</div>
          <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 12, padding: "12px 16px", marginBottom: 24 }}>
            <div style={{ fontSize: 28, fontWeight: 900, color: "#16a34a" }}>
              {isAU ? csvImportProgress.current.toLocaleString("en-AU") : `${csvImportProgress.current.toLocaleString()} 件`}
            </div>
            <div style={{ fontSize: 13, color: "#15803d", marginTop: 2 }}>
              {isAU ? "Added to your product catalogue" : "商品マスタに登録しました"}
              {csvImportProgress.skipped > 0 && (
                <div style={{ color: "#ca8a04", marginTop: 4 }}>
                  {isAU ? `Skipped ${csvImportProgress.skipped} row(s) (missing barcode or product name)` : `スキップ ${csvImportProgress.skipped} 件（JAN・商品名が空の行）`}
                </div>
              )}
            </div>
          </div>
          <button
            onClick={() => {
              setCsvImportProgress({ current: 0, total: 0, done: false, skipped: 0 });
              setCsvOpen(false);
            }}
            style={{ padding: "12px 48px", borderRadius: 14, background: "#111",
              color: "white", fontWeight: 900, border: "none", cursor: "pointer", fontSize: 16 }}
          >
            OK
          </button>
        </>
      ) : (
        <>
          <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 6, color: "#111" }}>{isAU ? "Importing..." : "取込中..."}</div>
          <div style={{ fontSize: 13, color: "#888", marginBottom: 20 }}>{isAU ? "Please wait" : "しばらくお待ちください"}</div>
          <div style={{ fontSize: 52, fontWeight: 900, color: "#111", lineHeight: 1, marginBottom: 16 }}>
            {csvImportProgress.total > 0
              ? `${Math.round((csvImportProgress.current / csvImportProgress.total) * 100)}%`
              : "0%"}
          </div>
          <div style={{ background: "#e5e7eb", borderRadius: 99, height: 12, marginBottom: 14, overflow: "hidden" }}>
            <div style={{
              background: "linear-gradient(90deg, #111 0%, #444 100%)",
              height: "100%", borderRadius: 99,
              width: csvImportProgress.total > 0
                ? `${Math.round((csvImportProgress.current / csvImportProgress.total) * 100)}%`
                : "3%",
              transition: "width 0.4s ease",
            }} />
          </div>
          <div style={{ fontSize: 14, color: "#555", fontWeight: 700 }}>
            {isAU
              ? `${csvImportProgress.current.toLocaleString("en-AU")} / ${csvImportProgress.total.toLocaleString("en-AU")}`
              : `${csvImportProgress.current.toLocaleString()} 件 / ${csvImportProgress.total.toLocaleString()} 件`}
          </div>
        </>
      )}
    </div>
  </div>,
  document.body
)}

{/* ===== サポートボタン＆フォーム（固定） ===== */}
{createPortal(
  <>
    {/* サポートボタン（発注画面では非表示） */}
    {!supportOpen && !(mode === "retail" && retailView === "order") && (
      <button
        onClick={() => setSupportOpen(true)}
        style={{
          position: "fixed", bottom: 24, right: 24, zIndex: 9999,
          background: "#111827", color: "white",
          borderRadius: 99, padding: "12px 18px",
          fontSize: 13, fontWeight: 700, border: "none", cursor: "pointer",
          display: "flex", alignItems: "center", gap: 6,
          boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        }}
      >
        {isAU ? "✉️ Support" : "✉️ サポート"}
      </button>
    )}

    {/* お問い合わせフォーム
        2026-08（Step 12 E2E検証時に発覚したバグ対応）：グローバルサポート
        ウィジェット全体がisAU分岐なしで完全に日本語ハードコードされていた */}
    {supportOpen && (
      <div style={{
        position: "fixed", bottom: 24, right: 24, zIndex: 9999,
        background: "white", borderRadius: 16, padding: 20,
        width: 320, boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        border: "1px solid #e5e7eb",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ fontWeight: 900, fontSize: 15 }}>{isAU ? "✉️ Contact us" : "✉️ お問い合わせ"}</div>
          <button
            onClick={() => { setSupportOpen(false); setSupportSent(false); setSupportMsg(""); }}
            style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#888", lineHeight: 1 }}
          >×</button>
        </div>

        {supportSent ? (
          <div style={{ textAlign: "center", padding: "24px 0" }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>✅</div>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>{isAU ? "Sent" : "送信しました"}</div>
            <div style={{ fontSize: 13, color: "#6b7280" }}>
              {isAU ? <>We'll get back to you at<br/>info@order-link.info</> : <>内容を確認の上、<br/>info@order-link.info よりご返信します</>}
            </div>
          </div>
        ) : (
          <>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>
              {isAU ? "Your email address" : "お客様メールアドレス"}
            </div>
            <input
              value={supportEmail}
              onChange={e => setSupportEmail(e.target.value)}
              placeholder="your@email.com"
              inputMode="email"
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box", marginBottom: 12 }}
            />
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>{isAU ? "What's this about?" : "お問い合わせ内容"}</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
              {(isAU
                ? ["How to use OrderLink", "Pricing & plans", "Delivery notes & invoices", "Report a bug", "Other"]
                : ["操作方法について", "料金・プランについて", "納品書・請求書について", "バグ・不具合の報告", "その他"]
              ).map(t => (
                <button
                  key={t}
                  onClick={() => setSupportMsg(m => m ? m : t)}
                  style={{
                    padding: "5px 10px", borderRadius: 99, border: "1px solid #ddd",
                    background: supportMsg === t ? "#111827" : "white",
                    color: supportMsg === t ? "white" : "#374151",
                    fontSize: 12, cursor: "pointer", fontWeight: 600,
                  }}
                >{t}</button>
              ))}
            </div>
            <textarea
              value={supportMsg}
              onChange={e => setSupportMsg(e.target.value)}
              placeholder={isAU ? "Tell us what's on your mind" : "ご質問・ご要望をご記入ください"}
              rows={3}
              style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ddd", fontSize: 14, boxSizing: "border-box", resize: "none", marginBottom: 12, fontFamily: "inherit" }}
            />
            <button
              disabled={!supportMsg.trim() || !supportEmail.trim() || supportSending}
              onClick={async () => {
                setSupportSending(true);
                try {
                  await addDoc(collection(db, "contacts"), {
                    email: supportEmail.trim(),
                    message: supportMsg.trim(),
                    tenantId: tenantId || null,
                    userName: tenantProfile?.name || tenantProfile?.retailName || null,
                    createdAt: serverTimestamp(),
                  });
                  setSupportSent(true);
                } catch(e) {
                  alert(isAU ? "Failed to send. Please try again later." : "送信に失敗しました。時間をおいて再度お試しください。");
                } finally {
                  setSupportSending(false);
                }
              }}
              style={{
                width: "100%", padding: "11px", borderRadius: 8, border: "none",
                background: !supportMsg.trim() || !supportEmail.trim() ? "#d1d5db" : "#111827",
                color: "white", fontWeight: 700, fontSize: 14, cursor: !supportMsg.trim() || !supportEmail.trim() ? "not-allowed" : "pointer",
              }}
            >
              {supportSending ? (isAU ? "Sending..." : "送信中...") : (isAU ? "Send" : "送信する")}
            </button>
          </>
        )}
      </div>
    )}
  </>,
  document.body
)}

{/* 2026-08 AU版基盤（Phase 2）：Sample Retailerモーダル本体 */}
<SampleRetailerModal
  open={showSampleRetailerModal}
  tenantId={tenantId}
  marketId={tenantProfile?.marketId}
  onClose={() => setShowSampleRetailerModal(false)}
  onOrderPlaced={() => {
    setShowSampleRetailerModal(false);
    markActivationOnce("sampleModeStartedAt");
    setMode("wholesale");
    setWholesaleView("orders");
    showToast("Sample order received — check it out below");
  }}
/>

</div>
</div>
);
}

